(window.webpackJsonp = window.webpackJsonp || []).push([
  [1],
  {
    "+h6j": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
          n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
          s = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
          ],
          r =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        e.defineLocale("nl-be", {
          months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
          monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
          weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
          weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[vandaag om] LT",
            nextDay: "[morgen om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[gisteren om] LT",
            lastWeek: "[afgelopen] dddd [om] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            ss: "%d seconden",
            m: "\xe9\xe9n minuut",
            mm: "%d minuten",
            h: "\xe9\xe9n uur",
            hh: "%d uur",
            d: "\xe9\xe9n dag",
            dd: "%d dagen",
            M: "\xe9\xe9n maand",
            MM: "%d maanden",
            y: "\xe9\xe9n jaar",
            yy: "%d jaar",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function (e) {
            return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "+n5x": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("bg", {
          months:
            "\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split(
              "_"
            ),
          monthsShort:
            "\u044f\u043d\u0443_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split(
              "_"
            ),
          weekdays:
            "\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split(
              "_"
            ),
          weekdaysShort:
            "\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split(
              "_"
            ),
          weekdaysMin:
            "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[\u0414\u043d\u0435\u0441 \u0432] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432] LT",
            nextWeek: "dddd [\u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                case 3:
                case 6:
                  return "[\u041c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[\u041c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0441\u043b\u0435\u0434 %s",
            past: "\u043f\u0440\u0435\u0434\u0438 %s",
            s: "\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            m: "\u043c\u0438\u043d\u0443\u0442\u0430",
            mm: "%d \u043c\u0438\u043d\u0443\u0442\u0438",
            h: "\u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0434\u0435\u043d",
            dd: "%d \u0434\u0435\u043d\u0430",
            w: "\u0441\u0435\u0434\u043c\u0438\u0446\u0430",
            ww: "%d \u0441\u0435\u0434\u043c\u0438\u0446\u0438",
            M: "\u043c\u0435\u0441\u0435\u0446",
            MM: "%d \u043c\u0435\u0441\u0435\u0446\u0430",
            y: "\u0433\u043e\u0434\u0438\u043d\u0430",
            yy: "%d \u0433\u043e\u0434\u0438\u043d\u0438",
          },
          dayOfMonthOrdinalParse:
            /\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,
          ordinal: function (e) {
            var t = e % 10,
              n = e % 100;
            return 0 === e
              ? e + "-\u0435\u0432"
              : 0 === n
              ? e + "-\u0435\u043d"
              : n > 10 && n < 20
              ? e + "-\u0442\u0438"
              : 1 === t
              ? e + "-\u0432\u0438"
              : 2 === t
              ? e + "-\u0440\u0438"
              : 7 === t || 8 === t
              ? e + "-\u043c\u0438"
              : e + "-\u0442\u0438";
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    "/hi0": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("tet", {
          months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split(
            "_"
          ),
          monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
          weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
          weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
          weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Ohin iha] LT",
            nextDay: "[Aban iha] LT",
            nextWeek: "dddd [iha] LT",
            lastDay: "[Horiseik iha] LT",
            lastWeek: "dddd [semana kotuk] [iha] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "iha %s",
            past: "%s liuba",
            s: "segundu balun",
            ss: "segundu %d",
            m: "minutu ida",
            mm: "minutu %d",
            h: "oras ida",
            hh: "oras %d",
            d: "loron ida",
            dd: "loron %d",
            M: "fulan ida",
            MM: "fulan %d",
            y: "tinan ida",
            yy: "tinan %d",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    0: function (e, t, n) {
      e.exports = n("zUnb");
    },
    "0yow": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("id", {
          months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
          weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
          weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
          weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
          },
          meridiemParse: /pagi|siang|sore|malam/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "pagi" === t
                ? e
                : "siang" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "sore" === t || "malam" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 11 ? "pagi" : e < 15 ? "siang" : e < 19 ? "sore" : "malam";
          },
          calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Besok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kemarin pukul] LT",
            lastWeek: "dddd [lalu pukul] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dalam %s",
            past: "%s yang lalu",
            s: "beberapa detik",
            ss: "%d detik",
            m: "semenit",
            mm: "%d menit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun",
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    "1KVU": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("mt", {
          months:
            "Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split(
              "_"
            ),
          monthsShort: "Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split("_"),
          weekdays: "Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split(
            "_"
          ),
          weekdaysShort: "\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),
          weekdaysMin: "\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Illum fil-]LT",
            nextDay: "[G\u0127ada fil-]LT",
            nextWeek: "dddd [fil-]LT",
            lastDay: "[Il-biera\u0127 fil-]LT",
            lastWeek: "dddd [li g\u0127adda] [fil-]LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "f\u2019 %s",
            past: "%s ilu",
            s: "ftit sekondi",
            ss: "%d sekondi",
            m: "minuta",
            mm: "%d minuti",
            h: "sieg\u0127a",
            hh: "%d sieg\u0127at",
            d: "\u0121urnata",
            dd: "%d \u0121ranet",
            M: "xahar",
            MM: "%d xhur",
            y: "sena",
            yy: "%d sni",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "1ors": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
          },
          n = {
            s: [
              "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
              "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u062b\u0627\u0646\u064a\u062a\u0627\u0646", "\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],
              "%d \u062b\u0648\u0627\u0646",
              "%d \u062b\u0627\u0646\u064a\u0629",
              "%d \u062b\u0627\u0646\u064a\u0629",
            ],
            m: [
              "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
              "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u062f\u0642\u064a\u0642\u062a\u0627\u0646", "\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],
              "%d \u062f\u0642\u0627\u0626\u0642",
              "%d \u062f\u0642\u064a\u0642\u0629",
              "%d \u062f\u0642\u064a\u0642\u0629",
            ],
            h: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
              "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u0633\u0627\u0639\u062a\u0627\u0646", "\u0633\u0627\u0639\u062a\u064a\u0646"],
              "%d \u0633\u0627\u0639\u0627\u062a",
              "%d \u0633\u0627\u0639\u0629",
              "%d \u0633\u0627\u0639\u0629",
            ],
            d: [
              "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
              "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
              ["\u064a\u0648\u0645\u0627\u0646", "\u064a\u0648\u0645\u064a\u0646"],
              "%d \u0623\u064a\u0627\u0645",
              "%d \u064a\u0648\u0645\u064b\u0627",
              "%d \u064a\u0648\u0645",
            ],
            M: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
              "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
              ["\u0634\u0647\u0631\u0627\u0646", "\u0634\u0647\u0631\u064a\u0646"],
              "%d \u0623\u0634\u0647\u0631",
              "%d \u0634\u0647\u0631\u0627",
              "%d \u0634\u0647\u0631",
            ],
            y: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
              "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
              ["\u0639\u0627\u0645\u0627\u0646", "\u0639\u0627\u0645\u064a\u0646"],
              "%d \u0623\u0639\u0648\u0627\u0645",
              "%d \u0639\u0627\u0645\u064b\u0627",
              "%d \u0639\u0627\u0645",
            ],
          },
          s = function (e) {
            return function (s, r, i, a) {
              var o = t(s),
                c = n[e][t(s)];
              return 2 === o && (c = c[r ? 0 : 1]), c.replace(/%d/i, s);
            };
          },
          r = [
            "\u062c\u0627\u0646\u0641\u064a",
            "\u0641\u064a\u0641\u0631\u064a",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0641\u0631\u064a\u0644",
            "\u0645\u0627\u064a",
            "\u062c\u0648\u0627\u0646",
            "\u062c\u0648\u064a\u0644\u064a\u0629",
            "\u0623\u0648\u062a",
            "\u0633\u0628\u062a\u0645\u0628\u0631",
            "\u0623\u0643\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062f\u064a\u0633\u0645\u0628\u0631",
          ];
        e.defineLocale("ar-dz", {
          months: r,
          monthsShort: r,
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200fM/\u200fYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0635|\u0645/,
          isPM: function (e) {
            return "\u0645" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0635" : "\u0645";
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0628\u0639\u062f %s",
            past: "\u0645\u0646\u0630 %s",
            s: s("s"),
            ss: s("s"),
            m: s("m"),
            mm: s("m"),
            h: s("h"),
            hh: s("h"),
            d: s("d"),
            dd: s("d"),
            M: s("M"),
            MM: s("M"),
            y: s("y"),
            yy: s("y"),
          },
          postformat: function (e) {
            return e.replace(/,/g, "\u060c");
          },
          week: { dow: 0, doy: 4 },
        });
      })(n("wgY5"));
    },
    "2B8G": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ss", {
          months:
            "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
              "_"
            ),
          monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
          weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
          weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
          weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A",
          },
          calendar: {
            sameDay: "[Namuhla nga] LT",
            nextDay: "[Kusasa nga] LT",
            nextWeek: "dddd [nga] LT",
            lastDay: "[Itolo nga] LT",
            lastWeek: "dddd [leliphelile] [nga] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "nga %s",
            past: "wenteka nga %s",
            s: "emizuzwana lomcane",
            ss: "%d mzuzwana",
            m: "umzuzu",
            mm: "%d emizuzu",
            h: "lihora",
            hh: "%d emahora",
            d: "lilanga",
            dd: "%d emalanga",
            M: "inyanga",
            MM: "%d tinyanga",
            y: "umnyaka",
            yy: "%d iminyaka",
          },
          meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
          meridiem: function (e, t, n) {
            return e < 11 ? "ekuseni" : e < 15 ? "emini" : e < 19 ? "entsambama" : "ebusuku";
          },
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "ekuseni" === t
                ? e
                : "emini" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "entsambama" === t || "ebusuku" === t
                ? 0 === e
                  ? 0
                  : e + 12
                : void 0
            );
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: "%d",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "2JSI": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0967",
            2: "\u0968",
            3: "\u0969",
            4: "\u096a",
            5: "\u096b",
            6: "\u096c",
            7: "\u096d",
            8: "\u096e",
            9: "\u096f",
            0: "\u0966",
          },
          n = {
            "\u0967": "1",
            "\u0968": "2",
            "\u0969": "3",
            "\u096a": "4",
            "\u096b": "5",
            "\u096c": "6",
            "\u096d": "7",
            "\u096e": "8",
            "\u096f": "9",
            "\u0966": "0",
          };
        e.defineLocale("ne", {
          months:
            "\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split(
              "_"
            ),
          monthsShort:
            "\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split(
              "_"
            ),
          weekdaysShort:
            "\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split(
              "_"
            ),
          weekdaysMin: "\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split(
            "_"
          ),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "A\u0915\u094b h:mm \u092c\u091c\u0947",
            LTS: "A\u0915\u094b h:mm:ss \u092c\u091c\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",
            LLLL: "dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",
          },
          preparse: function (e) {
            return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0930\u093e\u0924\u093f" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u092c\u093f\u0939\u093e\u0928" === t
                ? e
                : "\u0926\u093f\u0909\u0901\u0938\u094b" === t
                ? e >= 10
                  ? e
                  : e + 12
                : "\u0938\u093e\u0901\u091d" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 3
              ? "\u0930\u093e\u0924\u093f"
              : e < 12
              ? "\u092c\u093f\u0939\u093e\u0928"
              : e < 16
              ? "\u0926\u093f\u0909\u0901\u0938\u094b"
              : e < 20
              ? "\u0938\u093e\u0901\u091d"
              : "\u0930\u093e\u0924\u093f";
          },
          calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u092d\u094b\u0932\u093f] LT",
            nextWeek: "[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",
            lastDay: "[\u0939\u093f\u091c\u094b] LT",
            lastWeek: "[\u0917\u090f\u0915\u094b] dddd[,] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s\u092e\u093e",
            past: "%s \u0905\u0917\u093e\u0921\u093f",
            s: "\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",
            m: "\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",
            mm: "%d \u092e\u093f\u0928\u0947\u091f",
            h: "\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",
            hh: "%d \u0918\u0923\u094d\u091f\u093e",
            d: "\u090f\u0915 \u0926\u093f\u0928",
            dd: "%d \u0926\u093f\u0928",
            M: "\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",
            MM: "%d \u092e\u0939\u093f\u0928\u093e",
            y: "\u090f\u0915 \u092c\u0930\u094d\u0937",
            yy: "%d \u092c\u0930\u094d\u0937",
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    "3WqV": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0967",
            2: "\u0968",
            3: "\u0969",
            4: "\u096a",
            5: "\u096b",
            6: "\u096c",
            7: "\u096d",
            8: "\u096e",
            9: "\u096f",
            0: "\u0966",
          },
          n = {
            "\u0967": "1",
            "\u0968": "2",
            "\u0969": "3",
            "\u096a": "4",
            "\u096b": "5",
            "\u096c": "6",
            "\u096d": "7",
            "\u096e": "8",
            "\u096f": "9",
            "\u0966": "0",
          },
          s = [
            /^\u091c\u0928/i,
            /^\u092b\u093c\u0930|\u092b\u0930/i,
            /^\u092e\u093e\u0930\u094d\u091a/i,
            /^\u0905\u092a\u094d\u0930\u0948/i,
            /^\u092e\u0908/i,
            /^\u091c\u0942\u0928/i,
            /^\u091c\u0941\u0932/i,
            /^\u0905\u0917/i,
            /^\u0938\u093f\u0924\u0902|\u0938\u093f\u0924/i,
            /^\u0905\u0915\u094d\u091f\u0942/i,
            /^\u0928\u0935|\u0928\u0935\u0902/i,
            /^\u0926\u093f\u0938\u0902|\u0926\u093f\u0938/i,
          ];
        e.defineLocale("hi", {
          months: {
            format:
              "\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split(
                "_"
              ),
            standalone:
              "\u091c\u0928\u0935\u0930\u0940_\u092b\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u0902\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u0902\u092c\u0930_\u0926\u093f\u0938\u0902\u092c\u0930".split(
                "_"
              ),
          },
          monthsShort:
            "\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split(
              "_"
            ),
          weekdays:
            "\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split(
              "_"
            ),
          weekdaysShort:
            "\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split(
              "_"
            ),
          weekdaysMin: "\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
          longDateFormat: {
            LT: "A h:mm \u092c\u091c\u0947",
            LTS: "A h:mm:ss \u092c\u091c\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u092c\u091c\u0947",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947",
          },
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: [
            /^\u091c\u0928/i,
            /^\u092b\u093c\u0930/i,
            /^\u092e\u093e\u0930\u094d\u091a/i,
            /^\u0905\u092a\u094d\u0930\u0948/i,
            /^\u092e\u0908/i,
            /^\u091c\u0942\u0928/i,
            /^\u091c\u0941\u0932/i,
            /^\u0905\u0917/i,
            /^\u0938\u093f\u0924/i,
            /^\u0905\u0915\u094d\u091f\u0942/i,
            /^\u0928\u0935/i,
            /^\u0926\u093f\u0938/i,
          ],
          monthsRegex:
            /^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,
          monthsShortRegex:
            /^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,
          monthsStrictRegex:
            /^(\u091c\u0928\u0935\u0930\u0940?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908?|\u0905\u0917\u0938\u094d\u0924?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924?\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930?)/i,
          monthsShortStrictRegex:
            /^(\u091c\u0928\.?|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\.?|\u0905\u0917\.?|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\.?|\u0926\u093f\u0938\.?)/i,
          calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u0915\u0932] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u0932] LT",
            lastWeek: "[\u092a\u093f\u091b\u0932\u0947] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u092e\u0947\u0902",
            past: "%s \u092a\u0939\u0932\u0947",
            s: "\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0902\u0921",
            m: "\u090f\u0915 \u092e\u093f\u0928\u091f",
            mm: "%d \u092e\u093f\u0928\u091f",
            h: "\u090f\u0915 \u0918\u0902\u091f\u093e",
            hh: "%d \u0918\u0902\u091f\u0947",
            d: "\u090f\u0915 \u0926\u093f\u0928",
            dd: "%d \u0926\u093f\u0928",
            M: "\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",
            MM: "%d \u092e\u0939\u0940\u0928\u0947",
            y: "\u090f\u0915 \u0935\u0930\u094d\u0937",
            yy: "%d \u0935\u0930\u094d\u0937",
          },
          preparse: function (e) {
            return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0930\u093e\u0924" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0938\u0941\u092c\u0939" === t
                ? e
                : "\u0926\u094b\u092a\u0939\u0930" === t
                ? e >= 10
                  ? e
                  : e + 12
                : "\u0936\u093e\u092e" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0930\u093e\u0924"
              : e < 10
              ? "\u0938\u0941\u092c\u0939"
              : e < 17
              ? "\u0926\u094b\u092a\u0939\u0930"
              : e < 20
              ? "\u0936\u093e\u092e"
              : "\u0930\u093e\u0924";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    "3g1g": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("fil", {
          months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
          monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
          weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
          weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
          weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "MM/D/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY HH:mm",
            LLLL: "dddd, MMMM DD, YYYY HH:mm",
          },
          calendar: {
            sameDay: "LT [ngayong araw]",
            nextDay: "[Bukas ng] LT",
            nextWeek: "LT [sa susunod na] dddd",
            lastDay: "LT [kahapon]",
            lastWeek: "LT [noong nakaraang] dddd",
            sameElse: "L",
          },
          relativeTime: {
            future: "sa loob ng %s",
            past: "%s ang nakalipas",
            s: "ilang segundo",
            ss: "%d segundo",
            m: "isang minuto",
            mm: "%d minuto",
            h: "isang oras",
            hh: "%d oras",
            d: "isang araw",
            dd: "%d araw",
            M: "isang buwan",
            MM: "%d buwan",
            y: "isang taon",
            yy: "%d taon",
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: function (e) {
            return e;
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "3y2C": function (e) {
      e.exports = JSON.parse(
        '{"version":"2019b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}'
      );
    },
    "4MAb": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("te", {
          months:
            "\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split(
              "_"
            ),
          monthsShort:
            "\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split(
              "_"
            ),
          weekdaysShort:
            "\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split(
              "_"
            ),
          weekdaysMin: "\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split("_"),
          longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm",
          },
          calendar: {
            sameDay: "[\u0c28\u0c47\u0c21\u0c41] LT",
            nextDay: "[\u0c30\u0c47\u0c2a\u0c41] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",
            lastWeek: "[\u0c17\u0c24] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0c32\u0c4b",
            past: "%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",
            s: "\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",
            ss: "%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",
            m: "\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",
            mm: "%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",
            h: "\u0c12\u0c15 \u0c17\u0c02\u0c1f",
            hh: "%d \u0c17\u0c02\u0c1f\u0c32\u0c41",
            d: "\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",
            dd: "%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",
            M: "\u0c12\u0c15 \u0c28\u0c46\u0c32",
            MM: "%d \u0c28\u0c46\u0c32\u0c32\u0c41",
            y: "\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",
            yy: "%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\u0c35/,
          ordinal: "%d\u0c35",
          meridiemParse:
            /\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0c09\u0c26\u0c2f\u0c02" === t
                ? e
                : "\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02" === t
                ? e >= 10
                  ? e
                  : e + 12
                : "\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"
              : e < 10
              ? "\u0c09\u0c26\u0c2f\u0c02"
              : e < 17
              ? "\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02"
              : e < 20
              ? "\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02"
              : "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    "4VvY": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("sw", {
          months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),
          monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
          weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),
          weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
          weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "hh:mm A",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[leo saa] LT",
            nextDay: "[kesho saa] LT",
            nextWeek: "[wiki ijayo] dddd [saat] LT",
            lastDay: "[jana] LT",
            lastWeek: "[wiki iliyopita] dddd [saat] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s baadaye",
            past: "tokea %s",
            s: "hivi punde",
            ss: "sekunde %d",
            m: "dakika moja",
            mm: "dakika %d",
            h: "saa limoja",
            hh: "masaa %d",
            d: "siku moja",
            dd: "siku %d",
            M: "mwezi mmoja",
            MM: "miezi %d",
            y: "mwaka mmoja",
            yy: "miaka %d",
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    "4bvN": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("eo", {
          months:
            "januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split(
              "_"
            ),
          monthsShort: "jan_feb_mart_apr_maj_jun_jul_a\u016dg_sept_okt_nov_dec".split("_"),
          weekdays: "diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split("_"),
          weekdaysShort: "dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),
          weekdaysMin: "di_lu_ma_me_\u0135a_ve_sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "[la] D[-an de] MMMM, YYYY",
            LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
            LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
            llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm",
          },
          meridiemParse: /[ap]\.t\.m/i,
          isPM: function (e) {
            return "p" === e.charAt(0).toLowerCase();
          },
          meridiem: function (e, t, n) {
            return e > 11 ? (n ? "p.t.m." : "P.T.M.") : n ? "a.t.m." : "A.T.M.";
          },
          calendar: {
            sameDay: "[Hodia\u016d je] LT",
            nextDay: "[Morga\u016d je] LT",
            nextWeek: "dddd[n je] LT",
            lastDay: "[Hiera\u016d je] LT",
            lastWeek: "[pasintan] dddd[n je] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "post %s",
            past: "anta\u016d %s",
            s: "kelkaj sekundoj",
            ss: "%d sekundoj",
            m: "unu minuto",
            mm: "%d minutoj",
            h: "unu horo",
            hh: "%d horoj",
            d: "unu tago",
            dd: "%d tagoj",
            M: "unu monato",
            MM: "%d monatoj",
            y: "unu jaro",
            yy: "%d jaroj",
          },
          dayOfMonthOrdinalParse: /\d{1,2}a/,
          ordinal: "%da",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    "5BRa": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("zh-mo", {
          months:
            "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
              "_"
            ),
          monthsShort:
            "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
              "_"
            ),
          weekdays:
            "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
              "_"
            ),
          weekdaysShort:
            "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),
          weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            l: "D/M/YYYY",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
          },
          meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u51cc\u6668" === t || "\u65e9\u4e0a" === t || "\u4e0a\u5348" === t
                ? e
                : "\u4e2d\u5348" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "\u4e0b\u5348" === t || "\u665a\u4e0a" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            var s = 100 * e + t;
            return s < 600
              ? "\u51cc\u6668"
              : s < 900
              ? "\u65e9\u4e0a"
              : s < 1130
              ? "\u4e0a\u5348"
              : s < 1230
              ? "\u4e2d\u5348"
              : s < 1800
              ? "\u4e0b\u5348"
              : "\u665a\u4e0a";
          },
          calendar: {
            sameDay: "[\u4eca\u5929] LT",
            nextDay: "[\u660e\u5929] LT",
            nextWeek: "[\u4e0b]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4e0a]dddd LT",
            sameElse: "L",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + "\u65e5";
              case "M":
                return e + "\u6708";
              case "w":
              case "W":
                return e + "\u9031";
              default:
                return e;
            }
          },
          relativeTime: {
            future: "%s\u5167",
            past: "%s\u524d",
            s: "\u5e7e\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5c0f\u6642",
            hh: "%d \u5c0f\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500b\u6708",
            MM: "%d \u500b\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74",
          },
        });
      })(n("wgY5"));
    },
    "5Mza": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ar-tn", {
          months:
            "\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
              "_"
            ),
          monthsShort:
            "\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
              "_"
            ),
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a",
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "5j0y": function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            s: ["thoddea sekondamni", "thodde sekond"],
            ss: [e + " sekondamni", e + " sekond"],
            m: ["eka mintan", "ek minut"],
            mm: [e + " mintamni", e + " mintam"],
            h: ["eka voran", "ek vor"],
            hh: [e + " voramni", e + " voram"],
            d: ["eka disan", "ek dis"],
            dd: [e + " disamni", e + " dis"],
            M: ["eka mhoinean", "ek mhoino"],
            MM: [e + " mhoineamni", e + " mhoine"],
            y: ["eka vorsan", "ek voros"],
            yy: [e + " vorsamni", e + " vorsam"],
          };
          return s ? r[n][0] : r[n][1];
        }
        e.defineLocale("gom-latn", {
          months: {
            standalone: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),
            format:
              "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split(
                "_"
              ),
            isFormat: /MMMM(\s)+D[oD]?/,
          },
          monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
          monthsParseExact: !0,
          weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
          weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
          weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "A h:mm [vazta]",
            LTS: "A h:mm:ss [vazta]",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY A h:mm [vazta]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
            llll: "ddd, D MMM YYYY, A h:mm [vazta]",
          },
          calendar: {
            sameDay: "[Aiz] LT",
            nextDay: "[Faleam] LT",
            nextWeek: "[Fuddlo] dddd[,] LT",
            lastDay: "[Kal] LT",
            lastWeek: "[Fattlo] dddd[,] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s",
            past: "%s adim",
            s: t,
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: t,
            dd: t,
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er)/,
          ordinal: function (e, t) {
            switch (t) {
              case "D":
                return e + "er";
              default:
              case "M":
              case "Q":
              case "DDD":
              case "d":
              case "w":
              case "W":
                return e;
            }
          },
          week: { dow: 0, doy: 3 },
          meridiemParse: /rati|sokallim|donparam|sanje/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "rati" === t
                ? e < 4
                  ? e
                  : e + 12
                : "sokallim" === t
                ? e
                : "donparam" === t
                ? e > 12
                  ? e
                  : e + 12
                : "sanje" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4 ? "rati" : e < 12 ? "sokallim" : e < 16 ? "donparam" : e < 20 ? "sanje" : "rati";
          },
        });
      })(n("wgY5"));
    },
    "6Olw": function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          return "m" === n
            ? t
              ? "\u0445\u0432\u0438\u043b\u0438\u043d\u0430"
              : "\u0445\u0432\u0438\u043b\u0438\u043d\u0443"
            : "h" === n
            ? t
              ? "\u0433\u043e\u0434\u0438\u043d\u0430"
              : "\u0433\u043e\u0434\u0438\u043d\u0443"
            : e +
              " " +
              ((s = +e),
              (r = {
                ss: t
                  ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434"
                  : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",
                mm: t
                  ? "\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d"
                  : "\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",
                hh: t
                  ? "\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d"
                  : "\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",
                dd: "\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",
                MM: "\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",
                yy: "\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432",
              }[n].split("_")),
              s % 10 == 1 && s % 100 != 11
                ? r[0]
                : s % 10 >= 2 && s % 10 <= 4 && (s % 100 < 10 || s % 100 >= 20)
                ? r[1]
                : r[2]);
          var s, r;
        }
        function n(e) {
          return function () {
            return e + "\u043e" + (11 === this.hours() ? "\u0431" : "") + "] LT";
          };
        }
        e.defineLocale("uk", {
          months: {
            format:
              "\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split(
                "_"
              ),
            standalone:
              "\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split(
                "_"
              ),
          },
          monthsShort:
            "\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split(
              "_"
            ),
          weekdays: function (e, t) {
            var n = {
              nominative:
                "\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split(
                  "_"
                ),
              accusative:
                "\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split(
                  "_"
                ),
              genitive:
                "\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split(
                  "_"
                ),
            };
            return !0 === e
              ? n.nominative.slice(1, 7).concat(n.nominative.slice(0, 1))
              : e
              ? n[
                  /(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(t)
                    ? "accusative"
                    : /\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(
                        t
                      )
                    ? "genitive"
                    : "nominative"
                ][e.day()]
              : n.nominative;
          },
          weekdaysShort:
            "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
          weekdaysMin:
            "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0440.",
            LLL: "D MMMM YYYY \u0440., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0440., HH:mm",
          },
          calendar: {
            sameDay: n("[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "),
            nextDay: n("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
            lastDay: n("[\u0412\u0447\u043e\u0440\u0430 "),
            nextWeek: n("[\u0423] dddd ["),
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                  return n("[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd [").call(this);
                case 1:
                case 2:
                case 4:
                  return n("[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd [").call(this);
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0437\u0430 %s",
            past: "%s \u0442\u043e\u043c\u0443",
            s: "\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: t,
            m: t,
            mm: t,
            h: "\u0433\u043e\u0434\u0438\u043d\u0443",
            hh: t,
            d: "\u0434\u0435\u043d\u044c",
            dd: t,
            M: "\u043c\u0456\u0441\u044f\u0446\u044c",
            MM: t,
            y: "\u0440\u0456\u043a",
            yy: t,
          },
          meridiemParse:
            /\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,
          isPM: function (e) {
            return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u043d\u043e\u0447\u0456"
              : e < 12
              ? "\u0440\u0430\u043d\u043a\u0443"
              : e < 17
              ? "\u0434\u043d\u044f"
              : "\u0432\u0435\u0447\u043e\u0440\u0430";
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0439|\u0433\u043e)/,
          ordinal: function (e, t) {
            switch (t) {
              case "M":
              case "d":
              case "DDD":
              case "w":
              case "W":
                return e + "-\u0439";
              case "D":
                return e + "-\u0433\u043e";
              default:
                return e;
            }
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    "6PD3": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          ss: "sekund\u0117_sekund\u017ei\u0173_sekundes",
          m: "minut\u0117_minut\u0117s_minut\u0119",
          mm: "minut\u0117s_minu\u010di\u0173_minutes",
          h: "valanda_valandos_valand\u0105",
          hh: "valandos_valand\u0173_valandas",
          d: "diena_dienos_dien\u0105",
          dd: "dienos_dien\u0173_dienas",
          M: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",
          MM: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
          y: "metai_met\u0173_metus",
          yy: "metai_met\u0173_metus",
        };
        function n(e, t, n, s) {
          return t ? r(n)[0] : s ? r(n)[1] : r(n)[2];
        }
        function s(e) {
          return e % 10 == 0 || (e > 10 && e < 20);
        }
        function r(e) {
          return t[e].split("_");
        }
        function i(e, t, i, a) {
          var o = e + " ";
          return 1 === e
            ? o + n(0, t, i[0], a)
            : t
            ? o + (s(e) ? r(i)[1] : r(i)[0])
            : a
            ? o + r(i)[1]
            : o + (s(e) ? r(i)[1] : r(i)[2]);
        }
        e.defineLocale("lt", {
          months: {
            format:
              "sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split(
                "_"
              ),
            standalone:
              "sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split(
                "_"
              ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
          },
          monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
          weekdays: {
            format:
              "sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split(
                "_"
              ),
            standalone:
              "sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split(
                "_"
              ),
            isFormat: /dddd HH:mm/,
          },
          weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),
          weekdaysMin: "S_P_A_T_K_Pn_\u0160".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY [m.] MMMM D [d.]",
            LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
            l: "YYYY-MM-DD",
            ll: "YYYY [m.] MMMM D [d.]",
            lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]",
          },
          calendar: {
            sameDay: "[\u0160iandien] LT",
            nextDay: "[Rytoj] LT",
            nextWeek: "dddd LT",
            lastDay: "[Vakar] LT",
            lastWeek: "[Pra\u0117jus\u012f] dddd LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "po %s",
            past: "prie\u0161 %s",
            s: function (e, t, n, s) {
              return t ? "kelios sekund\u0117s" : s ? "keli\u0173 sekund\u017ei\u0173" : "kelias sekundes";
            },
            ss: i,
            m: n,
            mm: i,
            h: n,
            hh: i,
            d: n,
            dd: i,
            M: n,
            MM: i,
            y: n,
            yy: i,
          },
          dayOfMonthOrdinalParse: /\d{1,2}-oji/,
          ordinal: function (e) {
            return e + "-oji";
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "6cYq": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("tzm", {
          months:
            "\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split(
              "_"
            ),
          monthsShort:
            "\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split(
              "_"
            ),
          weekdays:
            "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split(
              "_"
            ),
          weekdaysShort:
            "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split(
              "_"
            ),
          weekdaysMin:
            "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split(
              "_"
            ),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",
            nextDay: "[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",
            nextWeek: "dddd [\u2d34] LT",
            lastDay: "[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",
            lastWeek: "dddd [\u2d34] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",
            past: "\u2d62\u2d30\u2d4f %s",
            s: "\u2d49\u2d4e\u2d49\u2d3d",
            ss: "%d \u2d49\u2d4e\u2d49\u2d3d",
            m: "\u2d4e\u2d49\u2d4f\u2d53\u2d3a",
            mm: "%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",
            h: "\u2d59\u2d30\u2d44\u2d30",
            hh: "%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",
            d: "\u2d30\u2d59\u2d59",
            dd: "%d o\u2d59\u2d59\u2d30\u2d4f",
            M: "\u2d30\u2d62o\u2d53\u2d54",
            MM: "%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",
            y: "\u2d30\u2d59\u2d33\u2d30\u2d59",
            yy: "%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f",
          },
          week: { dow: 6, doy: 12 },
        });
      })(n("wgY5"));
    },
    "8Bez": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t =
            "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split(
              "_"
            ),
          n =
            "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split(
              "_"
            ),
          s = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^pa\u017a/i,
            /^lis/i,
            /^gru/i,
          ];
        function r(e) {
          return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
        }
        function i(e, t, n) {
          var s = e + " ";
          switch (n) {
            case "ss":
              return s + (r(e) ? "sekundy" : "sekund");
            case "m":
              return t ? "minuta" : "minut\u0119";
            case "mm":
              return s + (r(e) ? "minuty" : "minut");
            case "h":
              return t ? "godzina" : "godzin\u0119";
            case "hh":
              return s + (r(e) ? "godziny" : "godzin");
            case "ww":
              return s + (r(e) ? "tygodnie" : "tygodni");
            case "MM":
              return s + (r(e) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
              return s + (r(e) ? "lata" : "lat");
          }
        }
        e.defineLocale("pl", {
          months: function (e, s) {
            return e ? (/D MMMM/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split("_"),
          weekdaysShort: "ndz_pon_wt_\u015br_czw_pt_sob".split("_"),
          weekdaysMin: "Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Dzi\u015b o] LT",
            nextDay: "[Jutro o] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[W niedziel\u0119 o] LT";
                case 2:
                  return "[We wtorek o] LT";
                case 3:
                  return "[W \u015brod\u0119 o] LT";
                case 6:
                  return "[W sobot\u0119 o] LT";
                default:
                  return "[W] dddd [o] LT";
              }
            },
            lastDay: "[Wczoraj o] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                case 3:
                  return "[W zesz\u0142\u0105 \u015brod\u0119 o] LT";
                case 6:
                  return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                default:
                  return "[W zesz\u0142y] dddd [o] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            ss: i,
            m: i,
            mm: i,
            h: i,
            hh: i,
            d: "1 dzie\u0144",
            dd: "%d dni",
            w: "tydzie\u0144",
            ww: i,
            M: "miesi\u0105c",
            MM: i,
            y: "rok",
            yy: i,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "8Cju": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u06f1",
            2: "\u06f2",
            3: "\u06f3",
            4: "\u06f4",
            5: "\u06f5",
            6: "\u06f6",
            7: "\u06f7",
            8: "\u06f8",
            9: "\u06f9",
            0: "\u06f0",
          },
          n = {
            "\u06f1": "1",
            "\u06f2": "2",
            "\u06f3": "3",
            "\u06f4": "4",
            "\u06f5": "5",
            "\u06f6": "6",
            "\u06f7": "7",
            "\u06f8": "8",
            "\u06f9": "9",
            "\u06f0": "0",
          };
        e.defineLocale("fa", {
          months:
            "\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split(
              "_"
            ),
          monthsShort:
            "\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split(
              "_"
            ),
          weekdays:
            "\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split(
              "_"
            ),
          weekdaysShort:
            "\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split(
              "_"
            ),
          weekdaysMin: "\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          meridiemParse:
            /\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,
          isPM: function (e) {
            return /\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 12
              ? "\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631"
              : "\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631";
          },
          calendar: {
            sameDay: "[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",
            nextDay: "[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",
            nextWeek: "dddd [\u0633\u0627\u0639\u062a] LT",
            lastDay: "[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",
            lastWeek: "dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u062f\u0631 %s",
            past: "%s \u067e\u06cc\u0634",
            s: "\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",
            ss: "%d \u062b\u0627\u0646\u06cc\u0647",
            m: "\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",
            mm: "%d \u062f\u0642\u06cc\u0642\u0647",
            h: "\u06cc\u06a9 \u0633\u0627\u0639\u062a",
            hh: "%d \u0633\u0627\u0639\u062a",
            d: "\u06cc\u06a9 \u0631\u0648\u0632",
            dd: "%d \u0631\u0648\u0632",
            M: "\u06cc\u06a9 \u0645\u0627\u0647",
            MM: "%d \u0645\u0627\u0647",
            y: "\u06cc\u06a9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644",
          },
          preparse: function (e) {
            return e
              .replace(/[\u06f0-\u06f9]/g, function (e) {
                return n[e];
              })
              .replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e
              .replace(/\d/g, function (e) {
                return t[e];
              })
              .replace(/,/g, "\u060c");
          },
          dayOfMonthOrdinalParse: /\d{1,2}\u0645/,
          ordinal: "%d\u0645",
          week: { dow: 6, doy: 12 },
        });
      })(n("wgY5"));
    },
    "8GSH": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("af", {
          months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split(
            "_"
          ),
          monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
          weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),
          weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
          weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
          meridiemParse: /vm|nm/i,
          isPM: function (e) {
            return /^nm$/i.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 12 ? (n ? "vm" : "VM") : n ? "nm" : "NM";
          },
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Vandag om] LT",
            nextDay: "[M\xf4re om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[Gister om] LT",
            lastWeek: "[Laas] dddd [om] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "oor %s",
            past: "%s gelede",
            s: "'n paar sekondes",
            ss: "%d sekondes",
            m: "'n minuut",
            mm: "%d minute",
            h: "'n uur",
            hh: "%d ure",
            d: "'n dag",
            dd: "%d dae",
            M: "'n maand",
            MM: "%d maande",
            y: "'n jaar",
            yy: "%d jaar",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function (e) {
            return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "8Ygf": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("fo", {
          months: "januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
          monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
          weekdays: "sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),
          weekdaysShort: "sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),
          weekdaysMin: "su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D. MMMM, YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\xcd dag kl.] LT",
            nextDay: "[\xcd morgin kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[\xcd gj\xe1r kl.] LT",
            lastWeek: "[s\xed\xf0stu] dddd [kl] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "um %s",
            past: "%s s\xed\xf0ani",
            s: "f\xe1 sekund",
            ss: "%d sekundir",
            m: "ein minuttur",
            mm: "%d minuttir",
            h: "ein t\xedmi",
            hh: "%d t\xedmar",
            d: "ein dagur",
            dd: "%d dagar",
            M: "ein m\xe1na\xf0ur",
            MM: "%d m\xe1na\xf0ir",
            y: "eitt \xe1r",
            yy: "%d \xe1r",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    ACAV: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("he", {
          months:
            "\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split(
              "_"
            ),
          monthsShort:
            "\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split(
              "_"
            ),
          weekdays:
            "\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split(
              "_"
            ),
          weekdaysShort:
            "\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split("_"),
          weekdaysMin: "\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [\u05d1]MMMM YYYY",
            LLL: "D [\u05d1]MMMM YYYY HH:mm",
            LLLL: "dddd, D [\u05d1]MMMM YYYY HH:mm",
            l: "D/M/YYYY",
            ll: "D MMM YYYY",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd, D MMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",
            nextDay: "[\u05de\u05d7\u05e8 \u05d1\u05be]LT",
            nextWeek: "dddd [\u05d1\u05e9\u05e2\u05d4] LT",
            lastDay: "[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",
            lastWeek:
              "[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u05d1\u05e2\u05d5\u05d3 %s",
            past: "\u05dc\u05e4\u05e0\u05d9 %s",
            s: "\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",
            ss: "%d \u05e9\u05e0\u05d9\u05d5\u05ea",
            m: "\u05d3\u05e7\u05d4",
            mm: "%d \u05d3\u05e7\u05d5\u05ea",
            h: "\u05e9\u05e2\u05d4",
            hh: function (e) {
              return 2 === e ? "\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd" : e + " \u05e9\u05e2\u05d5\u05ea";
            },
            d: "\u05d9\u05d5\u05dd",
            dd: function (e) {
              return 2 === e ? "\u05d9\u05d5\u05de\u05d9\u05d9\u05dd" : e + " \u05d9\u05de\u05d9\u05dd";
            },
            M: "\u05d7\u05d5\u05d3\u05e9",
            MM: function (e) {
              return 2 === e
                ? "\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd"
                : e + " \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd";
            },
            y: "\u05e9\u05e0\u05d4",
            yy: function (e) {
              return 2 === e
                ? "\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd"
                : e % 10 == 0 && 10 !== e
                ? e + " \u05e9\u05e0\u05d4"
                : e + " \u05e9\u05e0\u05d9\u05dd";
            },
          },
          meridiemParse:
            /\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,
          isPM: function (e) {
            return /^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(
              e
            );
          },
          meridiem: function (e, t, n) {
            return e < 5
              ? "\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8"
              : e < 10
              ? "\u05d1\u05d1\u05d5\u05e7\u05e8"
              : e < 12
              ? n
                ? '\u05dc\u05e4\u05e0\u05d4"\u05e6'
                : "\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd"
              : e < 18
              ? n
                ? '\u05d0\u05d7\u05d4"\u05e6'
                : "\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd"
              : "\u05d1\u05e2\u05e8\u05d1";
          },
        });
      })(n("wgY5"));
    },
    "BAN/": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ka", {
          months:
            "\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split(
              "_"
            ),
          monthsShort:
            "\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split(
              "_"
            ),
          weekdays: {
            standalone:
              "\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split(
                "_"
              ),
            format:
              "\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split(
                "_"
              ),
            isFormat: /(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/,
          },
          weekdaysShort:
            "\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split(
              "_"
            ),
          weekdaysMin:
            "\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",
            nextDay: "[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",
            lastDay: "[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",
            nextWeek: "[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",
            lastWeek: "[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",
            sameElse: "L",
          },
          relativeTime: {
            future: function (e) {
              return e.replace(
                /(\u10ec\u10d0\u10db|\u10ec\u10e3\u10d7|\u10e1\u10d0\u10d0\u10d7|\u10ec\u10d4\u10da|\u10d3\u10e6|\u10d7\u10d5)(\u10d8|\u10d4)/,
                function (e, t, n) {
                  return "\u10d8" === n ? t + "\u10e8\u10d8" : t + n + "\u10e8\u10d8";
                }
              );
            },
            past: function (e) {
              return /(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(
                e
              )
                ? e.replace(/(\u10d8|\u10d4)$/, "\u10d8\u10e1 \u10ec\u10d8\u10dc")
                : /\u10ec\u10d4\u10da\u10d8/.test(e)
                ? e.replace(/\u10ec\u10d4\u10da\u10d8$/, "\u10ec\u10da\u10d8\u10e1 \u10ec\u10d8\u10dc")
                : e;
            },
            s: "\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",
            ss: "%d \u10ec\u10d0\u10db\u10d8",
            m: "\u10ec\u10e3\u10d7\u10d8",
            mm: "%d \u10ec\u10e3\u10d7\u10d8",
            h: "\u10e1\u10d0\u10d0\u10d7\u10d8",
            hh: "%d \u10e1\u10d0\u10d0\u10d7\u10d8",
            d: "\u10d3\u10e6\u10d4",
            dd: "%d \u10d3\u10e6\u10d4",
            M: "\u10d7\u10d5\u10d4",
            MM: "%d \u10d7\u10d5\u10d4",
            y: "\u10ec\u10d4\u10da\u10d8",
            yy: "%d \u10ec\u10d4\u10da\u10d8",
          },
          dayOfMonthOrdinalParse: /0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,
          ordinal: function (e) {
            return 0 === e
              ? e
              : 1 === e
              ? e + "-\u10da\u10d8"
              : e < 20 || (e <= 100 && e % 20 == 0) || e % 100 == 0
              ? "\u10db\u10d4-" + e
              : e + "-\u10d4";
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    "BKZ+": function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            m: ["eine Minute", "einer Minute"],
            h: ["eine Stunde", "einer Stunde"],
            d: ["ein Tag", "einem Tag"],
            dd: [e + " Tage", e + " Tagen"],
            w: ["eine Woche", "einer Woche"],
            M: ["ein Monat", "einem Monat"],
            MM: [e + " Monate", e + " Monaten"],
            y: ["ein Jahr", "einem Jahr"],
            yy: [e + " Jahre", e + " Jahren"],
          };
          return t ? r[n][0] : r[n][1];
        }
        e.defineLocale("de", {
          months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
          monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
          monthsParseExact: !0,
          weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
          weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
          weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]",
          },
          relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: t,
            mm: "%d Minuten",
            h: t,
            hh: "%d Stunden",
            d: t,
            dd: t,
            w: t,
            ww: "%d Wochen",
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    CPJk: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0967",
            2: "\u0968",
            3: "\u0969",
            4: "\u096a",
            5: "\u096b",
            6: "\u096c",
            7: "\u096d",
            8: "\u096e",
            9: "\u096f",
            0: "\u0966",
          },
          n = {
            "\u0967": "1",
            "\u0968": "2",
            "\u0969": "3",
            "\u096a": "4",
            "\u096b": "5",
            "\u096c": "6",
            "\u096d": "7",
            "\u096e": "8",
            "\u096f": "9",
            "\u0966": "0",
          };
        function s(e, t, n, s) {
          var r = "";
          if (t)
            switch (n) {
              case "s":
                r = "\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";
                break;
              case "ss":
                r = "%d \u0938\u0947\u0915\u0902\u0926";
                break;
              case "m":
                r = "\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";
                break;
              case "mm":
                r = "%d \u092e\u093f\u0928\u093f\u091f\u0947";
                break;
              case "h":
                r = "\u090f\u0915 \u0924\u093e\u0938";
                break;
              case "hh":
                r = "%d \u0924\u093e\u0938";
                break;
              case "d":
                r = "\u090f\u0915 \u0926\u093f\u0935\u0938";
                break;
              case "dd":
                r = "%d \u0926\u093f\u0935\u0938";
                break;
              case "M":
                r = "\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";
                break;
              case "MM":
                r = "%d \u092e\u0939\u093f\u0928\u0947";
                break;
              case "y":
                r = "\u090f\u0915 \u0935\u0930\u094d\u0937";
                break;
              case "yy":
                r = "%d \u0935\u0930\u094d\u0937\u0947";
            }
          else
            switch (n) {
              case "s":
                r = "\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";
                break;
              case "ss":
                r = "%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";
                break;
              case "m":
                r = "\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";
                break;
              case "mm":
                r = "%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";
                break;
              case "h":
                r = "\u090f\u0915\u093e \u0924\u093e\u0938\u093e";
                break;
              case "hh":
                r = "%d \u0924\u093e\u0938\u093e\u0902";
                break;
              case "d":
                r = "\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";
                break;
              case "dd":
                r = "%d \u0926\u093f\u0935\u0938\u093e\u0902";
                break;
              case "M":
                r = "\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";
                break;
              case "MM":
                r = "%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";
                break;
              case "y":
                r = "\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";
                break;
              case "yy":
                r = "%d \u0935\u0930\u094d\u0937\u093e\u0902";
            }
          return r.replace(/%d/i, e);
        }
        e.defineLocale("mr", {
          months:
            "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split(
              "_"
            ),
          monthsShort:
            "\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split(
              "_"
            ),
          weekdaysShort:
            "\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split(
              "_"
            ),
          weekdaysMin: "\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
          longDateFormat: {
            LT: "A h:mm \u0935\u093e\u091c\u0924\u093e",
            LTS: "A h:mm:ss \u0935\u093e\u091c\u0924\u093e",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",
          },
          calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u0909\u0926\u094d\u092f\u093e] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u093e\u0932] LT",
            lastWeek: "[\u092e\u093e\u0917\u0940\u0932] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s\u092e\u0927\u094d\u092f\u0947",
            past: "%s\u092a\u0942\u0930\u094d\u0935\u0940",
            s,
            ss: s,
            m: s,
            mm: s,
            h: s,
            hh: s,
            d: s,
            dd: s,
            M: s,
            MM: s,
            y: s,
            yy: s,
          },
          preparse: function (e) {
            return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u092a\u0939\u093e\u091f\u0947|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940|\u0930\u093e\u0924\u094d\u0930\u0940/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u092a\u0939\u093e\u091f\u0947" === t || "\u0938\u0915\u093e\u0933\u0940" === t
                ? e
                : "\u0926\u0941\u092a\u093e\u0930\u0940" === t ||
                  "\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940" === t ||
                  "\u0930\u093e\u0924\u094d\u0930\u0940" === t
                ? e >= 12
                  ? e
                  : e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e >= 0 && e < 6
              ? "\u092a\u0939\u093e\u091f\u0947"
              : e < 12
              ? "\u0938\u0915\u093e\u0933\u0940"
              : e < 17
              ? "\u0926\u0941\u092a\u093e\u0930\u0940"
              : e < 20
              ? "\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940"
              : "\u0930\u093e\u0924\u094d\u0930\u0940";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    CZRU: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("se", {
          months:
            "o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split(
              "_"
            ),
          monthsShort: "o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split("_"),
          weekdays:
            "sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),
          weekdaysShort: "sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split("_"),
          weekdaysMin: "s_v_m_g_d_b_L".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "MMMM D. [b.] YYYY",
            LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
            LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm",
          },
          calendar: {
            sameDay: "[otne ti] LT",
            nextDay: "[ihttin ti] LT",
            nextWeek: "dddd [ti] LT",
            lastDay: "[ikte ti] LT",
            lastWeek: "[ovddit] dddd [ti] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s gea\u017ees",
            past: "ma\u014bit %s",
            s: "moadde sekunddat",
            ss: "%d sekunddat",
            m: "okta minuhta",
            mm: "%d minuhtat",
            h: "okta diimmu",
            hh: "%d diimmut",
            d: "okta beaivi",
            dd: "%d beaivvit",
            M: "okta m\xe1nnu",
            MM: "%d m\xe1nut",
            y: "okta jahki",
            yy: "%d jagit",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    DDip: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("pt", {
          months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
            "_"
          ),
          monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
          weekdays: "Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),
          weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),
          weekdaysMin: "Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function () {
              return 0 === this.day() || 6 === this.day()
                ? "[\xdaltimo] dddd [\xe0s] LT"
                : "[\xdaltima] dddd [\xe0s] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "segundos",
            ss: "%d segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            w: "uma semana",
            ww: "%d semanas",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    EL7g: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          var s = e + " ";
          switch (n) {
            case "ss":
              return s + (1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi");
            case "m":
              return t ? "jedna minuta" : "jedne minute";
            case "mm":
              return s + (1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta");
            case "h":
              return t ? "jedan sat" : "jednog sata";
            case "hh":
              return s + (1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati");
            case "dd":
              return s + (1 === e ? "dan" : "dana");
            case "MM":
              return s + (1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci");
            case "yy":
              return s + (1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina");
          }
        }
        e.defineLocale("bs", {
          months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),
          monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),
          weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
          weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[u] [nedjelju] [u] LT";
                case 3:
                  return "[u] [srijedu] [u] LT";
                case 6:
                  return "[u] [subotu] [u] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[u] dddd [u] LT";
              }
            },
            lastDay: "[ju\u010der u] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                case 3:
                  return "[pro\u0161lu] dddd [u] LT";
                case 6:
                  return "[pro\u0161le] [subote] [u] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[pro\u0161li] dddd [u] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "par sekundi",
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: "dan",
            dd: t,
            M: "mjesec",
            MM: t,
            y: "godinu",
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    EQmw: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");
        function n(e, t, n, s) {
          var r = e;
          switch (n) {
            case "s":
              return s || t ? "n\xe9h\xe1ny m\xe1sodperc" : "n\xe9h\xe1ny m\xe1sodperce";
            case "ss":
              return r + (s || t) ? " m\xe1sodperc" : " m\xe1sodperce";
            case "m":
              return "egy" + (s || t ? " perc" : " perce");
            case "mm":
              return r + (s || t ? " perc" : " perce");
            case "h":
              return "egy" + (s || t ? " \xf3ra" : " \xf3r\xe1ja");
            case "hh":
              return r + (s || t ? " \xf3ra" : " \xf3r\xe1ja");
            case "d":
              return "egy" + (s || t ? " nap" : " napja");
            case "dd":
              return r + (s || t ? " nap" : " napja");
            case "M":
              return "egy" + (s || t ? " h\xf3nap" : " h\xf3napja");
            case "MM":
              return r + (s || t ? " h\xf3nap" : " h\xf3napja");
            case "y":
              return "egy" + (s || t ? " \xe9v" : " \xe9ve");
            case "yy":
              return r + (s || t ? " \xe9v" : " \xe9ve");
          }
          return "";
        }
        function s(e) {
          return (e ? "" : "[m\xfalt] ") + "[" + t[this.day()] + "] LT[-kor]";
        }
        e.defineLocale("hu", {
          months:
            "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split(
              "_"
            ),
          monthsShort: "jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),
          weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),
          weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY. MMMM D.",
            LLL: "YYYY. MMMM D. H:mm",
            LLLL: "YYYY. MMMM D., dddd H:mm",
          },
          meridiemParse: /de|du/i,
          isPM: function (e) {
            return "u" === e.charAt(1).toLowerCase();
          },
          meridiem: function (e, t, n) {
            return e < 12 ? (!0 === n ? "de" : "DE") : !0 === n ? "du" : "DU";
          },
          calendar: {
            sameDay: "[ma] LT[-kor]",
            nextDay: "[holnap] LT[-kor]",
            nextWeek: function () {
              return s.call(this, !0);
            },
            lastDay: "[tegnap] LT[-kor]",
            lastWeek: function () {
              return s.call(this, !1);
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "%s m\xfalva",
            past: "%s",
            s: n,
            ss: n,
            m: n,
            mm: n,
            h: n,
            hh: n,
            d: n,
            dd: n,
            M: n,
            MM: n,
            y: n,
            yy: n,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    EnIJ: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("vi", {
          months:
            "th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split(
              "_"
            ),
          monthsShort: "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),
          monthsParseExact: !0,
          weekdays:
            "ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split(
              "_"
            ),
          weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
          weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
          weekdaysParseExact: !0,
          meridiemParse: /sa|ch/i,
          isPM: function (e) {
            return /^ch$/i.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 12 ? (n ? "sa" : "SA") : n ? "ch" : "CH";
          },
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [n\u0103m] YYYY",
            LLL: "D MMMM [n\u0103m] YYYY HH:mm",
            LLLL: "dddd, D MMMM [n\u0103m] YYYY HH:mm",
            l: "DD/M/YYYY",
            ll: "D MMM YYYY",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd, D MMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[H\xf4m nay l\xfac] LT",
            nextDay: "[Ng\xe0y mai l\xfac] LT",
            nextWeek: "dddd [tu\u1ea7n t\u1edbi l\xfac] LT",
            lastDay: "[H\xf4m qua l\xfac] LT",
            lastWeek: "dddd [tu\u1ea7n tr\u01b0\u1edbc l\xfac] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s t\u1edbi",
            past: "%s tr\u01b0\u1edbc",
            s: "v\xe0i gi\xe2y",
            ss: "%d gi\xe2y",
            m: "m\u1ed9t ph\xfat",
            mm: "%d ph\xfat",
            h: "m\u1ed9t gi\u1edd",
            hh: "%d gi\u1edd",
            d: "m\u1ed9t ng\xe0y",
            dd: "%d ng\xe0y",
            w: "m\u1ed9t tu\u1ea7n",
            ww: "%d tu\u1ea7n",
            M: "m\u1ed9t th\xe1ng",
            MM: "%d th\xe1ng",
            y: "m\u1ed9t n\u0103m",
            yy: "%d n\u0103m",
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: function (e) {
            return e;
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    EqYs: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          1: "'inci",
          5: "'inci",
          8: "'inci",
          70: "'inci",
          80: "'inci",
          2: "'nci",
          7: "'nci",
          20: "'nci",
          50: "'nci",
          3: "'\xfcnc\xfc",
          4: "'\xfcnc\xfc",
          100: "'\xfcnc\xfc",
          6: "'nc\u0131",
          9: "'uncu",
          10: "'uncu",
          30: "'uncu",
          60: "'\u0131nc\u0131",
          90: "'\u0131nc\u0131",
        };
        e.defineLocale("tr", {
          months:
            "Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split(
              "_"
            ),
          monthsShort: "Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split("_"),
          weekdays: "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split("_"),
          weekdaysShort: "Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split("_"),
          weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),
          meridiem: function (e, t, n) {
            return e < 12 ? (n ? "\xf6\xf6" : "\xd6\xd6") : n ? "\xf6s" : "\xd6S";
          },
          meridiemParse: /\xf6\xf6|\xd6\xd6|\xf6s|\xd6S/,
          isPM: function (e) {
            return "\xf6s" === e || "\xd6S" === e;
          },
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[yar\u0131n saat] LT",
            nextWeek: "[gelecek] dddd [saat] LT",
            lastDay: "[d\xfcn] LT",
            lastWeek: "[ge\xe7en] dddd [saat] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s sonra",
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            ss: "%d saniye",
            m: "bir dakika",
            mm: "%d dakika",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            w: "bir hafta",
            ww: "%d hafta",
            M: "bir ay",
            MM: "%d ay",
            y: "bir y\u0131l",
            yy: "%d y\u0131l",
          },
          ordinal: function (e, n) {
            switch (n) {
              case "d":
              case "D":
              case "Do":
              case "DD":
                return e;
              default:
                if (0 === e) return e + "'\u0131nc\u0131";
                var s = e % 10;
                return e + (t[s] || t[(e % 100) - s] || t[e >= 100 ? 100 : null]);
            }
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    FkqR: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          s = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
          ],
          r =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es-mx", {
          months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
          weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
          weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
          },
          calendar: {
            sameDay: function () {
              return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function () {
              return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function () {
              return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function () {
              return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function () {
              return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 0, doy: 4 },
          invalidDate: "Fecha inv\xe1lida",
        });
      })(n("wgY5"));
    },
    FyS8: function (e, t, n) {
      var s, r, i;
      !(function (a, o) {
        "use strict";
        e.exports
          ? (e.exports = o(n("wgY5")))
          : ((r = [n("wgY5")]), void 0 === (i = "function" == typeof (s = o) ? s.apply(t, r) : s) || (e.exports = i));
      })(0, function (e) {
        "use strict";
        var t,
          n = {},
          s = {},
          r = {},
          i = {};
        (e && "string" == typeof e.version) ||
          v("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
        var a = e.version.split("."),
          o = +a[0],
          c = +a[1];
        function l(e) {
          return e > 96 ? e - 87 : e > 64 ? e - 29 : e - 48;
        }
        function d(e) {
          var t = 0,
            n = e.split("."),
            s = n[0],
            r = n[1] || "",
            i = 1,
            a = 0,
            o = 1;
          for (45 === e.charCodeAt(0) && ((t = 1), (o = -1)); t < s.length; t++) a = 60 * a + l(s.charCodeAt(t));
          for (t = 0; t < r.length; t++) (i /= 60), (a += l(r.charCodeAt(t)) * i);
          return a * o;
        }
        function u(e) {
          for (var t = 0; t < e.length; t++) e[t] = d(e[t]);
        }
        function h(e, t) {
          var n,
            s = [];
          for (n = 0; n < t.length; n++) s[n] = e[t[n]];
          return s;
        }
        function M(e) {
          var t = e.split("|"),
            n = t[2].split(" "),
            s = t[3].split(""),
            r = t[4].split(" ");
          return (
            u(n),
            u(s),
            u(r),
            (function (e, t) {
              for (var n = 0; n < t; n++) e[n] = Math.round((e[n - 1] || 0) + 6e4 * e[n]);
              e[t - 1] = 1 / 0;
            })(r, s.length),
            { name: t[0], abbrs: h(t[1].split(" "), s), offsets: h(n, s), untils: r, population: 0 | t[5] }
          );
        }
        function p(e) {
          e && this._set(M(e));
        }
        function m(e) {
          var t = e.toTimeString(),
            n = t.match(/\([a-z ]+\)/i);
          "GMT" ===
            (n =
              n && n[0]
                ? (n = n[0].match(/[A-Z]/g))
                  ? n.join("")
                  : void 0
                : (n = t.match(/[A-Z]{3,5}/g))
                ? n[0]
                : void 0) && (n = void 0),
            (this.at = +e),
            (this.abbr = n),
            (this.offset = e.getTimezoneOffset());
        }
        function _(e) {
          (this.zone = e), (this.offsetScore = 0), (this.abbrScore = 0);
        }
        function f(e, t) {
          for (var n, s; (s = 6e4 * (((t.at - e.at) / 12e4) | 0)); )
            (n = new m(new Date(e.at + s))).offset === e.offset ? (e = n) : (t = n);
          return e;
        }
        function b(e, t) {
          return e.offsetScore !== t.offsetScore
            ? e.offsetScore - t.offsetScore
            : e.abbrScore !== t.abbrScore
            ? e.abbrScore - t.abbrScore
            : e.zone.population !== t.zone.population
            ? t.zone.population - e.zone.population
            : t.zone.name.localeCompare(e.zone.name);
        }
        function g(e, t) {
          var n, s;
          for (u(t), n = 0; n < t.length; n++) (i[(s = t[n])] = i[s] || {}), (i[s][e] = !0);
        }
        function y(e) {
          var t,
            n,
            s,
            a = e.length,
            o = {},
            c = [];
          for (t = 0; t < a; t++) for (n in (s = i[e[t].offset] || {})) s.hasOwnProperty(n) && (o[n] = !0);
          for (t in o) o.hasOwnProperty(t) && c.push(r[t]);
          return c;
        }
        function L(e) {
          return (e || "").toLowerCase().replace(/\//g, "_");
        }
        function A(e) {
          var t, s, i, a;
          for ("string" == typeof e && (e = [e]), t = 0; t < e.length; t++)
            (a = L((s = (i = e[t].split("|"))[0]))), (n[a] = e[t]), (r[a] = s), g(a, i[2].split(" "));
        }
        function w(e, t) {
          e = L(e);
          var i,
            a = n[e];
          return a instanceof p
            ? a
            : "string" == typeof a
            ? ((a = new p(a)), (n[e] = a), a)
            : s[e] && t !== w && (i = w(s[e], w))
            ? ((a = n[e] = new p())._set(i), (a.name = r[e]), a)
            : null;
        }
        function z(e) {
          var t, n, i, a;
          for ("string" == typeof e && (e = [e]), t = 0; t < e.length; t++)
            (i = L((n = e[t].split("|"))[0])), (a = L(n[1])), (s[i] = a), (r[i] = n[0]), (s[a] = i), (r[a] = n[1]);
        }
        function T(e) {
          return !(!e._a || void 0 !== e._tzm || "X" === e._f || "x" === e._f);
        }
        function v(e) {
          "undefined" != typeof console && "function" == typeof console.error && console.error(e);
        }
        function D(t) {
          var n = Array.prototype.slice.call(arguments, 0, -1),
            s = arguments[arguments.length - 1],
            r = w(s),
            i = e.utc.apply(null, n);
          return r && !e.isMoment(t) && T(i) && i.add(r.parse(i), "minutes"), i.tz(s), i;
        }
        (o < 2 || (2 === o && c < 6)) &&
          v("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + e.version + ". See momentjs.com"),
          (p.prototype = {
            _set: function (e) {
              (this.name = e.name),
                (this.abbrs = e.abbrs),
                (this.untils = e.untils),
                (this.offsets = e.offsets),
                (this.population = e.population);
            },
            _index: function (e) {
              var t,
                n = +e,
                s = this.untils;
              for (t = 0; t < s.length; t++) if (n < s[t]) return t;
            },
            parse: function (e) {
              var t,
                n,
                s,
                r,
                i = +e,
                a = this.offsets,
                o = this.untils,
                c = o.length - 1;
              for (r = 0; r < c; r++)
                if (
                  ((s = a[r ? r - 1 : r]),
                  (t = a[r]) < (n = a[r + 1]) && D.moveAmbiguousForward
                    ? (t = n)
                    : t > s && D.moveInvalidForward && (t = s),
                  i < o[r] - 6e4 * t)
                )
                  return a[r];
              return a[c];
            },
            abbr: function (e) {
              return this.abbrs[this._index(e)];
            },
            offset: function (e) {
              return v("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(e)];
            },
            utcOffset: function (e) {
              return this.offsets[this._index(e)];
            },
          }),
          (_.prototype.scoreOffsetAt = function (e) {
            (this.offsetScore += Math.abs(this.zone.utcOffset(e.at) - e.offset)),
              this.zone.abbr(e.at).replace(/[^A-Z]/g, "") !== e.abbr && this.abbrScore++;
          }),
          (D.version = "0.5.26"),
          (D.dataVersion = ""),
          (D._zones = n),
          (D._links = s),
          (D._names = r),
          (D.add = A),
          (D.link = z),
          (D.load = function (e) {
            A(e.zones), z(e.links), (D.dataVersion = e.version);
          }),
          (D.zone = w),
          (D.zoneExists = function e(t) {
            return (
              e.didShowError ||
                ((e.didShowError = !0),
                v("moment.tz.zoneExists('" + t + "') has been deprecated in favor of !moment.tz.zone('" + t + "')")),
              !!w(t)
            );
          }),
          (D.guess = function (e) {
            return (
              (t && !e) ||
                (t = (function () {
                  try {
                    var e = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    if (e && e.length > 3) {
                      var t = r[L(e)];
                      if (t) return t;
                      v("Moment Timezone found " + e + " from the Intl api, but did not have that data loaded.");
                    }
                  } catch (d) {}
                  var n,
                    s,
                    i,
                    a = (function () {
                      var e,
                        t,
                        n,
                        s = new Date().getFullYear() - 2,
                        r = new m(new Date(s, 0, 1)),
                        i = [r];
                      for (n = 1; n < 48; n++)
                        (t = new m(new Date(s, n, 1))).offset !== r.offset &&
                          ((e = f(r, t)), i.push(e), i.push(new m(new Date(e.at + 6e4)))),
                          (r = t);
                      for (n = 0; n < 4; n++)
                        i.push(new m(new Date(s + n, 0, 1))), i.push(new m(new Date(s + n, 6, 1)));
                      return i;
                    })(),
                    o = a.length,
                    c = y(a),
                    l = [];
                  for (s = 0; s < c.length; s++) {
                    for (n = new _(w(c[s]), o), i = 0; i < o; i++) n.scoreOffsetAt(a[i]);
                    l.push(n);
                  }
                  return l.sort(b), l.length > 0 ? l[0].zone.name : void 0;
                })()),
              t
            );
          }),
          (D.names = function () {
            var e,
              t = [];
            for (e in r) r.hasOwnProperty(e) && (n[e] || n[s[e]]) && r[e] && t.push(r[e]);
            return t.sort();
          }),
          (D.Zone = p),
          (D.unpack = M),
          (D.unpackBase60 = d),
          (D.needsOffset = T),
          (D.moveInvalidForward = !0),
          (D.moveAmbiguousForward = !1);
        var O,
          S = e.fn;
        function k(e) {
          return function () {
            return this._z ? this._z.abbr(this) : e.call(this);
          };
        }
        function Y(e) {
          return function () {
            return (this._z = null), e.apply(this, arguments);
          };
        }
        (e.tz = D),
          (e.defaultZone = null),
          (e.updateOffset = function (t, n) {
            var s,
              r = e.defaultZone;
            if (
              (void 0 === t._z &&
                (r && T(t) && !t._isUTC && ((t._d = e.utc(t._a)._d), t.utc().add(r.parse(t), "minutes")), (t._z = r)),
              t._z)
            )
              if (((s = t._z.utcOffset(t)), Math.abs(s) < 16 && (s /= 60), void 0 !== t.utcOffset)) {
                var i = t._z;
                t.utcOffset(-s, n), (t._z = i);
              } else t.zone(s, n);
          }),
          (S.tz = function (t, n) {
            if (t) {
              if ("string" != typeof t)
                throw new Error("Time zone name must be a string, got " + t + " [" + typeof t + "]");
              return (
                (this._z = w(t)),
                this._z
                  ? e.updateOffset(this, n)
                  : v(
                      "Moment Timezone has no data for " +
                        t +
                        ". See http://momentjs.com/timezone/docs/#/data-loading/."
                    ),
                this
              );
            }
            if (this._z) return this._z.name;
          }),
          (S.zoneName = k(S.zoneName)),
          (S.zoneAbbr = k(S.zoneAbbr)),
          (S.utc = Y(S.utc)),
          (S.local = Y(S.local)),
          (S.utcOffset =
            ((O = S.utcOffset),
            function () {
              return arguments.length > 0 && (this._z = null), O.apply(this, arguments);
            })),
          (e.tz.setDefault = function (t) {
            return (
              (o < 2 || (2 === o && c < 9)) &&
                v(
                  "Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + e.version + "."
                ),
              (e.defaultZone = t ? w(t) : null),
              e
            );
          });
        var N = e.momentProperties;
        return (
          "[object Array]" === Object.prototype.toString.call(N) ? (N.push("_z"), N.push("_a")) : N && (N._z = null), e
        );
      });
    },
    GJYX: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("gd", {
          months: [
            "Am Faoilleach",
            "An Gearran",
            "Am M\xe0rt",
            "An Giblean",
            "An C\xe8itean",
            "An t-\xd2gmhios",
            "An t-Iuchar",
            "An L\xf9nastal",
            "An t-Sultain",
            "An D\xe0mhair",
            "An t-Samhain",
            "An D\xf9bhlachd",
          ],
          monthsShort: [
            "Faoi",
            "Gear",
            "M\xe0rt",
            "Gibl",
            "C\xe8it",
            "\xd2gmh",
            "Iuch",
            "L\xf9n",
            "Sult",
            "D\xe0mh",
            "Samh",
            "D\xf9bh",
          ],
          monthsParseExact: !0,
          weekdays: ["Did\xf2mhnaich", "Diluain", "Dim\xe0irt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"],
          weekdaysShort: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
          weekdaysMin: ["D\xf2", "Lu", "M\xe0", "Ci", "Ar", "Ha", "Sa"],
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[An-diugh aig] LT",
            nextDay: "[A-m\xe0ireach aig] LT",
            nextWeek: "dddd [aig] LT",
            lastDay: "[An-d\xe8 aig] LT",
            lastWeek: "dddd [seo chaidh] [aig] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "ann an %s",
            past: "bho chionn %s",
            s: "beagan diogan",
            ss: "%d diogan",
            m: "mionaid",
            mm: "%d mionaidean",
            h: "uair",
            hh: "%d uairean",
            d: "latha",
            dd: "%d latha",
            M: "m\xecos",
            MM: "%d m\xecosan",
            y: "bliadhna",
            yy: "%d bliadhna",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
          ordinal: function (e) {
            return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    GNPT: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          s = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
          ],
          r =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es", {
          months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
          weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
          weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
          },
          calendar: {
            sameDay: function () {
              return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function () {
              return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function () {
              return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function () {
              return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function () {
              return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
          invalidDate: "Fecha inv\xe1lida",
        });
      })(n("wgY5"));
    },
    GzvP: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = { 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 0: "0" },
          n = function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
          },
          s = {
            s: [
              "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
              "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u062b\u0627\u0646\u064a\u062a\u0627\u0646", "\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],
              "%d \u062b\u0648\u0627\u0646",
              "%d \u062b\u0627\u0646\u064a\u0629",
              "%d \u062b\u0627\u0646\u064a\u0629",
            ],
            m: [
              "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
              "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u062f\u0642\u064a\u0642\u062a\u0627\u0646", "\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],
              "%d \u062f\u0642\u0627\u0626\u0642",
              "%d \u062f\u0642\u064a\u0642\u0629",
              "%d \u062f\u0642\u064a\u0642\u0629",
            ],
            h: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
              "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u0633\u0627\u0639\u062a\u0627\u0646", "\u0633\u0627\u0639\u062a\u064a\u0646"],
              "%d \u0633\u0627\u0639\u0627\u062a",
              "%d \u0633\u0627\u0639\u0629",
              "%d \u0633\u0627\u0639\u0629",
            ],
            d: [
              "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
              "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
              ["\u064a\u0648\u0645\u0627\u0646", "\u064a\u0648\u0645\u064a\u0646"],
              "%d \u0623\u064a\u0627\u0645",
              "%d \u064a\u0648\u0645\u064b\u0627",
              "%d \u064a\u0648\u0645",
            ],
            M: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
              "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
              ["\u0634\u0647\u0631\u0627\u0646", "\u0634\u0647\u0631\u064a\u0646"],
              "%d \u0623\u0634\u0647\u0631",
              "%d \u0634\u0647\u0631\u0627",
              "%d \u0634\u0647\u0631",
            ],
            y: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
              "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
              ["\u0639\u0627\u0645\u0627\u0646", "\u0639\u0627\u0645\u064a\u0646"],
              "%d \u0623\u0639\u0648\u0627\u0645",
              "%d \u0639\u0627\u0645\u064b\u0627",
              "%d \u0639\u0627\u0645",
            ],
          },
          r = function (e) {
            return function (t, r, i, a) {
              var o = n(t),
                c = s[e][n(t)];
              return 2 === o && (c = c[r ? 0 : 1]), c.replace(/%d/i, t);
            };
          },
          i = [
            "\u064a\u0646\u0627\u064a\u0631",
            "\u0641\u0628\u0631\u0627\u064a\u0631",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0628\u0631\u064a\u0644",
            "\u0645\u0627\u064a\u0648",
            "\u064a\u0648\u0646\u064a\u0648",
            "\u064a\u0648\u0644\u064a\u0648",
            "\u0623\u063a\u0633\u0637\u0633",
            "\u0633\u0628\u062a\u0645\u0628\u0631",
            "\u0623\u0643\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062f\u064a\u0633\u0645\u0628\u0631",
          ];
        e.defineLocale("ar-ly", {
          months: i,
          monthsShort: i,
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200fM/\u200fYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0635|\u0645/,
          isPM: function (e) {
            return "\u0645" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0635" : "\u0645";
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0628\u0639\u062f %s",
            past: "\u0645\u0646\u0630 %s",
            s: r("s"),
            ss: r("s"),
            m: r("m"),
            mm: r("m"),
            h: r("h"),
            hh: r("h"),
            d: r("d"),
            dd: r("d"),
            M: r("M"),
            MM: r("M"),
            y: r("y"),
            yy: r("y"),
          },
          preparse: function (e) {
            return e.replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e
              .replace(/\d/g, function (e) {
                return t[e];
              })
              .replace(/,/g, "\u060c");
          },
          week: { dow: 6, doy: 12 },
        });
      })(n("wgY5"));
    },
    HgyJ: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-au", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 0, doy: 4 },
        });
      })(n("wgY5"));
    },
    "J+SV": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ug-cn", {
          months:
            "\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split(
              "_"
            ),
          monthsShort:
            "\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split(
              "_"
            ),
          weekdays:
            "\u064a\u06d5\u0643\u0634\u06d5\u0646\u0628\u06d5_\u062f\u06c8\u0634\u06d5\u0646\u0628\u06d5_\u0633\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u0686\u0627\u0631\u0634\u06d5\u0646\u0628\u06d5_\u067e\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u062c\u06c8\u0645\u06d5_\u0634\u06d5\u0646\u0628\u06d5".split(
              "_"
            ),
          weekdaysShort:
            "\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),
          weekdaysMin:
            "\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649",
            LLL: "YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",
            LLLL: "dddd\u060c YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",
          },
          meridiemParse:
            /\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5|\u0633\u06d5\u06be\u06d5\u0631|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646|\u0686\u06c8\u0634|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646|\u0643\u06d5\u0686/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5" === t ||
              "\u0633\u06d5\u06be\u06d5\u0631" === t ||
              "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646" === t
                ? e
                : "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646" === t ||
                  "\u0643\u06d5\u0686" === t
                ? e + 12
                : e >= 11
                ? e
                : e + 12
            );
          },
          meridiem: function (e, t, n) {
            var s = 100 * e + t;
            return s < 600
              ? "\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5"
              : s < 900
              ? "\u0633\u06d5\u06be\u06d5\u0631"
              : s < 1130
              ? "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646"
              : s < 1230
              ? "\u0686\u06c8\u0634"
              : s < 1800
              ? "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646"
              : "\u0643\u06d5\u0686";
          },
          calendar: {
            sameDay: "[\u0628\u06c8\u06af\u06c8\u0646 \u0633\u0627\u0626\u06d5\u062a] LT",
            nextDay: "[\u0626\u06d5\u062a\u06d5 \u0633\u0627\u0626\u06d5\u062a] LT",
            nextWeek: "[\u0643\u06d0\u0644\u06d5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",
            lastDay: "[\u062a\u06c6\u0646\u06c8\u06af\u06c8\u0646] LT",
            lastWeek: "[\u0626\u0627\u0644\u062f\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0643\u06d0\u064a\u0649\u0646",
            past: "%s \u0628\u06c7\u0631\u06c7\u0646",
            s: "\u0646\u06d5\u0686\u0686\u06d5 \u0633\u06d0\u0643\u0648\u0646\u062a",
            ss: "%d \u0633\u06d0\u0643\u0648\u0646\u062a",
            m: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06c7\u062a",
            mm: "%d \u0645\u0649\u0646\u06c7\u062a",
            h: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06d5\u062a",
            hh: "%d \u0633\u0627\u0626\u06d5\u062a",
            d: "\u0628\u0649\u0631 \u0643\u06c8\u0646",
            dd: "%d \u0643\u06c8\u0646",
            M: "\u0628\u0649\u0631 \u0626\u0627\u064a",
            MM: "%d \u0626\u0627\u064a",
            y: "\u0628\u0649\u0631 \u064a\u0649\u0644",
            yy: "%d \u064a\u0649\u0644",
          },
          dayOfMonthOrdinalParse:
            /\d{1,2}(-\u0643\u06c8\u0646\u0649|-\u0626\u0627\u064a|-\u06be\u06d5\u067e\u062a\u06d5)/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + "-\u0643\u06c8\u0646\u0649";
              case "w":
              case "W":
                return e + "-\u06be\u06d5\u067e\u062a\u06d5";
              default:
                return e;
            }
          },
          preparse: function (e) {
            return e.replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e.replace(/,/g, "\u060c");
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    JFCg: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("zh-hk", {
          months:
            "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
              "_"
            ),
          monthsShort:
            "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
              "_"
            ),
          weekdays:
            "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
              "_"
            ),
          weekdaysShort:
            "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),
          weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            l: "YYYY/M/D",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
          },
          meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u51cc\u6668" === t || "\u65e9\u4e0a" === t || "\u4e0a\u5348" === t
                ? e
                : "\u4e2d\u5348" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "\u4e0b\u5348" === t || "\u665a\u4e0a" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            var s = 100 * e + t;
            return s < 600
              ? "\u51cc\u6668"
              : s < 900
              ? "\u65e9\u4e0a"
              : s < 1200
              ? "\u4e0a\u5348"
              : 1200 === s
              ? "\u4e2d\u5348"
              : s < 1800
              ? "\u4e0b\u5348"
              : "\u665a\u4e0a";
          },
          calendar: {
            sameDay: "[\u4eca\u5929]LT",
            nextDay: "[\u660e\u5929]LT",
            nextWeek: "[\u4e0b]ddddLT",
            lastDay: "[\u6628\u5929]LT",
            lastWeek: "[\u4e0a]ddddLT",
            sameElse: "L",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + "\u65e5";
              case "M":
                return e + "\u6708";
              case "w":
              case "W":
                return e + "\u9031";
              default:
                return e;
            }
          },
          relativeTime: {
            future: "%s\u5f8c",
            past: "%s\u524d",
            s: "\u5e7e\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5c0f\u6642",
            hh: "%d \u5c0f\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500b\u6708",
            MM: "%d \u500b\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74",
          },
        });
      })(n("wgY5"));
    },
    "JO+T": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          0: "-\u0447\u04af",
          1: "-\u0447\u0438",
          2: "-\u0447\u0438",
          3: "-\u0447\u04af",
          4: "-\u0447\u04af",
          5: "-\u0447\u0438",
          6: "-\u0447\u044b",
          7: "-\u0447\u0438",
          8: "-\u0447\u0438",
          9: "-\u0447\u0443",
          10: "-\u0447\u0443",
          20: "-\u0447\u044b",
          30: "-\u0447\u0443",
          40: "-\u0447\u044b",
          50: "-\u0447\u04af",
          60: "-\u0447\u044b",
          70: "-\u0447\u0438",
          80: "-\u0447\u0438",
          90: "-\u0447\u0443",
          100: "-\u0447\u04af",
        };
        e.defineLocale("ky", {
          months:
            "\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split(
              "_"
            ),
          monthsShort:
            "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split(
              "_"
            ),
          weekdays:
            "\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split(
              "_"
            ),
          weekdaysShort:
            "\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split(
              "_"
            ),
          weekdaysMin:
            "\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",
            nextDay: "[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0430\u0442] LT",
            lastDay: "[\u041a\u0435\u0447\u044d\u044d \u0441\u0430\u0430\u0442] LT",
            lastWeek:
              "[\u04e8\u0442\u043a\u04e9\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0438\u0447\u0438\u043d\u0434\u0435",
            past: "%s \u043c\u0443\u0440\u0443\u043d",
            s: "\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434",
            m: "\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",
            mm: "%d \u043c\u04af\u043d\u04e9\u0442",
            h: "\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",
            hh: "%d \u0441\u0430\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043a\u04af\u043d",
            dd: "%d \u043a\u04af\u043d",
            M: "\u0431\u0438\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0438\u0440 \u0436\u044b\u043b",
            yy: "%d \u0436\u044b\u043b",
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,
          ordinal: function (e) {
            return e + (t[e] || t[e % 10] || t[e >= 100 ? 100 : null]);
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    Jt3X: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("cv", {
          months:
            "\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split(
              "_"
            ),
          monthsShort:
            "\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split(
              "_"
            ),
          weekdays:
            "\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split(
              "_"
            ),
          weekdaysShort:
            "\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split(
              "_"
            ),
          weekdaysMin:
            "\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",
            LLL: "YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",
            LLLL: "dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",
          },
          calendar: {
            sameDay: "[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextDay: "[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastDay: "[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextWeek: "[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastWeek: "[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            sameElse: "L",
          },
          relativeTime: {
            future: function (e) {
              return (
                e +
                (/\u0441\u0435\u0445\u0435\u0442$/i.exec(e)
                  ? "\u0440\u0435\u043d"
                  : /\u04ab\u0443\u043b$/i.exec(e)
                  ? "\u0442\u0430\u043d"
                  : "\u0440\u0430\u043d")
              );
            },
            past: "%s \u043a\u0430\u044f\u043b\u043b\u0430",
            s: "\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",
            ss: "%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",
            m: "\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",
            mm: "%d \u043c\u0438\u043d\u0443\u0442",
            h: "\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",
            hh: "%d \u0441\u0435\u0445\u0435\u0442",
            d: "\u043f\u04d7\u0440 \u043a\u0443\u043d",
            dd: "%d \u043a\u0443\u043d",
            M: "\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",
            MM: "%d \u0443\u0439\u04d1\u0445",
            y: "\u043f\u04d7\u0440 \u04ab\u0443\u043b",
            yy: "%d \u04ab\u0443\u043b",
          },
          dayOfMonthOrdinalParse: /\d{1,2}-\u043c\u04d7\u0448/,
          ordinal: "%d-\u043c\u04d7\u0448",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    "K+3W": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            format:
              "leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split(
                "_"
              ),
            standalone:
              "ledna_\xfanora_b\u0159ezna_dubna_kv\u011btna_\u010dervna_\u010dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split(
                "_"
              ),
          },
          n = "led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_"),
          s = [
            /^led/i,
            /^\xfano/i,
            /^b\u0159e/i,
            /^dub/i,
            /^kv\u011b/i,
            /^(\u010dvn|\u010derven$|\u010dervna)/i,
            /^(\u010dvc|\u010dervenec|\u010dervence)/i,
            /^srp/i,
            /^z\xe1\u0159/i,
            /^\u0159\xedj/i,
            /^lis/i,
            /^pro/i,
          ],
          r =
            /^(leden|\xfanor|b\u0159ezen|duben|kv\u011bten|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|z\xe1\u0159\xed|\u0159\xedjen|listopad|prosinec|led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i;
        function i(e) {
          return e > 1 && e < 5 && 1 != ~~(e / 10);
        }
        function a(e, t, n, s) {
          var r = e + " ";
          switch (n) {
            case "s":
              return t || s ? "p\xe1r sekund" : "p\xe1r sekundami";
            case "ss":
              return t || s ? r + (i(e) ? "sekundy" : "sekund") : r + "sekundami";
            case "m":
              return t ? "minuta" : s ? "minutu" : "minutou";
            case "mm":
              return t || s ? r + (i(e) ? "minuty" : "minut") : r + "minutami";
            case "h":
              return t ? "hodina" : s ? "hodinu" : "hodinou";
            case "hh":
              return t || s ? r + (i(e) ? "hodiny" : "hodin") : r + "hodinami";
            case "d":
              return t || s ? "den" : "dnem";
            case "dd":
              return t || s ? r + (i(e) ? "dny" : "dn\xed") : r + "dny";
            case "M":
              return t || s ? "m\u011bs\xedc" : "m\u011bs\xedcem";
            case "MM":
              return t || s ? r + (i(e) ? "m\u011bs\xedce" : "m\u011bs\xedc\u016f") : r + "m\u011bs\xedci";
            case "y":
              return t || s ? "rok" : "rokem";
            case "yy":
              return t || s ? r + (i(e) ? "roky" : "let") : r + "lety";
          }
        }
        e.defineLocale("cs", {
          months: t,
          monthsShort: n,
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(leden|ledna|\xfanora|\xfanor|b\u0159ezen|b\u0159ezna|duben|dubna|kv\u011bten|kv\u011btna|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|srpna|z\xe1\u0159\xed|\u0159\xedjen|\u0159\xedjna|listopadu|listopad|prosinec|prosince)/i,
          monthsShortStrictRegex:
            /^(led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split("_"),
          weekdaysShort: "ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),
          weekdaysMin: "ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm",
            l: "D. M. YYYY",
          },
          calendar: {
            sameDay: "[dnes v] LT",
            nextDay: "[z\xedtra v] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[v ned\u011bli v] LT";
                case 1:
                case 2:
                  return "[v] dddd [v] LT";
                case 3:
                  return "[ve st\u0159edu v] LT";
                case 4:
                  return "[ve \u010dtvrtek v] LT";
                case 5:
                  return "[v p\xe1tek v] LT";
                case 6:
                  return "[v sobotu v] LT";
              }
            },
            lastDay: "[v\u010dera v] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[minulou ned\u011bli v] LT";
                case 1:
                case 2:
                  return "[minul\xe9] dddd [v] LT";
                case 3:
                  return "[minulou st\u0159edu v] LT";
                case 4:
                case 5:
                  return "[minul\xfd] dddd [v] LT";
                case 6:
                  return "[minulou sobotu v] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "p\u0159ed %s",
            s: a,
            ss: a,
            m: a,
            mm: a,
            h: a,
            hh: a,
            d: a,
            dd: a,
            M: a,
            MM: a,
            y: a,
            yy: a,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "K+Lk": function (e, t, n) {
      !(function (e) {
        "use strict";
        var t =
            "janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split(
              "_"
            ),
          n = "jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");
        function s(e) {
          return e > 1 && e < 5;
        }
        function r(e, t, n, r) {
          var i = e + " ";
          switch (n) {
            case "s":
              return t || r ? "p\xe1r sek\xfand" : "p\xe1r sekundami";
            case "ss":
              return t || r ? i + (s(e) ? "sekundy" : "sek\xfand") : i + "sekundami";
            case "m":
              return t ? "min\xfata" : r ? "min\xfatu" : "min\xfatou";
            case "mm":
              return t || r ? i + (s(e) ? "min\xfaty" : "min\xfat") : i + "min\xfatami";
            case "h":
              return t ? "hodina" : r ? "hodinu" : "hodinou";
            case "hh":
              return t || r ? i + (s(e) ? "hodiny" : "hod\xedn") : i + "hodinami";
            case "d":
              return t || r ? "de\u0148" : "d\u0148om";
            case "dd":
              return t || r ? i + (s(e) ? "dni" : "dn\xed") : i + "d\u0148ami";
            case "M":
              return t || r ? "mesiac" : "mesiacom";
            case "MM":
              return t || r ? i + (s(e) ? "mesiace" : "mesiacov") : i + "mesiacmi";
            case "y":
              return t || r ? "rok" : "rokom";
            case "yy":
              return t || r ? i + (s(e) ? "roky" : "rokov") : i + "rokmi";
          }
        }
        e.defineLocale("sk", {
          months: t,
          monthsShort: n,
          weekdays: "nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),
          weekdaysShort: "ne_po_ut_st_\u0161t_pi_so".split("_"),
          weekdaysMin: "ne_po_ut_st_\u0161t_pi_so".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[dnes o] LT",
            nextDay: "[zajtra o] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[v nede\u013eu o] LT";
                case 1:
                case 2:
                  return "[v] dddd [o] LT";
                case 3:
                  return "[v stredu o] LT";
                case 4:
                  return "[vo \u0161tvrtok o] LT";
                case 5:
                  return "[v piatok o] LT";
                case 6:
                  return "[v sobotu o] LT";
              }
            },
            lastDay: "[v\u010dera o] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[minul\xfa nede\u013eu o] LT";
                case 1:
                case 2:
                  return "[minul\xfd] dddd [o] LT";
                case 3:
                  return "[minul\xfa stredu o] LT";
                case 4:
                case 5:
                  return "[minul\xfd] dddd [o] LT";
                case 6:
                  return "[minul\xfa sobotu o] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "pred %s",
            s: r,
            ss: r,
            m: r,
            mm: r,
            h: r,
            hh: r,
            d: r,
            dd: r,
            M: r,
            MM: r,
            y: r,
            yy: r,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    KqOT: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("uz-latn", {
          months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),
          monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
          weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),
          weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
          weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "D MMMM YYYY, dddd HH:mm",
          },
          calendar: {
            sameDay: "[Bugun soat] LT [da]",
            nextDay: "[Ertaga] LT [da]",
            nextWeek: "dddd [kuni soat] LT [da]",
            lastDay: "[Kecha soat] LT [da]",
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: "L",
          },
          relativeTime: {
            future: "Yaqin %s ichida",
            past: "Bir necha %s oldin",
            s: "soniya",
            ss: "%d soniya",
            m: "bir daqiqa",
            mm: "%d daqiqa",
            h: "bir soat",
            hh: "%d soat",
            d: "bir kun",
            dd: "%d kun",
            M: "bir oy",
            MM: "%d oy",
            y: "bir yil",
            yy: "%d yil",
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    LsNb: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u1041",
            2: "\u1042",
            3: "\u1043",
            4: "\u1044",
            5: "\u1045",
            6: "\u1046",
            7: "\u1047",
            8: "\u1048",
            9: "\u1049",
            0: "\u1040",
          },
          n = {
            "\u1041": "1",
            "\u1042": "2",
            "\u1043": "3",
            "\u1044": "4",
            "\u1045": "5",
            "\u1046": "6",
            "\u1047": "7",
            "\u1048": "8",
            "\u1049": "9",
            "\u1040": "0",
          };
        e.defineLocale("my", {
          months:
            "\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split(
              "_"
            ),
          monthsShort:
            "\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split(
              "_"
            ),
          weekdays:
            "\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split(
              "_"
            ),
          weekdaysShort:
            "\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split(
              "_"
            ),
          weekdaysMin:
            "\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split(
              "_"
            ),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",
            nextDay: "[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",
            nextWeek: "dddd LT [\u1019\u103e\u102c]",
            lastDay: "[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",
            lastWeek: "[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",
            past: "\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",
            s: "\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",
            ss: "%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",
            m: "\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",
            mm: "%d \u1019\u102d\u1014\u1005\u103a",
            h: "\u1010\u1005\u103a\u1014\u102c\u101b\u102e",
            hh: "%d \u1014\u102c\u101b\u102e",
            d: "\u1010\u1005\u103a\u101b\u1000\u103a",
            dd: "%d \u101b\u1000\u103a",
            M: "\u1010\u1005\u103a\u101c",
            MM: "%d \u101c",
            y: "\u1010\u1005\u103a\u1014\u103e\u1005\u103a",
            yy: "%d \u1014\u103e\u1005\u103a",
          },
          preparse: function (e) {
            return e.replace(/[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    MNf7: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("hy-am", {
          months: {
            format:
              "\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split(
                "_"
              ),
            standalone:
              "\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split(
                "_"
              ),
          },
          monthsShort:
            "\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split(
              "_"
            ),
          weekdays:
            "\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split(
              "_"
            ),
          weekdaysShort:
            "\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split(
              "_"
            ),
          weekdaysMin:
            "\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split(
              "_"
            ),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0569.",
            LLL: "D MMMM YYYY \u0569., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0569., HH:mm",
          },
          calendar: {
            sameDay: "[\u0561\u0575\u057d\u0585\u0580] LT",
            nextDay: "[\u057e\u0561\u0572\u0568] LT",
            lastDay: "[\u0565\u0580\u0565\u056f] LT",
            nextWeek: function () {
              return "dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT";
            },
            lastWeek: function () {
              return "[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0570\u0565\u057f\u0578",
            past: "%s \u0561\u057c\u0561\u057b",
            s: "\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",
            ss: "%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",
            m: "\u0580\u0578\u057a\u0565",
            mm: "%d \u0580\u0578\u057a\u0565",
            h: "\u056a\u0561\u0574",
            hh: "%d \u056a\u0561\u0574",
            d: "\u0585\u0580",
            dd: "%d \u0585\u0580",
            M: "\u0561\u0574\u056b\u057d",
            MM: "%d \u0561\u0574\u056b\u057d",
            y: "\u057f\u0561\u0580\u056b",
            yy: "%d \u057f\u0561\u0580\u056b",
          },
          meridiemParse:
            /\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,
          isPM: function (e) {
            return /^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(
              e
            );
          },
          meridiem: function (e) {
            return e < 4
              ? "\u0563\u056b\u0577\u0565\u0580\u057e\u0561"
              : e < 12
              ? "\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561"
              : e < 17
              ? "\u0581\u0565\u0580\u0565\u056f\u057e\u0561"
              : "\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576";
          },
          dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,
          ordinal: function (e, t) {
            switch (t) {
              case "DDD":
              case "w":
              case "W":
              case "DDDo":
                return 1 === e ? e + "-\u056b\u0576" : e + "-\u0580\u0564";
              default:
                return e;
            }
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    MROq: function (e, t, n) {
      var s = {
        "./af": "8GSH",
        "./af.js": "8GSH",
        "./ar": "NcOb",
        "./ar-dz": "1ors",
        "./ar-dz.js": "1ors",
        "./ar-kw": "Sc1Y",
        "./ar-kw.js": "Sc1Y",
        "./ar-ly": "GzvP",
        "./ar-ly.js": "GzvP",
        "./ar-ma": "hH25",
        "./ar-ma.js": "hH25",
        "./ar-sa": "u2jB",
        "./ar-sa.js": "u2jB",
        "./ar-tn": "5Mza",
        "./ar-tn.js": "5Mza",
        "./ar.js": "NcOb",
        "./az": "ZVVJ",
        "./az.js": "ZVVJ",
        "./be": "kQaN",
        "./be.js": "kQaN",
        "./bg": "+n5x",
        "./bg.js": "+n5x",
        "./bm": "TTiN",
        "./bm.js": "TTiN",
        "./bn": "aIF2",
        "./bn-bd": "lTqY",
        "./bn-bd.js": "lTqY",
        "./bn.js": "aIF2",
        "./bo": "QWb5",
        "./bo.js": "QWb5",
        "./br": "iQoZ",
        "./br.js": "iQoZ",
        "./bs": "EL7g",
        "./bs.js": "EL7g",
        "./ca": "vd/2",
        "./ca.js": "vd/2",
        "./cs": "K+3W",
        "./cs.js": "K+3W",
        "./cv": "Jt3X",
        "./cv.js": "Jt3X",
        "./cy": "sWi3",
        "./cy.js": "sWi3",
        "./da": "YcFX",
        "./da.js": "YcFX",
        "./de": "BKZ+",
        "./de-at": "Oq9h",
        "./de-at.js": "Oq9h",
        "./de-ch": "hHY4",
        "./de-ch.js": "hHY4",
        "./de.js": "BKZ+",
        "./dv": "w8Ej",
        "./dv.js": "w8Ej",
        "./el": "tSbB",
        "./el.js": "tSbB",
        "./en-au": "HgyJ",
        "./en-au.js": "HgyJ",
        "./en-ca": "ZyTy",
        "./en-ca.js": "ZyTy",
        "./en-gb": "exaB",
        "./en-gb.js": "exaB",
        "./en-ie": "yKzn",
        "./en-ie.js": "yKzn",
        "./en-il": "TB59",
        "./en-il.js": "TB59",
        "./en-in": "S70V",
        "./en-in.js": "S70V",
        "./en-nz": "iDxo",
        "./en-nz.js": "iDxo",
        "./en-sg": "zS0P",
        "./en-sg.js": "zS0P",
        "./eo": "4bvN",
        "./eo.js": "4bvN",
        "./es": "GNPT",
        "./es-do": "R7mU",
        "./es-do.js": "R7mU",
        "./es-mx": "FkqR",
        "./es-mx.js": "FkqR",
        "./es-us": "Nstw",
        "./es-us.js": "Nstw",
        "./es.js": "GNPT",
        "./et": "ZOjb",
        "./et.js": "ZOjb",
        "./eu": "kFC9",
        "./eu.js": "kFC9",
        "./fa": "8Cju",
        "./fa.js": "8Cju",
        "./fi": "vcN1",
        "./fi.js": "vcN1",
        "./fil": "3g1g",
        "./fil.js": "3g1g",
        "./fo": "8Ygf",
        "./fo.js": "8Ygf",
        "./fr": "Y8Ij",
        "./fr-ca": "t+Zl",
        "./fr-ca.js": "t+Zl",
        "./fr-ch": "SPXN",
        "./fr-ch.js": "SPXN",
        "./fr.js": "Y8Ij",
        "./fy": "T3MF",
        "./fy.js": "T3MF",
        "./ga": "NowM",
        "./ga.js": "NowM",
        "./gd": "GJYX",
        "./gd.js": "GJYX",
        "./gl": "MdC8",
        "./gl.js": "MdC8",
        "./gom-deva": "QJjq",
        "./gom-deva.js": "QJjq",
        "./gom-latn": "5j0y",
        "./gom-latn.js": "5j0y",
        "./gu": "fY0S",
        "./gu.js": "fY0S",
        "./he": "ACAV",
        "./he.js": "ACAV",
        "./hi": "3WqV",
        "./hi.js": "3WqV",
        "./hr": "OnNk",
        "./hr.js": "OnNk",
        "./hu": "EQmw",
        "./hu.js": "EQmw",
        "./hy-am": "MNf7",
        "./hy-am.js": "MNf7",
        "./id": "0yow",
        "./id.js": "0yow",
        "./is": "TmOJ",
        "./is.js": "TmOJ",
        "./it": "xD/0",
        "./it-ch": "foQf",
        "./it-ch.js": "foQf",
        "./it.js": "xD/0",
        "./ja": "jOnb",
        "./ja.js": "jOnb",
        "./jv": "lOtj",
        "./jv.js": "lOtj",
        "./ka": "BAN/",
        "./ka.js": "BAN/",
        "./kk": "iNiw",
        "./kk.js": "iNiw",
        "./km": "TUxt",
        "./km.js": "TUxt",
        "./kn": "hQzt",
        "./kn.js": "hQzt",
        "./ko": "ZNZT",
        "./ko.js": "ZNZT",
        "./ku": "S0Tg",
        "./ku.js": "S0Tg",
        "./ky": "JO+T",
        "./ky.js": "JO+T",
        "./lb": "vn/h",
        "./lb.js": "vn/h",
        "./lo": "gnIm",
        "./lo.js": "gnIm",
        "./lt": "6PD3",
        "./lt.js": "6PD3",
        "./lv": "YKe2",
        "./lv.js": "YKe2",
        "./me": "d3TR",
        "./me.js": "d3TR",
        "./mi": "hTlv",
        "./mi.js": "hTlv",
        "./mk": "ffVN",
        "./mk.js": "ffVN",
        "./ml": "ejL1",
        "./ml.js": "ejL1",
        "./mn": "RIsM",
        "./mn.js": "RIsM",
        "./mr": "CPJk",
        "./mr.js": "CPJk",
        "./ms": "d5Hy",
        "./ms-my": "t4T9",
        "./ms-my.js": "t4T9",
        "./ms.js": "d5Hy",
        "./mt": "1KVU",
        "./mt.js": "1KVU",
        "./my": "LsNb",
        "./my.js": "LsNb",
        "./nb": "h+U8",
        "./nb.js": "h+U8",
        "./ne": "2JSI",
        "./ne.js": "2JSI",
        "./nl": "jsZ8",
        "./nl-be": "+h6j",
        "./nl-be.js": "+h6j",
        "./nl.js": "jsZ8",
        "./nn": "mh29",
        "./nn.js": "mh29",
        "./oc-lnc": "zX+o",
        "./oc-lnc.js": "zX+o",
        "./pa-in": "O6bP",
        "./pa-in.js": "O6bP",
        "./pl": "8Bez",
        "./pl.js": "8Bez",
        "./pt": "DDip",
        "./pt-br": "uHm5",
        "./pt-br.js": "uHm5",
        "./pt.js": "DDip",
        "./ro": "baBi",
        "./ro.js": "baBi",
        "./ru": "ecsu",
        "./ru.js": "ecsu",
        "./sd": "e9KM",
        "./sd.js": "e9KM",
        "./se": "CZRU",
        "./se.js": "CZRU",
        "./si": "TO58",
        "./si.js": "TO58",
        "./sk": "K+Lk",
        "./sk.js": "K+Lk",
        "./sl": "QK6v",
        "./sl.js": "QK6v",
        "./sq": "v3Qg",
        "./sq.js": "v3Qg",
        "./sr": "Ndyf",
        "./sr-cyrl": "PGvg",
        "./sr-cyrl.js": "PGvg",
        "./sr.js": "Ndyf",
        "./ss": "2B8G",
        "./ss.js": "2B8G",
        "./sv": "WF5B",
        "./sv.js": "WF5B",
        "./sw": "4VvY",
        "./sw.js": "4VvY",
        "./ta": "dw3T",
        "./ta.js": "dw3T",
        "./te": "4MAb",
        "./te.js": "4MAb",
        "./tet": "/hi0",
        "./tet.js": "/hi0",
        "./tg": "PoVJ",
        "./tg.js": "PoVJ",
        "./th": "OY2w",
        "./th.js": "OY2w",
        "./tk": "zO4H",
        "./tk.js": "zO4H",
        "./tl-ph": "UC+K",
        "./tl-ph.js": "UC+K",
        "./tlh": "cWLW",
        "./tlh.js": "cWLW",
        "./tr": "EqYs",
        "./tr.js": "EqYs",
        "./tzl": "fN8o",
        "./tzl.js": "fN8o",
        "./tzm": "6cYq",
        "./tzm-latn": "pdAN",
        "./tzm-latn.js": "pdAN",
        "./tzm.js": "6cYq",
        "./ug-cn": "J+SV",
        "./ug-cn.js": "J+SV",
        "./uk": "6Olw",
        "./uk.js": "6Olw",
        "./ur": "QNGR",
        "./ur.js": "QNGR",
        "./uz": "hLzJ",
        "./uz-latn": "KqOT",
        "./uz-latn.js": "KqOT",
        "./uz.js": "hLzJ",
        "./vi": "EnIJ",
        "./vi.js": "EnIJ",
        "./x-pseudo": "W7dU",
        "./x-pseudo.js": "W7dU",
        "./yo": "QDhB",
        "./yo.js": "QDhB",
        "./zh-cn": "bjMe",
        "./zh-cn.js": "bjMe",
        "./zh-hk": "JFCg",
        "./zh-hk.js": "JFCg",
        "./zh-mo": "5BRa",
        "./zh-mo.js": "5BRa",
        "./zh-tw": "xBDH",
        "./zh-tw.js": "xBDH",
      };
      function r(e) {
        var t = i(e);
        return n(t);
      }
      function i(e) {
        if (!n.o(s, e)) {
          var t = new Error("Cannot find module '" + e + "'");
          throw ((t.code = "MODULE_NOT_FOUND"), t);
        }
        return s[e];
      }
      (r.keys = function () {
        return Object.keys(s);
      }),
        (r.resolve = i),
        (e.exports = r),
        (r.id = "MROq");
    },
    MdC8: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("gl", {
          months: "xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split(
            "_"
          ),
          monthsShort: "xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),
          weekdaysShort: "dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),
          weekdaysMin: "do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
          },
          calendar: {
            sameDay: function () {
              return "[hoxe " + (1 !== this.hours() ? "\xe1s" : "\xe1") + "] LT";
            },
            nextDay: function () {
              return "[ma\xf1\xe1 " + (1 !== this.hours() ? "\xe1s" : "\xe1") + "] LT";
            },
            nextWeek: function () {
              return "dddd [" + (1 !== this.hours() ? "\xe1s" : "a") + "] LT";
            },
            lastDay: function () {
              return "[onte " + (1 !== this.hours() ? "\xe1" : "a") + "] LT";
            },
            lastWeek: function () {
              return "[o] dddd [pasado " + (1 !== this.hours() ? "\xe1s" : "a") + "] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: function (e) {
              return 0 === e.indexOf("un") ? "n" + e : "en " + e;
            },
            past: "hai %s",
            s: "uns segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "unha hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un ano",
            yy: "%d anos",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    NcOb: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0661",
            2: "\u0662",
            3: "\u0663",
            4: "\u0664",
            5: "\u0665",
            6: "\u0666",
            7: "\u0667",
            8: "\u0668",
            9: "\u0669",
            0: "\u0660",
          },
          n = {
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u0660": "0",
          },
          s = function (e) {
            return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
          },
          r = {
            s: [
              "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
              "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u062b\u0627\u0646\u064a\u062a\u0627\u0646", "\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],
              "%d \u062b\u0648\u0627\u0646",
              "%d \u062b\u0627\u0646\u064a\u0629",
              "%d \u062b\u0627\u0646\u064a\u0629",
            ],
            m: [
              "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
              "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u062f\u0642\u064a\u0642\u062a\u0627\u0646", "\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],
              "%d \u062f\u0642\u0627\u0626\u0642",
              "%d \u062f\u0642\u064a\u0642\u0629",
              "%d \u062f\u0642\u064a\u0642\u0629",
            ],
            h: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
              "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
              ["\u0633\u0627\u0639\u062a\u0627\u0646", "\u0633\u0627\u0639\u062a\u064a\u0646"],
              "%d \u0633\u0627\u0639\u0627\u062a",
              "%d \u0633\u0627\u0639\u0629",
              "%d \u0633\u0627\u0639\u0629",
            ],
            d: [
              "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
              "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
              ["\u064a\u0648\u0645\u0627\u0646", "\u064a\u0648\u0645\u064a\u0646"],
              "%d \u0623\u064a\u0627\u0645",
              "%d \u064a\u0648\u0645\u064b\u0627",
              "%d \u064a\u0648\u0645",
            ],
            M: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
              "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
              ["\u0634\u0647\u0631\u0627\u0646", "\u0634\u0647\u0631\u064a\u0646"],
              "%d \u0623\u0634\u0647\u0631",
              "%d \u0634\u0647\u0631\u0627",
              "%d \u0634\u0647\u0631",
            ],
            y: [
              "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
              "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
              ["\u0639\u0627\u0645\u0627\u0646", "\u0639\u0627\u0645\u064a\u0646"],
              "%d \u0623\u0639\u0648\u0627\u0645",
              "%d \u0639\u0627\u0645\u064b\u0627",
              "%d \u0639\u0627\u0645",
            ],
          },
          i = function (e) {
            return function (t, n, i, a) {
              var o = s(t),
                c = r[e][s(t)];
              return 2 === o && (c = c[n ? 0 : 1]), c.replace(/%d/i, t);
            };
          },
          a = [
            "\u064a\u0646\u0627\u064a\u0631",
            "\u0641\u0628\u0631\u0627\u064a\u0631",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0628\u0631\u064a\u0644",
            "\u0645\u0627\u064a\u0648",
            "\u064a\u0648\u0646\u064a\u0648",
            "\u064a\u0648\u0644\u064a\u0648",
            "\u0623\u063a\u0633\u0637\u0633",
            "\u0633\u0628\u062a\u0645\u0628\u0631",
            "\u0623\u0643\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062f\u064a\u0633\u0645\u0628\u0631",
          ];
        e.defineLocale("ar", {
          months: a,
          monthsShort: a,
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200fM/\u200fYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0635|\u0645/,
          isPM: function (e) {
            return "\u0645" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0635" : "\u0645";
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0628\u0639\u062f %s",
            past: "\u0645\u0646\u0630 %s",
            s: i("s"),
            ss: i("s"),
            m: i("m"),
            mm: i("m"),
            h: i("h"),
            hh: i("h"),
            d: i("d"),
            dd: i("d"),
            M: i("M"),
            MM: i("M"),
            y: i("y"),
            yy: i("y"),
          },
          preparse: function (e) {
            return e
              .replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function (e) {
                return n[e];
              })
              .replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e
              .replace(/\d/g, function (e) {
                return t[e];
              })
              .replace(/,/g, "\u060c");
          },
          week: { dow: 6, doy: 12 },
        });
      })(n("wgY5"));
    },
    Ndyf: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          words: {
            ss: ["sekunda", "sekunde", "sekundi"],
            m: ["jedan minut", "jednog minuta"],
            mm: ["minut", "minuta", "minuta"],
            h: ["jedan sat", "jednog sata"],
            hh: ["sat", "sata", "sati"],
            d: ["jedan dan", "jednog dana"],
            dd: ["dan", "dana", "dana"],
            M: ["jedan mesec", "jednog meseca"],
            MM: ["mesec", "meseca", "meseci"],
            y: ["jednu godinu", "jedne godine"],
            yy: ["godinu", "godine", "godina"],
          },
          correctGrammaticalCase: function (e, t) {
            return e % 10 >= 1 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? (e % 10 == 1 ? t[0] : t[1]) : t[2];
          },
          translate: function (e, n, s, r) {
            var i,
              a = t.words[s];
            return 1 === s.length
              ? "y" === s && n
                ? "jedna godina"
                : r || n
                ? a[0]
                : a[1]
              : ((i = t.correctGrammaticalCase(e, a)), "yy" === s && n && "godinu" === i ? e + " godina" : e + " " + i);
          },
        };
        e.defineLocale("sr", {
          months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
          monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split("_"),
          weekdaysShort: "ned._pon._uto._sre._\u010det._pet._sub.".split("_"),
          weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D. M. YYYY.",
            LL: "D. MMMM YYYY.",
            LLL: "D. MMMM YYYY. H:mm",
            LLLL: "dddd, D. MMMM YYYY. H:mm",
          },
          calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[u] [nedelju] [u] LT";
                case 3:
                  return "[u] [sredu] [u] LT";
                case 6:
                  return "[u] [subotu] [u] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[u] dddd [u] LT";
              }
            },
            lastDay: "[ju\u010de u] LT",
            lastWeek: function () {
              return [
                "[pro\u0161le] [nedelje] [u] LT",
                "[pro\u0161log] [ponedeljka] [u] LT",
                "[pro\u0161log] [utorka] [u] LT",
                "[pro\u0161le] [srede] [u] LT",
                "[pro\u0161log] [\u010detvrtka] [u] LT",
                "[pro\u0161log] [petka] [u] LT",
                "[pro\u0161le] [subote] [u] LT",
              ][this.day()];
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "pre %s",
            s: "nekoliko sekundi",
            ss: t.translate,
            m: t.translate,
            mm: t.translate,
            h: t.translate,
            hh: t.translate,
            d: t.translate,
            dd: t.translate,
            M: t.translate,
            MM: t.translate,
            y: t.translate,
            yy: t.translate,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    NowM: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ga", {
          months: [
            "Ean\xe1ir",
            "Feabhra",
            "M\xe1rta",
            "Aibre\xe1n",
            "Bealtaine",
            "Meitheamh",
            "I\xfail",
            "L\xfanasa",
            "Me\xe1n F\xf3mhair",
            "Deireadh F\xf3mhair",
            "Samhain",
            "Nollaig",
          ],
          monthsShort: [
            "Ean",
            "Feabh",
            "M\xe1rt",
            "Aib",
            "Beal",
            "Meith",
            "I\xfail",
            "L\xfan",
            "M.F.",
            "D.F.",
            "Samh",
            "Noll",
          ],
          monthsParseExact: !0,
          weekdays: [
            "D\xe9 Domhnaigh",
            "D\xe9 Luain",
            "D\xe9 M\xe1irt",
            "D\xe9 C\xe9adaoin",
            "D\xe9ardaoin",
            "D\xe9 hAoine",
            "D\xe9 Sathairn",
          ],
          weekdaysShort: ["Domh", "Luan", "M\xe1irt", "C\xe9ad", "D\xe9ar", "Aoine", "Sath"],
          weekdaysMin: ["Do", "Lu", "M\xe1", "C\xe9", "D\xe9", "A", "Sa"],
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Inniu ag] LT",
            nextDay: "[Am\xe1rach ag] LT",
            nextWeek: "dddd [ag] LT",
            lastDay: "[Inn\xe9 ag] LT",
            lastWeek: "dddd [seo caite] [ag] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "i %s",
            past: "%s \xf3 shin",
            s: "c\xfapla soicind",
            ss: "%d soicind",
            m: "n\xf3im\xe9ad",
            mm: "%d n\xf3im\xe9ad",
            h: "uair an chloig",
            hh: "%d uair an chloig",
            d: "l\xe1",
            dd: "%d l\xe1",
            M: "m\xed",
            MM: "%d m\xedonna",
            y: "bliain",
            yy: "%d bliain",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
          ordinal: function (e) {
            return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    Nstw: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          s = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
          ],
          r =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es-us", {
          months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
          weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
          weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "MM/DD/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY h:mm A",
            LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A",
          },
          calendar: {
            sameDay: function () {
              return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function () {
              return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function () {
              return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function () {
              return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function () {
              return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    O6bP: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0a67",
            2: "\u0a68",
            3: "\u0a69",
            4: "\u0a6a",
            5: "\u0a6b",
            6: "\u0a6c",
            7: "\u0a6d",
            8: "\u0a6e",
            9: "\u0a6f",
            0: "\u0a66",
          },
          n = {
            "\u0a67": "1",
            "\u0a68": "2",
            "\u0a69": "3",
            "\u0a6a": "4",
            "\u0a6b": "5",
            "\u0a6c": "6",
            "\u0a6d": "7",
            "\u0a6e": "8",
            "\u0a6f": "9",
            "\u0a66": "0",
          };
        e.defineLocale("pa-in", {
          months:
            "\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split(
              "_"
            ),
          monthsShort:
            "\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split(
              "_"
            ),
          weekdays:
            "\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split(
              "_"
            ),
          weekdaysShort:
            "\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split(
              "_"
            ),
          weekdaysMin:
            "\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split(
              "_"
            ),
          longDateFormat: {
            LT: "A h:mm \u0a35\u0a1c\u0a47",
            LTS: "A h:mm:ss \u0a35\u0a1c\u0a47",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",
          },
          calendar: {
            sameDay: "[\u0a05\u0a1c] LT",
            nextDay: "[\u0a15\u0a32] LT",
            nextWeek: "[\u0a05\u0a17\u0a32\u0a3e] dddd, LT",
            lastDay: "[\u0a15\u0a32] LT",
            lastWeek: "[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0a35\u0a3f\u0a71\u0a1a",
            past: "%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",
            s: "\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",
            ss: "%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",
            m: "\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",
            mm: "%d \u0a2e\u0a3f\u0a70\u0a1f",
            h: "\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",
            hh: "%d \u0a18\u0a70\u0a1f\u0a47",
            d: "\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",
            dd: "%d \u0a26\u0a3f\u0a28",
            M: "\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",
            MM: "%d \u0a2e\u0a39\u0a40\u0a28\u0a47",
            y: "\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",
            yy: "%d \u0a38\u0a3e\u0a32",
          },
          preparse: function (e) {
            return e.replace(/[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0a30\u0a3e\u0a24" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0a38\u0a35\u0a47\u0a30" === t
                ? e
                : "\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30" === t
                ? e >= 10
                  ? e
                  : e + 12
                : "\u0a38\u0a3c\u0a3e\u0a2e" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0a30\u0a3e\u0a24"
              : e < 10
              ? "\u0a38\u0a35\u0a47\u0a30"
              : e < 17
              ? "\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30"
              : e < 20
              ? "\u0a38\u0a3c\u0a3e\u0a2e"
              : "\u0a30\u0a3e\u0a24";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    OY2w: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("th", {
          months:
            "\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split(
              "_"
            ),
          monthsShort:
            "\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split(
              "_"
            ),
          weekdaysShort:
            "\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split(
              "_"
            ),
          weekdaysMin: "\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",
            LLLL: "\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",
          },
          meridiemParse:
            /\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,
          isPM: function (e) {
            return "\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12
              ? "\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"
              : "\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07";
          },
          calendar: {
            sameDay: "[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
            nextDay: "[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
            nextWeek: "dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",
            lastDay: "[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
            lastWeek:
              "[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0e2d\u0e35\u0e01 %s",
            past: "%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",
            s: "\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",
            ss: "%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",
            m: "1 \u0e19\u0e32\u0e17\u0e35",
            mm: "%d \u0e19\u0e32\u0e17\u0e35",
            h: "1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
            hh: "%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
            d: "1 \u0e27\u0e31\u0e19",
            dd: "%d \u0e27\u0e31\u0e19",
            w: "1 \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",
            ww: "%d \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",
            M: "1 \u0e40\u0e14\u0e37\u0e2d\u0e19",
            MM: "%d \u0e40\u0e14\u0e37\u0e2d\u0e19",
            y: "1 \u0e1b\u0e35",
            yy: "%d \u0e1b\u0e35",
          },
        });
      })(n("wgY5"));
    },
    OnNk: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          var s = e + " ";
          switch (n) {
            case "ss":
              return s + (1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi");
            case "m":
              return t ? "jedna minuta" : "jedne minute";
            case "mm":
              return s + (1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta");
            case "h":
              return t ? "jedan sat" : "jednog sata";
            case "hh":
              return s + (1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati");
            case "dd":
              return s + (1 === e ? "dan" : "dana");
            case "MM":
              return s + (1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci");
            case "yy":
              return s + (1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina");
          }
        }
        e.defineLocale("hr", {
          months: {
            format:
              "sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split(
                "_"
              ),
            standalone:
              "sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split(
                "_"
              ),
          },
          monthsShort: "sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
          monthsParseExact: !0,
          weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),
          weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
          weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM YYYY",
            LLL: "Do MMMM YYYY H:mm",
            LLLL: "dddd, Do MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[u] [nedjelju] [u] LT";
                case 3:
                  return "[u] [srijedu] [u] LT";
                case 6:
                  return "[u] [subotu] [u] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[u] dddd [u] LT";
              }
            },
            lastDay: "[ju\u010der u] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[pro\u0161lu] [nedjelju] [u] LT";
                case 3:
                  return "[pro\u0161lu] [srijedu] [u] LT";
                case 6:
                  return "[pro\u0161le] [subote] [u] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[pro\u0161li] dddd [u] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "par sekundi",
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: "dan",
            dd: t,
            M: "mjesec",
            MM: t,
            y: "godinu",
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    Oq9h: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            m: ["eine Minute", "einer Minute"],
            h: ["eine Stunde", "einer Stunde"],
            d: ["ein Tag", "einem Tag"],
            dd: [e + " Tage", e + " Tagen"],
            w: ["eine Woche", "einer Woche"],
            M: ["ein Monat", "einem Monat"],
            MM: [e + " Monate", e + " Monaten"],
            y: ["ein Jahr", "einem Jahr"],
            yy: [e + " Jahre", e + " Jahren"],
          };
          return t ? r[n][0] : r[n][1];
        }
        e.defineLocale("de-at", {
          months: "J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
          monthsShort: "J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
          monthsParseExact: !0,
          weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
          weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
          weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]",
          },
          relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: t,
            mm: "%d Minuten",
            h: t,
            hh: "%d Stunden",
            d: t,
            dd: t,
            w: t,
            ww: "%d Wochen",
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    PGvg: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          words: {
            ss: [
              "\u0441\u0435\u043a\u0443\u043d\u0434\u0430",
              "\u0441\u0435\u043a\u0443\u043d\u0434\u0435",
              "\u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ],
            m: [
              "\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442",
              "\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0438\u043d\u0443\u0442\u0430",
            ],
            mm: [
              "\u043c\u0438\u043d\u0443\u0442",
              "\u043c\u0438\u043d\u0443\u0442\u0430",
              "\u043c\u0438\u043d\u0443\u0442\u0430",
            ],
            h: [
              "\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442",
              "\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430",
            ],
            hh: ["\u0441\u0430\u0442", "\u0441\u0430\u0442\u0430", "\u0441\u0430\u0442\u0438"],
            d: [
              "\u0458\u0435\u0434\u0430\u043d \u0434\u0430\u043d",
              "\u0458\u0435\u0434\u043d\u043e\u0433 \u0434\u0430\u043d\u0430",
            ],
            dd: ["\u0434\u0430\u043d", "\u0434\u0430\u043d\u0430", "\u0434\u0430\u043d\u0430"],
            M: [
              "\u0458\u0435\u0434\u0430\u043d \u043c\u0435\u0441\u0435\u0446",
              "\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0435\u0441\u0435\u0446\u0430",
            ],
            MM: [
              "\u043c\u0435\u0441\u0435\u0446",
              "\u043c\u0435\u0441\u0435\u0446\u0430",
              "\u043c\u0435\u0441\u0435\u0446\u0438",
            ],
            y: [
              "\u0458\u0435\u0434\u043d\u0443 \u0433\u043e\u0434\u0438\u043d\u0443",
              "\u0458\u0435\u0434\u043d\u0435 \u0433\u043e\u0434\u0438\u043d\u0435",
            ],
            yy: [
              "\u0433\u043e\u0434\u0438\u043d\u0443",
              "\u0433\u043e\u0434\u0438\u043d\u0435",
              "\u0433\u043e\u0434\u0438\u043d\u0430",
            ],
          },
          correctGrammaticalCase: function (e, t) {
            return e % 10 >= 1 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? (e % 10 == 1 ? t[0] : t[1]) : t[2];
          },
          translate: function (e, n, s, r) {
            var i,
              a = t.words[s];
            return 1 === s.length
              ? "y" === s && n
                ? "\u0458\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430"
                : r || n
                ? a[0]
                : a[1]
              : ((i = t.correctGrammaticalCase(e, a)),
                "yy" === s && n && "\u0433\u043e\u0434\u0438\u043d\u0443" === i
                  ? e + " \u0433\u043e\u0434\u0438\u043d\u0430"
                  : e + " " + i);
          },
        };
        e.defineLocale("sr-cyrl", {
          months:
            "\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split(
              "_"
            ),
          monthsShort:
            "\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split(
              "_"
            ),
          weekdaysShort:
            "\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split(
              "_"
            ),
          weekdaysMin:
            "\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D. M. YYYY.",
            LL: "D. MMMM YYYY.",
            LLL: "D. MMMM YYYY. H:mm",
            LLLL: "dddd, D. MMMM YYYY. H:mm",
          },
          calendar: {
            sameDay: "[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",
            nextDay: "[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";
                case 3:
                  return "[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";
                case 6:
                  return "[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[\u0443] dddd [\u0443] LT";
              }
            },
            lastDay: "[\u0458\u0443\u0447\u0435 \u0443] LT",
            lastWeek: function () {
              return [
                "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT",
                "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT",
                "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT",
                "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT",
                "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT",
                "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT",
                "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT",
              ][this.day()];
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043f\u0440\u0435 %s",
            s: "\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ss: t.translate,
            m: t.translate,
            mm: t.translate,
            h: t.translate,
            hh: t.translate,
            d: t.translate,
            dd: t.translate,
            M: t.translate,
            MM: t.translate,
            y: t.translate,
            yy: t.translate,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    PoVJ: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          0: "-\u0443\u043c",
          1: "-\u0443\u043c",
          2: "-\u044e\u043c",
          3: "-\u044e\u043c",
          4: "-\u0443\u043c",
          5: "-\u0443\u043c",
          6: "-\u0443\u043c",
          7: "-\u0443\u043c",
          8: "-\u0443\u043c",
          9: "-\u0443\u043c",
          10: "-\u0443\u043c",
          12: "-\u0443\u043c",
          13: "-\u0443\u043c",
          20: "-\u0443\u043c",
          30: "-\u044e\u043c",
          40: "-\u0443\u043c",
          50: "-\u0443\u043c",
          60: "-\u0443\u043c",
          70: "-\u0443\u043c",
          80: "-\u0443\u043c",
          90: "-\u0443\u043c",
          100: "-\u0443\u043c",
        };
        e.defineLocale("tg", {
          months: {
            format:
              "\u044f\u043d\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043b\u0438_\u043c\u0430\u0440\u0442\u0438_\u0430\u043f\u0440\u0435\u043b\u0438_\u043c\u0430\u0439\u0438_\u0438\u044e\u043d\u0438_\u0438\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u0438_\u043e\u043a\u0442\u044f\u0431\u0440\u0438_\u043d\u043e\u044f\u0431\u0440\u0438_\u0434\u0435\u043a\u0430\u0431\u0440\u0438".split(
                "_"
              ),
            standalone:
              "\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split(
                "_"
              ),
          },
          monthsShort:
            "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split(
              "_"
            ),
          weekdays:
            "\u044f\u043a\u0448\u0430\u043d\u0431\u0435_\u0434\u0443\u0448\u0430\u043d\u0431\u0435_\u0441\u0435\u0448\u0430\u043d\u0431\u0435_\u0447\u043e\u0440\u0448\u0430\u043d\u0431\u0435_\u043f\u0430\u043d\u04b7\u0448\u0430\u043d\u0431\u0435_\u04b7\u0443\u043c\u044a\u0430_\u0448\u0430\u043d\u0431\u0435".split(
              "_"
            ),
          weekdaysShort:
            "\u044f\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043f\u0448\u0431_\u04b7\u0443\u043c_\u0448\u043d\u0431".split(
              "_"
            ),
          weekdaysMin:
            "\u044f\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043f\u0448_\u04b7\u043c_\u0448\u0431".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u0418\u043c\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",
            nextDay: "[\u0424\u0430\u0440\u0434\u043e \u0441\u043e\u0430\u0442\u0438] LT",
            lastDay: "[\u0414\u0438\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",
            nextWeek:
              "dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u043e\u044f\u043d\u0434\u0430 \u0441\u043e\u0430\u0442\u0438] LT",
            lastWeek:
              "dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043e\u0430\u0442\u0438] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0431\u0430\u044a\u0434\u0438 %s",
            past: "%s \u043f\u0435\u0448",
            s: "\u044f\u043a\u0447\u0430\u043d\u0434 \u0441\u043e\u043d\u0438\u044f",
            m: "\u044f\u043a \u0434\u0430\u049b\u0438\u049b\u0430",
            mm: "%d \u0434\u0430\u049b\u0438\u049b\u0430",
            h: "\u044f\u043a \u0441\u043e\u0430\u0442",
            hh: "%d \u0441\u043e\u0430\u0442",
            d: "\u044f\u043a \u0440\u04ef\u0437",
            dd: "%d \u0440\u04ef\u0437",
            M: "\u044f\u043a \u043c\u043e\u04b3",
            MM: "%d \u043c\u043e\u04b3",
            y: "\u044f\u043a \u0441\u043e\u043b",
            yy: "%d \u0441\u043e\u043b",
          },
          meridiemParse:
            /\u0448\u0430\u0431|\u0441\u0443\u0431\u04b3|\u0440\u04ef\u0437|\u0431\u0435\u0433\u043e\u04b3/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0448\u0430\u0431" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0441\u0443\u0431\u04b3" === t
                ? e
                : "\u0440\u04ef\u0437" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "\u0431\u0435\u0433\u043e\u04b3" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0448\u0430\u0431"
              : e < 11
              ? "\u0441\u0443\u0431\u04b3"
              : e < 16
              ? "\u0440\u04ef\u0437"
              : e < 19
              ? "\u0431\u0435\u0433\u043e\u04b3"
              : "\u0448\u0430\u0431";
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0443\u043c|\u044e\u043c)/,
          ordinal: function (e) {
            return e + (t[e] || t[e % 10] || t[e >= 100 ? 100 : null]);
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    QDhB: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("yo", {
          months:
            "S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split(
              "_"
            ),
          monthsShort:
            "S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split(
              "_"
            ),
          weekdays:
            "A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split(
              "_"
            ),
          weekdaysShort:
            "A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split(
              "_"
            ),
          weekdaysMin: "A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split("_"),
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A",
          },
          calendar: {
            sameDay: "[O\u0300ni\u0300 ni] LT",
            nextDay: "[\u1ecc\u0300la ni] LT",
            nextWeek: "dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",
            lastDay: "[A\u0300na ni] LT",
            lastWeek: "dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "ni\u0301 %s",
            past: "%s k\u1ecdja\u0301",
            s: "i\u0300s\u1eb9ju\u0301 aaya\u0301 die",
            ss: "aaya\u0301 %d",
            m: "i\u0300s\u1eb9ju\u0301 kan",
            mm: "i\u0300s\u1eb9ju\u0301 %d",
            h: "wa\u0301kati kan",
            hh: "wa\u0301kati %d",
            d: "\u1ecdj\u1ecd\u0301 kan",
            dd: "\u1ecdj\u1ecd\u0301 %d",
            M: "osu\u0300 kan",
            MM: "osu\u0300 %d",
            y: "\u1ecddu\u0301n kan",
            yy: "\u1ecddu\u0301n %d",
          },
          dayOfMonthOrdinalParse: /\u1ecdj\u1ecd\u0301\s\d{1,2}/,
          ordinal: "\u1ecdj\u1ecd\u0301 %d",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    QJjq: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            s: [
              "\u0925\u094b\u0921\u092f\u093e \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",
              "\u0925\u094b\u0921\u0947 \u0938\u0945\u0915\u0902\u0921",
            ],
            ss: [e + " \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940", e + " \u0938\u0945\u0915\u0902\u0921"],
            m: [
              "\u090f\u0915\u093e \u092e\u093f\u0923\u091f\u093e\u0928",
              "\u090f\u0915 \u092e\u093f\u0928\u0942\u091f",
            ],
            mm: [e + " \u092e\u093f\u0923\u091f\u093e\u0902\u0928\u0940", e + " \u092e\u093f\u0923\u091f\u093e\u0902"],
            h: ["\u090f\u0915\u093e \u0935\u0930\u093e\u0928", "\u090f\u0915 \u0935\u0930"],
            hh: [e + " \u0935\u0930\u093e\u0902\u0928\u0940", e + " \u0935\u0930\u093e\u0902"],
            d: ["\u090f\u0915\u093e \u0926\u093f\u0938\u093e\u0928", "\u090f\u0915 \u0926\u0940\u0938"],
            dd: [e + " \u0926\u093f\u0938\u093e\u0902\u0928\u0940", e + " \u0926\u0940\u0938"],
            M: [
              "\u090f\u0915\u093e \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928",
              "\u090f\u0915 \u092e\u094d\u0939\u092f\u0928\u094b",
            ],
            MM: [
              e + " \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928\u0940",
              e + " \u092e\u094d\u0939\u092f\u0928\u0947",
            ],
            y: ["\u090f\u0915\u093e \u0935\u0930\u094d\u0938\u093e\u0928", "\u090f\u0915 \u0935\u0930\u094d\u0938"],
            yy: [e + " \u0935\u0930\u094d\u0938\u093e\u0902\u0928\u0940", e + " \u0935\u0930\u094d\u0938\u093e\u0902"],
          };
          return s ? r[n][0] : r[n][1];
        }
        e.defineLocale("gom-deva", {
          months: {
            standalone:
              "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u092f_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split(
                "_"
              ),
            format:
              "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092e\u093e\u0930\u094d\u091a\u093e\u091a\u094d\u092f\u093e_\u090f\u092a\u094d\u0930\u0940\u0932\u093e\u091a\u094d\u092f\u093e_\u092e\u0947\u092f\u093e\u091a\u094d\u092f\u093e_\u091c\u0942\u0928\u093e\u091a\u094d\u092f\u093e_\u091c\u0941\u0932\u092f\u093e\u091a\u094d\u092f\u093e_\u0911\u0917\u0938\u094d\u091f\u093e\u091a\u094d\u092f\u093e_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0911\u0915\u094d\u091f\u094b\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0921\u093f\u0938\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e".split(
                "_"
              ),
            isFormat: /MMMM(\s)+D[oD]?/,
          },
          monthsShort:
            "\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940._\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0906\u092f\u0924\u093e\u0930_\u0938\u094b\u092e\u093e\u0930_\u092e\u0902\u0917\u0933\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u092c\u093f\u0930\u0947\u0938\u094d\u0924\u093e\u0930_\u0938\u0941\u0915\u094d\u0930\u093e\u0930_\u0936\u0947\u0928\u0935\u093e\u0930".split(
              "_"
            ),
          weekdaysShort:
            "\u0906\u092f\u0924._\u0938\u094b\u092e._\u092e\u0902\u0917\u0933._\u092c\u0941\u0927._\u092c\u094d\u0930\u0947\u0938\u094d\u0924._\u0938\u0941\u0915\u094d\u0930._\u0936\u0947\u0928.".split(
              "_"
            ),
          weekdaysMin:
            "\u0906_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u092c\u094d\u0930\u0947_\u0938\u0941_\u0936\u0947".split(
              "_"
            ),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            LTS: "A h:mm:ss [\u0935\u093e\u091c\u0924\u093e\u0902]",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            llll: "ddd, D MMM YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
          },
          calendar: {
            sameDay: "[\u0906\u092f\u091c] LT",
            nextDay: "[\u092b\u093e\u0932\u094d\u092f\u093e\u0902] LT",
            nextWeek: "[\u092b\u0941\u0921\u0932\u094b] dddd[,] LT",
            lastDay: "[\u0915\u093e\u0932] LT",
            lastWeek: "[\u092b\u093e\u091f\u0932\u094b] dddd[,] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s",
            past: "%s \u0906\u0926\u0940\u0902",
            s: t,
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: t,
            dd: t,
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\u0935\u0947\u0930)/,
          ordinal: function (e, t) {
            switch (t) {
              case "D":
                return e + "\u0935\u0947\u0930";
              default:
              case "M":
              case "Q":
              case "DDD":
              case "d":
              case "w":
              case "W":
                return e;
            }
          },
          week: { dow: 0, doy: 3 },
          meridiemParse:
            /\u0930\u093e\u0924\u0940|\u0938\u0915\u093e\u0933\u0940\u0902|\u0926\u0928\u092a\u093e\u0930\u093e\u0902|\u0938\u093e\u0902\u091c\u0947/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0930\u093e\u0924\u0940" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0938\u0915\u093e\u0933\u0940\u0902" === t
                ? e
                : "\u0926\u0928\u092a\u093e\u0930\u093e\u0902" === t
                ? e > 12
                  ? e
                  : e + 12
                : "\u0938\u093e\u0902\u091c\u0947" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0930\u093e\u0924\u0940"
              : e < 12
              ? "\u0938\u0915\u093e\u0933\u0940\u0902"
              : e < 16
              ? "\u0926\u0928\u092a\u093e\u0930\u093e\u0902"
              : e < 20
              ? "\u0938\u093e\u0902\u091c\u0947"
              : "\u0930\u093e\u0924\u0940";
          },
        });
      })(n("wgY5"));
    },
    QK6v: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = e + " ";
          switch (n) {
            case "s":
              return t || s ? "nekaj sekund" : "nekaj sekundami";
            case "ss":
              return (
                r +
                (1 === e
                  ? t
                    ? "sekundo"
                    : "sekundi"
                  : 2 === e
                  ? t || s
                    ? "sekundi"
                    : "sekundah"
                  : e < 5
                  ? t || s
                    ? "sekunde"
                    : "sekundah"
                  : "sekund")
              );
            case "m":
              return t ? "ena minuta" : "eno minuto";
            case "mm":
              return (
                r +
                (1 === e
                  ? t
                    ? "minuta"
                    : "minuto"
                  : 2 === e
                  ? t || s
                    ? "minuti"
                    : "minutama"
                  : e < 5
                  ? t || s
                    ? "minute"
                    : "minutami"
                  : t || s
                  ? "minut"
                  : "minutami")
              );
            case "h":
              return t ? "ena ura" : "eno uro";
            case "hh":
              return (
                r +
                (1 === e
                  ? t
                    ? "ura"
                    : "uro"
                  : 2 === e
                  ? t || s
                    ? "uri"
                    : "urama"
                  : e < 5
                  ? t || s
                    ? "ure"
                    : "urami"
                  : t || s
                  ? "ur"
                  : "urami")
              );
            case "d":
              return t || s ? "en dan" : "enim dnem";
            case "dd":
              return (
                r +
                (1 === e
                  ? t || s
                    ? "dan"
                    : "dnem"
                  : 2 === e
                  ? t || s
                    ? "dni"
                    : "dnevoma"
                  : t || s
                  ? "dni"
                  : "dnevi")
              );
            case "M":
              return t || s ? "en mesec" : "enim mesecem";
            case "MM":
              return (
                r +
                (1 === e
                  ? t || s
                    ? "mesec"
                    : "mesecem"
                  : 2 === e
                  ? t || s
                    ? "meseca"
                    : "mesecema"
                  : e < 5
                  ? t || s
                    ? "mesece"
                    : "meseci"
                  : t || s
                  ? "mesecev"
                  : "meseci")
              );
            case "y":
              return t || s ? "eno leto" : "enim letom";
            case "yy":
              return (
                r +
                (1 === e
                  ? t || s
                    ? "leto"
                    : "letom"
                  : 2 === e
                  ? t || s
                    ? "leti"
                    : "letoma"
                  : e < 5
                  ? t || s
                    ? "leta"
                    : "leti"
                  : t || s
                  ? "let"
                  : "leti")
              );
          }
        }
        e.defineLocale("sl", {
          months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
          monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split("_"),
          weekdaysShort: "ned._pon._tor._sre._\u010det._pet._sob.".split("_"),
          weekdaysMin: "ne_po_to_sr_\u010de_pe_so".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD. MM. YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[danes ob] LT",
            nextDay: "[jutri ob] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[v] [nedeljo] [ob] LT";
                case 3:
                  return "[v] [sredo] [ob] LT";
                case 6:
                  return "[v] [soboto] [ob] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[v] dddd [ob] LT";
              }
            },
            lastDay: "[v\u010deraj ob] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[prej\u0161njo] [nedeljo] [ob] LT";
                case 3:
                  return "[prej\u0161njo] [sredo] [ob] LT";
                case 6:
                  return "[prej\u0161njo] [soboto] [ob] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[prej\u0161nji] dddd [ob] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u010dez %s",
            past: "pred %s",
            s: t,
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: t,
            dd: t,
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    QNGR: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = [
            "\u062c\u0646\u0648\u0631\u06cc",
            "\u0641\u0631\u0648\u0631\u06cc",
            "\u0645\u0627\u0631\u0686",
            "\u0627\u067e\u0631\u06cc\u0644",
            "\u0645\u0626\u06cc",
            "\u062c\u0648\u0646",
            "\u062c\u0648\u0644\u0627\u0626\u06cc",
            "\u0627\u06af\u0633\u062a",
            "\u0633\u062a\u0645\u0628\u0631",
            "\u0627\u06a9\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0645\u0628\u0631",
            "\u062f\u0633\u0645\u0628\u0631",
          ],
          n = [
            "\u0627\u062a\u0648\u0627\u0631",
            "\u067e\u06cc\u0631",
            "\u0645\u0646\u06af\u0644",
            "\u0628\u062f\u06be",
            "\u062c\u0645\u0639\u0631\u0627\u062a",
            "\u062c\u0645\u0639\u06c1",
            "\u06c1\u0641\u062a\u06c1",
          ];
        e.defineLocale("ur", {
          months: t,
          monthsShort: t,
          weekdays: n,
          weekdaysShort: n,
          weekdaysMin: n,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd\u060c D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0635\u0628\u062d|\u0634\u0627\u0645/,
          isPM: function (e) {
            return "\u0634\u0627\u0645" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0635\u0628\u062d" : "\u0634\u0627\u0645";
          },
          calendar: {
            sameDay: "[\u0622\u062c \u0628\u0648\u0642\u062a] LT",
            nextDay: "[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",
            nextWeek: "dddd [\u0628\u0648\u0642\u062a] LT",
            lastDay: "[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",
            lastWeek: "[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0628\u0639\u062f",
            past: "%s \u0642\u0628\u0644",
            s: "\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",
            ss: "%d \u0633\u06cc\u06a9\u0646\u0688",
            m: "\u0627\u06cc\u06a9 \u0645\u0646\u0679",
            mm: "%d \u0645\u0646\u0679",
            h: "\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",
            hh: "%d \u06af\u06be\u0646\u0679\u06d2",
            d: "\u0627\u06cc\u06a9 \u062f\u0646",
            dd: "%d \u062f\u0646",
            M: "\u0627\u06cc\u06a9 \u0645\u0627\u06c1",
            MM: "%d \u0645\u0627\u06c1",
            y: "\u0627\u06cc\u06a9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644",
          },
          preparse: function (e) {
            return e.replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e.replace(/,/g, "\u060c");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    QWb5: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0f21",
            2: "\u0f22",
            3: "\u0f23",
            4: "\u0f24",
            5: "\u0f25",
            6: "\u0f26",
            7: "\u0f27",
            8: "\u0f28",
            9: "\u0f29",
            0: "\u0f20",
          },
          n = {
            "\u0f21": "1",
            "\u0f22": "2",
            "\u0f23": "3",
            "\u0f24": "4",
            "\u0f25": "5",
            "\u0f26": "6",
            "\u0f27": "7",
            "\u0f28": "8",
            "\u0f29": "9",
            "\u0f20": "0",
          };
        e.defineLocale("bo", {
          months:
            "\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split(
              "_"
            ),
          monthsShort:
            "\u0f5f\u0fb3\u0f0b1_\u0f5f\u0fb3\u0f0b2_\u0f5f\u0fb3\u0f0b3_\u0f5f\u0fb3\u0f0b4_\u0f5f\u0fb3\u0f0b5_\u0f5f\u0fb3\u0f0b6_\u0f5f\u0fb3\u0f0b7_\u0f5f\u0fb3\u0f0b8_\u0f5f\u0fb3\u0f0b9_\u0f5f\u0fb3\u0f0b10_\u0f5f\u0fb3\u0f0b11_\u0f5f\u0fb3\u0f0b12".split(
              "_"
            ),
          monthsShortRegex: /^(\u0f5f\u0fb3\u0f0b\d{1,2})/,
          monthsParseExact: !0,
          weekdays:
            "\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split(
              "_"
            ),
          weekdaysShort:
            "\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split(
              "_"
            ),
          weekdaysMin:
            "\u0f49\u0f72_\u0f5f\u0fb3_\u0f58\u0f72\u0f42_\u0f63\u0fb7\u0f42_\u0f55\u0f74\u0f62_\u0f66\u0f44\u0f66_\u0f66\u0fa4\u0f7a\u0f53".split(
              "_"
            ),
          longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm",
          },
          calendar: {
            sameDay: "[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",
            nextDay: "[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",
            nextWeek:
              "[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",
            lastDay: "[\u0f41\u0f0b\u0f66\u0f44] LT",
            lastWeek: "[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0f63\u0f0b",
            past: "%s \u0f66\u0f94\u0f53\u0f0b\u0f63",
            s: "\u0f63\u0f58\u0f0b\u0f66\u0f44",
            ss: "%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",
            m: "\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",
            mm: "%d \u0f66\u0f90\u0f62\u0f0b\u0f58",
            h: "\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",
            hh: "%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",
            d: "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",
            dd: "%d \u0f49\u0f72\u0f53\u0f0b",
            M: "\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",
            MM: "%d \u0f5f\u0fb3\u0f0b\u0f56",
            y: "\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",
            yy: "%d \u0f63\u0f7c",
          },
          preparse: function (e) {
            return e.replace(/[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              ("\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c" === t && e >= 4) ||
              ("\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44" === t && e < 5) ||
              "\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42" === t
                ? e + 12
                : e
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"
              : e < 10
              ? "\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66"
              : e < 17
              ? "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44"
              : e < 20
              ? "\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42"
              : "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    R7mU: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          s = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
          ],
          r =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es-do", {
          months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
          weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
          weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY h:mm A",
            LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A",
          },
          calendar: {
            sameDay: function () {
              return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function () {
              return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function () {
              return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function () {
              return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function () {
              return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    RIsM: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          switch (n) {
            case "s":
              return t
                ? "\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434"
                : "\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d";
            case "ss":
              return (
                e + (t ? " \u0441\u0435\u043a\u0443\u043d\u0434" : " \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d")
              );
            case "m":
            case "mm":
              return e + (t ? " \u043c\u0438\u043d\u0443\u0442" : " \u043c\u0438\u043d\u0443\u0442\u044b\u043d");
            case "h":
            case "hh":
              return e + (t ? " \u0446\u0430\u0433" : " \u0446\u0430\u0433\u0438\u0439\u043d");
            case "d":
            case "dd":
              return e + (t ? " \u04e9\u0434\u04e9\u0440" : " \u04e9\u0434\u0440\u0438\u0439\u043d");
            case "M":
            case "MM":
              return e + (t ? " \u0441\u0430\u0440" : " \u0441\u0430\u0440\u044b\u043d");
            case "y":
            case "yy":
              return e + (t ? " \u0436\u0438\u043b" : " \u0436\u0438\u043b\u0438\u0439\u043d");
            default:
              return e;
          }
        }
        e.defineLocale("mn", {
          months:
            "\u041d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0425\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04e9\u0440\u04e9\u0432\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043e\u043b\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041d\u0430\u0439\u043c\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u043d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u0445\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split(
              "_"
            ),
          monthsShort:
            "1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u041d\u044f\u043c_\u0414\u0430\u0432\u0430\u0430_\u041c\u044f\u0433\u043c\u0430\u0440_\u041b\u0445\u0430\u0433\u0432\u0430_\u041f\u04af\u0440\u044d\u0432_\u0411\u0430\u0430\u0441\u0430\u043d_\u0411\u044f\u043c\u0431\u0430".split(
              "_"
            ),
          weekdaysShort:
            "\u041d\u044f\u043c_\u0414\u0430\u0432_\u041c\u044f\u0433_\u041b\u0445\u0430_\u041f\u04af\u0440_\u0411\u0430\u0430_\u0411\u044f\u043c".split(
              "_"
            ),
          weekdaysMin:
            "\u041d\u044f_\u0414\u0430_\u041c\u044f_\u041b\u0445_\u041f\u04af_\u0411\u0430_\u0411\u044f".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY \u043e\u043d\u044b MMMM\u044b\u043d D",
            LLL: "YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",
            LLLL: "dddd, YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",
          },
          meridiemParse: /\u04ae\u04e8|\u04ae\u0425/i,
          isPM: function (e) {
            return "\u04ae\u0425" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u04ae\u04e8" : "\u04ae\u0425";
          },
          calendar: {
            sameDay: "[\u04e8\u043d\u04e9\u04e9\u0434\u04e9\u0440] LT",
            nextDay: "[\u041c\u0430\u0440\u0433\u0430\u0430\u0448] LT",
            nextWeek: "[\u0418\u0440\u044d\u0445] dddd LT",
            lastDay: "[\u04e8\u0447\u0438\u0433\u0434\u04e9\u0440] LT",
            lastWeek: "[\u04e8\u043d\u0433\u04e9\u0440\u0441\u04e9\u043d] dddd LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0434\u0430\u0440\u0430\u0430",
            past: "%s \u04e9\u043c\u043d\u04e9",
            s: t,
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: t,
            dd: t,
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2} \u04e9\u0434\u04e9\u0440/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + " \u04e9\u0434\u04e9\u0440";
              default:
                return e;
            }
          },
        });
      })(n("wgY5"));
    },
    S0Tg: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0661",
            2: "\u0662",
            3: "\u0663",
            4: "\u0664",
            5: "\u0665",
            6: "\u0666",
            7: "\u0667",
            8: "\u0668",
            9: "\u0669",
            0: "\u0660",
          },
          n = {
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u0660": "0",
          },
          s = [
            "\u06a9\u0627\u0646\u0648\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645",
            "\u0634\u0648\u0628\u0627\u062a",
            "\u0626\u0627\u0632\u0627\u0631",
            "\u0646\u06cc\u0633\u0627\u0646",
            "\u0626\u0627\u06cc\u0627\u0631",
            "\u062d\u0648\u0632\u06d5\u06cc\u0631\u0627\u0646",
            "\u062a\u06d5\u0645\u0645\u0648\u0632",
            "\u0626\u0627\u0628",
            "\u0626\u06d5\u06cc\u0644\u0648\u0648\u0644",
            "\u062a\u0634\u0631\u06cc\u0646\u06cc \u06cc\u06d5\u0643\u06d5\u0645",
            "\u062a\u0634\u0631\u06cc\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645",
            "\u0643\u0627\u0646\u0648\u0646\u06cc \u06cc\u06d5\u06a9\u06d5\u0645",
          ];
        e.defineLocale("ku", {
          months: s,
          monthsShort: s,
          weekdays:
            "\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u062f\u0648\u0648\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0633\u06ce\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split(
              "_"
            ),
          weekdaysShort:
            "\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645_\u062f\u0648\u0648\u0634\u0647\u200c\u0645_\u0633\u06ce\u0634\u0647\u200c\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split(
              "_"
            ),
          weekdaysMin: "\u06cc_\u062f_\u0633_\u0686_\u067e_\u0647_\u0634".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0626\u06ce\u0648\u0627\u0631\u0647\u200c|\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc/,
          isPM: function (e) {
            return /\u0626\u06ce\u0648\u0627\u0631\u0647\u200c/.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc" : "\u0626\u06ce\u0648\u0627\u0631\u0647\u200c";
          },
          calendar: {
            sameDay: "[\u0626\u0647\u200c\u0645\u0631\u06c6 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            nextDay: "[\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            nextWeek: "dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            lastDay: "[\u062f\u0648\u06ce\u0646\u06ce \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            lastWeek: "dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0644\u0647\u200c %s",
            past: "%s",
            s: "\u0686\u0647\u200c\u0646\u062f \u0686\u0631\u0643\u0647\u200c\u06cc\u0647\u200c\u0643",
            ss: "\u0686\u0631\u0643\u0647\u200c %d",
            m: "\u06cc\u0647\u200c\u0643 \u062e\u0648\u0644\u0647\u200c\u0643",
            mm: "%d \u062e\u0648\u0644\u0647\u200c\u0643",
            h: "\u06cc\u0647\u200c\u0643 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",
            hh: "%d \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",
            d: "\u06cc\u0647\u200c\u0643 \u0695\u06c6\u0698",
            dd: "%d \u0695\u06c6\u0698",
            M: "\u06cc\u0647\u200c\u0643 \u0645\u0627\u0646\u06af",
            MM: "%d \u0645\u0627\u0646\u06af",
            y: "\u06cc\u0647\u200c\u0643 \u0633\u0627\u06b5",
            yy: "%d \u0633\u0627\u06b5",
          },
          preparse: function (e) {
            return e
              .replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function (e) {
                return n[e];
              })
              .replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e
              .replace(/\d/g, function (e) {
                return t[e];
              })
              .replace(/,/g, "\u060c");
          },
          week: { dow: 6, doy: 12 },
        });
      })(n("wgY5"));
    },
    S70V: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-in", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    SPXN: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("fr-ch", {
          months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split(
            "_"
          ),
          monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
          monthsParseExact: !0,
          weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
          weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
          weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
          ordinal: function (e, t) {
            switch (t) {
              default:
              case "M":
              case "Q":
              case "D":
              case "DDD":
              case "d":
                return e + (1 === e ? "er" : "e");
              case "w":
              case "W":
                return e + (1 === e ? "re" : "e");
            }
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    Sc1Y: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ar-kw", {
          months:
            "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
              "_"
            ),
          monthsShort:
            "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
              "_"
            ),
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a",
          },
          week: { dow: 0, doy: 12 },
        });
      })(n("wgY5"));
    },
    T3MF: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),
          n = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
        e.defineLocale("fy", {
          months:
            "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsParseExact: !0,
          weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),
          weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
          weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[hjoed om] LT",
            nextDay: "[moarn om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[juster om] LT",
            lastWeek: "[\xf4fr\xfbne] dddd [om] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "oer %s",
            past: "%s lyn",
            s: "in pear sekonden",
            ss: "%d sekonden",
            m: "ien min\xfat",
            mm: "%d minuten",
            h: "ien oere",
            hh: "%d oeren",
            d: "ien dei",
            dd: "%d dagen",
            M: "ien moanne",
            MM: "%d moannen",
            y: "ien jier",
            yy: "%d jierren",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function (e) {
            return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    TB59: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-il", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
        });
      })(n("wgY5"));
    },
    TO58: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("si", {
          months:
            "\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split(
              "_"
            ),
          monthsShort:
            "\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split(
              "_"
            ),
          weekdays:
            "\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split(
              "_"
            ),
          weekdaysShort:
            "\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split(
              "_"
            ),
          weekdaysMin: "\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "a h:mm",
            LTS: "a h:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY MMMM D",
            LLL: "YYYY MMMM D, a h:mm",
            LLLL: "YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss",
          },
          calendar: {
            sameDay: "[\u0d85\u0daf] LT[\u0da7]",
            nextDay: "[\u0dc4\u0dd9\u0da7] LT[\u0da7]",
            nextWeek: "dddd LT[\u0da7]",
            lastDay: "[\u0d8a\u0dba\u0dda] LT[\u0da7]",
            lastWeek: "[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s\u0d9a\u0dd2\u0db1\u0dca",
            past: "%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
            s: "\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",
            ss: "\u0dad\u0dad\u0dca\u0db4\u0dbb %d",
            m: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",
            mm: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",
            h: "\u0db4\u0dd0\u0dba",
            hh: "\u0db4\u0dd0\u0dba %d",
            d: "\u0daf\u0dd2\u0db1\u0dba",
            dd: "\u0daf\u0dd2\u0db1 %d",
            M: "\u0db8\u0dcf\u0dc3\u0dba",
            MM: "\u0db8\u0dcf\u0dc3 %d",
            y: "\u0dc0\u0dc3\u0dbb",
            yy: "\u0dc0\u0dc3\u0dbb %d",
          },
          dayOfMonthOrdinalParse: /\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,
          ordinal: function (e) {
            return e + " \u0dc0\u0dd0\u0db1\u0dd2";
          },
          meridiemParse:
            /\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,
          isPM: function (e) {
            return "\u0db4.\u0dc0." === e || "\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4" === e;
          },
          meridiem: function (e, t, n) {
            return e > 11
              ? n
                ? "\u0db4.\u0dc0."
                : "\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4"
              : n
              ? "\u0db4\u0dd9.\u0dc0."
              : "\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4";
          },
        });
      })(n("wgY5"));
    },
    TTiN: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("bm", {
          months:
            "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split(
              "_"
            ),
          monthsShort: "Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split("_"),
          weekdays: "Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
          weekdaysShort: "Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),
          weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "MMMM [tile] D [san] YYYY",
            LLL: "MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",
            LLLL: "dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",
          },
          calendar: {
            sameDay: "[Bi l\u025br\u025b] LT",
            nextDay: "[Sini l\u025br\u025b] LT",
            nextWeek: "dddd [don l\u025br\u025b] LT",
            lastDay: "[Kunu l\u025br\u025b] LT",
            lastWeek: "dddd [t\u025bm\u025bnen l\u025br\u025b] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s k\u0254n\u0254",
            past: "a b\u025b %s b\u0254",
            s: "sanga dama dama",
            ss: "sekondi %d",
            m: "miniti kelen",
            mm: "miniti %d",
            h: "l\u025br\u025b kelen",
            hh: "l\u025br\u025b %d",
            d: "tile kelen",
            dd: "tile %d",
            M: "kalo kelen",
            MM: "kalo %d",
            y: "san kelen",
            yy: "san %d",
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    TUxt: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u17e1",
            2: "\u17e2",
            3: "\u17e3",
            4: "\u17e4",
            5: "\u17e5",
            6: "\u17e6",
            7: "\u17e7",
            8: "\u17e8",
            9: "\u17e9",
            0: "\u17e0",
          },
          n = {
            "\u17e1": "1",
            "\u17e2": "2",
            "\u17e3": "3",
            "\u17e4": "4",
            "\u17e5": "5",
            "\u17e6": "6",
            "\u17e7": "7",
            "\u17e8": "8",
            "\u17e9": "9",
            "\u17e0": "0",
          };
        e.defineLocale("km", {
          months:
            "\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split(
              "_"
            ),
          monthsShort:
            "\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split(
              "_"
            ),
          weekdays:
            "\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split(
              "_"
            ),
          weekdaysShort: "\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),
          weekdaysMin: "\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u1796\u17d2\u179a\u17b9\u1780|\u179b\u17d2\u1784\u17b6\u1785/,
          isPM: function (e) {
            return "\u179b\u17d2\u1784\u17b6\u1785" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u1796\u17d2\u179a\u17b9\u1780" : "\u179b\u17d2\u1784\u17b6\u1785";
          },
          calendar: {
            sameDay: "[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",
            nextDay: "[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",
            nextWeek: "dddd [\u1798\u17c9\u17c4\u1784] LT",
            lastDay: "[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",
            lastWeek:
              "dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s\u1791\u17c0\u178f",
            past: "%s\u1798\u17bb\u1793",
            s: "\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",
            ss: "%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",
            m: "\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",
            mm: "%d \u1793\u17b6\u1791\u17b8",
            h: "\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",
            hh: "%d \u1798\u17c9\u17c4\u1784",
            d: "\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",
            dd: "%d \u1790\u17d2\u1784\u17c3",
            M: "\u1798\u17bd\u1799\u1781\u17c2",
            MM: "%d \u1781\u17c2",
            y: "\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",
            yy: "%d \u1786\u17d2\u1793\u17b6\u17c6",
          },
          dayOfMonthOrdinalParse: /\u1791\u17b8\d{1,2}/,
          ordinal: "\u1791\u17b8%d",
          preparse: function (e) {
            return e.replace(/[\u17e1\u17e2\u17e3\u17e4\u17e5\u17e6\u17e7\u17e8\u17e9\u17e0]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    TmOJ: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e) {
          return e % 100 == 11 || e % 10 != 1;
        }
        function n(e, n, s, r) {
          var i = e + " ";
          switch (s) {
            case "s":
              return n || r ? "nokkrar sek\xfandur" : "nokkrum sek\xfandum";
            case "ss":
              return t(e) ? i + (n || r ? "sek\xfandur" : "sek\xfandum") : i + "sek\xfanda";
            case "m":
              return n ? "m\xedn\xfata" : "m\xedn\xfatu";
            case "mm":
              return t(e)
                ? i + (n || r ? "m\xedn\xfatur" : "m\xedn\xfatum")
                : n
                ? i + "m\xedn\xfata"
                : i + "m\xedn\xfatu";
            case "hh":
              return t(e) ? i + (n || r ? "klukkustundir" : "klukkustundum") : i + "klukkustund";
            case "d":
              return n ? "dagur" : r ? "dag" : "degi";
            case "dd":
              return t(e)
                ? n
                  ? i + "dagar"
                  : i + (r ? "daga" : "d\xf6gum")
                : n
                ? i + "dagur"
                : i + (r ? "dag" : "degi");
            case "M":
              return n ? "m\xe1nu\xf0ur" : r ? "m\xe1nu\xf0" : "m\xe1nu\xf0i";
            case "MM":
              return t(e)
                ? n
                  ? i + "m\xe1nu\xf0ir"
                  : i + (r ? "m\xe1nu\xf0i" : "m\xe1nu\xf0um")
                : n
                ? i + "m\xe1nu\xf0ur"
                : i + (r ? "m\xe1nu\xf0" : "m\xe1nu\xf0i");
            case "y":
              return n || r ? "\xe1r" : "\xe1ri";
            case "yy":
              return t(e) ? i + (n || r ? "\xe1r" : "\xe1rum") : i + (n || r ? "\xe1r" : "\xe1ri");
          }
        }
        e.defineLocale("is", {
          months:
            "jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split(
              "_"
            ),
          monthsShort: "jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),
          weekdays:
            "sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split(
              "_"
            ),
          weekdaysShort: "sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),
          weekdaysMin: "Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] H:mm",
            LLLL: "dddd, D. MMMM YYYY [kl.] H:mm",
          },
          calendar: {
            sameDay: "[\xed dag kl.] LT",
            nextDay: "[\xe1 morgun kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[\xed g\xe6r kl.] LT",
            lastWeek: "[s\xed\xf0asta] dddd [kl.] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "eftir %s",
            past: "fyrir %s s\xed\xf0an",
            s: n,
            ss: n,
            m: n,
            mm: n,
            h: "klukkustund",
            hh: n,
            d: n,
            dd: n,
            M: n,
            MM: n,
            y: n,
            yy: n,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "UC+K": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("tl-ph", {
          months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
          monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
          weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
          weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
          weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "MM/D/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY HH:mm",
            LLLL: "dddd, MMMM DD, YYYY HH:mm",
          },
          calendar: {
            sameDay: "LT [ngayong araw]",
            nextDay: "[Bukas ng] LT",
            nextWeek: "LT [sa susunod na] dddd",
            lastDay: "LT [kahapon]",
            lastWeek: "LT [noong nakaraang] dddd",
            sameElse: "L",
          },
          relativeTime: {
            future: "sa loob ng %s",
            past: "%s ang nakalipas",
            s: "ilang segundo",
            ss: "%d segundo",
            m: "isang minuto",
            mm: "%d minuto",
            h: "isang oras",
            hh: "%d oras",
            d: "isang araw",
            dd: "%d araw",
            M: "isang buwan",
            MM: "%d buwan",
            y: "isang taon",
            yy: "%d taon",
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: function (e) {
            return e;
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    W7dU: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("x-pseudo", {
          months:
            "J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split(
              "_"
            ),
          monthsShort:
            "J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split(
              "_"
            ),
          weekdaysShort: "S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),
          weekdaysMin: "S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[T~\xf3d\xe1~\xfd \xe1t] LT",
            nextDay: "[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",
            nextWeek: "dddd [\xe1t] LT",
            lastDay: "[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",
            lastWeek: "[L~\xe1st] dddd [\xe1t] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\xed~\xf1 %s",
            past: "%s \xe1~g\xf3",
            s: "\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",
            ss: "%d s~\xe9c\xf3\xf1~ds",
            m: "\xe1 ~m\xed\xf1~\xfat\xe9",
            mm: "%d m~\xed\xf1\xfa~t\xe9s",
            h: "\xe1~\xf1 h\xf3~\xfar",
            hh: "%d h~\xf3\xfars",
            d: "\xe1 ~d\xe1\xfd",
            dd: "%d d~\xe1\xfds",
            M: "\xe1 ~m\xf3\xf1~th",
            MM: "%d m~\xf3\xf1t~hs",
            y: "\xe1 ~\xfd\xe9\xe1r",
            yy: "%d \xfd~\xe9\xe1rs",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    WF5B: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("sv", {
          months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
          monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
          weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),
          weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),
          weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd D MMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Idag] LT",
            nextDay: "[Imorgon] LT",
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: "[I] dddd[s] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "om %s",
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: "%d sekunder",
            m: "en minut",
            mm: "%d minuter",
            h: "en timme",
            hh: "%d timmar",
            d: "en dag",
            dd: "%d dagar",
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? ":e" : 1 === t || 2 === t ? ":a" : ":e");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    Y8Ij: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t =
            /(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?|janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,
          n = [
            /^janv/i,
            /^f\xe9vr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^ao\xfbt/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^d\xe9c/i,
          ];
        e.defineLocale("fr", {
          months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split(
            "_"
          ),
          monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
          monthsRegex: t,
          monthsShortRegex: t,
          monthsStrictRegex:
            /^(janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,
          monthsShortStrictRegex:
            /(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?)/i,
          monthsParse: n,
          longMonthsParse: n,
          shortMonthsParse: n,
          weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
          weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
          weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            w: "une semaine",
            ww: "%d semaines",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
          ordinal: function (e, t) {
            switch (t) {
              case "D":
                return e + (1 === e ? "er" : "");
              default:
              case "M":
              case "Q":
              case "DDD":
              case "d":
                return e + (1 === e ? "er" : "e");
              case "w":
              case "W":
                return e + (1 === e ? "re" : "e");
            }
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    YKe2: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          ss: "sekundes_sekund\u0113m_sekunde_sekundes".split("_"),
          m: "min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),
          mm: "min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),
          h: "stundas_stund\u0101m_stunda_stundas".split("_"),
          hh: "stundas_stund\u0101m_stunda_stundas".split("_"),
          d: "dienas_dien\u0101m_diena_dienas".split("_"),
          dd: "dienas_dien\u0101m_diena_dienas".split("_"),
          M: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
          MM: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
          y: "gada_gadiem_gads_gadi".split("_"),
          yy: "gada_gadiem_gads_gadi".split("_"),
        };
        function n(e, t, n) {
          return n ? (t % 10 == 1 && t % 100 != 11 ? e[2] : e[3]) : t % 10 == 1 && t % 100 != 11 ? e[0] : e[1];
        }
        function s(e, s, r) {
          return e + " " + n(t[r], e, s);
        }
        function r(e, s, r) {
          return n(t[r], e, s);
        }
        e.defineLocale("lv", {
          months:
            "janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split(
              "_"
            ),
          monthsShort: "jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split("_"),
          weekdays: "sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),
          weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
          weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY.",
            LL: "YYYY. [gada] D. MMMM",
            LLL: "YYYY. [gada] D. MMMM, HH:mm",
            LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm",
          },
          calendar: {
            sameDay: "[\u0160odien pulksten] LT",
            nextDay: "[R\u012bt pulksten] LT",
            nextWeek: "dddd [pulksten] LT",
            lastDay: "[Vakar pulksten] LT",
            lastWeek: "[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "p\u0113c %s",
            past: "pirms %s",
            s: function (e, t) {
              return t ? "da\u017eas sekundes" : "da\u017e\u0101m sekund\u0113m";
            },
            ss: s,
            m: r,
            mm: s,
            h: r,
            hh: s,
            d: r,
            dd: s,
            M: r,
            MM: s,
            y: r,
            yy: s,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    YcFX: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("da", {
          months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
          monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
          weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
          weekdaysShort: "s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),
          weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm",
          },
          calendar: {
            sameDay: "[i dag kl.] LT",
            nextDay: "[i morgen kl.] LT",
            nextWeek: "p\xe5 dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: "[i] dddd[s kl.] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "f\xe5 sekunder",
            ss: "%d sekunder",
            m: "et minut",
            mm: "%d minutter",
            h: "en time",
            hh: "%d timer",
            d: "en dag",
            dd: "%d dage",
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "et \xe5r",
            yy: "%d \xe5r",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    ZNZT: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ko", {
          months:
            "1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split(
              "_"
            ),
          monthsShort:
            "1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split(
              "_"
            ),
          weekdays:
            "\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split(
              "_"
            ),
          weekdaysShort: "\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),
          weekdaysMin: "\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),
          longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY\ub144 MMMM D\uc77c",
            LLL: "YYYY\ub144 MMMM D\uc77c A h:mm",
            LLLL: "YYYY\ub144 MMMM D\uc77c dddd A h:mm",
            l: "YYYY.MM.DD.",
            ll: "YYYY\ub144 MMMM D\uc77c",
            lll: "YYYY\ub144 MMMM D\uc77c A h:mm",
            llll: "YYYY\ub144 MMMM D\uc77c dddd A h:mm",
          },
          calendar: {
            sameDay: "\uc624\ub298 LT",
            nextDay: "\ub0b4\uc77c LT",
            nextWeek: "dddd LT",
            lastDay: "\uc5b4\uc81c LT",
            lastWeek: "\uc9c0\ub09c\uc8fc dddd LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \ud6c4",
            past: "%s \uc804",
            s: "\uba87 \ucd08",
            ss: "%d\ucd08",
            m: "1\ubd84",
            mm: "%d\ubd84",
            h: "\ud55c \uc2dc\uac04",
            hh: "%d\uc2dc\uac04",
            d: "\ud558\ub8e8",
            dd: "%d\uc77c",
            M: "\ud55c \ub2ec",
            MM: "%d\ub2ec",
            y: "\uc77c \ub144",
            yy: "%d\ub144",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + "\uc77c";
              case "M":
                return e + "\uc6d4";
              case "w":
              case "W":
                return e + "\uc8fc";
              default:
                return e;
            }
          },
          meridiemParse: /\uc624\uc804|\uc624\ud6c4/,
          isPM: function (e) {
            return "\uc624\ud6c4" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\uc624\uc804" : "\uc624\ud6c4";
          },
        });
      })(n("wgY5"));
    },
    ZOjb: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            s: ["m\xf5ne sekundi", "m\xf5ni sekund", "paar sekundit"],
            ss: [e + "sekundi", e + "sekundit"],
            m: ["\xfche minuti", "\xfcks minut"],
            mm: [e + " minuti", e + " minutit"],
            h: ["\xfche tunni", "tund aega", "\xfcks tund"],
            hh: [e + " tunni", e + " tundi"],
            d: ["\xfche p\xe4eva", "\xfcks p\xe4ev"],
            M: ["kuu aja", "kuu aega", "\xfcks kuu"],
            MM: [e + " kuu", e + " kuud"],
            y: ["\xfche aasta", "aasta", "\xfcks aasta"],
            yy: [e + " aasta", e + " aastat"],
          };
          return t ? (r[n][2] ? r[n][2] : r[n][1]) : s ? r[n][0] : r[n][1];
        }
        e.defineLocale("et", {
          months: "jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split(
            "_"
          ),
          monthsShort: "jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
          weekdays: "p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),
          weekdaysShort: "P_E_T_K_N_R_L".split("_"),
          weekdaysMin: "P_E_T_K_N_R_L".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[T\xe4na,] LT",
            nextDay: "[Homme,] LT",
            nextWeek: "[J\xe4rgmine] dddd LT",
            lastDay: "[Eile,] LT",
            lastWeek: "[Eelmine] dddd LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s p\xe4rast",
            past: "%s tagasi",
            s: t,
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: t,
            dd: "%d p\xe4eva",
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    ZVVJ: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          1: "-inci",
          5: "-inci",
          8: "-inci",
          70: "-inci",
          80: "-inci",
          2: "-nci",
          7: "-nci",
          20: "-nci",
          50: "-nci",
          3: "-\xfcnc\xfc",
          4: "-\xfcnc\xfc",
          100: "-\xfcnc\xfc",
          6: "-nc\u0131",
          9: "-uncu",
          10: "-uncu",
          30: "-uncu",
          60: "-\u0131nc\u0131",
          90: "-\u0131nc\u0131",
        };
        e.defineLocale("az", {
          months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),
          monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
          weekdays:
            "Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split(
              "_"
            ),
          weekdaysShort: "Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),
          weekdaysMin: "Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[sabah saat] LT",
            nextWeek: "[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",
            lastDay: "[d\xfcn\u0259n] LT",
            lastWeek: "[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s sonra",
            past: "%s \u0259vv\u0259l",
            s: "bir ne\xe7\u0259 saniy\u0259",
            ss: "%d saniy\u0259",
            m: "bir d\u0259qiq\u0259",
            mm: "%d d\u0259qiq\u0259",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir ay",
            MM: "%d ay",
            y: "bir il",
            yy: "%d il",
          },
          meridiemParse: /gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,
          isPM: function (e) {
            return /^(g\xfcnd\xfcz|ax\u015fam)$/.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 4 ? "gec\u0259" : e < 12 ? "s\u0259h\u0259r" : e < 17 ? "g\xfcnd\xfcz" : "ax\u015fam";
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,
          ordinal: function (e) {
            if (0 === e) return e + "-\u0131nc\u0131";
            var n = e % 10;
            return e + (t[n] || t[(e % 100) - n] || t[e >= 100 ? 100 : null]);
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    ZyTy: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-ca", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "YYYY-MM-DD",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
        });
      })(n("wgY5"));
    },
    aIF2: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u09e7",
            2: "\u09e8",
            3: "\u09e9",
            4: "\u09ea",
            5: "\u09eb",
            6: "\u09ec",
            7: "\u09ed",
            8: "\u09ee",
            9: "\u09ef",
            0: "\u09e6",
          },
          n = {
            "\u09e7": "1",
            "\u09e8": "2",
            "\u09e9": "3",
            "\u09ea": "4",
            "\u09eb": "5",
            "\u09ec": "6",
            "\u09ed": "7",
            "\u09ee": "8",
            "\u09ef": "9",
            "\u09e6": "0",
          };
        e.defineLocale("bn", {
          months:
            "\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split(
              "_"
            ),
          monthsShort:
            "\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split(
              "_"
            ),
          weekdays:
            "\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split(
              "_"
            ),
          weekdaysShort:
            "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
              "_"
            ),
          weekdaysMin:
            "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
              "_"
            ),
          longDateFormat: {
            LT: "A h:mm \u09b8\u09ae\u09df",
            LTS: "A h:mm:ss \u09b8\u09ae\u09df",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
          },
          calendar: {
            sameDay: "[\u0986\u099c] LT",
            nextDay: "[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0997\u09a4\u0995\u09be\u09b2] LT",
            lastWeek: "[\u0997\u09a4] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u09aa\u09b0\u09c7",
            past: "%s \u0986\u0997\u09c7",
            s: "\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            ss: "%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            m: "\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",
            mm: "%d \u09ae\u09bf\u09a8\u09bf\u099f",
            h: "\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",
            hh: "%d \u0998\u09a8\u09cd\u099f\u09be",
            d: "\u098f\u0995 \u09a6\u09bf\u09a8",
            dd: "%d \u09a6\u09bf\u09a8",
            M: "\u098f\u0995 \u09ae\u09be\u09b8",
            MM: "%d \u09ae\u09be\u09b8",
            y: "\u098f\u0995 \u09ac\u099b\u09b0",
            yy: "%d \u09ac\u099b\u09b0",
          },
          preparse: function (e) {
            return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              ("\u09b0\u09be\u09a4" === t && e >= 4) ||
              ("\u09a6\u09c1\u09aa\u09c1\u09b0" === t && e < 5) ||
              "\u09ac\u09bf\u0995\u09be\u09b2" === t
                ? e + 12
                : e
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u09b0\u09be\u09a4"
              : e < 10
              ? "\u09b8\u0995\u09be\u09b2"
              : e < 17
              ? "\u09a6\u09c1\u09aa\u09c1\u09b0"
              : e < 20
              ? "\u09ac\u09bf\u0995\u09be\u09b2"
              : "\u09b0\u09be\u09a4";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    aYSr: function (e, t) {
      e.exports = function (e) {
        return (
          e.webpackPolyfill ||
            ((e.deprecate = function () {}),
            (e.paths = []),
            e.children || (e.children = []),
            Object.defineProperty(e, "loaded", {
              enumerable: !0,
              get: function () {
                return e.l;
              },
            }),
            Object.defineProperty(e, "id", {
              enumerable: !0,
              get: function () {
                return e.i;
              },
            }),
            (e.webpackPolyfill = 1)),
          e
        );
      };
    },
    baBi: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          var s = " ";
          return (
            (e % 100 >= 20 || (e >= 100 && e % 100 == 0)) && (s = " de "),
            e +
              s +
              {
                ss: "secunde",
                mm: "minute",
                hh: "ore",
                dd: "zile",
                ww: "s\u0103pt\u0103m\xe2ni",
                MM: "luni",
                yy: "ani",
              }[n]
          );
        }
        e.defineLocale("ro", {
          months:
            "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split(
              "_"
            ),
          monthsShort: "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),
          weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),
          weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[azi la] LT",
            nextDay: "[m\xe2ine la] LT",
            nextWeek: "dddd [la] LT",
            lastDay: "[ieri la] LT",
            lastWeek: "[fosta] dddd [la] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "peste %s",
            past: "%s \xeen urm\u0103",
            s: "c\xe2teva secunde",
            ss: t,
            m: "un minut",
            mm: t,
            h: "o or\u0103",
            hh: t,
            d: "o zi",
            dd: t,
            w: "o s\u0103pt\u0103m\xe2n\u0103",
            ww: t,
            M: "o lun\u0103",
            MM: t,
            y: "un an",
            yy: t,
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    bjMe: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("zh-cn", {
          months:
            "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
              "_"
            ),
          monthsShort:
            "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
              "_"
            ),
          weekdays:
            "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
              "_"
            ),
          weekdaysShort:
            "\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split("_"),
          weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",
            LLLL: "YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",
            l: "YYYY/M/D",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
          },
          meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u51cc\u6668" === t || "\u65e9\u4e0a" === t || "\u4e0a\u5348" === t
                ? e
                : "\u4e0b\u5348" === t || "\u665a\u4e0a" === t
                ? e + 12
                : e >= 11
                ? e
                : e + 12
            );
          },
          meridiem: function (e, t, n) {
            var s = 100 * e + t;
            return s < 600
              ? "\u51cc\u6668"
              : s < 900
              ? "\u65e9\u4e0a"
              : s < 1130
              ? "\u4e0a\u5348"
              : s < 1230
              ? "\u4e2d\u5348"
              : s < 1800
              ? "\u4e0b\u5348"
              : "\u665a\u4e0a";
          },
          calendar: {
            sameDay: "[\u4eca\u5929]LT",
            nextDay: "[\u660e\u5929]LT",
            nextWeek: function (e) {
              return e.week() !== this.week() ? "[\u4e0b]dddLT" : "[\u672c]dddLT";
            },
            lastDay: "[\u6628\u5929]LT",
            lastWeek: function (e) {
              return this.week() !== e.week() ? "[\u4e0a]dddLT" : "[\u672c]dddLT";
            },
            sameElse: "L",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u5468)/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + "\u65e5";
              case "M":
                return e + "\u6708";
              case "w":
              case "W":
                return e + "\u5468";
              default:
                return e;
            }
          },
          relativeTime: {
            future: "%s\u540e",
            past: "%s\u524d",
            s: "\u51e0\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u949f",
            mm: "%d \u5206\u949f",
            h: "1 \u5c0f\u65f6",
            hh: "%d \u5c0f\u65f6",
            d: "1 \u5929",
            dd: "%d \u5929",
            w: "1 \u5468",
            ww: "%d \u5468",
            M: "1 \u4e2a\u6708",
            MM: "%d \u4e2a\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74",
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    cWLW: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");
        function n(e, n, s, r) {
          var i = (function (e) {
            var n = Math.floor((e % 1e3) / 100),
              s = Math.floor((e % 100) / 10),
              r = e % 10,
              i = "";
            return (
              n > 0 && (i += t[n] + "vatlh"),
              s > 0 && (i += ("" !== i ? " " : "") + t[s] + "maH"),
              r > 0 && (i += ("" !== i ? " " : "") + t[r]),
              "" === i ? "pagh" : i
            );
          })(e);
          switch (s) {
            case "ss":
              return i + " lup";
            case "mm":
              return i + " tup";
            case "hh":
              return i + " rep";
            case "dd":
              return i + " jaj";
            case "MM":
              return i + " jar";
            case "yy":
              return i + " DIS";
          }
        }
        e.defineLocale("tlh", {
          months:
            "tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split(
              "_"
            ),
          monthsShort:
            "jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
          weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
          weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[DaHjaj] LT",
            nextDay: "[wa\u2019leS] LT",
            nextWeek: "LLL",
            lastDay: "[wa\u2019Hu\u2019] LT",
            lastWeek: "LLL",
            sameElse: "L",
          },
          relativeTime: {
            future: function (e) {
              var t = e;
              return -1 !== e.indexOf("jaj")
                ? t.slice(0, -3) + "leS"
                : -1 !== e.indexOf("jar")
                ? t.slice(0, -3) + "waQ"
                : -1 !== e.indexOf("DIS")
                ? t.slice(0, -3) + "nem"
                : t + " pIq";
            },
            past: function (e) {
              var t = e;
              return -1 !== e.indexOf("jaj")
                ? t.slice(0, -3) + "Hu\u2019"
                : -1 !== e.indexOf("jar")
                ? t.slice(0, -3) + "wen"
                : -1 !== e.indexOf("DIS")
                ? t.slice(0, -3) + "ben"
                : t + " ret";
            },
            s: "puS lup",
            ss: n,
            m: "wa\u2019 tup",
            mm: n,
            h: "wa\u2019 rep",
            hh: n,
            d: "wa\u2019 jaj",
            dd: n,
            M: "wa\u2019 jar",
            MM: n,
            y: "wa\u2019 DIS",
            yy: n,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    d3TR: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          words: {
            ss: ["sekund", "sekunda", "sekundi"],
            m: ["jedan minut", "jednog minuta"],
            mm: ["minut", "minuta", "minuta"],
            h: ["jedan sat", "jednog sata"],
            hh: ["sat", "sata", "sati"],
            dd: ["dan", "dana", "dana"],
            MM: ["mjesec", "mjeseca", "mjeseci"],
            yy: ["godina", "godine", "godina"],
          },
          correctGrammaticalCase: function (e, t) {
            return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
          },
          translate: function (e, n, s) {
            var r = t.words[s];
            return 1 === s.length ? (n ? r[0] : r[1]) : e + " " + t.correctGrammaticalCase(e, r);
          },
        };
        e.defineLocale("me", {
          months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
          monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),
          weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
          weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sjutra u] LT",
            nextWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[u] [nedjelju] [u] LT";
                case 3:
                  return "[u] [srijedu] [u] LT";
                case 6:
                  return "[u] [subotu] [u] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[u] dddd [u] LT";
              }
            },
            lastDay: "[ju\u010de u] LT",
            lastWeek: function () {
              return [
                "[pro\u0161le] [nedjelje] [u] LT",
                "[pro\u0161log] [ponedjeljka] [u] LT",
                "[pro\u0161log] [utorka] [u] LT",
                "[pro\u0161le] [srijede] [u] LT",
                "[pro\u0161log] [\u010detvrtka] [u] LT",
                "[pro\u0161log] [petka] [u] LT",
                "[pro\u0161le] [subote] [u] LT",
              ][this.day()];
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "nekoliko sekundi",
            ss: t.translate,
            m: t.translate,
            mm: t.translate,
            h: t.translate,
            hh: t.translate,
            d: "dan",
            dd: t.translate,
            M: "mjesec",
            MM: t.translate,
            y: "godinu",
            yy: t.translate,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    d5Hy: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ms", {
          months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
          monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
          weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
          weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
          weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
          },
          meridiemParse: /pagi|tengahari|petang|malam/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "pagi" === t
                ? e
                : "tengahari" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "petang" === t || "malam" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
          },
          calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Esok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kelmarin pukul] LT",
            lastWeek: "dddd [lepas pukul] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dalam %s",
            past: "%s yang lepas",
            s: "beberapa saat",
            ss: "%d saat",
            m: "seminit",
            mm: "%d minit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun",
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    dw3T: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0be7",
            2: "\u0be8",
            3: "\u0be9",
            4: "\u0bea",
            5: "\u0beb",
            6: "\u0bec",
            7: "\u0bed",
            8: "\u0bee",
            9: "\u0bef",
            0: "\u0be6",
          },
          n = {
            "\u0be7": "1",
            "\u0be8": "2",
            "\u0be9": "3",
            "\u0bea": "4",
            "\u0beb": "5",
            "\u0bec": "6",
            "\u0bed": "7",
            "\u0bee": "8",
            "\u0bef": "9",
            "\u0be6": "0",
          };
        e.defineLocale("ta", {
          months:
            "\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split(
              "_"
            ),
          monthsShort:
            "\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split(
              "_"
            ),
          weekdays:
            "\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split(
              "_"
            ),
          weekdaysShort:
            "\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split(
              "_"
            ),
          weekdaysMin: "\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split(
            "_"
          ),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, HH:mm",
            LLLL: "dddd, D MMMM YYYY, HH:mm",
          },
          calendar: {
            sameDay: "[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",
            nextDay: "[\u0ba8\u0bbe\u0bb3\u0bc8] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",
            lastWeek: "[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0b87\u0bb2\u0bcd",
            past: "%s \u0bae\u0bc1\u0ba9\u0bcd",
            s: "\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
            ss: "%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
            m: "\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",
            mm: "%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
            h: "\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
            hh: "%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
            d: "\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",
            dd: "%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",
            M: "\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",
            MM: "%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
            y: "\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",
            yy: "%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\u0bb5\u0ba4\u0bc1/,
          ordinal: function (e) {
            return e + "\u0bb5\u0ba4\u0bc1";
          },
          preparse: function (e) {
            return e.replace(/[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,
          meridiem: function (e, t, n) {
            return e < 2
              ? " \u0baf\u0bbe\u0bae\u0bae\u0bcd"
              : e < 6
              ? " \u0bb5\u0bc8\u0b95\u0bb1\u0bc8"
              : e < 10
              ? " \u0b95\u0bbe\u0bb2\u0bc8"
              : e < 14
              ? " \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd"
              : e < 18
              ? " \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1"
              : e < 22
              ? " \u0bae\u0bbe\u0bb2\u0bc8"
              : " \u0baf\u0bbe\u0bae\u0bae\u0bcd";
          },
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0baf\u0bbe\u0bae\u0bae\u0bcd" === t
                ? e < 2
                  ? e
                  : e + 12
                : "\u0bb5\u0bc8\u0b95\u0bb1\u0bc8" === t ||
                  "\u0b95\u0bbe\u0bb2\u0bc8" === t ||
                  ("\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd" === t && e >= 10)
                ? e
                : e + 12
            );
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    e9KM: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = [
            "\u062c\u0646\u0648\u0631\u064a",
            "\u0641\u064a\u0628\u0631\u0648\u0631\u064a",
            "\u0645\u0627\u0631\u0686",
            "\u0627\u067e\u0631\u064a\u0644",
            "\u0645\u0626\u064a",
            "\u062c\u0648\u0646",
            "\u062c\u0648\u0644\u0627\u0621\u0650",
            "\u0622\u06af\u0633\u067d",
            "\u0633\u064a\u067e\u067d\u0645\u0628\u0631",
            "\u0622\u06aa\u067d\u0648\u0628\u0631",
            "\u0646\u0648\u0645\u0628\u0631",
            "\u068a\u0633\u0645\u0628\u0631",
          ],
          n = [
            "\u0622\u0686\u0631",
            "\u0633\u0648\u0645\u0631",
            "\u0627\u06b1\u0627\u0631\u0648",
            "\u0627\u0631\u0628\u0639",
            "\u062e\u0645\u064a\u0633",
            "\u062c\u0645\u0639",
            "\u0687\u0646\u0687\u0631",
          ];
        e.defineLocale("sd", {
          months: t,
          monthsShort: t,
          weekdays: n,
          weekdaysShort: n,
          weekdaysMin: n,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd\u060c D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0635\u0628\u062d|\u0634\u0627\u0645/,
          isPM: function (e) {
            return "\u0634\u0627\u0645" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0635\u0628\u062d" : "\u0634\u0627\u0645";
          },
          calendar: {
            sameDay: "[\u0627\u0684] LT",
            nextDay: "[\u0633\u0680\u0627\u06bb\u064a] LT",
            nextWeek: "dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",
            lastDay: "[\u06aa\u0627\u0644\u0647\u0647] LT",
            lastWeek: "[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u067e\u0648\u0621",
            past: "%s \u0627\u06b3",
            s: "\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",
            ss: "%d \u0633\u064a\u06aa\u0646\u068a",
            m: "\u0647\u06aa \u0645\u0646\u067d",
            mm: "%d \u0645\u0646\u067d",
            h: "\u0647\u06aa \u06aa\u0644\u0627\u06aa",
            hh: "%d \u06aa\u0644\u0627\u06aa",
            d: "\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",
            dd: "%d \u068f\u064a\u0646\u0647\u0646",
            M: "\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",
            MM: "%d \u0645\u0647\u064a\u0646\u0627",
            y: "\u0647\u06aa \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644",
          },
          preparse: function (e) {
            return e.replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e.replace(/,/g, "\u060c");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    ecsu: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          return "m" === n
            ? t
              ? "\u043c\u0438\u043d\u0443\u0442\u0430"
              : "\u043c\u0438\u043d\u0443\u0442\u0443"
            : e +
                " " +
                ((s = +e),
                (r = {
                  ss: t
                    ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434"
                    : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",
                  mm: t
                    ? "\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442"
                    : "\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",
                  hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",
                  dd: "\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",
                  ww: "\u043d\u0435\u0434\u0435\u043b\u044f_\u043d\u0435\u0434\u0435\u043b\u0438_\u043d\u0435\u0434\u0435\u043b\u044c",
                  MM: "\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",
                  yy: "\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442",
                }[n].split("_")),
                s % 10 == 1 && s % 100 != 11
                  ? r[0]
                  : s % 10 >= 2 && s % 10 <= 4 && (s % 100 < 10 || s % 100 >= 20)
                  ? r[1]
                  : r[2]);
          var s, r;
        }
        var n = [
          /^\u044f\u043d\u0432/i,
          /^\u0444\u0435\u0432/i,
          /^\u043c\u0430\u0440/i,
          /^\u0430\u043f\u0440/i,
          /^\u043c\u0430[\u0439\u044f]/i,
          /^\u0438\u044e\u043d/i,
          /^\u0438\u044e\u043b/i,
          /^\u0430\u0432\u0433/i,
          /^\u0441\u0435\u043d/i,
          /^\u043e\u043a\u0442/i,
          /^\u043d\u043e\u044f/i,
          /^\u0434\u0435\u043a/i,
        ];
        e.defineLocale("ru", {
          months: {
            format:
              "\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split(
                "_"
              ),
            standalone:
              "\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split(
                "_"
              ),
          },
          monthsShort: {
            format:
              "\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split(
                "_"
              ),
            standalone:
              "\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split(
                "_"
              ),
          },
          weekdays: {
            standalone:
              "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split(
                "_"
              ),
            format:
              "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split(
                "_"
              ),
            isFormat:
              /\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?] ?dddd/,
          },
          weekdaysShort:
            "\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
          weekdaysMin:
            "\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
          monthsParse: n,
          longMonthsParse: n,
          shortMonthsParse: n,
          monthsRegex:
            /^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,
          monthsShortRegex:
            /^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,
          monthsStrictRegex:
            /^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,
          monthsShortStrictRegex:
            /^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm",
          },
          calendar: {
            sameDay: "[\u0421\u0435\u0433\u043e\u0434\u043d\u044f, \u0432] LT",
            nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
            nextWeek: function (e) {
              if (e.week() === this.week())
                return 2 === this.day() ? "[\u0412\u043e] dddd, [\u0432] LT" : "[\u0412] dddd, [\u0432] LT";
              switch (this.day()) {
                case 0:
                  return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd, [\u0432] LT";
                case 1:
                case 2:
                case 4:
                  return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd, [\u0432] LT";
                case 3:
                case 5:
                case 6:
                  return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd, [\u0432] LT";
              }
            },
            lastWeek: function (e) {
              if (e.week() === this.week())
                return 2 === this.day() ? "[\u0412\u043e] dddd, [\u0432] LT" : "[\u0412] dddd, [\u0432] LT";
              switch (this.day()) {
                case 0:
                  return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd, [\u0432] LT";
                case 1:
                case 2:
                case 4:
                  return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd, [\u0432] LT";
                case 3:
                case 5:
                case 6:
                  return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd, [\u0432] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043d\u0430\u0437\u0430\u0434",
            s: "\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: t,
            m: t,
            mm: t,
            h: "\u0447\u0430\u0441",
            hh: t,
            d: "\u0434\u0435\u043d\u044c",
            dd: t,
            w: "\u043d\u0435\u0434\u0435\u043b\u044f",
            ww: t,
            M: "\u043c\u0435\u0441\u044f\u0446",
            MM: t,
            y: "\u0433\u043e\u0434",
            yy: t,
          },
          meridiemParse:
            /\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,
          isPM: function (e) {
            return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u043d\u043e\u0447\u0438"
              : e < 12
              ? "\u0443\u0442\u0440\u0430"
              : e < 17
              ? "\u0434\u043d\u044f"
              : "\u0432\u0435\u0447\u0435\u0440\u0430";
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,
          ordinal: function (e, t) {
            switch (t) {
              case "M":
              case "d":
              case "DDD":
                return e + "-\u0439";
              case "D":
                return e + "-\u0433\u043e";
              case "w":
              case "W":
                return e + "-\u044f";
              default:
                return e;
            }
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    ejL1: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ml", {
          months:
            "\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split(
              "_"
            ),
          monthsShort:
            "\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split(
              "_"
            ),
          weekdaysShort:
            "\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split(
              "_"
            ),
          weekdaysMin:
            "\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split(
              "_"
            ),
          longDateFormat: {
            LT: "A h:mm -\u0d28\u0d41",
            LTS: "A h:mm:ss -\u0d28\u0d41",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm -\u0d28\u0d41",
            LLLL: "dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41",
          },
          calendar: {
            sameDay: "[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",
            nextDay: "[\u0d28\u0d3e\u0d33\u0d46] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",
            lastWeek: "[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",
            past: "%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",
            s: "\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",
            ss: "%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",
            m: "\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",
            mm: "%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",
            h: "\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",
            hh: "%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",
            d: "\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",
            dd: "%d \u0d26\u0d3f\u0d35\u0d38\u0d02",
            M: "\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",
            MM: "%d \u0d2e\u0d3e\u0d38\u0d02",
            y: "\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",
            yy: "%d \u0d35\u0d7c\u0d37\u0d02",
          },
          meridiemParse:
            /\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              ("\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f" === t && e >= 4) ||
              "\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d" === t ||
              "\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02" === t
                ? e + 12
                : e
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"
              : e < 12
              ? "\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46"
              : e < 17
              ? "\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d"
              : e < 20
              ? "\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02"
              : "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f";
          },
        });
      })(n("wgY5"));
    },
    exaB: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-gb", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    fN8o: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            s: ["viensas secunds", "'iensas secunds"],
            ss: [e + " secunds", e + " secunds"],
            m: ["'n m\xedut", "'iens m\xedut"],
            mm: [e + " m\xeduts", e + " m\xeduts"],
            h: ["'n \xfeora", "'iensa \xfeora"],
            hh: [e + " \xfeoras", e + " \xfeoras"],
            d: ["'n ziua", "'iensa ziua"],
            dd: [e + " ziuas", e + " ziuas"],
            M: ["'n mes", "'iens mes"],
            MM: [e + " mesen", e + " mesen"],
            y: ["'n ar", "'iens ar"],
            yy: [e + " ars", e + " ars"],
          };
          return s || t ? r[n][0] : r[n][1];
        }
        e.defineLocale("tzl", {
          months:
            "Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split(
              "_"
            ),
          monthsShort: "Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
          weekdays: "S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),
          weekdaysShort: "S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),
          weekdaysMin: "S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM [dallas] YYYY",
            LLL: "D. MMMM [dallas] YYYY HH.mm",
            LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm",
          },
          meridiemParse: /d\'o|d\'a/i,
          isPM: function (e) {
            return "d'o" === e.toLowerCase();
          },
          meridiem: function (e, t, n) {
            return e > 11 ? (n ? "d'o" : "D'O") : n ? "d'a" : "D'A";
          },
          calendar: {
            sameDay: "[oxhi \xe0] LT",
            nextDay: "[dem\xe0 \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[ieiri \xe0] LT",
            lastWeek: "[s\xfcr el] dddd [lasteu \xe0] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "osprei %s",
            past: "ja%s",
            s: t,
            ss: t,
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: t,
            dd: t,
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    fY0S: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0ae7",
            2: "\u0ae8",
            3: "\u0ae9",
            4: "\u0aea",
            5: "\u0aeb",
            6: "\u0aec",
            7: "\u0aed",
            8: "\u0aee",
            9: "\u0aef",
            0: "\u0ae6",
          },
          n = {
            "\u0ae7": "1",
            "\u0ae8": "2",
            "\u0ae9": "3",
            "\u0aea": "4",
            "\u0aeb": "5",
            "\u0aec": "6",
            "\u0aed": "7",
            "\u0aee": "8",
            "\u0aef": "9",
            "\u0ae6": "0",
          };
        e.defineLocale("gu", {
          months:
            "\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split(
              "_"
            ),
          monthsShort:
            "\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split(
              "_"
            ),
          weekdaysShort:
            "\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split(
              "_"
            ),
          weekdaysMin: "\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split("_"),
          longDateFormat: {
            LT: "A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
            LTS: "A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
          },
          calendar: {
            sameDay: "[\u0a86\u0a9c] LT",
            nextDay: "[\u0a95\u0abe\u0ab2\u0ac7] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",
            lastWeek: "[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0aae\u0abe",
            past: "%s \u0aaa\u0ab9\u0ac7\u0ab2\u0abe",
            s: "\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",
            ss: "%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",
            m: "\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",
            mm: "%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",
            h: "\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",
            hh: "%d \u0a95\u0ab2\u0abe\u0a95",
            d: "\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",
            dd: "%d \u0aa6\u0abf\u0ab5\u0ab8",
            M: "\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",
            MM: "%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",
            y: "\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",
            yy: "%d \u0ab5\u0ab0\u0acd\u0ab7",
          },
          preparse: function (e) {
            return e.replace(/[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0ab0\u0abe\u0aa4" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0ab8\u0ab5\u0abe\u0ab0" === t
                ? e
                : "\u0aac\u0aaa\u0acb\u0ab0" === t
                ? e >= 10
                  ? e
                  : e + 12
                : "\u0ab8\u0abe\u0a82\u0a9c" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0ab0\u0abe\u0aa4"
              : e < 10
              ? "\u0ab8\u0ab5\u0abe\u0ab0"
              : e < 17
              ? "\u0aac\u0aaa\u0acb\u0ab0"
              : e < 20
              ? "\u0ab8\u0abe\u0a82\u0a9c"
              : "\u0ab0\u0abe\u0aa4";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    ffVN: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("mk", {
          months:
            "\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split(
              "_"
            ),
          monthsShort:
            "\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split(
              "_"
            ),
          weekdays:
            "\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split(
              "_"
            ),
          weekdaysShort:
            "\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split(
              "_"
            ),
          weekdaysMin: "\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split("_"),
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm",
          },
          calendar: {
            sameDay: "[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",
            nextWeek: "[\u0412\u043e] dddd [\u0432\u043e] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                case 3:
                case 6:
                  return "[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";
                case 1:
                case 2:
                case 4:
                case 5:
                  return "[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043f\u0440\u0435\u0434 %s",
            s: "\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            m: "\u0435\u0434\u043d\u0430 \u043c\u0438\u043d\u0443\u0442\u0430",
            mm: "%d \u043c\u0438\u043d\u0443\u0442\u0438",
            h: "\u0435\u0434\u0435\u043d \u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0435\u0434\u0435\u043d \u0434\u0435\u043d",
            dd: "%d \u0434\u0435\u043d\u0430",
            M: "\u0435\u0434\u0435\u043d \u043c\u0435\u0441\u0435\u0446",
            MM: "%d \u043c\u0435\u0441\u0435\u0446\u0438",
            y: "\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430",
            yy: "%d \u0433\u043e\u0434\u0438\u043d\u0438",
          },
          dayOfMonthOrdinalParse:
            /\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,
          ordinal: function (e) {
            var t = e % 10,
              n = e % 100;
            return 0 === e
              ? e + "-\u0435\u0432"
              : 0 === n
              ? e + "-\u0435\u043d"
              : n > 10 && n < 20
              ? e + "-\u0442\u0438"
              : 1 === t
              ? e + "-\u0432\u0438"
              : 2 === t
              ? e + "-\u0440\u0438"
              : 7 === t || 8 === t
              ? e + "-\u043c\u0438"
              : e + "-\u0442\u0438";
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    foQf: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("it-ch", {
          months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
            "_"
          ),
          monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
          weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
          weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
          weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Oggi alle] LT",
            nextDay: "[Domani alle] LT",
            nextWeek: "dddd [alle] LT",
            lastDay: "[Ieri alle] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[la scorsa] dddd [alle] LT";
                default:
                  return "[lo scorso] dddd [alle] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: function (e) {
              return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
            },
            past: "%s fa",
            s: "alcuni secondi",
            ss: "%d secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    gnIm: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("lo", {
          months:
            "\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split(
              "_"
            ),
          monthsShort:
            "\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split(
              "_"
            ),
          weekdays:
            "\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split(
              "_"
            ),
          weekdaysShort:
            "\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split(
              "_"
            ),
          weekdaysMin: "\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,
          isPM: function (e) {
            return "\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2" : "\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87";
          },
          calendar: {
            sameDay: "[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            nextDay: "[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            nextWeek: "[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            lastDay: "[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            lastWeek: "[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0ead\u0eb5\u0e81 %s",
            past: "%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",
            s: "\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",
            ss: "%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",
            m: "1 \u0e99\u0eb2\u0e97\u0eb5",
            mm: "%d \u0e99\u0eb2\u0e97\u0eb5",
            h: "1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",
            hh: "%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",
            d: "1 \u0ea1\u0eb7\u0ec9",
            dd: "%d \u0ea1\u0eb7\u0ec9",
            M: "1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",
            MM: "%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",
            y: "1 \u0e9b\u0eb5",
            yy: "%d \u0e9b\u0eb5",
          },
          dayOfMonthOrdinalParse: /(\u0e97\u0eb5\u0ec8)\d{1,2}/,
          ordinal: function (e) {
            return "\u0e97\u0eb5\u0ec8" + e;
          },
        });
      })(n("wgY5"));
    },
    "h+U8": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("nb", {
          months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
          monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
          monthsParseExact: !0,
          weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
          weekdaysShort: "s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),
          weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D. MMMM YYYY [kl.] HH:mm",
          },
          calendar: {
            sameDay: "[i dag kl.] LT",
            nextDay: "[i morgen kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: "[forrige] dddd [kl.] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "noen sekunder",
            ss: "%d sekunder",
            m: "ett minutt",
            mm: "%d minutter",
            h: "en time",
            hh: "%d timer",
            d: "en dag",
            dd: "%d dager",
            w: "en uke",
            ww: "%d uker",
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "ett \xe5r",
            yy: "%d \xe5r",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    hH25: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ar-ma", {
          months:
            "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
              "_"
            ),
          monthsShort:
            "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
              "_"
            ),
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a",
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    hHY4: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            m: ["eine Minute", "einer Minute"],
            h: ["eine Stunde", "einer Stunde"],
            d: ["ein Tag", "einem Tag"],
            dd: [e + " Tage", e + " Tagen"],
            w: ["eine Woche", "einer Woche"],
            M: ["ein Monat", "einem Monat"],
            MM: [e + " Monate", e + " Monaten"],
            y: ["ein Jahr", "einem Jahr"],
            yy: [e + " Jahre", e + " Jahren"],
          };
          return t ? r[n][0] : r[n][1];
        }
        e.defineLocale("de-ch", {
          months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
          monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
          monthsParseExact: !0,
          weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
          weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
          weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]",
          },
          relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: t,
            mm: "%d Minuten",
            h: t,
            hh: "%d Stunden",
            d: t,
            dd: t,
            w: t,
            ww: "%d Wochen",
            M: t,
            MM: t,
            y: t,
            yy: t,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    hLzJ: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("uz", {
          months:
            "\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split(
              "_"
            ),
          monthsShort:
            "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split(
              "_"
            ),
          weekdays:
            "\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split(
              "_"
            ),
          weekdaysShort:
            "\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split(
              "_"
            ),
          weekdaysMin:
            "\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "D MMMM YYYY, dddd HH:mm",
          },
          calendar: {
            sameDay: "[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            nextDay: "[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",
            nextWeek: "dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            lastDay: "[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            lastWeek:
              "[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",
            past: "\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",
            s: "\u0444\u0443\u0440\u0441\u0430\u0442",
            ss: "%d \u0444\u0443\u0440\u0441\u0430\u0442",
            m: "\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",
            mm: "%d \u0434\u0430\u043a\u0438\u043a\u0430",
            h: "\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",
            hh: "%d \u0441\u043e\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043a\u0443\u043d",
            dd: "%d \u043a\u0443\u043d",
            M: "\u0431\u0438\u0440 \u043e\u0439",
            MM: "%d \u043e\u0439",
            y: "\u0431\u0438\u0440 \u0439\u0438\u043b",
            yy: "%d \u0439\u0438\u043b",
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    hQzt: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0ce7",
            2: "\u0ce8",
            3: "\u0ce9",
            4: "\u0cea",
            5: "\u0ceb",
            6: "\u0cec",
            7: "\u0ced",
            8: "\u0cee",
            9: "\u0cef",
            0: "\u0ce6",
          },
          n = {
            "\u0ce7": "1",
            "\u0ce8": "2",
            "\u0ce9": "3",
            "\u0cea": "4",
            "\u0ceb": "5",
            "\u0cec": "6",
            "\u0ced": "7",
            "\u0cee": "8",
            "\u0cef": "9",
            "\u0ce6": "0",
          };
        e.defineLocale("kn", {
          months:
            "\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split(
              "_"
            ),
          monthsShort:
            "\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5_\u0ca8\u0cb5\u0cc6\u0c82_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82".split(
              "_"
            ),
          monthsParseExact: !0,
          weekdays:
            "\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split(
              "_"
            ),
          weekdaysShort:
            "\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split(
              "_"
            ),
          weekdaysMin:
            "\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split(
              "_"
            ),
          longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm",
          },
          calendar: {
            sameDay: "[\u0c87\u0c82\u0ca6\u0cc1] LT",
            nextDay: "[\u0ca8\u0cbe\u0cb3\u0cc6] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",
            lastWeek: "[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0ca8\u0c82\u0ca4\u0cb0",
            past: "%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",
            s: "\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",
            ss: "%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",
            m: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",
            mm: "%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",
            h: "\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",
            hh: "%d \u0c97\u0c82\u0c9f\u0cc6",
            d: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",
            dd: "%d \u0ca6\u0cbf\u0ca8",
            M: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",
            MM: "%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",
            y: "\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",
            yy: "%d \u0cb5\u0cb0\u0ccd\u0cb7",
          },
          preparse: function (e) {
            return e.replace(/[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6" === t
                ? e
                : "\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8" === t
                ? e >= 10
                  ? e
                  : e + 12
                : "\u0cb8\u0c82\u0c9c\u0cc6" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"
              : e < 10
              ? "\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6"
              : e < 17
              ? "\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8"
              : e < 20
              ? "\u0cb8\u0c82\u0c9c\u0cc6"
              : "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf";
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\u0ca8\u0cc6\u0cd5)/,
          ordinal: function (e) {
            return e + "\u0ca8\u0cc6\u0cd5";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    hTlv: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("mi", {
          months:
            "Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split(
              "_"
            ),
          monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),
          monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
          monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
          monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
          monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
          weekdays: "R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),
          weekdaysShort: "Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),
          weekdaysMin: "Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [i] HH:mm",
            LLLL: "dddd, D MMMM YYYY [i] HH:mm",
          },
          calendar: {
            sameDay: "[i teie mahana, i] LT",
            nextDay: "[apopo i] LT",
            nextWeek: "dddd [i] LT",
            lastDay: "[inanahi i] LT",
            lastWeek: "dddd [whakamutunga i] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "i roto i %s",
            past: "%s i mua",
            s: "te h\u0113kona ruarua",
            ss: "%d h\u0113kona",
            m: "he meneti",
            mm: "%d meneti",
            h: "te haora",
            hh: "%d haora",
            d: "he ra",
            dd: "%d ra",
            M: "he marama",
            MM: "%d marama",
            y: "he tau",
            yy: "%d tau",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    iDxo: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-nz", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    iNiw: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          0: "-\u0448\u0456",
          1: "-\u0448\u0456",
          2: "-\u0448\u0456",
          3: "-\u0448\u0456",
          4: "-\u0448\u0456",
          5: "-\u0448\u0456",
          6: "-\u0448\u044b",
          7: "-\u0448\u0456",
          8: "-\u0448\u0456",
          9: "-\u0448\u044b",
          10: "-\u0448\u044b",
          20: "-\u0448\u044b",
          30: "-\u0448\u044b",
          40: "-\u0448\u044b",
          50: "-\u0448\u0456",
          60: "-\u0448\u044b",
          70: "-\u0448\u0456",
          80: "-\u0448\u0456",
          90: "-\u0448\u044b",
          100: "-\u0448\u0456",
        };
        e.defineLocale("kk", {
          months:
            "\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split(
              "_"
            ),
          monthsShort:
            "\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split(
              "_"
            ),
          weekdays:
            "\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split(
              "_"
            ),
          weekdaysShort:
            "\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split(
              "_"
            ),
          weekdaysMin:
            "\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",
            nextDay: "[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            lastDay: "[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",
            lastWeek:
              "[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u0456\u0448\u0456\u043d\u0434\u0435",
            past: "%s \u0431\u04b1\u0440\u044b\u043d",
            s: "\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434",
            m: "\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",
            mm: "%d \u043c\u0438\u043d\u0443\u0442",
            h: "\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",
            hh: "%d \u0441\u0430\u0493\u0430\u0442",
            d: "\u0431\u0456\u0440 \u043a\u04af\u043d",
            dd: "%d \u043a\u04af\u043d",
            M: "\u0431\u0456\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0456\u0440 \u0436\u044b\u043b",
            yy: "%d \u0436\u044b\u043b",
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0448\u0456|\u0448\u044b)/,
          ordinal: function (e) {
            return e + (t[e] || t[e % 10] || t[e >= 100 ? 100 : null]);
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    iQoZ: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          return (
            e +
            " " +
            (function (e, t) {
              return 2 === t
                ? (function (e) {
                    var t = { m: "v", b: "v", d: "z" };
                    return void 0 === t[e.charAt(0)] ? e : t[e.charAt(0)] + e.substring(1);
                  })(e)
                : e;
            })({ mm: "munutenn", MM: "miz", dd: "devezh" }[n], e)
          );
        }
        var n = [
            /^gen/i,
            /^c[\u02bc\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
          ],
          s =
            /^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
          r = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];
        e.defineLocale("br", {
          months: "Genver_C\u02bchwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
          monthsShort: "Gen_C\u02bchwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
          weekdays: "Sul_Lun_Meurzh_Merc\u02bcher_Yaou_Gwener_Sadorn".split("_"),
          weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
          weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
          weekdaysParse: r,
          fullWeekdaysParse: [/^sul/i, /^lun/i, /^meurzh/i, /^merc[\u02bc\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
          shortWeekdaysParse: [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
          minWeekdaysParse: r,
          monthsRegex: s,
          monthsShortRegex: s,
          monthsStrictRegex:
            /^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
          monthsShortStrictRegex: /^(gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
          monthsParse: n,
          longMonthsParse: n,
          shortMonthsParse: n,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [a viz] MMMM YYYY",
            LLL: "D [a viz] MMMM YYYY HH:mm",
            LLLL: "dddd, D [a viz] MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Hiziv da] LT",
            nextDay: "[Warc\u02bchoazh da] LT",
            nextWeek: "dddd [da] LT",
            lastDay: "[Dec\u02bch da] LT",
            lastWeek: "dddd [paset da] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "a-benn %s",
            past: "%s \u02bczo",
            s: "un nebeud segondenno\xf9",
            ss: "%d eilenn",
            m: "ur vunutenn",
            mm: t,
            h: "un eur",
            hh: "%d eur",
            d: "un devezh",
            dd: t,
            M: "ur miz",
            MM: t,
            y: "ur bloaz",
            yy: function (e) {
              switch (
                (function e(t) {
                  return t > 9 ? e(t % 10) : t;
                })(e)
              ) {
                case 1:
                case 3:
                case 4:
                case 5:
                case 9:
                  return e + " bloaz";
                default:
                  return e + " vloaz";
              }
            },
          },
          dayOfMonthOrdinalParse: /\d{1,2}(a\xf1|vet)/,
          ordinal: function (e) {
            return e + (1 === e ? "a\xf1" : "vet");
          },
          week: { dow: 1, doy: 4 },
          meridiemParse: /a.m.|g.m./,
          isPM: function (e) {
            return "g.m." === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "a.m." : "g.m.";
          },
        });
      })(n("wgY5"));
    },
    jOnb: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ja", {
          eras: [
            { since: "2019-05-01", offset: 1, name: "\u4ee4\u548c", narrow: "\u32ff", abbr: "R" },
            { since: "1989-01-08", until: "2019-04-30", offset: 1, name: "\u5e73\u6210", narrow: "\u337b", abbr: "H" },
            { since: "1926-12-25", until: "1989-01-07", offset: 1, name: "\u662d\u548c", narrow: "\u337c", abbr: "S" },
            { since: "1912-07-30", until: "1926-12-24", offset: 1, name: "\u5927\u6b63", narrow: "\u337d", abbr: "T" },
            { since: "1873-01-01", until: "1912-07-29", offset: 6, name: "\u660e\u6cbb", narrow: "\u337e", abbr: "M" },
            { since: "0001-01-01", until: "1873-12-31", offset: 1, name: "\u897f\u66a6", narrow: "AD", abbr: "AD" },
            { since: "0000-12-31", until: -1 / 0, offset: 1, name: "\u7d00\u5143\u524d", narrow: "BC", abbr: "BC" },
          ],
          eraYearOrdinalRegex: /(\u5143|\d+)\u5e74/,
          eraYearOrdinalParse: function (e, t) {
            return "\u5143" === t[1] ? 1 : parseInt(t[1] || e, 10);
          },
          months:
            "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
              "_"
            ),
          monthsShort:
            "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
              "_"
            ),
          weekdays:
            "\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split(
              "_"
            ),
          weekdaysShort: "\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),
          weekdaysMin: "\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5 dddd HH:mm",
            l: "YYYY/MM/DD",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5(ddd) HH:mm",
          },
          meridiemParse: /\u5348\u524d|\u5348\u5f8c/i,
          isPM: function (e) {
            return "\u5348\u5f8c" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u5348\u524d" : "\u5348\u5f8c";
          },
          calendar: {
            sameDay: "[\u4eca\u65e5] LT",
            nextDay: "[\u660e\u65e5] LT",
            nextWeek: function (e) {
              return e.week() !== this.week() ? "[\u6765\u9031]dddd LT" : "dddd LT";
            },
            lastDay: "[\u6628\u65e5] LT",
            lastWeek: function (e) {
              return this.week() !== e.week() ? "[\u5148\u9031]dddd LT" : "dddd LT";
            },
            sameElse: "L",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\u65e5/,
          ordinal: function (e, t) {
            switch (t) {
              case "y":
                return 1 === e ? "\u5143\u5e74" : e + "\u5e74";
              case "d":
              case "D":
              case "DDD":
                return e + "\u65e5";
              default:
                return e;
            }
          },
          relativeTime: {
            future: "%s\u5f8c",
            past: "%s\u524d",
            s: "\u6570\u79d2",
            ss: "%d\u79d2",
            m: "1\u5206",
            mm: "%d\u5206",
            h: "1\u6642\u9593",
            hh: "%d\u6642\u9593",
            d: "1\u65e5",
            dd: "%d\u65e5",
            M: "1\u30f6\u6708",
            MM: "%d\u30f6\u6708",
            y: "1\u5e74",
            yy: "%d\u5e74",
          },
        });
      })(n("wgY5"));
    },
    jsZ8: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
          n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
          s = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
          ],
          r =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        e.defineLocale("nl", {
          months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
          monthsShort: function (e, s) {
            return e ? (/-MMM-/.test(s) ? n[e.month()] : t[e.month()]) : t;
          },
          monthsRegex: r,
          monthsShortRegex: r,
          monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
          monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
          monthsParse: s,
          longMonthsParse: s,
          shortMonthsParse: s,
          weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
          weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
          weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[vandaag om] LT",
            nextDay: "[morgen om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[gisteren om] LT",
            lastWeek: "[afgelopen] dddd [om] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            ss: "%d seconden",
            m: "\xe9\xe9n minuut",
            mm: "%d minuten",
            h: "\xe9\xe9n uur",
            hh: "%d uur",
            d: "\xe9\xe9n dag",
            dd: "%d dagen",
            w: "\xe9\xe9n week",
            ww: "%d weken",
            M: "\xe9\xe9n maand",
            MM: "%d maanden",
            y: "\xe9\xe9n jaar",
            yy: "%d jaar",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function (e) {
            return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    kFC9: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("eu", {
          months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split(
            "_"
          ),
          monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
          monthsParseExact: !0,
          weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
          weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
          weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY[ko] MMMM[ren] D[a]",
            LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
            LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
            l: "YYYY-M-D",
            ll: "YYYY[ko] MMM D[a]",
            lll: "YYYY[ko] MMM D[a] HH:mm",
            llll: "ddd, YYYY[ko] MMM D[a] HH:mm",
          },
          calendar: {
            sameDay: "[gaur] LT[etan]",
            nextDay: "[bihar] LT[etan]",
            nextWeek: "dddd LT[etan]",
            lastDay: "[atzo] LT[etan]",
            lastWeek: "[aurreko] dddd LT[etan]",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s barru",
            past: "duela %s",
            s: "segundo batzuk",
            ss: "%d segundo",
            m: "minutu bat",
            mm: "%d minutu",
            h: "ordu bat",
            hh: "%d ordu",
            d: "egun bat",
            dd: "%d egun",
            M: "hilabete bat",
            MM: "%d hilabete",
            y: "urte bat",
            yy: "%d urte",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    kQaN: function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n) {
          return "m" === n
            ? t
              ? "\u0445\u0432\u0456\u043b\u0456\u043d\u0430"
              : "\u0445\u0432\u0456\u043b\u0456\u043d\u0443"
            : "h" === n
            ? t
              ? "\u0433\u0430\u0434\u0437\u0456\u043d\u0430"
              : "\u0433\u0430\u0434\u0437\u0456\u043d\u0443"
            : e +
              " " +
              ((s = +e),
              (r = {
                ss: t
                  ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434"
                  : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",
                mm: t
                  ? "\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d"
                  : "\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",
                hh: t
                  ? "\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d"
                  : "\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",
                dd: "\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",
                MM: "\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",
                yy: "\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e",
              }[n].split("_")),
              s % 10 == 1 && s % 100 != 11
                ? r[0]
                : s % 10 >= 2 && s % 10 <= 4 && (s % 100 < 10 || s % 100 >= 20)
                ? r[1]
                : r[2]);
          var s, r;
        }
        e.defineLocale("be", {
          months: {
            format:
              "\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split(
                "_"
              ),
            standalone:
              "\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split(
                "_"
              ),
          },
          monthsShort:
            "\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split(
              "_"
            ),
          weekdays: {
            format:
              "\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split(
                "_"
              ),
            standalone:
              "\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split(
                "_"
              ),
            isFormat:
              /\[ ?[\u0423\u0443\u045e] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/,
          },
          weekdaysShort:
            "\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),
          weekdaysMin:
            "\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., HH:mm",
          },
          calendar: {
            sameDay: "[\u0421\u0451\u043d\u043d\u044f \u045e] LT",
            nextDay: "[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",
            lastDay: "[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",
            nextWeek: function () {
              return "[\u0423] dddd [\u045e] LT";
            },
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                  return "[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";
                case 1:
                case 2:
                case 4:
                  return "[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "\u043f\u0440\u0430\u0437 %s",
            past: "%s \u0442\u0430\u043c\u0443",
            s: "\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",
            m: t,
            mm: t,
            h: t,
            hh: t,
            d: "\u0434\u0437\u0435\u043d\u044c",
            dd: t,
            M: "\u043c\u0435\u0441\u044f\u0446",
            MM: t,
            y: "\u0433\u043e\u0434",
            yy: t,
          },
          meridiemParse:
            /\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,
          isPM: function (e) {
            return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(e);
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u043d\u043e\u0447\u044b"
              : e < 12
              ? "\u0440\u0430\u043d\u0456\u0446\u044b"
              : e < 17
              ? "\u0434\u043d\u044f"
              : "\u0432\u0435\u0447\u0430\u0440\u0430";
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,
          ordinal: function (e, t) {
            switch (t) {
              case "M":
              case "d":
              case "DDD":
              case "w":
              case "W":
                return (e % 10 != 2 && e % 10 != 3) || e % 100 == 12 || e % 100 == 13 ? e + "-\u044b" : e + "-\u0456";
              case "D":
                return e + "-\u0433\u0430";
              default:
                return e;
            }
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    lOtj: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("jv", {
          months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
          weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
          weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
          weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
          },
          meridiemParse: /enjing|siyang|sonten|ndalu/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "enjing" === t
                ? e
                : "siyang" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "sonten" === t || "ndalu" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 11 ? "enjing" : e < 15 ? "siyang" : e < 19 ? "sonten" : "ndalu";
          },
          calendar: {
            sameDay: "[Dinten puniko pukul] LT",
            nextDay: "[Mbenjang pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kala wingi pukul] LT",
            lastWeek: "dddd [kepengker pukul] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "wonten ing %s",
            past: "%s ingkang kepengker",
            s: "sawetawis detik",
            ss: "%d detik",
            m: "setunggal menit",
            mm: "%d menit",
            h: "setunggal jam",
            hh: "%d jam",
            d: "sedinten",
            dd: "%d dinten",
            M: "sewulan",
            MM: "%d wulan",
            y: "setaun",
            yy: "%d taun",
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    lTqY: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u09e7",
            2: "\u09e8",
            3: "\u09e9",
            4: "\u09ea",
            5: "\u09eb",
            6: "\u09ec",
            7: "\u09ed",
            8: "\u09ee",
            9: "\u09ef",
            0: "\u09e6",
          },
          n = {
            "\u09e7": "1",
            "\u09e8": "2",
            "\u09e9": "3",
            "\u09ea": "4",
            "\u09eb": "5",
            "\u09ec": "6",
            "\u09ed": "7",
            "\u09ee": "8",
            "\u09ef": "9",
            "\u09e6": "0",
          };
        e.defineLocale("bn-bd", {
          months:
            "\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split(
              "_"
            ),
          monthsShort:
            "\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split(
              "_"
            ),
          weekdays:
            "\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split(
              "_"
            ),
          weekdaysShort:
            "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
              "_"
            ),
          weekdaysMin:
            "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
              "_"
            ),
          longDateFormat: {
            LT: "A h:mm \u09b8\u09ae\u09df",
            LTS: "A h:mm:ss \u09b8\u09ae\u09df",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
          },
          calendar: {
            sameDay: "[\u0986\u099c] LT",
            nextDay: "[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0997\u09a4\u0995\u09be\u09b2] LT",
            lastWeek: "[\u0997\u09a4] dddd, LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s \u09aa\u09b0\u09c7",
            past: "%s \u0986\u0997\u09c7",
            s: "\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            ss: "%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            m: "\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",
            mm: "%d \u09ae\u09bf\u09a8\u09bf\u099f",
            h: "\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",
            hh: "%d \u0998\u09a8\u09cd\u099f\u09be",
            d: "\u098f\u0995 \u09a6\u09bf\u09a8",
            dd: "%d \u09a6\u09bf\u09a8",
            M: "\u098f\u0995 \u09ae\u09be\u09b8",
            MM: "%d \u09ae\u09be\u09b8",
            y: "\u098f\u0995 \u09ac\u099b\u09b0",
            yy: "%d \u09ac\u099b\u09b0",
          },
          preparse: function (e) {
            return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g, function (e) {
              return n[e];
            });
          },
          postformat: function (e) {
            return e.replace(/\d/g, function (e) {
              return t[e];
            });
          },
          meridiemParse:
            /\u09b0\u09be\u09a4|\u09ad\u09cb\u09b0|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be|\u09b0\u09be\u09a4/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u09b0\u09be\u09a4" === t
                ? e < 4
                  ? e
                  : e + 12
                : "\u09ad\u09cb\u09b0" === t || "\u09b8\u0995\u09be\u09b2" === t
                ? e
                : "\u09a6\u09c1\u09aa\u09c1\u09b0" === t
                ? e >= 3
                  ? e
                  : e + 12
                : "\u09ac\u09bf\u0995\u09be\u09b2" === t || "\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 4
              ? "\u09b0\u09be\u09a4"
              : e < 6
              ? "\u09ad\u09cb\u09b0"
              : e < 12
              ? "\u09b8\u0995\u09be\u09b2"
              : e < 15
              ? "\u09a6\u09c1\u09aa\u09c1\u09b0"
              : e < 18
              ? "\u09ac\u09bf\u0995\u09be\u09b2"
              : e < 20
              ? "\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be"
              : "\u09b0\u09be\u09a4";
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    mh29: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("nn", {
          months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
          monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
          monthsParseExact: !0,
          weekdays: "sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
          weekdaysShort: "su._m\xe5._ty._on._to._fr._lau.".split("_"),
          weekdaysMin: "su_m\xe5_ty_on_to_fr_la".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] H:mm",
            LLLL: "dddd D. MMMM YYYY [kl.] HH:mm",
          },
          calendar: {
            sameDay: "[I dag klokka] LT",
            nextDay: "[I morgon klokka] LT",
            nextWeek: "dddd [klokka] LT",
            lastDay: "[I g\xe5r klokka] LT",
            lastWeek: "[F\xf8reg\xe5ande] dddd [klokka] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "om %s",
            past: "%s sidan",
            s: "nokre sekund",
            ss: "%d sekund",
            m: "eit minutt",
            mm: "%d minutt",
            h: "ein time",
            hh: "%d timar",
            d: "ein dag",
            dd: "%d dagar",
            w: "ei veke",
            ww: "%d veker",
            M: "ein m\xe5nad",
            MM: "%d m\xe5nader",
            y: "eit \xe5r",
            yy: "%d \xe5r",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    nVrk: function (e, t, n) {
      (e.exports = n("FyS8")).tz.load(n("3y2C"));
    },
    pdAN: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("tzm-latn", {
          months:
            "innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split(
              "_"
            ),
          monthsShort:
            "innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split(
              "_"
            ),
          weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),
          weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),
          weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[asdkh g] LT",
            nextDay: "[aska g] LT",
            nextWeek: "dddd [g] LT",
            lastDay: "[assant g] LT",
            lastWeek: "dddd [g] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dadkh s yan %s",
            past: "yan %s",
            s: "imik",
            ss: "%d imik",
            m: "minu\u1e0d",
            mm: "%d minu\u1e0d",
            h: "sa\u025ba",
            hh: "%d tassa\u025bin",
            d: "ass",
            dd: "%d ossan",
            M: "ayowr",
            MM: "%d iyyirn",
            y: "asgas",
            yy: "%d isgasn",
          },
          week: { dow: 6, doy: 12 },
        });
      })(n("wgY5"));
    },
    sWi3: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("cy", {
          months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
          monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
          weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
          weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
          weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Heddiw am] LT",
            nextDay: "[Yfory am] LT",
            nextWeek: "dddd [am] LT",
            lastDay: "[Ddoe am] LT",
            lastWeek: "dddd [diwethaf am] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "mewn %s",
            past: "%s yn \xf4l",
            s: "ychydig eiliadau",
            ss: "%d eiliad",
            m: "munud",
            mm: "%d munud",
            h: "awr",
            hh: "%d awr",
            d: "diwrnod",
            dd: "%d diwrnod",
            M: "mis",
            MM: "%d mis",
            y: "blwyddyn",
            yy: "%d flynedd",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
          ordinal: function (e) {
            var t = "";
            return (
              e > 20
                ? (t = 40 === e || 50 === e || 60 === e || 80 === e || 100 === e ? "fed" : "ain")
                : e > 0 &&
                  (t = [
                    "",
                    "af",
                    "il",
                    "ydd",
                    "ydd",
                    "ed",
                    "ed",
                    "ed",
                    "fed",
                    "fed",
                    "fed",
                    "eg",
                    "fed",
                    "eg",
                    "eg",
                    "fed",
                    "eg",
                    "eg",
                    "fed",
                    "eg",
                    "fed",
                  ][e]),
              e + t
            );
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "t+Zl": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("fr-ca", {
          months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split(
            "_"
          ),
          monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
          monthsParseExact: !0,
          weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
          weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
          weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
          ordinal: function (e, t) {
            switch (t) {
              default:
              case "M":
              case "Q":
              case "D":
              case "DDD":
              case "d":
                return e + (1 === e ? "er" : "e");
              case "w":
              case "W":
                return e + (1 === e ? "re" : "e");
            }
          },
        });
      })(n("wgY5"));
    },
    t4T9: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ms-my", {
          months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
          monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
          weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
          weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
          weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
          },
          meridiemParse: /pagi|tengahari|petang|malam/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "pagi" === t
                ? e
                : "tengahari" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "petang" === t || "malam" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
          },
          calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Esok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kelmarin pukul] LT",
            lastWeek: "dddd [lepas pukul] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dalam %s",
            past: "%s yang lepas",
            s: "beberapa saat",
            ss: "%d saat",
            m: "seminit",
            mm: "%d minit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun",
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    tSbB: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("el", {
          monthsNominativeEl:
            "\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split(
              "_"
            ),
          monthsGenitiveEl:
            "\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split(
              "_"
            ),
          months: function (e, t) {
            return e
              ? "string" == typeof t && /D/.test(t.substring(0, t.indexOf("MMMM")))
                ? this._monthsGenitiveEl[e.month()]
                : this._monthsNominativeEl[e.month()]
              : this._monthsNominativeEl;
          },
          monthsShort:
            "\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split(
              "_"
            ),
          weekdays:
            "\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split(
              "_"
            ),
          weekdaysShort:
            "\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split(
              "_"
            ),
          weekdaysMin:
            "\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split("_"),
          meridiem: function (e, t, n) {
            return e > 11 ? (n ? "\u03bc\u03bc" : "\u039c\u039c") : n ? "\u03c0\u03bc" : "\u03a0\u039c";
          },
          isPM: function (e) {
            return "\u03bc" === (e + "").toLowerCase()[0];
          },
          meridiemParse: /[\u03a0\u039c]\.?\u039c?\.?/i,
          longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A",
          },
          calendarEl: {
            sameDay: "[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",
            nextDay: "[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",
            nextWeek: "dddd [{}] LT",
            lastDay: "[\u03a7\u03b8\u03b5\u03c2 {}] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 6:
                  return "[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";
                default:
                  return "[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT";
              }
            },
            sameElse: "L",
          },
          calendar: function (e, t) {
            var n,
              s = this._calendarEl[e],
              r = t && t.hours();
            return (
              (n = s),
              (("undefined" != typeof Function && n instanceof Function) ||
                "[object Function]" === Object.prototype.toString.call(n)) &&
                (s = s.apply(t)),
              s.replace("{}", r % 12 == 1 ? "\u03c3\u03c4\u03b7" : "\u03c3\u03c4\u03b9\u03c2")
            );
          },
          relativeTime: {
            future: "\u03c3\u03b5 %s",
            past: "%s \u03c0\u03c1\u03b9\u03bd",
            s: "\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",
            ss: "%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",
            m: "\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",
            mm: "%d \u03bb\u03b5\u03c0\u03c4\u03ac",
            h: "\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",
            hh: "%d \u03ce\u03c1\u03b5\u03c2",
            d: "\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",
            dd: "%d \u03bc\u03ad\u03c1\u03b5\u03c2",
            M: "\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",
            MM: "%d \u03bc\u03ae\u03bd\u03b5\u03c2",
            y: "\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",
            yy: "%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\u03b7/,
          ordinal: "%d\u03b7",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    u2jB: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
            1: "\u0661",
            2: "\u0662",
            3: "\u0663",
            4: "\u0664",
            5: "\u0665",
            6: "\u0666",
            7: "\u0667",
            8: "\u0668",
            9: "\u0669",
            0: "\u0660",
          },
          n = {
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u0660": "0",
          };
        e.defineLocale("ar-sa", {
          months:
            "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
              "_"
            ),
          monthsShort:
            "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
              "_"
            ),
          weekdays:
            "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysShort:
            "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
              "_"
            ),
          weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0635|\u0645/,
          isPM: function (e) {
            return "\u0645" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0635" : "\u0645";
          },
          calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a",
          },
          preparse: function (e) {
            return e
              .replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function (e) {
                return n[e];
              })
              .replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e
              .replace(/\d/g, function (e) {
                return t[e];
              })
              .replace(/,/g, "\u060c");
          },
          week: { dow: 0, doy: 6 },
        });
      })(n("wgY5"));
    },
    uHm5: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("pt-br", {
          months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
            "_"
          ),
          monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
          weekdays: "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),
          weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),
          weekdaysMin: "do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm",
          },
          calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function () {
              return 0 === this.day() || 6 === this.day()
                ? "[\xdaltimo] dddd [\xe0s] LT"
                : "[\xdaltima] dddd [\xe0s] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "poucos segundos",
            ss: "%d segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          invalidDate: "Data inv\xe1lida",
        });
      })(n("wgY5"));
    },
    v3Qg: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("sq", {
          months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),
          monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),
          weekdays: "E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),
          weekdaysShort: "Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),
          weekdaysMin: "D_H_Ma_M\xeb_E_P_Sh".split("_"),
          weekdaysParseExact: !0,
          meridiemParse: /PD|MD/,
          isPM: function (e) {
            return "M" === e.charAt(0);
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "PD" : "MD";
          },
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Sot n\xeb] LT",
            nextDay: "[Nes\xebr n\xeb] LT",
            nextWeek: "dddd [n\xeb] LT",
            lastDay: "[Dje n\xeb] LT",
            lastWeek: "dddd [e kaluar n\xeb] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "n\xeb %s",
            past: "%s m\xeb par\xeb",
            s: "disa sekonda",
            ss: "%d sekonda",
            m: "nj\xeb minut\xeb",
            mm: "%d minuta",
            h: "nj\xeb or\xeb",
            hh: "%d or\xeb",
            d: "nj\xeb dit\xeb",
            dd: "%d dit\xeb",
            M: "nj\xeb muaj",
            MM: "%d muaj",
            y: "nj\xeb vit",
            yy: "%d vite",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    vcN1: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = "nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" "),
          n = ["nolla", "yhden", "kahden", "kolmen", "nelj\xe4n", "viiden", "kuuden", t[7], t[8], t[9]];
        function s(e, s, r, i) {
          var a = "";
          switch (r) {
            case "s":
              return i ? "muutaman sekunnin" : "muutama sekunti";
            case "ss":
              a = i ? "sekunnin" : "sekuntia";
              break;
            case "m":
              return i ? "minuutin" : "minuutti";
            case "mm":
              a = i ? "minuutin" : "minuuttia";
              break;
            case "h":
              return i ? "tunnin" : "tunti";
            case "hh":
              a = i ? "tunnin" : "tuntia";
              break;
            case "d":
              return i ? "p\xe4iv\xe4n" : "p\xe4iv\xe4";
            case "dd":
              a = i ? "p\xe4iv\xe4n" : "p\xe4iv\xe4\xe4";
              break;
            case "M":
              return i ? "kuukauden" : "kuukausi";
            case "MM":
              a = i ? "kuukauden" : "kuukautta";
              break;
            case "y":
              return i ? "vuoden" : "vuosi";
            case "yy":
              a = i ? "vuoden" : "vuotta";
          }
          return (
            (function (e, s) {
              return e < 10 ? (s ? n[e] : t[e]) : e;
            })(e, i) +
            " " +
            a
          );
        }
        e.defineLocale("fi", {
          months:
            "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split(
              "_"
            ),
          monthsShort: "tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),
          weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
          weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
          weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM[ta] YYYY",
            LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
            LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
            l: "D.M.YYYY",
            ll: "Do MMM YYYY",
            lll: "Do MMM YYYY, [klo] HH.mm",
            llll: "ddd, Do MMM YYYY, [klo] HH.mm",
          },
          calendar: {
            sameDay: "[t\xe4n\xe4\xe4n] [klo] LT",
            nextDay: "[huomenna] [klo] LT",
            nextWeek: "dddd [klo] LT",
            lastDay: "[eilen] [klo] LT",
            lastWeek: "[viime] dddd[na] [klo] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s p\xe4\xe4st\xe4",
            past: "%s sitten",
            s,
            ss: s,
            m: s,
            mm: s,
            h: s,
            hh: s,
            d: s,
            dd: s,
            M: s,
            MM: s,
            y: s,
            yy: s,
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "vd/2": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("ca", {
          months: {
            standalone: "gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split(
              "_"
            ),
            format:
              "de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                "_"
              ),
            isFormat: /D[oD]?(\s)+MMMM/,
          },
          monthsShort: "gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),
          monthsParseExact: !0,
          weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
          weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
          weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [de] YYYY",
            ll: "D MMM YYYY",
            LLL: "D MMMM [de] YYYY [a les] H:mm",
            lll: "D MMM YYYY, H:mm",
            LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
            llll: "ddd D MMM YYYY, H:mm",
          },
          calendar: {
            sameDay: function () {
              return "[avui a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            nextDay: function () {
              return "[dem\xe0 a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            nextWeek: function () {
              return "dddd [a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            lastDay: function () {
              return "[ahir a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            lastWeek: function () {
              return "[el] dddd [passat a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "d'aqu\xed %s",
            past: "fa %s",
            s: "uns segons",
            ss: "%d segons",
            m: "un minut",
            mm: "%d minuts",
            h: "una hora",
            hh: "%d hores",
            d: "un dia",
            dd: "%d dies",
            M: "un mes",
            MM: "%d mesos",
            y: "un any",
            yy: "%d anys",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|\xe8|a)/,
          ordinal: function (e, t) {
            var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "\xe8";
            return ("w" !== t && "W" !== t) || (n = "a"), e + n;
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    "vn/h": function (e, t, n) {
      !(function (e) {
        "use strict";
        function t(e, t, n, s) {
          var r = {
            m: ["eng Minutt", "enger Minutt"],
            h: ["eng Stonn", "enger Stonn"],
            d: ["een Dag", "engem Dag"],
            M: ["ee Mount", "engem Mount"],
            y: ["ee Joer", "engem Joer"],
          };
          return t ? r[n][0] : r[n][1];
        }
        function n(e) {
          if (((e = parseInt(e, 10)), isNaN(e))) return !1;
          if (e < 0) return !0;
          if (e < 10) return 4 <= e && e <= 7;
          if (e < 100) {
            var t = e % 10;
            return n(0 === t ? e / 10 : t);
          }
          if (e < 1e4) {
            for (; e >= 10; ) e /= 10;
            return n(e);
          }
          return n((e /= 1e3));
        }
        e.defineLocale("lb", {
          months: "Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split(
            "_"
          ),
          monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
          monthsParseExact: !0,
          weekdays: "Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
          weekdaysShort: "So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),
          weekdaysMin: "So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm [Auer]",
            LTS: "H:mm:ss [Auer]",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm [Auer]",
            LLLL: "dddd, D. MMMM YYYY H:mm [Auer]",
          },
          calendar: {
            sameDay: "[Haut um] LT",
            sameElse: "L",
            nextDay: "[Muer um] LT",
            nextWeek: "dddd [um] LT",
            lastDay: "[G\xebschter um] LT",
            lastWeek: function () {
              switch (this.day()) {
                case 2:
                case 4:
                  return "[Leschten] dddd [um] LT";
                default:
                  return "[Leschte] dddd [um] LT";
              }
            },
          },
          relativeTime: {
            future: function (e) {
              return n(e.substr(0, e.indexOf(" "))) ? "a " + e : "an " + e;
            },
            past: function (e) {
              return n(e.substr(0, e.indexOf(" "))) ? "viru " + e : "virun " + e;
            },
            s: "e puer Sekonnen",
            ss: "%d Sekonnen",
            m: t,
            mm: "%d Minutten",
            h: t,
            hh: "%d Stonnen",
            d: t,
            dd: "%d Deeg",
            M: t,
            MM: "%d M\xe9int",
            y: t,
            yy: "%d Joer",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: "%d.",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    w8Ej: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = [
            "\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9",
            "\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9",
            "\u0789\u07a7\u0783\u07a8\u0797\u07aa",
            "\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa",
            "\u0789\u07ad",
            "\u0796\u07ab\u0782\u07b0",
            "\u0796\u07aa\u078d\u07a6\u0787\u07a8",
            "\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa",
            "\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
            "\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa",
            "\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
            "\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
          ],
          n = [
            "\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6",
            "\u0780\u07af\u0789\u07a6",
            "\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6",
            "\u0784\u07aa\u078b\u07a6",
            "\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8",
            "\u0780\u07aa\u0786\u07aa\u0783\u07aa",
            "\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa",
          ];
        e.defineLocale("dv", {
          months: t,
          monthsShort: t,
          weekdays: n,
          weekdaysShort: n,
          weekdaysMin:
            "\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split(
              "_"
            ),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/M/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          meridiemParse: /\u0789\u0786|\u0789\u078a/,
          isPM: function (e) {
            return "\u0789\u078a" === e;
          },
          meridiem: function (e, t, n) {
            return e < 12 ? "\u0789\u0786" : "\u0789\u078a";
          },
          calendar: {
            sameDay: "[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",
            nextDay: "[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",
            nextWeek: "dddd LT",
            lastDay: "[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",
            lastWeek: "[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",
            past: "\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",
            s: "\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",
            ss: "d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",
            m: "\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",
            mm: "\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",
            h: "\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",
            hh: "\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",
            d: "\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",
            dd: "\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",
            M: "\u0789\u07a6\u0780\u07ac\u0787\u07b0",
            MM: "\u0789\u07a6\u0790\u07b0 %d",
            y: "\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",
            yy: "\u0787\u07a6\u0780\u07a6\u0783\u07aa %d",
          },
          preparse: function (e) {
            return e.replace(/\u060c/g, ",");
          },
          postformat: function (e) {
            return e.replace(/,/g, "\u060c");
          },
          week: { dow: 7, doy: 12 },
        });
      })(n("wgY5"));
    },
    wgY5: function (e, t, n) {
      (function (e) {
        e.exports = (function () {
          "use strict";
          var t, s;
          function r() {
            return t.apply(null, arguments);
          }
          function i(e) {
            return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
          }
          function a(e) {
            return null != e && "[object Object]" === Object.prototype.toString.call(e);
          }
          function o(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }
          function c(e) {
            if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
            var t;
            for (t in e) if (o(e, t)) return !1;
            return !0;
          }
          function l(e) {
            return void 0 === e;
          }
          function d(e) {
            return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
          }
          function u(e) {
            return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
          }
          function h(e, t) {
            var n,
              s = [],
              r = e.length;
            for (n = 0; n < r; ++n) s.push(t(e[n], n));
            return s;
          }
          function M(e, t) {
            for (var n in t) o(t, n) && (e[n] = t[n]);
            return o(t, "toString") && (e.toString = t.toString), o(t, "valueOf") && (e.valueOf = t.valueOf), e;
          }
          function p(e, t, n, s) {
            return zt(e, t, n, s, !0).utc();
          }
          function m(e) {
            return (
              null == e._pf &&
                (e._pf = {
                  empty: !1,
                  unusedTokens: [],
                  unusedInput: [],
                  overflow: -2,
                  charsLeftOver: 0,
                  nullInput: !1,
                  invalidEra: null,
                  invalidMonth: null,
                  invalidFormat: !1,
                  userInvalidated: !1,
                  iso: !1,
                  parsedDateParts: [],
                  era: null,
                  meridiem: null,
                  rfc2822: !1,
                  weekdayMismatch: !1,
                }),
              e._pf
            );
          }
          function _(e) {
            if (null == e._isValid) {
              var t = m(e),
                n = s.call(t.parsedDateParts, function (e) {
                  return null != e;
                }),
                r =
                  !isNaN(e._d.getTime()) &&
                  t.overflow < 0 &&
                  !t.empty &&
                  !t.invalidEra &&
                  !t.invalidMonth &&
                  !t.invalidWeekday &&
                  !t.weekdayMismatch &&
                  !t.nullInput &&
                  !t.invalidFormat &&
                  !t.userInvalidated &&
                  (!t.meridiem || (t.meridiem && n));
              if (
                (e._strict && (r = r && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour),
                null != Object.isFrozen && Object.isFrozen(e))
              )
                return r;
              e._isValid = r;
            }
            return e._isValid;
          }
          function f(e) {
            var t = p(NaN);
            return null != e ? M(m(t), e) : (m(t).userInvalidated = !0), t;
          }
          s = Array.prototype.some
            ? Array.prototype.some
            : function (e) {
                var t,
                  n = Object(this),
                  s = n.length >>> 0;
                for (t = 0; t < s; t++) if (t in n && e.call(this, n[t], t, n)) return !0;
                return !1;
              };
          var b = (r.momentProperties = []),
            g = !1;
          function y(e, t) {
            var n,
              s,
              r,
              i = b.length;
            if (
              (l(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject),
              l(t._i) || (e._i = t._i),
              l(t._f) || (e._f = t._f),
              l(t._l) || (e._l = t._l),
              l(t._strict) || (e._strict = t._strict),
              l(t._tzm) || (e._tzm = t._tzm),
              l(t._isUTC) || (e._isUTC = t._isUTC),
              l(t._offset) || (e._offset = t._offset),
              l(t._pf) || (e._pf = m(t)),
              l(t._locale) || (e._locale = t._locale),
              i > 0)
            )
              for (n = 0; n < i; n++) l((r = t[(s = b[n])])) || (e[s] = r);
            return e;
          }
          function L(e) {
            y(this, e),
              (this._d = new Date(null != e._d ? e._d.getTime() : NaN)),
              this.isValid() || (this._d = new Date(NaN)),
              !1 === g && ((g = !0), r.updateOffset(this), (g = !1));
          }
          function A(e) {
            return e instanceof L || (null != e && null != e._isAMomentObject);
          }
          function w(e) {
            !1 === r.suppressDeprecationWarnings &&
              "undefined" != typeof console &&
              console.warn &&
              console.warn("Deprecation warning: " + e);
          }
          function z(e, t) {
            var n = !0;
            return M(function () {
              if ((null != r.deprecationHandler && r.deprecationHandler(null, e), n)) {
                var s,
                  i,
                  a,
                  c = [],
                  l = arguments.length;
                for (i = 0; i < l; i++) {
                  if (((s = ""), "object" == typeof arguments[i])) {
                    for (a in ((s += "\n[" + i + "] "), arguments[0]))
                      o(arguments[0], a) && (s += a + ": " + arguments[0][a] + ", ");
                    s = s.slice(0, -2);
                  } else s = arguments[i];
                  c.push(s);
                }
                w(e + "\nArguments: " + Array.prototype.slice.call(c).join("") + "\n" + new Error().stack), (n = !1);
              }
              return t.apply(this, arguments);
            }, t);
          }
          var T,
            v = {};
          function D(e, t) {
            null != r.deprecationHandler && r.deprecationHandler(e, t), v[e] || (w(t), (v[e] = !0));
          }
          function O(e) {
            return (
              ("undefined" != typeof Function && e instanceof Function) ||
              "[object Function]" === Object.prototype.toString.call(e)
            );
          }
          function S(e, t) {
            var n,
              s = M({}, e);
            for (n in t)
              o(t, n) &&
                (a(e[n]) && a(t[n])
                  ? ((s[n] = {}), M(s[n], e[n]), M(s[n], t[n]))
                  : null != t[n]
                  ? (s[n] = t[n])
                  : delete s[n]);
            for (n in e) o(e, n) && !o(t, n) && a(e[n]) && (s[n] = M({}, s[n]));
            return s;
          }
          function k(e) {
            null != e && this.set(e);
          }
          function Y(e, t, n) {
            var s = "" + Math.abs(e);
            return (
              (e >= 0 ? (n ? "+" : "") : "-") +
              Math.pow(10, Math.max(0, t - s.length))
                .toString()
                .substr(1) +
              s
            );
          }
          (r.suppressDeprecationWarnings = !1),
            (r.deprecationHandler = null),
            (T = Object.keys
              ? Object.keys
              : function (e) {
                  var t,
                    n = [];
                  for (t in e) o(e, t) && n.push(t);
                  return n;
                });
          var N =
              /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
            E = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
            C = {},
            W = {};
          function q(e, t, n, s) {
            var r = s;
            "string" == typeof s &&
              (r = function () {
                return this[s]();
              }),
              e && (W[e] = r),
              t &&
                (W[t[0]] = function () {
                  return Y(r.apply(this, arguments), t[1], t[2]);
                }),
              n &&
                (W[n] = function () {
                  return this.localeData().ordinal(r.apply(this, arguments), e);
                });
          }
          function x(e, t) {
            return e.isValid()
              ? ((t = B(t, e.localeData())),
                (C[t] =
                  C[t] ||
                  (function (e) {
                    var t,
                      n,
                      s,
                      r = e.match(N);
                    for (t = 0, n = r.length; t < n; t++)
                      r[t] = W[r[t]]
                        ? W[r[t]]
                        : (s = r[t]).match(/\[[\s\S]/)
                        ? s.replace(/^\[|\]$/g, "")
                        : s.replace(/\\/g, "");
                    return function (t) {
                      var s,
                        i = "";
                      for (s = 0; s < n; s++) i += O(r[s]) ? r[s].call(t, e) : r[s];
                      return i;
                    };
                  })(t)),
                C[t](e))
              : e.localeData().invalidDate();
          }
          function B(e, t) {
            var n = 5;
            function s(e) {
              return t.longDateFormat(e) || e;
            }
            for (E.lastIndex = 0; n >= 0 && E.test(e); ) (e = e.replace(E, s)), (E.lastIndex = 0), (n -= 1);
            return e;
          }
          var H = {};
          function j(e, t) {
            var n = e.toLowerCase();
            H[n] = H[n + "s"] = H[t] = e;
          }
          function P(e) {
            return "string" == typeof e ? H[e] || H[e.toLowerCase()] : void 0;
          }
          function X(e) {
            var t,
              n,
              s = {};
            for (n in e) o(e, n) && (t = P(n)) && (s[t] = e[n]);
            return s;
          }
          var R = {};
          function I(e, t) {
            R[e] = t;
          }
          function F(e) {
            return (e % 4 == 0 && e % 100 != 0) || e % 400 == 0;
          }
          function V(e) {
            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
          }
          function U(e) {
            var t = +e,
              n = 0;
            return 0 !== t && isFinite(t) && (n = V(t)), n;
          }
          function J(e, t) {
            return function (n) {
              return null != n ? (Q(this, e, n), r.updateOffset(this, t), this) : G(this, e);
            };
          }
          function G(e, t) {
            return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
          }
          function Q(e, t, n) {
            e.isValid() &&
              !isNaN(n) &&
              ("FullYear" === t && F(e.year()) && 1 === e.month() && 29 === e.date()
                ? ((n = U(n)), e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), Ae(n, e.month())))
                : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
          }
          var K,
            $ = /\d/,
            Z = /\d\d/,
            ee = /\d{3}/,
            te = /\d{4}/,
            ne = /[+-]?\d{6}/,
            se = /\d\d?/,
            re = /\d\d\d\d?/,
            ie = /\d\d\d\d\d\d?/,
            ae = /\d{1,3}/,
            oe = /\d{1,4}/,
            ce = /[+-]?\d{1,6}/,
            le = /\d+/,
            de = /[+-]?\d+/,
            ue = /Z|[+-]\d\d:?\d\d/gi,
            he = /Z|[+-]\d\d(?::?\d\d)?/gi,
            Me =
              /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
          function pe(e, t, n) {
            K[e] = O(t)
              ? t
              : function (e, s) {
                  return e && n ? n : t;
                };
          }
          function me(e, t) {
            return o(K, e)
              ? K[e](t._strict, t._locale)
              : new RegExp(
                  _e(
                    e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, s, r) {
                      return t || n || s || r;
                    })
                  )
                );
          }
          function _e(e) {
            return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
          }
          K = {};
          var fe,
            be = {};
          function ge(e, t) {
            var n,
              s,
              r = t;
            for (
              "string" == typeof e && (e = [e]),
                d(t) &&
                  (r = function (e, n) {
                    n[t] = U(e);
                  }),
                s = e.length,
                n = 0;
              n < s;
              n++
            )
              be[e[n]] = r;
          }
          function ye(e, t) {
            ge(e, function (e, n, s, r) {
              (s._w = s._w || {}), t(e, s._w, s, r);
            });
          }
          function Le(e, t, n) {
            null != t && o(be, e) && be[e](t, n._a, n, e);
          }
          function Ae(e, t) {
            if (isNaN(e) || isNaN(t)) return NaN;
            var n = ((t % 12) + 12) % 12;
            return (e += (t - n) / 12), 1 === n ? (F(e) ? 29 : 28) : 31 - ((n % 7) % 2);
          }
          (fe = Array.prototype.indexOf
            ? Array.prototype.indexOf
            : function (e) {
                var t;
                for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
                return -1;
              }),
            q("M", ["MM", 2], "Mo", function () {
              return this.month() + 1;
            }),
            q("MMM", 0, 0, function (e) {
              return this.localeData().monthsShort(this, e);
            }),
            q("MMMM", 0, 0, function (e) {
              return this.localeData().months(this, e);
            }),
            j("month", "M"),
            I("month", 8),
            pe("M", se),
            pe("MM", se, Z),
            pe("MMM", function (e, t) {
              return t.monthsShortRegex(e);
            }),
            pe("MMMM", function (e, t) {
              return t.monthsRegex(e);
            }),
            ge(["M", "MM"], function (e, t) {
              t[1] = U(e) - 1;
            }),
            ge(["MMM", "MMMM"], function (e, t, n, s) {
              var r = n._locale.monthsParse(e, s, n._strict);
              null != r ? (t[1] = r) : (m(n).invalidMonth = e);
            });
          var we = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            ze = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            Te = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
            ve = Me,
            De = Me;
          function Oe(e, t, n) {
            var s,
              r,
              i,
              a = e.toLocaleLowerCase();
            if (!this._monthsParse)
              for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s)
                (i = p([2e3, s])),
                  (this._shortMonthsParse[s] = this.monthsShort(i, "").toLocaleLowerCase()),
                  (this._longMonthsParse[s] = this.months(i, "").toLocaleLowerCase());
            return n
              ? "MMM" === t
                ? -1 !== (r = fe.call(this._shortMonthsParse, a))
                  ? r
                  : null
                : -1 !== (r = fe.call(this._longMonthsParse, a))
                ? r
                : null
              : "MMM" === t
              ? -1 !== (r = fe.call(this._shortMonthsParse, a)) || -1 !== (r = fe.call(this._longMonthsParse, a))
                ? r
                : null
              : -1 !== (r = fe.call(this._longMonthsParse, a)) || -1 !== (r = fe.call(this._shortMonthsParse, a))
              ? r
              : null;
          }
          function Se(e, t) {
            var n;
            if (!e.isValid()) return e;
            if ("string" == typeof t)
              if (/^\d+$/.test(t)) t = U(t);
              else if (!d((t = e.localeData().monthsParse(t)))) return e;
            return (n = Math.min(e.date(), Ae(e.year(), t))), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
          }
          function ke(e) {
            return null != e ? (Se(this, e), r.updateOffset(this, !0), this) : G(this, "Month");
          }
          function Ye() {
            function e(e, t) {
              return t.length - e.length;
            }
            var t,
              n,
              s = [],
              r = [],
              i = [];
            for (t = 0; t < 12; t++)
              (n = p([2e3, t])),
                s.push(this.monthsShort(n, "")),
                r.push(this.months(n, "")),
                i.push(this.months(n, "")),
                i.push(this.monthsShort(n, ""));
            for (s.sort(e), r.sort(e), i.sort(e), t = 0; t < 12; t++) (s[t] = _e(s[t])), (r[t] = _e(r[t]));
            for (t = 0; t < 24; t++) i[t] = _e(i[t]);
            (this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i")),
              (this._monthsShortRegex = this._monthsRegex),
              (this._monthsStrictRegex = new RegExp("^(" + r.join("|") + ")", "i")),
              (this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"));
          }
          function Ne(e) {
            return F(e) ? 366 : 365;
          }
          q("Y", 0, 0, function () {
            var e = this.year();
            return e <= 9999 ? Y(e, 4) : "+" + e;
          }),
            q(0, ["YY", 2], 0, function () {
              return this.year() % 100;
            }),
            q(0, ["YYYY", 4], 0, "year"),
            q(0, ["YYYYY", 5], 0, "year"),
            q(0, ["YYYYYY", 6, !0], 0, "year"),
            j("year", "y"),
            I("year", 1),
            pe("Y", de),
            pe("YY", se, Z),
            pe("YYYY", oe, te),
            pe("YYYYY", ce, ne),
            pe("YYYYYY", ce, ne),
            ge(["YYYYY", "YYYYYY"], 0),
            ge("YYYY", function (e, t) {
              t[0] = 2 === e.length ? r.parseTwoDigitYear(e) : U(e);
            }),
            ge("YY", function (e, t) {
              t[0] = r.parseTwoDigitYear(e);
            }),
            ge("Y", function (e, t) {
              t[0] = parseInt(e, 10);
            }),
            (r.parseTwoDigitYear = function (e) {
              return U(e) + (U(e) > 68 ? 1900 : 2e3);
            });
          var Ee = J("FullYear", !0);
          function Ce(e, t, n, s, r, i, a) {
            var o;
            return (
              e < 100 && e >= 0
                ? ((o = new Date(e + 400, t, n, s, r, i, a)), isFinite(o.getFullYear()) && o.setFullYear(e))
                : (o = new Date(e, t, n, s, r, i, a)),
              o
            );
          }
          function We(e) {
            var t, n;
            return (
              e < 100 && e >= 0
                ? (((n = Array.prototype.slice.call(arguments))[0] = e + 400),
                  (t = new Date(Date.UTC.apply(null, n))),
                  isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e))
                : (t = new Date(Date.UTC.apply(null, arguments))),
              t
            );
          }
          function qe(e, t, n) {
            var s = 7 + t - n;
            return (-(7 + We(e, 0, s).getUTCDay() - t) % 7) + s - 1;
          }
          function xe(e, t, n, s, r) {
            var i,
              a,
              o = 1 + 7 * (t - 1) + ((7 + n - s) % 7) + qe(e, s, r);
            return (
              o <= 0 ? (a = Ne((i = e - 1)) + o) : o > Ne(e) ? ((i = e + 1), (a = o - Ne(e))) : ((i = e), (a = o)),
              { year: i, dayOfYear: a }
            );
          }
          function Be(e, t, n) {
            var s,
              r,
              i = qe(e.year(), t, n),
              a = Math.floor((e.dayOfYear() - i - 1) / 7) + 1;
            return (
              a < 1
                ? (s = a + He((r = e.year() - 1), t, n))
                : a > He(e.year(), t, n)
                ? ((s = a - He(e.year(), t, n)), (r = e.year() + 1))
                : ((r = e.year()), (s = a)),
              { week: s, year: r }
            );
          }
          function He(e, t, n) {
            var s = qe(e, t, n),
              r = qe(e + 1, t, n);
            return (Ne(e) - s + r) / 7;
          }
          function je(e, t) {
            return e.slice(t, 7).concat(e.slice(0, t));
          }
          q("w", ["ww", 2], "wo", "week"),
            q("W", ["WW", 2], "Wo", "isoWeek"),
            j("week", "w"),
            j("isoWeek", "W"),
            I("week", 5),
            I("isoWeek", 5),
            pe("w", se),
            pe("ww", se, Z),
            pe("W", se),
            pe("WW", se, Z),
            ye(["w", "ww", "W", "WW"], function (e, t, n, s) {
              t[s.substr(0, 1)] = U(e);
            }),
            q("d", 0, "do", "day"),
            q("dd", 0, 0, function (e) {
              return this.localeData().weekdaysMin(this, e);
            }),
            q("ddd", 0, 0, function (e) {
              return this.localeData().weekdaysShort(this, e);
            }),
            q("dddd", 0, 0, function (e) {
              return this.localeData().weekdays(this, e);
            }),
            q("e", 0, 0, "weekday"),
            q("E", 0, 0, "isoWeekday"),
            j("day", "d"),
            j("weekday", "e"),
            j("isoWeekday", "E"),
            I("day", 11),
            I("weekday", 11),
            I("isoWeekday", 11),
            pe("d", se),
            pe("e", se),
            pe("E", se),
            pe("dd", function (e, t) {
              return t.weekdaysMinRegex(e);
            }),
            pe("ddd", function (e, t) {
              return t.weekdaysShortRegex(e);
            }),
            pe("dddd", function (e, t) {
              return t.weekdaysRegex(e);
            }),
            ye(["dd", "ddd", "dddd"], function (e, t, n, s) {
              var r = n._locale.weekdaysParse(e, s, n._strict);
              null != r ? (t.d = r) : (m(n).invalidWeekday = e);
            }),
            ye(["d", "e", "E"], function (e, t, n, s) {
              t[s] = U(e);
            });
          var Pe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            Xe = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            Re = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            Ie = Me,
            Fe = Me,
            Ve = Me;
          function Ue(e, t, n) {
            var s,
              r,
              i,
              a = e.toLocaleLowerCase();
            if (!this._weekdaysParse)
              for (
                this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0;
                s < 7;
                ++s
              )
                (i = p([2e3, 1]).day(s)),
                  (this._minWeekdaysParse[s] = this.weekdaysMin(i, "").toLocaleLowerCase()),
                  (this._shortWeekdaysParse[s] = this.weekdaysShort(i, "").toLocaleLowerCase()),
                  (this._weekdaysParse[s] = this.weekdays(i, "").toLocaleLowerCase());
            return n
              ? "dddd" === t
                ? -1 !== (r = fe.call(this._weekdaysParse, a))
                  ? r
                  : null
                : "ddd" === t
                ? -1 !== (r = fe.call(this._shortWeekdaysParse, a))
                  ? r
                  : null
                : -1 !== (r = fe.call(this._minWeekdaysParse, a))
                ? r
                : null
              : "dddd" === t
              ? -1 !== (r = fe.call(this._weekdaysParse, a)) ||
                -1 !== (r = fe.call(this._shortWeekdaysParse, a)) ||
                -1 !== (r = fe.call(this._minWeekdaysParse, a))
                ? r
                : null
              : "ddd" === t
              ? -1 !== (r = fe.call(this._shortWeekdaysParse, a)) ||
                -1 !== (r = fe.call(this._weekdaysParse, a)) ||
                -1 !== (r = fe.call(this._minWeekdaysParse, a))
                ? r
                : null
              : -1 !== (r = fe.call(this._minWeekdaysParse, a)) ||
                -1 !== (r = fe.call(this._weekdaysParse, a)) ||
                -1 !== (r = fe.call(this._shortWeekdaysParse, a))
              ? r
              : null;
          }
          function Je() {
            function e(e, t) {
              return t.length - e.length;
            }
            var t,
              n,
              s,
              r,
              i,
              a = [],
              o = [],
              c = [],
              l = [];
            for (t = 0; t < 7; t++)
              (n = p([2e3, 1]).day(t)),
                (s = _e(this.weekdaysMin(n, ""))),
                (r = _e(this.weekdaysShort(n, ""))),
                (i = _e(this.weekdays(n, ""))),
                a.push(s),
                o.push(r),
                c.push(i),
                l.push(s),
                l.push(r),
                l.push(i);
            a.sort(e),
              o.sort(e),
              c.sort(e),
              l.sort(e),
              (this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i")),
              (this._weekdaysShortRegex = this._weekdaysRegex),
              (this._weekdaysMinRegex = this._weekdaysRegex),
              (this._weekdaysStrictRegex = new RegExp("^(" + c.join("|") + ")", "i")),
              (this._weekdaysShortStrictRegex = new RegExp("^(" + o.join("|") + ")", "i")),
              (this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"));
          }
          function Ge() {
            return this.hours() % 12 || 12;
          }
          function Qe(e, t) {
            q(e, 0, 0, function () {
              return this.localeData().meridiem(this.hours(), this.minutes(), t);
            });
          }
          function Ke(e, t) {
            return t._meridiemParse;
          }
          q("H", ["HH", 2], 0, "hour"),
            q("h", ["hh", 2], 0, Ge),
            q("k", ["kk", 2], 0, function () {
              return this.hours() || 24;
            }),
            q("hmm", 0, 0, function () {
              return "" + Ge.apply(this) + Y(this.minutes(), 2);
            }),
            q("hmmss", 0, 0, function () {
              return "" + Ge.apply(this) + Y(this.minutes(), 2) + Y(this.seconds(), 2);
            }),
            q("Hmm", 0, 0, function () {
              return "" + this.hours() + Y(this.minutes(), 2);
            }),
            q("Hmmss", 0, 0, function () {
              return "" + this.hours() + Y(this.minutes(), 2) + Y(this.seconds(), 2);
            }),
            Qe("a", !0),
            Qe("A", !1),
            j("hour", "h"),
            I("hour", 13),
            pe("a", Ke),
            pe("A", Ke),
            pe("H", se),
            pe("h", se),
            pe("k", se),
            pe("HH", se, Z),
            pe("hh", se, Z),
            pe("kk", se, Z),
            pe("hmm", re),
            pe("hmmss", ie),
            pe("Hmm", re),
            pe("Hmmss", ie),
            ge(["H", "HH"], 3),
            ge(["k", "kk"], function (e, t, n) {
              var s = U(e);
              t[3] = 24 === s ? 0 : s;
            }),
            ge(["a", "A"], function (e, t, n) {
              (n._isPm = n._locale.isPM(e)), (n._meridiem = e);
            }),
            ge(["h", "hh"], function (e, t, n) {
              (t[3] = U(e)), (m(n).bigHour = !0);
            }),
            ge("hmm", function (e, t, n) {
              var s = e.length - 2;
              (t[3] = U(e.substr(0, s))), (t[4] = U(e.substr(s))), (m(n).bigHour = !0);
            }),
            ge("hmmss", function (e, t, n) {
              var s = e.length - 4,
                r = e.length - 2;
              (t[3] = U(e.substr(0, s))), (t[4] = U(e.substr(s, 2))), (t[5] = U(e.substr(r))), (m(n).bigHour = !0);
            }),
            ge("Hmm", function (e, t, n) {
              var s = e.length - 2;
              (t[3] = U(e.substr(0, s))), (t[4] = U(e.substr(s)));
            }),
            ge("Hmmss", function (e, t, n) {
              var s = e.length - 4,
                r = e.length - 2;
              (t[3] = U(e.substr(0, s))), (t[4] = U(e.substr(s, 2))), (t[5] = U(e.substr(r)));
            });
          var $e,
            Ze = J("Hours", !0),
            et = {
              calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
              },
              longDateFormat: {
                LTS: "h:mm:ss A",
                LT: "h:mm A",
                L: "MM/DD/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A",
              },
              invalidDate: "Invalid date",
              ordinal: "%d",
              dayOfMonthOrdinalParse: /\d{1,2}/,
              relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                w: "a week",
                ww: "%d weeks",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
              },
              months: we,
              monthsShort: ze,
              week: { dow: 0, doy: 6 },
              weekdays: Pe,
              weekdaysMin: Re,
              weekdaysShort: Xe,
              meridiemParse: /[ap]\.?m?\.?/i,
            },
            tt = {},
            nt = {};
          function st(e, t) {
            var n,
              s = Math.min(e.length, t.length);
            for (n = 0; n < s; n += 1) if (e[n] !== t[n]) return n;
            return s;
          }
          function rt(e) {
            return e ? e.toLowerCase().replace("_", "-") : e;
          }
          function it(t) {
            var s = null;
            if (
              void 0 === tt[t] &&
              void 0 !== e &&
              e &&
              e.exports &&
              (function (e) {
                return null != e.match("^[^/\\\\]*$");
              })(t)
            )
              try {
                (s = $e._abbr), n("MROq")("./" + t), at(s);
              } catch (r) {
                tt[t] = null;
              }
            return tt[t];
          }
          function at(e, t) {
            var n;
            return (
              e &&
                ((n = l(t) ? ct(e) : ot(e, t))
                  ? ($e = n)
                  : "undefined" != typeof console &&
                    console.warn &&
                    console.warn("Locale " + e + " not found. Did you forget to load it?")),
              $e._abbr
            );
          }
          function ot(e, t) {
            if (null !== t) {
              var n,
                s = et;
              if (((t.abbr = e), null != tt[e]))
                D(
                  "defineLocaleOverride",
                  "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
                ),
                  (s = tt[e]._config);
              else if (null != t.parentLocale)
                if (null != tt[t.parentLocale]) s = tt[t.parentLocale]._config;
                else {
                  if (null == (n = it(t.parentLocale)))
                    return (
                      nt[t.parentLocale] || (nt[t.parentLocale] = []),
                      nt[t.parentLocale].push({ name: e, config: t }),
                      null
                    );
                  s = n._config;
                }
              return (
                (tt[e] = new k(S(s, t))),
                nt[e] &&
                  nt[e].forEach(function (e) {
                    ot(e.name, e.config);
                  }),
                at(e),
                tt[e]
              );
            }
            return delete tt[e], null;
          }
          function ct(e) {
            var t;
            if ((e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)) return $e;
            if (!i(e)) {
              if ((t = it(e))) return t;
              e = [e];
            }
            return (function (e) {
              for (var t, n, s, r, i = 0; i < e.length; ) {
                for (t = (r = rt(e[i]).split("-")).length, n = (n = rt(e[i + 1])) ? n.split("-") : null; t > 0; ) {
                  if ((s = it(r.slice(0, t).join("-")))) return s;
                  if (n && n.length >= t && st(r, n) >= t - 1) break;
                  t--;
                }
                i++;
              }
              return $e;
            })(e);
          }
          function lt(e) {
            var t,
              n = e._a;
            return (
              n &&
                -2 === m(e).overflow &&
                ((t =
                  n[1] < 0 || n[1] > 11
                    ? 1
                    : n[2] < 1 || n[2] > Ae(n[0], n[1])
                    ? 2
                    : n[3] < 0 || n[3] > 24 || (24 === n[3] && (0 !== n[4] || 0 !== n[5] || 0 !== n[6]))
                    ? 3
                    : n[4] < 0 || n[4] > 59
                    ? 4
                    : n[5] < 0 || n[5] > 59
                    ? 5
                    : n[6] < 0 || n[6] > 999
                    ? 6
                    : -1),
                m(e)._overflowDayOfYear && (t < 0 || t > 2) && (t = 2),
                m(e)._overflowWeeks && -1 === t && (t = 7),
                m(e)._overflowWeekday && -1 === t && (t = 8),
                (m(e).overflow = t)),
              e
            );
          }
          var dt =
              /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            ut =
              /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            ht = /Z|[+-]\d\d(?::?\d\d)?/,
            Mt = [
              ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
              ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
              ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
              ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
              ["YYYY-DDD", /\d{4}-\d{3}/],
              ["YYYY-MM", /\d{4}-\d\d/, !1],
              ["YYYYYYMMDD", /[+-]\d{10}/],
              ["YYYYMMDD", /\d{8}/],
              ["GGGG[W]WWE", /\d{4}W\d{3}/],
              ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
              ["YYYYDDD", /\d{7}/],
              ["YYYYMM", /\d{6}/, !1],
              ["YYYY", /\d{4}/, !1],
            ],
            pt = [
              ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
              ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
              ["HH:mm:ss", /\d\d:\d\d:\d\d/],
              ["HH:mm", /\d\d:\d\d/],
              ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
              ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
              ["HHmmss", /\d\d\d\d\d\d/],
              ["HHmm", /\d\d\d\d/],
              ["HH", /\d\d/],
            ],
            mt = /^\/?Date\((-?\d+)/i,
            _t =
              /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
            ft = {
              UT: 0,
              GMT: 0,
              EDT: -240,
              EST: -300,
              CDT: -300,
              CST: -360,
              MDT: -360,
              MST: -420,
              PDT: -420,
              PST: -480,
            };
          function bt(e) {
            var t,
              n,
              s,
              r,
              i,
              a,
              o = e._i,
              c = dt.exec(o) || ut.exec(o),
              l = Mt.length,
              d = pt.length;
            if (c) {
              for (m(e).iso = !0, t = 0, n = l; t < n; t++)
                if (Mt[t][1].exec(c[1])) {
                  (r = Mt[t][0]), (s = !1 !== Mt[t][2]);
                  break;
                }
              if (null == r) return void (e._isValid = !1);
              if (c[3]) {
                for (t = 0, n = d; t < n; t++)
                  if (pt[t][1].exec(c[3])) {
                    i = (c[2] || " ") + pt[t][0];
                    break;
                  }
                if (null == i) return void (e._isValid = !1);
              }
              if (!s && null != i) return void (e._isValid = !1);
              if (c[4]) {
                if (!ht.exec(c[4])) return void (e._isValid = !1);
                a = "Z";
              }
              (e._f = r + (i || "") + (a || "")), At(e);
            } else e._isValid = !1;
          }
          function gt(e) {
            var t,
              n,
              s,
              r,
              i,
              a,
              o,
              c,
              l,
              d = _t.exec(
                e._i
                  .replace(/\([^)]*\)|[\n\t]/g, " ")
                  .replace(/(\s\s+)/g, " ")
                  .replace(/^\s\s*/, "")
                  .replace(/\s\s*$/, "")
              );
            if (d) {
              if (
                ((n = d[3]),
                (s = d[2]),
                (r = d[5]),
                (i = d[6]),
                (a = d[7]),
                (o = [
                  ((c = d[4]), (l = parseInt(c, 10)), l <= 49 ? 2e3 + l : l <= 999 ? 1900 + l : l),
                  ze.indexOf(n),
                  parseInt(s, 10),
                  parseInt(r, 10),
                  parseInt(i, 10),
                ]),
                a && o.push(parseInt(a, 10)),
                !(function (e, t, n) {
                  return (
                    !e ||
                    Xe.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() ||
                    ((m(n).weekdayMismatch = !0), (n._isValid = !1), !1)
                  );
                })(d[1], (t = o), e))
              )
                return;
              (e._a = t),
                (e._tzm = (function (e, t, n) {
                  if (e) return ft[e];
                  if (t) return 0;
                  var s = parseInt(n, 10),
                    r = s % 100;
                  return ((s - r) / 100) * 60 + r;
                })(d[8], d[9], d[10])),
                (e._d = We.apply(null, e._a)),
                e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                (m(e).rfc2822 = !0);
            } else e._isValid = !1;
          }
          function yt(e, t, n) {
            return null != e ? e : null != t ? t : n;
          }
          function Lt(e) {
            var t,
              n,
              s,
              i,
              a,
              o = [];
            if (!e._d) {
              for (
                s = (function (e) {
                  var t = new Date(r.now());
                  return e._useUTC
                    ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()]
                    : [t.getFullYear(), t.getMonth(), t.getDate()];
                })(e),
                  e._w &&
                    null == e._a[2] &&
                    null == e._a[1] &&
                    (function (e) {
                      var t, n, s, r, i, a, o, c, l;
                      null != (t = e._w).GG || null != t.W || null != t.E
                        ? ((i = 1),
                          (a = 4),
                          (n = yt(t.GG, e._a[0], Be(Tt(), 1, 4).year)),
                          (s = yt(t.W, 1)),
                          ((r = yt(t.E, 1)) < 1 || r > 7) && (c = !0))
                        : ((i = e._locale._week.dow),
                          (a = e._locale._week.doy),
                          (l = Be(Tt(), i, a)),
                          (n = yt(t.gg, e._a[0], l.year)),
                          (s = yt(t.w, l.week)),
                          null != t.d
                            ? ((r = t.d) < 0 || r > 6) && (c = !0)
                            : null != t.e
                            ? ((r = t.e + i), (t.e < 0 || t.e > 6) && (c = !0))
                            : (r = i)),
                        s < 1 || s > He(n, i, a)
                          ? (m(e)._overflowWeeks = !0)
                          : null != c
                          ? (m(e)._overflowWeekday = !0)
                          : ((o = xe(n, s, r, i, a)), (e._a[0] = o.year), (e._dayOfYear = o.dayOfYear));
                    })(e),
                  null != e._dayOfYear &&
                    ((a = yt(e._a[0], s[0])),
                    (e._dayOfYear > Ne(a) || 0 === e._dayOfYear) && (m(e)._overflowDayOfYear = !0),
                    (n = We(a, 0, e._dayOfYear)),
                    (e._a[1] = n.getUTCMonth()),
                    (e._a[2] = n.getUTCDate())),
                  t = 0;
                t < 3 && null == e._a[t];
                ++t
              )
                e._a[t] = o[t] = s[t];
              for (; t < 7; t++) e._a[t] = o[t] = null == e._a[t] ? (2 === t ? 1 : 0) : e._a[t];
              24 === e._a[3] && 0 === e._a[4] && 0 === e._a[5] && 0 === e._a[6] && ((e._nextDay = !0), (e._a[3] = 0)),
                (e._d = (e._useUTC ? We : Ce).apply(null, o)),
                (i = e._useUTC ? e._d.getUTCDay() : e._d.getDay()),
                null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                e._nextDay && (e._a[3] = 24),
                e._w && void 0 !== e._w.d && e._w.d !== i && (m(e).weekdayMismatch = !0);
            }
          }
          function At(e) {
            if (e._f !== r.ISO_8601)
              if (e._f !== r.RFC_2822) {
                (e._a = []), (m(e).empty = !0);
                var t,
                  n,
                  s,
                  i,
                  a,
                  o,
                  c,
                  l = "" + e._i,
                  d = l.length,
                  u = 0;
                for (c = (s = B(e._f, e._locale).match(N) || []).length, t = 0; t < c; t++)
                  (n = (l.match(me((i = s[t]), e)) || [])[0]) &&
                    ((a = l.substr(0, l.indexOf(n))).length > 0 && m(e).unusedInput.push(a),
                    (l = l.slice(l.indexOf(n) + n.length)),
                    (u += n.length)),
                    W[i]
                      ? (n ? (m(e).empty = !1) : m(e).unusedTokens.push(i), Le(i, n, e))
                      : e._strict && !n && m(e).unusedTokens.push(i);
                (m(e).charsLeftOver = d - u),
                  l.length > 0 && m(e).unusedInput.push(l),
                  e._a[3] <= 12 && !0 === m(e).bigHour && e._a[3] > 0 && (m(e).bigHour = void 0),
                  (m(e).parsedDateParts = e._a.slice(0)),
                  (m(e).meridiem = e._meridiem),
                  (e._a[3] = (function (e, t, n) {
                    var s;
                    return null == n
                      ? t
                      : null != e.meridiemHour
                      ? e.meridiemHour(t, n)
                      : null != e.isPM
                      ? ((s = e.isPM(n)) && t < 12 && (t += 12), s || 12 !== t || (t = 0), t)
                      : t;
                  })(e._locale, e._a[3], e._meridiem)),
                  null !== (o = m(e).era) && (e._a[0] = e._locale.erasConvertYear(o, e._a[0])),
                  Lt(e),
                  lt(e);
              } else gt(e);
            else bt(e);
          }
          function wt(e) {
            var t = e._i,
              n = e._f;
            return (
              (e._locale = e._locale || ct(e._l)),
              null === t || (void 0 === n && "" === t)
                ? f({ nullInput: !0 })
                : ("string" == typeof t && (e._i = t = e._locale.preparse(t)),
                  A(t)
                    ? new L(lt(t))
                    : (u(t)
                        ? (e._d = t)
                        : i(n)
                        ? (function (e) {
                            var t,
                              n,
                              s,
                              r,
                              i,
                              a,
                              o = !1,
                              c = e._f.length;
                            if (0 === c) return (m(e).invalidFormat = !0), void (e._d = new Date(NaN));
                            for (r = 0; r < c; r++)
                              (i = 0),
                                (a = !1),
                                (t = y({}, e)),
                                null != e._useUTC && (t._useUTC = e._useUTC),
                                (t._f = e._f[r]),
                                At(t),
                                _(t) && (a = !0),
                                (i += m(t).charsLeftOver),
                                (i += 10 * m(t).unusedTokens.length),
                                (m(t).score = i),
                                o
                                  ? i < s && ((s = i), (n = t))
                                  : (null == s || i < s || a) && ((s = i), (n = t), a && (o = !0));
                            M(e, n || t);
                          })(e)
                        : n
                        ? At(e)
                        : (function (e) {
                            var t = e._i;
                            l(t)
                              ? (e._d = new Date(r.now()))
                              : u(t)
                              ? (e._d = new Date(t.valueOf()))
                              : "string" == typeof t
                              ? (function (e) {
                                  var t = mt.exec(e._i);
                                  null === t
                                    ? (bt(e),
                                      !1 === e._isValid &&
                                        (delete e._isValid,
                                        gt(e),
                                        !1 === e._isValid &&
                                          (delete e._isValid,
                                          e._strict ? (e._isValid = !1) : r.createFromInputFallback(e))))
                                    : (e._d = new Date(+t[1]));
                                })(e)
                              : i(t)
                              ? ((e._a = h(t.slice(0), function (e) {
                                  return parseInt(e, 10);
                                })),
                                Lt(e))
                              : a(t)
                              ? (function (e) {
                                  if (!e._d) {
                                    var t = X(e._i);
                                    (e._a = h(
                                      [
                                        t.year,
                                        t.month,
                                        void 0 === t.day ? t.date : t.day,
                                        t.hour,
                                        t.minute,
                                        t.second,
                                        t.millisecond,
                                      ],
                                      function (e) {
                                        return e && parseInt(e, 10);
                                      }
                                    )),
                                      Lt(e);
                                  }
                                })(e)
                              : d(t)
                              ? (e._d = new Date(t))
                              : r.createFromInputFallback(e);
                          })(e),
                      _(e) || (e._d = null),
                      e))
            );
          }
          function zt(e, t, n, s, r) {
            var o,
              l = {};
            return (
              (!0 !== t && !1 !== t) || ((s = t), (t = void 0)),
              (!0 !== n && !1 !== n) || ((s = n), (n = void 0)),
              ((a(e) && c(e)) || (i(e) && 0 === e.length)) && (e = void 0),
              (l._isAMomentObject = !0),
              (l._useUTC = l._isUTC = r),
              (l._l = n),
              (l._i = e),
              (l._f = t),
              (l._strict = s),
              (o = new L(lt(wt(l))))._nextDay && (o.add(1, "d"), (o._nextDay = void 0)),
              o
            );
          }
          function Tt(e, t, n, s) {
            return zt(e, t, n, s, !1);
          }
          (r.createFromInputFallback = z(
            "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
            function (e) {
              e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
            }
          )),
            (r.ISO_8601 = function () {}),
            (r.RFC_2822 = function () {});
          var vt = z(
              "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
              function () {
                var e = Tt.apply(null, arguments);
                return this.isValid() && e.isValid() ? (e < this ? this : e) : f();
              }
            ),
            Dt = z(
              "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
              function () {
                var e = Tt.apply(null, arguments);
                return this.isValid() && e.isValid() ? (e > this ? this : e) : f();
              }
            );
          function Ot(e, t) {
            var n, s;
            if ((1 === t.length && i(t[0]) && (t = t[0]), !t.length)) return Tt();
            for (n = t[0], s = 1; s < t.length; ++s) (t[s].isValid() && !t[s][e](n)) || (n = t[s]);
            return n;
          }
          var St = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
          function kt(e) {
            var t = X(e),
              n = t.year || 0,
              s = t.quarter || 0,
              r = t.month || 0,
              i = t.week || t.isoWeek || 0,
              a = t.day || 0,
              c = t.hour || 0,
              l = t.minute || 0,
              d = t.second || 0,
              u = t.millisecond || 0;
            (this._isValid = (function (e) {
              var t,
                n,
                s = !1,
                r = St.length;
              for (t in e) if (o(e, t) && (-1 === fe.call(St, t) || (null != e[t] && isNaN(e[t])))) return !1;
              for (n = 0; n < r; ++n)
                if (e[St[n]]) {
                  if (s) return !1;
                  parseFloat(e[St[n]]) !== U(e[St[n]]) && (s = !0);
                }
              return !0;
            })(t)),
              (this._milliseconds = +u + 1e3 * d + 6e4 * l + 1e3 * c * 60 * 60),
              (this._days = +a + 7 * i),
              (this._months = +r + 3 * s + 12 * n),
              (this._data = {}),
              (this._locale = ct()),
              this._bubble();
          }
          function Yt(e) {
            return e instanceof kt;
          }
          function Nt(e) {
            return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
          }
          function Et(e, t) {
            q(e, 0, 0, function () {
              var e = this.utcOffset(),
                n = "+";
              return e < 0 && ((e = -e), (n = "-")), n + Y(~~(e / 60), 2) + t + Y(~~e % 60, 2);
            });
          }
          Et("Z", ":"),
            Et("ZZ", ""),
            pe("Z", he),
            pe("ZZ", he),
            ge(["Z", "ZZ"], function (e, t, n) {
              (n._useUTC = !0), (n._tzm = Wt(he, e));
            });
          var Ct = /([\+\-]|\d\d)/gi;
          function Wt(e, t) {
            var n,
              s,
              r = (t || "").match(e);
            return null === r
              ? null
              : 0 === (s = 60 * (n = ((r[r.length - 1] || []) + "").match(Ct) || ["-", 0, 0])[1] + U(n[2]))
              ? 0
              : "+" === n[0]
              ? s
              : -s;
          }
          function qt(e, t) {
            var n, s;
            return t._isUTC
              ? ((n = t.clone()),
                (s = (A(e) || u(e) ? e.valueOf() : Tt(e).valueOf()) - n.valueOf()),
                n._d.setTime(n._d.valueOf() + s),
                r.updateOffset(n, !1),
                n)
              : Tt(e).local();
          }
          function xt(e) {
            return -Math.round(e._d.getTimezoneOffset());
          }
          function Bt() {
            return !!this.isValid() && this._isUTC && 0 === this._offset;
          }
          r.updateOffset = function () {};
          var Ht = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
            jt =
              /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
          function Pt(e, t) {
            var n,
              s,
              r,
              i,
              a,
              c,
              l = e,
              u = null;
            return (
              Yt(e)
                ? (l = { ms: e._milliseconds, d: e._days, M: e._months })
                : d(e) || !isNaN(+e)
                ? ((l = {}), t ? (l[t] = +e) : (l.milliseconds = +e))
                : (u = Ht.exec(e))
                ? ((n = "-" === u[1] ? -1 : 1),
                  (l = {
                    y: 0,
                    d: U(u[2]) * n,
                    h: U(u[3]) * n,
                    m: U(u[4]) * n,
                    s: U(u[5]) * n,
                    ms: U(Nt(1e3 * u[6])) * n,
                  }))
                : (u = jt.exec(e))
                ? (l = {
                    y: Xt(u[2], (n = "-" === u[1] ? -1 : 1)),
                    M: Xt(u[3], n),
                    w: Xt(u[4], n),
                    d: Xt(u[5], n),
                    h: Xt(u[6], n),
                    m: Xt(u[7], n),
                    s: Xt(u[8], n),
                  })
                : null == l
                ? (l = {})
                : "object" == typeof l &&
                  ("from" in l || "to" in l) &&
                  ((i = Tt(l.from)),
                  (a = Tt(l.to)),
                  (r =
                    i.isValid() && a.isValid()
                      ? ((a = qt(a, i)),
                        i.isBefore(a)
                          ? (c = Rt(i, a))
                          : (((c = Rt(a, i)).milliseconds = -c.milliseconds), (c.months = -c.months)),
                        c)
                      : { milliseconds: 0, months: 0 }),
                  ((l = {}).ms = r.milliseconds),
                  (l.M = r.months)),
              (s = new kt(l)),
              Yt(e) && o(e, "_locale") && (s._locale = e._locale),
              Yt(e) && o(e, "_isValid") && (s._isValid = e._isValid),
              s
            );
          }
          function Xt(e, t) {
            var n = e && parseFloat(e.replace(",", "."));
            return (isNaN(n) ? 0 : n) * t;
          }
          function Rt(e, t) {
            var n = {};
            return (
              (n.months = t.month() - e.month() + 12 * (t.year() - e.year())),
              e.clone().add(n.months, "M").isAfter(t) && --n.months,
              (n.milliseconds = +t - +e.clone().add(n.months, "M")),
              n
            );
          }
          function It(e, t) {
            return function (n, s) {
              var r;
              return (
                null === s ||
                  isNaN(+s) ||
                  (D(
                    t,
                    "moment()." +
                      t +
                      "(period, number) is deprecated. Please use moment()." +
                      t +
                      "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
                  ),
                  (r = n),
                  (n = s),
                  (s = r)),
                Ft(this, Pt(n, s), e),
                this
              );
            };
          }
          function Ft(e, t, n, s) {
            var i = t._milliseconds,
              a = Nt(t._days),
              o = Nt(t._months);
            e.isValid() &&
              ((s = null == s || s),
              o && Se(e, G(e, "Month") + o * n),
              a && Q(e, "Date", G(e, "Date") + a * n),
              i && e._d.setTime(e._d.valueOf() + i * n),
              s && r.updateOffset(e, a || o));
          }
          (Pt.fn = kt.prototype),
            (Pt.invalid = function () {
              return Pt(NaN);
            });
          var Vt = It(1, "add"),
            Ut = It(-1, "subtract");
          function Jt(e) {
            return "string" == typeof e || e instanceof String;
          }
          function Gt(e) {
            return (
              A(e) ||
              u(e) ||
              Jt(e) ||
              d(e) ||
              (function (e) {
                var t = i(e),
                  n = !1;
                return (
                  t &&
                    (n =
                      0 ===
                      e.filter(function (t) {
                        return !d(t) && Jt(e);
                      }).length),
                  t && n
                );
              })(e) ||
              (function (e) {
                var t,
                  n = a(e) && !c(e),
                  s = !1,
                  r = [
                    "years",
                    "year",
                    "y",
                    "months",
                    "month",
                    "M",
                    "days",
                    "day",
                    "d",
                    "dates",
                    "date",
                    "D",
                    "hours",
                    "hour",
                    "h",
                    "minutes",
                    "minute",
                    "m",
                    "seconds",
                    "second",
                    "s",
                    "milliseconds",
                    "millisecond",
                    "ms",
                  ],
                  i = r.length;
                for (t = 0; t < i; t += 1) s = s || o(e, r[t]);
                return n && s;
              })(e) ||
              null == e
            );
          }
          function Qt(e) {
            var t,
              n = a(e) && !c(e),
              s = !1,
              r = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
            for (t = 0; t < r.length; t += 1) s = s || o(e, r[t]);
            return n && s;
          }
          function Kt(e, t) {
            if (e.date() < t.date()) return -Kt(t, e);
            var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
              s = e.clone().add(n, "months");
            return (
              -(
                n +
                (t - s < 0
                  ? (t - s) / (s - e.clone().add(n - 1, "months"))
                  : (t - s) / (e.clone().add(n + 1, "months") - s))
              ) || 0
            );
          }
          function $t(e) {
            var t;
            return void 0 === e ? this._locale._abbr : (null != (t = ct(e)) && (this._locale = t), this);
          }
          (r.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ"), (r.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]");
          var Zt = z(
            "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
            function (e) {
              return void 0 === e ? this.localeData() : this.locale(e);
            }
          );
          function en() {
            return this._locale;
          }
          function tn(e, t) {
            return ((e % t) + t) % t;
          }
          function nn(e, t, n) {
            return e < 100 && e >= 0 ? new Date(e + 400, t, n) - 126227808e5 : new Date(e, t, n).valueOf();
          }
          function sn(e, t, n) {
            return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - 126227808e5 : Date.UTC(e, t, n);
          }
          function rn(e, t) {
            return t.erasAbbrRegex(e);
          }
          function an() {
            var e,
              t,
              n = [],
              s = [],
              r = [],
              i = [],
              a = this.eras();
            for (e = 0, t = a.length; e < t; ++e)
              s.push(_e(a[e].name)),
                n.push(_e(a[e].abbr)),
                r.push(_e(a[e].narrow)),
                i.push(_e(a[e].name)),
                i.push(_e(a[e].abbr)),
                i.push(_e(a[e].narrow));
            (this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i")),
              (this._erasNameRegex = new RegExp("^(" + s.join("|") + ")", "i")),
              (this._erasAbbrRegex = new RegExp("^(" + n.join("|") + ")", "i")),
              (this._erasNarrowRegex = new RegExp("^(" + r.join("|") + ")", "i"));
          }
          function on(e, t) {
            q(0, [e, e.length], 0, t);
          }
          function cn(e, t, n, s, r) {
            var i;
            return null == e ? Be(this, s, r).year : (t > (i = He(e, s, r)) && (t = i), ln.call(this, e, t, n, s, r));
          }
          function ln(e, t, n, s, r) {
            var i = xe(e, t, n, s, r),
              a = We(i.year, 0, i.dayOfYear);
            return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
          }
          q("N", 0, 0, "eraAbbr"),
            q("NN", 0, 0, "eraAbbr"),
            q("NNN", 0, 0, "eraAbbr"),
            q("NNNN", 0, 0, "eraName"),
            q("NNNNN", 0, 0, "eraNarrow"),
            q("y", ["y", 1], "yo", "eraYear"),
            q("y", ["yy", 2], 0, "eraYear"),
            q("y", ["yyy", 3], 0, "eraYear"),
            q("y", ["yyyy", 4], 0, "eraYear"),
            pe("N", rn),
            pe("NN", rn),
            pe("NNN", rn),
            pe("NNNN", function (e, t) {
              return t.erasNameRegex(e);
            }),
            pe("NNNNN", function (e, t) {
              return t.erasNarrowRegex(e);
            }),
            ge(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, n, s) {
              var r = n._locale.erasParse(e, s, n._strict);
              r ? (m(n).era = r) : (m(n).invalidEra = e);
            }),
            pe("y", le),
            pe("yy", le),
            pe("yyy", le),
            pe("yyyy", le),
            pe("yo", function (e, t) {
              return t._eraYearOrdinalRegex || le;
            }),
            ge(["y", "yy", "yyy", "yyyy"], 0),
            ge(["yo"], function (e, t, n, s) {
              var r;
              n._locale._eraYearOrdinalRegex && (r = e.match(n._locale._eraYearOrdinalRegex)),
                (t[0] = n._locale.eraYearOrdinalParse ? n._locale.eraYearOrdinalParse(e, r) : parseInt(e, 10));
            }),
            q(0, ["gg", 2], 0, function () {
              return this.weekYear() % 100;
            }),
            q(0, ["GG", 2], 0, function () {
              return this.isoWeekYear() % 100;
            }),
            on("gggg", "weekYear"),
            on("ggggg", "weekYear"),
            on("GGGG", "isoWeekYear"),
            on("GGGGG", "isoWeekYear"),
            j("weekYear", "gg"),
            j("isoWeekYear", "GG"),
            I("weekYear", 1),
            I("isoWeekYear", 1),
            pe("G", de),
            pe("g", de),
            pe("GG", se, Z),
            pe("gg", se, Z),
            pe("GGGG", oe, te),
            pe("gggg", oe, te),
            pe("GGGGG", ce, ne),
            pe("ggggg", ce, ne),
            ye(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, s) {
              t[s.substr(0, 2)] = U(e);
            }),
            ye(["gg", "GG"], function (e, t, n, s) {
              t[s] = r.parseTwoDigitYear(e);
            }),
            q("Q", 0, "Qo", "quarter"),
            j("quarter", "Q"),
            I("quarter", 7),
            pe("Q", $),
            ge("Q", function (e, t) {
              t[1] = 3 * (U(e) - 1);
            }),
            q("D", ["DD", 2], "Do", "date"),
            j("date", "D"),
            I("date", 9),
            pe("D", se),
            pe("DD", se, Z),
            pe("Do", function (e, t) {
              return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
            }),
            ge(["D", "DD"], 2),
            ge("Do", function (e, t) {
              t[2] = U(e.match(se)[0]);
            });
          var dn = J("Date", !0);
          q("DDD", ["DDDD", 3], "DDDo", "dayOfYear"),
            j("dayOfYear", "DDD"),
            I("dayOfYear", 4),
            pe("DDD", ae),
            pe("DDDD", ee),
            ge(["DDD", "DDDD"], function (e, t, n) {
              n._dayOfYear = U(e);
            }),
            q("m", ["mm", 2], 0, "minute"),
            j("minute", "m"),
            I("minute", 14),
            pe("m", se),
            pe("mm", se, Z),
            ge(["m", "mm"], 4);
          var un = J("Minutes", !1);
          q("s", ["ss", 2], 0, "second"),
            j("second", "s"),
            I("second", 15),
            pe("s", se),
            pe("ss", se, Z),
            ge(["s", "ss"], 5);
          var hn,
            Mn,
            pn = J("Seconds", !1);
          for (
            q("S", 0, 0, function () {
              return ~~(this.millisecond() / 100);
            }),
              q(0, ["SS", 2], 0, function () {
                return ~~(this.millisecond() / 10);
              }),
              q(0, ["SSS", 3], 0, "millisecond"),
              q(0, ["SSSS", 4], 0, function () {
                return 10 * this.millisecond();
              }),
              q(0, ["SSSSS", 5], 0, function () {
                return 100 * this.millisecond();
              }),
              q(0, ["SSSSSS", 6], 0, function () {
                return 1e3 * this.millisecond();
              }),
              q(0, ["SSSSSSS", 7], 0, function () {
                return 1e4 * this.millisecond();
              }),
              q(0, ["SSSSSSSS", 8], 0, function () {
                return 1e5 * this.millisecond();
              }),
              q(0, ["SSSSSSSSS", 9], 0, function () {
                return 1e6 * this.millisecond();
              }),
              j("millisecond", "ms"),
              I("millisecond", 16),
              pe("S", ae, $),
              pe("SS", ae, Z),
              pe("SSS", ae, ee),
              hn = "SSSS";
            hn.length <= 9;
            hn += "S"
          )
            pe(hn, le);
          function mn(e, t) {
            t[6] = U(1e3 * ("0." + e));
          }
          for (hn = "S"; hn.length <= 9; hn += "S") ge(hn, mn);
          (Mn = J("Milliseconds", !1)), q("z", 0, 0, "zoneAbbr"), q("zz", 0, 0, "zoneName");
          var _n = L.prototype;
          function fn(e) {
            return e;
          }
          (_n.add = Vt),
            (_n.calendar = function (e, t) {
              1 === arguments.length &&
                (arguments[0]
                  ? Gt(arguments[0])
                    ? ((e = arguments[0]), (t = void 0))
                    : Qt(arguments[0]) && ((t = arguments[0]), (e = void 0))
                  : ((e = void 0), (t = void 0)));
              var n = e || Tt(),
                s = qt(n, this).startOf("day"),
                i = r.calendarFormat(this, s) || "sameElse",
                a = t && (O(t[i]) ? t[i].call(this, n) : t[i]);
              return this.format(a || this.localeData().calendar(i, this, Tt(n)));
            }),
            (_n.clone = function () {
              return new L(this);
            }),
            (_n.diff = function (e, t, n) {
              var s, r, i;
              if (!this.isValid()) return NaN;
              if (!(s = qt(e, this)).isValid()) return NaN;
              switch (((r = 6e4 * (s.utcOffset() - this.utcOffset())), (t = P(t)))) {
                case "year":
                  i = Kt(this, s) / 12;
                  break;
                case "month":
                  i = Kt(this, s);
                  break;
                case "quarter":
                  i = Kt(this, s) / 3;
                  break;
                case "second":
                  i = (this - s) / 1e3;
                  break;
                case "minute":
                  i = (this - s) / 6e4;
                  break;
                case "hour":
                  i = (this - s) / 36e5;
                  break;
                case "day":
                  i = (this - s - r) / 864e5;
                  break;
                case "week":
                  i = (this - s - r) / 6048e5;
                  break;
                default:
                  i = this - s;
              }
              return n ? i : V(i);
            }),
            (_n.endOf = function (e) {
              var t, n;
              if (void 0 === (e = P(e)) || "millisecond" === e || !this.isValid()) return this;
              switch (((n = this._isUTC ? sn : nn), e)) {
                case "year":
                  t = n(this.year() + 1, 0, 1) - 1;
                  break;
                case "quarter":
                  t = n(this.year(), this.month() - (this.month() % 3) + 3, 1) - 1;
                  break;
                case "month":
                  t = n(this.year(), this.month() + 1, 1) - 1;
                  break;
                case "week":
                  t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                  break;
                case "isoWeek":
                  t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                  break;
                case "day":
                case "date":
                  t = n(this.year(), this.month(), this.date() + 1) - 1;
                  break;
                case "hour":
                  (t = this._d.valueOf()), (t += 36e5 - tn(t + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1);
                  break;
                case "minute":
                  (t = this._d.valueOf()), (t += 6e4 - tn(t, 6e4) - 1);
                  break;
                case "second":
                  (t = this._d.valueOf()), (t += 1e3 - tn(t, 1e3) - 1);
              }
              return this._d.setTime(t), r.updateOffset(this, !0), this;
            }),
            (_n.format = function (e) {
              e || (e = this.isUtc() ? r.defaultFormatUtc : r.defaultFormat);
              var t = x(this, e);
              return this.localeData().postformat(t);
            }),
            (_n.from = function (e, t) {
              return this.isValid() && ((A(e) && e.isValid()) || Tt(e).isValid())
                ? Pt({ to: this, from: e }).locale(this.locale()).humanize(!t)
                : this.localeData().invalidDate();
            }),
            (_n.fromNow = function (e) {
              return this.from(Tt(), e);
            }),
            (_n.to = function (e, t) {
              return this.isValid() && ((A(e) && e.isValid()) || Tt(e).isValid())
                ? Pt({ from: this, to: e }).locale(this.locale()).humanize(!t)
                : this.localeData().invalidDate();
            }),
            (_n.toNow = function (e) {
              return this.to(Tt(), e);
            }),
            (_n.get = function (e) {
              return O(this[(e = P(e))]) ? this[e]() : this;
            }),
            (_n.invalidAt = function () {
              return m(this).overflow;
            }),
            (_n.isAfter = function (e, t) {
              var n = A(e) ? e : Tt(e);
              return (
                !(!this.isValid() || !n.isValid()) &&
                ("millisecond" === (t = P(t) || "millisecond")
                  ? this.valueOf() > n.valueOf()
                  : n.valueOf() < this.clone().startOf(t).valueOf())
              );
            }),
            (_n.isBefore = function (e, t) {
              var n = A(e) ? e : Tt(e);
              return (
                !(!this.isValid() || !n.isValid()) &&
                ("millisecond" === (t = P(t) || "millisecond")
                  ? this.valueOf() < n.valueOf()
                  : this.clone().endOf(t).valueOf() < n.valueOf())
              );
            }),
            (_n.isBetween = function (e, t, n, s) {
              var r = A(e) ? e : Tt(e),
                i = A(t) ? t : Tt(t);
              return (
                !!(this.isValid() && r.isValid() && i.isValid()) &&
                ("(" === (s = s || "()")[0] ? this.isAfter(r, n) : !this.isBefore(r, n)) &&
                (")" === s[1] ? this.isBefore(i, n) : !this.isAfter(i, n))
              );
            }),
            (_n.isSame = function (e, t) {
              var n,
                s = A(e) ? e : Tt(e);
              return (
                !(!this.isValid() || !s.isValid()) &&
                ("millisecond" === (t = P(t) || "millisecond")
                  ? this.valueOf() === s.valueOf()
                  : ((n = s.valueOf()), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()))
              );
            }),
            (_n.isSameOrAfter = function (e, t) {
              return this.isSame(e, t) || this.isAfter(e, t);
            }),
            (_n.isSameOrBefore = function (e, t) {
              return this.isSame(e, t) || this.isBefore(e, t);
            }),
            (_n.isValid = function () {
              return _(this);
            }),
            (_n.lang = Zt),
            (_n.locale = $t),
            (_n.localeData = en),
            (_n.max = Dt),
            (_n.min = vt),
            (_n.parsingFlags = function () {
              return M({}, m(this));
            }),
            (_n.set = function (e, t) {
              if ("object" == typeof e) {
                var n,
                  s = (function (e) {
                    var t,
                      n = [];
                    for (t in e) o(e, t) && n.push({ unit: t, priority: R[t] });
                    return (
                      n.sort(function (e, t) {
                        return e.priority - t.priority;
                      }),
                      n
                    );
                  })((e = X(e))),
                  r = s.length;
                for (n = 0; n < r; n++) this[s[n].unit](e[s[n].unit]);
              } else if (O(this[(e = P(e))])) return this[e](t);
              return this;
            }),
            (_n.startOf = function (e) {
              var t, n;
              if (void 0 === (e = P(e)) || "millisecond" === e || !this.isValid()) return this;
              switch (((n = this._isUTC ? sn : nn), e)) {
                case "year":
                  t = n(this.year(), 0, 1);
                  break;
                case "quarter":
                  t = n(this.year(), this.month() - (this.month() % 3), 1);
                  break;
                case "month":
                  t = n(this.year(), this.month(), 1);
                  break;
                case "week":
                  t = n(this.year(), this.month(), this.date() - this.weekday());
                  break;
                case "isoWeek":
                  t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                  break;
                case "day":
                case "date":
                  t = n(this.year(), this.month(), this.date());
                  break;
                case "hour":
                  (t = this._d.valueOf()), (t -= tn(t + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5));
                  break;
                case "minute":
                  (t = this._d.valueOf()), (t -= tn(t, 6e4));
                  break;
                case "second":
                  (t = this._d.valueOf()), (t -= tn(t, 1e3));
              }
              return this._d.setTime(t), r.updateOffset(this, !0), this;
            }),
            (_n.subtract = Ut),
            (_n.toArray = function () {
              var e = this;
              return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
            }),
            (_n.toObject = function () {
              var e = this;
              return {
                years: e.year(),
                months: e.month(),
                date: e.date(),
                hours: e.hours(),
                minutes: e.minutes(),
                seconds: e.seconds(),
                milliseconds: e.milliseconds(),
              };
            }),
            (_n.toDate = function () {
              return new Date(this.valueOf());
            }),
            (_n.toISOString = function (e) {
              if (!this.isValid()) return null;
              var t = !0 !== e,
                n = t ? this.clone().utc() : this;
              return n.year() < 0 || n.year() > 9999
                ? x(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ")
                : O(Date.prototype.toISOString)
                ? t
                  ? this.toDate().toISOString()
                  : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", x(n, "Z"))
                : x(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
            }),
            (_n.inspect = function () {
              if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
              var e,
                t,
                n = "moment",
                s = "";
              return (
                this.isLocal() || ((n = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone"), (s = "Z")),
                (e = "[" + n + '("]'),
                (t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY"),
                this.format(e + t + "-MM-DD[T]HH:mm:ss.SSS" + s + '[")]')
              );
            }),
            "undefined" != typeof Symbol &&
              null != Symbol.for &&
              (_n[Symbol.for("nodejs.util.inspect.custom")] = function () {
                return "Moment<" + this.format() + ">";
              }),
            (_n.toJSON = function () {
              return this.isValid() ? this.toISOString() : null;
            }),
            (_n.toString = function () {
              return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
            }),
            (_n.unix = function () {
              return Math.floor(this.valueOf() / 1e3);
            }),
            (_n.valueOf = function () {
              return this._d.valueOf() - 6e4 * (this._offset || 0);
            }),
            (_n.creationData = function () {
              return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict,
              };
            }),
            (_n.eraName = function () {
              var e,
                t,
                n,
                s = this.localeData().eras();
              for (e = 0, t = s.length; e < t; ++e) {
                if (((n = this.clone().startOf("day").valueOf()), s[e].since <= n && n <= s[e].until)) return s[e].name;
                if (s[e].until <= n && n <= s[e].since) return s[e].name;
              }
              return "";
            }),
            (_n.eraNarrow = function () {
              var e,
                t,
                n,
                s = this.localeData().eras();
              for (e = 0, t = s.length; e < t; ++e) {
                if (((n = this.clone().startOf("day").valueOf()), s[e].since <= n && n <= s[e].until))
                  return s[e].narrow;
                if (s[e].until <= n && n <= s[e].since) return s[e].narrow;
              }
              return "";
            }),
            (_n.eraAbbr = function () {
              var e,
                t,
                n,
                s = this.localeData().eras();
              for (e = 0, t = s.length; e < t; ++e) {
                if (((n = this.clone().startOf("day").valueOf()), s[e].since <= n && n <= s[e].until)) return s[e].abbr;
                if (s[e].until <= n && n <= s[e].since) return s[e].abbr;
              }
              return "";
            }),
            (_n.eraYear = function () {
              var e,
                t,
                n,
                s,
                i = this.localeData().eras();
              for (e = 0, t = i.length; e < t; ++e)
                if (
                  ((n = i[e].since <= i[e].until ? 1 : -1),
                  (s = this.clone().startOf("day").valueOf()),
                  (i[e].since <= s && s <= i[e].until) || (i[e].until <= s && s <= i[e].since))
                )
                  return (this.year() - r(i[e].since).year()) * n + i[e].offset;
              return this.year();
            }),
            (_n.year = Ee),
            (_n.isLeapYear = function () {
              return F(this.year());
            }),
            (_n.weekYear = function (e) {
              return cn.call(
                this,
                e,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy
              );
            }),
            (_n.isoWeekYear = function (e) {
              return cn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
            }),
            (_n.quarter = _n.quarters =
              function (e) {
                return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + (this.month() % 3));
              }),
            (_n.month = ke),
            (_n.daysInMonth = function () {
              return Ae(this.year(), this.month());
            }),
            (_n.week = _n.weeks =
              function (e) {
                var t = this.localeData().week(this);
                return null == e ? t : this.add(7 * (e - t), "d");
              }),
            (_n.isoWeek = _n.isoWeeks =
              function (e) {
                var t = Be(this, 1, 4).week;
                return null == e ? t : this.add(7 * (e - t), "d");
              }),
            (_n.weeksInYear = function () {
              var e = this.localeData()._week;
              return He(this.year(), e.dow, e.doy);
            }),
            (_n.weeksInWeekYear = function () {
              var e = this.localeData()._week;
              return He(this.weekYear(), e.dow, e.doy);
            }),
            (_n.isoWeeksInYear = function () {
              return He(this.year(), 1, 4);
            }),
            (_n.isoWeeksInISOWeekYear = function () {
              return He(this.isoWeekYear(), 1, 4);
            }),
            (_n.date = dn),
            (_n.day = _n.days =
              function (e) {
                if (!this.isValid()) return null != e ? this : NaN;
                var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                return null != e
                  ? ((e = (function (e, t) {
                      return "string" != typeof e
                        ? e
                        : isNaN(e)
                        ? "number" == typeof (e = t.weekdaysParse(e))
                          ? e
                          : null
                        : parseInt(e, 10);
                    })(e, this.localeData())),
                    this.add(e - t, "d"))
                  : t;
              }),
            (_n.weekday = function (e) {
              if (!this.isValid()) return null != e ? this : NaN;
              var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
              return null == e ? t : this.add(e - t, "d");
            }),
            (_n.isoWeekday = function (e) {
              if (!this.isValid()) return null != e ? this : NaN;
              if (null != e) {
                var t = (function (e, t) {
                  return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
                })(e, this.localeData());
                return this.day(this.day() % 7 ? t : t - 7);
              }
              return this.day() || 7;
            }),
            (_n.dayOfYear = function (e) {
              var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
              return null == e ? t : this.add(e - t, "d");
            }),
            (_n.hour = _n.hours = Ze),
            (_n.minute = _n.minutes = un),
            (_n.second = _n.seconds = pn),
            (_n.millisecond = _n.milliseconds = Mn),
            (_n.utcOffset = function (e, t, n) {
              var s,
                i = this._offset || 0;
              if (!this.isValid()) return null != e ? this : NaN;
              if (null != e) {
                if ("string" == typeof e) {
                  if (null === (e = Wt(he, e))) return this;
                } else Math.abs(e) < 16 && !n && (e *= 60);
                return (
                  !this._isUTC && t && (s = xt(this)),
                  (this._offset = e),
                  (this._isUTC = !0),
                  null != s && this.add(s, "m"),
                  i !== e &&
                    (!t || this._changeInProgress
                      ? Ft(this, Pt(e - i, "m"), 1, !1)
                      : this._changeInProgress ||
                        ((this._changeInProgress = !0), r.updateOffset(this, !0), (this._changeInProgress = null))),
                  this
                );
              }
              return this._isUTC ? i : xt(this);
            }),
            (_n.utc = function (e) {
              return this.utcOffset(0, e);
            }),
            (_n.local = function (e) {
              return this._isUTC && (this.utcOffset(0, e), (this._isUTC = !1), e && this.subtract(xt(this), "m")), this;
            }),
            (_n.parseZone = function () {
              if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
              else if ("string" == typeof this._i) {
                var e = Wt(ue, this._i);
                null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
              }
              return this;
            }),
            (_n.hasAlignedHourOffset = function (e) {
              return !!this.isValid() && ((e = e ? Tt(e).utcOffset() : 0), (this.utcOffset() - e) % 60 == 0);
            }),
            (_n.isDST = function () {
              return (
                this.utcOffset() > this.clone().month(0).utcOffset() ||
                this.utcOffset() > this.clone().month(5).utcOffset()
              );
            }),
            (_n.isLocal = function () {
              return !!this.isValid() && !this._isUTC;
            }),
            (_n.isUtcOffset = function () {
              return !!this.isValid() && this._isUTC;
            }),
            (_n.isUtc = Bt),
            (_n.isUTC = Bt),
            (_n.zoneAbbr = function () {
              return this._isUTC ? "UTC" : "";
            }),
            (_n.zoneName = function () {
              return this._isUTC ? "Coordinated Universal Time" : "";
            }),
            (_n.dates = z("dates accessor is deprecated. Use date instead.", dn)),
            (_n.months = z("months accessor is deprecated. Use month instead", ke)),
            (_n.years = z("years accessor is deprecated. Use year instead", Ee)),
            (_n.zone = z(
              "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
              function (e, t) {
                return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
              }
            )),
            (_n.isDSTShifted = z(
              "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
              function () {
                if (!l(this._isDSTShifted)) return this._isDSTShifted;
                var e,
                  t = {};
                return (
                  y(t, this),
                  (t = wt(t))._a
                    ? ((e = t._isUTC ? p(t._a) : Tt(t._a)),
                      (this._isDSTShifted =
                        this.isValid() &&
                        (function (e, t, n) {
                          var s,
                            r = Math.min(e.length, t.length),
                            i = Math.abs(e.length - t.length),
                            a = 0;
                          for (s = 0; s < r; s++) U(e[s]) !== U(t[s]) && a++;
                          return a + i;
                        })(t._a, e.toArray()) > 0))
                    : (this._isDSTShifted = !1),
                  this._isDSTShifted
                );
              }
            ));
          var bn = k.prototype;
          function gn(e, t, n, s) {
            var r = ct(),
              i = p().set(s, t);
            return r[n](i, e);
          }
          function yn(e, t, n) {
            if ((d(e) && ((t = e), (e = void 0)), (e = e || ""), null != t)) return gn(e, t, n, "month");
            var s,
              r = [];
            for (s = 0; s < 12; s++) r[s] = gn(e, s, n, "month");
            return r;
          }
          function Ln(e, t, n, s) {
            "boolean" == typeof e
              ? (d(t) && ((n = t), (t = void 0)), (t = t || ""))
              : ((n = t = e), (e = !1), d(t) && ((n = t), (t = void 0)), (t = t || ""));
            var r,
              i = ct(),
              a = e ? i._week.dow : 0,
              o = [];
            if (null != n) return gn(t, (n + a) % 7, s, "day");
            for (r = 0; r < 7; r++) o[r] = gn(t, (r + a) % 7, s, "day");
            return o;
          }
          (bn.calendar = function (e, t, n) {
            var s = this._calendar[e] || this._calendar.sameElse;
            return O(s) ? s.call(t, n) : s;
          }),
            (bn.longDateFormat = function (e) {
              var t = this._longDateFormat[e],
                n = this._longDateFormat[e.toUpperCase()];
              return t || !n
                ? t
                : ((this._longDateFormat[e] = n
                    .match(N)
                    .map(function (e) {
                      return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
                    })
                    .join("")),
                  this._longDateFormat[e]);
            }),
            (bn.invalidDate = function () {
              return this._invalidDate;
            }),
            (bn.ordinal = function (e) {
              return this._ordinal.replace("%d", e);
            }),
            (bn.preparse = fn),
            (bn.postformat = fn),
            (bn.relativeTime = function (e, t, n, s) {
              var r = this._relativeTime[n];
              return O(r) ? r(e, t, n, s) : r.replace(/%d/i, e);
            }),
            (bn.pastFuture = function (e, t) {
              var n = this._relativeTime[e > 0 ? "future" : "past"];
              return O(n) ? n(t) : n.replace(/%s/i, t);
            }),
            (bn.set = function (e) {
              var t, n;
              for (n in e) o(e, n) && (O((t = e[n])) ? (this[n] = t) : (this["_" + n] = t));
              (this._config = e),
                (this._dayOfMonthOrdinalParseLenient = new RegExp(
                  (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
                ));
            }),
            (bn.eras = function (e, t) {
              var n,
                s,
                i,
                a = this._eras || ct("en")._eras;
              for (n = 0, s = a.length; n < s; ++n) {
                switch (typeof a[n].since) {
                  case "string":
                    (i = r(a[n].since).startOf("day")), (a[n].since = i.valueOf());
                }
                switch (typeof a[n].until) {
                  case "undefined":
                    a[n].until = 1 / 0;
                    break;
                  case "string":
                    (i = r(a[n].until).startOf("day").valueOf()), (a[n].until = i.valueOf());
                }
              }
              return a;
            }),
            (bn.erasParse = function (e, t, n) {
              var s,
                r,
                i,
                a,
                o,
                c = this.eras();
              for (e = e.toUpperCase(), s = 0, r = c.length; s < r; ++s)
                if (((i = c[s].name.toUpperCase()), (a = c[s].abbr.toUpperCase()), (o = c[s].narrow.toUpperCase()), n))
                  switch (t) {
                    case "N":
                    case "NN":
                    case "NNN":
                      if (a === e) return c[s];
                      break;
                    case "NNNN":
                      if (i === e) return c[s];
                      break;
                    case "NNNNN":
                      if (o === e) return c[s];
                  }
                else if ([i, a, o].indexOf(e) >= 0) return c[s];
            }),
            (bn.erasConvertYear = function (e, t) {
              var n = e.since <= e.until ? 1 : -1;
              return void 0 === t ? r(e.since).year() : r(e.since).year() + (t - e.offset) * n;
            }),
            (bn.erasAbbrRegex = function (e) {
              return o(this, "_erasAbbrRegex") || an.call(this), e ? this._erasAbbrRegex : this._erasRegex;
            }),
            (bn.erasNameRegex = function (e) {
              return o(this, "_erasNameRegex") || an.call(this), e ? this._erasNameRegex : this._erasRegex;
            }),
            (bn.erasNarrowRegex = function (e) {
              return o(this, "_erasNarrowRegex") || an.call(this), e ? this._erasNarrowRegex : this._erasRegex;
            }),
            (bn.months = function (e, t) {
              return e
                ? i(this._months)
                  ? this._months[e.month()]
                  : this._months[(this._months.isFormat || Te).test(t) ? "format" : "standalone"][e.month()]
                : i(this._months)
                ? this._months
                : this._months.standalone;
            }),
            (bn.monthsShort = function (e, t) {
              return e
                ? i(this._monthsShort)
                  ? this._monthsShort[e.month()]
                  : this._monthsShort[Te.test(t) ? "format" : "standalone"][e.month()]
                : i(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort.standalone;
            }),
            (bn.monthsParse = function (e, t, n) {
              var s, r, i;
              if (this._monthsParseExact) return Oe.call(this, e, t, n);
              for (
                this._monthsParse ||
                  ((this._monthsParse = []), (this._longMonthsParse = []), (this._shortMonthsParse = [])),
                  s = 0;
                s < 12;
                s++
              ) {
                if (
                  ((r = p([2e3, s])),
                  n &&
                    !this._longMonthsParse[s] &&
                    ((this._longMonthsParse[s] = new RegExp("^" + this.months(r, "").replace(".", "") + "$", "i")),
                    (this._shortMonthsParse[s] = new RegExp(
                      "^" + this.monthsShort(r, "").replace(".", "") + "$",
                      "i"
                    ))),
                  n ||
                    this._monthsParse[s] ||
                    ((i = "^" + this.months(r, "") + "|^" + this.monthsShort(r, "")),
                    (this._monthsParse[s] = new RegExp(i.replace(".", ""), "i"))),
                  n && "MMMM" === t && this._longMonthsParse[s].test(e))
                )
                  return s;
                if (n && "MMM" === t && this._shortMonthsParse[s].test(e)) return s;
                if (!n && this._monthsParse[s].test(e)) return s;
              }
            }),
            (bn.monthsRegex = function (e) {
              return this._monthsParseExact
                ? (o(this, "_monthsRegex") || Ye.call(this), e ? this._monthsStrictRegex : this._monthsRegex)
                : (o(this, "_monthsRegex") || (this._monthsRegex = De),
                  this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
            }),
            (bn.monthsShortRegex = function (e) {
              return this._monthsParseExact
                ? (o(this, "_monthsRegex") || Ye.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex)
                : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = ve),
                  this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
            }),
            (bn.week = function (e) {
              return Be(e, this._week.dow, this._week.doy).week;
            }),
            (bn.firstDayOfYear = function () {
              return this._week.doy;
            }),
            (bn.firstDayOfWeek = function () {
              return this._week.dow;
            }),
            (bn.weekdays = function (e, t) {
              var n = i(this._weekdays)
                ? this._weekdays
                : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
              return !0 === e ? je(n, this._week.dow) : e ? n[e.day()] : n;
            }),
            (bn.weekdaysMin = function (e) {
              return !0 === e
                ? je(this._weekdaysMin, this._week.dow)
                : e
                ? this._weekdaysMin[e.day()]
                : this._weekdaysMin;
            }),
            (bn.weekdaysShort = function (e) {
              return !0 === e
                ? je(this._weekdaysShort, this._week.dow)
                : e
                ? this._weekdaysShort[e.day()]
                : this._weekdaysShort;
            }),
            (bn.weekdaysParse = function (e, t, n) {
              var s, r, i;
              if (this._weekdaysParseExact) return Ue.call(this, e, t, n);
              for (
                this._weekdaysParse ||
                  ((this._weekdaysParse = []),
                  (this._minWeekdaysParse = []),
                  (this._shortWeekdaysParse = []),
                  (this._fullWeekdaysParse = [])),
                  s = 0;
                s < 7;
                s++
              ) {
                if (
                  ((r = p([2e3, 1]).day(s)),
                  n &&
                    !this._fullWeekdaysParse[s] &&
                    ((this._fullWeekdaysParse[s] = new RegExp(
                      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
                      "i"
                    )),
                    (this._shortWeekdaysParse[s] = new RegExp(
                      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
                      "i"
                    )),
                    (this._minWeekdaysParse[s] = new RegExp(
                      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
                      "i"
                    ))),
                  this._weekdaysParse[s] ||
                    ((i =
                      "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, "")),
                    (this._weekdaysParse[s] = new RegExp(i.replace(".", ""), "i"))),
                  n && "dddd" === t && this._fullWeekdaysParse[s].test(e))
                )
                  return s;
                if (n && "ddd" === t && this._shortWeekdaysParse[s].test(e)) return s;
                if (n && "dd" === t && this._minWeekdaysParse[s].test(e)) return s;
                if (!n && this._weekdaysParse[s].test(e)) return s;
              }
            }),
            (bn.weekdaysRegex = function (e) {
              return this._weekdaysParseExact
                ? (o(this, "_weekdaysRegex") || Je.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex)
                : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = Ie),
                  this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
            }),
            (bn.weekdaysShortRegex = function (e) {
              return this._weekdaysParseExact
                ? (o(this, "_weekdaysRegex") || Je.call(this),
                  e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
                : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Fe),
                  this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
            }),
            (bn.weekdaysMinRegex = function (e) {
              return this._weekdaysParseExact
                ? (o(this, "_weekdaysRegex") || Je.call(this),
                  e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
                : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Ve),
                  this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
            }),
            (bn.isPM = function (e) {
              return "p" === (e + "").toLowerCase().charAt(0);
            }),
            (bn.meridiem = function (e, t, n) {
              return e > 11 ? (n ? "pm" : "PM") : n ? "am" : "AM";
            }),
            at("en", {
              eras: [
                { since: "0001-01-01", until: 1 / 0, offset: 1, name: "Anno Domini", narrow: "AD", abbr: "AD" },
                { since: "0000-12-31", until: -1 / 0, offset: 1, name: "Before Christ", narrow: "BC", abbr: "BC" },
              ],
              dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
              ordinal: function (e) {
                var t = e % 10;
                return e + (1 === U((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
              },
            }),
            (r.lang = z("moment.lang is deprecated. Use moment.locale instead.", at)),
            (r.langData = z("moment.langData is deprecated. Use moment.localeData instead.", ct));
          var An = Math.abs;
          function wn(e, t, n, s) {
            var r = Pt(t, n);
            return (
              (e._milliseconds += s * r._milliseconds),
              (e._days += s * r._days),
              (e._months += s * r._months),
              e._bubble()
            );
          }
          function zn(e) {
            return e < 0 ? Math.floor(e) : Math.ceil(e);
          }
          function Tn(e) {
            return (4800 * e) / 146097;
          }
          function vn(e) {
            return (146097 * e) / 4800;
          }
          function Dn(e) {
            return function () {
              return this.as(e);
            };
          }
          var On = Dn("ms"),
            Sn = Dn("s"),
            kn = Dn("m"),
            Yn = Dn("h"),
            Nn = Dn("d"),
            En = Dn("w"),
            Cn = Dn("M"),
            Wn = Dn("Q"),
            qn = Dn("y");
          function xn(e) {
            return function () {
              return this.isValid() ? this._data[e] : NaN;
            };
          }
          var Bn = xn("milliseconds"),
            Hn = xn("seconds"),
            jn = xn("minutes"),
            Pn = xn("hours"),
            Xn = xn("days"),
            Rn = xn("months"),
            In = xn("years"),
            Fn = Math.round,
            Vn = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };
          function Un(e, t, n, s, r) {
            return r.relativeTime(t || 1, !!n, e, s);
          }
          var Jn = Math.abs;
          function Gn(e) {
            return (e > 0) - (e < 0) || +e;
          }
          function Qn() {
            if (!this.isValid()) return this.localeData().invalidDate();
            var e,
              t,
              n,
              s,
              r,
              i,
              a,
              o,
              c = Jn(this._milliseconds) / 1e3,
              l = Jn(this._days),
              d = Jn(this._months),
              u = this.asSeconds();
            return u
              ? ((e = V(c / 60)),
                (t = V(e / 60)),
                (c %= 60),
                (e %= 60),
                (n = V(d / 12)),
                (d %= 12),
                (s = c ? c.toFixed(3).replace(/\.?0+$/, "") : ""),
                (r = u < 0 ? "-" : ""),
                (i = Gn(this._months) !== Gn(u) ? "-" : ""),
                (a = Gn(this._days) !== Gn(u) ? "-" : ""),
                (o = Gn(this._milliseconds) !== Gn(u) ? "-" : ""),
                r +
                  "P" +
                  (n ? i + n + "Y" : "") +
                  (d ? i + d + "M" : "") +
                  (l ? a + l + "D" : "") +
                  (t || e || c ? "T" : "") +
                  (t ? o + t + "H" : "") +
                  (e ? o + e + "M" : "") +
                  (c ? o + s + "S" : ""))
              : "P0D";
          }
          var Kn = kt.prototype;
          return (
            (Kn.isValid = function () {
              return this._isValid;
            }),
            (Kn.abs = function () {
              var e = this._data;
              return (
                (this._milliseconds = An(this._milliseconds)),
                (this._days = An(this._days)),
                (this._months = An(this._months)),
                (e.milliseconds = An(e.milliseconds)),
                (e.seconds = An(e.seconds)),
                (e.minutes = An(e.minutes)),
                (e.hours = An(e.hours)),
                (e.months = An(e.months)),
                (e.years = An(e.years)),
                this
              );
            }),
            (Kn.add = function (e, t) {
              return wn(this, e, t, 1);
            }),
            (Kn.subtract = function (e, t) {
              return wn(this, e, t, -1);
            }),
            (Kn.as = function (e) {
              if (!this.isValid()) return NaN;
              var t,
                n,
                s = this._milliseconds;
              if ("month" === (e = P(e)) || "quarter" === e || "year" === e)
                switch (((n = this._months + Tn((t = this._days + s / 864e5))), e)) {
                  case "month":
                    return n;
                  case "quarter":
                    return n / 3;
                  case "year":
                    return n / 12;
                }
              else
                switch (((t = this._days + Math.round(vn(this._months))), e)) {
                  case "week":
                    return t / 7 + s / 6048e5;
                  case "day":
                    return t + s / 864e5;
                  case "hour":
                    return 24 * t + s / 36e5;
                  case "minute":
                    return 1440 * t + s / 6e4;
                  case "second":
                    return 86400 * t + s / 1e3;
                  case "millisecond":
                    return Math.floor(864e5 * t) + s;
                  default:
                    throw new Error("Unknown unit " + e);
                }
            }),
            (Kn.asMilliseconds = On),
            (Kn.asSeconds = Sn),
            (Kn.asMinutes = kn),
            (Kn.asHours = Yn),
            (Kn.asDays = Nn),
            (Kn.asWeeks = En),
            (Kn.asMonths = Cn),
            (Kn.asQuarters = Wn),
            (Kn.asYears = qn),
            (Kn.valueOf = function () {
              return this.isValid()
                ? this._milliseconds +
                    864e5 * this._days +
                    (this._months % 12) * 2592e6 +
                    31536e6 * U(this._months / 12)
                : NaN;
            }),
            (Kn._bubble = function () {
              var e,
                t,
                n,
                s,
                r,
                i = this._milliseconds,
                a = this._days,
                o = this._months,
                c = this._data;
              return (
                (i >= 0 && a >= 0 && o >= 0) ||
                  (i <= 0 && a <= 0 && o <= 0) ||
                  ((i += 864e5 * zn(vn(o) + a)), (a = 0), (o = 0)),
                (c.milliseconds = i % 1e3),
                (e = V(i / 1e3)),
                (c.seconds = e % 60),
                (t = V(e / 60)),
                (c.minutes = t % 60),
                (n = V(t / 60)),
                (c.hours = n % 24),
                (a += V(n / 24)),
                (o += r = V(Tn(a))),
                (a -= zn(vn(r))),
                (s = V(o / 12)),
                (o %= 12),
                (c.days = a),
                (c.months = o),
                (c.years = s),
                this
              );
            }),
            (Kn.clone = function () {
              return Pt(this);
            }),
            (Kn.get = function (e) {
              return (e = P(e)), this.isValid() ? this[e + "s"]() : NaN;
            }),
            (Kn.milliseconds = Bn),
            (Kn.seconds = Hn),
            (Kn.minutes = jn),
            (Kn.hours = Pn),
            (Kn.days = Xn),
            (Kn.weeks = function () {
              return V(this.days() / 7);
            }),
            (Kn.months = Rn),
            (Kn.years = In),
            (Kn.humanize = function (e, t) {
              if (!this.isValid()) return this.localeData().invalidDate();
              var n,
                s,
                r = !1,
                i = Vn;
              return (
                "object" == typeof e && ((t = e), (e = !1)),
                "boolean" == typeof e && (r = e),
                "object" == typeof t &&
                  ((i = Object.assign({}, Vn, t)), null != t.s && null == t.ss && (i.ss = t.s - 1)),
                (s = (function (e, t, n, s) {
                  var r = Pt(e).abs(),
                    i = Fn(r.as("s")),
                    a = Fn(r.as("m")),
                    o = Fn(r.as("h")),
                    c = Fn(r.as("d")),
                    l = Fn(r.as("M")),
                    d = Fn(r.as("w")),
                    u = Fn(r.as("y")),
                    h =
                      (i <= n.ss && ["s", i]) ||
                      (i < n.s && ["ss", i]) ||
                      (a <= 1 && ["m"]) ||
                      (a < n.m && ["mm", a]) ||
                      (o <= 1 && ["h"]) ||
                      (o < n.h && ["hh", o]) ||
                      (c <= 1 && ["d"]) ||
                      (c < n.d && ["dd", c]);
                  return (
                    null != n.w && (h = h || (d <= 1 && ["w"]) || (d < n.w && ["ww", d])),
                    ((h = h || (l <= 1 && ["M"]) || (l < n.M && ["MM", l]) || (u <= 1 && ["y"]) || ["yy", u])[2] = t),
                    (h[3] = +e > 0),
                    (h[4] = s),
                    Un.apply(null, h)
                  );
                })(this, !r, i, (n = this.localeData()))),
                r && (s = n.pastFuture(+this, s)),
                n.postformat(s)
              );
            }),
            (Kn.toISOString = Qn),
            (Kn.toString = Qn),
            (Kn.toJSON = Qn),
            (Kn.locale = $t),
            (Kn.localeData = en),
            (Kn.toIsoString = z(
              "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
              Qn
            )),
            (Kn.lang = Zt),
            q("X", 0, 0, "unix"),
            q("x", 0, 0, "valueOf"),
            pe("x", de),
            pe("X", /[+-]?\d+(\.\d{1,3})?/),
            ge("X", function (e, t, n) {
              n._d = new Date(1e3 * parseFloat(e));
            }),
            ge("x", function (e, t, n) {
              n._d = new Date(U(e));
            }),
            (r.version = "2.29.3"),
            (t = Tt),
            (r.fn = _n),
            (r.min = function () {
              return Ot("isBefore", [].slice.call(arguments, 0));
            }),
            (r.max = function () {
              return Ot("isAfter", [].slice.call(arguments, 0));
            }),
            (r.now = function () {
              return Date.now ? Date.now() : +new Date();
            }),
            (r.utc = p),
            (r.unix = function (e) {
              return Tt(1e3 * e);
            }),
            (r.months = function (e, t) {
              return yn(e, t, "months");
            }),
            (r.isDate = u),
            (r.locale = at),
            (r.invalid = f),
            (r.duration = Pt),
            (r.isMoment = A),
            (r.weekdays = function (e, t, n) {
              return Ln(e, t, n, "weekdays");
            }),
            (r.parseZone = function () {
              return Tt.apply(null, arguments).parseZone();
            }),
            (r.localeData = ct),
            (r.isDuration = Yt),
            (r.monthsShort = function (e, t) {
              return yn(e, t, "monthsShort");
            }),
            (r.weekdaysMin = function (e, t, n) {
              return Ln(e, t, n, "weekdaysMin");
            }),
            (r.defineLocale = ot),
            (r.updateLocale = function (e, t) {
              if (null != t) {
                var n,
                  s,
                  r = et;
                null != tt[e] && null != tt[e].parentLocale
                  ? tt[e].set(S(tt[e]._config, t))
                  : (null != (s = it(e)) && (r = s._config),
                    (t = S(r, t)),
                    null == s && (t.abbr = e),
                    ((n = new k(t)).parentLocale = tt[e]),
                    (tt[e] = n)),
                  at(e);
              } else
                null != tt[e] &&
                  (null != tt[e].parentLocale
                    ? ((tt[e] = tt[e].parentLocale), e === at() && at(e))
                    : null != tt[e] && delete tt[e]);
              return tt[e];
            }),
            (r.locales = function () {
              return T(tt);
            }),
            (r.weekdaysShort = function (e, t, n) {
              return Ln(e, t, n, "weekdaysShort");
            }),
            (r.normalizeUnits = P),
            (r.relativeTimeRounding = function (e) {
              return void 0 === e ? Fn : "function" == typeof e && ((Fn = e), !0);
            }),
            (r.relativeTimeThreshold = function (e, t) {
              return void 0 !== Vn[e] && (void 0 === t ? Vn[e] : ((Vn[e] = t), "s" === e && (Vn.ss = t - 1), !0));
            }),
            (r.calendarFormat = function (e, t) {
              var n = e.diff(t, "days", !0);
              return n < -6
                ? "sameElse"
                : n < -1
                ? "lastWeek"
                : n < 0
                ? "lastDay"
                : n < 1
                ? "sameDay"
                : n < 2
                ? "nextDay"
                : n < 7
                ? "nextWeek"
                : "sameElse";
            }),
            (r.prototype = _n),
            (r.HTML5_FMT = {
              DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
              DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
              DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
              DATE: "YYYY-MM-DD",
              TIME: "HH:mm",
              TIME_SECONDS: "HH:mm:ss",
              TIME_MS: "HH:mm:ss.SSS",
              WEEK: "GGGG-[W]WW",
              MONTH: "YYYY-MM",
            }),
            r
          );
        })();
      }).call(this, n("aYSr")(e));
    },
    xBDH: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("zh-tw", {
          months:
            "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
              "_"
            ),
          monthsShort:
            "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
              "_"
            ),
          weekdays:
            "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
              "_"
            ),
          weekdaysShort:
            "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),
          weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            l: "YYYY/M/D",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
          },
          meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
          meridiemHour: function (e, t) {
            return (
              12 === e && (e = 0),
              "\u51cc\u6668" === t || "\u65e9\u4e0a" === t || "\u4e0a\u5348" === t
                ? e
                : "\u4e2d\u5348" === t
                ? e >= 11
                  ? e
                  : e + 12
                : "\u4e0b\u5348" === t || "\u665a\u4e0a" === t
                ? e + 12
                : void 0
            );
          },
          meridiem: function (e, t, n) {
            var s = 100 * e + t;
            return s < 600
              ? "\u51cc\u6668"
              : s < 900
              ? "\u65e9\u4e0a"
              : s < 1130
              ? "\u4e0a\u5348"
              : s < 1230
              ? "\u4e2d\u5348"
              : s < 1800
              ? "\u4e0b\u5348"
              : "\u665a\u4e0a";
          },
          calendar: {
            sameDay: "[\u4eca\u5929] LT",
            nextDay: "[\u660e\u5929] LT",
            nextWeek: "[\u4e0b]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4e0a]dddd LT",
            sameElse: "L",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
          ordinal: function (e, t) {
            switch (t) {
              case "d":
              case "D":
              case "DDD":
                return e + "\u65e5";
              case "M":
                return e + "\u6708";
              case "w":
              case "W":
                return e + "\u9031";
              default:
                return e;
            }
          },
          relativeTime: {
            future: "%s\u5f8c",
            past: "%s\u524d",
            s: "\u5e7e\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5c0f\u6642",
            hh: "%d \u5c0f\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500b\u6708",
            MM: "%d \u500b\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74",
          },
        });
      })(n("wgY5"));
    },
    "xD/0": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("it", {
          months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
            "_"
          ),
          monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
          weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
          weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
          weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: function () {
              return "[Oggi a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            nextDay: function () {
              return "[Domani a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            nextWeek: function () {
              return "dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            lastDay: function () {
              return "[Ieri a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            lastWeek: function () {
              switch (this.day()) {
                case 0:
                  return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
                default:
                  return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
              }
            },
            sameElse: "L",
          },
          relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "alcuni secondi",
            ss: "%d secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            w: "una settimana",
            ww: "%d settimane",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni",
          },
          dayOfMonthOrdinalParse: /\d{1,2}\xba/,
          ordinal: "%d\xba",
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    yKzn: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-ie", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    zO4H: function (e, t, n) {
      !(function (e) {
        "use strict";
        var t = {
          1: "'inji",
          5: "'inji",
          8: "'inji",
          70: "'inji",
          80: "'inji",
          2: "'nji",
          7: "'nji",
          20: "'nji",
          50: "'nji",
          3: "'\xfcnji",
          4: "'\xfcnji",
          100: "'\xfcnji",
          6: "'njy",
          9: "'unjy",
          10: "'unjy",
          30: "'unjy",
          60: "'ynjy",
          90: "'ynjy",
        };
        e.defineLocale("tk", {
          months:
            "\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split(
              "_"
            ),
          monthsShort: "\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split("_"),
          weekdays: "\xddek\u015fenbe_Du\u015fenbe_Si\u015fenbe_\xc7ar\u015fenbe_Pen\u015fenbe_Anna_\u015eenbe".split(
            "_"
          ),
          weekdaysShort: "\xddek_Du\u015f_Si\u015f_\xc7ar_Pen_Ann_\u015een".split("_"),
          weekdaysMin: "\xddk_D\u015f_S\u015f_\xc7r_Pn_An_\u015en".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[bug\xfcn sagat] LT",
            nextDay: "[ertir sagat] LT",
            nextWeek: "[indiki] dddd [sagat] LT",
            lastDay: "[d\xfc\xfdn] LT",
            lastWeek: "[ge\xe7en] dddd [sagat] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "%s so\u0148",
            past: "%s \xf6\u0148",
            s: "birn\xe4\xe7e sekunt",
            m: "bir minut",
            mm: "%d minut",
            h: "bir sagat",
            hh: "%d sagat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir a\xfd",
            MM: "%d a\xfd",
            y: "bir \xfdyl",
            yy: "%d \xfdyl",
          },
          ordinal: function (e, n) {
            switch (n) {
              case "d":
              case "D":
              case "Do":
              case "DD":
                return e;
              default:
                if (0 === e) return e + "'unjy";
                var s = e % 10;
                return e + (t[s] || t[(e % 100) - s] || t[e >= 100 ? 100 : null]);
            }
          },
          week: { dow: 1, doy: 7 },
        });
      })(n("wgY5"));
    },
    zS0P: function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("en-sg", {
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 == ~~((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    zUnb: function (e, t, n) {
      "use strict";
      function s(e) {
        return "function" == typeof e;
      }
      n.r(t);
      let r = !1;
      const i = {
        Promise: void 0,
        set useDeprecatedSynchronousErrorHandling(e) {
          if (e) {
            const e = new Error();
            console.warn(
              "DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + e.stack
            );
          } else r && console.log("RxJS: Back to a better error behavior. Thank you. <3");
          r = e;
        },
        get useDeprecatedSynchronousErrorHandling() {
          return r;
        },
      };
      function a(e) {
        setTimeout(() => {
          throw e;
        }, 0);
      }
      const o = {
          closed: !0,
          next(e) {},
          error(e) {
            if (i.useDeprecatedSynchronousErrorHandling) throw e;
            a(e);
          },
          complete() {},
        },
        c = (() => Array.isArray || ((e) => e && "number" == typeof e.length))();
      function l(e) {
        return null !== e && "object" == typeof e;
      }
      const d = (() => {
        function e(e) {
          return (
            Error.call(this),
            (this.message = e
              ? `${e.length} errors occurred during unsubscription:\n${e
                  .map((e, t) => `${t + 1}) ${e.toString()}`)
                  .join("\n  ")}`
              : ""),
            (this.name = "UnsubscriptionError"),
            (this.errors = e),
            this
          );
        }
        return (e.prototype = Object.create(Error.prototype)), e;
      })();
      let u = (() => {
        class e {
          constructor(e) {
            (this.closed = !1),
              (this._parentOrParents = null),
              (this._subscriptions = null),
              e && ((this._ctorUnsubscribe = !0), (this._unsubscribe = e));
          }
          unsubscribe() {
            let t;
            if (this.closed) return;
            let { _parentOrParents: n, _ctorUnsubscribe: r, _unsubscribe: i, _subscriptions: a } = this;
            if (((this.closed = !0), (this._parentOrParents = null), (this._subscriptions = null), n instanceof e))
              n.remove(this);
            else if (null !== n) for (let e = 0; e < n.length; ++e) n[e].remove(this);
            if (s(i)) {
              r && (this._unsubscribe = void 0);
              try {
                i.call(this);
              } catch (o) {
                t = o instanceof d ? h(o.errors) : [o];
              }
            }
            if (c(a)) {
              let e = -1,
                n = a.length;
              for (; ++e < n; ) {
                const n = a[e];
                if (l(n))
                  try {
                    n.unsubscribe();
                  } catch (o) {
                    (t = t || []), o instanceof d ? (t = t.concat(h(o.errors))) : t.push(o);
                  }
              }
            }
            if (t) throw new d(t);
          }
          add(t) {
            let n = t;
            if (!t) return e.EMPTY;
            switch (typeof t) {
              case "function":
                n = new e(t);
              case "object":
                if (n === this || n.closed || "function" != typeof n.unsubscribe) return n;
                if (this.closed) return n.unsubscribe(), n;
                if (!(n instanceof e)) {
                  const t = n;
                  (n = new e()), (n._subscriptions = [t]);
                }
                break;
              default:
                throw new Error("unrecognized teardown " + t + " added to Subscription.");
            }
            let { _parentOrParents: s } = n;
            if (null === s) n._parentOrParents = this;
            else if (s instanceof e) {
              if (s === this) return n;
              n._parentOrParents = [s, this];
            } else {
              if (-1 !== s.indexOf(this)) return n;
              s.push(this);
            }
            const r = this._subscriptions;
            return null === r ? (this._subscriptions = [n]) : r.push(n), n;
          }
          remove(e) {
            const t = this._subscriptions;
            if (t) {
              const n = t.indexOf(e);
              -1 !== n && t.splice(n, 1);
            }
          }
        }
        return (
          (e.EMPTY = (function (e) {
            return (e.closed = !0), e;
          })(new e())),
          e
        );
      })();
      function h(e) {
        return e.reduce((e, t) => e.concat(t instanceof d ? t.errors : t), []);
      }
      const M = (() => ("function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random()))();
      class p extends u {
        constructor(e, t, n) {
          switch (
            (super(),
            (this.syncErrorValue = null),
            (this.syncErrorThrown = !1),
            (this.syncErrorThrowable = !1),
            (this.isStopped = !1),
            arguments.length)
          ) {
            case 0:
              this.destination = o;
              break;
            case 1:
              if (!e) {
                this.destination = o;
                break;
              }
              if ("object" == typeof e) {
                e instanceof p
                  ? ((this.syncErrorThrowable = e.syncErrorThrowable), (this.destination = e), e.add(this))
                  : ((this.syncErrorThrowable = !0), (this.destination = new m(this, e)));
                break;
              }
            default:
              (this.syncErrorThrowable = !0), (this.destination = new m(this, e, t, n));
          }
        }
        [M]() {
          return this;
        }
        static create(e, t, n) {
          const s = new p(e, t, n);
          return (s.syncErrorThrowable = !1), s;
        }
        next(e) {
          this.isStopped || this._next(e);
        }
        error(e) {
          this.isStopped || ((this.isStopped = !0), this._error(e));
        }
        complete() {
          this.isStopped || ((this.isStopped = !0), this._complete());
        }
        unsubscribe() {
          this.closed || ((this.isStopped = !0), super.unsubscribe());
        }
        _next(e) {
          this.destination.next(e);
        }
        _error(e) {
          this.destination.error(e), this.unsubscribe();
        }
        _complete() {
          this.destination.complete(), this.unsubscribe();
        }
        _unsubscribeAndRecycle() {
          const { _parentOrParents: e } = this;
          return (
            (this._parentOrParents = null),
            this.unsubscribe(),
            (this.closed = !1),
            (this.isStopped = !1),
            (this._parentOrParents = e),
            this
          );
        }
      }
      class m extends p {
        constructor(e, t, n, r) {
          let i;
          super(), (this._parentSubscriber = e);
          let a = this;
          s(t)
            ? (i = t)
            : t &&
              ((i = t.next),
              (n = t.error),
              (r = t.complete),
              t !== o &&
                ((a = Object.create(t)),
                s(a.unsubscribe) && this.add(a.unsubscribe.bind(a)),
                (a.unsubscribe = this.unsubscribe.bind(this)))),
            (this._context = a),
            (this._next = i),
            (this._error = n),
            (this._complete = r);
        }
        next(e) {
          if (!this.isStopped && this._next) {
            const { _parentSubscriber: t } = this;
            i.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable
              ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe()
              : this.__tryOrUnsub(this._next, e);
          }
        }
        error(e) {
          if (!this.isStopped) {
            const { _parentSubscriber: t } = this,
              { useDeprecatedSynchronousErrorHandling: n } = i;
            if (this._error)
              n && t.syncErrorThrowable
                ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe())
                : (this.__tryOrUnsub(this._error, e), this.unsubscribe());
            else if (t.syncErrorThrowable)
              n ? ((t.syncErrorValue = e), (t.syncErrorThrown = !0)) : a(e), this.unsubscribe();
            else {
              if ((this.unsubscribe(), n)) throw e;
              a(e);
            }
          }
        }
        complete() {
          if (!this.isStopped) {
            const { _parentSubscriber: e } = this;
            if (this._complete) {
              const t = () => this._complete.call(this._context);
              i.useDeprecatedSynchronousErrorHandling && e.syncErrorThrowable
                ? (this.__tryOrSetError(e, t), this.unsubscribe())
                : (this.__tryOrUnsub(t), this.unsubscribe());
            } else this.unsubscribe();
          }
        }
        __tryOrUnsub(e, t) {
          try {
            e.call(this._context, t);
          } catch (n) {
            if ((this.unsubscribe(), i.useDeprecatedSynchronousErrorHandling)) throw n;
            a(n);
          }
        }
        __tryOrSetError(e, t, n) {
          if (!i.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
          try {
            t.call(this._context, n);
          } catch (s) {
            return i.useDeprecatedSynchronousErrorHandling
              ? ((e.syncErrorValue = s), (e.syncErrorThrown = !0), !0)
              : (a(s), !0);
          }
          return !1;
        }
        _unsubscribe() {
          const { _parentSubscriber: e } = this;
          (this._context = null), (this._parentSubscriber = null), e.unsubscribe();
        }
      }
      const _ = (() => ("function" == typeof Symbol && Symbol.observable) || "@@observable")();
      function f(e) {
        return e;
      }
      let b = (() => {
        class e {
          constructor(e) {
            (this._isScalar = !1), e && (this._subscribe = e);
          }
          lift(t) {
            const n = new e();
            return (n.source = this), (n.operator = t), n;
          }
          subscribe(e, t, n) {
            const { operator: s } = this,
              r = (function (e, t, n) {
                if (e) {
                  if (e instanceof p) return e;
                  if (e[M]) return e[M]();
                }
                return e || t || n ? new p(e, t, n) : new p(o);
              })(e, t, n);
            if (
              (r.add(
                s
                  ? s.call(r, this.source)
                  : this.source || (i.useDeprecatedSynchronousErrorHandling && !r.syncErrorThrowable)
                  ? this._subscribe(r)
                  : this._trySubscribe(r)
              ),
              i.useDeprecatedSynchronousErrorHandling &&
                r.syncErrorThrowable &&
                ((r.syncErrorThrowable = !1), r.syncErrorThrown))
            )
              throw r.syncErrorValue;
            return r;
          }
          _trySubscribe(e) {
            try {
              return this._subscribe(e);
            } catch (t) {
              i.useDeprecatedSynchronousErrorHandling && ((e.syncErrorThrown = !0), (e.syncErrorValue = t)),
                (function (e) {
                  for (; e; ) {
                    const { closed: t, destination: n, isStopped: s } = e;
                    if (t || s) return !1;
                    e = n && n instanceof p ? n : null;
                  }
                  return !0;
                })(e)
                  ? e.error(t)
                  : console.warn(t);
            }
          }
          forEach(e, t) {
            return new (t = g(t))((t, n) => {
              let s;
              s = this.subscribe(
                (t) => {
                  try {
                    e(t);
                  } catch (r) {
                    n(r), s && s.unsubscribe();
                  }
                },
                n,
                t
              );
            });
          }
          _subscribe(e) {
            const { source: t } = this;
            return t && t.subscribe(e);
          }
          [_]() {
            return this;
          }
          pipe(...e) {
            return 0 === e.length
              ? this
              : (0 === (t = e).length
                  ? f
                  : 1 === t.length
                  ? t[0]
                  : function (e) {
                      return t.reduce((e, t) => t(e), e);
                    })(this);
            var t;
          }
          toPromise(e) {
            return new (e = g(e))((e, t) => {
              let n;
              this.subscribe(
                (e) => (n = e),
                (e) => t(e),
                () => e(n)
              );
            });
          }
        }
        return (e.create = (t) => new e(t)), e;
      })();
      function g(e) {
        if ((e || (e = i.Promise || Promise), !e)) throw new Error("no Promise impl found");
        return e;
      }
      const y = (() => {
        function e() {
          return (
            Error.call(this), (this.message = "object unsubscribed"), (this.name = "ObjectUnsubscribedError"), this
          );
        }
        return (e.prototype = Object.create(Error.prototype)), e;
      })();
      class L extends u {
        constructor(e, t) {
          super(), (this.subject = e), (this.subscriber = t), (this.closed = !1);
        }
        unsubscribe() {
          if (this.closed) return;
          this.closed = !0;
          const e = this.subject,
            t = e.observers;
          if (((this.subject = null), !t || 0 === t.length || e.isStopped || e.closed)) return;
          const n = t.indexOf(this.subscriber);
          -1 !== n && t.splice(n, 1);
        }
      }
      class A extends p {
        constructor(e) {
          super(e), (this.destination = e);
        }
      }
      let w = (() => {
        class e extends b {
          constructor() {
            super(),
              (this.observers = []),
              (this.closed = !1),
              (this.isStopped = !1),
              (this.hasError = !1),
              (this.thrownError = null);
          }
          [M]() {
            return new A(this);
          }
          lift(e) {
            const t = new z(this, this);
            return (t.operator = e), t;
          }
          next(e) {
            if (this.closed) throw new y();
            if (!this.isStopped) {
              const { observers: t } = this,
                n = t.length,
                s = t.slice();
              for (let r = 0; r < n; r++) s[r].next(e);
            }
          }
          error(e) {
            if (this.closed) throw new y();
            (this.hasError = !0), (this.thrownError = e), (this.isStopped = !0);
            const { observers: t } = this,
              n = t.length,
              s = t.slice();
            for (let r = 0; r < n; r++) s[r].error(e);
            this.observers.length = 0;
          }
          complete() {
            if (this.closed) throw new y();
            this.isStopped = !0;
            const { observers: e } = this,
              t = e.length,
              n = e.slice();
            for (let s = 0; s < t; s++) n[s].complete();
            this.observers.length = 0;
          }
          unsubscribe() {
            (this.isStopped = !0), (this.closed = !0), (this.observers = null);
          }
          _trySubscribe(e) {
            if (this.closed) throw new y();
            return super._trySubscribe(e);
          }
          _subscribe(e) {
            if (this.closed) throw new y();
            return this.hasError
              ? (e.error(this.thrownError), u.EMPTY)
              : this.isStopped
              ? (e.complete(), u.EMPTY)
              : (this.observers.push(e), new L(this, e));
          }
          asObservable() {
            const e = new b();
            return (e.source = this), e;
          }
        }
        return (e.create = (e, t) => new z(e, t)), e;
      })();
      class z extends w {
        constructor(e, t) {
          super(), (this.destination = e), (this.source = t);
        }
        next(e) {
          const { destination: t } = this;
          t && t.next && t.next(e);
        }
        error(e) {
          const { destination: t } = this;
          t && t.error && this.destination.error(e);
        }
        complete() {
          const { destination: e } = this;
          e && e.complete && this.destination.complete();
        }
        _subscribe(e) {
          const { source: t } = this;
          return t ? this.source.subscribe(e) : u.EMPTY;
        }
      }
      function T(e) {
        return e && "function" == typeof e.schedule;
      }
      function v(e, t) {
        return function (n) {
          if ("function" != typeof e) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
          return n.lift(new D(e, t));
        };
      }
      class D {
        constructor(e, t) {
          (this.project = e), (this.thisArg = t);
        }
        call(e, t) {
          return t.subscribe(new O(e, this.project, this.thisArg));
        }
      }
      class O extends p {
        constructor(e, t, n) {
          super(e), (this.project = t), (this.count = 0), (this.thisArg = n || this);
        }
        _next(e) {
          let t;
          try {
            t = this.project.call(this.thisArg, e, this.count++);
          } catch (n) {
            return void this.destination.error(n);
          }
          this.destination.next(t);
        }
      }
      const S = (e) => (t) => {
        for (let n = 0, s = e.length; n < s && !t.closed; n++) t.next(e[n]);
        t.complete();
      };
      function k() {
        return "function" == typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
      }
      const Y = k(),
        N = (e) => e && "number" == typeof e.length && "function" != typeof e;
      function E(e) {
        return !!e && "function" != typeof e.subscribe && "function" == typeof e.then;
      }
      const C = (e) => {
        if (e && "function" == typeof e[_])
          return (
            (s = e),
            (e) => {
              const t = s[_]();
              if ("function" != typeof t.subscribe)
                throw new TypeError("Provided object does not correctly implement Symbol.observable");
              return t.subscribe(e);
            }
          );
        if (N(e)) return S(e);
        if (E(e))
          return (
            (n = e),
            (e) => (
              n
                .then(
                  (t) => {
                    e.closed || (e.next(t), e.complete());
                  },
                  (t) => e.error(t)
                )
                .then(null, a),
              e
            )
          );
        if (e && "function" == typeof e[Y])
          return (
            (t = e),
            (e) => {
              const n = t[Y]();
              for (;;) {
                let t;
                try {
                  t = n.next();
                } catch (s) {
                  return e.error(s), e;
                }
                if (t.done) {
                  e.complete();
                  break;
                }
                if ((e.next(t.value), e.closed)) break;
              }
              return (
                "function" == typeof n.return &&
                  e.add(() => {
                    n.return && n.return();
                  }),
                e
              );
            }
          );
        {
          const t = l(e) ? "an invalid object" : `'${e}'`;
          throw new TypeError(
            `You provided ${t} where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.`
          );
        }
        var t, n, s;
      };
      function W(e, t) {
        return new b((n) => {
          const s = new u();
          let r = 0;
          return (
            s.add(
              t.schedule(function () {
                r !== e.length ? (n.next(e[r++]), n.closed || s.add(this.schedule())) : n.complete();
              })
            ),
            s
          );
        });
      }
      function q(e, t) {
        return t
          ? (function (e, t) {
              if (null != e) {
                if (
                  (function (e) {
                    return e && "function" == typeof e[_];
                  })(e)
                )
                  return (function (e, t) {
                    return new b((n) => {
                      const s = new u();
                      return (
                        s.add(
                          t.schedule(() => {
                            const r = e[_]();
                            s.add(
                              r.subscribe({
                                next(e) {
                                  s.add(t.schedule(() => n.next(e)));
                                },
                                error(e) {
                                  s.add(t.schedule(() => n.error(e)));
                                },
                                complete() {
                                  s.add(t.schedule(() => n.complete()));
                                },
                              })
                            );
                          })
                        ),
                        s
                      );
                    });
                  })(e, t);
                if (E(e))
                  return (function (e, t) {
                    return new b((n) => {
                      const s = new u();
                      return (
                        s.add(
                          t.schedule(() =>
                            e.then(
                              (e) => {
                                s.add(
                                  t.schedule(() => {
                                    n.next(e), s.add(t.schedule(() => n.complete()));
                                  })
                                );
                              },
                              (e) => {
                                s.add(t.schedule(() => n.error(e)));
                              }
                            )
                          )
                        ),
                        s
                      );
                    });
                  })(e, t);
                if (N(e)) return W(e, t);
                if (
                  (function (e) {
                    return e && "function" == typeof e[Y];
                  })(e) ||
                  "string" == typeof e
                )
                  return (function (e, t) {
                    if (!e) throw new Error("Iterable cannot be null");
                    return new b((n) => {
                      const s = new u();
                      let r;
                      return (
                        s.add(() => {
                          r && "function" == typeof r.return && r.return();
                        }),
                        s.add(
                          t.schedule(() => {
                            (r = e[Y]()),
                              s.add(
                                t.schedule(function () {
                                  if (n.closed) return;
                                  let e, t;
                                  try {
                                    const n = r.next();
                                    (e = n.value), (t = n.done);
                                  } catch (s) {
                                    return void n.error(s);
                                  }
                                  t ? n.complete() : (n.next(e), this.schedule());
                                })
                              );
                          })
                        ),
                        s
                      );
                    });
                  })(e, t);
              }
              throw new TypeError(((null !== e && typeof e) || e) + " is not observable");
            })(e, t)
          : e instanceof b
          ? e
          : new b(C(e));
      }
      class x extends p {
        constructor(e) {
          super(), (this.parent = e);
        }
        _next(e) {
          this.parent.notifyNext(e);
        }
        _error(e) {
          this.parent.notifyError(e), this.unsubscribe();
        }
        _complete() {
          this.parent.notifyComplete(), this.unsubscribe();
        }
      }
      class B extends p {
        notifyNext(e) {
          this.destination.next(e);
        }
        notifyError(e) {
          this.destination.error(e);
        }
        notifyComplete() {
          this.destination.complete();
        }
      }
      function H(e, t) {
        if (t.closed) return;
        if (e instanceof b) return e.subscribe(t);
        let n;
        try {
          n = C(e)(t);
        } catch (s) {
          t.error(s);
        }
        return n;
      }
      function j(e, t, n = Number.POSITIVE_INFINITY) {
        return "function" == typeof t
          ? (s) => s.pipe(j((n, s) => q(e(n, s)).pipe(v((e, r) => t(n, e, s, r))), n))
          : ("number" == typeof t && (n = t), (t) => t.lift(new P(e, n)));
      }
      class P {
        constructor(e, t = Number.POSITIVE_INFINITY) {
          (this.project = e), (this.concurrent = t);
        }
        call(e, t) {
          return t.subscribe(new X(e, this.project, this.concurrent));
        }
      }
      class X extends B {
        constructor(e, t, n = Number.POSITIVE_INFINITY) {
          super(e),
            (this.project = t),
            (this.concurrent = n),
            (this.hasCompleted = !1),
            (this.buffer = []),
            (this.active = 0),
            (this.index = 0);
        }
        _next(e) {
          this.active < this.concurrent ? this._tryNext(e) : this.buffer.push(e);
        }
        _tryNext(e) {
          let t;
          const n = this.index++;
          try {
            t = this.project(e, n);
          } catch (s) {
            return void this.destination.error(s);
          }
          this.active++, this._innerSub(t);
        }
        _innerSub(e) {
          const t = new x(this),
            n = this.destination;
          n.add(t);
          const s = H(e, t);
          s !== t && n.add(s);
        }
        _complete() {
          (this.hasCompleted = !0),
            0 === this.active && 0 === this.buffer.length && this.destination.complete(),
            this.unsubscribe();
        }
        notifyNext(e) {
          this.destination.next(e);
        }
        notifyComplete() {
          const e = this.buffer;
          this.active--,
            e.length > 0
              ? this._next(e.shift())
              : 0 === this.active && this.hasCompleted && this.destination.complete();
        }
      }
      function R(e = Number.POSITIVE_INFINITY) {
        return j(f, e);
      }
      function I(e, t) {
        return t ? W(e, t) : new b(S(e));
      }
      function F(...e) {
        let t = Number.POSITIVE_INFINITY,
          n = null,
          s = e[e.length - 1];
        return (
          T(s)
            ? ((n = e.pop()), e.length > 1 && "number" == typeof e[e.length - 1] && (t = e.pop()))
            : "number" == typeof s && (t = e.pop()),
          null === n && 1 === e.length && e[0] instanceof b ? e[0] : R(t)(I(e, n))
        );
      }
      function V() {
        return function (e) {
          return e.lift(new U(e));
        };
      }
      class U {
        constructor(e) {
          this.connectable = e;
        }
        call(e, t) {
          const { connectable: n } = this;
          n._refCount++;
          const s = new J(e, n),
            r = t.subscribe(s);
          return s.closed || (s.connection = n.connect()), r;
        }
      }
      class J extends p {
        constructor(e, t) {
          super(e), (this.connectable = t);
        }
        _unsubscribe() {
          const { connectable: e } = this;
          if (!e) return void (this.connection = null);
          this.connectable = null;
          const t = e._refCount;
          if (t <= 0) return void (this.connection = null);
          if (((e._refCount = t - 1), t > 1)) return void (this.connection = null);
          const { connection: n } = this,
            s = e._connection;
          (this.connection = null), !s || (n && s !== n) || s.unsubscribe();
        }
      }
      class G extends b {
        constructor(e, t) {
          super(), (this.source = e), (this.subjectFactory = t), (this._refCount = 0), (this._isComplete = !1);
        }
        _subscribe(e) {
          return this.getSubject().subscribe(e);
        }
        getSubject() {
          const e = this._subject;
          return (e && !e.isStopped) || (this._subject = this.subjectFactory()), this._subject;
        }
        connect() {
          let e = this._connection;
          return (
            e ||
              ((this._isComplete = !1),
              (e = this._connection = new u()),
              e.add(this.source.subscribe(new K(this.getSubject(), this))),
              e.closed && ((this._connection = null), (e = u.EMPTY))),
            e
          );
        }
        refCount() {
          return V()(this);
        }
      }
      const Q = (() => {
        const e = G.prototype;
        return {
          operator: { value: null },
          _refCount: { value: 0, writable: !0 },
          _subject: { value: null, writable: !0 },
          _connection: { value: null, writable: !0 },
          _subscribe: { value: e._subscribe },
          _isComplete: { value: e._isComplete, writable: !0 },
          getSubject: { value: e.getSubject },
          connect: { value: e.connect },
          refCount: { value: e.refCount },
        };
      })();
      class K extends A {
        constructor(e, t) {
          super(e), (this.connectable = t);
        }
        _error(e) {
          this._unsubscribe(), super._error(e);
        }
        _complete() {
          (this.connectable._isComplete = !0), this._unsubscribe(), super._complete();
        }
        _unsubscribe() {
          const e = this.connectable;
          if (e) {
            this.connectable = null;
            const t = e._connection;
            (e._refCount = 0), (e._subject = null), (e._connection = null), t && t.unsubscribe();
          }
        }
      }
      function $() {
        return new w();
      }
      function Z(e) {
        return { toString: e }.toString();
      }
      function ee(e, t, n) {
        return Z(() => {
          const s = (function (e) {
            return function (...t) {
              if (e) {
                const n = e(...t);
                for (const e in n) this[e] = n[e];
              }
            };
          })(t);
          function r(...e) {
            if (this instanceof r) return s.apply(this, e), this;
            const t = new r(...e);
            return (n.annotation = t), n;
            function n(e, n, s) {
              const r = e.hasOwnProperty("__parameters__")
                ? e.__parameters__
                : Object.defineProperty(e, "__parameters__", { value: [] }).__parameters__;
              for (; r.length <= s; ) r.push(null);
              return (r[s] = r[s] || []).push(t), e;
            }
          }
          return (
            n && (r.prototype = Object.create(n.prototype)), (r.prototype.ngMetadataName = e), (r.annotationCls = r), r
          );
        });
      }
      const te = ee("Inject", (e) => ({ token: e })),
        ne = ee("Optional"),
        se = ee("Self"),
        re = ee("SkipSelf");
      var ie = (function (e) {
        return (
          (e[(e.Default = 0)] = "Default"),
          (e[(e.Host = 1)] = "Host"),
          (e[(e.Self = 2)] = "Self"),
          (e[(e.SkipSelf = 4)] = "SkipSelf"),
          (e[(e.Optional = 8)] = "Optional"),
          e
        );
      })({});
      function ae(e) {
        for (let t in e) if (e[t] === ae) return t;
        throw Error("Could not find renamed property on target object.");
      }
      function oe(e, t) {
        for (const n in t) t.hasOwnProperty(n) && !e.hasOwnProperty(n) && (e[n] = t[n]);
      }
      function ce(e) {
        return { token: e.token, providedIn: e.providedIn || null, factory: e.factory, value: void 0 };
      }
      function le(e) {
        return { factory: e.factory, providers: e.providers || [], imports: e.imports || [] };
      }
      function de(e) {
        return ue(e, e[Me]) || ue(e, e[_e]);
      }
      function ue(e, t) {
        return t && t.token === e ? t : null;
      }
      function he(e) {
        return e && (e.hasOwnProperty(pe) || e.hasOwnProperty(fe)) ? e[pe] : null;
      }
      const Me = ae({ ɵprov: ae }),
        pe = ae({ ɵinj: ae }),
        me = ae({ ɵprovFallback: ae }),
        _e = ae({ ngInjectableDef: ae }),
        fe = ae({ ngInjectorDef: ae });
      function be(e) {
        if ("string" == typeof e) return e;
        if (Array.isArray(e)) return "[" + e.map(be).join(", ") + "]";
        if (null == e) return "" + e;
        if (e.overriddenName) return "" + e.overriddenName;
        if (e.name) return "" + e.name;
        const t = e.toString();
        if (null == t) return "" + t;
        const n = t.indexOf("\n");
        return -1 === n ? t : t.substring(0, n);
      }
      function ge(e, t) {
        return null == e || "" === e ? (null === t ? "" : t) : null == t || "" === t ? e : e + " " + t;
      }
      const ye = ae({ __forward_ref__: ae });
      function Le(e) {
        return (
          (e.__forward_ref__ = Le),
          (e.toString = function () {
            return be(this());
          }),
          e
        );
      }
      function Ae(e) {
        return we(e) ? e() : e;
      }
      function we(e) {
        return "function" == typeof e && e.hasOwnProperty(ye) && e.__forward_ref__ === Le;
      }
      const ze = "undefined" != typeof globalThis && globalThis,
        Te = "undefined" != typeof window && window,
        ve =
          "undefined" != typeof self &&
          "undefined" != typeof WorkerGlobalScope &&
          self instanceof WorkerGlobalScope &&
          self,
        De = "undefined" != typeof global && global,
        Oe = ze || De || Te || ve,
        Se = ae({ ɵcmp: ae }),
        ke = ae({ ɵdir: ae }),
        Ye = ae({ ɵpipe: ae }),
        Ne = ae({ ɵmod: ae }),
        Ee = ae({ ɵloc: ae }),
        Ce = ae({ ɵfac: ae }),
        We = ae({ __NG_ELEMENT_ID__: ae });
      class qe {
        constructor(e, t) {
          (this._desc = e),
            (this.ngMetadataName = "InjectionToken"),
            (this.ɵprov = void 0),
            "number" == typeof t
              ? (this.__NG_ELEMENT_ID__ = t)
              : void 0 !== t &&
                (this.ɵprov = ce({ token: this, providedIn: t.providedIn || "root", factory: t.factory }));
        }
        toString() {
          return "InjectionToken " + this._desc;
        }
      }
      const xe = new qe("INJECTOR", -1),
        Be = {},
        He = /\n/gm,
        je = ae({ provide: String, useValue: ae });
      let Pe,
        Xe = void 0;
      function Re(e) {
        const t = Xe;
        return (Xe = e), t;
      }
      function Ie(e) {
        const t = Pe;
        return (Pe = e), t;
      }
      function Fe(e, t = ie.Default) {
        if (void 0 === Xe) throw new Error("inject() must be called from an injection context");
        return null === Xe ? Ue(e, void 0, t) : Xe.get(e, t & ie.Optional ? null : void 0, t);
      }
      function Ve(e, t = ie.Default) {
        return (Pe || Fe)(Ae(e), t);
      }
      function Ue(e, t, n) {
        const s = de(e);
        if (s && "root" == s.providedIn) return void 0 === s.value ? (s.value = s.factory()) : s.value;
        if (n & ie.Optional) return null;
        if (void 0 !== t) return t;
        throw new Error(`Injector: NOT_FOUND [${be(e)}]`);
      }
      function Je(e) {
        const t = [];
        for (let n = 0; n < e.length; n++) {
          const s = Ae(e[n]);
          if (Array.isArray(s)) {
            if (0 === s.length) throw new Error("Arguments array must have arguments.");
            let e = void 0,
              n = ie.Default;
            for (let t = 0; t < s.length; t++) {
              const r = s[t];
              r instanceof ne || "Optional" === r.ngMetadataName || r === ne
                ? (n |= ie.Optional)
                : r instanceof re || "SkipSelf" === r.ngMetadataName || r === re
                ? (n |= ie.SkipSelf)
                : r instanceof se || "Self" === r.ngMetadataName || r === se
                ? (n |= ie.Self)
                : (e = r instanceof te || r === te ? r.token : r);
            }
            t.push(Ve(e, n));
          } else t.push(Ve(s));
        }
        return t;
      }
      class Ge {
        get(e, t = Be) {
          if (t === Be) {
            const t = new Error(`NullInjectorError: No provider for ${be(e)}!`);
            throw ((t.name = "NullInjectorError"), t);
          }
          return t;
        }
      }
      class Qe {}
      class Ke {}
      function $e(e, t) {
        e.forEach((e) => (Array.isArray(e) ? $e(e, t) : t(e)));
      }
      function Ze(e, t, n) {
        t >= e.length ? e.push(n) : e.splice(t, 0, n);
      }
      function et(e, t) {
        return t >= e.length - 1 ? e.pop() : e.splice(t, 1)[0];
      }
      function tt(e, t) {
        const n = [];
        for (let s = 0; s < e; s++) n.push(t);
        return n;
      }
      function nt(e, t, n) {
        let s = rt(e, t);
        return (
          s >= 0
            ? (e[1 | s] = n)
            : ((s = ~s),
              (function (e, t, n, s) {
                let r = e.length;
                if (r == t) e.push(n, s);
                else if (1 === r) e.push(s, e[0]), (e[0] = n);
                else {
                  for (r--, e.push(e[r - 1], e[r]); r > t; ) (e[r] = e[r - 2]), r--;
                  (e[t] = n), (e[t + 1] = s);
                }
              })(e, s, t, n)),
          s
        );
      }
      function st(e, t) {
        const n = rt(e, t);
        if (n >= 0) return e[1 | n];
      }
      function rt(e, t) {
        return (function (e, t, n) {
          let s = 0,
            r = e.length >> 1;
          for (; r !== s; ) {
            const n = s + ((r - s) >> 1),
              i = e[n << 1];
            if (t === i) return n << 1;
            i > t ? (r = n) : (s = n + 1);
          }
          return ~(r << 1);
        })(e, t);
      }
      var it = (function (e) {
          return (e[(e.OnPush = 0)] = "OnPush"), (e[(e.Default = 1)] = "Default"), e;
        })({}),
        at = (function (e) {
          return (
            (e[(e.Emulated = 0)] = "Emulated"),
            (e[(e.Native = 1)] = "Native"),
            (e[(e.None = 2)] = "None"),
            (e[(e.ShadowDom = 3)] = "ShadowDom"),
            e
          );
        })({});
      const ot = {},
        ct = [];
      let lt = 0;
      function dt(e) {
        return Z(() => {
          const t = {},
            n = {
              type: e.type,
              providersResolver: null,
              decls: e.decls,
              vars: e.vars,
              factory: null,
              template: e.template || null,
              consts: e.consts || null,
              ngContentSelectors: e.ngContentSelectors,
              hostBindings: e.hostBindings || null,
              hostVars: e.hostVars || 0,
              hostAttrs: e.hostAttrs || null,
              contentQueries: e.contentQueries || null,
              declaredInputs: t,
              inputs: null,
              outputs: null,
              exportAs: e.exportAs || null,
              onPush: e.changeDetection === it.OnPush,
              directiveDefs: null,
              pipeDefs: null,
              selectors: e.selectors || ct,
              viewQuery: e.viewQuery || null,
              features: e.features || null,
              data: e.data || {},
              encapsulation: e.encapsulation || at.Emulated,
              id: "c",
              styles: e.styles || ct,
              _: null,
              setInput: null,
              schemas: e.schemas || null,
              tView: null,
            },
            s = e.directives,
            r = e.features,
            i = e.pipes;
          return (
            (n.id += lt++),
            (n.inputs = mt(e.inputs, t)),
            (n.outputs = mt(e.outputs)),
            r && r.forEach((e) => e(n)),
            (n.directiveDefs = s ? () => ("function" == typeof s ? s() : s).map(ut) : null),
            (n.pipeDefs = i ? () => ("function" == typeof i ? i() : i).map(ht) : null),
            n
          );
        });
      }
      function ut(e) {
        return (
          bt(e) ||
          (function (e) {
            return e[ke] || null;
          })(e)
        );
      }
      function ht(e) {
        return (function (e) {
          return e[Ye] || null;
        })(e);
      }
      const Mt = {};
      function pt(e) {
        const t = {
          type: e.type,
          bootstrap: e.bootstrap || ct,
          declarations: e.declarations || ct,
          imports: e.imports || ct,
          exports: e.exports || ct,
          transitiveCompileScopes: null,
          schemas: e.schemas || null,
          id: e.id || null,
        };
        return (
          null != e.id &&
            Z(() => {
              Mt[e.id] = e.type;
            }),
          t
        );
      }
      function mt(e, t) {
        if (null == e) return ot;
        const n = {};
        for (const s in e)
          if (e.hasOwnProperty(s)) {
            let r = e[s],
              i = r;
            Array.isArray(r) && ((i = r[1]), (r = r[0])), (n[r] = s), t && (t[r] = i);
          }
        return n;
      }
      const _t = dt;
      function ft(e) {
        return {
          type: e.type,
          name: e.name,
          factory: null,
          pure: !1 !== e.pure,
          onDestroy: e.type.prototype.ngOnDestroy || null,
        };
      }
      function bt(e) {
        return e[Se] || null;
      }
      function gt(e, t) {
        return e.hasOwnProperty(Ce) ? e[Ce] : null;
      }
      function yt(e, t) {
        const n = e[Ne] || null;
        if (!n && !0 === t) throw new Error(`Type ${be(e)} does not have '\u0275mod' property.`);
        return n;
      }
      function Lt(e) {
        return Array.isArray(e) && "object" == typeof e[1];
      }
      function At(e) {
        return Array.isArray(e) && !0 === e[1];
      }
      function wt(e) {
        return 0 != (8 & e.flags);
      }
      function zt(e) {
        return 2 == (2 & e.flags);
      }
      function Tt(e) {
        return 1 == (1 & e.flags);
      }
      function vt(e) {
        return null !== e.template;
      }
      function Dt(e) {
        return 0 != (512 & e[2]);
      }
      function Ot(e) {
        return "string" == typeof e ? e : null == e ? "" : "" + e;
      }
      function St(e) {
        return "function" == typeof e
          ? e.name || e.toString()
          : "object" == typeof e && null != e && "function" == typeof e.type
          ? e.type.name || e.type.toString()
          : Ot(e);
      }
      const kt = (() =>
        (("undefined" != typeof requestAnimationFrame && requestAnimationFrame) || setTimeout).bind(Oe))();
      function Yt(e) {
        return { name: "document", target: e.ownerDocument };
      }
      function Nt(e) {
        return e instanceof Function ? e() : e;
      }
      function Et(e, t) {
        const n = t ? " in " + t : "";
        throw new Error(`No provider for ${St(e)} found${n}`);
      }
      class Ct {
        constructor(e, t, n) {
          (this.previousValue = e), (this.currentValue = t), (this.firstChange = n);
        }
        isFirstChange() {
          return this.firstChange;
        }
      }
      function Wt() {
        return qt;
      }
      function qt(e) {
        return e.type.prototype.ngOnChanges && (e.setInput = Bt), xt;
      }
      function xt() {
        const e = Ht(this),
          t = null == e ? void 0 : e.current;
        if (t) {
          const n = e.previous;
          if (n === ot) e.previous = t;
          else for (let e in t) n[e] = t[e];
          (e.current = null), this.ngOnChanges(t);
        }
      }
      function Bt(e, t, n, s) {
        const r =
            Ht(e) ||
            (function (e, t) {
              return (e.__ngSimpleChanges__ = t);
            })(e, { previous: ot, current: null }),
          i = r.current || (r.current = {}),
          a = r.previous,
          o = this.declaredInputs[n],
          c = a[o];
        (i[o] = new Ct(c && c.currentValue, t, a === ot)), (e[s] = t);
      }
      function Ht(e) {
        return e.__ngSimpleChanges__ || null;
      }
      Wt.ngInherit = !0;
      let jt = void 0;
      function Pt(e) {
        return !!e.listen;
      }
      const Xt = {
        createRenderer: (e, t) => (void 0 !== jt ? jt : "undefined" != typeof document ? document : void 0),
      };
      function Rt(e) {
        for (; Array.isArray(e); ) e = e[0];
        return e;
      }
      function It(e, t) {
        return Rt(t[e + 20]);
      }
      function Ft(e, t) {
        return Rt(t[e.index]);
      }
      function Vt(e, t) {
        return e.data[t + 20];
      }
      function Ut(e, t) {
        return e[t + 20];
      }
      function Jt(e, t) {
        const n = t[e];
        return Lt(n) ? n : n[0];
      }
      function Gt(e) {
        const t = (function (e) {
          return e.__ngContext__ || null;
        })(e);
        return t ? (Array.isArray(t) ? t : t.lView) : null;
      }
      function Qt(e) {
        return 4 == (4 & e[2]);
      }
      function Kt(e) {
        return 128 == (128 & e[2]);
      }
      function $t(e, t) {
        return null === e || null == t ? null : e[t];
      }
      function Zt(e) {
        e[18] = 0;
      }
      function en(e, t) {
        e[5] += t;
        let n = e,
          s = e[3];
        for (; null !== s && ((1 === t && 1 === n[5]) || (-1 === t && 0 === n[5])); ) (s[5] += t), (n = s), (s = s[3]);
      }
      const tn = { lFrame: zn(null), bindingsEnabled: !0, isInCheckNoChangesMode: !1 };
      function nn() {
        return tn.bindingsEnabled;
      }
      function sn() {
        return tn.lFrame.lView;
      }
      function rn() {
        return tn.lFrame.tView;
      }
      function an(e) {
        tn.lFrame.contextLView = e;
      }
      function on() {
        return tn.lFrame.currentTNode;
      }
      function cn(e, t) {
        (tn.lFrame.currentTNode = e), (tn.lFrame.isParent = t);
      }
      function ln() {
        return tn.lFrame.isParent;
      }
      function dn() {
        tn.lFrame.isParent = !1;
      }
      function un() {
        return tn.isInCheckNoChangesMode;
      }
      function hn(e) {
        tn.isInCheckNoChangesMode = e;
      }
      function Mn() {
        const e = tn.lFrame;
        let t = e.bindingRootIndex;
        return -1 === t && (t = e.bindingRootIndex = e.tView.bindingStartIndex), t;
      }
      function pn() {
        return tn.lFrame.bindingIndex;
      }
      function mn() {
        return tn.lFrame.bindingIndex++;
      }
      function _n(e) {
        const t = tn.lFrame,
          n = t.bindingIndex;
        return (t.bindingIndex = t.bindingIndex + e), n;
      }
      function fn(e, t) {
        const n = tn.lFrame;
        (n.bindingIndex = n.bindingRootIndex = e), bn(t);
      }
      function bn(e) {
        tn.lFrame.currentDirectiveIndex = e;
      }
      function gn() {
        return tn.lFrame.currentQueryIndex;
      }
      function yn(e) {
        tn.lFrame.currentQueryIndex = e;
      }
      function Ln(e, t) {
        const n = wn();
        (tn.lFrame = n), (n.currentTNode = t), (n.lView = e);
      }
      function An(e) {
        const t = wn(),
          n = e[1];
        (tn.lFrame = t),
          (t.currentTNode = n.firstChild),
          (t.lView = e),
          (t.tView = n),
          (t.contextLView = e),
          (t.bindingIndex = n.bindingStartIndex);
      }
      function wn() {
        const e = tn.lFrame,
          t = null === e ? null : e.child;
        return null === t ? zn(e) : t;
      }
      function zn(e) {
        const t = {
          currentTNode: null,
          isParent: !0,
          lView: null,
          tView: null,
          selectedIndex: 0,
          contextLView: null,
          elementDepthCount: 0,
          currentNamespace: null,
          currentDirectiveIndex: -1,
          bindingRootIndex: -1,
          bindingIndex: -1,
          currentQueryIndex: 0,
          parent: e,
          child: null,
        };
        return null !== e && (e.child = t), t;
      }
      function Tn() {
        const e = tn.lFrame;
        return (tn.lFrame = e.parent), (e.currentTNode = null), (e.lView = null), e;
      }
      const vn = Tn;
      function Dn() {
        const e = Tn();
        (e.isParent = !0),
          (e.tView = null),
          (e.selectedIndex = 0),
          (e.contextLView = null),
          (e.elementDepthCount = 0),
          (e.currentDirectiveIndex = -1),
          (e.currentNamespace = null),
          (e.bindingRootIndex = -1),
          (e.bindingIndex = -1),
          (e.currentQueryIndex = 0);
      }
      function On() {
        return tn.lFrame.selectedIndex;
      }
      function Sn(e) {
        tn.lFrame.selectedIndex = e;
      }
      function kn() {
        const e = tn.lFrame;
        return Vt(e.tView, e.selectedIndex);
      }
      function Yn(e, t) {
        for (let n = t.directiveStart, s = t.directiveEnd; n < s; n++) {
          const t = e.data[n].type.prototype,
            {
              ngAfterContentInit: s,
              ngAfterContentChecked: r,
              ngAfterViewInit: i,
              ngAfterViewChecked: a,
              ngOnDestroy: o,
            } = t;
          s && (e.contentHooks || (e.contentHooks = [])).push(-n, s),
            r &&
              ((e.contentHooks || (e.contentHooks = [])).push(n, r),
              (e.contentCheckHooks || (e.contentCheckHooks = [])).push(n, r)),
            i && (e.viewHooks || (e.viewHooks = [])).push(-n, i),
            a &&
              ((e.viewHooks || (e.viewHooks = [])).push(n, a),
              (e.viewCheckHooks || (e.viewCheckHooks = [])).push(n, a)),
            null != o && (e.destroyHooks || (e.destroyHooks = [])).push(n, o);
        }
      }
      function Nn(e, t, n) {
        Wn(e, t, 3, n);
      }
      function En(e, t, n, s) {
        (3 & e[2]) === n && Wn(e, t, n, s);
      }
      function Cn(e, t) {
        let n = e[2];
        (3 & n) === t && ((n &= 2047), (n += 1), (e[2] = n));
      }
      function Wn(e, t, n, s) {
        const r = null != s ? s : -1;
        let i = 0;
        for (let a = void 0 !== s ? 65535 & e[18] : 0; a < t.length; a++)
          if ("number" == typeof t[a + 1]) {
            if (((i = t[a]), null != s && i >= s)) break;
          } else
            t[a] < 0 && (e[18] += 65536),
              (i < r || -1 == r) && (qn(e, n, t, a), (e[18] = (4294901760 & e[18]) + a + 2)),
              a++;
      }
      function qn(e, t, n, s) {
        const r = n[s] < 0,
          i = n[s + 1],
          a = e[r ? -n[s] : n[s]];
        r ? e[2] >> 11 < e[18] >> 16 && (3 & e[2]) === t && ((e[2] += 2048), i.call(a)) : i.call(a);
      }
      class xn {
        constructor(e, t, n) {
          (this.factory = e), (this.resolving = !1), (this.canSeeViewProviders = t), (this.injectImpl = n);
        }
      }
      function Bn(e, t, n) {
        const s = Pt(e);
        let r = 0;
        for (; r < n.length; ) {
          const i = n[r];
          if ("number" == typeof i) {
            if (0 !== i) break;
            r++;
            const a = n[r++],
              o = n[r++],
              c = n[r++];
            s ? e.setAttribute(t, o, c, a) : t.setAttributeNS(a, o, c);
          } else {
            const a = i,
              o = n[++r];
            jn(a) ? s && e.setProperty(t, a, o) : s ? e.setAttribute(t, a, o) : t.setAttribute(a, o), r++;
          }
        }
        return r;
      }
      function Hn(e) {
        return 3 === e || 4 === e || 6 === e;
      }
      function jn(e) {
        return 64 === e.charCodeAt(0);
      }
      function Pn(e, t) {
        if (null === t || 0 === t.length);
        else if (null === e || 0 === e.length) e = t.slice();
        else {
          let n = -1;
          for (let s = 0; s < t.length; s++) {
            const r = t[s];
            "number" == typeof r ? (n = r) : 0 === n || Xn(e, n, r, null, -1 === n || 2 === n ? t[++s] : null);
          }
        }
        return e;
      }
      function Xn(e, t, n, s, r) {
        let i = 0,
          a = e.length;
        if (-1 === t) a = -1;
        else
          for (; i < e.length; ) {
            const n = e[i++];
            if ("number" == typeof n) {
              if (n === t) {
                a = -1;
                break;
              }
              if (n > t) {
                a = i - 1;
                break;
              }
            }
          }
        for (; i < e.length; ) {
          const t = e[i];
          if ("number" == typeof t) break;
          if (t === n) {
            if (null === s) return void (null !== r && (e[i + 1] = r));
            if (s === e[i + 1]) return void (e[i + 2] = r);
          }
          i++, null !== s && i++, null !== r && i++;
        }
        -1 !== a && (e.splice(a, 0, t), (i = a + 1)),
          e.splice(i++, 0, n),
          null !== s && e.splice(i++, 0, s),
          null !== r && e.splice(i++, 0, r);
      }
      function Rn(e) {
        return -1 !== e;
      }
      function In(e) {
        return 32767 & e;
      }
      function Fn(e, t) {
        let n = e >> 16,
          s = t;
        for (; n > 0; ) (s = s[15]), n--;
        return s;
      }
      let Vn = !0;
      function Un(e) {
        const t = Vn;
        return (Vn = e), t;
      }
      let Jn = 0;
      function Gn(e, t) {
        const n = Kn(e, t);
        if (-1 !== n) return n;
        const s = t[1];
        s.firstCreatePass && ((e.injectorIndex = t.length), Qn(s.data, e), Qn(t, null), Qn(s.blueprint, null));
        const r = $n(e, t),
          i = e.injectorIndex;
        if (Rn(r)) {
          const e = In(r),
            n = Fn(r, t),
            s = n[1].data;
          for (let r = 0; r < 8; r++) t[i + r] = n[e + r] | s[e + r];
        }
        return (t[i + 8] = r), i;
      }
      function Qn(e, t) {
        e.push(0, 0, 0, 0, 0, 0, 0, 0, t);
      }
      function Kn(e, t) {
        return -1 === e.injectorIndex ||
          (e.parent && e.parent.injectorIndex === e.injectorIndex) ||
          null === t[e.injectorIndex + 8]
          ? -1
          : e.injectorIndex;
      }
      function $n(e, t) {
        if (e.parent && -1 !== e.parent.injectorIndex) return e.parent.injectorIndex;
        let n = 0,
          s = null,
          r = t;
        for (; null !== r; ) {
          const e = r[1],
            t = e.type;
          if (((s = 2 === t ? e.declTNode : 1 === t ? r[6] : null), null === s)) return -1;
          if ((n++, (r = r[15]), -1 !== s.injectorIndex)) return s.injectorIndex | (n << 16);
        }
        return -1;
      }
      function Zn(e, t, n) {
        !(function (e, t, n) {
          let s;
          "string" == typeof n ? (s = n.charCodeAt(0) || 0) : n.hasOwnProperty(We) && (s = n[We]),
            null == s && (s = n[We] = Jn++);
          const r = 255 & s,
            i = 1 << r,
            a = 64 & r,
            o = 32 & r,
            c = t.data;
          128 & r
            ? a
              ? o
                ? (c[e + 7] |= i)
                : (c[e + 6] |= i)
              : o
              ? (c[e + 5] |= i)
              : (c[e + 4] |= i)
            : a
            ? o
              ? (c[e + 3] |= i)
              : (c[e + 2] |= i)
            : o
            ? (c[e + 1] |= i)
            : (c[e] |= i);
        })(e, t, n);
      }
      function es(e, t, n, s = ie.Default, r) {
        if (null !== e) {
          const r = (function (e) {
            if ("string" == typeof e) return e.charCodeAt(0) || 0;
            const t = e.hasOwnProperty(We) ? e[We] : void 0;
            return "number" == typeof t && t > 0 ? 255 & t : t;
          })(n);
          if ("function" == typeof r) {
            Ln(t, e);
            try {
              const e = r();
              if (null != e || s & ie.Optional) return e;
              Et(n);
            } finally {
              vn();
            }
          } else if ("number" == typeof r) {
            if (-1 === r) return new os(e, t);
            let i = null,
              a = Kn(e, t),
              o = -1,
              c = s & ie.Host ? t[16][6] : null;
            for (
              (-1 === a || s & ie.SkipSelf) &&
              ((o = -1 === a ? $n(e, t) : t[a + 8]),
              -1 !== o && as(s, !1) ? ((i = t[1]), (a = In(o)), (t = Fn(o, t))) : (a = -1));
              -1 !== a;

            ) {
              const e = t[1];
              if (is(r, a, e.data)) {
                const e = ns(a, t, n, i, s, c);
                if (e !== ts) return e;
              }
              (o = t[a + 8]),
                -1 !== o && as(s, t[1].data[a + 8] === c) && is(r, a, t)
                  ? ((i = e), (a = In(o)), (t = Fn(o, t)))
                  : (a = -1);
            }
          }
        }
        if ((s & ie.Optional && void 0 === r && (r = null), 0 == (s & (ie.Self | ie.Host)))) {
          const e = t[9],
            i = Ie(void 0);
          try {
            return e ? e.get(n, r, s & ie.Optional) : Ue(n, r, s & ie.Optional);
          } finally {
            Ie(i);
          }
        }
        if (s & ie.Optional) return r;
        Et(n, "NodeInjector");
      }
      const ts = {};
      function ns(e, t, n, s, r, i) {
        const a = t[1],
          o = a.data[e + 8],
          c = ss(o, a, n, null == s ? zt(o) && Vn : s != a && 2 === o.type, r & ie.Host && i === o);
        return null !== c ? rs(t, a, c, o) : ts;
      }
      function ss(e, t, n, s, r) {
        const i = e.providerIndexes,
          a = t.data,
          o = 1048575 & i,
          c = e.directiveStart,
          l = i >> 20,
          d = r ? o + l : e.directiveEnd;
        for (let u = s ? o : o + l; u < d; u++) {
          const e = a[u];
          if ((u < c && n === e) || (u >= c && e.type === n)) return u;
        }
        if (r) {
          const e = a[c];
          if (e && vt(e) && e.type === n) return c;
        }
        return null;
      }
      function rs(e, t, n, s) {
        let r = e[n];
        const i = t.data;
        if (r instanceof xn) {
          const a = r;
          a.resolving &&
            (function (e, t) {
              throw new Error("Circular dependency in DI detected for " + e);
            })(St(i[n]));
          const o = Un(a.canSeeViewProviders);
          a.resolving = !0;
          const c = a.injectImpl ? Ie(a.injectImpl) : null;
          Ln(e, s);
          try {
            (r = e[n] = a.factory(void 0, i, e, s)),
              t.firstCreatePass &&
                n >= s.directiveStart &&
                (function (e, t, n) {
                  const { ngOnChanges: s, ngOnInit: r, ngDoCheck: i } = t.type.prototype;
                  if (s) {
                    const s = qt(t);
                    (n.preOrderHooks || (n.preOrderHooks = [])).push(e, s),
                      (n.preOrderCheckHooks || (n.preOrderCheckHooks = [])).push(e, s);
                  }
                  r && (n.preOrderHooks || (n.preOrderHooks = [])).push(0 - e, r),
                    i &&
                      ((n.preOrderHooks || (n.preOrderHooks = [])).push(e, i),
                      (n.preOrderCheckHooks || (n.preOrderCheckHooks = [])).push(e, i));
                })(n, i[n], t);
          } finally {
            null !== c && Ie(c), Un(o), (a.resolving = !1), vn();
          }
        }
        return r;
      }
      function is(e, t, n) {
        const s = 64 & e,
          r = 32 & e;
        let i;
        return (
          (i =
            128 & e
              ? s
                ? r
                  ? n[t + 7]
                  : n[t + 6]
                : r
                ? n[t + 5]
                : n[t + 4]
              : s
              ? r
                ? n[t + 3]
                : n[t + 2]
              : r
              ? n[t + 1]
              : n[t]),
          !!(i & (1 << e))
        );
      }
      function as(e, t) {
        return !(e & ie.Self || (e & ie.Host && t));
      }
      class os {
        constructor(e, t) {
          (this._tNode = e), (this._lView = t);
        }
        get(e, t) {
          return es(this._tNode, this._lView, e, void 0, t);
        }
      }
      function cs(e) {
        const t = e;
        if (we(e))
          return () => {
            const e = cs(Ae(t));
            return e ? e() : null;
          };
        let n = gt(t);
        if (null === n) {
          const e = he(t);
          n = e && e.factory;
        }
        return n || null;
      }
      function ls(e) {
        return Z(() => {
          const t = e.prototype.constructor,
            n = t[Ce] || cs(t),
            s = Object.prototype;
          let r = Object.getPrototypeOf(e.prototype).constructor;
          for (; r && r !== s; ) {
            const e = r[Ce] || cs(r);
            if (e && e !== n) return e;
            r = Object.getPrototypeOf(r);
          }
          return (e) => new e();
        });
      }
      function ds(e) {
        return e.ngDebugContext;
      }
      function us(e) {
        return e.ngOriginalError;
      }
      function hs(e, ...t) {
        e.error(...t);
      }
      class Ms {
        constructor() {
          this._console = console;
        }
        handleError(e) {
          const t = this._findOriginalError(e),
            n = this._findContext(e),
            s = (function (e) {
              return e.ngErrorLogger || hs;
            })(e);
          s(this._console, "ERROR", e),
            t && s(this._console, "ORIGINAL ERROR", t),
            n && s(this._console, "ERROR CONTEXT", n);
        }
        _findContext(e) {
          return e ? (ds(e) ? ds(e) : this._findContext(us(e))) : null;
        }
        _findOriginalError(e) {
          let t = us(e);
          for (; t && us(t); ) t = us(t);
          return t;
        }
      }
      function ps(e) {
        return e instanceof
          class {
            constructor(e) {
              this.changingThisBreaksApplicationSecurity = e;
            }
            toString() {
              return (
                "SafeValue must use [property]=binding: " +
                this.changingThisBreaksApplicationSecurity +
                " (see http://g.co/ng/security#xss)"
              );
            }
          }
          ? e.changingThisBreaksApplicationSecurity
          : e;
      }
      let ms = !0,
        _s = !1;
      function fs() {
        return (_s = !0), ms;
      }
      function bs(e, t) {
        e.__ngContext__ = t;
      }
      function gs(e, t, n) {
        let s = e.length;
        for (;;) {
          const r = e.indexOf(t, n);
          if (-1 === r) return r;
          if (0 === r || e.charCodeAt(r - 1) <= 32) {
            const n = t.length;
            if (r + n === s || e.charCodeAt(r + n) <= 32) return r;
          }
          n = r + 1;
        }
      }
      function ys(e, t, n) {
        let s = 0;
        for (; s < e.length; ) {
          let r = e[s++];
          if (n && "class" === r) {
            if (((r = e[s]), -1 !== gs(r.toLowerCase(), t, 0))) return !0;
          } else if (1 === r) {
            for (; s < e.length && "string" == typeof (r = e[s++]); ) if (r.toLowerCase() === t) return !0;
            return !1;
          }
        }
        return !1;
      }
      function Ls(e) {
        return 0 === e.type && "ng-template" !== e.tagName;
      }
      function As(e, t, n) {
        return t === (0 !== e.type || n ? e.tagName : "ng-template");
      }
      function ws(e, t, n) {
        let s = 4;
        const r = e.attrs || [],
          i = (function (e) {
            for (let t = 0; t < e.length; t++) if (Hn(e[t])) return t;
            return e.length;
          })(r);
        let a = !1;
        for (let o = 0; o < t.length; o++) {
          const c = t[o];
          if ("number" != typeof c) {
            if (!a)
              if (4 & s) {
                if (((s = 2 | (1 & s)), ("" !== c && !As(e, c, n)) || ("" === c && 1 === t.length))) {
                  if (zs(s)) return !1;
                  a = !0;
                }
              } else {
                const l = 8 & s ? c : t[++o];
                if (8 & s && null !== e.attrs) {
                  if (!ys(e.attrs, l, n)) {
                    if (zs(s)) return !1;
                    a = !0;
                  }
                  continue;
                }
                const d = Ts(8 & s ? "class" : c, r, Ls(e), n);
                if (-1 === d) {
                  if (zs(s)) return !1;
                  a = !0;
                  continue;
                }
                if ("" !== l) {
                  let e;
                  e = d > i ? "" : r[d + 1].toLowerCase();
                  const t = 8 & s ? e : null;
                  if ((t && -1 !== gs(t, l, 0)) || (2 & s && l !== e)) {
                    if (zs(s)) return !1;
                    a = !0;
                  }
                }
              }
          } else {
            if (!a && !zs(s) && !zs(c)) return !1;
            if (a && zs(c)) continue;
            (a = !1), (s = c | (1 & s));
          }
        }
        return zs(s) || a;
      }
      function zs(e) {
        return 0 == (1 & e);
      }
      function Ts(e, t, n, s) {
        if (null === t) return -1;
        let r = 0;
        if (s || !n) {
          let n = !1;
          for (; r < t.length; ) {
            const s = t[r];
            if (s === e) return r;
            if (3 === s || 6 === s) n = !0;
            else {
              if (1 === s || 2 === s) {
                let e = t[++r];
                for (; "string" == typeof e; ) e = t[++r];
                continue;
              }
              if (4 === s) break;
              if (0 === s) {
                r += 4;
                continue;
              }
            }
            r += n ? 1 : 2;
          }
          return -1;
        }
        return (function (e, t) {
          let n = e.indexOf(4);
          if (n > -1)
            for (n++; n < e.length; ) {
              const s = e[n];
              if ("number" == typeof s) return -1;
              if (s === t) return n;
              n++;
            }
          return -1;
        })(t, e);
      }
      function vs(e, t, n = !1) {
        for (let s = 0; s < t.length; s++) if (ws(e, t[s], n)) return !0;
        return !1;
      }
      function Ds(e, t) {
        e: for (let n = 0; n < t.length; n++) {
          const s = t[n];
          if (e.length === s.length) {
            for (let t = 0; t < e.length; t++) if (e[t] !== s[t]) continue e;
            return !0;
          }
        }
        return !1;
      }
      function Os(e, t) {
        return e ? ":not(" + t.trim() + ")" : t;
      }
      function Ss(e) {
        let t = e[0],
          n = 1,
          s = 2,
          r = "",
          i = !1;
        for (; n < e.length; ) {
          let a = e[n];
          if ("string" == typeof a)
            if (2 & s) {
              const t = e[++n];
              r += "[" + a + (t.length > 0 ? '="' + t + '"' : "") + "]";
            } else 8 & s ? (r += "." + a) : 4 & s && (r += " " + a);
          else "" === r || zs(a) || ((t += Os(i, r)), (r = "")), (s = a), (i = i || !zs(s));
          n++;
        }
        return "" !== r && (t += Os(i, r)), t;
      }
      const ks = {};
      function Ys(e) {
        const t = e[3];
        return At(t) ? t[3] : t;
      }
      function Ns(e) {
        return Cs(e[13]);
      }
      function Es(e) {
        return Cs(e[4]);
      }
      function Cs(e) {
        for (; null !== e && !At(e); ) e = e[4];
        return e;
      }
      function Ws(e) {
        qs(rn(), sn(), On() + e, un());
      }
      function qs(e, t, n, s) {
        if (!s)
          if (3 == (3 & t[2])) {
            const s = e.preOrderCheckHooks;
            null !== s && Nn(t, s, n);
          } else {
            const s = e.preOrderHooks;
            null !== s && En(t, s, 0, n);
          }
        Sn(n);
      }
      function xs(e, t) {
        return (e << 17) | (t << 2);
      }
      function Bs(e) {
        return (e >> 17) & 32767;
      }
      function Hs(e) {
        return 2 | e;
      }
      function js(e) {
        return (131068 & e) >> 2;
      }
      function Ps(e, t) {
        return (-131069 & e) | (t << 2);
      }
      function Xs(e) {
        return 1 | e;
      }
      function Rs(e, t) {
        const n = e.contentQueries;
        if (null !== n)
          for (let s = 0; s < n.length; s += 2) {
            const r = n[s],
              i = n[s + 1];
            if (-1 !== i) {
              const n = e.data[i];
              yn(r), n.contentQueries(2, t[i], i);
            }
          }
      }
      function Is(e, t, n) {
        return Pt(t) ? t.createElement(e, n) : null === n ? t.createElement(e) : t.createElementNS(n, e);
      }
      function Fs(e, t, n, s, r, i, a, o, c, l) {
        const d = t.blueprint.slice();
        return (
          (d[0] = r),
          (d[2] = 140 | s),
          Zt(d),
          (d[3] = d[15] = e),
          (d[8] = n),
          (d[10] = a || (e && e[10])),
          (d[11] = o || (e && e[11])),
          (d[12] = c || (e && e[12]) || null),
          (d[9] = l || (e && e[9]) || null),
          (d[6] = i),
          (d[16] = 2 == t.type ? e[16] : d),
          d
        );
      }
      function Vs(e, t, n, s, r) {
        const i = t + 20,
          a =
            e.data[i] ||
            (function (e, t, n, s, r) {
              const i = on(),
                a = ln(),
                o = (e.data[t] = (function (e, t, n, s, r, i) {
                  return {
                    type: n,
                    index: s,
                    injectorIndex: t ? t.injectorIndex : -1,
                    directiveStart: -1,
                    directiveEnd: -1,
                    directiveStylingLast: -1,
                    propertyBindings: null,
                    flags: 0,
                    providerIndexes: 0,
                    tagName: r,
                    attrs: i,
                    mergedAttrs: null,
                    localNames: null,
                    initialInputs: void 0,
                    inputs: null,
                    outputs: null,
                    tViews: null,
                    next: null,
                    projectionNext: null,
                    child: null,
                    parent: t,
                    projection: null,
                    styles: null,
                    stylesWithoutHost: null,
                    residualStyles: void 0,
                    classes: null,
                    classesWithoutHost: null,
                    residualClasses: void 0,
                    classBindings: 0,
                    styleBindings: 0,
                  };
                })(0, a ? i : i && i.parent, n, t, s, r));
              return (
                null === e.firstChild && (e.firstChild = o),
                null !== i && (a && null == i.child && null !== o.parent ? (i.child = o) : a || (i.next = o)),
                o
              );
            })(e, i, n, s, r);
        return cn(a, !0), a;
      }
      function Us(e, t, n) {
        An(t);
        try {
          const s = e.viewQuery;
          null !== s && zr(1, s, n);
          const r = e.template;
          null !== r && Qs(e, t, r, 1, n),
            e.firstCreatePass && (e.firstCreatePass = !1),
            e.staticContentQueries && Rs(e, t),
            e.staticViewQueries && zr(2, e.viewQuery, n);
          const i = e.components;
          null !== i &&
            (function (e, t) {
              for (let n = 0; n < t.length; n++) gr(e, t[n]);
            })(t, i);
        } catch (s) {
          throw (e.firstCreatePass && (e.incompleteFirstPass = !0), s);
        } finally {
          (t[2] &= -5), Dn();
        }
      }
      function Js(e, t, n, s) {
        const r = t[2];
        if (256 == (256 & r)) return;
        An(t);
        const i = un();
        try {
          Zt(t), (tn.lFrame.bindingIndex = e.bindingStartIndex), null !== n && Qs(e, t, n, 2, s);
          const a = 3 == (3 & r);
          if (!i)
            if (a) {
              const n = e.preOrderCheckHooks;
              null !== n && Nn(t, n, null);
            } else {
              const n = e.preOrderHooks;
              null !== n && En(t, n, 0, null), Cn(t, 0);
            }
          if (
            ((function (e) {
              for (let t = Ns(e); null !== t; t = Es(t)) {
                if (!t[2]) continue;
                const e = t[9];
                for (let t = 0; t < e.length; t++) {
                  const n = e[t],
                    s = n[3];
                  0 == (1024 & n[2]) && en(s, 1), (n[2] |= 1024);
                }
              }
            })(t),
            (function (e) {
              for (let t = Ns(e); null !== t; t = Es(t))
                for (let e = 10; e < t.length; e++) {
                  const n = t[e],
                    s = n[1];
                  Kt(n) && Js(s, n, s.template, n[8]);
                }
            })(t),
            null !== e.contentQueries && Rs(e, t),
            !i)
          )
            if (a) {
              const n = e.contentCheckHooks;
              null !== n && Nn(t, n);
            } else {
              const n = e.contentHooks;
              null !== n && En(t, n, 1), Cn(t, 1);
            }
          !(function (e, t) {
            try {
              const n = e.expandoInstructions;
              if (null !== n) {
                let s = e.expandoStartIndex,
                  r = -1,
                  i = -1;
                for (let e = 0; e < n.length; e++) {
                  const a = n[e];
                  "number" == typeof a
                    ? a <= 0
                      ? ((i = 0 - a), Sn(i), (s += 9 + n[++e]), (r = s))
                      : (s += a)
                    : (null !== a && (fn(s, r), a(2, t[r])), r++);
                }
              }
            } finally {
              Sn(-1);
            }
          })(e, t);
          const o = e.components;
          null !== o &&
            (function (e, t) {
              for (let n = 0; n < t.length; n++) br(e, t[n]);
            })(t, o);
          const c = e.viewQuery;
          if ((null !== c && zr(2, c, s), !i))
            if (a) {
              const n = e.viewCheckHooks;
              null !== n && Nn(t, n);
            } else {
              const n = e.viewHooks;
              null !== n && En(t, n, 2), Cn(t, 2);
            }
          !0 === e.firstUpdatePass && (e.firstUpdatePass = !1),
            i || (t[2] &= -73),
            1024 & t[2] && ((t[2] &= -1025), en(t[3], -1));
        } finally {
          Dn();
        }
      }
      function Gs(e, t, n, s) {
        const r = t[10],
          i = !un(),
          a = Qt(t);
        try {
          i && !a && r.begin && r.begin(), a && Us(e, t, s), Js(e, t, n, s);
        } finally {
          i && !a && r.end && r.end();
        }
      }
      function Qs(e, t, n, s, r) {
        const i = On();
        try {
          Sn(-1), 2 & s && t.length > 20 && qs(e, t, 0, un()), n(s, r);
        } finally {
          Sn(i);
        }
      }
      function Ks(e, t, n) {
        nn() &&
          ((function (e, t, n, s) {
            const r = n.directiveStart,
              i = n.directiveEnd;
            e.firstCreatePass || Gn(n, t), bs(s, t);
            const a = n.initialInputs;
            for (let o = r; o < i; o++) {
              const s = e.data[o],
                i = vt(s);
              i && Mr(t, n, s);
              const c = rs(t, e, o, n);
              bs(c, t), null !== a && mr(0, o - r, c, s, 0, a), i && (Jt(n.index, t)[8] = c);
            }
          })(e, t, n, Ft(n, t)),
          128 == (128 & n.flags) &&
            (function (e, t, n) {
              const s = n.directiveStart,
                r = n.directiveEnd,
                i = e.expandoInstructions,
                a = e.firstCreatePass,
                o = n.index - 20,
                c = tn.lFrame.currentDirectiveIndex;
              try {
                Sn(o);
                for (let n = s; n < r; n++) {
                  const s = e.data[n],
                    r = t[n];
                  bn(n),
                    null !== s.hostBindings || 0 !== s.hostVars || null !== s.hostAttrs ? or(s, r) : a && i.push(null);
                }
              } finally {
                Sn(-1), bn(c);
              }
            })(e, t, n));
      }
      function $s(e, t, n = Ft) {
        const s = t.localNames;
        if (null !== s) {
          let r = t.index + 1;
          for (let i = 0; i < s.length; i += 2) {
            const a = s[i + 1],
              o = -1 === a ? n(t, e) : e[a];
            e[r++] = o;
          }
        }
      }
      function Zs(e) {
        const t = e.tView;
        return null === t || t.incompleteFirstPass
          ? (e.tView = er(
              1,
              null,
              e.template,
              e.decls,
              e.vars,
              e.directiveDefs,
              e.pipeDefs,
              e.viewQuery,
              e.schemas,
              e.consts
            ))
          : t;
      }
      function er(e, t, n, s, r, i, a, o, c, l) {
        const d = 20 + s,
          u = d + r,
          h = (function (e, t) {
            const n = [];
            for (let s = 0; s < t; s++) n.push(s < e ? null : ks);
            return n;
          })(d, u),
          M = "function" == typeof l ? l() : l;
        return (h[1] = {
          type: e,
          blueprint: h,
          template: n,
          queries: null,
          viewQuery: o,
          declTNode: t,
          data: h.slice().fill(null, d),
          bindingStartIndex: d,
          expandoStartIndex: u,
          expandoInstructions: null,
          firstCreatePass: !0,
          firstUpdatePass: !0,
          staticViewQueries: !1,
          staticContentQueries: !1,
          preOrderHooks: null,
          preOrderCheckHooks: null,
          contentHooks: null,
          contentCheckHooks: null,
          viewHooks: null,
          viewCheckHooks: null,
          destroyHooks: null,
          cleanup: null,
          contentQueries: null,
          components: null,
          directiveRegistry: "function" == typeof i ? i() : i,
          pipeRegistry: "function" == typeof a ? a() : a,
          firstChild: null,
          schemas: c,
          consts: M,
          incompleteFirstPass: !1,
        });
      }
      function tr(e, t, n, s) {
        const r = vr(t);
        r.push(n),
          e.firstCreatePass &&
            (function (e) {
              return e.cleanup || (e.cleanup = []);
            })(e).push(s, r.length - 1);
      }
      function nr(e, t, n) {
        for (let s in e)
          if (e.hasOwnProperty(s)) {
            const r = e[s];
            (n = null === n ? {} : n).hasOwnProperty(s) ? n[s].push(t, r) : (n[s] = [t, r]);
          }
        return n;
      }
      function sr(e, t, n, s, r, i, a, o) {
        const c = Ft(t, n);
        let l,
          d = t.inputs;
        var u;
        !o && null != d && (l = d[s])
          ? (Or(e, n, l, s, r),
            zt(t) &&
              (function (e, t) {
                const n = Jt(t, e);
                16 & n[2] || (n[2] |= 64);
              })(n, t.index))
          : 2 === t.type &&
            ((s =
              "class" === (u = s)
                ? "className"
                : "for" === u
                ? "htmlFor"
                : "formaction" === u
                ? "formAction"
                : "innerHtml" === u
                ? "innerHTML"
                : "readonly" === u
                ? "readOnly"
                : "tabindex" === u
                ? "tabIndex"
                : u),
            (r = null != a ? a(r, t.tagName || "", s) : r),
            Pt(i) ? i.setProperty(c, s, r) : jn(s) || (c.setProperty ? c.setProperty(s, r) : (c[s] = r)));
      }
      function rr(e, t, n, s) {
        let r = !1;
        if (nn()) {
          const i = (function (e, t, n) {
              const s = e.directiveRegistry;
              let r = null;
              if (s)
                for (let i = 0; i < s.length; i++) {
                  const a = s[i];
                  vs(n, a.selectors, !1) &&
                    (r || (r = []), Zn(Gn(n, t), e, a.type), vt(a) ? (lr(e, n), r.unshift(a)) : r.push(a));
                }
              return r;
            })(e, t, n),
            a = null === s ? null : { "": -1 };
          if (null !== i) {
            let s = 0;
            (r = !0), ur(n, e.data.length, i.length);
            for (let e = 0; e < i.length; e++) {
              const t = i[e];
              t.providersResolver && t.providersResolver(t);
            }
            cr(e, n, i.length);
            let o = !1,
              c = !1;
            for (let r = 0; r < i.length; r++) {
              const l = i[r];
              (n.mergedAttrs = Pn(n.mergedAttrs, l.hostAttrs)),
                hr(e, t, l),
                dr(e.data.length - 1, l, a),
                null !== l.contentQueries && (n.flags |= 8),
                (null === l.hostBindings && null === l.hostAttrs && 0 === l.hostVars) || (n.flags |= 128);
              const d = l.type.prototype;
              !o &&
                (d.ngOnChanges || d.ngOnInit || d.ngDoCheck) &&
                ((e.preOrderHooks || (e.preOrderHooks = [])).push(n.index - 20), (o = !0)),
                c ||
                  (!d.ngOnChanges && !d.ngDoCheck) ||
                  ((e.preOrderCheckHooks || (e.preOrderCheckHooks = [])).push(n.index - 20), (c = !0)),
                ir(e, l),
                (s += l.hostVars);
            }
            !(function (e, t) {
              const n = t.directiveEnd,
                s = e.data,
                r = t.attrs,
                i = [];
              let a = null,
                o = null;
              for (let c = t.directiveStart; c < n; c++) {
                const e = s[c],
                  n = e.inputs,
                  l = null === r || Ls(t) ? null : _r(n, r);
                i.push(l), (a = nr(n, c, a)), (o = nr(e.outputs, c, o));
              }
              null !== a &&
                (a.hasOwnProperty("class") && (t.flags |= 16), a.hasOwnProperty("style") && (t.flags |= 32)),
                (t.initialInputs = i),
                (t.inputs = a),
                (t.outputs = o);
            })(e, n),
              ar(e, t, s);
          }
          a &&
            (function (e, t, n) {
              if (t) {
                const s = (e.localNames = []);
                for (let e = 0; e < t.length; e += 2) {
                  const r = n[t[e + 1]];
                  if (null == r) throw new Error(`Export of name '${t[e + 1]}' not found!`);
                  s.push(t[e], r);
                }
              }
            })(n, s, a);
        }
        return (n.mergedAttrs = Pn(n.mergedAttrs, n.attrs)), r;
      }
      function ir(e, t) {
        const n = e.expandoInstructions;
        n.push(t.hostBindings), 0 !== t.hostVars && n.push(t.hostVars);
      }
      function ar(e, t, n) {
        for (let s = 0; s < n; s++) t.push(ks), e.blueprint.push(ks), e.data.push(null);
      }
      function or(e, t) {
        null !== e.hostBindings && e.hostBindings(1, t);
      }
      function cr(e, t, n) {
        const s = 20 - t.index,
          r = e.data.length - (1048575 & t.providerIndexes);
        (e.expandoInstructions || (e.expandoInstructions = [])).push(s, r, n);
      }
      function lr(e, t) {
        (t.flags |= 2), (e.components || (e.components = [])).push(t.index);
      }
      function dr(e, t, n) {
        if (n) {
          if (t.exportAs) for (let s = 0; s < t.exportAs.length; s++) n[t.exportAs[s]] = e;
          vt(t) && (n[""] = e);
        }
      }
      function ur(e, t, n) {
        (e.flags |= 1), (e.directiveStart = t), (e.directiveEnd = t + n), (e.providerIndexes = t);
      }
      function hr(e, t, n) {
        e.data.push(n);
        const s = n.factory || (n.factory = gt(n.type)),
          r = new xn(s, vt(n), null);
        e.blueprint.push(r), t.push(r);
      }
      function Mr(e, t, n) {
        const s = Ft(t, e),
          r = Zs(n),
          i = e[10],
          a = yr(e, Fs(e, r, null, n.onPush ? 64 : 16, s, t, i, i.createRenderer(s, n), null, null));
        e[t.index] = a;
      }
      function pr(e, t, n, s, r, i) {
        const a = Ft(e, t),
          o = t[11];
        if (null == s) Pt(o) ? o.removeAttribute(a, n, i) : a.removeAttribute(n);
        else {
          const t = null == r ? Ot(s) : r(s, e.tagName || "", n);
          Pt(o) ? o.setAttribute(a, n, t, i) : i ? a.setAttributeNS(i, n, t) : a.setAttribute(n, t);
        }
      }
      function mr(e, t, n, s, r, i) {
        const a = i[t];
        if (null !== a) {
          const e = s.setInput;
          for (let t = 0; t < a.length; ) {
            const r = a[t++],
              i = a[t++],
              o = a[t++];
            null !== e ? s.setInput(n, o, r, i) : (n[i] = o);
          }
        }
      }
      function _r(e, t) {
        let n = null,
          s = 0;
        for (; s < t.length; ) {
          const r = t[s];
          if (0 !== r)
            if (5 !== r) {
              if ("number" == typeof r) break;
              e.hasOwnProperty(r) && (null === n && (n = []), n.push(r, e[r], t[s + 1])), (s += 2);
            } else s += 2;
          else s += 4;
        }
        return n;
      }
      function fr(e, t, n, s) {
        return new Array(e, !0, !1, t, null, 0, s, n, null, null);
      }
      function br(e, t) {
        const n = Jt(t, e);
        if (Kt(n)) {
          const e = n[1];
          80 & n[2]
            ? Js(e, n, e.template, n[8])
            : n[5] > 0 &&
              (function e(t) {
                for (let s = Ns(t); null !== s; s = Es(s))
                  for (let t = 10; t < s.length; t++) {
                    const n = s[t];
                    if (1024 & n[2]) {
                      const e = n[1];
                      Js(e, n, e.template, n[8]);
                    } else n[5] > 0 && e(n);
                  }
                const n = t[1].components;
                if (null !== n)
                  for (let s = 0; s < n.length; s++) {
                    const r = Jt(n[s], t);
                    Kt(r) && r[5] > 0 && e(r);
                  }
              })(n);
        }
      }
      function gr(e, t) {
        const n = Jt(t, e),
          s = n[1];
        !(function (e, t) {
          for (let n = t.length; n < e.blueprint.length; n++) t.push(e.blueprint[n]);
        })(s, n),
          Us(s, n, n[8]);
      }
      function yr(e, t) {
        return e[13] ? (e[14][4] = t) : (e[13] = t), (e[14] = t), t;
      }
      function Lr(e) {
        for (; e; ) {
          e[2] |= 64;
          const t = Ys(e);
          if (Dt(e) && !t) return e;
          e = t;
        }
        return null;
      }
      function Ar(e, t, n) {
        const s = t[10];
        s.begin && s.begin();
        try {
          Js(e, t, e.template, n);
        } catch (r) {
          throw (Dr(t, r), r);
        } finally {
          s.end && s.end();
        }
      }
      function wr(e) {
        !(function (e) {
          for (let t = 0; t < e.components.length; t++) {
            const n = e.components[t],
              s = Gt(n),
              r = s[1];
            Gs(r, s, r.template, n);
          }
        })(e[8]);
      }
      function zr(e, t, n) {
        yn(0), t(e, n);
      }
      const Tr = (() => Promise.resolve(null))();
      function vr(e) {
        return e[7] || (e[7] = []);
      }
      function Dr(e, t) {
        const n = e[9],
          s = n ? n.get(Ms, null) : null;
        s && s.handleError(t);
      }
      function Or(e, t, n, s, r) {
        for (let i = 0; i < n.length; ) {
          const a = n[i++],
            o = n[i++],
            c = t[a],
            l = e.data[a];
          null !== l.setInput ? l.setInput(c, r, s, o) : (c[o] = r);
        }
      }
      function Sr(e, t, n, s, r) {
        if (null != s) {
          let i,
            a = !1;
          At(s) ? (i = s) : Lt(s) && ((a = !0), (s = s[0]));
          const o = Rt(s);
          0 === e && null !== n
            ? null == r
              ? qr(t, n, o)
              : Wr(t, n, o, r || null)
            : 1 === e && null !== n
            ? Wr(t, n, o, r || null)
            : 2 === e
            ? (function (e, t, n) {
                const s = Br(e, t);
                s &&
                  (function (e, t, n, s) {
                    Pt(e) ? e.removeChild(t, n, s) : t.removeChild(n);
                  })(e, s, t, n);
              })(t, o, a)
            : 3 === e && t.destroyNode(o),
            null != i &&
              (function (e, t, n, s, r) {
                const i = n[7];
                i !== Rt(n) && Sr(t, e, s, i, r);
                for (let a = 10; a < n.length; a++) {
                  const r = n[a];
                  Xr(r[1], r, e, t, s, i);
                }
              })(t, e, i, n, r);
        }
      }
      function kr(e, t) {
        const n = e[9],
          s = n.indexOf(t),
          r = t[3];
        1024 & t[2] && ((t[2] &= -1025), en(r, -1)), n.splice(s, 1);
      }
      function Yr(e, t) {
        if (e.length <= 10) return;
        const n = 10 + t,
          s = e[n];
        if (s) {
          const i = s[17];
          null !== i && i !== e && kr(i, s), t > 0 && (e[n - 1][4] = s[4]);
          const a = et(e, 10 + t);
          Xr(s[1], (r = s), r[11], 2, null, null), (r[0] = null), (r[6] = null);
          const o = a[19];
          null !== o && o.detachView(a[1]), (s[3] = null), (s[4] = null), (s[2] &= -129);
        }
        var r;
        return s;
      }
      function Nr(e, t) {
        if (!(256 & t[2])) {
          const n = t[11];
          Pt(n) && n.destroyNode && Xr(e, t, n, 3, null, null),
            (function (e) {
              let t = e[13];
              if (!t) return Er(e[1], e);
              for (; t; ) {
                let n = null;
                if (Lt(t)) n = t[13];
                else {
                  const e = t[10];
                  e && (n = e);
                }
                if (!n) {
                  for (; t && !t[4] && t !== e; ) Lt(t) && Er(t[1], t), (t = t[3]);
                  null === t && (t = e), Lt(t) && Er(t[1], t), (n = t && t[4]);
                }
                t = n;
              }
            })(t);
        }
      }
      function Er(e, t) {
        if (!(256 & t[2])) {
          (t[2] &= -129),
            (t[2] |= 256),
            (function (e, t) {
              let n;
              if (null != e && null != (n = e.destroyHooks))
                for (let s = 0; s < n.length; s += 2) {
                  const e = t[n[s]];
                  if (!(e instanceof xn)) {
                    const t = n[s + 1];
                    if (Array.isArray(t)) for (let n = 0; n < t.length; n += 2) t[n + 1].call(e[t[n]]);
                    else t.call(e);
                  }
                }
            })(e, t),
            (function (e, t) {
              const n = e.cleanup;
              if (null !== n) {
                const e = t[7];
                for (let s = 0; s < n.length - 1; s += 2)
                  if ("string" == typeof n[s]) {
                    const r = n[s + 1],
                      i = "function" == typeof r ? r(t) : Rt(t[r]),
                      a = e[n[s + 2]],
                      o = n[s + 3];
                    "boolean" == typeof o ? i.removeEventListener(n[s], a, o) : o >= 0 ? e[o]() : e[-o].unsubscribe(),
                      (s += 2);
                  } else n[s].call(e[n[s + 1]]);
                t[7] = null;
              }
            })(e, t),
            1 === t[1].type && Pt(t[11]) && t[11].destroy();
          const n = t[17];
          if (null !== n && At(t[3])) {
            n !== t[3] && kr(n, t);
            const s = t[19];
            null !== s && s.detachView(e);
          }
        }
      }
      function Cr(e, t, n) {
        let s = t.parent;
        for (; null != s && (3 === s.type || 4 === s.type); ) s = (t = s).parent;
        if (null === s) return n[0];
        if (t && 4 === t.type && 4 & t.flags) return Ft(t, n).parentNode;
        if (2 & s.flags) {
          const t = e.data,
            n = t[t[s.index].directiveStart].encapsulation;
          if (n !== at.ShadowDom && n !== at.Native) return null;
        }
        return Ft(s, n);
      }
      function Wr(e, t, n, s) {
        Pt(e) ? e.insertBefore(t, n, s) : t.insertBefore(n, s, !0);
      }
      function qr(e, t, n) {
        Pt(e) ? e.appendChild(t, n) : t.appendChild(n);
      }
      function xr(e, t, n, s) {
        null !== s ? Wr(e, t, n, s) : qr(e, t, n);
      }
      function Br(e, t) {
        return Pt(e) ? e.parentNode(t) : t.parentNode;
      }
      function Hr(e, t) {
        return 3 === e.type || 4 === e.type ? Ft(e, t) : null;
      }
      function jr(e, t, n, s) {
        const r = Cr(e, s, t);
        if (null != r) {
          const e = t[11],
            i = Hr(s.parent || t[6], t);
          if (Array.isArray(n)) for (let t = 0; t < n.length; t++) xr(e, r, n[t], i);
          else xr(e, r, n, i);
        }
      }
      function Pr(e, t, n, s, r, i, a) {
        for (; null != n; ) {
          const o = s[n.index],
            c = n.type;
          a && 0 === t && (o && bs(Rt(o), s), (n.flags |= 4)),
            64 != (64 & n.flags) &&
              (3 === c || 4 === c
                ? (Pr(e, t, n.child, s, r, i, !1), Sr(t, e, r, o, i))
                : 1 === c
                ? Rr(e, t, s, n, r, i)
                : Sr(t, e, r, o, i)),
            (n = a ? n.projectionNext : n.next);
        }
      }
      function Xr(e, t, n, s, r, i) {
        Pr(n, s, e.firstChild, t, r, i, !1);
      }
      function Rr(e, t, n, s, r, i) {
        const a = n[16],
          o = a[6].projection[s.projection];
        if (Array.isArray(o)) for (let c = 0; c < o.length; c++) Sr(t, e, r, o[c], i);
        else Pr(e, t, o, a[3], r, i, !0);
      }
      function Ir(e, t, n) {
        Pt(e) ? e.setAttribute(t, "style", n) : (t.style.cssText = n);
      }
      function Fr(e, t, n) {
        Pt(e) ? ("" === n ? e.removeAttribute(t, "class") : e.setAttribute(t, "class", n)) : (t.className = n);
      }
      class Vr {
        constructor(e, t) {
          (this._lView = e), (this._cdRefInjectingView = t), (this._appRef = null), (this._viewContainerRef = null);
        }
        get rootNodes() {
          const e = this._lView,
            t = e[1];
          return (function e(t, n, s, r, i = !1) {
            for (; null !== s; ) {
              const a = n[s.index];
              if ((null !== a && r.push(Rt(a)), At(a)))
                for (let t = 10; t < a.length; t++) {
                  const n = a[t],
                    s = n[1].firstChild;
                  null !== s && e(n[1], n, s, r);
                }
              const o = s.type;
              if (3 === o || 4 === o) e(t, n, s.child, r);
              else if (1 === o) {
                const t = n[16],
                  i = t[6].projection[s.projection];
                if (Array.isArray(i)) r.push(...i);
                else {
                  const n = Ys(t);
                  e(n[1], n, i, r, !0);
                }
              }
              s = i ? s.projectionNext : s.next;
            }
            return r;
          })(t, e, t.firstChild, []);
        }
        get context() {
          return this._lView[8];
        }
        get destroyed() {
          return 256 == (256 & this._lView[2]);
        }
        destroy() {
          if (this._appRef) this._appRef.detachView(this);
          else if (this._viewContainerRef) {
            const e = this._viewContainerRef.indexOf(this);
            e > -1 && this._viewContainerRef.detach(e), (this._viewContainerRef = null);
          }
          Nr(this._lView[1], this._lView);
        }
        onDestroy(e) {
          tr(this._lView[1], this._lView, null, e);
        }
        markForCheck() {
          Lr(this._cdRefInjectingView || this._lView);
        }
        detach() {
          this._lView[2] &= -129;
        }
        reattach() {
          this._lView[2] |= 128;
        }
        detectChanges() {
          Ar(this._lView[1], this._lView, this.context);
        }
        checkNoChanges() {
          !(function (e, t, n) {
            hn(!0);
            try {
              Ar(e, t, n);
            } finally {
              hn(!1);
            }
          })(this._lView[1], this._lView, this.context);
        }
        attachToViewContainerRef(e) {
          if (this._appRef) throw new Error("This view is already attached directly to the ApplicationRef!");
          this._viewContainerRef = e;
        }
        detachFromAppRef() {
          var e;
          (this._appRef = null), Xr(this._lView[1], (e = this._lView), e[11], 2, null, null);
        }
        attachToAppRef(e) {
          if (this._viewContainerRef) throw new Error("This view is already attached to a ViewContainer!");
          this._appRef = e;
        }
      }
      class Ur extends Vr {
        constructor(e) {
          super(e), (this._view = e);
        }
        detectChanges() {
          wr(this._view);
        }
        checkNoChanges() {
          !(function (e) {
            hn(!0);
            try {
              wr(e);
            } finally {
              hn(!1);
            }
          })(this._view);
        }
        get context() {
          return null;
        }
      }
      let Jr, Gr, Qr;
      function Kr(e, t, n) {
        return Jr || (Jr = class extends e {}), new Jr(Ft(t, n));
      }
      function $r(e, t, n, s) {
        return (
          Gr ||
            (Gr = class extends e {
              constructor(e, t, n) {
                super(), (this._declarationView = e), (this._declarationTContainer = t), (this.elementRef = n);
              }
              createEmbeddedView(e) {
                const t = this._declarationTContainer.tViews,
                  n = Fs(this._declarationView, t, e, 16, null, t.declTNode, null, null, null, null);
                n[17] = this._declarationView[this._declarationTContainer.index];
                const s = this._declarationView[19];
                return null !== s && (n[19] = s.createEmbeddedView(t)), Us(t, n, e), new Vr(n);
              }
            }),
          0 === n.type ? new Gr(s, n, Kr(t, n, s)) : null
        );
      }
      function Zr(e, t, n, s) {
        let r;
        Qr ||
          (Qr = class extends e {
            constructor(e, t, n) {
              super(), (this._lContainer = e), (this._hostTNode = t), (this._hostView = n);
            }
            get element() {
              return Kr(t, this._hostTNode, this._hostView);
            }
            get injector() {
              return new os(this._hostTNode, this._hostView);
            }
            get parentInjector() {
              const e = $n(this._hostTNode, this._hostView);
              if (Rn(e)) {
                const t = Fn(e, this._hostView),
                  n = In(e);
                return new os(t[1].data[n + 8], t);
              }
              return new os(null, this._hostView);
            }
            clear() {
              for (; this.length > 0; ) this.remove(this.length - 1);
            }
            get(e) {
              return (null !== this._lContainer[8] && this._lContainer[8][e]) || null;
            }
            get length() {
              return this._lContainer.length - 10;
            }
            createEmbeddedView(e, t, n) {
              const s = e.createEmbeddedView(t || {});
              return this.insert(s, n), s;
            }
            createComponent(e, t, n, s, r) {
              const i = n || this.parentInjector;
              if (!r && null == e.ngModule && i) {
                const e = i.get(Qe, null);
                e && (r = e);
              }
              const a = e.create(i, s, void 0, r);
              return this.insert(a.hostView, t), a;
            }
            insert(e, t) {
              const n = e._lView,
                s = n[1];
              if (e.destroyed) throw new Error("Cannot insert a destroyed View in a ViewContainer!");
              if ((this.allocateContainerIfNeeded(), At(n[3]))) {
                const t = this.indexOf(e);
                if (-1 !== t) this.detach(t);
                else {
                  const t = n[3],
                    s = new Qr(t, t[6], t[3]);
                  s.detach(s.indexOf(e));
                }
              }
              const r = this._adjustIndex(t),
                i = this._lContainer;
              !(function (e, t, n, s) {
                const r = 10 + s,
                  i = n.length;
                s > 0 && (n[r - 1][4] = t),
                  s < i - 10 ? ((t[4] = n[r]), Ze(n, 10 + s, t)) : (n.push(t), (t[4] = null)),
                  (t[3] = n);
                const a = t[17];
                null !== a &&
                  n !== a &&
                  (function (e, t) {
                    const n = e[9];
                    t[16] !== t[3][3][16] && (e[2] = !0), null === n ? (e[9] = [t]) : n.push(t);
                  })(a, t);
                const o = t[19];
                null !== o && o.insertView(e), (t[2] |= 128);
              })(s, n, i, r);
              const a = (function e(t, n) {
                  const s = 10 + t + 1;
                  if (s < n.length) {
                    const t = n[s],
                      r = t[1].firstChild;
                    if (null !== r)
                      return (function t(n, s) {
                        if (null !== s) {
                          const r = s.type;
                          if (2 === r) return Ft(s, n);
                          if (0 === r) return e(-1, n[s.index]);
                          if (3 === r || 4 === r) {
                            const r = s.child;
                            if (null !== r) return t(n, r);
                            {
                              const t = n[s.index];
                              return At(t) ? e(-1, t) : Rt(t);
                            }
                          }
                          {
                            const e = n[16],
                              r = e[6],
                              i = Ys(e),
                              a = r.projection[s.projection];
                            return null != a ? t(i, a) : t(n, s.next);
                          }
                        }
                        return null;
                      })(t, r);
                  }
                  return n[7];
                })(r, i),
                o = n[11],
                c = Br(o, i[7]);
              return (
                null !== c &&
                  (function (e, t, n, s, r, i) {
                    (s[0] = r), (s[6] = t), Xr(e, s, n, 1, r, i);
                  })(s, i[6], o, n, c, a),
                e.attachToViewContainerRef(this),
                Ze(i[8], r, e),
                e
              );
            }
            move(e, t) {
              if (e.destroyed) throw new Error("Cannot move a destroyed View in a ViewContainer!");
              return this.insert(e, t);
            }
            indexOf(e) {
              const t = this._lContainer[8];
              return null !== t ? t.indexOf(e) : -1;
            }
            remove(e) {
              this.allocateContainerIfNeeded();
              const t = this._adjustIndex(e, -1),
                n = Yr(this._lContainer, t);
              n && (et(this._lContainer[8], t), Nr(n[1], n));
            }
            detach(e) {
              this.allocateContainerIfNeeded();
              const t = this._adjustIndex(e, -1),
                n = Yr(this._lContainer, t);
              return n && null != et(this._lContainer[8], t) ? new Vr(n) : null;
            }
            _adjustIndex(e, t = 0) {
              return null == e ? this.length + t : e;
            }
            allocateContainerIfNeeded() {
              null === this._lContainer[8] && (this._lContainer[8] = []);
            }
          });
        const i = s[n.index];
        if (At(i)) r = i;
        else {
          let e;
          if (3 === n.type) e = Rt(i);
          else if (((e = s[11].createComment("")), Dt(s))) {
            const t = s[11],
              r = Ft(n, s);
            Wr(
              t,
              Br(t, r),
              e,
              (function (e, t) {
                return Pt(e) ? e.nextSibling(t) : t.nextSibling;
              })(t, r)
            );
          } else jr(s[1], s, e, n);
          (s[n.index] = r = fr(i, s, e, n)), yr(s, r);
        }
        return new Qr(r, n, s);
      }
      let ei = (() => {
        class e {}
        return (e.__NG_ELEMENT_ID__ = () => ti()), e;
      })();
      const ti = function (e = !1) {
          return (function (e, t, n) {
            if (!n && zt(e)) {
              const n = Jt(e.index, t);
              return new Vr(n, n);
            }
            return 2 === e.type || 0 === e.type || 3 === e.type || 4 === e.type ? new Vr(t[16], t) : null;
          })(on(), sn(), e);
        },
        ni = Function,
        si = new qe("Set Injector scope."),
        ri = {},
        ii = {},
        ai = [];
      let oi = void 0;
      function ci() {
        return void 0 === oi && (oi = new Ge()), oi;
      }
      function li(e, t = null, n = null, s) {
        return new di(e, n, t || ci(), s);
      }
      class di {
        constructor(e, t, n, s = null) {
          (this.parent = n),
            (this.records = new Map()),
            (this.injectorDefTypes = new Set()),
            (this.onDestroy = new Set()),
            (this._destroyed = !1);
          const r = [];
          t && $e(t, (n) => this.processProvider(n, e, t)),
            $e([e], (e) => this.processInjectorType(e, [], r)),
            this.records.set(xe, Mi(void 0, this));
          const i = this.records.get(si);
          (this.scope = null != i ? i.value : null), (this.source = s || ("object" == typeof e ? null : be(e)));
        }
        get destroyed() {
          return this._destroyed;
        }
        destroy() {
          this.assertNotDestroyed(), (this._destroyed = !0);
          try {
            this.onDestroy.forEach((e) => e.ngOnDestroy());
          } finally {
            this.records.clear(), this.onDestroy.clear(), this.injectorDefTypes.clear();
          }
        }
        get(e, t = Be, n = ie.Default) {
          this.assertNotDestroyed();
          const s = Re(this);
          try {
            if (!(n & ie.SkipSelf)) {
              let t = this.records.get(e);
              if (void 0 === t) {
                const n = ("function" == typeof (r = e) || ("object" == typeof r && r instanceof qe)) && de(e);
                (t = n && this.injectableDefInScope(n) ? Mi(ui(e), ri) : null), this.records.set(e, t);
              }
              if (null != t) return this.hydrate(e, t);
            }
            return (n & ie.Self ? ci() : this.parent).get(e, (t = n & ie.Optional && t === Be ? null : t));
          } catch (i) {
            if ("NullInjectorError" === i.name) {
              if (((i.ngTempTokenPath = i.ngTempTokenPath || []).unshift(be(e)), s)) throw i;
              return (function (e, t, n, s) {
                const r = e.ngTempTokenPath;
                throw (
                  (t.__source && r.unshift(t.__source),
                  (e.message = (function (e, t, n, s = null) {
                    e = e && "\n" === e.charAt(0) && "\u0275" == e.charAt(1) ? e.substr(2) : e;
                    let r = be(t);
                    if (Array.isArray(t)) r = t.map(be).join(" -> ");
                    else if ("object" == typeof t) {
                      let e = [];
                      for (let n in t)
                        if (t.hasOwnProperty(n)) {
                          let s = t[n];
                          e.push(n + ":" + ("string" == typeof s ? JSON.stringify(s) : be(s)));
                        }
                      r = `{${e.join(", ")}}`;
                    }
                    return `${n}${s ? "(" + s + ")" : ""}[${r}]: ${e.replace(He, "\n  ")}`;
                  })("\n" + e.message, r, n, s)),
                  (e.ngTokenPath = r),
                  (e.ngTempTokenPath = null),
                  e)
                );
              })(i, e, "R3InjectorError", this.source);
            }
            throw i;
          } finally {
            Re(s);
          }
          var r;
        }
        _resolveInjectorDefTypes() {
          this.injectorDefTypes.forEach((e) => this.get(e));
        }
        toString() {
          const e = [];
          return this.records.forEach((t, n) => e.push(be(n))), `R3Injector[${e.join(", ")}]`;
        }
        assertNotDestroyed() {
          if (this._destroyed) throw new Error("Injector has already been destroyed.");
        }
        processInjectorType(e, t, n) {
          if (!(e = Ae(e))) return !1;
          let s = he(e);
          const r = (null == s && e.ngModule) || void 0,
            i = void 0 === r ? e : r,
            a = -1 !== n.indexOf(i);
          if ((void 0 !== r && (s = he(r)), null == s)) return !1;
          if (null != s.imports && !a) {
            let e;
            n.push(i);
            try {
              $e(s.imports, (s) => {
                this.processInjectorType(s, t, n) && (void 0 === e && (e = []), e.push(s));
              });
            } finally {
            }
            if (void 0 !== e)
              for (let t = 0; t < e.length; t++) {
                const { ngModule: n, providers: s } = e[t];
                $e(s, (e) => this.processProvider(e, n, s || ai));
              }
          }
          this.injectorDefTypes.add(i), this.records.set(i, Mi(s.factory, ri));
          const o = s.providers;
          if (null != o && !a) {
            const t = e;
            $e(o, (e) => this.processProvider(e, t, o));
          }
          return void 0 !== r && void 0 !== e.providers;
        }
        processProvider(e, t, n) {
          let s = mi((e = Ae(e))) ? e : Ae(e && e.provide);
          const r = (function (e, t, n) {
            return pi(e) ? Mi(void 0, e.useValue) : Mi(hi(e), ri);
          })(e);
          if (mi(e) || !0 !== e.multi) this.records.get(s);
          else {
            let t = this.records.get(s);
            t || ((t = Mi(void 0, ri, !0)), (t.factory = () => Je(t.multi)), this.records.set(s, t)),
              (s = e),
              t.multi.push(e);
          }
          this.records.set(s, r);
        }
        hydrate(e, t) {
          var n;
          return (
            t.value === ri && ((t.value = ii), (t.value = t.factory())),
            "object" == typeof t.value &&
              t.value &&
              null !== (n = t.value) &&
              "object" == typeof n &&
              "function" == typeof n.ngOnDestroy &&
              this.onDestroy.add(t.value),
            t.value
          );
        }
        injectableDefInScope(e) {
          return (
            !!e.providedIn &&
            ("string" == typeof e.providedIn
              ? "any" === e.providedIn || e.providedIn === this.scope
              : this.injectorDefTypes.has(e.providedIn))
          );
        }
      }
      function ui(e) {
        const t = de(e),
          n = null !== t ? t.factory : gt(e);
        if (null !== n) return n;
        const s = he(e);
        if (null !== s) return s.factory;
        if (e instanceof qe) throw new Error(`Token ${be(e)} is missing a \u0275prov definition.`);
        if (e instanceof Function)
          return (function (e) {
            const t = e.length;
            if (t > 0) {
              const n = tt(t, "?");
              throw new Error(`Can't resolve all parameters for ${be(e)}: (${n.join(", ")}).`);
            }
            const n = (function (e) {
              const t = e && (e[Me] || e[_e] || (e[me] && e[me]()));
              if (t) {
                const n = (function (e) {
                  if (e.hasOwnProperty("name")) return e.name;
                  const t = ("" + e).match(/^function\s*([^\s(]+)/);
                  return null === t ? "" : t[1];
                })(e);
                return (
                  console.warn(
                    `DEPRECATED: DI is instantiating a token "${n}" that inherits its @Injectable decorator but does not provide one itself.\nThis will become an error in a future version of Angular. Please add @Injectable() to the "${n}" class.`
                  ),
                  t
                );
              }
              return null;
            })(e);
            return null !== n ? () => n.factory(e) : () => new e();
          })(e);
        throw new Error("unreachable");
      }
      function hi(e, t, n) {
        let s = void 0;
        if (mi(e)) {
          const t = Ae(e);
          return gt(t) || ui(t);
        }
        if (pi(e)) s = () => Ae(e.useValue);
        else if ((r = e) && r.useFactory) s = () => e.useFactory(...Je(e.deps || []));
        else if (
          (function (e) {
            return !(!e || !e.useExisting);
          })(e)
        )
          s = () => Ve(Ae(e.useExisting));
        else {
          const t = Ae(e && (e.useClass || e.provide));
          if (
            !(function (e) {
              return !!e.deps;
            })(e)
          )
            return gt(t) || ui(t);
          s = () => new t(...Je(e.deps));
        }
        var r;
        return s;
      }
      function Mi(e, t, n = !1) {
        return { factory: e, value: t, multi: n ? [] : void 0 };
      }
      function pi(e) {
        return null !== e && "object" == typeof e && je in e;
      }
      function mi(e) {
        return "function" == typeof e;
      }
      const _i = function (e, t, n) {
        return (function (e, t = null, n = null, s) {
          const r = li(e, t, n, s);
          return r._resolveInjectorDefTypes(), r;
        })({ name: n }, t, e, n);
      };
      let fi = (() => {
        class e {
          static create(e, t) {
            return Array.isArray(e) ? _i(e, t, "") : _i(e.providers, e.parent, e.name || "");
          }
        }
        return (
          (e.THROW_IF_NOT_FOUND = Be),
          (e.NULL = new Ge()),
          (e.ɵprov = ce({ token: e, providedIn: "any", factory: () => Ve(xe) })),
          (e.__NG_ELEMENT_ID__ = -1),
          e
        );
      })();
      const bi = new qe("AnalyzeForEntryComponents");
      function gi(e, t, n) {
        let s = n ? e.styles : null,
          r = n ? e.classes : null,
          i = 0;
        if (null !== t)
          for (let a = 0; a < t.length; a++) {
            const e = t[a];
            "number" == typeof e ? (i = e) : 1 == i ? (r = ge(r, e)) : 2 == i && (s = ge(s, e + ": " + t[++a] + ";"));
          }
        n ? (e.styles = s) : (e.stylesWithoutHost = s), n ? (e.classes = r) : (e.classesWithoutHost = r);
      }
      function yi(e, t) {
        const n = Gt(e)[1],
          s = n.data.length - 1;
        Yn(n, { directiveStart: s, directiveEnd: s + 1 });
      }
      function Li(e) {
        let t = Object.getPrototypeOf(e.type.prototype).constructor,
          n = !0;
        const s = [e];
        for (; t; ) {
          let r = void 0;
          if (vt(e)) r = t.ɵcmp || t.ɵdir;
          else {
            if (t.ɵcmp) throw new Error("Directives cannot inherit Components");
            r = t.ɵdir;
          }
          if (r) {
            if (n) {
              s.push(r);
              const t = e;
              (t.inputs = Ai(e.inputs)), (t.declaredInputs = Ai(e.declaredInputs)), (t.outputs = Ai(e.outputs));
              const n = r.hostBindings;
              n && Ti(e, n);
              const i = r.viewQuery,
                a = r.contentQueries;
              if (
                (i && wi(e, i),
                a && zi(e, a),
                oe(e.inputs, r.inputs),
                oe(e.declaredInputs, r.declaredInputs),
                oe(e.outputs, r.outputs),
                vt(r) && r.data.animation)
              ) {
                const t = e.data;
                t.animation = (t.animation || []).concat(r.data.animation);
              }
            }
            const t = r.features;
            if (t)
              for (let s = 0; s < t.length; s++) {
                const r = t[s];
                r && r.ngInherit && r(e), r === Li && (n = !1);
              }
          }
          t = Object.getPrototypeOf(t);
        }
        !(function (e) {
          let t = 0,
            n = null;
          for (let s = e.length - 1; s >= 0; s--) {
            const r = e[s];
            (r.hostVars = t += r.hostVars), (r.hostAttrs = Pn(r.hostAttrs, (n = Pn(n, r.hostAttrs))));
          }
        })(s);
      }
      function Ai(e) {
        return e === ot ? {} : e === ct ? [] : e;
      }
      function wi(e, t) {
        const n = e.viewQuery;
        e.viewQuery = n
          ? (e, s) => {
              t(e, s), n(e, s);
            }
          : t;
      }
      function zi(e, t) {
        const n = e.contentQueries;
        e.contentQueries = n
          ? (e, s, r) => {
              t(e, s, r), n(e, s, r);
            }
          : t;
      }
      function Ti(e, t) {
        const n = e.hostBindings;
        e.hostBindings = n
          ? (e, s) => {
              t(e, s), n(e, s);
            }
          : t;
      }
      let vi = null;
      function Di() {
        if (!vi) {
          const e = Oe.Symbol;
          if (e && e.iterator) vi = e.iterator;
          else {
            const e = Object.getOwnPropertyNames(Map.prototype);
            for (let t = 0; t < e.length; ++t) {
              const n = e[t];
              "entries" !== n && "size" !== n && Map.prototype[n] === Map.prototype.entries && (vi = n);
            }
          }
        }
        return vi;
      }
      class Oi {
        constructor(e) {
          this.wrapped = e;
        }
        static wrap(e) {
          return new Oi(e);
        }
        static unwrap(e) {
          return Oi.isWrapped(e) ? e.wrapped : e;
        }
        static isWrapped(e) {
          return e instanceof Oi;
        }
      }
      function Si(e) {
        return !!ki(e) && (Array.isArray(e) || (!(e instanceof Map) && Di() in e));
      }
      function ki(e) {
        return null !== e && ("function" == typeof e || "object" == typeof e);
      }
      function Yi(e, t, n) {
        return (e[t] = n);
      }
      function Ni(e, t, n) {
        return !Object.is(e[t], n) && ((e[t] = n), !0);
      }
      function Ei(e, t, n, s) {
        const r = Ni(e, t, n);
        return Ni(e, t + 1, s) || r;
      }
      function Ci(e, t, n, s) {
        const r = sn();
        return Ni(r, mn(), t) && (rn(), pr(kn(), r, e, t, n, s)), Ci;
      }
      function Wi(e, t, n, s) {
        return Ni(e, mn(), n) ? t + Ot(n) + s : ks;
      }
      function qi(e, t, n, s, r, i, a, o) {
        const c = sn(),
          l = (function (e, t, n, s, r, i) {
            const a = Ei(e, pn(), n, r);
            return _n(2), a ? t + Ot(n) + s + Ot(r) + i : ks;
          })(c, t, n, s, r, i);
        return l !== ks && pr(kn(), c, e, l, a, o), qi;
      }
      function xi(e, t, n, s, r, i, a, o) {
        const c = sn(),
          l = rn(),
          d = e + 20,
          u = l.firstCreatePass
            ? (function (e, t, n, s, r, i, a, o, c) {
                const l = t.consts,
                  d = Vs(t, e, 0, a || null, $t(l, o));
                rr(t, n, d, $t(l, c)), Yn(t, d);
                const u = (d.tViews = er(2, d, s, r, i, t.directiveRegistry, t.pipeRegistry, null, t.schemas, l));
                return null !== t.queries && (t.queries.template(t, d), (u.queries = t.queries.embeddedTView(d))), d;
              })(e, l, c, t, n, s, r, i, a)
            : l.data[d];
        cn(u, !1);
        const h = c[11].createComment("");
        jr(l, c, h, u), bs(h, c), yr(c, (c[d] = fr(h, c, h, u))), Tt(u) && Ks(l, c, u), null != a && $s(c, u, o);
      }
      function Bi(e) {
        return Ut(tn.lFrame.contextLView, e);
      }
      function Hi(e, t = ie.Default) {
        const n = sn();
        return null === n ? Ve(e, t) : es(on(), n, Ae(e), t);
      }
      function ji(e, t, n) {
        const s = sn();
        return Ni(s, mn(), t) && sr(rn(), kn(), s, e, t, s[11], n, !1), ji;
      }
      function Pi(e, t, n, s, r) {
        const i = r ? "class" : "style";
        Or(e, n, t.inputs[i], i, s);
      }
      function Xi(e, t, n, s) {
        const r = sn(),
          i = rn(),
          a = 20 + e,
          o = r[11],
          c = (r[a] = Is(t, o, tn.lFrame.currentNamespace)),
          l = i.firstCreatePass
            ? (function (e, t, n, s, r, i, a) {
                const o = t.consts,
                  c = Vs(t, e, 2, r, $t(o, i));
                return (
                  rr(t, n, c, $t(o, a)),
                  null !== c.attrs && gi(c, c.attrs, !1),
                  null !== c.mergedAttrs && gi(c, c.mergedAttrs, !0),
                  null !== t.queries && t.queries.elementStart(t, c),
                  c
                );
              })(e, i, r, 0, t, n, s)
            : i.data[a];
        cn(l, !0);
        const d = l.mergedAttrs;
        null !== d && Bn(o, c, d);
        const u = l.classes;
        null !== u && Fr(o, c, u);
        const h = l.styles;
        null !== h && Ir(o, c, h),
          jr(i, r, c, l),
          0 === tn.lFrame.elementDepthCount && bs(c, r),
          tn.lFrame.elementDepthCount++,
          Tt(l) &&
            (Ks(i, r, l),
            (function (e, t, n) {
              if (wt(t)) {
                const s = t.directiveEnd;
                for (let r = t.directiveStart; r < s; r++) {
                  const t = e.data[r];
                  t.contentQueries && t.contentQueries(1, n[r], r);
                }
              }
            })(i, l, r)),
          null !== s && $s(r, l);
      }
      function Ri() {
        let e = on();
        ln() ? dn() : ((e = e.parent), cn(e, !1));
        const t = e;
        tn.lFrame.elementDepthCount--;
        const n = rn();
        n.firstCreatePass && (Yn(n, e), wt(e) && n.queries.elementEnd(e)),
          null != t.classesWithoutHost &&
            (function (e) {
              return 0 != (16 & e.flags);
            })(t) &&
            Pi(n, t, sn(), t.classesWithoutHost, !0),
          null != t.stylesWithoutHost &&
            (function (e) {
              return 0 != (32 & e.flags);
            })(t) &&
            Pi(n, t, sn(), t.stylesWithoutHost, !1);
      }
      function Ii(e, t, n, s) {
        Xi(e, t, n, s), Ri();
      }
      function Fi() {
        return sn();
      }
      function Vi(e) {
        return !!e && "function" == typeof e.then;
      }
      function Ui(e) {
        return !!e && "function" == typeof e.subscribe;
      }
      function Ji(e, t, n = !1, s) {
        const r = sn(),
          i = rn(),
          a = on();
        return (
          (function (e, t, n, s, r, i, a = !1, o) {
            const c = Tt(s),
              l = e.firstCreatePass && (e.cleanup || (e.cleanup = [])),
              d = vr(t);
            let u = !0;
            if (2 === s.type) {
              const h = Ft(s, t),
                M = o ? o(h) : ot,
                p = M.target || h,
                m = d.length,
                _ = o ? (e) => o(Rt(e[s.index])).target : s.index;
              if (Pt(n)) {
                let a = null;
                if (
                  (!o &&
                    c &&
                    (a = (function (e, t, n, s) {
                      const r = e.cleanup;
                      if (null != r)
                        for (let i = 0; i < r.length - 1; i += 2) {
                          const e = r[i];
                          if (e === n && r[i + 1] === s) {
                            const e = t[7],
                              n = r[i + 2];
                            return e.length > n ? e[n] : null;
                          }
                          "string" == typeof e && (i += 2);
                        }
                      return null;
                    })(e, t, r, s.index)),
                  null !== a)
                )
                  ((a.__ngLastListenerFn__ || a).__ngNextListenerFn__ = i), (a.__ngLastListenerFn__ = i), (u = !1);
                else {
                  i = Qi(s, t, i, !1);
                  const e = n.listen(M.name || p, r, i);
                  d.push(i, e), l && l.push(r, _, m, m + 1);
                }
              } else (i = Qi(s, t, i, !0)), p.addEventListener(r, i, a), d.push(i), l && l.push(r, _, m, a);
            }
            const h = s.outputs;
            let M;
            if (u && null !== h && (M = h[r])) {
              const e = M.length;
              if (e)
                for (let n = 0; n < e; n += 2) {
                  const e = t[M[n]][M[n + 1]].subscribe(i),
                    a = d.length;
                  d.push(i, e), l && l.push(r, s.index, a, -(a + 1));
                }
            }
          })(i, r, r[11], a, e, t, n, s),
          Ji
        );
      }
      function Gi(e, t, n) {
        try {
          return !1 !== t(n);
        } catch (s) {
          return Dr(e, s), !1;
        }
      }
      function Qi(e, t, n, s) {
        return function r(i) {
          if (i === Function) return n;
          const a = 2 & e.flags ? Jt(e.index, t) : t;
          0 == (32 & t[2]) && Lr(a);
          let o = Gi(t, n, i),
            c = r.__ngNextListenerFn__;
          for (; c; ) (o = Gi(t, c, i) && o), (c = c.__ngNextListenerFn__);
          return s && !1 === o && (i.preventDefault(), (i.returnValue = !1)), o;
        };
      }
      function Ki(e = 1) {
        return (function (e) {
          return (tn.lFrame.contextLView = (function (e, t) {
            for (; e > 0; ) (t = t[15]), e--;
            return t;
          })(e, tn.lFrame.contextLView))[8];
        })(e);
      }
      function $i(e, t) {
        let n = null;
        const s = (function (e) {
          const t = e.attrs;
          if (null != t) {
            const e = t.indexOf(5);
            if (0 == (1 & e)) return t[e + 1];
          }
          return null;
        })(e);
        for (let r = 0; r < t.length; r++) {
          const i = t[r];
          if ("*" !== i) {
            if (null === s ? vs(e, i, !0) : Ds(s, i)) return r;
          } else n = r;
        }
        return n;
      }
      function Zi(e, t = 0, n) {
        const s = sn(),
          r = rn(),
          i = Vs(r, e, 1, null, n || null);
        null === i.projection && (i.projection = t),
          dn(),
          (function (e, t, n) {
            Rr(t[11], 0, t, n, Cr(e, n, t), Hr(n.parent || t[6], t));
          })(r, s, i);
      }
      function ea(e, t, n) {
        return ta(e, "", t, "", n), ea;
      }
      function ta(e, t, n, s, r) {
        const i = sn(),
          a = Wi(i, t, n, s);
        return a !== ks && sr(rn(), kn(), i, e, a, i[11], r, !1), ta;
      }
      const na = [];
      function sa(e, t, n, s, r) {
        const i = e[n + 1],
          a = null === t;
        let o = s ? Bs(i) : js(i),
          c = !1;
        for (; 0 !== o && (!1 === c || a); ) {
          const n = e[o + 1];
          ra(e[o], t) && ((c = !0), (e[o + 1] = s ? Xs(n) : Hs(n))), (o = s ? Bs(n) : js(n));
        }
        c && (e[n + 1] = s ? Hs(i) : Xs(i));
      }
      function ra(e, t) {
        return (
          null === e ||
          null == t ||
          (Array.isArray(e) ? e[1] : e) === t ||
          (!(!Array.isArray(e) || "string" != typeof t) && rt(e, t) >= 0)
        );
      }
      const ia = { textEnd: 0, key: 0, keyEnd: 0, value: 0, valueEnd: 0 };
      function aa(e) {
        return e.substring(ia.key, ia.keyEnd);
      }
      function oa(e, t) {
        const n = ia.textEnd;
        return n === t
          ? -1
          : ((t = ia.keyEnd =
              (function (e, t, n) {
                for (; t < n && e.charCodeAt(t) > 32; ) t++;
                return t;
              })(e, (ia.key = t), n)),
            ca(e, t, n));
      }
      function ca(e, t, n) {
        for (; t < n && e.charCodeAt(t) <= 32; ) t++;
        return t;
      }
      function la(e, t) {
        return (
          (function (e, t, n, s) {
            const r = sn(),
              i = rn(),
              a = _n(2);
            i.firstUpdatePass && Ma(i, e, a, true),
              t !== ks &&
                Ni(r, a, t) &&
                _a(
                  i,
                  i.data[On() + 20],
                  r,
                  r[11],
                  e,
                  (r[a + 1] = (function (e, t) {
                    return null == e || ("object" == typeof e && (e = be(ps(e)))), e;
                  })(t)),
                  true,
                  a
                );
          })(e, t),
          la
        );
      }
      function da(e) {
        !(function (e, t, n, s) {
          const r = rn(),
            i = _n(2);
          r.firstUpdatePass && Ma(r, null, i, true);
          const a = sn();
          if (n !== ks && Ni(a, i, n)) {
            const s = r.data[On() + 20];
            if (ga(s, true) && !ha(r, i)) {
              let e = s.classesWithoutHost;
              null !== e && (n = ge(e, n || "")), Pi(r, s, a, n, true);
            } else
              !(function (e, t, n, s, r, i, a, o) {
                r === ks && (r = na);
                let c = 0,
                  l = 0,
                  d = 0 < r.length ? r[0] : null,
                  u = 0 < i.length ? i[0] : null;
                for (; null !== d || null !== u; ) {
                  const a = c < r.length ? r[c + 1] : void 0,
                    h = l < i.length ? i[l + 1] : void 0;
                  let M = null,
                    p = void 0;
                  d === u
                    ? ((c += 2), (l += 2), a !== h && ((M = u), (p = h)))
                    : null === u || (null !== d && d < u)
                    ? ((c += 2), (M = d))
                    : ((l += 2), (M = u), (p = h)),
                    null !== M && _a(e, t, n, s, M, p, true, o),
                    (d = c < r.length ? r[c] : null),
                    (u = l < i.length ? i[l] : null);
                }
              })(
                r,
                s,
                a,
                a[11],
                a[i + 1],
                (a[i + 1] = (function (e, t, n) {
                  if (null == n || "" === n) return na;
                  const s = [],
                    r = ps(n);
                  if (Array.isArray(r)) for (let i = 0; i < r.length; i++) e(s, r[i], !0);
                  else if ("object" == typeof r) for (const i in r) r.hasOwnProperty(i) && e(s, i, r[i]);
                  else "string" == typeof r && t(s, r);
                  return s;
                })(e, t, n)),
                0,
                i
              );
          }
        })(nt, ua, e);
      }
      function ua(e, t) {
        for (
          let n = (function (e) {
            return (
              (function (e) {
                (ia.key = 0), (ia.keyEnd = 0), (ia.value = 0), (ia.valueEnd = 0), (ia.textEnd = e.length);
              })(e),
              oa(e, ca(e, 0, ia.textEnd))
            );
          })(t);
          n >= 0;
          n = oa(t, n)
        )
          nt(e, aa(t), !0);
      }
      function ha(e, t) {
        return t >= e.expandoStartIndex;
      }
      function Ma(e, t, n, s) {
        const r = e.data;
        if (null === r[n + 1]) {
          const i = r[On() + 20],
            a = ha(e, n);
          ga(i, s) && null === t && !a && (t = !1),
            (t = (function (e, t, n, s) {
              const r = (function (e) {
                const t = tn.lFrame.currentDirectiveIndex;
                return -1 === t ? null : e[t];
              })(e);
              let i = s ? t.residualClasses : t.residualStyles;
              if (null === r)
                0 === (s ? t.classBindings : t.styleBindings) &&
                  ((n = ma((n = pa(null, e, t, n, s)), t.attrs, s)), (i = null));
              else {
                const a = t.directiveStylingLast;
                if (-1 === a || e[a] !== r)
                  if (((n = pa(r, e, t, n, s)), null === i)) {
                    let n = (function (e, t, n) {
                      const s = n ? t.classBindings : t.styleBindings;
                      if (0 !== js(s)) return e[Bs(s)];
                    })(e, t, s);
                    void 0 !== n &&
                      Array.isArray(n) &&
                      ((n = pa(null, e, t, n[1], s)),
                      (n = ma(n, t.attrs, s)),
                      (function (e, t, n, s) {
                        e[Bs(n ? t.classBindings : t.styleBindings)] = s;
                      })(e, t, s, n));
                  } else
                    i = (function (e, t, n) {
                      let s = void 0;
                      const r = t.directiveEnd;
                      for (let i = 1 + t.directiveStylingLast; i < r; i++) s = ma(s, e[i].hostAttrs, n);
                      return ma(s, t.attrs, n);
                    })(e, t, s);
              }
              return void 0 !== i && (s ? (t.residualClasses = i) : (t.residualStyles = i)), n;
            })(r, i, t, s)),
            (function (e, t, n, s, r, i) {
              let a = i ? t.classBindings : t.styleBindings,
                o = Bs(a),
                c = js(a);
              e[s] = n;
              let l,
                d = !1;
              if (Array.isArray(n)) {
                const e = n;
                (l = e[1]), (null === l || rt(e, l) > 0) && (d = !0);
              } else l = n;
              if (r)
                if (0 !== c) {
                  const t = Bs(e[o + 1]);
                  (e[s + 1] = xs(t, o)),
                    0 !== t && (e[t + 1] = Ps(e[t + 1], s)),
                    (e[o + 1] = (131071 & e[o + 1]) | (s << 17));
                } else (e[s + 1] = xs(o, 0)), 0 !== o && (e[o + 1] = Ps(e[o + 1], s)), (o = s);
              else (e[s + 1] = xs(c, 0)), 0 === o ? (o = s) : (e[c + 1] = Ps(e[c + 1], s)), (c = s);
              d && (e[s + 1] = Hs(e[s + 1])),
                sa(e, l, s, !0),
                sa(e, l, s, !1),
                (function (e, t, n, s, r) {
                  const i = r ? e.residualClasses : e.residualStyles;
                  null != i && "string" == typeof t && rt(i, t) >= 0 && (n[s + 1] = Xs(n[s + 1]));
                })(t, l, e, s, i),
                (a = xs(o, c)),
                i ? (t.classBindings = a) : (t.styleBindings = a);
            })(r, i, t, n, a, s);
        }
      }
      function pa(e, t, n, s, r) {
        let i = null;
        const a = n.directiveEnd;
        let o = n.directiveStylingLast;
        for (-1 === o ? (o = n.directiveStart) : o++; o < a && ((i = t[o]), (s = ma(s, i.hostAttrs, r)), i !== e); )
          o++;
        return null !== e && (n.directiveStylingLast = o), s;
      }
      function ma(e, t, n) {
        const s = n ? 1 : 2;
        let r = -1;
        if (null !== t)
          for (let i = 0; i < t.length; i++) {
            const a = t[i];
            "number" == typeof a
              ? (r = a)
              : r === s && (Array.isArray(e) || (e = void 0 === e ? [] : ["", e]), nt(e, a, !!n || t[++i]));
          }
        return void 0 === e ? null : e;
      }
      function _a(e, t, n, s, r, i, a, o) {
        if (2 !== t.type) return;
        const c = e.data,
          l = c[o + 1];
        ba(1 == (1 & l) ? fa(c, t, n, r, js(l), a) : void 0) ||
          (ba(i) || (2 == (2 & l) && (i = fa(c, null, n, r, o, a))),
          (function (e, t, n, s, r) {
            const i = Pt(e);
            if (t) r ? (i ? e.addClass(n, s) : n.classList.add(s)) : i ? e.removeClass(n, s) : n.classList.remove(s);
            else {
              const t = -1 == s.indexOf("-") ? void 0 : 2;
              null == r
                ? i
                  ? e.removeStyle(n, s, t)
                  : n.style.removeProperty(s)
                : i
                ? e.setStyle(n, s, r, t)
                : n.style.setProperty(s, r);
            }
          })(s, a, It(On(), n), r, i));
      }
      function fa(e, t, n, s, r, i) {
        const a = null === t;
        let o = void 0;
        for (; r > 0; ) {
          const t = e[r],
            i = Array.isArray(t),
            c = i ? t[1] : t,
            l = null === c;
          let d = n[r + 1];
          d === ks && (d = l ? na : void 0);
          let u = l ? st(d, s) : c === s ? d : void 0;
          if ((i && !ba(u) && (u = st(t, s)), ba(u) && ((o = u), a))) return o;
          const h = e[r + 1];
          r = a ? Bs(h) : js(h);
        }
        if (null !== t) {
          let e = i ? t.residualClasses : t.residualStyles;
          null != e && (o = st(e, s));
        }
        return o;
      }
      function ba(e) {
        return void 0 !== e;
      }
      function ga(e, t) {
        return 0 != (e.flags & (t ? 16 : 32));
      }
      function ya(e, t = "") {
        const n = sn(),
          s = rn(),
          r = e + 20,
          i = s.firstCreatePass ? Vs(s, e, 2, null, null) : s.data[r],
          a = (n[r] = (function (e, t) {
            return Pt(t) ? t.createText(e) : t.createTextNode(e);
          })(t, n[11]));
        jr(s, n, a, i), cn(i, !1);
      }
      function La(e) {
        return Aa("", e, ""), La;
      }
      function Aa(e, t, n) {
        const s = sn(),
          r = Wi(s, e, t, n);
        return (
          r !== ks &&
            (function (e, t, n) {
              const s = It(t, e),
                r = e[11];
              Pt(r) ? r.setValue(s, n) : (s.textContent = n);
            })(s, On(), r),
          Aa
        );
      }
      const wa = void 0;
      var za = [
        "en",
        [["a", "p"], ["AM", "PM"], wa],
        [["AM", "PM"], wa, wa],
        [
          ["S", "M", "T", "W", "T", "F", "S"],
          ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        ],
        wa,
        [
          ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
          ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
        ],
        wa,
        [
          ["B", "A"],
          ["BC", "AD"],
          ["Before Christ", "Anno Domini"],
        ],
        0,
        [6, 0],
        ["M/d/yy", "MMM d, y", "MMMM d, y", "EEEE, MMMM d, y"],
        ["h:mm a", "h:mm:ss a", "h:mm:ss a z", "h:mm:ss a zzzz"],
        ["{1}, {0}", wa, "{1} 'at' {0}", wa],
        [".", ",", ";", "%", "+", "-", "E", "\xd7", "\u2030", "\u221e", "NaN", ":"],
        ["#,##0.###", "#,##0%", "\xa4#,##0.00", "#E0"],
        "USD",
        "$",
        "US Dollar",
        {},
        "ltr",
        function (e) {
          let t = Math.floor(Math.abs(e)),
            n = e.toString().replace(/^[^.]*\.?/, "").length;
          return 1 === t && 0 === n ? 1 : 5;
        },
      ];
      let Ta = {};
      function va(e) {
        const t = (function (e) {
          return e.toLowerCase().replace(/_/g, "-");
        })(e);
        let n = Da(t);
        if (n) return n;
        const s = t.split("-")[0];
        if (((n = Da(s)), n)) return n;
        if ("en" === s) return za;
        throw new Error(`Missing locale data for the locale "${e}".`);
      }
      function Da(e) {
        return e in Ta || (Ta[e] = Oe.ng && Oe.ng.common && Oe.ng.common.locales && Oe.ng.common.locales[e]), Ta[e];
      }
      var Oa = (function (e) {
        return (
          (e[(e.LocaleId = 0)] = "LocaleId"),
          (e[(e.DayPeriodsFormat = 1)] = "DayPeriodsFormat"),
          (e[(e.DayPeriodsStandalone = 2)] = "DayPeriodsStandalone"),
          (e[(e.DaysFormat = 3)] = "DaysFormat"),
          (e[(e.DaysStandalone = 4)] = "DaysStandalone"),
          (e[(e.MonthsFormat = 5)] = "MonthsFormat"),
          (e[(e.MonthsStandalone = 6)] = "MonthsStandalone"),
          (e[(e.Eras = 7)] = "Eras"),
          (e[(e.FirstDayOfWeek = 8)] = "FirstDayOfWeek"),
          (e[(e.WeekendRange = 9)] = "WeekendRange"),
          (e[(e.DateFormat = 10)] = "DateFormat"),
          (e[(e.TimeFormat = 11)] = "TimeFormat"),
          (e[(e.DateTimeFormat = 12)] = "DateTimeFormat"),
          (e[(e.NumberSymbols = 13)] = "NumberSymbols"),
          (e[(e.NumberFormats = 14)] = "NumberFormats"),
          (e[(e.CurrencyCode = 15)] = "CurrencyCode"),
          (e[(e.CurrencySymbol = 16)] = "CurrencySymbol"),
          (e[(e.CurrencyName = 17)] = "CurrencyName"),
          (e[(e.Currencies = 18)] = "Currencies"),
          (e[(e.Directionality = 19)] = "Directionality"),
          (e[(e.PluralCase = 20)] = "PluralCase"),
          (e[(e.ExtraData = 21)] = "ExtraData"),
          e
        );
      })({});
      let Sa = "en-US";
      function ka(e) {
        var t, n;
        (n = "Expected localeId to be defined"),
          null == (t = e) &&
            (function (e, t, n, s) {
              throw new Error("ASSERTION ERROR: " + e + ` [Expected=> null != ${t} <=Actual]`);
            })(n, t),
          "string" == typeof e && (Sa = e.toLowerCase().replace(/_/g, "-"));
      }
      function Ya(e, t, n, s, r) {
        if (((e = Ae(e)), Array.isArray(e))) for (let i = 0; i < e.length; i++) Ya(e[i], t, n, s, r);
        else {
          const i = rn(),
            a = sn();
          let o = mi(e) ? e : Ae(e.provide),
            c = hi(e);
          const l = on(),
            d = 1048575 & l.providerIndexes,
            u = l.directiveStart,
            h = l.providerIndexes >> 20;
          if (mi(e) || !e.multi) {
            const s = new xn(c, r, Hi),
              M = Ca(o, t, r ? d : d + h, u);
            -1 === M
              ? (Zn(Gn(l, a), i, o),
                Na(i, e, t.length),
                t.push(o),
                l.directiveStart++,
                l.directiveEnd++,
                r && (l.providerIndexes += 1048576),
                n.push(s),
                a.push(s))
              : ((n[M] = s), (a[M] = s));
          } else {
            const M = Ca(o, t, d + h, u),
              p = Ca(o, t, d, d + h),
              m = M >= 0 && n[M],
              _ = p >= 0 && n[p];
            if ((r && !_) || (!r && !m)) {
              Zn(Gn(l, a), i, o);
              const d = (function (e, t, n, s, r) {
                const i = new xn(e, n, Hi);
                return (i.multi = []), (i.index = t), (i.componentProviders = 0), Ea(i, r, s && !n), i;
              })(r ? qa : Wa, n.length, r, s, c);
              !r && _ && (n[p].providerFactory = d),
                Na(i, e, t.length, 0),
                t.push(o),
                l.directiveStart++,
                l.directiveEnd++,
                r && (l.providerIndexes += 1048576),
                n.push(d),
                a.push(d);
            } else Na(i, e, M > -1 ? M : p, Ea(n[r ? p : M], c, !r && s));
            !r && s && _ && n[p].componentProviders++;
          }
        }
      }
      function Na(e, t, n, s) {
        const r = mi(t);
        if (r || t.useClass) {
          const i = (t.useClass || t).prototype.ngOnDestroy;
          if (i) {
            const a = e.destroyHooks || (e.destroyHooks = []);
            if (!r && t.multi) {
              const e = a.indexOf(n);
              -1 === e ? a.push(n, [s, i]) : a[e + 1].push(s, i);
            } else a.push(n, i);
          }
        }
      }
      function Ea(e, t, n) {
        return n && e.componentProviders++, e.multi.push(t) - 1;
      }
      function Ca(e, t, n, s) {
        for (let r = n; r < s; r++) if (t[r] === e) return r;
        return -1;
      }
      function Wa(e, t, n, s) {
        return xa(this.multi, []);
      }
      function qa(e, t, n, s) {
        const r = this.multi;
        let i;
        if (this.providerFactory) {
          const e = this.providerFactory.componentProviders,
            t = rs(n, n[1], this.providerFactory.index, s);
          (i = t.slice(0, e)), xa(r, i);
          for (let n = e; n < t.length; n++) i.push(t[n]);
        } else (i = []), xa(r, i);
        return i;
      }
      function xa(e, t) {
        for (let n = 0; n < e.length; n++) t.push((0, e[n])());
        return t;
      }
      function Ba(e, t = []) {
        return (n) => {
          n.providersResolver = (n, s) =>
            (function (e, t, n) {
              const s = rn();
              if (s.firstCreatePass) {
                const r = vt(e);
                Ya(n, s.data, s.blueprint, r, !0), Ya(t, s.data, s.blueprint, r, !1);
              }
            })(n, s ? s(e) : e, t);
        };
      }
      class Ha {}
      class ja {
        resolveComponentFactory(e) {
          throw (function (e) {
            const t = Error(`No component factory found for ${be(e)}. Did you add it to @NgModule.entryComponents?`);
            return (t.ngComponent = e), t;
          })(e);
        }
      }
      let Pa = (() => {
          class e {}
          return (e.NULL = new ja()), e;
        })(),
        Xa = (() => {
          class e {
            constructor(e) {
              this.nativeElement = e;
            }
          }
          return (e.__NG_ELEMENT_ID__ = () => Ra(e)), e;
        })();
      const Ra = function (e) {
        return Kr(e, on(), sn());
      };
      class Ia {}
      var Fa = (function (e) {
        return (e[(e.Important = 1)] = "Important"), (e[(e.DashCase = 2)] = "DashCase"), e;
      })({});
      let Va = (() => {
        class e {}
        return (e.__NG_ELEMENT_ID__ = () => Ua()), e;
      })();
      const Ua = function () {
        const e = sn(),
          t = Jt(on().index, e);
        return (function (e) {
          const t = e[11];
          if (Pt(t)) return t;
          throw new Error("Cannot inject Renderer2 when the application uses Renderer3!");
        })(Lt(t) ? t : e);
      };
      let Ja = (() => {
        class e {}
        return (e.ɵprov = ce({ token: e, providedIn: "root", factory: () => null })), e;
      })();
      class Ga {
        constructor(e) {
          (this.full = e),
            (this.major = e.split(".")[0]),
            (this.minor = e.split(".")[1]),
            (this.patch = e.split(".").slice(2).join("."));
        }
      }
      const Qa = new Ga("10.2.5");
      class Ka {
        constructor() {}
        supports(e) {
          return Si(e);
        }
        create(e) {
          return new Za(e);
        }
      }
      const $a = (e, t) => t;
      class Za {
        constructor(e) {
          (this.length = 0),
            (this._linkedRecords = null),
            (this._unlinkedRecords = null),
            (this._previousItHead = null),
            (this._itHead = null),
            (this._itTail = null),
            (this._additionsHead = null),
            (this._additionsTail = null),
            (this._movesHead = null),
            (this._movesTail = null),
            (this._removalsHead = null),
            (this._removalsTail = null),
            (this._identityChangesHead = null),
            (this._identityChangesTail = null),
            (this._trackByFn = e || $a);
        }
        forEachItem(e) {
          let t;
          for (t = this._itHead; null !== t; t = t._next) e(t);
        }
        forEachOperation(e) {
          let t = this._itHead,
            n = this._removalsHead,
            s = 0,
            r = null;
          for (; t || n; ) {
            const i = !n || (t && t.currentIndex < so(n, s, r)) ? t : n,
              a = so(i, s, r),
              o = i.currentIndex;
            if (i === n) s--, (n = n._nextRemoved);
            else if (((t = t._next), null == i.previousIndex)) s++;
            else {
              r || (r = []);
              const e = a - s,
                t = o - s;
              if (e != t) {
                for (let n = 0; n < e; n++) {
                  const s = n < r.length ? r[n] : (r[n] = 0),
                    i = s + n;
                  t <= i && i < e && (r[n] = s + 1);
                }
                r[i.previousIndex] = t - e;
              }
            }
            a !== o && e(i, a, o);
          }
        }
        forEachPreviousItem(e) {
          let t;
          for (t = this._previousItHead; null !== t; t = t._nextPrevious) e(t);
        }
        forEachAddedItem(e) {
          let t;
          for (t = this._additionsHead; null !== t; t = t._nextAdded) e(t);
        }
        forEachMovedItem(e) {
          let t;
          for (t = this._movesHead; null !== t; t = t._nextMoved) e(t);
        }
        forEachRemovedItem(e) {
          let t;
          for (t = this._removalsHead; null !== t; t = t._nextRemoved) e(t);
        }
        forEachIdentityChange(e) {
          let t;
          for (t = this._identityChangesHead; null !== t; t = t._nextIdentityChange) e(t);
        }
        diff(e) {
          if ((null == e && (e = []), !Si(e)))
            throw new Error(`Error trying to diff '${be(e)}'. Only arrays and iterables are allowed`);
          return this.check(e) ? this : null;
        }
        onDestroy() {}
        check(e) {
          this._reset();
          let t,
            n,
            s,
            r = this._itHead,
            i = !1;
          if (Array.isArray(e)) {
            this.length = e.length;
            for (let t = 0; t < this.length; t++)
              (n = e[t]),
                (s = this._trackByFn(t, n)),
                null !== r && Object.is(r.trackById, s)
                  ? (i && (r = this._verifyReinsertion(r, n, s, t)),
                    Object.is(r.item, n) || this._addIdentityChange(r, n))
                  : ((r = this._mismatch(r, n, s, t)), (i = !0)),
                (r = r._next);
          } else
            (t = 0),
              (function (e, t) {
                if (Array.isArray(e)) for (let n = 0; n < e.length; n++) t(e[n]);
                else {
                  const n = e[Di()]();
                  let s;
                  for (; !(s = n.next()).done; ) t(s.value);
                }
              })(e, (e) => {
                (s = this._trackByFn(t, e)),
                  null !== r && Object.is(r.trackById, s)
                    ? (i && (r = this._verifyReinsertion(r, e, s, t)),
                      Object.is(r.item, e) || this._addIdentityChange(r, e))
                    : ((r = this._mismatch(r, e, s, t)), (i = !0)),
                  (r = r._next),
                  t++;
              }),
              (this.length = t);
          return this._truncate(r), (this.collection = e), this.isDirty;
        }
        get isDirty() {
          return (
            null !== this._additionsHead ||
            null !== this._movesHead ||
            null !== this._removalsHead ||
            null !== this._identityChangesHead
          );
        }
        _reset() {
          if (this.isDirty) {
            let e;
            for (e = this._previousItHead = this._itHead; null !== e; e = e._next) e._nextPrevious = e._next;
            for (e = this._additionsHead; null !== e; e = e._nextAdded) e.previousIndex = e.currentIndex;
            for (this._additionsHead = this._additionsTail = null, e = this._movesHead; null !== e; e = e._nextMoved)
              e.previousIndex = e.currentIndex;
            (this._movesHead = this._movesTail = null),
              (this._removalsHead = this._removalsTail = null),
              (this._identityChangesHead = this._identityChangesTail = null);
          }
        }
        _mismatch(e, t, n, s) {
          let r;
          return (
            null === e ? (r = this._itTail) : ((r = e._prev), this._remove(e)),
            null !== (e = null === this._linkedRecords ? null : this._linkedRecords.get(n, s))
              ? (Object.is(e.item, t) || this._addIdentityChange(e, t), this._moveAfter(e, r, s))
              : null !== (e = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(n, null))
              ? (Object.is(e.item, t) || this._addIdentityChange(e, t), this._reinsertAfter(e, r, s))
              : (e = this._addAfter(new eo(t, n), r, s)),
            e
          );
        }
        _verifyReinsertion(e, t, n, s) {
          let r = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(n, null);
          return (
            null !== r
              ? (e = this._reinsertAfter(r, e._prev, s))
              : e.currentIndex != s && ((e.currentIndex = s), this._addToMoves(e, s)),
            e
          );
        }
        _truncate(e) {
          for (; null !== e; ) {
            const t = e._next;
            this._addToRemovals(this._unlink(e)), (e = t);
          }
          null !== this._unlinkedRecords && this._unlinkedRecords.clear(),
            null !== this._additionsTail && (this._additionsTail._nextAdded = null),
            null !== this._movesTail && (this._movesTail._nextMoved = null),
            null !== this._itTail && (this._itTail._next = null),
            null !== this._removalsTail && (this._removalsTail._nextRemoved = null),
            null !== this._identityChangesTail && (this._identityChangesTail._nextIdentityChange = null);
        }
        _reinsertAfter(e, t, n) {
          null !== this._unlinkedRecords && this._unlinkedRecords.remove(e);
          const s = e._prevRemoved,
            r = e._nextRemoved;
          return (
            null === s ? (this._removalsHead = r) : (s._nextRemoved = r),
            null === r ? (this._removalsTail = s) : (r._prevRemoved = s),
            this._insertAfter(e, t, n),
            this._addToMoves(e, n),
            e
          );
        }
        _moveAfter(e, t, n) {
          return this._unlink(e), this._insertAfter(e, t, n), this._addToMoves(e, n), e;
        }
        _addAfter(e, t, n) {
          return (
            this._insertAfter(e, t, n),
            (this._additionsTail =
              null === this._additionsTail ? (this._additionsHead = e) : (this._additionsTail._nextAdded = e)),
            e
          );
        }
        _insertAfter(e, t, n) {
          const s = null === t ? this._itHead : t._next;
          return (
            (e._next = s),
            (e._prev = t),
            null === s ? (this._itTail = e) : (s._prev = e),
            null === t ? (this._itHead = e) : (t._next = e),
            null === this._linkedRecords && (this._linkedRecords = new no()),
            this._linkedRecords.put(e),
            (e.currentIndex = n),
            e
          );
        }
        _remove(e) {
          return this._addToRemovals(this._unlink(e));
        }
        _unlink(e) {
          null !== this._linkedRecords && this._linkedRecords.remove(e);
          const t = e._prev,
            n = e._next;
          return null === t ? (this._itHead = n) : (t._next = n), null === n ? (this._itTail = t) : (n._prev = t), e;
        }
        _addToMoves(e, t) {
          return (
            e.previousIndex === t ||
              (this._movesTail = null === this._movesTail ? (this._movesHead = e) : (this._movesTail._nextMoved = e)),
            e
          );
        }
        _addToRemovals(e) {
          return (
            null === this._unlinkedRecords && (this._unlinkedRecords = new no()),
            this._unlinkedRecords.put(e),
            (e.currentIndex = null),
            (e._nextRemoved = null),
            null === this._removalsTail
              ? ((this._removalsTail = this._removalsHead = e), (e._prevRemoved = null))
              : ((e._prevRemoved = this._removalsTail), (this._removalsTail = this._removalsTail._nextRemoved = e)),
            e
          );
        }
        _addIdentityChange(e, t) {
          return (
            (e.item = t),
            (this._identityChangesTail =
              null === this._identityChangesTail
                ? (this._identityChangesHead = e)
                : (this._identityChangesTail._nextIdentityChange = e)),
            e
          );
        }
      }
      class eo {
        constructor(e, t) {
          (this.item = e),
            (this.trackById = t),
            (this.currentIndex = null),
            (this.previousIndex = null),
            (this._nextPrevious = null),
            (this._prev = null),
            (this._next = null),
            (this._prevDup = null),
            (this._nextDup = null),
            (this._prevRemoved = null),
            (this._nextRemoved = null),
            (this._nextAdded = null),
            (this._nextMoved = null),
            (this._nextIdentityChange = null);
        }
      }
      class to {
        constructor() {
          (this._head = null), (this._tail = null);
        }
        add(e) {
          null === this._head
            ? ((this._head = this._tail = e), (e._nextDup = null), (e._prevDup = null))
            : ((this._tail._nextDup = e), (e._prevDup = this._tail), (e._nextDup = null), (this._tail = e));
        }
        get(e, t) {
          let n;
          for (n = this._head; null !== n; n = n._nextDup)
            if ((null === t || t <= n.currentIndex) && Object.is(n.trackById, e)) return n;
          return null;
        }
        remove(e) {
          const t = e._prevDup,
            n = e._nextDup;
          return (
            null === t ? (this._head = n) : (t._nextDup = n),
            null === n ? (this._tail = t) : (n._prevDup = t),
            null === this._head
          );
        }
      }
      class no {
        constructor() {
          this.map = new Map();
        }
        put(e) {
          const t = e.trackById;
          let n = this.map.get(t);
          n || ((n = new to()), this.map.set(t, n)), n.add(e);
        }
        get(e, t) {
          const n = this.map.get(e);
          return n ? n.get(e, t) : null;
        }
        remove(e) {
          const t = e.trackById;
          return this.map.get(t).remove(e) && this.map.delete(t), e;
        }
        get isEmpty() {
          return 0 === this.map.size;
        }
        clear() {
          this.map.clear();
        }
      }
      function so(e, t, n) {
        const s = e.previousIndex;
        if (null === s) return s;
        let r = 0;
        return n && s < n.length && (r = n[s]), s + t + r;
      }
      class ro {
        constructor() {}
        supports(e) {
          return e instanceof Map || ki(e);
        }
        create() {
          return new io();
        }
      }
      class io {
        constructor() {
          (this._records = new Map()),
            (this._mapHead = null),
            (this._appendAfter = null),
            (this._previousMapHead = null),
            (this._changesHead = null),
            (this._changesTail = null),
            (this._additionsHead = null),
            (this._additionsTail = null),
            (this._removalsHead = null),
            (this._removalsTail = null);
        }
        get isDirty() {
          return null !== this._additionsHead || null !== this._changesHead || null !== this._removalsHead;
        }
        forEachItem(e) {
          let t;
          for (t = this._mapHead; null !== t; t = t._next) e(t);
        }
        forEachPreviousItem(e) {
          let t;
          for (t = this._previousMapHead; null !== t; t = t._nextPrevious) e(t);
        }
        forEachChangedItem(e) {
          let t;
          for (t = this._changesHead; null !== t; t = t._nextChanged) e(t);
        }
        forEachAddedItem(e) {
          let t;
          for (t = this._additionsHead; null !== t; t = t._nextAdded) e(t);
        }
        forEachRemovedItem(e) {
          let t;
          for (t = this._removalsHead; null !== t; t = t._nextRemoved) e(t);
        }
        diff(e) {
          if (e) {
            if (!(e instanceof Map || ki(e)))
              throw new Error(`Error trying to diff '${be(e)}'. Only maps and objects are allowed`);
          } else e = new Map();
          return this.check(e) ? this : null;
        }
        onDestroy() {}
        check(e) {
          this._reset();
          let t = this._mapHead;
          if (
            ((this._appendAfter = null),
            this._forEach(e, (e, n) => {
              if (t && t.key === n) this._maybeAddToChanges(t, e), (this._appendAfter = t), (t = t._next);
              else {
                const s = this._getOrCreateRecordForKey(n, e);
                t = this._insertBeforeOrAppend(t, s);
              }
            }),
            t)
          ) {
            t._prev && (t._prev._next = null), (this._removalsHead = t);
            for (let e = t; null !== e; e = e._nextRemoved)
              e === this._mapHead && (this._mapHead = null),
                this._records.delete(e.key),
                (e._nextRemoved = e._next),
                (e.previousValue = e.currentValue),
                (e.currentValue = null),
                (e._prev = null),
                (e._next = null);
          }
          return (
            this._changesTail && (this._changesTail._nextChanged = null),
            this._additionsTail && (this._additionsTail._nextAdded = null),
            this.isDirty
          );
        }
        _insertBeforeOrAppend(e, t) {
          if (e) {
            const n = e._prev;
            return (
              (t._next = e),
              (t._prev = n),
              (e._prev = t),
              n && (n._next = t),
              e === this._mapHead && (this._mapHead = t),
              (this._appendAfter = e),
              e
            );
          }
          return (
            this._appendAfter ? ((this._appendAfter._next = t), (t._prev = this._appendAfter)) : (this._mapHead = t),
            (this._appendAfter = t),
            null
          );
        }
        _getOrCreateRecordForKey(e, t) {
          if (this._records.has(e)) {
            const n = this._records.get(e);
            this._maybeAddToChanges(n, t);
            const s = n._prev,
              r = n._next;
            return s && (s._next = r), r && (r._prev = s), (n._next = null), (n._prev = null), n;
          }
          const n = new ao(e);
          return this._records.set(e, n), (n.currentValue = t), this._addToAdditions(n), n;
        }
        _reset() {
          if (this.isDirty) {
            let e;
            for (this._previousMapHead = this._mapHead, e = this._previousMapHead; null !== e; e = e._next)
              e._nextPrevious = e._next;
            for (e = this._changesHead; null !== e; e = e._nextChanged) e.previousValue = e.currentValue;
            for (e = this._additionsHead; null != e; e = e._nextAdded) e.previousValue = e.currentValue;
            (this._changesHead = this._changesTail = null),
              (this._additionsHead = this._additionsTail = null),
              (this._removalsHead = null);
          }
        }
        _maybeAddToChanges(e, t) {
          Object.is(t, e.currentValue) ||
            ((e.previousValue = e.currentValue), (e.currentValue = t), this._addToChanges(e));
        }
        _addToAdditions(e) {
          null === this._additionsHead
            ? (this._additionsHead = this._additionsTail = e)
            : ((this._additionsTail._nextAdded = e), (this._additionsTail = e));
        }
        _addToChanges(e) {
          null === this._changesHead
            ? (this._changesHead = this._changesTail = e)
            : ((this._changesTail._nextChanged = e), (this._changesTail = e));
        }
        _forEach(e, t) {
          e instanceof Map ? e.forEach(t) : Object.keys(e).forEach((n) => t(e[n], n));
        }
      }
      class ao {
        constructor(e) {
          (this.key = e),
            (this.previousValue = null),
            (this.currentValue = null),
            (this._nextPrevious = null),
            (this._next = null),
            (this._prev = null),
            (this._nextAdded = null),
            (this._nextRemoved = null),
            (this._nextChanged = null);
        }
      }
      let oo = (() => {
          class e {
            constructor(e) {
              this.factories = e;
            }
            static create(t, n) {
              if (null != n) {
                const e = n.factories.slice();
                t = t.concat(e);
              }
              return new e(t);
            }
            static extend(t) {
              return {
                provide: e,
                useFactory: (n) => {
                  if (!n) throw new Error("Cannot extend IterableDiffers without a parent injector");
                  return e.create(t, n);
                },
                deps: [[e, new re(), new ne()]],
              };
            }
            find(e) {
              const t = this.factories.find((t) => t.supports(e));
              if (null != t) return t;
              throw new Error(
                `Cannot find a differ supporting object '${e}' of type '${((n = e), n.name || typeof n)}'`
              );
              var n;
            }
          }
          return (e.ɵprov = ce({ token: e, providedIn: "root", factory: () => new e([new Ka()]) })), e;
        })(),
        co = (() => {
          class e {
            constructor(e) {
              this.factories = e;
            }
            static create(t, n) {
              if (n) {
                const e = n.factories.slice();
                t = t.concat(e);
              }
              return new e(t);
            }
            static extend(t) {
              return {
                provide: e,
                useFactory: (n) => {
                  if (!n) throw new Error("Cannot extend KeyValueDiffers without a parent injector");
                  return e.create(t, n);
                },
                deps: [[e, new re(), new ne()]],
              };
            }
            find(e) {
              const t = this.factories.find((t) => t.supports(e));
              if (t) return t;
              throw new Error(`Cannot find a differ supporting object '${e}'`);
            }
          }
          return (e.ɵprov = ce({ token: e, providedIn: "root", factory: () => new e([new ro()]) })), e;
        })();
      const lo = [new ro()],
        uo = new oo([new Ka()]),
        ho = new co(lo);
      let Mo = (() => {
        class e {}
        return (e.__NG_ELEMENT_ID__ = () => po(e, Xa)), e;
      })();
      const po = function (e, t) {
        return $r(e, t, on(), sn());
      };
      let mo = (() => {
        class e {}
        return (e.__NG_ELEMENT_ID__ = () => _o(e, Xa)), e;
      })();
      const _o = function (e, t) {
          return Zr(e, t, on(), sn());
        },
        fo = {};
      class bo extends Pa {
        constructor(e) {
          super(), (this.ngModule = e);
        }
        resolveComponentFactory(e) {
          const t = bt(e);
          return new Lo(t, this.ngModule);
        }
      }
      function go(e) {
        const t = [];
        for (let n in e) e.hasOwnProperty(n) && t.push({ propName: e[n], templateName: n });
        return t;
      }
      const yo = new qe("SCHEDULER_TOKEN", { providedIn: "root", factory: () => kt });
      class Lo extends Ha {
        constructor(e, t) {
          super(),
            (this.componentDef = e),
            (this.ngModule = t),
            (this.componentType = e.type),
            (this.selector = e.selectors.map(Ss).join(",")),
            (this.ngContentSelectors = e.ngContentSelectors ? e.ngContentSelectors : []),
            (this.isBoundToModule = !!t);
        }
        get inputs() {
          return go(this.componentDef.inputs);
        }
        get outputs() {
          return go(this.componentDef.outputs);
        }
        create(e, t, n, s) {
          const r = (s = s || this.ngModule)
              ? (function (e, t) {
                  return {
                    get: (n, s, r) => {
                      const i = e.get(n, fo, r);
                      return i !== fo || s === fo ? i : t.get(n, s, r);
                    },
                  };
                })(e, s.injector)
              : e,
            i = r.get(Ia, Xt),
            a = r.get(Ja, null),
            o = i.createRenderer(null, this.componentDef),
            c = this.componentDef.selectors[0][0] || "div",
            l = n
              ? (function (e, t, n) {
                  if (Pt(e)) return e.selectRootElement(t, n === at.ShadowDom);
                  let s = "string" == typeof t ? e.querySelector(t) : t;
                  return (s.textContent = ""), s;
                })(o, n, this.componentDef.encapsulation)
              : Is(
                  c,
                  i.createRenderer(null, this.componentDef),
                  (function (e) {
                    const t = e.toLowerCase();
                    return "svg" === t
                      ? "http://www.w3.org/2000/svg"
                      : "math" === t
                      ? "http://www.w3.org/1998/MathML/"
                      : null;
                  })(c)
                ),
            d = this.componentDef.onPush ? 576 : 528,
            u = { components: [], scheduler: kt, clean: Tr, playerHandler: null, flags: 0 },
            h = er(0, null, null, 1, 0, null, null, null, null, null),
            M = Fs(null, h, u, d, null, null, i, o, a, r);
          let p, m;
          An(M);
          try {
            const e = (function (e, t, n, s, r, i) {
              const a = n[1];
              n[20] = e;
              const o = Vs(a, 0, 2, null, null),
                c = (o.mergedAttrs = t.hostAttrs);
              null !== c &&
                (gi(o, c, !0),
                null !== e &&
                  (Bn(r, e, c), null !== o.classes && Fr(r, e, o.classes), null !== o.styles && Ir(r, e, o.styles)));
              const l = s.createRenderer(e, t),
                d = Fs(n, Zs(t), null, t.onPush ? 64 : 16, n[20], o, s, l, null, null);
              return (
                a.firstCreatePass && (Zn(Gn(o, n), a, t.type), lr(a, o), ur(o, n.length, 1)), yr(n, d), (n[20] = d)
              );
            })(l, this.componentDef, M, i, o);
            if (l)
              if (n) Bn(o, l, ["ng-version", Qa.full]);
              else {
                const { attrs: e, classes: t } = (function (e) {
                  const t = [],
                    n = [];
                  let s = 1,
                    r = 2;
                  for (; s < e.length; ) {
                    let i = e[s];
                    if ("string" == typeof i) 2 === r ? "" !== i && t.push(i, e[++s]) : 8 === r && n.push(i);
                    else {
                      if (!zs(r)) break;
                      r = i;
                    }
                    s++;
                  }
                  return { attrs: t, classes: n };
                })(this.componentDef.selectors[0]);
                e && Bn(o, l, e), t && t.length > 0 && Fr(o, l, t.join(" "));
              }
            if (((m = Vt(h, 0)), void 0 !== t)) {
              const e = (m.projection = []);
              for (let n = 0; n < this.ngContentSelectors.length; n++) {
                const s = t[n];
                e.push(null != s ? Array.from(s) : null);
              }
            }
            (p = (function (e, t, n, s, r) {
              const i = n[1],
                a = (function (e, t, n) {
                  const s = on();
                  e.firstCreatePass && (n.providersResolver && n.providersResolver(n), cr(e, s, 1), hr(e, t, n));
                  const r = rs(t, e, t.length - 1, s);
                  bs(r, t);
                  const i = Ft(s, t);
                  return i && bs(i, t), r;
                })(i, n, t);
              s.components.push(a),
                (e[8] = a),
                r && r.forEach((e) => e(a, t)),
                t.contentQueries && t.contentQueries(1, a, n.length - 1);
              const o = on();
              if (i.firstCreatePass && (null !== t.hostBindings || null !== t.hostAttrs)) {
                Sn(o.index - 20);
                const e = n[1];
                ir(e, t), ar(e, n, t.hostVars), or(t, a);
              }
              return a;
            })(e, this.componentDef, M, u, [yi])),
              Us(h, M, null);
          } finally {
            Dn();
          }
          return new Ao(this.componentType, p, Kr(Xa, m, M), M, m);
        }
      }
      class Ao extends class {} {
        constructor(e, t, n, s, r) {
          super(),
            (this.location = n),
            (this._rootLView = s),
            (this._tNode = r),
            (this.destroyCbs = []),
            (this.instance = t),
            (this.hostView = this.changeDetectorRef = new Ur(s)),
            (this.componentType = e);
        }
        get injector() {
          return new os(this._tNode, this._rootLView);
        }
        destroy() {
          this.destroyCbs &&
            (this.destroyCbs.forEach((e) => e()),
            (this.destroyCbs = null),
            !this.hostView.destroyed && this.hostView.destroy());
        }
        onDestroy(e) {
          this.destroyCbs && this.destroyCbs.push(e);
        }
      }
      const wo = new Map();
      class zo extends Qe {
        constructor(e, t) {
          super(),
            (this._parent = t),
            (this._bootstrapComponents = []),
            (this.injector = this),
            (this.destroyCbs = []),
            (this.componentFactoryResolver = new bo(this));
          const n = yt(e),
            s = e[Ee] || null;
          s && ka(s),
            (this._bootstrapComponents = Nt(n.bootstrap)),
            (this._r3Injector = li(
              e,
              t,
              [
                { provide: Qe, useValue: this },
                { provide: Pa, useValue: this.componentFactoryResolver },
              ],
              be(e)
            )),
            this._r3Injector._resolveInjectorDefTypes(),
            (this.instance = this.get(e));
        }
        get(e, t = fi.THROW_IF_NOT_FOUND, n = ie.Default) {
          return e === fi || e === Qe || e === xe ? this : this._r3Injector.get(e, t, n);
        }
        destroy() {
          const e = this._r3Injector;
          !e.destroyed && e.destroy(), this.destroyCbs.forEach((e) => e()), (this.destroyCbs = null);
        }
        onDestroy(e) {
          this.destroyCbs.push(e);
        }
      }
      class To extends Ke {
        constructor(e) {
          super(),
            (this.moduleType = e),
            null !== yt(e) &&
              (function (e) {
                const t = new Set();
                !(function e(n) {
                  const s = yt(n, !0),
                    r = s.id;
                  null !== r &&
                    ((function (e, t, n) {
                      if (t && t !== n)
                        throw new Error(`Duplicate module registered for ${e} - ${be(t)} vs ${be(t.name)}`);
                    })(r, wo.get(r), n),
                    wo.set(r, n));
                  const i = Nt(s.imports);
                  for (const a of i) t.has(a) || (t.add(a), e(a));
                })(e);
              })(e);
        }
        create(e) {
          return new zo(this.moduleType, e);
        }
      }
      function vo(e, t, n, s) {
        return ko(sn(), Mn(), e, t, n, s);
      }
      function Do(e, t, n, s, r, i) {
        return (function (e, t, n, s, r, i, a, o) {
          const c = t + n;
          return (function (e, t, n, s, r) {
            const i = Ei(e, t, n, s);
            return Ni(e, t + 2, r) || i;
          })(e, c, r, i, a)
            ? Yi(e, c + 3, o ? s.call(o, r, i, a) : s(r, i, a))
            : So(e, c + 3);
        })(sn(), Mn(), e, t, n, s, r, i);
      }
      function Oo(e, t, n, s, r, i, a, o) {
        const c = Mn() + e,
          l = sn(),
          d = (function (e, t, n, s, r, i) {
            const a = Ei(e, t, n, s);
            return Ei(e, t + 2, r, i) || a;
          })(l, c, n, s, r, i);
        return Ni(l, c + 4, a) || d
          ? Yi(l, c + 5, o ? t.call(o, n, s, r, i, a) : t(n, s, r, i, a))
          : (function (e, t) {
              return e[t];
            })(l, c + 5);
      }
      function So(e, t) {
        const n = e[t];
        return n === ks ? void 0 : n;
      }
      function ko(e, t, n, s, r, i) {
        const a = t + n;
        return Ni(e, a, r) ? Yi(e, a + 1, i ? s.call(i, r) : s(r)) : So(e, a + 1);
      }
      function Yo(e, t) {
        const n = rn();
        let s;
        const r = e + 20;
        n.firstCreatePass
          ? ((s = (function (e, t) {
              if (t)
                for (let n = t.length - 1; n >= 0; n--) {
                  const s = t[n];
                  if (e === s.name) return s;
                }
              throw new Error(`The pipe '${e}' could not be found!`);
            })(t, n.pipeRegistry)),
            (n.data[r] = s),
            s.onDestroy && (n.destroyHooks || (n.destroyHooks = [])).push(r, s.onDestroy))
          : (s = n.data[r]);
        const i = s.factory || (s.factory = gt(s.type)),
          a = Ie(Hi);
        try {
          const t = Un(!1),
            s = i();
          return (
            Un(t),
            (function (e, t, n, s) {
              const r = n + 20;
              r >= e.data.length && ((e.data[r] = null), (e.blueprint[r] = null)), (t[r] = s);
            })(n, sn(), e, s),
            s
          );
        } finally {
          Ie(a);
        }
      }
      function No(e, t) {
        return e[1].data[t + 20].pure;
      }
      function Eo(e, t) {
        return Oi.isWrapped(t) && ((t = Oi.unwrap(t)), (e[pn()] = ks)), t;
      }
      const Co = class extends w {
        constructor(e = !1) {
          super(), (this.__isAsync = e);
        }
        emit(e) {
          super.next(e);
        }
        subscribe(e, t, n) {
          let s,
            r = (e) => null,
            i = () => null;
          e && "object" == typeof e
            ? ((s = this.__isAsync
                ? (t) => {
                    setTimeout(() => e.next(t));
                  }
                : (t) => {
                    e.next(t);
                  }),
              e.error &&
                (r = this.__isAsync
                  ? (t) => {
                      setTimeout(() => e.error(t));
                    }
                  : (t) => {
                      e.error(t);
                    }),
              e.complete &&
                (i = this.__isAsync
                  ? () => {
                      setTimeout(() => e.complete());
                    }
                  : () => {
                      e.complete();
                    }))
            : ((s = this.__isAsync
                ? (t) => {
                    setTimeout(() => e(t));
                  }
                : (t) => {
                    e(t);
                  }),
              t &&
                (r = this.__isAsync
                  ? (e) => {
                      setTimeout(() => t(e));
                    }
                  : (e) => {
                      t(e);
                    }),
              n &&
                (i = this.__isAsync
                  ? () => {
                      setTimeout(() => n());
                    }
                  : () => {
                      n();
                    }));
          const a = super.subscribe(s, r, i);
          return e instanceof u && e.add(a), a;
        }
      };
      function Wo() {
        return this._results[Di()]();
      }
      class qo {
        constructor() {
          (this.dirty = !0), (this._results = []), (this.changes = new Co()), (this.length = 0);
          const e = Di(),
            t = qo.prototype;
          t[e] || (t[e] = Wo);
        }
        map(e) {
          return this._results.map(e);
        }
        filter(e) {
          return this._results.filter(e);
        }
        find(e) {
          return this._results.find(e);
        }
        reduce(e, t) {
          return this._results.reduce(e, t);
        }
        forEach(e) {
          this._results.forEach(e);
        }
        some(e) {
          return this._results.some(e);
        }
        toArray() {
          return this._results.slice();
        }
        toString() {
          return this._results.toString();
        }
        reset(e) {
          (this._results = (function e(t, n) {
            void 0 === n && (n = t);
            for (let s = 0; s < t.length; s++) {
              let r = t[s];
              Array.isArray(r) ? (n === t && (n = t.slice(0, s)), e(r, n)) : n !== t && n.push(r);
            }
            return n;
          })(e)),
            (this.dirty = !1),
            (this.length = this._results.length),
            (this.last = this._results[this.length - 1]),
            (this.first = this._results[0]);
        }
        notifyOnChanges() {
          this.changes.emit(this);
        }
        setDirty() {
          this.dirty = !0;
        }
        destroy() {
          this.changes.complete(), this.changes.unsubscribe();
        }
      }
      class xo {
        constructor(e) {
          (this.queryList = e), (this.matches = null);
        }
        clone() {
          return new xo(this.queryList);
        }
        setDirty() {
          this.queryList.setDirty();
        }
      }
      class Bo {
        constructor(e = []) {
          this.queries = e;
        }
        createEmbeddedView(e) {
          const t = e.queries;
          if (null !== t) {
            const n = null !== e.contentQueries ? e.contentQueries[0] : t.length,
              s = [];
            for (let e = 0; e < n; e++) {
              const n = t.getByIndex(e);
              s.push(this.queries[n.indexInDeclarationView].clone());
            }
            return new Bo(s);
          }
          return null;
        }
        insertView(e) {
          this.dirtyQueriesWithMatches(e);
        }
        detachView(e) {
          this.dirtyQueriesWithMatches(e);
        }
        dirtyQueriesWithMatches(e) {
          for (let t = 0; t < this.queries.length; t++) null !== Go(e, t).matches && this.queries[t].setDirty();
        }
      }
      class Ho {
        constructor(e, t, n, s = null) {
          (this.predicate = e), (this.descendants = t), (this.isStatic = n), (this.read = s);
        }
      }
      class jo {
        constructor(e = []) {
          this.queries = e;
        }
        elementStart(e, t) {
          for (let n = 0; n < this.queries.length; n++) this.queries[n].elementStart(e, t);
        }
        elementEnd(e) {
          for (let t = 0; t < this.queries.length; t++) this.queries[t].elementEnd(e);
        }
        embeddedTView(e) {
          let t = null;
          for (let n = 0; n < this.length; n++) {
            const s = null !== t ? t.length : 0,
              r = this.getByIndex(n).embeddedTView(e, s);
            r && ((r.indexInDeclarationView = n), null !== t ? t.push(r) : (t = [r]));
          }
          return null !== t ? new jo(t) : null;
        }
        template(e, t) {
          for (let n = 0; n < this.queries.length; n++) this.queries[n].template(e, t);
        }
        getByIndex(e) {
          return this.queries[e];
        }
        get length() {
          return this.queries.length;
        }
        track(e) {
          this.queries.push(e);
        }
      }
      class Po {
        constructor(e, t = -1) {
          (this.metadata = e),
            (this.matches = null),
            (this.indexInDeclarationView = -1),
            (this.crossesNgTemplate = !1),
            (this._appliesToNextNode = !0),
            (this._declarationNodeIndex = t);
        }
        elementStart(e, t) {
          this.isApplyingToNode(t) && this.matchTNode(e, t);
        }
        elementEnd(e) {
          this._declarationNodeIndex === e.index && (this._appliesToNextNode = !1);
        }
        template(e, t) {
          this.elementStart(e, t);
        }
        embeddedTView(e, t) {
          return this.isApplyingToNode(e)
            ? ((this.crossesNgTemplate = !0), this.addMatch(-e.index, t), new Po(this.metadata))
            : null;
        }
        isApplyingToNode(e) {
          if (this._appliesToNextNode && !1 === this.metadata.descendants) {
            const t = this._declarationNodeIndex;
            let n = e.parent;
            for (; null !== n && 3 === n.type && n.index !== t; ) n = n.parent;
            return t === (null !== n ? n.index : -1);
          }
          return this._appliesToNextNode;
        }
        matchTNode(e, t) {
          const n = this.metadata.predicate;
          if (Array.isArray(n))
            for (let s = 0; s < n.length; s++) {
              const r = n[s];
              this.matchTNodeWithReadOption(e, t, Xo(t, r)), this.matchTNodeWithReadOption(e, t, ss(t, e, r, !1, !1));
            }
          else
            n === Mo
              ? 0 === t.type && this.matchTNodeWithReadOption(e, t, -1)
              : this.matchTNodeWithReadOption(e, t, ss(t, e, n, !1, !1));
        }
        matchTNodeWithReadOption(e, t, n) {
          if (null !== n) {
            const s = this.metadata.read;
            if (null !== s)
              if (s === Xa || s === mo || (s === Mo && 0 === t.type)) this.addMatch(t.index, -2);
              else {
                const n = ss(t, e, s, !1, !1);
                null !== n && this.addMatch(t.index, n);
              }
            else this.addMatch(t.index, n);
          }
        }
        addMatch(e, t) {
          null === this.matches ? (this.matches = [e, t]) : this.matches.push(e, t);
        }
      }
      function Xo(e, t) {
        const n = e.localNames;
        if (null !== n) for (let s = 0; s < n.length; s += 2) if (n[s] === t) return n[s + 1];
        return null;
      }
      function Ro(e, t, n, s) {
        return -1 === n
          ? (function (e, t) {
              return 2 === e.type || 3 === e.type ? Kr(Xa, e, t) : 0 === e.type ? $r(Mo, Xa, e, t) : null;
            })(t, e)
          : -2 === n
          ? (function (e, t, n) {
              return n === Xa ? Kr(Xa, t, e) : n === Mo ? $r(Mo, Xa, t, e) : n === mo ? Zr(mo, Xa, t, e) : void 0;
            })(e, t, s)
          : rs(e, e[1], n, t);
      }
      function Io(e, t, n, s) {
        const r = t[19].queries[s];
        if (null === r.matches) {
          const s = e.data,
            i = n.matches,
            a = [];
          for (let e = 0; e < i.length; e += 2) {
            const r = i[e];
            a.push(r < 0 ? null : Ro(t, s[r], i[e + 1], n.metadata.read));
          }
          r.matches = a;
        }
        return r.matches;
      }
      function Fo(e) {
        const t = sn(),
          n = rn(),
          s = gn();
        yn(s + 1);
        const r = Go(n, s);
        if (e.dirty && Qt(t) === r.metadata.isStatic) {
          if (null === r.matches) e.reset([]);
          else {
            const i = r.crossesNgTemplate
              ? (function e(t, n, s, r) {
                  const i = t.queries.getByIndex(s),
                    a = i.matches;
                  if (null !== a) {
                    const o = Io(t, n, i, s);
                    for (let t = 0; t < a.length; t += 2) {
                      const s = a[t];
                      if (s > 0) r.push(o[t / 2]);
                      else {
                        const i = a[t + 1],
                          o = n[-s];
                        for (let t = 10; t < o.length; t++) {
                          const n = o[t];
                          n[17] === n[3] && e(n[1], n, i, r);
                        }
                        if (null !== o[9]) {
                          const t = o[9];
                          for (let n = 0; n < t.length; n++) {
                            const s = t[n];
                            e(s[1], s, i, r);
                          }
                        }
                      }
                    }
                  }
                  return r;
                })(n, t, s, [])
              : Io(n, t, r, s);
            e.reset(i), e.notifyOnChanges();
          }
          return !0;
        }
        return !1;
      }
      function Vo(e, t, n) {
        Uo(rn(), sn(), e, t, n, !0);
      }
      function Uo(e, t, n, s, r, i) {
        e.firstCreatePass &&
          ((function (e, t, n) {
            null === e.queries && (e.queries = new jo()), e.queries.track(new Po(t, -1));
          })(e, new Ho(n, s, i, r)),
          i && (e.staticViewQueries = !0)),
          (function (e, t) {
            const n = new qo();
            tr(e, t, n, n.destroy), null === t[19] && (t[19] = new Bo()), t[19].queries.push(new xo(n));
          })(e, t);
      }
      function Jo() {
        return (e = sn()), (t = gn()), e[19].queries[t].queryList;
        var e, t;
      }
      function Go(e, t) {
        return e.queries.getByIndex(t);
      }
      function Qo(e, t) {
        return $r(Mo, Xa, e, t);
      }
      const Ko = new qe("Application Initializer");
      let $o = (() => {
        class e {
          constructor(e) {
            (this.appInits = e),
              (this.initialized = !1),
              (this.done = !1),
              (this.donePromise = new Promise((e, t) => {
                (this.resolve = e), (this.reject = t);
              }));
          }
          runInitializers() {
            if (this.initialized) return;
            const e = [],
              t = () => {
                (this.done = !0), this.resolve();
              };
            if (this.appInits)
              for (let n = 0; n < this.appInits.length; n++) {
                const t = this.appInits[n]();
                Vi(t) && e.push(t);
              }
            Promise.all(e)
              .then(() => {
                t();
              })
              .catch((e) => {
                this.reject(e);
              }),
              0 === e.length && t(),
              (this.initialized = !0);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Ko, 8));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      const Zo = new qe("AppId"),
        ec = {
          provide: Zo,
          useFactory: function () {
            return `${tc()}${tc()}${tc()}`;
          },
          deps: [],
        };
      function tc() {
        return String.fromCharCode(97 + Math.floor(25 * Math.random()));
      }
      const nc = new qe("Platform Initializer"),
        sc = new qe("Platform ID"),
        rc = new qe("appBootstrapListener");
      let ic = (() => {
        class e {
          log(e) {
            console.log(e);
          }
          warn(e) {
            console.warn(e);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      const ac = new qe("LocaleId"),
        oc = new qe("DefaultCurrencyCode");
      class cc {
        constructor(e, t) {
          (this.ngModuleFactory = e), (this.componentFactories = t);
        }
      }
      const lc = function (e) {
          return new To(e);
        },
        dc = lc,
        uc = function (e) {
          return Promise.resolve(lc(e));
        },
        hc = function (e) {
          const t = lc(e),
            n = Nt(yt(e).declarations).reduce((e, t) => {
              const n = bt(t);
              return n && e.push(new Lo(n)), e;
            }, []);
          return new cc(t, n);
        },
        Mc = hc,
        pc = function (e) {
          return Promise.resolve(hc(e));
        };
      let mc = (() => {
        class e {
          constructor() {
            (this.compileModuleSync = dc),
              (this.compileModuleAsync = uc),
              (this.compileModuleAndAllComponentsSync = Mc),
              (this.compileModuleAndAllComponentsAsync = pc);
          }
          clearCache() {}
          clearCacheFor(e) {}
          getModuleId(e) {}
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      const _c = (() => Promise.resolve(0))();
      function fc(e) {
        "undefined" == typeof Zone
          ? _c.then(() => {
              e && e.apply(null, null);
            })
          : Zone.current.scheduleMicroTask("scheduleMicrotask", e);
      }
      class bc {
        constructor({ enableLongStackTrace: e = !1, shouldCoalesceEventChangeDetection: t = !1 }) {
          if (
            ((this.hasPendingMacrotasks = !1),
            (this.hasPendingMicrotasks = !1),
            (this.isStable = !0),
            (this.onUnstable = new Co(!1)),
            (this.onMicrotaskEmpty = new Co(!1)),
            (this.onStable = new Co(!1)),
            (this.onError = new Co(!1)),
            "undefined" == typeof Zone)
          )
            throw new Error("In this configuration Angular requires Zone.js");
          Zone.assertZonePatched(),
            (this._nesting = 0),
            (this._outer = this._inner = Zone.current),
            Zone.wtfZoneSpec && (this._inner = this._inner.fork(Zone.wtfZoneSpec)),
            Zone.TaskTrackingZoneSpec && (this._inner = this._inner.fork(new Zone.TaskTrackingZoneSpec())),
            e && Zone.longStackTraceZoneSpec && (this._inner = this._inner.fork(Zone.longStackTraceZoneSpec)),
            (this.shouldCoalesceEventChangeDetection = t),
            (this.lastRequestAnimationFrameId = -1),
            (this.nativeRequestAnimationFrame = (function () {
              let e = Oe.requestAnimationFrame,
                t = Oe.cancelAnimationFrame;
              if ("undefined" != typeof Zone && e && t) {
                const n = e[Zone.__symbol__("OriginalDelegate")];
                n && (e = n);
                const s = t[Zone.__symbol__("OriginalDelegate")];
                s && (t = s);
              }
              return { nativeRequestAnimationFrame: e, nativeCancelAnimationFrame: t };
            })().nativeRequestAnimationFrame),
            (function (e) {
              const t =
                !!e.shouldCoalesceEventChangeDetection &&
                e.nativeRequestAnimationFrame &&
                (() => {
                  !(function (e) {
                    -1 === e.lastRequestAnimationFrameId &&
                      ((e.lastRequestAnimationFrameId = e.nativeRequestAnimationFrame.call(Oe, () => {
                        e.fakeTopEventTask ||
                          (e.fakeTopEventTask = Zone.root.scheduleEventTask(
                            "fakeTopEventTask",
                            () => {
                              (e.lastRequestAnimationFrameId = -1), Ac(e), Lc(e);
                            },
                            void 0,
                            () => {},
                            () => {}
                          )),
                          e.fakeTopEventTask.invoke();
                      })),
                      Ac(e));
                  })(e);
                });
              e._inner = e._inner.fork({
                name: "angular",
                properties: { isAngularZone: !0, maybeDelayChangeDetection: t },
                onInvokeTask: (n, s, r, i, a, o) => {
                  try {
                    return wc(e), n.invokeTask(r, i, a, o);
                  } finally {
                    t && "eventTask" === i.type && t(), zc(e);
                  }
                },
                onInvoke: (t, n, s, r, i, a, o) => {
                  try {
                    return wc(e), t.invoke(s, r, i, a, o);
                  } finally {
                    zc(e);
                  }
                },
                onHasTask: (t, n, s, r) => {
                  t.hasTask(s, r),
                    n === s &&
                      ("microTask" == r.change
                        ? ((e._hasPendingMicrotasks = r.microTask), Ac(e), Lc(e))
                        : "macroTask" == r.change && (e.hasPendingMacrotasks = r.macroTask));
                },
                onHandleError: (t, n, s, r) => (t.handleError(s, r), e.runOutsideAngular(() => e.onError.emit(r)), !1),
              });
            })(this);
        }
        static isInAngularZone() {
          return !0 === Zone.current.get("isAngularZone");
        }
        static assertInAngularZone() {
          if (!bc.isInAngularZone()) throw new Error("Expected to be in Angular Zone, but it is not!");
        }
        static assertNotInAngularZone() {
          if (bc.isInAngularZone()) throw new Error("Expected to not be in Angular Zone, but it is!");
        }
        run(e, t, n) {
          return this._inner.run(e, t, n);
        }
        runTask(e, t, n, s) {
          const r = this._inner,
            i = r.scheduleEventTask("NgZoneEvent: " + s, e, yc, gc, gc);
          try {
            return r.runTask(i, t, n);
          } finally {
            r.cancelTask(i);
          }
        }
        runGuarded(e, t, n) {
          return this._inner.runGuarded(e, t, n);
        }
        runOutsideAngular(e) {
          return this._outer.run(e);
        }
      }
      function gc() {}
      const yc = {};
      function Lc(e) {
        if (0 == e._nesting && !e.hasPendingMicrotasks && !e.isStable)
          try {
            e._nesting++, e.onMicrotaskEmpty.emit(null);
          } finally {
            if ((e._nesting--, !e.hasPendingMicrotasks))
              try {
                e.runOutsideAngular(() => e.onStable.emit(null));
              } finally {
                e.isStable = !0;
              }
          }
      }
      function Ac(e) {
        e.hasPendingMicrotasks = !!(
          e._hasPendingMicrotasks ||
          (e.shouldCoalesceEventChangeDetection && -1 !== e.lastRequestAnimationFrameId)
        );
      }
      function wc(e) {
        e._nesting++, e.isStable && ((e.isStable = !1), e.onUnstable.emit(null));
      }
      function zc(e) {
        e._nesting--, Lc(e);
      }
      class Tc {
        constructor() {
          (this.hasPendingMicrotasks = !1),
            (this.hasPendingMacrotasks = !1),
            (this.isStable = !0),
            (this.onUnstable = new Co()),
            (this.onMicrotaskEmpty = new Co()),
            (this.onStable = new Co()),
            (this.onError = new Co());
        }
        run(e, t, n) {
          return e.apply(t, n);
        }
        runGuarded(e, t, n) {
          return e.apply(t, n);
        }
        runOutsideAngular(e) {
          return e();
        }
        runTask(e, t, n, s) {
          return e.apply(t, n);
        }
      }
      let vc = (() => {
          class e {
            constructor(e) {
              (this._ngZone = e),
                (this._pendingCount = 0),
                (this._isZoneStable = !0),
                (this._didWork = !1),
                (this._callbacks = []),
                (this.taskTrackingZone = null),
                this._watchAngularEvents(),
                e.run(() => {
                  this.taskTrackingZone = "undefined" == typeof Zone ? null : Zone.current.get("TaskTrackingZone");
                });
            }
            _watchAngularEvents() {
              this._ngZone.onUnstable.subscribe({
                next: () => {
                  (this._didWork = !0), (this._isZoneStable = !1);
                },
              }),
                this._ngZone.runOutsideAngular(() => {
                  this._ngZone.onStable.subscribe({
                    next: () => {
                      bc.assertNotInAngularZone(),
                        fc(() => {
                          (this._isZoneStable = !0), this._runCallbacksIfReady();
                        });
                    },
                  });
                });
            }
            increasePendingRequestCount() {
              return (this._pendingCount += 1), (this._didWork = !0), this._pendingCount;
            }
            decreasePendingRequestCount() {
              if (((this._pendingCount -= 1), this._pendingCount < 0))
                throw new Error("pending async requests below zero");
              return this._runCallbacksIfReady(), this._pendingCount;
            }
            isStable() {
              return this._isZoneStable && 0 === this._pendingCount && !this._ngZone.hasPendingMacrotasks;
            }
            _runCallbacksIfReady() {
              if (this.isStable())
                fc(() => {
                  for (; 0 !== this._callbacks.length; ) {
                    let e = this._callbacks.pop();
                    clearTimeout(e.timeoutId), e.doneCb(this._didWork);
                  }
                  this._didWork = !1;
                });
              else {
                let e = this.getPendingTasks();
                (this._callbacks = this._callbacks.filter(
                  (t) => !t.updateCb || !t.updateCb(e) || (clearTimeout(t.timeoutId), !1)
                )),
                  (this._didWork = !0);
              }
            }
            getPendingTasks() {
              return this.taskTrackingZone
                ? this.taskTrackingZone.macroTasks.map((e) => ({
                    source: e.source,
                    creationLocation: e.creationLocation,
                    data: e.data,
                  }))
                : [];
            }
            addCallback(e, t, n) {
              let s = -1;
              t &&
                t > 0 &&
                (s = setTimeout(() => {
                  (this._callbacks = this._callbacks.filter((e) => e.timeoutId !== s)),
                    e(this._didWork, this.getPendingTasks());
                }, t)),
                this._callbacks.push({ doneCb: e, timeoutId: s, updateCb: n });
            }
            whenStable(e, t, n) {
              if (n && !this.taskTrackingZone)
                throw new Error(
                  'Task tracking zone is required when passing an update callback to whenStable(). Is "zone.js/dist/task-tracking.js" loaded?'
                );
              this.addCallback(e, t, n), this._runCallbacksIfReady();
            }
            getPendingRequestCount() {
              return this._pendingCount;
            }
            findProviders(e, t, n) {
              return [];
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(bc));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        Dc = (() => {
          class e {
            constructor() {
              (this._applications = new Map()), kc.addToWindow(this);
            }
            registerApplication(e, t) {
              this._applications.set(e, t);
            }
            unregisterApplication(e) {
              this._applications.delete(e);
            }
            unregisterAllApplications() {
              this._applications.clear();
            }
            getTestability(e) {
              return this._applications.get(e) || null;
            }
            getAllTestabilities() {
              return Array.from(this._applications.values());
            }
            getAllRootElements() {
              return Array.from(this._applications.keys());
            }
            findTestabilityInTree(e, t = !0) {
              return kc.findTestabilityInTree(this, e, t);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })();
      class Oc {
        addToWindow(e) {}
        findTestabilityInTree(e, t, n) {
          return null;
        }
      }
      let Sc,
        kc = new Oc();
      const Yc = new qe("AllowMultipleToken");
      class Nc {
        constructor(e, t) {
          (this.name = e), (this.token = t);
        }
      }
      function Ec(e, t, n = []) {
        const s = "Platform: " + t,
          r = new qe(s);
        return (t = []) => {
          let i = Cc();
          if (!i || i.injector.get(Yc, !1))
            if (e) e(n.concat(t).concat({ provide: r, useValue: !0 }));
            else {
              const e = n.concat(t).concat({ provide: r, useValue: !0 }, { provide: si, useValue: "platform" });
              !(function (e) {
                if (Sc && !Sc.destroyed && !Sc.injector.get(Yc, !1))
                  throw new Error("There can be only one platform. Destroy the previous one to create a new one.");
                Sc = e.get(Wc);
                const t = e.get(nc, null);
                t && t.forEach((e) => e());
              })(fi.create({ providers: e, name: s }));
            }
          return (function (e) {
            const t = Cc();
            if (!t) throw new Error("No platform exists!");
            if (!t.injector.get(e, null))
              throw new Error("A platform with a different configuration has been created. Please destroy it first.");
            return t;
          })(r);
        };
      }
      function Cc() {
        return Sc && !Sc.destroyed ? Sc : null;
      }
      let Wc = (() => {
        class e {
          constructor(e) {
            (this._injector = e), (this._modules = []), (this._destroyListeners = []), (this._destroyed = !1);
          }
          bootstrapModuleFactory(e, t) {
            const n = (function (e, t) {
                let n;
                return (
                  (n =
                    "noop" === e
                      ? new Tc()
                      : ("zone.js" === e ? void 0 : e) ||
                        new bc({ enableLongStackTrace: fs(), shouldCoalesceEventChangeDetection: t })),
                  n
                );
              })(t ? t.ngZone : void 0, (t && t.ngZoneEventCoalescing) || !1),
              s = [{ provide: bc, useValue: n }];
            return n.run(() => {
              const t = fi.create({ providers: s, parent: this.injector, name: e.moduleType.name }),
                r = e.create(t),
                i = r.injector.get(Ms, null);
              if (!i) throw new Error("No ErrorHandler. Is platform module (BrowserModule) included?");
              return (
                r.onDestroy(() => Bc(this._modules, r)),
                n.runOutsideAngular(() =>
                  n.onError.subscribe({
                    next: (e) => {
                      i.handleError(e);
                    },
                  })
                ),
                (function (e, t, n) {
                  try {
                    const s = n();
                    return Vi(s)
                      ? s.catch((n) => {
                          throw (t.runOutsideAngular(() => e.handleError(n)), n);
                        })
                      : s;
                  } catch (s) {
                    throw (t.runOutsideAngular(() => e.handleError(s)), s);
                  }
                })(i, n, () => {
                  const e = r.injector.get($o);
                  return (
                    e.runInitializers(),
                    e.donePromise.then(
                      () => (ka(r.injector.get(ac, "en-US") || "en-US"), this._moduleDoBootstrap(r), r)
                    )
                  );
                })
              );
            });
          }
          bootstrapModule(e, t = []) {
            const n = qc({}, t);
            return (function (e, t, n) {
              const s = new To(n);
              return Promise.resolve(s);
            })(0, 0, e).then((e) => this.bootstrapModuleFactory(e, n));
          }
          _moduleDoBootstrap(e) {
            const t = e.injector.get(xc);
            if (e._bootstrapComponents.length > 0) e._bootstrapComponents.forEach((e) => t.bootstrap(e));
            else {
              if (!e.instance.ngDoBootstrap)
                throw new Error(
                  `The module ${be(
                    e.instance.constructor
                  )} was bootstrapped, but it does not declare "@NgModule.bootstrap" components nor a "ngDoBootstrap" method. Please define one of these.`
                );
              e.instance.ngDoBootstrap(t);
            }
            this._modules.push(e);
          }
          onDestroy(e) {
            this._destroyListeners.push(e);
          }
          get injector() {
            return this._injector;
          }
          destroy() {
            if (this._destroyed) throw new Error("The platform has already been destroyed!");
            this._modules.slice().forEach((e) => e.destroy()),
              this._destroyListeners.forEach((e) => e()),
              (this._destroyed = !0);
          }
          get destroyed() {
            return this._destroyed;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(fi));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      function qc(e, t) {
        return Array.isArray(t) ? t.reduce(qc, e) : Object.assign(Object.assign({}, e), t);
      }
      let xc = (() => {
        class e {
          constructor(e, t, n, s, r, i) {
            (this._zone = e),
              (this._console = t),
              (this._injector = n),
              (this._exceptionHandler = s),
              (this._componentFactoryResolver = r),
              (this._initStatus = i),
              (this._bootstrapListeners = []),
              (this._views = []),
              (this._runningTick = !1),
              (this._enforceNoNewChanges = !1),
              (this._stable = !0),
              (this.componentTypes = []),
              (this.components = []),
              (this._enforceNoNewChanges = fs()),
              this._zone.onMicrotaskEmpty.subscribe({
                next: () => {
                  this._zone.run(() => {
                    this.tick();
                  });
                },
              });
            const a = new b((e) => {
                (this._stable =
                  this._zone.isStable && !this._zone.hasPendingMacrotasks && !this._zone.hasPendingMicrotasks),
                  this._zone.runOutsideAngular(() => {
                    e.next(this._stable), e.complete();
                  });
              }),
              o = new b((e) => {
                let t;
                this._zone.runOutsideAngular(() => {
                  t = this._zone.onStable.subscribe(() => {
                    bc.assertNotInAngularZone(),
                      fc(() => {
                        this._stable ||
                          this._zone.hasPendingMacrotasks ||
                          this._zone.hasPendingMicrotasks ||
                          ((this._stable = !0), e.next(!0));
                      });
                  });
                });
                const n = this._zone.onUnstable.subscribe(() => {
                  bc.assertInAngularZone(),
                    this._stable &&
                      ((this._stable = !1),
                      this._zone.runOutsideAngular(() => {
                        e.next(!1);
                      }));
                });
                return () => {
                  t.unsubscribe(), n.unsubscribe();
                };
              });
            this.isStable = F(
              a,
              o.pipe((e) => {
                return V()(
                  ((t = $),
                  function (e) {
                    let n;
                    n =
                      "function" == typeof t
                        ? t
                        : function () {
                            return t;
                          };
                    const s = Object.create(e, Q);
                    return (s.source = e), (s.subjectFactory = n), s;
                  })(e)
                );
                var t;
              })
            );
          }
          bootstrap(e, t) {
            if (!this._initStatus.done)
              throw new Error(
                "Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module."
              );
            let n;
            (n = e instanceof Ha ? e : this._componentFactoryResolver.resolveComponentFactory(e)),
              this.componentTypes.push(n.componentType);
            const s = n.isBoundToModule ? void 0 : this._injector.get(Qe),
              r = n.create(fi.NULL, [], t || n.selector, s);
            r.onDestroy(() => {
              this._unloadComponent(r);
            });
            const i = r.injector.get(vc, null);
            return (
              i && r.injector.get(Dc).registerApplication(r.location.nativeElement, i),
              this._loadComponent(r),
              fs() &&
                this._console.log(
                  "Angular is running in development mode. Call enableProdMode() to enable production mode."
                ),
              r
            );
          }
          tick() {
            if (this._runningTick) throw new Error("ApplicationRef.tick is called recursively");
            try {
              this._runningTick = !0;
              for (let e of this._views) e.detectChanges();
              if (this._enforceNoNewChanges) for (let e of this._views) e.checkNoChanges();
            } catch (e) {
              this._zone.runOutsideAngular(() => this._exceptionHandler.handleError(e));
            } finally {
              this._runningTick = !1;
            }
          }
          attachView(e) {
            const t = e;
            this._views.push(t), t.attachToAppRef(this);
          }
          detachView(e) {
            const t = e;
            Bc(this._views, t), t.detachFromAppRef();
          }
          _loadComponent(e) {
            this.attachView(e.hostView),
              this.tick(),
              this.components.push(e),
              this._injector
                .get(rc, [])
                .concat(this._bootstrapListeners)
                .forEach((t) => t(e));
          }
          _unloadComponent(e) {
            this.detachView(e.hostView), Bc(this.components, e);
          }
          ngOnDestroy() {
            this._views.slice().forEach((e) => e.destroy());
          }
          get viewCount() {
            return this._views.length;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(bc), Ve(ic), Ve(fi), Ve(Ms), Ve(Pa), Ve($o));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      function Bc(e, t) {
        const n = e.indexOf(t);
        n > -1 && e.splice(n, 1);
      }
      class Hc {}
      class jc {}
      const Pc = { factoryPathPrefix: "", factoryPathSuffix: ".ngfactory" };
      let Xc = (() => {
        class e {
          constructor(e, t) {
            (this._compiler = e), (this._config = t || Pc);
          }
          load(e) {
            return this.loadAndCompile(e);
          }
          loadAndCompile(e) {
            let [t, s] = e.split("#");
            return (
              void 0 === s && (s = "default"),
              n("zn8P")(t)
                .then((e) => e[s])
                .then((e) => Rc(e, t, s))
                .then((e) => this._compiler.compileModuleAsync(e))
            );
          }
          loadFactory(e) {
            let [t, s] = e.split("#"),
              r = "NgFactory";
            return (
              void 0 === s && ((s = "default"), (r = "")),
              n("zn8P")(this._config.factoryPathPrefix + t + this._config.factoryPathSuffix)
                .then((e) => e[s + r])
                .then((e) => Rc(e, t, s))
            );
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(mc), Ve(jc, 8));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      function Rc(e, t, n) {
        if (!e) throw new Error(`Cannot find '${n}' in '${t}'`);
        return e;
      }
      const Ic = Ec(null, "core", [
          { provide: sc, useValue: "unknown" },
          { provide: Wc, deps: [fi] },
          { provide: Dc, deps: [] },
          { provide: ic, deps: [] },
        ]),
        Fc = [
          { provide: xc, useClass: xc, deps: [bc, ic, fi, Ms, Pa, $o] },
          {
            provide: yo,
            deps: [bc],
            useFactory: function (e) {
              let t = [];
              return (
                e.onStable.subscribe(() => {
                  for (; t.length; ) t.pop()();
                }),
                function (e) {
                  t.push(e);
                }
              );
            },
          },
          { provide: $o, useClass: $o, deps: [[new ne(), Ko]] },
          { provide: mc, useClass: mc, deps: [] },
          ec,
          {
            provide: oo,
            useFactory: function () {
              return uo;
            },
            deps: [],
          },
          {
            provide: co,
            useFactory: function () {
              return ho;
            },
            deps: [],
          },
          {
            provide: ac,
            useFactory: function (e) {
              return ka((e = e || ("undefined" != typeof $localize && $localize.locale) || "en-US")), e;
            },
            deps: [[new te(ac), new ne(), new re()]],
          },
          { provide: oc, useValue: "USD" },
        ];
      let Vc = (() => {
          class e {
            constructor(e) {}
          }
          return (
            (e.ɵmod = pt({ type: e })),
            (e.ɵinj = le({
              factory: function (t) {
                return new (t || e)(Ve(xc));
              },
              providers: Fc,
            })),
            e
          );
        })(),
        Uc = null;
      function Jc() {
        return Uc;
      }
      const Gc = new qe("DocumentToken");
      let Qc = (() => {
        class e {}
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵprov = ce({ factory: Kc, token: e, providedIn: "platform" })),
          e
        );
      })();
      function Kc() {
        return Ve(Zc);
      }
      const $c = new qe("Location Initialized");
      let Zc = (() => {
        class e extends Qc {
          constructor(e) {
            super(), (this._doc = e), this._init();
          }
          _init() {
            (this.location = Jc().getLocation()), (this._history = Jc().getHistory());
          }
          getBaseHrefFromDOM() {
            return Jc().getBaseHref(this._doc);
          }
          onPopState(e) {
            Jc().getGlobalEventTarget(this._doc, "window").addEventListener("popstate", e, !1);
          }
          onHashChange(e) {
            Jc().getGlobalEventTarget(this._doc, "window").addEventListener("hashchange", e, !1);
          }
          get href() {
            return this.location.href;
          }
          get protocol() {
            return this.location.protocol;
          }
          get hostname() {
            return this.location.hostname;
          }
          get port() {
            return this.location.port;
          }
          get pathname() {
            return this.location.pathname;
          }
          get search() {
            return this.location.search;
          }
          get hash() {
            return this.location.hash;
          }
          set pathname(e) {
            this.location.pathname = e;
          }
          pushState(e, t, n) {
            el() ? this._history.pushState(e, t, n) : (this.location.hash = n);
          }
          replaceState(e, t, n) {
            el() ? this._history.replaceState(e, t, n) : (this.location.hash = n);
          }
          forward() {
            this._history.forward();
          }
          back() {
            this._history.back();
          }
          getState() {
            return this._history.state;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Gc));
          }),
          (e.ɵprov = ce({ factory: tl, token: e, providedIn: "platform" })),
          e
        );
      })();
      function el() {
        return !!window.history.pushState;
      }
      function tl() {
        return new Zc(Ve(Gc));
      }
      function nl(e, t) {
        if (0 == e.length) return t;
        if (0 == t.length) return e;
        let n = 0;
        return (
          e.endsWith("/") && n++, t.startsWith("/") && n++, 2 == n ? e + t.substring(1) : 1 == n ? e + t : e + "/" + t
        );
      }
      function sl(e) {
        const t = e.match(/#|\?|$/),
          n = (t && t.index) || e.length;
        return e.slice(0, n - ("/" === e[n - 1] ? 1 : 0)) + e.slice(n);
      }
      function rl(e) {
        return e && "?" !== e[0] ? "?" + e : e;
      }
      let il = (() => {
        class e {}
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵprov = ce({ factory: al, token: e, providedIn: "root" })),
          e
        );
      })();
      function al(e) {
        const t = Ve(Gc).location;
        return new cl(Ve(Qc), (t && t.origin) || "");
      }
      const ol = new qe("appBaseHref");
      let cl = (() => {
          class e extends il {
            constructor(e, t) {
              if (
                (super(),
                (this._platformLocation = e),
                null == t && (t = this._platformLocation.getBaseHrefFromDOM()),
                null == t)
              )
                throw new Error(
                  "No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document."
                );
              this._baseHref = t;
            }
            onPopState(e) {
              this._platformLocation.onPopState(e), this._platformLocation.onHashChange(e);
            }
            getBaseHref() {
              return this._baseHref;
            }
            prepareExternalUrl(e) {
              return nl(this._baseHref, e);
            }
            path(e = !1) {
              const t = this._platformLocation.pathname + rl(this._platformLocation.search),
                n = this._platformLocation.hash;
              return n && e ? `${t}${n}` : t;
            }
            pushState(e, t, n, s) {
              const r = this.prepareExternalUrl(n + rl(s));
              this._platformLocation.pushState(e, t, r);
            }
            replaceState(e, t, n, s) {
              const r = this.prepareExternalUrl(n + rl(s));
              this._platformLocation.replaceState(e, t, r);
            }
            forward() {
              this._platformLocation.forward();
            }
            back() {
              this._platformLocation.back();
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(Qc), Ve(ol, 8));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        ll = (() => {
          class e extends il {
            constructor(e, t) {
              super(), (this._platformLocation = e), (this._baseHref = ""), null != t && (this._baseHref = t);
            }
            onPopState(e) {
              this._platformLocation.onPopState(e), this._platformLocation.onHashChange(e);
            }
            getBaseHref() {
              return this._baseHref;
            }
            path(e = !1) {
              let t = this._platformLocation.hash;
              return null == t && (t = "#"), t.length > 0 ? t.substring(1) : t;
            }
            prepareExternalUrl(e) {
              const t = nl(this._baseHref, e);
              return t.length > 0 ? "#" + t : t;
            }
            pushState(e, t, n, s) {
              let r = this.prepareExternalUrl(n + rl(s));
              0 == r.length && (r = this._platformLocation.pathname), this._platformLocation.pushState(e, t, r);
            }
            replaceState(e, t, n, s) {
              let r = this.prepareExternalUrl(n + rl(s));
              0 == r.length && (r = this._platformLocation.pathname), this._platformLocation.replaceState(e, t, r);
            }
            forward() {
              this._platformLocation.forward();
            }
            back() {
              this._platformLocation.back();
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(Qc), Ve(ol, 8));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        dl = (() => {
          class e {
            constructor(e, t) {
              (this._subject = new Co()), (this._urlChangeListeners = []), (this._platformStrategy = e);
              const n = this._platformStrategy.getBaseHref();
              (this._platformLocation = t),
                (this._baseHref = sl(hl(n))),
                this._platformStrategy.onPopState((e) => {
                  this._subject.emit({ url: this.path(!0), pop: !0, state: e.state, type: e.type });
                });
            }
            path(e = !1) {
              return this.normalize(this._platformStrategy.path(e));
            }
            getState() {
              return this._platformLocation.getState();
            }
            isCurrentPathEqualTo(e, t = "") {
              return this.path() == this.normalize(e + rl(t));
            }
            normalize(t) {
              return e.stripTrailingSlash(
                (function (e, t) {
                  return e && t.startsWith(e) ? t.substring(e.length) : t;
                })(this._baseHref, hl(t))
              );
            }
            prepareExternalUrl(e) {
              return e && "/" !== e[0] && (e = "/" + e), this._platformStrategy.prepareExternalUrl(e);
            }
            go(e, t = "", n = null) {
              this._platformStrategy.pushState(n, "", e, t),
                this._notifyUrlChangeListeners(this.prepareExternalUrl(e + rl(t)), n);
            }
            replaceState(e, t = "", n = null) {
              this._platformStrategy.replaceState(n, "", e, t),
                this._notifyUrlChangeListeners(this.prepareExternalUrl(e + rl(t)), n);
            }
            forward() {
              this._platformStrategy.forward();
            }
            back() {
              this._platformStrategy.back();
            }
            onUrlChange(e) {
              this._urlChangeListeners.push(e),
                this._urlChangeSubscription ||
                  (this._urlChangeSubscription = this.subscribe((e) => {
                    this._notifyUrlChangeListeners(e.url, e.state);
                  }));
            }
            _notifyUrlChangeListeners(e = "", t) {
              this._urlChangeListeners.forEach((n) => n(e, t));
            }
            subscribe(e, t, n) {
              return this._subject.subscribe({ next: e, error: t, complete: n });
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(il), Ve(Qc));
            }),
            (e.normalizeQueryParams = rl),
            (e.joinWithSlash = nl),
            (e.stripTrailingSlash = sl),
            (e.ɵprov = ce({ factory: ul, token: e, providedIn: "root" })),
            e
          );
        })();
      function ul() {
        return new dl(Ve(il), Ve(Qc));
      }
      function hl(e) {
        return e.replace(/\/index.html$/, "");
      }
      var Ml = (function (e) {
          return (
            (e[(e.Zero = 0)] = "Zero"),
            (e[(e.One = 1)] = "One"),
            (e[(e.Two = 2)] = "Two"),
            (e[(e.Few = 3)] = "Few"),
            (e[(e.Many = 4)] = "Many"),
            (e[(e.Other = 5)] = "Other"),
            e
          );
        })({}),
        pl = (function (e) {
          return (e[(e.Format = 0)] = "Format"), (e[(e.Standalone = 1)] = "Standalone"), e;
        })({}),
        ml = (function (e) {
          return (
            (e[(e.Narrow = 0)] = "Narrow"),
            (e[(e.Abbreviated = 1)] = "Abbreviated"),
            (e[(e.Wide = 2)] = "Wide"),
            (e[(e.Short = 3)] = "Short"),
            e
          );
        })({}),
        _l = (function (e) {
          return (
            (e[(e.Short = 0)] = "Short"),
            (e[(e.Medium = 1)] = "Medium"),
            (e[(e.Long = 2)] = "Long"),
            (e[(e.Full = 3)] = "Full"),
            e
          );
        })({}),
        fl = (function (e) {
          return (
            (e[(e.Decimal = 0)] = "Decimal"),
            (e[(e.Group = 1)] = "Group"),
            (e[(e.List = 2)] = "List"),
            (e[(e.PercentSign = 3)] = "PercentSign"),
            (e[(e.PlusSign = 4)] = "PlusSign"),
            (e[(e.MinusSign = 5)] = "MinusSign"),
            (e[(e.Exponential = 6)] = "Exponential"),
            (e[(e.SuperscriptingExponent = 7)] = "SuperscriptingExponent"),
            (e[(e.PerMille = 8)] = "PerMille"),
            (e[(e[1 / 0] = 9)] = "Infinity"),
            (e[(e.NaN = 10)] = "NaN"),
            (e[(e.TimeSeparator = 11)] = "TimeSeparator"),
            (e[(e.CurrencyDecimal = 12)] = "CurrencyDecimal"),
            (e[(e.CurrencyGroup = 13)] = "CurrencyGroup"),
            e
          );
        })({});
      function bl(e, t) {
        return wl(va(e)[Oa.DateFormat], t);
      }
      function gl(e, t) {
        return wl(va(e)[Oa.TimeFormat], t);
      }
      function yl(e, t) {
        return wl(va(e)[Oa.DateTimeFormat], t);
      }
      function Ll(e, t) {
        const n = va(e),
          s = n[Oa.NumberSymbols][t];
        if (void 0 === s) {
          if (t === fl.CurrencyDecimal) return n[Oa.NumberSymbols][fl.Decimal];
          if (t === fl.CurrencyGroup) return n[Oa.NumberSymbols][fl.Group];
        }
        return s;
      }
      function Al(e) {
        if (!e[Oa.ExtraData])
          throw new Error(
            `Missing extra locale data for the locale "${
              e[Oa.LocaleId]
            }". Use "registerLocaleData" to load new data. See the "I18n guide" on angular.io to know more.`
          );
      }
      function wl(e, t) {
        for (let n = t; n > -1; n--) if (void 0 !== e[n]) return e[n];
        throw new Error("Locale data API: locale data undefined");
      }
      function zl(e) {
        const [t, n] = e.split(":");
        return { hours: +t, minutes: +n };
      }
      const Tl = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/,
        vl = {},
        Dl =
          /((?:[^GyMLwWdEabBhHmsSzZO']+)|(?:'(?:[^']|'')*')|(?:G{1,5}|y{1,4}|M{1,5}|L{1,5}|w{1,2}|W{1}|d{1,2}|E{1,6}|a{1,5}|b{1,5}|B{1,5}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|O{1,4}))([\s\S]*)/;
      var Ol = (function (e) {
          return (
            (e[(e.Short = 0)] = "Short"),
            (e[(e.ShortGMT = 1)] = "ShortGMT"),
            (e[(e.Long = 2)] = "Long"),
            (e[(e.Extended = 3)] = "Extended"),
            e
          );
        })({}),
        Sl = (function (e) {
          return (
            (e[(e.FullYear = 0)] = "FullYear"),
            (e[(e.Month = 1)] = "Month"),
            (e[(e.Date = 2)] = "Date"),
            (e[(e.Hours = 3)] = "Hours"),
            (e[(e.Minutes = 4)] = "Minutes"),
            (e[(e.Seconds = 5)] = "Seconds"),
            (e[(e.FractionalSeconds = 6)] = "FractionalSeconds"),
            (e[(e.Day = 7)] = "Day"),
            e
          );
        })({}),
        kl = (function (e) {
          return (
            (e[(e.DayPeriods = 0)] = "DayPeriods"),
            (e[(e.Days = 1)] = "Days"),
            (e[(e.Months = 2)] = "Months"),
            (e[(e.Eras = 3)] = "Eras"),
            e
          );
        })({});
      function Yl(e, t) {
        return (
          t &&
            (e = e.replace(/\{([^}]+)}/g, function (e, n) {
              return null != t && n in t ? t[n] : e;
            })),
          e
        );
      }
      function Nl(e, t, n = "-", s, r) {
        let i = "";
        (e < 0 || (r && e <= 0)) && (r ? (e = 1 - e) : ((e = -e), (i = n)));
        let a = String(e);
        for (; a.length < t; ) a = "0" + a;
        return s && (a = a.substr(a.length - t)), i + a;
      }
      function El(e, t, n = 0, s = !1, r = !1) {
        return function (i, a) {
          let o = (function (e, t) {
            switch (e) {
              case Sl.FullYear:
                return t.getFullYear();
              case Sl.Month:
                return t.getMonth();
              case Sl.Date:
                return t.getDate();
              case Sl.Hours:
                return t.getHours();
              case Sl.Minutes:
                return t.getMinutes();
              case Sl.Seconds:
                return t.getSeconds();
              case Sl.FractionalSeconds:
                return t.getMilliseconds();
              case Sl.Day:
                return t.getDay();
              default:
                throw new Error(`Unknown DateType value "${e}".`);
            }
          })(e, i);
          if (((n > 0 || o > -n) && (o += n), e === Sl.Hours)) 0 === o && -12 === n && (o = 12);
          else if (e === Sl.FractionalSeconds) return (c = t), Nl(o, 3).substr(0, c);
          var c;
          const l = Ll(a, fl.MinusSign);
          return Nl(o, t, l, s, r);
        };
      }
      function Cl(e, t, n = pl.Format, s = !1) {
        return function (r, i) {
          return (function (e, t, n, s, r, i) {
            switch (n) {
              case kl.Months:
                return (function (e, t, n) {
                  const s = va(e),
                    r = wl([s[Oa.MonthsFormat], s[Oa.MonthsStandalone]], t);
                  return wl(r, n);
                })(t, r, s)[e.getMonth()];
              case kl.Days:
                return (function (e, t, n) {
                  const s = va(e),
                    r = wl([s[Oa.DaysFormat], s[Oa.DaysStandalone]], t);
                  return wl(r, n);
                })(t, r, s)[e.getDay()];
              case kl.DayPeriods:
                const a = e.getHours(),
                  o = e.getMinutes();
                if (i) {
                  const e = (function (e) {
                      const t = va(e);
                      return (
                        Al(t),
                        (t[Oa.ExtraData][2] || []).map((e) => ("string" == typeof e ? zl(e) : [zl(e[0]), zl(e[1])]))
                      );
                    })(t),
                    n = (function (e, t, n) {
                      const s = va(e);
                      Al(s);
                      const r = wl([s[Oa.ExtraData][0], s[Oa.ExtraData][1]], t) || [];
                      return wl(r, n) || [];
                    })(t, r, s),
                    i = e.findIndex((e) => {
                      if (Array.isArray(e)) {
                        const [t, n] = e,
                          s = a >= t.hours && o >= t.minutes,
                          r = a < n.hours || (a === n.hours && o < n.minutes);
                        if (t.hours < n.hours) {
                          if (s && r) return !0;
                        } else if (s || r) return !0;
                      } else if (e.hours === a && e.minutes === o) return !0;
                      return !1;
                    });
                  if (-1 !== i) return n[i];
                }
                return (function (e, t, n) {
                  const s = va(e),
                    r = wl([s[Oa.DayPeriodsFormat], s[Oa.DayPeriodsStandalone]], t);
                  return wl(r, n);
                })(t, r, s)[a < 12 ? 0 : 1];
              case kl.Eras:
                return (function (e, t) {
                  return wl(va(e)[Oa.Eras], t);
                })(t, s)[e.getFullYear() <= 0 ? 0 : 1];
              default:
                throw new Error("unexpected translation type " + n);
            }
          })(r, i, e, t, n, s);
        };
      }
      function Wl(e) {
        return function (t, n, s) {
          const r = -1 * s,
            i = Ll(n, fl.MinusSign),
            a = r > 0 ? Math.floor(r / 60) : Math.ceil(r / 60);
          switch (e) {
            case Ol.Short:
              return (r >= 0 ? "+" : "") + Nl(a, 2, i) + Nl(Math.abs(r % 60), 2, i);
            case Ol.ShortGMT:
              return "GMT" + (r >= 0 ? "+" : "") + Nl(a, 1, i);
            case Ol.Long:
              return "GMT" + (r >= 0 ? "+" : "") + Nl(a, 2, i) + ":" + Nl(Math.abs(r % 60), 2, i);
            case Ol.Extended:
              return 0 === s ? "Z" : (r >= 0 ? "+" : "") + Nl(a, 2, i) + ":" + Nl(Math.abs(r % 60), 2, i);
            default:
              throw new Error(`Unknown zone width "${e}"`);
          }
        };
      }
      function ql(e, t = !1) {
        return function (n, s) {
          let r;
          if (t) {
            const e = new Date(n.getFullYear(), n.getMonth(), 1).getDay() - 1,
              t = n.getDate();
            r = 1 + Math.floor((t + e) / 7);
          } else {
            const e = ((i = n), new Date(i.getFullYear(), i.getMonth(), i.getDate() + (4 - i.getDay()))),
              t = (function (e) {
                const t = new Date(e, 0, 1).getDay();
                return new Date(e, 0, 1 + (t <= 4 ? 4 : 11) - t);
              })(e.getFullYear()),
              s = e.getTime() - t.getTime();
            r = 1 + Math.round(s / 6048e5);
          }
          var i;
          return Nl(r, e, Ll(s, fl.MinusSign));
        };
      }
      const xl = {};
      function Bl(e, t) {
        e = e.replace(/:/g, "");
        const n = Date.parse("Jan 01, 1970 00:00:00 " + e) / 6e4;
        return isNaN(n) ? t : n;
      }
      function Hl(e) {
        return e instanceof Date && !isNaN(e.valueOf());
      }
      class jl {}
      let Pl = (() => {
          class e extends jl {
            constructor(e) {
              super(), (this.locale = e);
            }
            getPluralCategory(e, t) {
              switch (
                (function (e) {
                  return va(e)[Oa.PluralCase];
                })(t || this.locale)(e)
              ) {
                case Ml.Zero:
                  return "zero";
                case Ml.One:
                  return "one";
                case Ml.Two:
                  return "two";
                case Ml.Few:
                  return "few";
                case Ml.Many:
                  return "many";
                default:
                  return "other";
              }
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(ac));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        Xl = (() => {
          class e {
            constructor(e, t, n, s) {
              (this._iterableDiffers = e),
                (this._keyValueDiffers = t),
                (this._ngEl = n),
                (this._renderer = s),
                (this._iterableDiffer = null),
                (this._keyValueDiffer = null),
                (this._initialClasses = []),
                (this._rawClass = null);
            }
            set klass(e) {
              this._removeClasses(this._initialClasses),
                (this._initialClasses = "string" == typeof e ? e.split(/\s+/) : []),
                this._applyClasses(this._initialClasses),
                this._applyClasses(this._rawClass);
            }
            set ngClass(e) {
              this._removeClasses(this._rawClass),
                this._applyClasses(this._initialClasses),
                (this._iterableDiffer = null),
                (this._keyValueDiffer = null),
                (this._rawClass = "string" == typeof e ? e.split(/\s+/) : e),
                this._rawClass &&
                  (Si(this._rawClass)
                    ? (this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create())
                    : (this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create()));
            }
            ngDoCheck() {
              if (this._iterableDiffer) {
                const e = this._iterableDiffer.diff(this._rawClass);
                e && this._applyIterableChanges(e);
              } else if (this._keyValueDiffer) {
                const e = this._keyValueDiffer.diff(this._rawClass);
                e && this._applyKeyValueChanges(e);
              }
            }
            _applyKeyValueChanges(e) {
              e.forEachAddedItem((e) => this._toggleClass(e.key, e.currentValue)),
                e.forEachChangedItem((e) => this._toggleClass(e.key, e.currentValue)),
                e.forEachRemovedItem((e) => {
                  e.previousValue && this._toggleClass(e.key, !1);
                });
            }
            _applyIterableChanges(e) {
              e.forEachAddedItem((e) => {
                if ("string" != typeof e.item)
                  throw new Error("NgClass can only toggle CSS classes expressed as strings, got " + be(e.item));
                this._toggleClass(e.item, !0);
              }),
                e.forEachRemovedItem((e) => this._toggleClass(e.item, !1));
            }
            _applyClasses(e) {
              e &&
                (Array.isArray(e) || e instanceof Set
                  ? e.forEach((e) => this._toggleClass(e, !0))
                  : Object.keys(e).forEach((t) => this._toggleClass(t, !!e[t])));
            }
            _removeClasses(e) {
              e &&
                (Array.isArray(e) || e instanceof Set
                  ? e.forEach((e) => this._toggleClass(e, !1))
                  : Object.keys(e).forEach((e) => this._toggleClass(e, !1)));
            }
            _toggleClass(e, t) {
              (e = e.trim()) &&
                e.split(/\s+/g).forEach((e) => {
                  t
                    ? this._renderer.addClass(this._ngEl.nativeElement, e)
                    : this._renderer.removeClass(this._ngEl.nativeElement, e);
                });
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(oo), Hi(co), Hi(Xa), Hi(Va));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [["", "ngClass", ""]],
              inputs: { klass: ["class", "klass"], ngClass: "ngClass" },
            })),
            e
          );
        })();
      class Rl {
        constructor(e, t, n, s) {
          (this.$implicit = e), (this.ngForOf = t), (this.index = n), (this.count = s);
        }
        get first() {
          return 0 === this.index;
        }
        get last() {
          return this.index === this.count - 1;
        }
        get even() {
          return this.index % 2 == 0;
        }
        get odd() {
          return !this.even;
        }
      }
      let Il = (() => {
        class e {
          constructor(e, t, n) {
            (this._viewContainer = e),
              (this._template = t),
              (this._differs = n),
              (this._ngForOf = null),
              (this._ngForOfDirty = !0),
              (this._differ = null);
          }
          set ngForOf(e) {
            (this._ngForOf = e), (this._ngForOfDirty = !0);
          }
          set ngForTrackBy(e) {
            fs() &&
              null != e &&
              "function" != typeof e &&
              console &&
              console.warn &&
              console.warn(
                `trackBy must be a function, but received ${JSON.stringify(
                  e
                )}. See https://angular.io/api/common/NgForOf#change-propagation for more information.`
              ),
              (this._trackByFn = e);
          }
          get ngForTrackBy() {
            return this._trackByFn;
          }
          set ngForTemplate(e) {
            e && (this._template = e);
          }
          ngDoCheck() {
            if (this._ngForOfDirty) {
              this._ngForOfDirty = !1;
              const n = this._ngForOf;
              if (!this._differ && n)
                try {
                  this._differ = this._differs.find(n).create(this.ngForTrackBy);
                } catch (t) {
                  throw new Error(
                    `Cannot find a differ supporting object '${n}' of type '${
                      ((e = n), e.name || typeof e)
                    }'. NgFor only supports binding to Iterables such as Arrays.`
                  );
                }
            }
            var e;
            if (this._differ) {
              const e = this._differ.diff(this._ngForOf);
              e && this._applyChanges(e);
            }
          }
          _applyChanges(e) {
            const t = [];
            e.forEachOperation((e, n, s) => {
              if (null == e.previousIndex) {
                const n = this._viewContainer.createEmbeddedView(
                    this._template,
                    new Rl(null, this._ngForOf, -1, -1),
                    null === s ? void 0 : s
                  ),
                  r = new Fl(e, n);
                t.push(r);
              } else if (null == s) this._viewContainer.remove(null === n ? void 0 : n);
              else if (null !== n) {
                const r = this._viewContainer.get(n);
                this._viewContainer.move(r, s);
                const i = new Fl(e, r);
                t.push(i);
              }
            });
            for (let n = 0; n < t.length; n++) this._perViewChange(t[n].view, t[n].record);
            for (let n = 0, s = this._viewContainer.length; n < s; n++) {
              const e = this._viewContainer.get(n);
              (e.context.index = n), (e.context.count = s), (e.context.ngForOf = this._ngForOf);
            }
            e.forEachIdentityChange((e) => {
              this._viewContainer.get(e.currentIndex).context.$implicit = e.item;
            });
          }
          _perViewChange(e, t) {
            e.context.$implicit = t.item;
          }
          static ngTemplateContextGuard(e, t) {
            return !0;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(mo), Hi(Mo), Hi(oo));
          }),
          (e.ɵdir = _t({
            type: e,
            selectors: [["", "ngFor", "", "ngForOf", ""]],
            inputs: { ngForOf: "ngForOf", ngForTrackBy: "ngForTrackBy", ngForTemplate: "ngForTemplate" },
          })),
          e
        );
      })();
      class Fl {
        constructor(e, t) {
          (this.record = e), (this.view = t);
        }
      }
      let Vl = (() => {
        class e {
          constructor(e, t) {
            (this._viewContainer = e),
              (this._context = new Ul()),
              (this._thenTemplateRef = null),
              (this._elseTemplateRef = null),
              (this._thenViewRef = null),
              (this._elseViewRef = null),
              (this._thenTemplateRef = t);
          }
          set ngIf(e) {
            (this._context.$implicit = this._context.ngIf = e), this._updateView();
          }
          set ngIfThen(e) {
            Jl("ngIfThen", e), (this._thenTemplateRef = e), (this._thenViewRef = null), this._updateView();
          }
          set ngIfElse(e) {
            Jl("ngIfElse", e), (this._elseTemplateRef = e), (this._elseViewRef = null), this._updateView();
          }
          _updateView() {
            this._context.$implicit
              ? this._thenViewRef ||
                (this._viewContainer.clear(),
                (this._elseViewRef = null),
                this._thenTemplateRef &&
                  (this._thenViewRef = this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context)))
              : this._elseViewRef ||
                (this._viewContainer.clear(),
                (this._thenViewRef = null),
                this._elseTemplateRef &&
                  (this._elseViewRef = this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context)));
          }
          static ngTemplateContextGuard(e, t) {
            return !0;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(mo), Hi(Mo));
          }),
          (e.ɵdir = _t({
            type: e,
            selectors: [["", "ngIf", ""]],
            inputs: { ngIf: "ngIf", ngIfThen: "ngIfThen", ngIfElse: "ngIfElse" },
          })),
          e
        );
      })();
      class Ul {
        constructor() {
          (this.$implicit = null), (this.ngIf = null);
        }
      }
      function Jl(e, t) {
        if (t && !t.createEmbeddedView) throw new Error(`${e} must be a TemplateRef, but received '${be(t)}'.`);
      }
      let Gl = (() => {
        class e {
          constructor(e, t, n) {
            (this._ngEl = e), (this._differs = t), (this._renderer = n), (this._ngStyle = null), (this._differ = null);
          }
          set ngStyle(e) {
            (this._ngStyle = e), !this._differ && e && (this._differ = this._differs.find(e).create());
          }
          ngDoCheck() {
            if (this._differ) {
              const e = this._differ.diff(this._ngStyle);
              e && this._applyChanges(e);
            }
          }
          _setStyle(e, t) {
            const [n, s] = e.split(".");
            null != (t = null != t && s ? `${t}${s}` : t)
              ? this._renderer.setStyle(this._ngEl.nativeElement, n, t)
              : this._renderer.removeStyle(this._ngEl.nativeElement, n);
          }
          _applyChanges(e) {
            e.forEachRemovedItem((e) => this._setStyle(e.key, null)),
              e.forEachAddedItem((e) => this._setStyle(e.key, e.currentValue)),
              e.forEachChangedItem((e) => this._setStyle(e.key, e.currentValue));
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(Xa), Hi(co), Hi(Va));
          }),
          (e.ɵdir = _t({ type: e, selectors: [["", "ngStyle", ""]], inputs: { ngStyle: "ngStyle" } })),
          e
        );
      })();
      function Ql(e, t) {
        return Error(`InvalidPipeArgument: '${t}' for pipe '${be(e)}'`);
      }
      let Kl = (() => {
          class e {
            transform(t) {
              if (!t) return t;
              if ("string" != typeof t) throw Ql(e, t);
              return t.toLowerCase();
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵpipe = ft({ name: "lowercase", type: e, pure: !0 })),
            e
          );
        })(),
        $l = (() => {
          class e {
            constructor(e) {
              this.locale = e;
            }
            transform(t, n = "mediumDate", s, r) {
              if (null == t || "" === t || t != t) return null;
              try {
                return (function (e, t, n, s) {
                  let r = (function (e) {
                    if (Hl(e)) return e;
                    if ("number" == typeof e && !isNaN(e)) return new Date(e);
                    if ("string" == typeof e) {
                      e = e.trim();
                      const t = parseFloat(e);
                      if (!isNaN(e - t)) return new Date(t);
                      if (/^(\d{4}-\d{1,2}-\d{1,2})$/.test(e)) {
                        const [t, n, s] = e.split("-").map((e) => +e);
                        return new Date(t, n - 1, s);
                      }
                      let n;
                      if ((n = e.match(Tl)))
                        return (function (e) {
                          const t = new Date(0);
                          let n = 0,
                            s = 0;
                          const r = e[8] ? t.setUTCFullYear : t.setFullYear,
                            i = e[8] ? t.setUTCHours : t.setHours;
                          e[9] && ((n = Number(e[9] + e[10])), (s = Number(e[9] + e[11]))),
                            r.call(t, Number(e[1]), Number(e[2]) - 1, Number(e[3]));
                          const a = Number(e[4] || 0) - n,
                            o = Number(e[5] || 0) - s,
                            c = Number(e[6] || 0),
                            l = Math.round(1e3 * parseFloat("0." + (e[7] || 0)));
                          return i.call(t, a, o, c, l), t;
                        })(n);
                    }
                    const t = new Date(e);
                    if (!Hl(t)) throw new Error(`Unable to convert "${e}" into a date`);
                    return t;
                  })(e);
                  t =
                    (function e(t, n) {
                      const s = (function (e) {
                        return va(e)[Oa.LocaleId];
                      })(t);
                      if (((vl[s] = vl[s] || {}), vl[s][n])) return vl[s][n];
                      let r = "";
                      switch (n) {
                        case "shortDate":
                          r = bl(t, _l.Short);
                          break;
                        case "mediumDate":
                          r = bl(t, _l.Medium);
                          break;
                        case "longDate":
                          r = bl(t, _l.Long);
                          break;
                        case "fullDate":
                          r = bl(t, _l.Full);
                          break;
                        case "shortTime":
                          r = gl(t, _l.Short);
                          break;
                        case "mediumTime":
                          r = gl(t, _l.Medium);
                          break;
                        case "longTime":
                          r = gl(t, _l.Long);
                          break;
                        case "fullTime":
                          r = gl(t, _l.Full);
                          break;
                        case "short":
                          const n = e(t, "shortTime"),
                            s = e(t, "shortDate");
                          r = Yl(yl(t, _l.Short), [n, s]);
                          break;
                        case "medium":
                          const i = e(t, "mediumTime"),
                            a = e(t, "mediumDate");
                          r = Yl(yl(t, _l.Medium), [i, a]);
                          break;
                        case "long":
                          const o = e(t, "longTime"),
                            c = e(t, "longDate");
                          r = Yl(yl(t, _l.Long), [o, c]);
                          break;
                        case "full":
                          const l = e(t, "fullTime"),
                            d = e(t, "fullDate");
                          r = Yl(yl(t, _l.Full), [l, d]);
                      }
                      return r && (vl[s][n] = r), r;
                    })(n, t) || t;
                  let i,
                    a = [];
                  for (; t; ) {
                    if (((i = Dl.exec(t)), !i)) {
                      a.push(t);
                      break;
                    }
                    {
                      a = a.concat(i.slice(1));
                      const e = a.pop();
                      if (!e) break;
                      t = e;
                    }
                  }
                  let o = r.getTimezoneOffset();
                  s &&
                    ((o = Bl(s, o)),
                    (r = (function (e, t, n) {
                      const s = e.getTimezoneOffset();
                      return (function (e, t) {
                        return (e = new Date(e.getTime())).setMinutes(e.getMinutes() + t), e;
                      })(e, -1 * (Bl(t, s) - s));
                    })(r, s)));
                  let c = "";
                  return (
                    a.forEach((e) => {
                      const t = (function (e) {
                        if (xl[e]) return xl[e];
                        let t;
                        switch (e) {
                          case "G":
                          case "GG":
                          case "GGG":
                            t = Cl(kl.Eras, ml.Abbreviated);
                            break;
                          case "GGGG":
                            t = Cl(kl.Eras, ml.Wide);
                            break;
                          case "GGGGG":
                            t = Cl(kl.Eras, ml.Narrow);
                            break;
                          case "y":
                            t = El(Sl.FullYear, 1, 0, !1, !0);
                            break;
                          case "yy":
                            t = El(Sl.FullYear, 2, 0, !0, !0);
                            break;
                          case "yyy":
                            t = El(Sl.FullYear, 3, 0, !1, !0);
                            break;
                          case "yyyy":
                            t = El(Sl.FullYear, 4, 0, !1, !0);
                            break;
                          case "M":
                          case "L":
                            t = El(Sl.Month, 1, 1);
                            break;
                          case "MM":
                          case "LL":
                            t = El(Sl.Month, 2, 1);
                            break;
                          case "MMM":
                            t = Cl(kl.Months, ml.Abbreviated);
                            break;
                          case "MMMM":
                            t = Cl(kl.Months, ml.Wide);
                            break;
                          case "MMMMM":
                            t = Cl(kl.Months, ml.Narrow);
                            break;
                          case "LLL":
                            t = Cl(kl.Months, ml.Abbreviated, pl.Standalone);
                            break;
                          case "LLLL":
                            t = Cl(kl.Months, ml.Wide, pl.Standalone);
                            break;
                          case "LLLLL":
                            t = Cl(kl.Months, ml.Narrow, pl.Standalone);
                            break;
                          case "w":
                            t = ql(1);
                            break;
                          case "ww":
                            t = ql(2);
                            break;
                          case "W":
                            t = ql(1, !0);
                            break;
                          case "d":
                            t = El(Sl.Date, 1);
                            break;
                          case "dd":
                            t = El(Sl.Date, 2);
                            break;
                          case "E":
                          case "EE":
                          case "EEE":
                            t = Cl(kl.Days, ml.Abbreviated);
                            break;
                          case "EEEE":
                            t = Cl(kl.Days, ml.Wide);
                            break;
                          case "EEEEE":
                            t = Cl(kl.Days, ml.Narrow);
                            break;
                          case "EEEEEE":
                            t = Cl(kl.Days, ml.Short);
                            break;
                          case "a":
                          case "aa":
                          case "aaa":
                            t = Cl(kl.DayPeriods, ml.Abbreviated);
                            break;
                          case "aaaa":
                            t = Cl(kl.DayPeriods, ml.Wide);
                            break;
                          case "aaaaa":
                            t = Cl(kl.DayPeriods, ml.Narrow);
                            break;
                          case "b":
                          case "bb":
                          case "bbb":
                            t = Cl(kl.DayPeriods, ml.Abbreviated, pl.Standalone, !0);
                            break;
                          case "bbbb":
                            t = Cl(kl.DayPeriods, ml.Wide, pl.Standalone, !0);
                            break;
                          case "bbbbb":
                            t = Cl(kl.DayPeriods, ml.Narrow, pl.Standalone, !0);
                            break;
                          case "B":
                          case "BB":
                          case "BBB":
                            t = Cl(kl.DayPeriods, ml.Abbreviated, pl.Format, !0);
                            break;
                          case "BBBB":
                            t = Cl(kl.DayPeriods, ml.Wide, pl.Format, !0);
                            break;
                          case "BBBBB":
                            t = Cl(kl.DayPeriods, ml.Narrow, pl.Format, !0);
                            break;
                          case "h":
                            t = El(Sl.Hours, 1, -12);
                            break;
                          case "hh":
                            t = El(Sl.Hours, 2, -12);
                            break;
                          case "H":
                            t = El(Sl.Hours, 1);
                            break;
                          case "HH":
                            t = El(Sl.Hours, 2);
                            break;
                          case "m":
                            t = El(Sl.Minutes, 1);
                            break;
                          case "mm":
                            t = El(Sl.Minutes, 2);
                            break;
                          case "s":
                            t = El(Sl.Seconds, 1);
                            break;
                          case "ss":
                            t = El(Sl.Seconds, 2);
                            break;
                          case "S":
                            t = El(Sl.FractionalSeconds, 1);
                            break;
                          case "SS":
                            t = El(Sl.FractionalSeconds, 2);
                            break;
                          case "SSS":
                            t = El(Sl.FractionalSeconds, 3);
                            break;
                          case "Z":
                          case "ZZ":
                          case "ZZZ":
                            t = Wl(Ol.Short);
                            break;
                          case "ZZZZZ":
                            t = Wl(Ol.Extended);
                            break;
                          case "O":
                          case "OO":
                          case "OOO":
                          case "z":
                          case "zz":
                          case "zzz":
                            t = Wl(Ol.ShortGMT);
                            break;
                          case "OOOO":
                          case "ZZZZ":
                          case "zzzz":
                            t = Wl(Ol.Long);
                            break;
                          default:
                            return null;
                        }
                        return (xl[e] = t), t;
                      })(e);
                      c += t ? t(r, n, o) : "''" === e ? "'" : e.replace(/(^'|'$)/g, "").replace(/''/g, "'");
                    }),
                    c
                  );
                })(t, n, r || this.locale, s);
              } catch (i) {
                throw Ql(e, i.message);
              }
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(ac));
            }),
            (e.ɵpipe = ft({ name: "date", type: e, pure: !0 })),
            e
          );
        })(),
        Zl = (() => {
          class e {}
          return (
            (e.ɵmod = pt({ type: e })),
            (e.ɵinj = le({
              factory: function (t) {
                return new (t || e)();
              },
              providers: [{ provide: jl, useClass: Pl }],
            })),
            e
          );
        })(),
        ed = (() => {
          class e {}
          return (e.ɵprov = ce({ token: e, providedIn: "root", factory: () => new td(Ve(Gc), window, Ve(Ms)) })), e;
        })();
      class td {
        constructor(e, t, n) {
          (this.document = e), (this.window = t), (this.errorHandler = n), (this.offset = () => [0, 0]);
        }
        setOffset(e) {
          this.offset = Array.isArray(e) ? () => e : e;
        }
        getScrollPosition() {
          return this.supportsScrolling() ? [this.window.scrollX, this.window.scrollY] : [0, 0];
        }
        scrollToPosition(e) {
          this.supportsScrolling() && this.window.scrollTo(e[0], e[1]);
        }
        scrollToAnchor(e) {
          if (this.supportsScrolling()) {
            const t = this.document.getElementById(e) || this.document.getElementsByName(e)[0];
            t && this.scrollToElement(t);
          }
        }
        setHistoryScrollRestoration(e) {
          if (this.supportScrollRestoration()) {
            const t = this.window.history;
            t && t.scrollRestoration && (t.scrollRestoration = e);
          }
        }
        scrollToElement(e) {
          const t = e.getBoundingClientRect(),
            n = t.left + this.window.pageXOffset,
            s = t.top + this.window.pageYOffset,
            r = this.offset();
          this.window.scrollTo(n - r[0], s - r[1]);
        }
        supportScrollRestoration() {
          try {
            if (!this.window || !this.window.scrollTo) return !1;
            const e = nd(this.window.history) || nd(Object.getPrototypeOf(this.window.history));
            return !(!e || (!e.writable && !e.set));
          } catch (e) {
            return !1;
          }
        }
        supportsScrolling() {
          try {
            return !!this.window.scrollTo;
          } catch (e) {
            return !1;
          }
        }
      }
      function nd(e) {
        return Object.getOwnPropertyDescriptor(e, "scrollRestoration");
      }
      class sd extends class extends class {} {
        constructor() {
          super();
        }
        supportsDOMEvents() {
          return !0;
        }
      } {
        static makeCurrent() {
          var e;
          (e = new sd()), Uc || (Uc = e);
        }
        getProperty(e, t) {
          return e[t];
        }
        log(e) {
          window.console && window.console.log && window.console.log(e);
        }
        logGroup(e) {
          window.console && window.console.group && window.console.group(e);
        }
        logGroupEnd() {
          window.console && window.console.groupEnd && window.console.groupEnd();
        }
        onAndCancel(e, t, n) {
          return (
            e.addEventListener(t, n, !1),
            () => {
              e.removeEventListener(t, n, !1);
            }
          );
        }
        dispatchEvent(e, t) {
          e.dispatchEvent(t);
        }
        remove(e) {
          return e.parentNode && e.parentNode.removeChild(e), e;
        }
        getValue(e) {
          return e.value;
        }
        createElement(e, t) {
          return (t = t || this.getDefaultDocument()).createElement(e);
        }
        createHtmlDocument() {
          return document.implementation.createHTMLDocument("fakeTitle");
        }
        getDefaultDocument() {
          return document;
        }
        isElementNode(e) {
          return e.nodeType === Node.ELEMENT_NODE;
        }
        isShadowRoot(e) {
          return e instanceof DocumentFragment;
        }
        getGlobalEventTarget(e, t) {
          return "window" === t ? window : "document" === t ? e : "body" === t ? e.body : null;
        }
        getHistory() {
          return window.history;
        }
        getLocation() {
          return window.location;
        }
        getBaseHref(e) {
          const t = id || ((id = document.querySelector("base")), id) ? id.getAttribute("href") : null;
          return null == t
            ? null
            : ((n = t),
              rd || (rd = document.createElement("a")),
              rd.setAttribute("href", n),
              "/" === rd.pathname.charAt(0) ? rd.pathname : "/" + rd.pathname);
          var n;
        }
        resetBaseElement() {
          id = null;
        }
        getUserAgent() {
          return window.navigator.userAgent;
        }
        performanceNow() {
          return window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
        }
        supportsCookies() {
          return !0;
        }
        getCookie(e) {
          return (function (e, t) {
            t = encodeURIComponent(t);
            for (const n of e.split(";")) {
              const e = n.indexOf("="),
                [s, r] = -1 == e ? [n, ""] : [n.slice(0, e), n.slice(e + 1)];
              if (s.trim() === t) return decodeURIComponent(r);
            }
            return null;
          })(document.cookie, e);
        }
      }
      let rd,
        id = null;
      const ad = new qe("TRANSITION_ID"),
        od = [
          {
            provide: Ko,
            useFactory: function (e, t, n) {
              return () => {
                n.get($o).donePromise.then(() => {
                  const n = Jc();
                  Array.prototype.slice
                    .apply(t.querySelectorAll("style[ng-transition]"))
                    .filter((t) => t.getAttribute("ng-transition") === e)
                    .forEach((e) => n.remove(e));
                });
              };
            },
            deps: [ad, Gc, fi],
            multi: !0,
          },
        ];
      class cd {
        static init() {
          var e;
          (e = new cd()), (kc = e);
        }
        addToWindow(e) {
          (Oe.getAngularTestability = (t, n = !0) => {
            const s = e.findTestabilityInTree(t, n);
            if (null == s) throw new Error("Could not find testability for element.");
            return s;
          }),
            (Oe.getAllAngularTestabilities = () => e.getAllTestabilities()),
            (Oe.getAllAngularRootElements = () => e.getAllRootElements()),
            Oe.frameworkStabilizers || (Oe.frameworkStabilizers = []),
            Oe.frameworkStabilizers.push((e) => {
              const t = Oe.getAllAngularTestabilities();
              let n = t.length,
                s = !1;
              const r = function (t) {
                (s = s || t), n--, 0 == n && e(s);
              };
              t.forEach(function (e) {
                e.whenStable(r);
              });
            });
        }
        findTestabilityInTree(e, t, n) {
          if (null == t) return null;
          const s = e.getTestability(t);
          return null != s
            ? s
            : n
            ? Jc().isShadowRoot(t)
              ? this.findTestabilityInTree(e, t.host, !0)
              : this.findTestabilityInTree(e, t.parentElement, !0)
            : null;
        }
      }
      const ld = new qe("EventManagerPlugins");
      let dd = (() => {
        class e {
          constructor(e, t) {
            (this._zone = t),
              (this._eventNameToPlugin = new Map()),
              e.forEach((e) => (e.manager = this)),
              (this._plugins = e.slice().reverse());
          }
          addEventListener(e, t, n) {
            return this._findPluginFor(t).addEventListener(e, t, n);
          }
          addGlobalEventListener(e, t, n) {
            return this._findPluginFor(t).addGlobalEventListener(e, t, n);
          }
          getZone() {
            return this._zone;
          }
          _findPluginFor(e) {
            const t = this._eventNameToPlugin.get(e);
            if (t) return t;
            const n = this._plugins;
            for (let s = 0; s < n.length; s++) {
              const t = n[s];
              if (t.supports(e)) return this._eventNameToPlugin.set(e, t), t;
            }
            throw new Error("No event manager plugin found for event " + e);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(ld), Ve(bc));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      class ud {
        constructor(e) {
          this._doc = e;
        }
        addGlobalEventListener(e, t, n) {
          const s = Jc().getGlobalEventTarget(this._doc, e);
          if (!s) throw new Error(`Unsupported event target ${s} for event ${t}`);
          return this.addEventListener(s, t, n);
        }
      }
      let hd = (() => {
          class e {
            constructor() {
              this._stylesSet = new Set();
            }
            addStyles(e) {
              const t = new Set();
              e.forEach((e) => {
                this._stylesSet.has(e) || (this._stylesSet.add(e), t.add(e));
              }),
                this.onStylesAdded(t);
            }
            onStylesAdded(e) {}
            getAllStyles() {
              return Array.from(this._stylesSet);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        Md = (() => {
          class e extends hd {
            constructor(e) {
              super(),
                (this._doc = e),
                (this._hostNodes = new Set()),
                (this._styleNodes = new Set()),
                this._hostNodes.add(e.head);
            }
            _addStylesToHost(e, t) {
              e.forEach((e) => {
                const n = this._doc.createElement("style");
                (n.textContent = e), this._styleNodes.add(t.appendChild(n));
              });
            }
            addHost(e) {
              this._addStylesToHost(this._stylesSet, e), this._hostNodes.add(e);
            }
            removeHost(e) {
              this._hostNodes.delete(e);
            }
            onStylesAdded(e) {
              this._hostNodes.forEach((t) => this._addStylesToHost(e, t));
            }
            ngOnDestroy() {
              this._styleNodes.forEach((e) => Jc().remove(e));
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(Gc));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })();
      const pd = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: "http://www.w3.org/1999/xhtml",
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/",
        },
        md = /%COMP%/g;
      function _d(e, t, n) {
        for (let s = 0; s < t.length; s++) {
          let r = t[s];
          Array.isArray(r) ? _d(e, r, n) : ((r = r.replace(md, e)), n.push(r));
        }
        return n;
      }
      function fd(e) {
        return (t) => {
          if ("__ngUnwrap__" === t) return e;
          !1 === e(t) && (t.preventDefault(), (t.returnValue = !1));
        };
      }
      let bd = (() => {
        class e {
          constructor(e, t, n) {
            (this.eventManager = e),
              (this.sharedStylesHost = t),
              (this.appId = n),
              (this.rendererByCompId = new Map()),
              (this.defaultRenderer = new gd(e));
          }
          createRenderer(e, t) {
            if (!e || !t) return this.defaultRenderer;
            switch (t.encapsulation) {
              case at.Emulated: {
                let n = this.rendererByCompId.get(t.id);
                return (
                  n ||
                    ((n = new yd(this.eventManager, this.sharedStylesHost, t, this.appId)),
                    this.rendererByCompId.set(t.id, n)),
                  n.applyToHost(e),
                  n
                );
              }
              case at.Native:
              case at.ShadowDom:
                return new Ld(this.eventManager, this.sharedStylesHost, e, t);
              default:
                if (!this.rendererByCompId.has(t.id)) {
                  const e = _d(t.id, t.styles, []);
                  this.sharedStylesHost.addStyles(e), this.rendererByCompId.set(t.id, this.defaultRenderer);
                }
                return this.defaultRenderer;
            }
          }
          begin() {}
          end() {}
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(dd), Ve(Md), Ve(Zo));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      class gd {
        constructor(e) {
          (this.eventManager = e), (this.data = Object.create(null));
        }
        destroy() {}
        createElement(e, t) {
          return t ? document.createElementNS(pd[t] || t, e) : document.createElement(e);
        }
        createComment(e) {
          return document.createComment(e);
        }
        createText(e) {
          return document.createTextNode(e);
        }
        appendChild(e, t) {
          e.appendChild(t);
        }
        insertBefore(e, t, n) {
          e && e.insertBefore(t, n);
        }
        removeChild(e, t) {
          e && e.removeChild(t);
        }
        selectRootElement(e, t) {
          let n = "string" == typeof e ? document.querySelector(e) : e;
          if (!n) throw new Error(`The selector "${e}" did not match any elements`);
          return t || (n.textContent = ""), n;
        }
        parentNode(e) {
          return e.parentNode;
        }
        nextSibling(e) {
          return e.nextSibling;
        }
        setAttribute(e, t, n, s) {
          if (s) {
            t = s + ":" + t;
            const r = pd[s];
            r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n);
          } else e.setAttribute(t, n);
        }
        removeAttribute(e, t, n) {
          if (n) {
            const s = pd[n];
            s ? e.removeAttributeNS(s, t) : e.removeAttribute(`${n}:${t}`);
          } else e.removeAttribute(t);
        }
        addClass(e, t) {
          e.classList.add(t);
        }
        removeClass(e, t) {
          e.classList.remove(t);
        }
        setStyle(e, t, n, s) {
          s & Fa.DashCase ? e.style.setProperty(t, n, s & Fa.Important ? "important" : "") : (e.style[t] = n);
        }
        removeStyle(e, t, n) {
          n & Fa.DashCase ? e.style.removeProperty(t) : (e.style[t] = "");
        }
        setProperty(e, t, n) {
          e[t] = n;
        }
        setValue(e, t) {
          e.nodeValue = t;
        }
        listen(e, t, n) {
          return "string" == typeof e
            ? this.eventManager.addGlobalEventListener(e, t, fd(n))
            : this.eventManager.addEventListener(e, t, fd(n));
        }
      }
      class yd extends gd {
        constructor(e, t, n, s) {
          super(e), (this.component = n);
          const r = _d(s + "-" + n.id, n.styles, []);
          t.addStyles(r),
            (this.contentAttr = "_ngcontent-%COMP%".replace(md, s + "-" + n.id)),
            (this.hostAttr = "_nghost-%COMP%".replace(md, s + "-" + n.id));
        }
        applyToHost(e) {
          super.setAttribute(e, this.hostAttr, "");
        }
        createElement(e, t) {
          const n = super.createElement(e, t);
          return super.setAttribute(n, this.contentAttr, ""), n;
        }
      }
      class Ld extends gd {
        constructor(e, t, n, s) {
          super(e),
            (this.sharedStylesHost = t),
            (this.hostEl = n),
            (this.component = s),
            (this.shadowRoot =
              s.encapsulation === at.ShadowDom ? n.attachShadow({ mode: "open" }) : n.createShadowRoot()),
            this.sharedStylesHost.addHost(this.shadowRoot);
          const r = _d(s.id, s.styles, []);
          for (let i = 0; i < r.length; i++) {
            const e = document.createElement("style");
            (e.textContent = r[i]), this.shadowRoot.appendChild(e);
          }
        }
        nodeOrShadowRoot(e) {
          return e === this.hostEl ? this.shadowRoot : e;
        }
        destroy() {
          this.sharedStylesHost.removeHost(this.shadowRoot);
        }
        appendChild(e, t) {
          return super.appendChild(this.nodeOrShadowRoot(e), t);
        }
        insertBefore(e, t, n) {
          return super.insertBefore(this.nodeOrShadowRoot(e), t, n);
        }
        removeChild(e, t) {
          return super.removeChild(this.nodeOrShadowRoot(e), t);
        }
        parentNode(e) {
          return this.nodeOrShadowRoot(super.parentNode(this.nodeOrShadowRoot(e)));
        }
      }
      let Ad = (() => {
        class e extends ud {
          constructor(e) {
            super(e);
          }
          supports(e) {
            return !0;
          }
          addEventListener(e, t, n) {
            return e.addEventListener(t, n, !1), () => this.removeEventListener(e, t, n);
          }
          removeEventListener(e, t, n) {
            return e.removeEventListener(t, n);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Gc));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      const wd = ["alt", "control", "meta", "shift"],
        zd = {
          "\b": "Backspace",
          "\t": "Tab",
          "\x7f": "Delete",
          "\x1b": "Escape",
          Del: "Delete",
          Esc: "Escape",
          Left: "ArrowLeft",
          Right: "ArrowRight",
          Up: "ArrowUp",
          Down: "ArrowDown",
          Menu: "ContextMenu",
          Scroll: "ScrollLock",
          Win: "OS",
        },
        Td = {
          A: "1",
          B: "2",
          C: "3",
          D: "4",
          E: "5",
          F: "6",
          G: "7",
          H: "8",
          I: "9",
          J: "*",
          K: "+",
          M: "-",
          N: ".",
          O: "/",
          "`": "0",
          "\x90": "NumLock",
        },
        vd = { alt: (e) => e.altKey, control: (e) => e.ctrlKey, meta: (e) => e.metaKey, shift: (e) => e.shiftKey };
      let Dd = (() => {
        class e extends ud {
          constructor(e) {
            super(e);
          }
          supports(t) {
            return null != e.parseEventName(t);
          }
          addEventListener(t, n, s) {
            const r = e.parseEventName(n),
              i = e.eventCallback(r.fullKey, s, this.manager.getZone());
            return this.manager.getZone().runOutsideAngular(() => Jc().onAndCancel(t, r.domEventName, i));
          }
          static parseEventName(t) {
            const n = t.toLowerCase().split("."),
              s = n.shift();
            if (0 === n.length || ("keydown" !== s && "keyup" !== s)) return null;
            const r = e._normalizeKey(n.pop());
            let i = "";
            if (
              (wd.forEach((e) => {
                const t = n.indexOf(e);
                t > -1 && (n.splice(t, 1), (i += e + "."));
              }),
              (i += r),
              0 != n.length || 0 === r.length)
            )
              return null;
            const a = {};
            return (a.domEventName = s), (a.fullKey = i), a;
          }
          static getEventFullKey(e) {
            let t = "",
              n = (function (e) {
                let t = e.key;
                if (null == t) {
                  if (((t = e.keyIdentifier), null == t)) return "Unidentified";
                  t.startsWith("U+") &&
                    ((t = String.fromCharCode(parseInt(t.substring(2), 16))),
                    3 === e.location && Td.hasOwnProperty(t) && (t = Td[t]));
                }
                return zd[t] || t;
              })(e);
            return (
              (n = n.toLowerCase()),
              " " === n ? (n = "space") : "." === n && (n = "dot"),
              wd.forEach((s) => {
                s != n && (0, vd[s])(e) && (t += s + ".");
              }),
              (t += n),
              t
            );
          }
          static eventCallback(t, n, s) {
            return (r) => {
              e.getEventFullKey(r) === t && s.runGuarded(() => n(r));
            };
          }
          static _normalizeKey(e) {
            switch (e) {
              case "esc":
                return "escape";
              default:
                return e;
            }
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Gc));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      const Od = Ec(Ic, "browser", [
          { provide: sc, useValue: "browser" },
          {
            provide: nc,
            useValue: function () {
              sd.makeCurrent(), cd.init();
            },
            multi: !0,
          },
          {
            provide: Gc,
            useFactory: function () {
              return (
                (function (e) {
                  jt = e;
                })(document),
                document
              );
            },
            deps: [],
          },
        ]),
        Sd = [
          [],
          { provide: si, useValue: "root" },
          {
            provide: Ms,
            useFactory: function () {
              return new Ms();
            },
            deps: [],
          },
          { provide: ld, useClass: Ad, multi: !0, deps: [Gc, bc, sc] },
          { provide: ld, useClass: Dd, multi: !0, deps: [Gc] },
          [],
          { provide: bd, useClass: bd, deps: [dd, Md, Zo] },
          { provide: Ia, useExisting: bd },
          { provide: hd, useExisting: Md },
          { provide: Md, useClass: Md, deps: [Gc] },
          { provide: vc, useClass: vc, deps: [bc] },
          { provide: dd, useClass: dd, deps: [ld, bc] },
          [],
        ];
      let kd = (() => {
        class e {
          constructor(e) {
            if (e)
              throw new Error(
                "BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead."
              );
          }
          static withServerTransition(t) {
            return {
              ngModule: e,
              providers: [{ provide: Zo, useValue: t.appId }, { provide: ad, useExisting: Zo }, od],
            };
          }
        }
        return (
          (e.ɵmod = pt({ type: e })),
          (e.ɵinj = le({
            factory: function (t) {
              return new (t || e)(Ve(e, 12));
            },
            providers: Sd,
            imports: [Zl, Vc],
          })),
          e
        );
      })();
      function Yd(...e) {
        let t = e[e.length - 1];
        return T(t) ? (e.pop(), W(e, t)) : I(e);
      }
      "undefined" != typeof window && window;
      class Nd extends w {
        constructor(e) {
          super(), (this._value = e);
        }
        get value() {
          return this.getValue();
        }
        _subscribe(e) {
          const t = super._subscribe(e);
          return t && !t.closed && e.next(this._value), t;
        }
        getValue() {
          if (this.hasError) throw this.thrownError;
          if (this.closed) throw new y();
          return this._value;
        }
        next(e) {
          super.next((this._value = e));
        }
      }
      class Ed extends p {
        notifyNext(e, t, n, s, r) {
          this.destination.next(t);
        }
        notifyError(e, t) {
          this.destination.error(e);
        }
        notifyComplete(e) {
          this.destination.complete();
        }
      }
      class Cd extends p {
        constructor(e, t, n) {
          super(), (this.parent = e), (this.outerValue = t), (this.outerIndex = n), (this.index = 0);
        }
        _next(e) {
          this.parent.notifyNext(this.outerValue, e, this.outerIndex, this.index++, this);
        }
        _error(e) {
          this.parent.notifyError(e, this), this.unsubscribe();
        }
        _complete() {
          this.parent.notifyComplete(this), this.unsubscribe();
        }
      }
      function Wd(e, t, n, s, r = new Cd(e, n, s)) {
        if (!r.closed) return t instanceof b ? t.subscribe(r) : C(t)(r);
      }
      const qd = {};
      class xd {
        constructor(e) {
          this.resultSelector = e;
        }
        call(e, t) {
          return t.subscribe(new Bd(e, this.resultSelector));
        }
      }
      class Bd extends Ed {
        constructor(e, t) {
          super(e), (this.resultSelector = t), (this.active = 0), (this.values = []), (this.observables = []);
        }
        _next(e) {
          this.values.push(qd), this.observables.push(e);
        }
        _complete() {
          const e = this.observables,
            t = e.length;
          if (0 === t) this.destination.complete();
          else {
            (this.active = t), (this.toRespond = t);
            for (let n = 0; n < t; n++) this.add(Wd(this, e[n], void 0, n));
          }
        }
        notifyComplete(e) {
          0 == (this.active -= 1) && this.destination.complete();
        }
        notifyNext(e, t, n) {
          const s = this.values,
            r = this.toRespond ? (s[n] === qd ? --this.toRespond : this.toRespond) : 0;
          (s[n] = t), 0 === r && (this.resultSelector ? this._tryResultSelector(s) : this.destination.next(s.slice()));
        }
        _tryResultSelector(e) {
          let t;
          try {
            t = this.resultSelector.apply(this, e);
          } catch (n) {
            return void this.destination.error(n);
          }
          this.destination.next(t);
        }
      }
      const Hd = (() => {
          function e() {
            return Error.call(this), (this.message = "no elements in sequence"), (this.name = "EmptyError"), this;
          }
          return (e.prototype = Object.create(Error.prototype)), e;
        })(),
        jd = new b((e) => e.complete());
      function Pd(e) {
        return e
          ? (function (e) {
              return new b((t) => e.schedule(() => t.complete()));
            })(e)
          : jd;
      }
      function Xd(e) {
        return new b((t) => {
          let n;
          try {
            n = e();
          } catch (s) {
            return void t.error(s);
          }
          return (n ? q(n) : Pd()).subscribe(t);
        });
      }
      function Rd() {
        return R(1);
      }
      function Id(e, t) {
        return function (n) {
          return n.lift(new Fd(e, t));
        };
      }
      class Fd {
        constructor(e, t) {
          (this.predicate = e), (this.thisArg = t);
        }
        call(e, t) {
          return t.subscribe(new Vd(e, this.predicate, this.thisArg));
        }
      }
      class Vd extends p {
        constructor(e, t, n) {
          super(e), (this.predicate = t), (this.thisArg = n), (this.count = 0);
        }
        _next(e) {
          let t;
          try {
            t = this.predicate.call(this.thisArg, e, this.count++);
          } catch (n) {
            return void this.destination.error(n);
          }
          t && this.destination.next(e);
        }
      }
      const Ud = (() => {
        function e() {
          return (
            Error.call(this), (this.message = "argument out of range"), (this.name = "ArgumentOutOfRangeError"), this
          );
        }
        return (e.prototype = Object.create(Error.prototype)), e;
      })();
      function Jd(e) {
        return function (t) {
          return 0 === e ? Pd() : t.lift(new Gd(e));
        };
      }
      class Gd {
        constructor(e) {
          if (((this.total = e), this.total < 0)) throw new Ud();
        }
        call(e, t) {
          return t.subscribe(new Qd(e, this.total));
        }
      }
      class Qd extends p {
        constructor(e, t) {
          super(e), (this.total = t), (this.ring = new Array()), (this.count = 0);
        }
        _next(e) {
          const t = this.ring,
            n = this.total,
            s = this.count++;
          t.length < n ? t.push(e) : (t[s % n] = e);
        }
        _complete() {
          const e = this.destination;
          let t = this.count;
          if (t > 0) {
            const n = this.count >= this.total ? this.total : this.count,
              s = this.ring;
            for (let r = 0; r < n; r++) {
              const r = t++ % n;
              e.next(s[r]);
            }
          }
          e.complete();
        }
      }
      function Kd(e = eu) {
        return (t) => t.lift(new $d(e));
      }
      class $d {
        constructor(e) {
          this.errorFactory = e;
        }
        call(e, t) {
          return t.subscribe(new Zd(e, this.errorFactory));
        }
      }
      class Zd extends p {
        constructor(e, t) {
          super(e), (this.errorFactory = t), (this.hasValue = !1);
        }
        _next(e) {
          (this.hasValue = !0), this.destination.next(e);
        }
        _complete() {
          if (this.hasValue) return this.destination.complete();
          {
            let t;
            try {
              t = this.errorFactory();
            } catch (e) {
              t = e;
            }
            this.destination.error(t);
          }
        }
      }
      function eu() {
        return new Hd();
      }
      function tu(e = null) {
        return (t) => t.lift(new nu(e));
      }
      class nu {
        constructor(e) {
          this.defaultValue = e;
        }
        call(e, t) {
          return t.subscribe(new su(e, this.defaultValue));
        }
      }
      class su extends p {
        constructor(e, t) {
          super(e), (this.defaultValue = t), (this.isEmpty = !0);
        }
        _next(e) {
          (this.isEmpty = !1), this.destination.next(e);
        }
        _complete() {
          this.isEmpty && this.destination.next(this.defaultValue), this.destination.complete();
        }
      }
      function ru(e, t) {
        return "function" == typeof t
          ? (n) => n.pipe(ru((n, s) => q(e(n, s)).pipe(v((e, r) => t(n, e, s, r)))))
          : (t) => t.lift(new iu(e));
      }
      class iu {
        constructor(e) {
          this.project = e;
        }
        call(e, t) {
          return t.subscribe(new au(e, this.project));
        }
      }
      class au extends B {
        constructor(e, t) {
          super(e), (this.project = t), (this.index = 0);
        }
        _next(e) {
          let t;
          const n = this.index++;
          try {
            t = this.project(e, n);
          } catch (s) {
            return void this.destination.error(s);
          }
          this._innerSub(t);
        }
        _innerSub(e) {
          const t = this.innerSubscription;
          t && t.unsubscribe();
          const n = new x(this),
            s = this.destination;
          s.add(n), (this.innerSubscription = H(e, n)), this.innerSubscription !== n && s.add(this.innerSubscription);
        }
        _complete() {
          const { innerSubscription: e } = this;
          (e && !e.closed) || super._complete(), this.unsubscribe();
        }
        _unsubscribe() {
          this.innerSubscription = void 0;
        }
        notifyComplete() {
          (this.innerSubscription = void 0), this.isStopped && super._complete();
        }
        notifyNext(e) {
          this.destination.next(e);
        }
      }
      function ou(e) {
        return (t) => (0 === e ? Pd() : t.lift(new cu(e)));
      }
      class cu {
        constructor(e) {
          if (((this.total = e), this.total < 0)) throw new Ud();
        }
        call(e, t) {
          return t.subscribe(new lu(e, this.total));
        }
      }
      class lu extends p {
        constructor(e, t) {
          super(e), (this.total = t), (this.count = 0);
        }
        _next(e) {
          const t = this.total,
            n = ++this.count;
          n <= t && (this.destination.next(e), n === t && (this.destination.complete(), this.unsubscribe()));
        }
      }
      function du(...e) {
        return Rd()(Yd(...e));
      }
      class uu {
        constructor(e, t, n = !1) {
          (this.accumulator = e), (this.seed = t), (this.hasSeed = n);
        }
        call(e, t) {
          return t.subscribe(new hu(e, this.accumulator, this.seed, this.hasSeed));
        }
      }
      class hu extends p {
        constructor(e, t, n, s) {
          super(e), (this.accumulator = t), (this._seed = n), (this.hasSeed = s), (this.index = 0);
        }
        get seed() {
          return this._seed;
        }
        set seed(e) {
          (this.hasSeed = !0), (this._seed = e);
        }
        _next(e) {
          if (this.hasSeed) return this._tryNext(e);
          (this.seed = e), this.destination.next(e);
        }
        _tryNext(e) {
          const t = this.index++;
          let n;
          try {
            n = this.accumulator(this.seed, e, t);
          } catch (s) {
            this.destination.error(s);
          }
          (this.seed = n), this.destination.next(n);
        }
      }
      function Mu(e) {
        return function (t) {
          const n = new pu(e),
            s = t.lift(n);
          return (n.caught = s);
        };
      }
      class pu {
        constructor(e) {
          this.selector = e;
        }
        call(e, t) {
          return t.subscribe(new mu(e, this.selector, this.caught));
        }
      }
      class mu extends B {
        constructor(e, t, n) {
          super(e), (this.selector = t), (this.caught = n);
        }
        error(e) {
          if (!this.isStopped) {
            let n;
            try {
              n = this.selector(e, this.caught);
            } catch (t) {
              return void super.error(t);
            }
            this._unsubscribeAndRecycle();
            const s = new x(this);
            this.add(s);
            const r = H(n, s);
            r !== s && this.add(r);
          }
        }
      }
      function _u(e, t) {
        return j(e, t, 1);
      }
      function fu(e, t) {
        const n = arguments.length >= 2;
        return (s) => s.pipe(e ? Id((t, n) => e(t, n, s)) : f, ou(1), n ? tu(t) : Kd(() => new Hd()));
      }
      function bu() {}
      function gu(e, t, n) {
        return function (s) {
          return s.lift(new yu(e, t, n));
        };
      }
      class yu {
        constructor(e, t, n) {
          (this.nextOrObserver = e), (this.error = t), (this.complete = n);
        }
        call(e, t) {
          return t.subscribe(new Lu(e, this.nextOrObserver, this.error, this.complete));
        }
      }
      class Lu extends p {
        constructor(e, t, n, r) {
          super(e),
            (this._tapNext = bu),
            (this._tapError = bu),
            (this._tapComplete = bu),
            (this._tapError = n || bu),
            (this._tapComplete = r || bu),
            s(t)
              ? ((this._context = this), (this._tapNext = t))
              : t &&
                ((this._context = t),
                (this._tapNext = t.next || bu),
                (this._tapError = t.error || bu),
                (this._tapComplete = t.complete || bu));
        }
        _next(e) {
          try {
            this._tapNext.call(this._context, e);
          } catch (t) {
            return void this.destination.error(t);
          }
          this.destination.next(e);
        }
        _error(e) {
          try {
            this._tapError.call(this._context, e);
          } catch (e) {
            return void this.destination.error(e);
          }
          this.destination.error(e);
        }
        _complete() {
          try {
            this._tapComplete.call(this._context);
          } catch (e) {
            return void this.destination.error(e);
          }
          return this.destination.complete();
        }
      }
      class Au {
        constructor(e) {
          this.callback = e;
        }
        call(e, t) {
          return t.subscribe(new wu(e, this.callback));
        }
      }
      class wu extends p {
        constructor(e, t) {
          super(e), this.add(new u(t));
        }
      }
      class zu {
        constructor(e, t) {
          (this.id = e), (this.url = t);
        }
      }
      class Tu extends zu {
        constructor(e, t, n = "imperative", s = null) {
          super(e, t), (this.navigationTrigger = n), (this.restoredState = s);
        }
        toString() {
          return `NavigationStart(id: ${this.id}, url: '${this.url}')`;
        }
      }
      class vu extends zu {
        constructor(e, t, n) {
          super(e, t), (this.urlAfterRedirects = n);
        }
        toString() {
          return `NavigationEnd(id: ${this.id}, url: '${this.url}', urlAfterRedirects: '${this.urlAfterRedirects}')`;
        }
      }
      class Du extends zu {
        constructor(e, t, n) {
          super(e, t), (this.reason = n);
        }
        toString() {
          return `NavigationCancel(id: ${this.id}, url: '${this.url}')`;
        }
      }
      class Ou extends zu {
        constructor(e, t, n) {
          super(e, t), (this.error = n);
        }
        toString() {
          return `NavigationError(id: ${this.id}, url: '${this.url}', error: ${this.error})`;
        }
      }
      class Su extends zu {
        constructor(e, t, n, s) {
          super(e, t), (this.urlAfterRedirects = n), (this.state = s);
        }
        toString() {
          return `RoutesRecognized(id: ${this.id}, url: '${this.url}', urlAfterRedirects: '${this.urlAfterRedirects}', state: ${this.state})`;
        }
      }
      class ku extends zu {
        constructor(e, t, n, s) {
          super(e, t), (this.urlAfterRedirects = n), (this.state = s);
        }
        toString() {
          return `GuardsCheckStart(id: ${this.id}, url: '${this.url}', urlAfterRedirects: '${this.urlAfterRedirects}', state: ${this.state})`;
        }
      }
      class Yu extends zu {
        constructor(e, t, n, s, r) {
          super(e, t), (this.urlAfterRedirects = n), (this.state = s), (this.shouldActivate = r);
        }
        toString() {
          return `GuardsCheckEnd(id: ${this.id}, url: '${this.url}', urlAfterRedirects: '${this.urlAfterRedirects}', state: ${this.state}, shouldActivate: ${this.shouldActivate})`;
        }
      }
      class Nu extends zu {
        constructor(e, t, n, s) {
          super(e, t), (this.urlAfterRedirects = n), (this.state = s);
        }
        toString() {
          return `ResolveStart(id: ${this.id}, url: '${this.url}', urlAfterRedirects: '${this.urlAfterRedirects}', state: ${this.state})`;
        }
      }
      class Eu extends zu {
        constructor(e, t, n, s) {
          super(e, t), (this.urlAfterRedirects = n), (this.state = s);
        }
        toString() {
          return `ResolveEnd(id: ${this.id}, url: '${this.url}', urlAfterRedirects: '${this.urlAfterRedirects}', state: ${this.state})`;
        }
      }
      class Cu {
        constructor(e) {
          this.route = e;
        }
        toString() {
          return `RouteConfigLoadStart(path: ${this.route.path})`;
        }
      }
      class Wu {
        constructor(e) {
          this.route = e;
        }
        toString() {
          return `RouteConfigLoadEnd(path: ${this.route.path})`;
        }
      }
      class qu {
        constructor(e) {
          this.snapshot = e;
        }
        toString() {
          return `ChildActivationStart(path: '${(this.snapshot.routeConfig && this.snapshot.routeConfig.path) || ""}')`;
        }
      }
      class xu {
        constructor(e) {
          this.snapshot = e;
        }
        toString() {
          return `ChildActivationEnd(path: '${(this.snapshot.routeConfig && this.snapshot.routeConfig.path) || ""}')`;
        }
      }
      class Bu {
        constructor(e) {
          this.snapshot = e;
        }
        toString() {
          return `ActivationStart(path: '${(this.snapshot.routeConfig && this.snapshot.routeConfig.path) || ""}')`;
        }
      }
      class Hu {
        constructor(e) {
          this.snapshot = e;
        }
        toString() {
          return `ActivationEnd(path: '${(this.snapshot.routeConfig && this.snapshot.routeConfig.path) || ""}')`;
        }
      }
      class ju {
        constructor(e, t, n) {
          (this.routerEvent = e), (this.position = t), (this.anchor = n);
        }
        toString() {
          return `Scroll(anchor: '${this.anchor}', position: '${
            this.position ? `${this.position[0]}, ${this.position[1]}` : null
          }')`;
        }
      }
      class Pu {
        constructor(e) {
          this.params = e || {};
        }
        has(e) {
          return Object.prototype.hasOwnProperty.call(this.params, e);
        }
        get(e) {
          if (this.has(e)) {
            const t = this.params[e];
            return Array.isArray(t) ? t[0] : t;
          }
          return null;
        }
        getAll(e) {
          if (this.has(e)) {
            const t = this.params[e];
            return Array.isArray(t) ? t : [t];
          }
          return [];
        }
        get keys() {
          return Object.keys(this.params);
        }
      }
      function Xu(e) {
        return new Pu(e);
      }
      function Ru(e) {
        const t = Error("NavigationCancelingError: " + e);
        return (t.ngNavigationCancelingError = !0), t;
      }
      function Iu(e, t, n) {
        const s = n.path.split("/");
        if (s.length > e.length) return null;
        if ("full" === n.pathMatch && (t.hasChildren() || s.length < e.length)) return null;
        const r = {};
        for (let i = 0; i < s.length; i++) {
          const t = s[i],
            n = e[i];
          if (t.startsWith(":")) r[t.substring(1)] = n;
          else if (t !== n.path) return null;
        }
        return { consumed: e.slice(0, s.length), posParams: r };
      }
      function Fu(e, t) {
        const n = Object.keys(e),
          s = Object.keys(t);
        if (!n || !s || n.length != s.length) return !1;
        let r;
        for (let i = 0; i < n.length; i++) if (((r = n[i]), !Vu(e[r], t[r]))) return !1;
        return !0;
      }
      function Vu(e, t) {
        if (Array.isArray(e) && Array.isArray(t)) {
          if (e.length !== t.length) return !1;
          const n = [...e].sort(),
            s = [...t].sort();
          return n.every((e, t) => s[t] === e);
        }
        return e === t;
      }
      function Uu(e) {
        return Array.prototype.concat.apply([], e);
      }
      function Ju(e) {
        return e.length > 0 ? e[e.length - 1] : null;
      }
      function Gu(e, t) {
        for (const n in e) e.hasOwnProperty(n) && t(e[n], n);
      }
      function Qu(e) {
        return Ui(e) ? e : Vi(e) ? q(Promise.resolve(e)) : Yd(e);
      }
      function Ku(e, t, n) {
        return n
          ? (function (e, t) {
              return Fu(e, t);
            })(e.queryParams, t.queryParams) &&
              (function e(t, n) {
                if (!th(t.segments, n.segments)) return !1;
                if (t.numberOfChildren !== n.numberOfChildren) return !1;
                for (const s in n.children) {
                  if (!t.children[s]) return !1;
                  if (!e(t.children[s], n.children[s])) return !1;
                }
                return !0;
              })(e.root, t.root)
          : (function (e, t) {
              return Object.keys(t).length <= Object.keys(e).length && Object.keys(t).every((n) => Vu(e[n], t[n]));
            })(e.queryParams, t.queryParams) &&
              (function e(t, n) {
                return (function t(n, s, r) {
                  if (n.segments.length > r.length) return !!th(n.segments.slice(0, r.length), r) && !s.hasChildren();
                  if (n.segments.length === r.length) {
                    if (!th(n.segments, r)) return !1;
                    for (const t in s.children) {
                      if (!n.children[t]) return !1;
                      if (!e(n.children[t], s.children[t])) return !1;
                    }
                    return !0;
                  }
                  {
                    const e = r.slice(0, n.segments.length),
                      i = r.slice(n.segments.length);
                    return !!th(n.segments, e) && !!n.children.primary && t(n.children.primary, s, i);
                  }
                })(t, n, n.segments);
              })(e.root, t.root);
      }
      class $u {
        constructor(e, t, n) {
          (this.root = e), (this.queryParams = t), (this.fragment = n);
        }
        get queryParamMap() {
          return this._queryParamMap || (this._queryParamMap = Xu(this.queryParams)), this._queryParamMap;
        }
        toString() {
          return ih.serialize(this);
        }
      }
      class Zu {
        constructor(e, t) {
          (this.segments = e), (this.children = t), (this.parent = null), Gu(t, (e, t) => (e.parent = this));
        }
        hasChildren() {
          return this.numberOfChildren > 0;
        }
        get numberOfChildren() {
          return Object.keys(this.children).length;
        }
        toString() {
          return ah(this);
        }
      }
      class eh {
        constructor(e, t) {
          (this.path = e), (this.parameters = t);
        }
        get parameterMap() {
          return this._parameterMap || (this._parameterMap = Xu(this.parameters)), this._parameterMap;
        }
        toString() {
          return hh(this);
        }
      }
      function th(e, t) {
        return e.length === t.length && e.every((e, n) => e.path === t[n].path);
      }
      function nh(e, t) {
        let n = [];
        return (
          Gu(e.children, (e, s) => {
            "primary" === s && (n = n.concat(t(e, s)));
          }),
          Gu(e.children, (e, s) => {
            "primary" !== s && (n = n.concat(t(e, s)));
          }),
          n
        );
      }
      class sh {}
      class rh {
        parse(e) {
          const t = new fh(e);
          return new $u(t.parseRootSegment(), t.parseQueryParams(), t.parseFragment());
        }
        serialize(e) {
          return `${
            "/" +
            (function e(t, n) {
              if (!t.hasChildren()) return ah(t);
              if (n) {
                const n = t.children.primary ? e(t.children.primary, !1) : "",
                  s = [];
                return (
                  Gu(t.children, (t, n) => {
                    "primary" !== n && s.push(`${n}:${e(t, !1)}`);
                  }),
                  s.length > 0 ? `${n}(${s.join("//")})` : n
                );
              }
              {
                const n = nh(t, (n, s) => ("primary" === s ? [e(t.children.primary, !1)] : [`${s}:${e(n, !1)}`]));
                return 1 === Object.keys(t.children).length && null != t.children.primary
                  ? `${ah(t)}/${n[0]}`
                  : `${ah(t)}/(${n.join("//")})`;
              }
            })(e.root, !0)
          }${(function (e) {
            const t = Object.keys(e).map((t) => {
              const n = e[t];
              return Array.isArray(n) ? n.map((e) => `${ch(t)}=${ch(e)}`).join("&") : `${ch(t)}=${ch(n)}`;
            });
            return t.length ? "?" + t.join("&") : "";
          })(e.queryParams)}${"string" == typeof e.fragment ? "#" + encodeURI(e.fragment) : ""}`;
        }
      }
      const ih = new rh();
      function ah(e) {
        return e.segments.map((e) => hh(e)).join("/");
      }
      function oh(e) {
        return encodeURIComponent(e)
          .replace(/%40/g, "@")
          .replace(/%3A/gi, ":")
          .replace(/%24/g, "$")
          .replace(/%2C/gi, ",");
      }
      function ch(e) {
        return oh(e).replace(/%3B/gi, ";");
      }
      function lh(e) {
        return oh(e).replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/%26/gi, "&");
      }
      function dh(e) {
        return decodeURIComponent(e);
      }
      function uh(e) {
        return dh(e.replace(/\+/g, "%20"));
      }
      function hh(e) {
        return `${lh(e.path)}${
          ((t = e.parameters),
          Object.keys(t)
            .map((e) => `;${lh(e)}=${lh(t[e])}`)
            .join(""))
        }`;
        var t;
      }
      const Mh = /^[^\/()?;=#]+/;
      function ph(e) {
        const t = e.match(Mh);
        return t ? t[0] : "";
      }
      const mh = /^[^=?&#]+/,
        _h = /^[^?&#]+/;
      class fh {
        constructor(e) {
          (this.url = e), (this.remaining = e);
        }
        parseRootSegment() {
          return (
            this.consumeOptional("/"),
            "" === this.remaining || this.peekStartsWith("?") || this.peekStartsWith("#")
              ? new Zu([], {})
              : new Zu([], this.parseChildren())
          );
        }
        parseQueryParams() {
          const e = {};
          if (this.consumeOptional("?"))
            do {
              this.parseQueryParam(e);
            } while (this.consumeOptional("&"));
          return e;
        }
        parseFragment() {
          return this.consumeOptional("#") ? decodeURIComponent(this.remaining) : null;
        }
        parseChildren() {
          if ("" === this.remaining) return {};
          this.consumeOptional("/");
          const e = [];
          for (
            this.peekStartsWith("(") || e.push(this.parseSegment());
            this.peekStartsWith("/") && !this.peekStartsWith("//") && !this.peekStartsWith("/(");

          )
            this.capture("/"), e.push(this.parseSegment());
          let t = {};
          this.peekStartsWith("/(") && (this.capture("/"), (t = this.parseParens(!0)));
          let n = {};
          return (
            this.peekStartsWith("(") && (n = this.parseParens(!1)),
            (e.length > 0 || Object.keys(t).length > 0) && (n.primary = new Zu(e, t)),
            n
          );
        }
        parseSegment() {
          const e = ph(this.remaining);
          if ("" === e && this.peekStartsWith(";"))
            throw new Error(`Empty path url segment cannot have parameters: '${this.remaining}'.`);
          return this.capture(e), new eh(dh(e), this.parseMatrixParams());
        }
        parseMatrixParams() {
          const e = {};
          for (; this.consumeOptional(";"); ) this.parseParam(e);
          return e;
        }
        parseParam(e) {
          const t = ph(this.remaining);
          if (!t) return;
          this.capture(t);
          let n = "";
          if (this.consumeOptional("=")) {
            const e = ph(this.remaining);
            e && ((n = e), this.capture(n));
          }
          e[dh(t)] = dh(n);
        }
        parseQueryParam(e) {
          const t = (function (e) {
            const t = e.match(mh);
            return t ? t[0] : "";
          })(this.remaining);
          if (!t) return;
          this.capture(t);
          let n = "";
          if (this.consumeOptional("=")) {
            const e = (function (e) {
              const t = e.match(_h);
              return t ? t[0] : "";
            })(this.remaining);
            e && ((n = e), this.capture(n));
          }
          const s = uh(t),
            r = uh(n);
          if (e.hasOwnProperty(s)) {
            let t = e[s];
            Array.isArray(t) || ((t = [t]), (e[s] = t)), t.push(r);
          } else e[s] = r;
        }
        parseParens(e) {
          const t = {};
          for (this.capture("("); !this.consumeOptional(")") && this.remaining.length > 0; ) {
            const n = ph(this.remaining),
              s = this.remaining[n.length];
            if ("/" !== s && ")" !== s && ";" !== s) throw new Error(`Cannot parse url '${this.url}'`);
            let r = void 0;
            n.indexOf(":") > -1
              ? ((r = n.substr(0, n.indexOf(":"))), this.capture(r), this.capture(":"))
              : e && (r = "primary");
            const i = this.parseChildren();
            (t[r] = 1 === Object.keys(i).length ? i.primary : new Zu([], i)), this.consumeOptional("//");
          }
          return t;
        }
        peekStartsWith(e) {
          return this.remaining.startsWith(e);
        }
        consumeOptional(e) {
          return !!this.peekStartsWith(e) && ((this.remaining = this.remaining.substring(e.length)), !0);
        }
        capture(e) {
          if (!this.consumeOptional(e)) throw new Error(`Expected "${e}".`);
        }
      }
      class bh {
        constructor(e) {
          this._root = e;
        }
        get root() {
          return this._root.value;
        }
        parent(e) {
          const t = this.pathFromRoot(e);
          return t.length > 1 ? t[t.length - 2] : null;
        }
        children(e) {
          const t = gh(e, this._root);
          return t ? t.children.map((e) => e.value) : [];
        }
        firstChild(e) {
          const t = gh(e, this._root);
          return t && t.children.length > 0 ? t.children[0].value : null;
        }
        siblings(e) {
          const t = yh(e, this._root);
          return t.length < 2 ? [] : t[t.length - 2].children.map((e) => e.value).filter((t) => t !== e);
        }
        pathFromRoot(e) {
          return yh(e, this._root).map((e) => e.value);
        }
      }
      function gh(e, t) {
        if (e === t.value) return t;
        for (const n of t.children) {
          const t = gh(e, n);
          if (t) return t;
        }
        return null;
      }
      function yh(e, t) {
        if (e === t.value) return [t];
        for (const n of t.children) {
          const s = yh(e, n);
          if (s.length) return s.unshift(t), s;
        }
        return [];
      }
      class Lh {
        constructor(e, t) {
          (this.value = e), (this.children = t);
        }
        toString() {
          return `TreeNode(${this.value})`;
        }
      }
      function Ah(e) {
        const t = {};
        return e && e.children.forEach((e) => (t[e.value.outlet] = e)), t;
      }
      class wh extends bh {
        constructor(e, t) {
          super(e), (this.snapshot = t), Sh(this, e);
        }
        toString() {
          return this.snapshot.toString();
        }
      }
      function zh(e, t) {
        const n = (function (e, t) {
            const n = new Dh([], {}, {}, "", {}, "primary", t, null, e.root, -1, {});
            return new Oh("", new Lh(n, []));
          })(e, t),
          s = new Nd([new eh("", {})]),
          r = new Nd({}),
          i = new Nd({}),
          a = new Nd({}),
          o = new Nd(""),
          c = new Th(s, r, a, o, i, "primary", t, n.root);
        return (c.snapshot = n.root), new wh(new Lh(c, []), n);
      }
      class Th {
        constructor(e, t, n, s, r, i, a, o) {
          (this.url = e),
            (this.params = t),
            (this.queryParams = n),
            (this.fragment = s),
            (this.data = r),
            (this.outlet = i),
            (this.component = a),
            (this._futureSnapshot = o);
        }
        get routeConfig() {
          return this._futureSnapshot.routeConfig;
        }
        get root() {
          return this._routerState.root;
        }
        get parent() {
          return this._routerState.parent(this);
        }
        get firstChild() {
          return this._routerState.firstChild(this);
        }
        get children() {
          return this._routerState.children(this);
        }
        get pathFromRoot() {
          return this._routerState.pathFromRoot(this);
        }
        get paramMap() {
          return this._paramMap || (this._paramMap = this.params.pipe(v((e) => Xu(e)))), this._paramMap;
        }
        get queryParamMap() {
          return (
            this._queryParamMap || (this._queryParamMap = this.queryParams.pipe(v((e) => Xu(e)))), this._queryParamMap
          );
        }
        toString() {
          return this.snapshot ? this.snapshot.toString() : `Future(${this._futureSnapshot})`;
        }
      }
      function vh(e, t = "emptyOnly") {
        const n = e.pathFromRoot;
        let s = 0;
        if ("always" !== t)
          for (s = n.length - 1; s >= 1; ) {
            const e = n[s],
              t = n[s - 1];
            if (e.routeConfig && "" === e.routeConfig.path) s--;
            else {
              if (t.component) break;
              s--;
            }
          }
        return (function (e) {
          return e.reduce(
            (e, t) => ({
              params: Object.assign(Object.assign({}, e.params), t.params),
              data: Object.assign(Object.assign({}, e.data), t.data),
              resolve: Object.assign(Object.assign({}, e.resolve), t._resolvedData),
            }),
            { params: {}, data: {}, resolve: {} }
          );
        })(n.slice(s));
      }
      class Dh {
        constructor(e, t, n, s, r, i, a, o, c, l, d) {
          (this.url = e),
            (this.params = t),
            (this.queryParams = n),
            (this.fragment = s),
            (this.data = r),
            (this.outlet = i),
            (this.component = a),
            (this.routeConfig = o),
            (this._urlSegment = c),
            (this._lastPathIndex = l),
            (this._resolve = d);
        }
        get root() {
          return this._routerState.root;
        }
        get parent() {
          return this._routerState.parent(this);
        }
        get firstChild() {
          return this._routerState.firstChild(this);
        }
        get children() {
          return this._routerState.children(this);
        }
        get pathFromRoot() {
          return this._routerState.pathFromRoot(this);
        }
        get paramMap() {
          return this._paramMap || (this._paramMap = Xu(this.params)), this._paramMap;
        }
        get queryParamMap() {
          return this._queryParamMap || (this._queryParamMap = Xu(this.queryParams)), this._queryParamMap;
        }
        toString() {
          return `Route(url:'${this.url.map((e) => e.toString()).join("/")}', path:'${
            this.routeConfig ? this.routeConfig.path : ""
          }')`;
        }
      }
      class Oh extends bh {
        constructor(e, t) {
          super(t), (this.url = e), Sh(this, t);
        }
        toString() {
          return kh(this._root);
        }
      }
      function Sh(e, t) {
        (t.value._routerState = e), t.children.forEach((t) => Sh(e, t));
      }
      function kh(e) {
        const t = e.children.length > 0 ? ` { ${e.children.map(kh).join(", ")} } ` : "";
        return `${e.value}${t}`;
      }
      function Yh(e) {
        if (e.snapshot) {
          const t = e.snapshot,
            n = e._futureSnapshot;
          (e.snapshot = n),
            Fu(t.queryParams, n.queryParams) || e.queryParams.next(n.queryParams),
            t.fragment !== n.fragment && e.fragment.next(n.fragment),
            Fu(t.params, n.params) || e.params.next(n.params),
            (function (e, t) {
              if (e.length !== t.length) return !1;
              for (let n = 0; n < e.length; ++n) if (!Fu(e[n], t[n])) return !1;
              return !0;
            })(t.url, n.url) || e.url.next(n.url),
            Fu(t.data, n.data) || e.data.next(n.data);
        } else (e.snapshot = e._futureSnapshot), e.data.next(e._futureSnapshot.data);
      }
      function Nh(e, t) {
        var n, s;
        return (
          Fu(e.params, t.params) &&
          th((n = e.url), (s = t.url)) &&
          n.every((e, t) => Fu(e.parameters, s[t].parameters)) &&
          !(!e.parent != !t.parent) &&
          (!e.parent || Nh(e.parent, t.parent))
        );
      }
      function Eh(e) {
        return "object" == typeof e && null != e && !e.outlets && !e.segmentPath;
      }
      function Ch(e) {
        return "object" == typeof e && null != e && e.outlets;
      }
      function Wh(e, t, n, s, r) {
        let i = {};
        return (
          s &&
            Gu(s, (e, t) => {
              i[t] = Array.isArray(e) ? e.map((e) => "" + e) : "" + e;
            }),
          new $u(
            n.root === e
              ? t
              : (function e(t, n, s) {
                  const r = {};
                  return (
                    Gu(t.children, (t, i) => {
                      r[i] = t === n ? s : e(t, n, s);
                    }),
                    new Zu(t.segments, r)
                  );
                })(n.root, e, t),
            i,
            r
          )
        );
      }
      class qh {
        constructor(e, t, n) {
          if (
            ((this.isAbsolute = e), (this.numberOfDoubleDots = t), (this.commands = n), e && n.length > 0 && Eh(n[0]))
          )
            throw new Error("Root segment cannot have matrix parameters");
          const s = n.find(Ch);
          if (s && s !== Ju(n)) throw new Error("{outlets:{}} has to be the last command");
        }
        toRoot() {
          return this.isAbsolute && 1 === this.commands.length && "/" == this.commands[0];
        }
      }
      class xh {
        constructor(e, t, n) {
          (this.segmentGroup = e), (this.processChildren = t), (this.index = n);
        }
      }
      function Bh(e, t, n) {
        if ((e || (e = new Zu([], {})), 0 === e.segments.length && e.hasChildren())) return Hh(e, t, n);
        const s = (function (e, t, n) {
            let s = 0,
              r = t;
            const i = { match: !1, pathIndex: 0, commandIndex: 0 };
            for (; r < e.segments.length; ) {
              if (s >= n.length) return i;
              const t = e.segments[r],
                a = n[s];
              if (Ch(a)) break;
              const o = "" + a,
                c = s < n.length - 1 ? n[s + 1] : null;
              if (r > 0 && void 0 === o) break;
              if (o && c && "object" == typeof c && void 0 === c.outlets) {
                if (!Rh(o, c, t)) return i;
                s += 2;
              } else {
                if (!Rh(o, {}, t)) return i;
                s++;
              }
              r++;
            }
            return { match: !0, pathIndex: r, commandIndex: s };
          })(e, t, n),
          r = n.slice(s.commandIndex);
        if (s.match && s.pathIndex < e.segments.length) {
          const t = new Zu(e.segments.slice(0, s.pathIndex), {});
          return (t.children.primary = new Zu(e.segments.slice(s.pathIndex), e.children)), Hh(t, 0, r);
        }
        return s.match && 0 === r.length
          ? new Zu(e.segments, {})
          : s.match && !e.hasChildren()
          ? jh(e, t, n)
          : s.match
          ? Hh(e, 0, r)
          : jh(e, t, n);
      }
      function Hh(e, t, n) {
        if (0 === n.length) return new Zu(e.segments, {});
        {
          const s = (function (e) {
              return Ch(e[0]) ? e[0].outlets : { primary: e };
            })(n),
            r = {};
          return (
            Gu(s, (n, s) => {
              null !== n && (r[s] = Bh(e.children[s], t, n));
            }),
            Gu(e.children, (e, t) => {
              void 0 === s[t] && (r[t] = e);
            }),
            new Zu(e.segments, r)
          );
        }
      }
      function jh(e, t, n) {
        const s = e.segments.slice(0, t);
        let r = 0;
        for (; r < n.length; ) {
          const i = n[r];
          if (Ch(i)) {
            const e = Ph(i.outlets);
            return new Zu(s, e);
          }
          if (0 === r && Eh(n[0])) {
            s.push(new eh(e.segments[t].path, n[0])), r++;
            continue;
          }
          const a = Ch(i) ? i.outlets.primary : "" + i,
            o = r < n.length - 1 ? n[r + 1] : null;
          a && o && Eh(o) ? (s.push(new eh(a, Xh(o))), (r += 2)) : (s.push(new eh(a, {})), r++);
        }
        return new Zu(s, {});
      }
      function Ph(e) {
        const t = {};
        return (
          Gu(e, (e, n) => {
            null !== e && (t[n] = jh(new Zu([], {}), 0, e));
          }),
          t
        );
      }
      function Xh(e) {
        const t = {};
        return Gu(e, (e, n) => (t[n] = "" + e)), t;
      }
      function Rh(e, t, n) {
        return e == n.path && Fu(t, n.parameters);
      }
      class Ih {
        constructor(e, t, n, s) {
          (this.routeReuseStrategy = e), (this.futureState = t), (this.currState = n), (this.forwardEvent = s);
        }
        activate(e) {
          const t = this.futureState._root,
            n = this.currState ? this.currState._root : null;
          this.deactivateChildRoutes(t, n, e), Yh(this.futureState.root), this.activateChildRoutes(t, n, e);
        }
        deactivateChildRoutes(e, t, n) {
          const s = Ah(t);
          e.children.forEach((e) => {
            const t = e.value.outlet;
            this.deactivateRoutes(e, s[t], n), delete s[t];
          }),
            Gu(s, (e, t) => {
              this.deactivateRouteAndItsChildren(e, n);
            });
        }
        deactivateRoutes(e, t, n) {
          const s = e.value,
            r = t ? t.value : null;
          if (s === r)
            if (s.component) {
              const r = n.getContext(s.outlet);
              r && this.deactivateChildRoutes(e, t, r.children);
            } else this.deactivateChildRoutes(e, t, n);
          else r && this.deactivateRouteAndItsChildren(t, n);
        }
        deactivateRouteAndItsChildren(e, t) {
          this.routeReuseStrategy.shouldDetach(e.value.snapshot)
            ? this.detachAndStoreRouteSubtree(e, t)
            : this.deactivateRouteAndOutlet(e, t);
        }
        detachAndStoreRouteSubtree(e, t) {
          const n = t.getContext(e.value.outlet);
          if (n && n.outlet) {
            const t = n.outlet.detach(),
              s = n.children.onOutletDeactivated();
            this.routeReuseStrategy.store(e.value.snapshot, { componentRef: t, route: e, contexts: s });
          }
        }
        deactivateRouteAndOutlet(e, t) {
          const n = t.getContext(e.value.outlet);
          if (n) {
            const s = Ah(e),
              r = e.value.component ? n.children : t;
            Gu(s, (e, t) => this.deactivateRouteAndItsChildren(e, r)),
              n.outlet && (n.outlet.deactivate(), n.children.onOutletDeactivated());
          }
        }
        activateChildRoutes(e, t, n) {
          const s = Ah(t);
          e.children.forEach((e) => {
            this.activateRoutes(e, s[e.value.outlet], n), this.forwardEvent(new Hu(e.value.snapshot));
          }),
            e.children.length && this.forwardEvent(new xu(e.value.snapshot));
        }
        activateRoutes(e, t, n) {
          const s = e.value,
            r = t ? t.value : null;
          if ((Yh(s), s === r))
            if (s.component) {
              const r = n.getOrCreateContext(s.outlet);
              this.activateChildRoutes(e, t, r.children);
            } else this.activateChildRoutes(e, t, n);
          else if (s.component) {
            const t = n.getOrCreateContext(s.outlet);
            if (this.routeReuseStrategy.shouldAttach(s.snapshot)) {
              const e = this.routeReuseStrategy.retrieve(s.snapshot);
              this.routeReuseStrategy.store(s.snapshot, null),
                t.children.onOutletReAttached(e.contexts),
                (t.attachRef = e.componentRef),
                (t.route = e.route.value),
                t.outlet && t.outlet.attach(e.componentRef, e.route.value),
                Fh(e.route);
            } else {
              const n = (function (e) {
                  for (let t = e.parent; t; t = t.parent) {
                    const e = t.routeConfig;
                    if (e && e._loadedConfig) return e._loadedConfig;
                    if (e && e.component) return null;
                  }
                  return null;
                })(s.snapshot),
                r = n ? n.module.componentFactoryResolver : null;
              (t.attachRef = null),
                (t.route = s),
                (t.resolver = r),
                t.outlet && t.outlet.activateWith(s, r),
                this.activateChildRoutes(e, null, t.children);
            }
          } else this.activateChildRoutes(e, null, n);
        }
      }
      function Fh(e) {
        Yh(e.value), e.children.forEach(Fh);
      }
      class Vh {
        constructor(e, t) {
          (this.routes = e), (this.module = t);
        }
      }
      function Uh(e) {
        return "function" == typeof e;
      }
      function Jh(e) {
        return e instanceof $u;
      }
      const Gh = Symbol("INITIAL_VALUE");
      function Qh() {
        return ru((e) =>
          (function (...e) {
            let t = void 0,
              n = void 0;
            return (
              T(e[e.length - 1]) && (n = e.pop()),
              "function" == typeof e[e.length - 1] && (t = e.pop()),
              1 === e.length && c(e[0]) && (e = e[0]),
              I(e, n).lift(new xd(t))
            );
          })(
            ...e.map((e) =>
              e.pipe(
                ou(1),
                (function (...e) {
                  const t = e[e.length - 1];
                  return T(t) ? (e.pop(), (n) => du(e, n, t)) : (t) => du(e, t);
                })(Gh)
              )
            )
          ).pipe(
            (function (e, t) {
              let n = !1;
              return (
                arguments.length >= 2 && (n = !0),
                function (s) {
                  return s.lift(new uu(e, t, n));
                }
              );
            })((e, t) => {
              let n = !1;
              return t.reduce((e, s, r) => {
                if (e !== Gh) return e;
                if ((s === Gh && (n = !0), !n)) {
                  if (!1 === s) return s;
                  if (r === t.length - 1 || Jh(s)) return s;
                }
                return e;
              }, e);
            }, Gh),
            Id((e) => e !== Gh),
            v((e) => (Jh(e) ? e : !0 === e)),
            ou(1)
          )
        );
      }
      class Kh {
        constructor(e) {
          this.segmentGroup = e || null;
        }
      }
      class $h {
        constructor(e) {
          this.urlTree = e;
        }
      }
      function Zh(e) {
        return new b((t) => t.error(new Kh(e)));
      }
      function eM(e) {
        return new b((t) => t.error(new $h(e)));
      }
      function tM(e) {
        return new b((t) => t.error(new Error(`Only absolute redirects can have named outlets. redirectTo: '${e}'`)));
      }
      class nM {
        constructor(e, t, n, s, r) {
          (this.configLoader = t),
            (this.urlSerializer = n),
            (this.urlTree = s),
            (this.config = r),
            (this.allowRedirects = !0),
            (this.ngModule = e.get(Qe));
        }
        apply() {
          return this.expandSegmentGroup(this.ngModule, this.config, this.urlTree.root, "primary")
            .pipe(v((e) => this.createUrlTree(e, this.urlTree.queryParams, this.urlTree.fragment)))
            .pipe(
              Mu((e) => {
                if (e instanceof $h) return (this.allowRedirects = !1), this.match(e.urlTree);
                if (e instanceof Kh) throw this.noMatchError(e);
                throw e;
              })
            );
        }
        match(e) {
          return this.expandSegmentGroup(this.ngModule, this.config, e.root, "primary")
            .pipe(v((t) => this.createUrlTree(t, e.queryParams, e.fragment)))
            .pipe(
              Mu((e) => {
                if (e instanceof Kh) throw this.noMatchError(e);
                throw e;
              })
            );
        }
        noMatchError(e) {
          return new Error(`Cannot match any routes. URL Segment: '${e.segmentGroup}'`);
        }
        createUrlTree(e, t, n) {
          const s = e.segments.length > 0 ? new Zu([], { primary: e }) : e;
          return new $u(s, t, n);
        }
        expandSegmentGroup(e, t, n, s) {
          return 0 === n.segments.length && n.hasChildren()
            ? this.expandChildren(e, t, n).pipe(v((e) => new Zu([], e)))
            : this.expandSegment(e, n, t, n.segments, s, !0);
        }
        expandChildren(e, t, n) {
          return (function (e, t) {
            if (0 === Object.keys(e).length) return Yd({});
            const n = [],
              s = [],
              r = {};
            return (
              Gu(e, (e, i) => {
                const a = t(i, e).pipe(v((e) => (r[i] = e)));
                "primary" === i ? n.push(a) : s.push(a);
              }),
              Yd.apply(null, n.concat(s)).pipe(
                Rd(),
                (function (e, t) {
                  const n = arguments.length >= 2;
                  return (s) => s.pipe(e ? Id((t, n) => e(t, n, s)) : f, Jd(1), n ? tu(t) : Kd(() => new Hd()));
                })(),
                v(() => r)
              )
            );
          })(n.children, (n, s) => this.expandSegmentGroup(e, t, s, n));
        }
        expandSegment(e, t, n, s, r, i) {
          return Yd(...n).pipe(
            _u((a) =>
              this.expandSegmentAgainstRoute(e, t, n, a, s, r, i).pipe(
                Mu((e) => {
                  if (e instanceof Kh) return Yd(null);
                  throw e;
                })
              )
            ),
            fu((e) => !!e),
            Mu((e, n) => {
              if (e instanceof Hd || "EmptyError" === e.name) {
                if (this.noLeftoversInUrl(t, s, r)) return Yd(new Zu([], {}));
                throw new Kh(t);
              }
              throw e;
            })
          );
        }
        noLeftoversInUrl(e, t, n) {
          return 0 === t.length && !e.children[n];
        }
        expandSegmentAgainstRoute(e, t, n, s, r, i, a) {
          return aM(s) !== i
            ? Zh(t)
            : void 0 === s.redirectTo
            ? this.matchSegmentAgainstRoute(e, t, s, r)
            : a && this.allowRedirects
            ? this.expandSegmentAgainstRouteUsingRedirect(e, t, n, s, r, i)
            : Zh(t);
        }
        expandSegmentAgainstRouteUsingRedirect(e, t, n, s, r, i) {
          return "**" === s.path
            ? this.expandWildCardWithParamsAgainstRouteUsingRedirect(e, n, s, i)
            : this.expandRegularSegmentAgainstRouteUsingRedirect(e, t, n, s, r, i);
        }
        expandWildCardWithParamsAgainstRouteUsingRedirect(e, t, n, s) {
          const r = this.applyRedirectCommands([], n.redirectTo, {});
          return n.redirectTo.startsWith("/")
            ? eM(r)
            : this.lineralizeSegments(n, r).pipe(
                j((n) => {
                  const r = new Zu(n, {});
                  return this.expandSegment(e, r, t, n, s, !1);
                })
              );
        }
        expandRegularSegmentAgainstRouteUsingRedirect(e, t, n, s, r, i) {
          const { matched: a, consumedSegments: o, lastChild: c, positionalParamSegments: l } = sM(t, s, r);
          if (!a) return Zh(t);
          const d = this.applyRedirectCommands(o, s.redirectTo, l);
          return s.redirectTo.startsWith("/")
            ? eM(d)
            : this.lineralizeSegments(s, d).pipe(j((s) => this.expandSegment(e, t, n, s.concat(r.slice(c)), i, !1)));
        }
        matchSegmentAgainstRoute(e, t, n, s) {
          if ("**" === n.path)
            return n.loadChildren
              ? this.configLoader.load(e.injector, n).pipe(v((e) => ((n._loadedConfig = e), new Zu(s, {}))))
              : Yd(new Zu(s, {}));
          const { matched: r, consumedSegments: i, lastChild: a } = sM(t, n, s);
          if (!r) return Zh(t);
          const o = s.slice(a);
          return this.getChildConfig(e, n, s).pipe(
            j((e) => {
              const n = e.module,
                s = e.routes,
                { segmentGroup: r, slicedSegments: a } = (function (e, t, n, s) {
                  return n.length > 0 &&
                    (function (e, t, n) {
                      return n.some((n) => iM(e, t, n) && "primary" !== aM(n));
                    })(e, n, s)
                    ? {
                        segmentGroup: rM(
                          new Zu(
                            t,
                            (function (e, t) {
                              const n = {};
                              n.primary = t;
                              for (const s of e) "" === s.path && "primary" !== aM(s) && (n[aM(s)] = new Zu([], {}));
                              return n;
                            })(s, new Zu(n, e.children))
                          )
                        ),
                        slicedSegments: [],
                      }
                    : 0 === n.length &&
                      (function (e, t, n) {
                        return n.some((n) => iM(e, t, n));
                      })(e, n, s)
                    ? {
                        segmentGroup: rM(
                          new Zu(
                            e.segments,
                            (function (e, t, n, s) {
                              const r = {};
                              for (const i of n) iM(e, t, i) && !s[aM(i)] && (r[aM(i)] = new Zu([], {}));
                              return Object.assign(Object.assign({}, s), r);
                            })(e, n, s, e.children)
                          )
                        ),
                        slicedSegments: n,
                      }
                    : { segmentGroup: e, slicedSegments: n };
                })(t, i, o, s);
              return 0 === a.length && r.hasChildren()
                ? this.expandChildren(n, s, r).pipe(v((e) => new Zu(i, e)))
                : 0 === s.length && 0 === a.length
                ? Yd(new Zu(i, {}))
                : this.expandSegment(n, r, s, a, "primary", !0).pipe(
                    v((e) => new Zu(i.concat(e.segments), e.children))
                  );
            })
          );
        }
        getChildConfig(e, t, n) {
          return t.children
            ? Yd(new Vh(t.children, e))
            : t.loadChildren
            ? void 0 !== t._loadedConfig
              ? Yd(t._loadedConfig)
              : this.runCanLoadGuards(e.injector, t, n).pipe(
                  j((n) =>
                    n
                      ? this.configLoader.load(e.injector, t).pipe(v((e) => ((t._loadedConfig = e), e)))
                      : (function (e) {
                          return new b((t) =>
                            t.error(
                              Ru(
                                `Cannot load children because the guard of the route "path: '${e.path}'" returned false`
                              )
                            )
                          );
                        })(t)
                  )
                )
            : Yd(new Vh([], e));
        }
        runCanLoadGuards(e, t, n) {
          const s = t.canLoad;
          return s && 0 !== s.length
            ? Yd(
                s.map((s) => {
                  const r = e.get(s);
                  let i;
                  if (
                    (function (e) {
                      return e && Uh(e.canLoad);
                    })(r)
                  )
                    i = r.canLoad(t, n);
                  else {
                    if (!Uh(r)) throw new Error("Invalid CanLoad guard");
                    i = r(t, n);
                  }
                  return Qu(i);
                })
              ).pipe(
                Qh(),
                gu((e) => {
                  if (!Jh(e)) return;
                  const t = Ru(`Redirecting to "${this.urlSerializer.serialize(e)}"`);
                  throw ((t.url = e), t);
                }),
                v((e) => !0 === e)
              )
            : Yd(!0);
        }
        lineralizeSegments(e, t) {
          let n = [],
            s = t.root;
          for (;;) {
            if (((n = n.concat(s.segments)), 0 === s.numberOfChildren)) return Yd(n);
            if (s.numberOfChildren > 1 || !s.children.primary) return tM(e.redirectTo);
            s = s.children.primary;
          }
        }
        applyRedirectCommands(e, t, n) {
          return this.applyRedirectCreatreUrlTree(t, this.urlSerializer.parse(t), e, n);
        }
        applyRedirectCreatreUrlTree(e, t, n, s) {
          const r = this.createSegmentGroup(e, t.root, n, s);
          return new $u(r, this.createQueryParams(t.queryParams, this.urlTree.queryParams), t.fragment);
        }
        createQueryParams(e, t) {
          const n = {};
          return (
            Gu(e, (e, s) => {
              if ("string" == typeof e && e.startsWith(":")) {
                const r = e.substring(1);
                n[s] = t[r];
              } else n[s] = e;
            }),
            n
          );
        }
        createSegmentGroup(e, t, n, s) {
          const r = this.createSegments(e, t.segments, n, s);
          let i = {};
          return (
            Gu(t.children, (t, r) => {
              i[r] = this.createSegmentGroup(e, t, n, s);
            }),
            new Zu(r, i)
          );
        }
        createSegments(e, t, n, s) {
          return t.map((t) => (t.path.startsWith(":") ? this.findPosParam(e, t, s) : this.findOrReturn(t, n)));
        }
        findPosParam(e, t, n) {
          const s = n[t.path.substring(1)];
          if (!s) throw new Error(`Cannot redirect to '${e}'. Cannot find '${t.path}'.`);
          return s;
        }
        findOrReturn(e, t) {
          let n = 0;
          for (const s of t) {
            if (s.path === e.path) return t.splice(n), s;
            n++;
          }
          return e;
        }
      }
      function sM(e, t, n) {
        if ("" === t.path)
          return "full" === t.pathMatch && (e.hasChildren() || n.length > 0)
            ? { matched: !1, consumedSegments: [], lastChild: 0, positionalParamSegments: {} }
            : { matched: !0, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        const s = (t.matcher || Iu)(n, e, t);
        return s
          ? {
              matched: !0,
              consumedSegments: s.consumed,
              lastChild: s.consumed.length,
              positionalParamSegments: s.posParams,
            }
          : { matched: !1, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
      }
      function rM(e) {
        if (1 === e.numberOfChildren && e.children.primary) {
          const t = e.children.primary;
          return new Zu(e.segments.concat(t.segments), t.children);
        }
        return e;
      }
      function iM(e, t, n) {
        return (
          (!(e.hasChildren() || t.length > 0) || "full" !== n.pathMatch) && "" === n.path && void 0 !== n.redirectTo
        );
      }
      function aM(e) {
        return e.outlet || "primary";
      }
      class oM {
        constructor(e) {
          (this.path = e), (this.route = this.path[this.path.length - 1]);
        }
      }
      class cM {
        constructor(e, t) {
          (this.component = e), (this.route = t);
        }
      }
      function lM(e, t, n) {
        const s = e._root;
        return (function e(t, n, s, r, i = { canDeactivateChecks: [], canActivateChecks: [] }) {
          const a = Ah(n);
          return (
            t.children.forEach((t) => {
              !(function (t, n, s, r, i = { canDeactivateChecks: [], canActivateChecks: [] }) {
                const a = t.value,
                  o = n ? n.value : null,
                  c = s ? s.getContext(t.value.outlet) : null;
                if (o && a.routeConfig === o.routeConfig) {
                  const l = (function (e, t, n) {
                    if ("function" == typeof n) return n(e, t);
                    switch (n) {
                      case "pathParamsChange":
                        return !th(e.url, t.url);
                      case "pathParamsOrQueryParamsChange":
                        return !th(e.url, t.url) || !Fu(e.queryParams, t.queryParams);
                      case "always":
                        return !0;
                      case "paramsOrQueryParamsChange":
                        return !Nh(e, t) || !Fu(e.queryParams, t.queryParams);
                      case "paramsChange":
                      default:
                        return !Nh(e, t);
                    }
                  })(o, a, a.routeConfig.runGuardsAndResolvers);
                  l ? i.canActivateChecks.push(new oM(r)) : ((a.data = o.data), (a._resolvedData = o._resolvedData)),
                    e(t, n, a.component ? (c ? c.children : null) : s, r, i),
                    l &&
                      c &&
                      c.outlet &&
                      c.outlet.isActivated &&
                      i.canDeactivateChecks.push(new cM(c.outlet.component, o));
                } else
                  o && uM(n, c, i),
                    i.canActivateChecks.push(new oM(r)),
                    e(t, null, a.component ? (c ? c.children : null) : s, r, i);
              })(t, a[t.value.outlet], s, r.concat([t.value]), i),
                delete a[t.value.outlet];
            }),
            Gu(a, (e, t) => uM(e, s.getContext(t), i)),
            i
          );
        })(s, t ? t._root : null, n, [s.value]);
      }
      function dM(e, t, n) {
        const s = (function (e) {
          if (!e) return null;
          for (let t = e.parent; t; t = t.parent) {
            const e = t.routeConfig;
            if (e && e._loadedConfig) return e._loadedConfig;
          }
          return null;
        })(t);
        return (s ? s.module.injector : n).get(e);
      }
      function uM(e, t, n) {
        const s = Ah(e),
          r = e.value;
        Gu(s, (e, s) => {
          uM(e, r.component ? (t ? t.children.getContext(s) : null) : t, n);
        }),
          n.canDeactivateChecks.push(
            new cM(r.component && t && t.outlet && t.outlet.isActivated ? t.outlet.component : null, r)
          );
      }
      function hM(e, t) {
        return null !== e && t && t(new Bu(e)), Yd(!0);
      }
      function MM(e, t) {
        return null !== e && t && t(new qu(e)), Yd(!0);
      }
      function pM(e, t, n) {
        const s = t.routeConfig ? t.routeConfig.canActivate : null;
        return s && 0 !== s.length
          ? Yd(
              s.map((s) =>
                Xd(() => {
                  const r = dM(s, t, n);
                  let i;
                  if (
                    (function (e) {
                      return e && Uh(e.canActivate);
                    })(r)
                  )
                    i = Qu(r.canActivate(t, e));
                  else {
                    if (!Uh(r)) throw new Error("Invalid CanActivate guard");
                    i = Qu(r(t, e));
                  }
                  return i.pipe(fu());
                })
              )
            ).pipe(Qh())
          : Yd(!0);
      }
      function mM(e, t, n) {
        const s = t[t.length - 1],
          r = t
            .slice(0, t.length - 1)
            .reverse()
            .map((e) =>
              (function (e) {
                const t = e.routeConfig ? e.routeConfig.canActivateChild : null;
                return t && 0 !== t.length ? { node: e, guards: t } : null;
              })(e)
            )
            .filter((e) => null !== e)
            .map((t) =>
              Xd(() =>
                Yd(
                  t.guards.map((r) => {
                    const i = dM(r, t.node, n);
                    let a;
                    if (
                      (function (e) {
                        return e && Uh(e.canActivateChild);
                      })(i)
                    )
                      a = Qu(i.canActivateChild(s, e));
                    else {
                      if (!Uh(i)) throw new Error("Invalid CanActivateChild guard");
                      a = Qu(i(s, e));
                    }
                    return a.pipe(fu());
                  })
                ).pipe(Qh())
              )
            );
        return Yd(r).pipe(Qh());
      }
      class _M {}
      class fM {
        constructor(e, t, n, s, r, i) {
          (this.rootComponentType = e),
            (this.config = t),
            (this.urlTree = n),
            (this.url = s),
            (this.paramsInheritanceStrategy = r),
            (this.relativeLinkResolution = i);
        }
        recognize() {
          try {
            const e = yM(this.urlTree.root, [], [], this.config, this.relativeLinkResolution).segmentGroup,
              t = this.processSegmentGroup(this.config, e, "primary"),
              n = new Dh(
                [],
                Object.freeze({}),
                Object.freeze(Object.assign({}, this.urlTree.queryParams)),
                this.urlTree.fragment,
                {},
                "primary",
                this.rootComponentType,
                null,
                this.urlTree.root,
                -1,
                {}
              ),
              s = new Lh(n, t),
              r = new Oh(this.url, s);
            return this.inheritParamsAndData(r._root), Yd(r);
          } catch (e) {
            return new b((t) => t.error(e));
          }
        }
        inheritParamsAndData(e) {
          const t = e.value,
            n = vh(t, this.paramsInheritanceStrategy);
          (t.params = Object.freeze(n.params)),
            (t.data = Object.freeze(n.data)),
            e.children.forEach((e) => this.inheritParamsAndData(e));
        }
        processSegmentGroup(e, t, n) {
          return 0 === t.segments.length && t.hasChildren()
            ? this.processChildren(e, t)
            : this.processSegment(e, t, t.segments, n);
        }
        processChildren(e, t) {
          const n = nh(t, (t, n) => this.processSegmentGroup(e, t, n));
          return (
            (function (e) {
              const t = {};
              e.forEach((e) => {
                const n = t[e.value.outlet];
                if (n) {
                  const t = n.url.map((e) => e.toString()).join("/"),
                    s = e.value.url.map((e) => e.toString()).join("/");
                  throw new Error(`Two segments cannot have the same outlet name: '${t}' and '${s}'.`);
                }
                t[e.value.outlet] = e.value;
              });
            })(n),
            n.sort((e, t) =>
              "primary" === e.value.outlet
                ? -1
                : "primary" === t.value.outlet
                ? 1
                : e.value.outlet.localeCompare(t.value.outlet)
            ),
            n
          );
        }
        processSegment(e, t, n, s) {
          for (const i of e)
            try {
              return this.processSegmentAgainstRoute(i, t, n, s);
            } catch (r) {
              if (!(r instanceof _M)) throw r;
            }
          if (this.noLeftoversInUrl(t, n, s)) return [];
          throw new _M();
        }
        noLeftoversInUrl(e, t, n) {
          return 0 === t.length && !e.children[n];
        }
        processSegmentAgainstRoute(e, t, n, s) {
          if (e.redirectTo) throw new _M();
          if ((e.outlet || "primary") !== s) throw new _M();
          let r,
            i = [],
            a = [];
          if ("**" === e.path) {
            const i = n.length > 0 ? Ju(n).parameters : {};
            r = new Dh(
              n,
              i,
              Object.freeze(Object.assign({}, this.urlTree.queryParams)),
              this.urlTree.fragment,
              wM(e),
              s,
              e.component,
              e,
              bM(t),
              gM(t) + n.length,
              zM(e)
            );
          } else {
            const o = (function (e, t, n) {
              if ("" === t.path) {
                if ("full" === t.pathMatch && (e.hasChildren() || n.length > 0)) throw new _M();
                return { consumedSegments: [], lastChild: 0, parameters: {} };
              }
              const s = (t.matcher || Iu)(n, e, t);
              if (!s) throw new _M();
              const r = {};
              Gu(s.posParams, (e, t) => {
                r[t] = e.path;
              });
              const i =
                s.consumed.length > 0
                  ? Object.assign(Object.assign({}, r), s.consumed[s.consumed.length - 1].parameters)
                  : r;
              return { consumedSegments: s.consumed, lastChild: s.consumed.length, parameters: i };
            })(t, e, n);
            (i = o.consumedSegments),
              (a = n.slice(o.lastChild)),
              (r = new Dh(
                i,
                o.parameters,
                Object.freeze(Object.assign({}, this.urlTree.queryParams)),
                this.urlTree.fragment,
                wM(e),
                s,
                e.component,
                e,
                bM(t),
                gM(t) + i.length,
                zM(e)
              ));
          }
          const o = (function (e) {
              return e.children ? e.children : e.loadChildren ? e._loadedConfig.routes : [];
            })(e),
            { segmentGroup: c, slicedSegments: l } = yM(t, i, a, o, this.relativeLinkResolution);
          if (0 === l.length && c.hasChildren()) {
            const e = this.processChildren(o, c);
            return [new Lh(r, e)];
          }
          if (0 === o.length && 0 === l.length) return [new Lh(r, [])];
          const d = this.processSegment(o, c, l, "primary");
          return [new Lh(r, d)];
        }
      }
      function bM(e) {
        let t = e;
        for (; t._sourceSegment; ) t = t._sourceSegment;
        return t;
      }
      function gM(e) {
        let t = e,
          n = t._segmentIndexShift ? t._segmentIndexShift : 0;
        for (; t._sourceSegment; ) (t = t._sourceSegment), (n += t._segmentIndexShift ? t._segmentIndexShift : 0);
        return n - 1;
      }
      function yM(e, t, n, s, r) {
        if (
          n.length > 0 &&
          (function (e, t, n) {
            return n.some((n) => LM(e, t, n) && "primary" !== AM(n));
          })(e, n, s)
        ) {
          const r = new Zu(
            t,
            (function (e, t, n, s) {
              const r = {};
              (r.primary = s), (s._sourceSegment = e), (s._segmentIndexShift = t.length);
              for (const i of n)
                if ("" === i.path && "primary" !== AM(i)) {
                  const n = new Zu([], {});
                  (n._sourceSegment = e), (n._segmentIndexShift = t.length), (r[AM(i)] = n);
                }
              return r;
            })(e, t, s, new Zu(n, e.children))
          );
          return (r._sourceSegment = e), (r._segmentIndexShift = t.length), { segmentGroup: r, slicedSegments: [] };
        }
        if (
          0 === n.length &&
          (function (e, t, n) {
            return n.some((n) => LM(e, t, n));
          })(e, n, s)
        ) {
          const i = new Zu(
            e.segments,
            (function (e, t, n, s, r, i) {
              const a = {};
              for (const o of s)
                if (LM(e, n, o) && !r[AM(o)]) {
                  const n = new Zu([], {});
                  (n._sourceSegment = e),
                    (n._segmentIndexShift = "legacy" === i ? e.segments.length : t.length),
                    (a[AM(o)] = n);
                }
              return Object.assign(Object.assign({}, r), a);
            })(e, t, n, s, e.children, r)
          );
          return (i._sourceSegment = e), (i._segmentIndexShift = t.length), { segmentGroup: i, slicedSegments: n };
        }
        const i = new Zu(e.segments, e.children);
        return (i._sourceSegment = e), (i._segmentIndexShift = t.length), { segmentGroup: i, slicedSegments: n };
      }
      function LM(e, t, n) {
        return (
          (!(e.hasChildren() || t.length > 0) || "full" !== n.pathMatch) && "" === n.path && void 0 === n.redirectTo
        );
      }
      function AM(e) {
        return e.outlet || "primary";
      }
      function wM(e) {
        return e.data || {};
      }
      function zM(e) {
        return e.resolve || {};
      }
      function TM(e) {
        return function (t) {
          return t.pipe(
            ru((t) => {
              const n = e(t);
              return n ? q(n).pipe(v(() => t)) : q([t]);
            })
          );
        };
      }
      class vM extends class {
        shouldDetach(e) {
          return !1;
        }
        store(e, t) {}
        shouldAttach(e) {
          return !1;
        }
        retrieve(e) {
          return null;
        }
        shouldReuseRoute(e, t) {
          return e.routeConfig === t.routeConfig;
        }
      } {}
      let DM = (() => {
        class e {}
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵcmp = dt({
            type: e,
            selectors: [["ng-component"]],
            decls: 1,
            vars: 0,
            template: function (e, t) {
              1 & e && Ii(0, "router-outlet");
            },
            directives: function () {
              return [PM];
            },
            encapsulation: 2,
          })),
          e
        );
      })();
      function OM(e, t = "") {
        for (let n = 0; n < e.length; n++) {
          const s = e[n];
          SM(s, kM(t, s));
        }
      }
      function SM(e, t) {
        if (!e)
          throw new Error(
            `\n      Invalid configuration of route '${t}': Encountered undefined route.\n      The reason might be an extra comma.\n\n      Example:\n      const routes: Routes = [\n        { path: '', redirectTo: '/dashboard', pathMatch: 'full' },\n        { path: 'dashboard',  component: DashboardComponent },, << two commas\n        { path: 'detail/:id', component: HeroDetailComponent }\n      ];\n    `
          );
        if (Array.isArray(e)) throw new Error(`Invalid configuration of route '${t}': Array cannot be specified`);
        if (!e.component && !e.children && !e.loadChildren && e.outlet && "primary" !== e.outlet)
          throw new Error(
            `Invalid configuration of route '${t}': a componentless route without children or loadChildren cannot have a named outlet set`
          );
        if (e.redirectTo && e.children)
          throw new Error(`Invalid configuration of route '${t}': redirectTo and children cannot be used together`);
        if (e.redirectTo && e.loadChildren)
          throw new Error(`Invalid configuration of route '${t}': redirectTo and loadChildren cannot be used together`);
        if (e.children && e.loadChildren)
          throw new Error(`Invalid configuration of route '${t}': children and loadChildren cannot be used together`);
        if (e.redirectTo && e.component)
          throw new Error(`Invalid configuration of route '${t}': redirectTo and component cannot be used together`);
        if (e.path && e.matcher)
          throw new Error(`Invalid configuration of route '${t}': path and matcher cannot be used together`);
        if (void 0 === e.redirectTo && !e.component && !e.children && !e.loadChildren)
          throw new Error(
            `Invalid configuration of route '${t}'. One of the following must be provided: component, redirectTo, children or loadChildren`
          );
        if (void 0 === e.path && void 0 === e.matcher)
          throw new Error(
            `Invalid configuration of route '${t}': routes must have either a path or a matcher specified`
          );
        if ("string" == typeof e.path && "/" === e.path.charAt(0))
          throw new Error(`Invalid configuration of route '${t}': path cannot start with a slash`);
        if ("" === e.path && void 0 !== e.redirectTo && void 0 === e.pathMatch)
          throw new Error(
            `Invalid configuration of route '{path: "${t}", redirectTo: "${e.redirectTo}"}': please provide 'pathMatch'. The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.`
          );
        if (void 0 !== e.pathMatch && "full" !== e.pathMatch && "prefix" !== e.pathMatch)
          throw new Error(`Invalid configuration of route '${t}': pathMatch can only be set to 'prefix' or 'full'`);
        e.children && OM(e.children, t);
      }
      function kM(e, t) {
        return t ? (e || t.path ? (e && !t.path ? e + "/" : !e && t.path ? t.path : `${e}/${t.path}`) : "") : e;
      }
      function YM(e) {
        const t = e.children && e.children.map(YM),
          n = t ? Object.assign(Object.assign({}, e), { children: t }) : Object.assign({}, e);
        return !n.component && (t || n.loadChildren) && n.outlet && "primary" !== n.outlet && (n.component = DM), n;
      }
      const NM = new qe("ROUTES");
      class EM {
        constructor(e, t, n, s) {
          (this.loader = e), (this.compiler = t), (this.onLoadStartListener = n), (this.onLoadEndListener = s);
        }
        load(e, t) {
          return (
            this.onLoadStartListener && this.onLoadStartListener(t),
            this.loadModuleFactory(t.loadChildren).pipe(
              v((n) => {
                this.onLoadEndListener && this.onLoadEndListener(t);
                const s = n.create(e);
                return new Vh(Uu(s.injector.get(NM)).map(YM), s);
              })
            )
          );
        }
        loadModuleFactory(e) {
          return "string" == typeof e
            ? q(this.loader.load(e))
            : Qu(e()).pipe(j((e) => (e instanceof Ke ? Yd(e) : q(this.compiler.compileModuleAsync(e)))));
        }
      }
      class CM {
        constructor() {
          (this.outlet = null),
            (this.route = null),
            (this.resolver = null),
            (this.children = new WM()),
            (this.attachRef = null);
        }
      }
      class WM {
        constructor() {
          this.contexts = new Map();
        }
        onChildOutletCreated(e, t) {
          const n = this.getOrCreateContext(e);
          (n.outlet = t), this.contexts.set(e, n);
        }
        onChildOutletDestroyed(e) {
          const t = this.getContext(e);
          t && (t.outlet = null);
        }
        onOutletDeactivated() {
          const e = this.contexts;
          return (this.contexts = new Map()), e;
        }
        onOutletReAttached(e) {
          this.contexts = e;
        }
        getOrCreateContext(e) {
          let t = this.getContext(e);
          return t || ((t = new CM()), this.contexts.set(e, t)), t;
        }
        getContext(e) {
          return this.contexts.get(e) || null;
        }
      }
      class qM {
        shouldProcessUrl(e) {
          return !0;
        }
        extract(e) {
          return e;
        }
        merge(e, t) {
          return e;
        }
      }
      function xM(e) {
        throw e;
      }
      function BM(e, t, n) {
        return t.parse("/");
      }
      function HM(e, t) {
        return Yd(null);
      }
      let jM = (() => {
          class e {
            constructor(e, t, n, s, r, i, a, o) {
              (this.rootComponentType = e),
                (this.urlSerializer = t),
                (this.rootContexts = n),
                (this.location = s),
                (this.config = o),
                (this.lastSuccessfulNavigation = null),
                (this.currentNavigation = null),
                (this.lastLocationChangeInfo = null),
                (this.navigationId = 0),
                (this.isNgZoneEnabled = !1),
                (this.events = new w()),
                (this.errorHandler = xM),
                (this.malformedUriErrorHandler = BM),
                (this.navigated = !1),
                (this.lastSuccessfulId = -1),
                (this.hooks = { beforePreactivation: HM, afterPreactivation: HM }),
                (this.urlHandlingStrategy = new qM()),
                (this.routeReuseStrategy = new vM()),
                (this.onSameUrlNavigation = "ignore"),
                (this.paramsInheritanceStrategy = "emptyOnly"),
                (this.urlUpdateStrategy = "deferred"),
                (this.relativeLinkResolution = "legacy"),
                (this.ngModule = r.get(Qe)),
                (this.console = r.get(ic));
              const c = r.get(bc);
              (this.isNgZoneEnabled = c instanceof bc),
                this.resetConfig(o),
                (this.currentUrlTree = new $u(new Zu([], {}), {}, null)),
                (this.rawUrlTree = this.currentUrlTree),
                (this.browserUrlTree = this.currentUrlTree),
                (this.configLoader = new EM(
                  i,
                  a,
                  (e) => this.triggerEvent(new Cu(e)),
                  (e) => this.triggerEvent(new Wu(e))
                )),
                (this.routerState = zh(this.currentUrlTree, this.rootComponentType)),
                (this.transitions = new Nd({
                  id: 0,
                  currentUrlTree: this.currentUrlTree,
                  currentRawUrl: this.currentUrlTree,
                  extractedUrl: this.urlHandlingStrategy.extract(this.currentUrlTree),
                  urlAfterRedirects: this.urlHandlingStrategy.extract(this.currentUrlTree),
                  rawUrl: this.currentUrlTree,
                  extras: {},
                  resolve: null,
                  reject: null,
                  promise: Promise.resolve(!0),
                  source: "imperative",
                  restoredState: null,
                  currentSnapshot: this.routerState.snapshot,
                  targetSnapshot: null,
                  currentRouterState: this.routerState,
                  targetRouterState: null,
                  guards: { canActivateChecks: [], canDeactivateChecks: [] },
                  guardsResult: null,
                })),
                (this.navigations = this.setupNavigations(this.transitions)),
                this.processNavigations();
            }
            setupNavigations(e) {
              const t = this.events;
              return e.pipe(
                Id((e) => 0 !== e.id),
                v((e) =>
                  Object.assign(Object.assign({}, e), { extractedUrl: this.urlHandlingStrategy.extract(e.rawUrl) })
                ),
                ru((e) => {
                  let n = !1,
                    s = !1;
                  return Yd(e).pipe(
                    gu((e) => {
                      this.currentNavigation = {
                        id: e.id,
                        initialUrl: e.currentRawUrl,
                        extractedUrl: e.extractedUrl,
                        trigger: e.source,
                        extras: e.extras,
                        previousNavigation: this.lastSuccessfulNavigation
                          ? Object.assign(Object.assign({}, this.lastSuccessfulNavigation), {
                              previousNavigation: null,
                            })
                          : null,
                      };
                    }),
                    ru((e) => {
                      const n = !this.navigated || e.extractedUrl.toString() !== this.browserUrlTree.toString();
                      if (
                        ("reload" === this.onSameUrlNavigation || n) &&
                        this.urlHandlingStrategy.shouldProcessUrl(e.rawUrl)
                      )
                        return Yd(e).pipe(
                          ru((e) => {
                            const n = this.transitions.getValue();
                            return (
                              t.next(new Tu(e.id, this.serializeUrl(e.extractedUrl), e.source, e.restoredState)),
                              n !== this.transitions.getValue() ? jd : [e]
                            );
                          }),
                          ru((e) => Promise.resolve(e)),
                          ((s = this.ngModule.injector),
                          (r = this.configLoader),
                          (i = this.urlSerializer),
                          (a = this.config),
                          function (e) {
                            return e.pipe(
                              ru((e) =>
                                (function (e, t, n, s, r) {
                                  return new nM(e, t, n, s, r).apply();
                                })(s, r, i, e.extractedUrl, a).pipe(
                                  v((t) => Object.assign(Object.assign({}, e), { urlAfterRedirects: t }))
                                )
                              )
                            );
                          }),
                          gu((e) => {
                            this.currentNavigation = Object.assign(Object.assign({}, this.currentNavigation), {
                              finalUrl: e.urlAfterRedirects,
                            });
                          }),
                          (function (e, t, n, s, r) {
                            return function (i) {
                              return i.pipe(
                                j((i) =>
                                  (function (e, t, n, s, r = "emptyOnly", i = "legacy") {
                                    return new fM(e, t, n, s, r, i).recognize();
                                  })(e, t, i.urlAfterRedirects, n(i.urlAfterRedirects), s, r).pipe(
                                    v((e) => Object.assign(Object.assign({}, i), { targetSnapshot: e }))
                                  )
                                )
                              );
                            };
                          })(
                            this.rootComponentType,
                            this.config,
                            (e) => this.serializeUrl(e),
                            this.paramsInheritanceStrategy,
                            this.relativeLinkResolution
                          ),
                          gu((e) => {
                            "eager" === this.urlUpdateStrategy &&
                              (e.extras.skipLocationChange ||
                                this.setBrowserUrl(e.urlAfterRedirects, !!e.extras.replaceUrl, e.id, e.extras.state),
                              (this.browserUrlTree = e.urlAfterRedirects));
                          }),
                          gu((e) => {
                            const n = new Su(
                              e.id,
                              this.serializeUrl(e.extractedUrl),
                              this.serializeUrl(e.urlAfterRedirects),
                              e.targetSnapshot
                            );
                            t.next(n);
                          })
                        );
                      var s, r, i, a;
                      if (n && this.rawUrlTree && this.urlHandlingStrategy.shouldProcessUrl(this.rawUrlTree)) {
                        const { id: n, extractedUrl: s, source: r, restoredState: i, extras: a } = e,
                          o = new Tu(n, this.serializeUrl(s), r, i);
                        t.next(o);
                        const c = zh(s, this.rootComponentType).snapshot;
                        return Yd(
                          Object.assign(Object.assign({}, e), {
                            targetSnapshot: c,
                            urlAfterRedirects: s,
                            extras: Object.assign(Object.assign({}, a), { skipLocationChange: !1, replaceUrl: !1 }),
                          })
                        );
                      }
                      return (
                        (this.rawUrlTree = e.rawUrl), (this.browserUrlTree = e.urlAfterRedirects), e.resolve(null), jd
                      );
                    }),
                    TM((e) => {
                      const {
                        targetSnapshot: t,
                        id: n,
                        extractedUrl: s,
                        rawUrl: r,
                        extras: { skipLocationChange: i, replaceUrl: a },
                      } = e;
                      return this.hooks.beforePreactivation(t, {
                        navigationId: n,
                        appliedUrlTree: s,
                        rawUrlTree: r,
                        skipLocationChange: !!i,
                        replaceUrl: !!a,
                      });
                    }),
                    gu((e) => {
                      const t = new ku(
                        e.id,
                        this.serializeUrl(e.extractedUrl),
                        this.serializeUrl(e.urlAfterRedirects),
                        e.targetSnapshot
                      );
                      this.triggerEvent(t);
                    }),
                    v((e) =>
                      Object.assign(Object.assign({}, e), {
                        guards: lM(e.targetSnapshot, e.currentSnapshot, this.rootContexts),
                      })
                    ),
                    (function (e, t) {
                      return function (n) {
                        return n.pipe(
                          j((n) => {
                            const {
                              targetSnapshot: s,
                              currentSnapshot: r,
                              guards: { canActivateChecks: i, canDeactivateChecks: a },
                            } = n;
                            return 0 === a.length && 0 === i.length
                              ? Yd(Object.assign(Object.assign({}, n), { guardsResult: !0 }))
                              : (function (e, t, n, s) {
                                  return q(e).pipe(
                                    j((e) =>
                                      (function (e, t, n, s, r) {
                                        const i = t && t.routeConfig ? t.routeConfig.canDeactivate : null;
                                        return i && 0 !== i.length
                                          ? Yd(
                                              i.map((i) => {
                                                const a = dM(i, t, r);
                                                let o;
                                                if (
                                                  (function (e) {
                                                    return e && Uh(e.canDeactivate);
                                                  })(a)
                                                )
                                                  o = Qu(a.canDeactivate(e, t, n, s));
                                                else {
                                                  if (!Uh(a)) throw new Error("Invalid CanDeactivate guard");
                                                  o = Qu(a(e, t, n, s));
                                                }
                                                return o.pipe(fu());
                                              })
                                            ).pipe(Qh())
                                          : Yd(!0);
                                      })(e.component, e.route, n, t, s)
                                    ),
                                    fu((e) => !0 !== e, !0)
                                  );
                                })(a, s, r, e).pipe(
                                  j((n) =>
                                    n && "boolean" == typeof n
                                      ? (function (e, t, n, s) {
                                          return q(t).pipe(
                                            _u((t) =>
                                              q([
                                                MM(t.route.parent, s),
                                                hM(t.route, s),
                                                mM(e, t.path, n),
                                                pM(e, t.route, n),
                                              ]).pipe(
                                                Rd(),
                                                fu((e) => !0 !== e, !0)
                                              )
                                            ),
                                            fu((e) => !0 !== e, !0)
                                          );
                                        })(s, i, e, t)
                                      : Yd(n)
                                  ),
                                  v((e) => Object.assign(Object.assign({}, n), { guardsResult: e }))
                                );
                          })
                        );
                      };
                    })(this.ngModule.injector, (e) => this.triggerEvent(e)),
                    gu((e) => {
                      if (Jh(e.guardsResult)) {
                        const t = Ru(`Redirecting to "${this.serializeUrl(e.guardsResult)}"`);
                        throw ((t.url = e.guardsResult), t);
                      }
                    }),
                    gu((e) => {
                      const t = new Yu(
                        e.id,
                        this.serializeUrl(e.extractedUrl),
                        this.serializeUrl(e.urlAfterRedirects),
                        e.targetSnapshot,
                        !!e.guardsResult
                      );
                      this.triggerEvent(t);
                    }),
                    Id((e) => {
                      if (!e.guardsResult) {
                        this.resetUrlToCurrentUrlTree();
                        const n = new Du(e.id, this.serializeUrl(e.extractedUrl), "");
                        return t.next(n), e.resolve(!1), !1;
                      }
                      return !0;
                    }),
                    TM((e) => {
                      if (e.guards.canActivateChecks.length)
                        return Yd(e).pipe(
                          gu((e) => {
                            const t = new Nu(
                              e.id,
                              this.serializeUrl(e.extractedUrl),
                              this.serializeUrl(e.urlAfterRedirects),
                              e.targetSnapshot
                            );
                            this.triggerEvent(t);
                          }),
                          ru((e) => {
                            let n = !1;
                            return Yd(e).pipe(
                              ((s = this.paramsInheritanceStrategy),
                              (r = this.ngModule.injector),
                              function (e) {
                                return e.pipe(
                                  j((e) => {
                                    const {
                                      targetSnapshot: t,
                                      guards: { canActivateChecks: n },
                                    } = e;
                                    if (!n.length) return Yd(e);
                                    let i = 0;
                                    return q(n).pipe(
                                      _u((e) =>
                                        (function (e, t, n, s) {
                                          return (function (e, t, n, s) {
                                            const r = Object.keys(e);
                                            if (0 === r.length) return Yd({});
                                            const i = {};
                                            return q(r).pipe(
                                              j((r) =>
                                                (function (e, t, n, s) {
                                                  const r = dM(e, t, s);
                                                  return Qu(r.resolve ? r.resolve(t, n) : r(t, n));
                                                })(e[r], t, n, s).pipe(
                                                  gu((e) => {
                                                    i[r] = e;
                                                  })
                                                )
                                              ),
                                              Jd(1),
                                              j(() => (Object.keys(i).length === r.length ? Yd(i) : jd))
                                            );
                                          })(e._resolve, e, t, s).pipe(
                                            v(
                                              (t) => (
                                                (e._resolvedData = t),
                                                (e.data = Object.assign(Object.assign({}, e.data), vh(e, n).resolve)),
                                                null
                                              )
                                            )
                                          );
                                        })(e.route, t, s, r)
                                      ),
                                      gu(() => i++),
                                      Jd(1),
                                      j((t) => (i === n.length ? Yd(e) : jd))
                                    );
                                  })
                                );
                              }),
                              gu({
                                next: () => (n = !0),
                                complete: () => {
                                  if (!n) {
                                    const n = new Du(
                                      e.id,
                                      this.serializeUrl(e.extractedUrl),
                                      "At least one route resolver didn't emit any value."
                                    );
                                    t.next(n), e.resolve(!1);
                                  }
                                },
                              })
                            );
                            var s, r;
                          }),
                          gu((e) => {
                            const t = new Eu(
                              e.id,
                              this.serializeUrl(e.extractedUrl),
                              this.serializeUrl(e.urlAfterRedirects),
                              e.targetSnapshot
                            );
                            this.triggerEvent(t);
                          })
                        );
                    }),
                    TM((e) => {
                      const {
                        targetSnapshot: t,
                        id: n,
                        extractedUrl: s,
                        rawUrl: r,
                        extras: { skipLocationChange: i, replaceUrl: a },
                      } = e;
                      return this.hooks.afterPreactivation(t, {
                        navigationId: n,
                        appliedUrlTree: s,
                        rawUrlTree: r,
                        skipLocationChange: !!i,
                        replaceUrl: !!a,
                      });
                    }),
                    v((e) => {
                      const t = (function (e, t, n) {
                        const s = (function e(t, n, s) {
                          if (s && t.shouldReuseRoute(n.value, s.value.snapshot)) {
                            const r = s.value;
                            r._futureSnapshot = n.value;
                            const i = (function (t, n, s) {
                              return n.children.map((n) => {
                                for (const r of s.children)
                                  if (t.shouldReuseRoute(r.value.snapshot, n.value)) return e(t, n, r);
                                return e(t, n);
                              });
                            })(t, n, s);
                            return new Lh(r, i);
                          }
                          {
                            const s = t.retrieve(n.value);
                            if (s) {
                              const e = s.route;
                              return (
                                (function e(t, n) {
                                  if (t.value.routeConfig !== n.value.routeConfig)
                                    throw new Error(
                                      "Cannot reattach ActivatedRouteSnapshot created from a different route"
                                    );
                                  if (t.children.length !== n.children.length)
                                    throw new Error(
                                      "Cannot reattach ActivatedRouteSnapshot with a different number of children"
                                    );
                                  n.value._futureSnapshot = t.value;
                                  for (let s = 0; s < t.children.length; ++s) e(t.children[s], n.children[s]);
                                })(n, e),
                                e
                              );
                            }
                            {
                              const s = new Th(
                                  new Nd((r = n.value).url),
                                  new Nd(r.params),
                                  new Nd(r.queryParams),
                                  new Nd(r.fragment),
                                  new Nd(r.data),
                                  r.outlet,
                                  r.component,
                                  r
                                ),
                                i = n.children.map((n) => e(t, n));
                              return new Lh(s, i);
                            }
                          }
                          var r;
                        })(e, t._root, n ? n._root : void 0);
                        return new wh(s, t);
                      })(this.routeReuseStrategy, e.targetSnapshot, e.currentRouterState);
                      return Object.assign(Object.assign({}, e), { targetRouterState: t });
                    }),
                    gu((e) => {
                      (this.currentUrlTree = e.urlAfterRedirects),
                        (this.rawUrlTree = this.urlHandlingStrategy.merge(this.currentUrlTree, e.rawUrl)),
                        (this.routerState = e.targetRouterState),
                        "deferred" === this.urlUpdateStrategy &&
                          (e.extras.skipLocationChange ||
                            this.setBrowserUrl(this.rawUrlTree, !!e.extras.replaceUrl, e.id, e.extras.state),
                          (this.browserUrlTree = e.urlAfterRedirects));
                    }),
                    ((i = this.rootContexts),
                    (a = this.routeReuseStrategy),
                    (o = (e) => this.triggerEvent(e)),
                    v((e) => (new Ih(a, e.targetRouterState, e.currentRouterState, o).activate(i), e))),
                    gu({
                      next() {
                        n = !0;
                      },
                      complete() {
                        n = !0;
                      },
                    }),
                    ((r = () => {
                      if (!n && !s) {
                        this.resetUrlToCurrentUrlTree();
                        const n = new Du(
                          e.id,
                          this.serializeUrl(e.extractedUrl),
                          `Navigation ID ${e.id} is not equal to the current navigation id ${this.navigationId}`
                        );
                        t.next(n), e.resolve(!1);
                      }
                      this.currentNavigation = null;
                    }),
                    (e) => e.lift(new Au(r))),
                    Mu((n) => {
                      if (((s = !0), (r = n) && r.ngNavigationCancelingError)) {
                        const s = Jh(n.url);
                        s ||
                          ((this.navigated = !0),
                          this.resetStateAndUrl(e.currentRouterState, e.currentUrlTree, e.rawUrl));
                        const r = new Du(e.id, this.serializeUrl(e.extractedUrl), n.message);
                        t.next(r),
                          s
                            ? setTimeout(() => {
                                const t = this.urlHandlingStrategy.merge(n.url, this.rawUrlTree);
                                return this.scheduleNavigation(
                                  t,
                                  "imperative",
                                  null,
                                  {
                                    skipLocationChange: e.extras.skipLocationChange,
                                    replaceUrl: "eager" === this.urlUpdateStrategy,
                                  },
                                  { resolve: e.resolve, reject: e.reject, promise: e.promise }
                                );
                              }, 0)
                            : e.resolve(!1);
                      } else {
                        this.resetStateAndUrl(e.currentRouterState, e.currentUrlTree, e.rawUrl);
                        const s = new Ou(e.id, this.serializeUrl(e.extractedUrl), n);
                        t.next(s);
                        try {
                          e.resolve(this.errorHandler(n));
                        } catch (i) {
                          e.reject(i);
                        }
                      }
                      var r;
                      return jd;
                    })
                  );
                  var r, i, a, o;
                })
              );
            }
            resetRootComponentType(e) {
              (this.rootComponentType = e), (this.routerState.root.component = this.rootComponentType);
            }
            getTransition() {
              const e = this.transitions.value;
              return (e.urlAfterRedirects = this.browserUrlTree), e;
            }
            setTransition(e) {
              this.transitions.next(Object.assign(Object.assign({}, this.getTransition()), e));
            }
            initialNavigation() {
              this.setUpLocationChangeListener(),
                0 === this.navigationId && this.navigateByUrl(this.location.path(!0), { replaceUrl: !0 });
            }
            setUpLocationChangeListener() {
              this.locationSubscription ||
                (this.locationSubscription = this.location.subscribe((e) => {
                  const t = this.extractLocationChangeInfoFromEvent(e);
                  this.shouldScheduleNavigation(this.lastLocationChangeInfo, t) &&
                    setTimeout(() => {
                      const { source: e, state: n, urlTree: s } = t,
                        r = { replaceUrl: !0 };
                      if (n) {
                        const e = Object.assign({}, n);
                        delete e.navigationId, 0 !== Object.keys(e).length && (r.state = e);
                      }
                      this.scheduleNavigation(s, e, n, r);
                    }, 0),
                    (this.lastLocationChangeInfo = t);
                }));
            }
            extractLocationChangeInfoFromEvent(e) {
              var t;
              return {
                source: "popstate" === e.type ? "popstate" : "hashchange",
                urlTree: this.parseUrl(e.url),
                state: (null === (t = e.state) || void 0 === t ? void 0 : t.navigationId) ? e.state : null,
                transitionId: this.getTransition().id,
              };
            }
            shouldScheduleNavigation(e, t) {
              if (!e) return !0;
              const n = t.urlTree.toString() === e.urlTree.toString();
              return !(
                t.transitionId === e.transitionId &&
                n &&
                (("hashchange" === t.source && "popstate" === e.source) ||
                  ("popstate" === t.source && "hashchange" === e.source))
              );
            }
            get url() {
              return this.serializeUrl(this.currentUrlTree);
            }
            getCurrentNavigation() {
              return this.currentNavigation;
            }
            triggerEvent(e) {
              this.events.next(e);
            }
            resetConfig(e) {
              OM(e), (this.config = e.map(YM)), (this.navigated = !1), (this.lastSuccessfulId = -1);
            }
            ngOnDestroy() {
              this.dispose();
            }
            dispose() {
              this.locationSubscription &&
                (this.locationSubscription.unsubscribe(), (this.locationSubscription = void 0));
            }
            createUrlTree(e, t = {}) {
              const {
                relativeTo: n,
                queryParams: s,
                fragment: r,
                preserveQueryParams: i,
                queryParamsHandling: a,
                preserveFragment: o,
              } = t;
              fs() &&
                i &&
                console &&
                console.warn &&
                console.warn("preserveQueryParams is deprecated, use queryParamsHandling instead.");
              const c = n || this.routerState.root,
                l = o ? this.currentUrlTree.fragment : r;
              let d = null;
              if (a)
                switch (a) {
                  case "merge":
                    d = Object.assign(Object.assign({}, this.currentUrlTree.queryParams), s);
                    break;
                  case "preserve":
                    d = this.currentUrlTree.queryParams;
                    break;
                  default:
                    d = s || null;
                }
              else d = i ? this.currentUrlTree.queryParams : s || null;
              return (
                null !== d && (d = this.removeEmptyProps(d)),
                (function (e, t, n, s, r) {
                  if (0 === n.length) return Wh(t.root, t.root, t, s, r);
                  const i = (function (e) {
                    if ("string" == typeof e[0] && 1 === e.length && "/" === e[0]) return new qh(!0, 0, e);
                    let t = 0,
                      n = !1;
                    const s = e.reduce((e, s, r) => {
                      if ("object" == typeof s && null != s) {
                        if (s.outlets) {
                          const t = {};
                          return (
                            Gu(s.outlets, (e, n) => {
                              t[n] = "string" == typeof e ? e.split("/") : e;
                            }),
                            [...e, { outlets: t }]
                          );
                        }
                        if (s.segmentPath) return [...e, s.segmentPath];
                      }
                      return "string" != typeof s
                        ? [...e, s]
                        : 0 === r
                        ? (s.split("/").forEach((s, r) => {
                            (0 == r && "." === s) ||
                              (0 == r && "" === s ? (n = !0) : ".." === s ? t++ : "" != s && e.push(s));
                          }),
                          e)
                        : [...e, s];
                    }, []);
                    return new qh(n, t, s);
                  })(n);
                  if (i.toRoot()) return Wh(t.root, new Zu([], {}), t, s, r);
                  const a = (function (e, t, n) {
                      if (e.isAbsolute) return new xh(t.root, !0, 0);
                      if (-1 === n.snapshot._lastPathIndex) {
                        const e = n.snapshot._urlSegment;
                        return new xh(e, e === t.root, 0);
                      }
                      const s = Eh(e.commands[0]) ? 0 : 1;
                      return (function (e, t, n) {
                        let s = e,
                          r = t,
                          i = n;
                        for (; i > r; ) {
                          if (((i -= r), (s = s.parent), !s)) throw new Error("Invalid number of '../'");
                          r = s.segments.length;
                        }
                        return new xh(s, !1, r - i);
                      })(n.snapshot._urlSegment, n.snapshot._lastPathIndex + s, e.numberOfDoubleDots);
                    })(i, t, e),
                    o = a.processChildren
                      ? Hh(a.segmentGroup, a.index, i.commands)
                      : Bh(a.segmentGroup, a.index, i.commands);
                  return Wh(a.segmentGroup, o, t, s, r);
                })(c, this.currentUrlTree, e, d, l)
              );
            }
            navigateByUrl(e, t = { skipLocationChange: !1 }) {
              fs() &&
                this.isNgZoneEnabled &&
                !bc.isInAngularZone() &&
                this.console.warn("Navigation triggered outside Angular zone, did you forget to call 'ngZone.run()'?");
              const n = Jh(e) ? e : this.parseUrl(e),
                s = this.urlHandlingStrategy.merge(n, this.rawUrlTree);
              return this.scheduleNavigation(s, "imperative", null, t);
            }
            navigate(e, t = { skipLocationChange: !1 }) {
              return (
                (function (e) {
                  for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    if (null == n) throw new Error(`The requested path contains ${n} segment at index ${t}`);
                  }
                })(e),
                this.navigateByUrl(this.createUrlTree(e, t), t)
              );
            }
            serializeUrl(e) {
              return this.urlSerializer.serialize(e);
            }
            parseUrl(e) {
              let t;
              try {
                t = this.urlSerializer.parse(e);
              } catch (n) {
                t = this.malformedUriErrorHandler(n, this.urlSerializer, e);
              }
              return t;
            }
            isActive(e, t) {
              if (Jh(e)) return Ku(this.currentUrlTree, e, t);
              const n = this.parseUrl(e);
              return Ku(this.currentUrlTree, n, t);
            }
            removeEmptyProps(e) {
              return Object.keys(e).reduce((t, n) => {
                const s = e[n];
                return null != s && (t[n] = s), t;
              }, {});
            }
            processNavigations() {
              this.navigations.subscribe(
                (e) => {
                  (this.navigated = !0),
                    (this.lastSuccessfulId = e.id),
                    this.events.next(
                      new vu(e.id, this.serializeUrl(e.extractedUrl), this.serializeUrl(this.currentUrlTree))
                    ),
                    (this.lastSuccessfulNavigation = this.currentNavigation),
                    (this.currentNavigation = null),
                    e.resolve(!0);
                },
                (e) => {
                  this.console.warn("Unhandled Navigation Error: ");
                }
              );
            }
            scheduleNavigation(e, t, n, s, r) {
              const i = this.getTransition(),
                a = "imperative" !== t && "imperative" === (null == i ? void 0 : i.source),
                o =
                  (this.lastSuccessfulId === i.id || this.currentNavigation
                    ? i.rawUrl
                    : i.urlAfterRedirects
                  ).toString() === e.toString();
              if (a && o) return Promise.resolve(!0);
              let c, l, d;
              r
                ? ((c = r.resolve), (l = r.reject), (d = r.promise))
                : (d = new Promise((e, t) => {
                    (c = e), (l = t);
                  }));
              const u = ++this.navigationId;
              return (
                this.setTransition({
                  id: u,
                  source: t,
                  restoredState: n,
                  currentUrlTree: this.currentUrlTree,
                  currentRawUrl: this.rawUrlTree,
                  rawUrl: e,
                  extras: s,
                  resolve: c,
                  reject: l,
                  promise: d,
                  currentSnapshot: this.routerState.snapshot,
                  currentRouterState: this.routerState,
                }),
                d.catch((e) => Promise.reject(e))
              );
            }
            setBrowserUrl(e, t, n, s) {
              const r = this.urlSerializer.serialize(e);
              (s = s || {}),
                this.location.isCurrentPathEqualTo(r) || t
                  ? this.location.replaceState(r, "", Object.assign(Object.assign({}, s), { navigationId: n }))
                  : this.location.go(r, "", Object.assign(Object.assign({}, s), { navigationId: n }));
            }
            resetStateAndUrl(e, t, n) {
              (this.routerState = e),
                (this.currentUrlTree = t),
                (this.rawUrlTree = this.urlHandlingStrategy.merge(this.currentUrlTree, n)),
                this.resetUrlToCurrentUrlTree();
            }
            resetUrlToCurrentUrlTree() {
              this.location.replaceState(this.urlSerializer.serialize(this.rawUrlTree), "", {
                navigationId: this.lastSuccessfulId,
              });
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(ni), Ve(sh), Ve(WM), Ve(dl), Ve(fi), Ve(Hc), Ve(mc), Ve(void 0));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        PM = (() => {
          class e {
            constructor(e, t, n, s, r) {
              (this.parentContexts = e),
                (this.location = t),
                (this.resolver = n),
                (this.changeDetector = r),
                (this.activated = null),
                (this._activatedRoute = null),
                (this.activateEvents = new Co()),
                (this.deactivateEvents = new Co()),
                (this.name = s || "primary"),
                e.onChildOutletCreated(this.name, this);
            }
            ngOnDestroy() {
              this.parentContexts.onChildOutletDestroyed(this.name);
            }
            ngOnInit() {
              if (!this.activated) {
                const e = this.parentContexts.getContext(this.name);
                e &&
                  e.route &&
                  (e.attachRef ? this.attach(e.attachRef, e.route) : this.activateWith(e.route, e.resolver || null));
              }
            }
            get isActivated() {
              return !!this.activated;
            }
            get component() {
              if (!this.activated) throw new Error("Outlet is not activated");
              return this.activated.instance;
            }
            get activatedRoute() {
              if (!this.activated) throw new Error("Outlet is not activated");
              return this._activatedRoute;
            }
            get activatedRouteData() {
              return this._activatedRoute ? this._activatedRoute.snapshot.data : {};
            }
            detach() {
              if (!this.activated) throw new Error("Outlet is not activated");
              this.location.detach();
              const e = this.activated;
              return (this.activated = null), (this._activatedRoute = null), e;
            }
            attach(e, t) {
              (this.activated = e), (this._activatedRoute = t), this.location.insert(e.hostView);
            }
            deactivate() {
              if (this.activated) {
                const e = this.component;
                this.activated.destroy(),
                  (this.activated = null),
                  (this._activatedRoute = null),
                  this.deactivateEvents.emit(e);
              }
            }
            activateWith(e, t) {
              if (this.isActivated) throw new Error("Cannot activate an already activated outlet");
              this._activatedRoute = e;
              const n = (t = t || this.resolver).resolveComponentFactory(e._futureSnapshot.routeConfig.component),
                s = this.parentContexts.getOrCreateContext(this.name).children,
                r = new XM(e, s, this.location.injector);
              (this.activated = this.location.createComponent(n, this.location.length, r)),
                this.changeDetector.markForCheck(),
                this.activateEvents.emit(this.activated.instance);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(
                Hi(WM),
                Hi(mo),
                Hi(Pa),
                ("name",
                (function (e, t) {
                  const n = e.attrs;
                  if (n) {
                    const e = n.length;
                    let t = 0;
                    for (; t < e; ) {
                      const s = n[t];
                      if (Hn(s)) break;
                      if (0 === s) t += 2;
                      else if ("number" == typeof s) for (t++; t < e && "string" == typeof n[t]; ) t++;
                      else {
                        if ("name" === s) return n[t + 1];
                        t += 2;
                      }
                    }
                  }
                  return null;
                })(on())),
                Hi(ei)
              );
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [["router-outlet"]],
              outputs: { activateEvents: "activate", deactivateEvents: "deactivate" },
              exportAs: ["outlet"],
            })),
            e
          );
        })();
      class XM {
        constructor(e, t, n) {
          (this.route = e), (this.childContexts = t), (this.parent = n);
        }
        get(e, t) {
          return e === Th ? this.route : e === WM ? this.childContexts : this.parent.get(e, t);
        }
      }
      class RM {}
      class IM {
        preload(e, t) {
          return Yd(null);
        }
      }
      let FM = (() => {
          class e {
            constructor(e, t, n, s, r) {
              (this.router = e),
                (this.injector = s),
                (this.preloadingStrategy = r),
                (this.loader = new EM(
                  t,
                  n,
                  (t) => e.triggerEvent(new Cu(t)),
                  (t) => e.triggerEvent(new Wu(t))
                ));
            }
            setUpPreloading() {
              this.subscription = this.router.events
                .pipe(
                  Id((e) => e instanceof vu),
                  _u(() => this.preload())
                )
                .subscribe(() => {});
            }
            preload() {
              const e = this.injector.get(Qe);
              return this.processRoutes(e, this.router.config);
            }
            ngOnDestroy() {
              this.subscription && this.subscription.unsubscribe();
            }
            processRoutes(e, t) {
              const n = [];
              for (const s of t)
                if (s.loadChildren && !s.canLoad && s._loadedConfig) {
                  const e = s._loadedConfig;
                  n.push(this.processRoutes(e.module, e.routes));
                } else
                  s.loadChildren && !s.canLoad
                    ? n.push(this.preloadConfig(e, s))
                    : s.children && n.push(this.processRoutes(e, s.children));
              return q(n).pipe(
                R(),
                v((e) => {})
              );
            }
            preloadConfig(e, t) {
              return this.preloadingStrategy.preload(t, () =>
                this.loader
                  .load(e.injector, t)
                  .pipe(j((e) => ((t._loadedConfig = e), this.processRoutes(e.module, e.routes))))
              );
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(jM), Ve(Hc), Ve(mc), Ve(fi), Ve(RM));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        VM = (() => {
          class e {
            constructor(e, t, n = {}) {
              (this.router = e),
                (this.viewportScroller = t),
                (this.options = n),
                (this.lastId = 0),
                (this.lastSource = "imperative"),
                (this.restoredId = 0),
                (this.store = {}),
                (n.scrollPositionRestoration = n.scrollPositionRestoration || "disabled"),
                (n.anchorScrolling = n.anchorScrolling || "disabled");
            }
            init() {
              "disabled" !== this.options.scrollPositionRestoration &&
                this.viewportScroller.setHistoryScrollRestoration("manual"),
                (this.routerEventsSubscription = this.createScrollEvents()),
                (this.scrollEventsSubscription = this.consumeScrollEvents());
            }
            createScrollEvents() {
              return this.router.events.subscribe((e) => {
                e instanceof Tu
                  ? ((this.store[this.lastId] = this.viewportScroller.getScrollPosition()),
                    (this.lastSource = e.navigationTrigger),
                    (this.restoredId = e.restoredState ? e.restoredState.navigationId : 0))
                  : e instanceof vu &&
                    ((this.lastId = e.id),
                    this.scheduleScrollEvent(e, this.router.parseUrl(e.urlAfterRedirects).fragment));
              });
            }
            consumeScrollEvents() {
              return this.router.events.subscribe((e) => {
                e instanceof ju &&
                  (e.position
                    ? "top" === this.options.scrollPositionRestoration
                      ? this.viewportScroller.scrollToPosition([0, 0])
                      : "enabled" === this.options.scrollPositionRestoration &&
                        this.viewportScroller.scrollToPosition(e.position)
                    : e.anchor && "enabled" === this.options.anchorScrolling
                    ? this.viewportScroller.scrollToAnchor(e.anchor)
                    : "disabled" !== this.options.scrollPositionRestoration &&
                      this.viewportScroller.scrollToPosition([0, 0]));
              });
            }
            scheduleScrollEvent(e, t) {
              this.router.triggerEvent(
                new ju(e, "popstate" === this.lastSource ? this.store[this.restoredId] : null, t)
              );
            }
            ngOnDestroy() {
              this.routerEventsSubscription && this.routerEventsSubscription.unsubscribe(),
                this.scrollEventsSubscription && this.scrollEventsSubscription.unsubscribe();
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Ve(jM), Ve(ed), Ve(void 0));
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })();
      const UM = new qe("ROUTER_CONFIGURATION"),
        JM = new qe("ROUTER_FORROOT_GUARD"),
        GM = [
          dl,
          { provide: sh, useClass: rh },
          {
            provide: jM,
            useFactory: function (e, t, n, s, r, i, a, o = {}, c, l) {
              const d = new jM(null, e, t, n, s, r, i, Uu(a));
              if (
                (c && (d.urlHandlingStrategy = c),
                l && (d.routeReuseStrategy = l),
                o.errorHandler && (d.errorHandler = o.errorHandler),
                o.malformedUriErrorHandler && (d.malformedUriErrorHandler = o.malformedUriErrorHandler),
                o.enableTracing)
              ) {
                const e = Jc();
                d.events.subscribe((t) => {
                  e.logGroup("Router Event: " + t.constructor.name), e.log(t.toString()), e.log(t), e.logGroupEnd();
                });
              }
              return (
                o.onSameUrlNavigation && (d.onSameUrlNavigation = o.onSameUrlNavigation),
                o.paramsInheritanceStrategy && (d.paramsInheritanceStrategy = o.paramsInheritanceStrategy),
                o.urlUpdateStrategy && (d.urlUpdateStrategy = o.urlUpdateStrategy),
                o.relativeLinkResolution && (d.relativeLinkResolution = o.relativeLinkResolution),
                d
              );
            },
            deps: [sh, WM, dl, fi, Hc, mc, NM, UM, [class {}, new ne()], [class {}, new ne()]],
          },
          WM,
          {
            provide: Th,
            useFactory: function (e) {
              return e.routerState.root;
            },
            deps: [jM],
          },
          { provide: Hc, useClass: Xc },
          FM,
          IM,
          class {
            preload(e, t) {
              return t().pipe(Mu(() => Yd(null)));
            }
          },
          { provide: UM, useValue: { enableTracing: !1 } },
        ];
      function QM() {
        return new Nc("Router", jM);
      }
      let KM = (() => {
        class e {
          constructor(e, t) {}
          static forRoot(t, n) {
            return {
              ngModule: e,
              providers: [
                GM,
                tp(t),
                { provide: JM, useFactory: ep, deps: [[jM, new ne(), new re()]] },
                { provide: UM, useValue: n || {} },
                { provide: il, useFactory: ZM, deps: [Qc, [new te(ol), new ne()], UM] },
                { provide: VM, useFactory: $M, deps: [jM, ed, UM] },
                { provide: RM, useExisting: n && n.preloadingStrategy ? n.preloadingStrategy : IM },
                { provide: Nc, multi: !0, useFactory: QM },
                [
                  np,
                  { provide: Ko, multi: !0, useFactory: sp, deps: [np] },
                  { provide: ip, useFactory: rp, deps: [np] },
                  { provide: rc, multi: !0, useExisting: ip },
                ],
              ],
            };
          }
          static forChild(t) {
            return { ngModule: e, providers: [tp(t)] };
          }
        }
        return (
          (e.ɵmod = pt({ type: e })),
          (e.ɵinj = le({
            factory: function (t) {
              return new (t || e)(Ve(JM, 8), Ve(jM, 8));
            },
          })),
          e
        );
      })();
      function $M(e, t, n) {
        return n.scrollOffset && t.setOffset(n.scrollOffset), new VM(e, t, n);
      }
      function ZM(e, t, n = {}) {
        return n.useHash ? new ll(e, t) : new cl(e, t);
      }
      function ep(e) {
        if (e)
          throw new Error(
            "RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead."
          );
        return "guarded";
      }
      function tp(e) {
        return [
          { provide: bi, multi: !0, useValue: e },
          { provide: NM, multi: !0, useValue: e },
        ];
      }
      let np = (() => {
        class e {
          constructor(e) {
            (this.injector = e), (this.initNavigation = !1), (this.resultOfPreactivationDone = new w());
          }
          appInitializer() {
            return this.injector.get($c, Promise.resolve(null)).then(() => {
              let e = null;
              const t = new Promise((t) => (e = t)),
                n = this.injector.get(jM),
                s = this.injector.get(UM);
              if (this.isLegacyDisabled(s) || this.isLegacyEnabled(s)) e(!0);
              else if ("disabled" === s.initialNavigation) n.setUpLocationChangeListener(), e(!0);
              else {
                if ("enabled" !== s.initialNavigation)
                  throw new Error(`Invalid initialNavigation options: '${s.initialNavigation}'`);
                (n.hooks.afterPreactivation = () =>
                  this.initNavigation ? Yd(null) : ((this.initNavigation = !0), e(!0), this.resultOfPreactivationDone)),
                  n.initialNavigation();
              }
              return t;
            });
          }
          bootstrapListener(e) {
            const t = this.injector.get(UM),
              n = this.injector.get(FM),
              s = this.injector.get(VM),
              r = this.injector.get(jM),
              i = this.injector.get(xc);
            e === i.components[0] &&
              (this.isLegacyEnabled(t)
                ? r.initialNavigation()
                : this.isLegacyDisabled(t) && r.setUpLocationChangeListener(),
              n.setUpPreloading(),
              s.init(),
              r.resetRootComponentType(i.componentTypes[0]),
              this.resultOfPreactivationDone.next(null),
              this.resultOfPreactivationDone.complete());
          }
          isLegacyEnabled(e) {
            return (
              "legacy_enabled" === e.initialNavigation || !0 === e.initialNavigation || void 0 === e.initialNavigation
            );
          }
          isLegacyDisabled(e) {
            return "legacy_disabled" === e.initialNavigation || !1 === e.initialNavigation;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(fi));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      function sp(e) {
        return e.appInitializer.bind(e);
      }
      function rp(e) {
        return e.bootstrapListener.bind(e);
      }
      const ip = new qe("Router Initializer"),
        ap = [];
      let op = (() => {
        class e {}
        return (
          (e.ɵmod = pt({ type: e })),
          (e.ɵinj = le({
            factory: function (t) {
              return new (t || e)();
            },
            imports: [[KM.forRoot(ap)], KM],
          })),
          e
        );
      })();
      class cp extends u {
        constructor(e, t) {
          super();
        }
        schedule(e, t = 0) {
          return this;
        }
      }
      class lp extends cp {
        constructor(e, t) {
          super(e, t), (this.scheduler = e), (this.work = t), (this.pending = !1);
        }
        schedule(e, t = 0) {
          if (this.closed) return this;
          this.state = e;
          const n = this.id,
            s = this.scheduler;
          return (
            null != n && (this.id = this.recycleAsyncId(s, n, t)),
            (this.pending = !0),
            (this.delay = t),
            (this.id = this.id || this.requestAsyncId(s, this.id, t)),
            this
          );
        }
        requestAsyncId(e, t, n = 0) {
          return setInterval(e.flush.bind(e, this), n);
        }
        recycleAsyncId(e, t, n = 0) {
          if (null !== n && this.delay === n && !1 === this.pending) return t;
          clearInterval(t);
        }
        execute(e, t) {
          if (this.closed) return new Error("executing a cancelled action");
          this.pending = !1;
          const n = this._execute(e, t);
          if (n) return n;
          !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
        }
        _execute(e, t) {
          let n = !1,
            s = void 0;
          try {
            this.work(e);
          } catch (r) {
            (n = !0), (s = (!!r && r) || new Error(r));
          }
          if (n) return this.unsubscribe(), s;
        }
        _unsubscribe() {
          const e = this.id,
            t = this.scheduler,
            n = t.actions,
            s = n.indexOf(this);
          (this.work = null),
            (this.state = null),
            (this.pending = !1),
            (this.scheduler = null),
            -1 !== s && n.splice(s, 1),
            null != e && (this.id = this.recycleAsyncId(t, e, null)),
            (this.delay = null);
        }
      }
      class dp extends lp {
        constructor(e, t) {
          super(e, t), (this.scheduler = e), (this.work = t);
        }
        schedule(e, t = 0) {
          return t > 0 ? super.schedule(e, t) : ((this.delay = t), (this.state = e), this.scheduler.flush(this), this);
        }
        execute(e, t) {
          return t > 0 || this.closed ? super.execute(e, t) : this._execute(e, t);
        }
        requestAsyncId(e, t, n = 0) {
          return (null !== n && n > 0) || (null === n && this.delay > 0)
            ? super.requestAsyncId(e, t, n)
            : e.flush(this);
        }
      }
      let up = (() => {
        class e {
          constructor(t, n = e.now) {
            (this.SchedulerAction = t), (this.now = n);
          }
          schedule(e, t = 0, n) {
            return new this.SchedulerAction(this, e).schedule(n, t);
          }
        }
        return (e.now = () => Date.now()), e;
      })();
      class hp extends up {
        constructor(e, t = up.now) {
          super(e, () => (hp.delegate && hp.delegate !== this ? hp.delegate.now() : t())),
            (this.actions = []),
            (this.active = !1),
            (this.scheduled = void 0);
        }
        schedule(e, t = 0, n) {
          return hp.delegate && hp.delegate !== this ? hp.delegate.schedule(e, t, n) : super.schedule(e, t, n);
        }
        flush(e) {
          const { actions: t } = this;
          if (this.active) return void t.push(e);
          let n;
          this.active = !0;
          do {
            if ((n = e.execute(e.state, e.delay))) break;
          } while ((e = t.shift()));
          if (((this.active = !1), n)) {
            for (; (e = t.shift()); ) e.unsubscribe();
            throw n;
          }
        }
      }
      class Mp extends hp {}
      const pp = new Mp(dp);
      let mp = (() => {
        class e {
          constructor(e, t, n) {
            (this.kind = e), (this.value = t), (this.error = n), (this.hasValue = "N" === e);
          }
          observe(e) {
            switch (this.kind) {
              case "N":
                return e.next && e.next(this.value);
              case "E":
                return e.error && e.error(this.error);
              case "C":
                return e.complete && e.complete();
            }
          }
          do(e, t, n) {
            switch (this.kind) {
              case "N":
                return e && e(this.value);
              case "E":
                return t && t(this.error);
              case "C":
                return n && n();
            }
          }
          accept(e, t, n) {
            return e && "function" == typeof e.next ? this.observe(e) : this.do(e, t, n);
          }
          toObservable() {
            switch (this.kind) {
              case "N":
                return Yd(this.value);
              case "E":
                return (e = this.error), new b((t) => t.error(e));
              case "C":
                return Pd();
            }
            var e;
            throw new Error("unexpected notification kind value");
          }
          static createNext(t) {
            return void 0 !== t ? new e("N", t) : e.undefinedValueNotification;
          }
          static createError(t) {
            return new e("E", void 0, t);
          }
          static createComplete() {
            return e.completeNotification;
          }
        }
        return (e.completeNotification = new e("C")), (e.undefinedValueNotification = new e("N", void 0)), e;
      })();
      class _p extends p {
        constructor(e, t, n = 0) {
          super(e), (this.scheduler = t), (this.delay = n);
        }
        static dispatch(e) {
          const { notification: t, destination: n } = e;
          t.observe(n), this.unsubscribe();
        }
        scheduleMessage(e) {
          this.destination.add(this.scheduler.schedule(_p.dispatch, this.delay, new fp(e, this.destination)));
        }
        _next(e) {
          this.scheduleMessage(mp.createNext(e));
        }
        _error(e) {
          this.scheduleMessage(mp.createError(e)), this.unsubscribe();
        }
        _complete() {
          this.scheduleMessage(mp.createComplete()), this.unsubscribe();
        }
      }
      class fp {
        constructor(e, t) {
          (this.notification = e), (this.destination = t);
        }
      }
      class bp extends w {
        constructor(e = Number.POSITIVE_INFINITY, t = Number.POSITIVE_INFINITY, n) {
          super(),
            (this.scheduler = n),
            (this._events = []),
            (this._infiniteTimeWindow = !1),
            (this._bufferSize = e < 1 ? 1 : e),
            (this._windowTime = t < 1 ? 1 : t),
            t === Number.POSITIVE_INFINITY
              ? ((this._infiniteTimeWindow = !0), (this.next = this.nextInfiniteTimeWindow))
              : (this.next = this.nextTimeWindow);
        }
        nextInfiniteTimeWindow(e) {
          if (!this.isStopped) {
            const t = this._events;
            t.push(e), t.length > this._bufferSize && t.shift();
          }
          super.next(e);
        }
        nextTimeWindow(e) {
          this.isStopped || (this._events.push(new gp(this._getNow(), e)), this._trimBufferThenGetEvents()),
            super.next(e);
        }
        _subscribe(e) {
          const t = this._infiniteTimeWindow,
            n = t ? this._events : this._trimBufferThenGetEvents(),
            s = this.scheduler,
            r = n.length;
          let i;
          if (this.closed) throw new y();
          if (
            (this.isStopped || this.hasError ? (i = u.EMPTY) : (this.observers.push(e), (i = new L(this, e))),
            s && e.add((e = new _p(e, s))),
            t)
          )
            for (let a = 0; a < r && !e.closed; a++) e.next(n[a]);
          else for (let a = 0; a < r && !e.closed; a++) e.next(n[a].value);
          return this.hasError ? e.error(this.thrownError) : this.isStopped && e.complete(), i;
        }
        _getNow() {
          return (this.scheduler || pp).now();
        }
        _trimBufferThenGetEvents() {
          const e = this._getNow(),
            t = this._bufferSize,
            n = this._windowTime,
            s = this._events,
            r = s.length;
          let i = 0;
          for (; i < r && !(e - s[i].time < n); ) i++;
          return r > t && (i = Math.max(i, r - t)), i > 0 && s.splice(0, i), s;
        }
      }
      class gp {
        constructor(e, t) {
          (this.time = e), (this.value = t);
        }
      }
      const yp = {
        schedule(e, t) {
          const n = setTimeout(e, t);
          return () => clearTimeout(n);
        },
        scheduleBeforeRender(e) {
          if ("undefined" == typeof window) return yp.schedule(e, 0);
          if (void 0 === window.requestAnimationFrame) return yp.schedule(e, 16);
          const t = window.requestAnimationFrame(e);
          return () => window.cancelAnimationFrame(t);
        },
      };
      let Lp;
      function Ap(e, t, n) {
        let s = n;
        return (
          (function (e) {
            return !!e && e.nodeType === Node.ELEMENT_NODE;
          })(e) &&
            t.some(
              (t, n) =>
                !(
                  "*" === t ||
                  !(function (e, t) {
                    if (!Lp) {
                      const e = Element.prototype;
                      Lp =
                        e.matches ||
                        e.matchesSelector ||
                        e.mozMatchesSelector ||
                        e.msMatchesSelector ||
                        e.oMatchesSelector ||
                        e.webkitMatchesSelector;
                    }
                    return e.nodeType === Node.ELEMENT_NODE && Lp.call(e, t);
                  })(e, t) ||
                  ((s = n), 0)
                )
            ),
          s
        );
      }
      class wp {
        constructor(e, t) {
          this.componentFactory = t.get(Pa).resolveComponentFactory(e);
        }
        create(e) {
          return new zp(this.componentFactory, e);
        }
      }
      class zp {
        constructor(e, t) {
          (this.componentFactory = e),
            (this.injector = t),
            (this.eventEmitters = new bp(1)),
            (this.events = this.eventEmitters.pipe(ru((e) => F(...e)))),
            (this.componentRef = null),
            (this.inputChanges = null),
            (this.implementsOnChanges = !1),
            (this.scheduledChangeDetectionFn = null),
            (this.scheduledDestroyFn = null),
            (this.initialInputValues = new Map()),
            (this.unchangedInputs = new Set()),
            (this.ngZone = this.injector.get(bc)),
            (this.elementZone = "undefined" == typeof Zone ? null : this.ngZone.run(() => Zone.current));
        }
        connect(e) {
          this.runInZone(() => {
            if (null !== this.scheduledDestroyFn)
              return this.scheduledDestroyFn(), void (this.scheduledDestroyFn = null);
            null === this.componentRef && this.initializeComponent(e);
          });
        }
        disconnect() {
          this.runInZone(() => {
            null !== this.componentRef &&
              null === this.scheduledDestroyFn &&
              (this.scheduledDestroyFn = yp.schedule(() => {
                null !== this.componentRef && (this.componentRef.destroy(), (this.componentRef = null));
              }, 10));
          });
        }
        getInputValue(e) {
          return this.runInZone(() =>
            null === this.componentRef ? this.initialInputValues.get(e) : this.componentRef.instance[e]
          );
        }
        setInputValue(e, t) {
          this.runInZone(() => {
            var n, s;
            null !== this.componentRef
              ? (((n = t) !== (s = this.getInputValue(e)) && (n == n || s == s)) ||
                  (void 0 === t && this.unchangedInputs.has(e))) &&
                (this.recordInputChange(e, t), (this.componentRef.instance[e] = t), this.scheduleDetectChanges())
              : this.initialInputValues.set(e, t);
          });
        }
        initializeComponent(e) {
          const t = fi.create({ providers: [], parent: this.injector }),
            n = (function (e, t) {
              const n = e.childNodes,
                s = t.map(() => []);
              let r = -1;
              t.some((e, t) => "*" === e && ((r = t), !0));
              for (let i = 0, a = n.length; i < a; ++i) {
                const e = n[i],
                  a = Ap(e, t, r);
                -1 !== a && s[a].push(e);
              }
              return s;
            })(e, this.componentFactory.ngContentSelectors);
          (this.componentRef = this.componentFactory.create(t, n, e)),
            (this.implementsOnChanges = "function" == typeof this.componentRef.instance.ngOnChanges),
            this.initializeInputs(),
            this.initializeOutputs(this.componentRef),
            this.detectChanges(),
            this.injector.get(xc).attachView(this.componentRef.hostView);
        }
        initializeInputs() {
          this.componentFactory.inputs.forEach(({ propName: e }) => {
            this.implementsOnChanges && this.unchangedInputs.add(e),
              this.initialInputValues.has(e) && this.setInputValue(e, this.initialInputValues.get(e));
          }),
            this.initialInputValues.clear();
        }
        initializeOutputs(e) {
          const t = this.componentFactory.outputs.map(({ propName: t, templateName: n }) =>
            e.instance[t].pipe(v((e) => ({ name: n, value: e })))
          );
          this.eventEmitters.next(t);
        }
        callNgOnChanges(e) {
          if (!this.implementsOnChanges || null === this.inputChanges) return;
          const t = this.inputChanges;
          (this.inputChanges = null), e.instance.ngOnChanges(t);
        }
        scheduleDetectChanges() {
          this.scheduledChangeDetectionFn ||
            (this.scheduledChangeDetectionFn = yp.scheduleBeforeRender(() => {
              (this.scheduledChangeDetectionFn = null), this.detectChanges();
            }));
        }
        recordInputChange(e, t) {
          if (null !== this.componentRef && !this.implementsOnChanges) return;
          null === this.inputChanges && (this.inputChanges = {});
          const n = this.inputChanges[e];
          if (n) return void (n.currentValue = t);
          const s = this.unchangedInputs.has(e);
          this.unchangedInputs.delete(e);
          const r = s ? void 0 : this.getInputValue(e);
          this.inputChanges[e] = new Ct(r, t, s);
        }
        detectChanges() {
          null !== this.componentRef &&
            (this.callNgOnChanges(this.componentRef), this.componentRef.changeDetectorRef.detectChanges());
        }
        runInZone(e) {
          return this.elementZone && Zone.current !== this.elementZone ? this.ngZone.run(e) : e();
        }
      }
      class Tp extends HTMLElement {
        constructor() {
          super(...arguments), (this.ngElementEventsSubscription = null);
        }
      }
      function vp(e, t) {
        const n = (function (e, t) {
            return t.get(Pa).resolveComponentFactory(e).inputs;
          })(e, t.injector),
          s = t.strategyFactory || new wp(e, t.injector),
          r = (function (e) {
            const t = {};
            return (
              e.forEach(({ propName: e, templateName: n }) => {
                var s;
                t[((s = n), s.replace(/[A-Z]/g, (e) => "-" + e.toLowerCase()))] = e;
              }),
              t
            );
          })(n);
        class i extends Tp {
          constructor(e) {
            super(), (this.injector = e);
          }
          get ngElementStrategy() {
            if (!this._ngElementStrategy) {
              const e = (this._ngElementStrategy = s.create(this.injector || t.injector)),
                r = n.filter(({ propName: e }) => this.hasOwnProperty(e)).map(({ propName: e }) => [e, this[e]]);
              this instanceof i ? r.forEach(([e]) => delete this[e]) : Dp(n, this),
                r.forEach(([t, n]) => e.setInputValue(t, n));
            }
            return this._ngElementStrategy;
          }
          attributeChangedCallback(e, t, n, s) {
            this.ngElementStrategy.setInputValue(r[e], n);
          }
          connectedCallback() {
            let e = !1;
            this.ngElementStrategy.events && (this.subscribeToEvents(), (e = !0)),
              this.ngElementStrategy.connect(this),
              e || this.subscribeToEvents();
          }
          disconnectedCallback() {
            this._ngElementStrategy && this._ngElementStrategy.disconnect(),
              this.ngElementEventsSubscription &&
                (this.ngElementEventsSubscription.unsubscribe(), (this.ngElementEventsSubscription = null));
          }
          subscribeToEvents() {
            this.ngElementEventsSubscription = this.ngElementStrategy.events.subscribe((e) => {
              const t = (function (e, t, n) {
                if ("function" != typeof CustomEvent) {
                  const s = e.createEvent("CustomEvent");
                  return s.initCustomEvent(t, !1, !1, n), s;
                }
                return new CustomEvent(t, { bubbles: !1, cancelable: !1, detail: n });
              })(this.ownerDocument, e.name, e.value);
              this.dispatchEvent(t);
            });
          }
        }
        return (
          (i.observedAttributes = Object.keys(r)),
          Object.defineProperty(i.prototype, "ngElementStrategy", { enumerable: !0 }),
          Dp(n, i.prototype),
          i
        );
      }
      function Dp(e, t) {
        e.forEach(({ propName: e }) => {
          Object.defineProperty(t, e, {
            get() {
              return this.ngElementStrategy.getInputValue(e);
            },
            set(t) {
              this.ngElementStrategy.setInputValue(e, t);
            },
            configurable: !0,
            enumerable: !0,
          });
        });
      }
      let Op = (() => {
        class e {
          static isValidDate(e) {
            try {
              e && e.replace && (e = e.replace("Z", ""));
              const t = Date.parse(e);
              return !isNaN(t);
            } catch (t) {
              return !1;
            }
          }
          static getFormattedDate(e) {
            let t = "";
            try {
              if (e) {
                const n = e.substring(0, 10).split("-");
                t = this.getMonthName(parseInt(n[1])) + " " + n[2] + " " + n[0];
              }
            } catch (n) {}
            return t;
          }
          static getFormattedTime(e) {
            let t = "";
            try {
              if (e) {
                const n = e.substring(11, 16).split(":");
                t = this.getFormattedHours(parseInt(n[0])) + ":" + n[1] + " " + this.getAmpm(parseInt(n[0]));
              }
            } catch (n) {}
            return t;
          }
          static compareTwoDates(e, t) {
            try {
              const n = e.substring(0, 10),
                s = t.substring(0, 10),
                r = new Date(n),
                i = new Date(s);
              return r.setHours(0, 0, 0, 0), i.setHours(0, 0, 0, 0), r.getTime() === i.getTime();
            } catch (n) {
              return !1;
            }
          }
          static getTimezoneString(e) {
            try {
              return e.substring(e.length - 4, e.length).trim();
            } catch (t) {
              return "";
            }
          }
          static getMinutesFromSeconds(e) {
            let t = 0;
            try {
              t = Math.round(e / 60);
            } catch (n) {}
            return t;
          }
          static getMinutesFromSecondsWithMinSuffix(e) {
            try {
              let t = "";
              const n = parseInt(e);
              return n >= 60 ? ((t = this.getMinutesFromSeconds(n) + " min"), (e = t)) : (e = "0 min"), e;
            } catch (t) {
              return "0 min";
            }
          }
          static getMonthNumber(e) {
            let t = "";
            try {
              switch (e.toLowerCase()) {
                case "jan":
                  t = "01";
                  break;
                case "feb":
                  t = "02";
                  break;
                case "mar":
                  t = "03";
                  break;
                case "apr":
                  t = "04";
                  break;
                case "may":
                  t = "05";
                  break;
                case "jun":
                  t = "06";
                  break;
                case "jul":
                  t = "07";
                  break;
                case "aug":
                  t = "08";
                  break;
                case "sep":
                  t = "09";
                  break;
                case "oct":
                  t = "10";
                  break;
                case "nov":
                  t = "11";
                  break;
                case "dec":
                  t = "12";
              }
            } catch (n) {}
            return t;
          }
          static getTwoDigitYear(e) {
            let t = "";
            try {
              (t = e.toString()), t.length > 2 && (t = t.substring(2, 4));
            } catch (n) {}
            return t;
          }
          static getFullMonthName(e) {
            let t;
            try {
              switch (e.toLowerCase()) {
                case "jan":
                  t = "January";
                  break;
                case "feb":
                  t = "February";
                  break;
                case "mar":
                  t = "March";
                  break;
                case "apr":
                  t = "April";
                  break;
                case "may":
                  t = "May";
                  break;
                case "jun":
                  t = "June";
                  break;
                case "jul":
                  t = "July";
                  break;
                case "aug":
                  t = "August";
                  break;
                case "sep":
                  t = "September";
                  break;
                case "oct":
                  t = "October";
                  break;
                case "nov":
                  t = "November";
                  break;
                case "dec":
                  t = "December";
              }
            } catch (n) {}
            return t;
          }
          static getFullDayName(e) {
            let t;
            try {
              switch (e.toLowerCase()) {
                case "mon":
                  t = "Monday";
                  break;
                case "tue":
                  t = "Tuesday";
                  break;
                case "wed":
                  t = "Wednesday";
                  break;
                case "thu":
                  t = "Thursday";
                  break;
                case "fri":
                  t = "Friday";
                  break;
                case "sat":
                  t = "Saturday";
                  break;
                case "sun":
                  t = "Sunday";
              }
            } catch (n) {}
            return t;
          }
          static getDateWithoutLeadingZero(e) {
            try {
              return parseInt(e);
            } catch (t) {
              return 0;
            }
          }
          static getAmpm(e) {
            let t = "AM";
            return e >= 12 && (t = "PM"), t;
          }
          static getFormattedHours(e) {
            let t = "";
            try {
              e >= 12
                ? ((t = (e = (e %= 12) || 12).toString()), e < 10 && (t = "0" + e))
                : (0 === e && (e = 12), (t = e < 10 ? "0" + e : e.toString()));
            } catch ({}) {}
            return t;
          }
          static getMonthName(e) {
            let t = "";
            try {
              switch (e) {
                case 1:
                  t = "Jan";
                  break;
                case 2:
                  t = "Feb";
                  break;
                case 3:
                  t = "Mar";
                  break;
                case 4:
                  t = "Apr";
                  break;
                case 5:
                  t = "May";
                  break;
                case 6:
                  t = "Jun";
                  break;
                case 7:
                  t = "Jul";
                  break;
                case 8:
                  t = "Aug";
                  break;
                case 9:
                  t = "Sep";
                  break;
                case 10:
                  t = "Oct";
                  break;
                case 11:
                  t = "Nov";
                  break;
                case 12:
                  t = "Dec";
              }
            } catch (n) {}
            return t;
          }
          static getTimeZoneConvertedDateTime(e, t) {
            let n = new Date().toLocaleString();
            try {
              e = e.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "");
              const s = Date.parse(e);
              if (e && this.isValidDate(e) && t && Number(t) && !isNaN(s)) {
                const s = new Date(e),
                  r = s.getTime() + 6e4 * s.getTimezoneOffset();
                new Date(r + 36e5 * t), (n = new $l("en-US").transform(s, "M/D/YYYY, h:mm:ss A"));
              }
            } catch (s) {
            } finally {
              n = n.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "");
            }
            return n;
          }
          static getCustomFormattedDateTime(e, t, n) {
            let s = new Date().toLocaleString();
            try {
              let r = e;
              e && e.indexOf("+") > 0
                ? (r = e.slice(0, e.lastIndexOf("+")))
                : e && e.indexOf("-") > 0 && (r = e.slice(0, e.split("-", 3).join("-").length)),
                (e = r.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "")) &&
                  this.isValidDate(e) &&
                  t &&
                  (e && -1 === e.toUpperCase().indexOf("Z") && (e += " Z"), (s = new $l("en-US").transform(e, n, t)));
            } catch (r) {
            } finally {
              s = s.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "");
            }
            return s;
          }
          static isDstObserved(e) {
            return e.getTimezoneOffset() < this.stdTimezoneOffset(e);
          }
          static stdTimezoneOffset(e) {
            const t = new Date(e, 0, 1),
              n = new Date(e, 6, 1);
            return Math.max(t.getTimezoneOffset(), n.getTimezoneOffset());
          }
          static getCustomFormattedDate(e, t, n, s) {
            let r = new Date().toLocaleString();
            try {
              let i = e;
              e && e.indexOf("+") > 0
                ? (i = e.slice(0, e.lastIndexOf("+")))
                : e && e.indexOf("-") > 0 && (i = e.slice(0, e.split("-", 3).join("-").length)),
                (e = i.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, ""));
              const a = Date.parse(e);
              if (e && this.isValidDate(e) && t && Number(t) && !isNaN(a)) {
                const i = new Date(e),
                  a = this.isDstObserved(i);
                let o = n;
                a && n.indexOf("S") > 0 && ((o = o.replace("S", "D")), (t += 1));
                const c = i.getTime() + 6e4 * i.getTimezoneOffset(),
                  l = new Date(c + 36e5 * t);
                let d = s;
                s.indexOf("z") > 0 && (d = d.replace("z", "")),
                  (r = new $l("en-US").transform(l, d)),
                  s.indexOf("z") > 0 && (r += o);
              }
            } catch (i) {
            } finally {
              r = r.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "");
            }
            return r;
          }
          static getToLocaleDateString(e) {
            let t = new Date().toLocaleString();
            try {
              (e = e.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "")) &&
              e.indexOf("+") > 0
                ? (e = e.slice(0, e.lastIndexOf("+")))
                : e && e.indexOf("-") > 0 && (e = e.slice(0, e.lastIndexOf("-")));
              const n = Date.parse(e);
              if (e && this.isValidDate(e) && !isNaN(n)) {
                const n = new Date(e);
                t = new $l("en-US").transform(n, "M/D/YYYY, h:mm:ss A");
              }
            } catch (n) {
            } finally {
              t = t.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "");
            }
            return t;
          }
        }
        return (e.DEFAULT_TIMEZONE_OFFSET = -4), e;
      })();
      var Sp = (function (e) {
        return (
          (e[
            (e.DEFAULT_DATE_MASK = [
              /[a-zA-Z]/,
              /[a-zA-Z]/,
              /[a-zA-Z]/,
              " ",
              /[a-zA-Z]/,
              /[a-zA-Z]/,
              /[a-zA-Z]/,
              " ",
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ])
          ] = "DEFAULT_DATE_MASK"),
          (e[(e.DEFAULT_DATE_FORMAT = "ddd mmm dd yyyy")] = "DEFAULT_DATE_FORMAT"),
          (e[(e.SHORT_DATE_MASK = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/])] = "SHORT_DATE_MASK"),
          (e[(e.SHORT_DATE_FORMAT = "m/d/yy")] = "SHORT_DATE_FORMAT"),
          (e[
            (e.MEDIUM_DATE_MASK = [
              /[a-zA-Z]/,
              /[a-zA-Z]/,
              /[a-zA-Z]/,
              " ",
              /\d/,
              /\d/,
              ",",
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ])
          ] = "MEDIUM_DATE_MASK"),
          (e[(e.MEDIUM_DATE_FORMAT = "mmm d, yyyy")] = "MEDIUM_DATE_FORMAT"),
          (e[(e.LONG_DATE_FORMAT = "mmmm d, yyyy")] = "LONG_DATE_FORMAT"),
          (e[(e.FULL_DATE_FORMAT = "dddd, mmmm d, yyyy")] = "FULL_DATE_FORMAT"),
          (e[(e.CUSTOM_DATE_FORMAT = "day, month, year : hh:mm")] = "CUSTOM_DATE_FORMAT"),
          (e[(e.STANDARD_DATE_MASK = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/])] =
            "STANDARD_DATE_MASK"),
          (e[(e.STANDARD_DATE_FORMAT = "mm/dd/yyyy")] = "STANDARD_DATE_FORMAT"),
          (e[(e.ISO_DATE_MASK = [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/])] = "ISO_DATE_MASK"),
          (e[(e.ISO_DATE_FORMAT = "yyyy-mm-dd")] = "ISO_DATE_FORMAT"),
          e
        );
      })({});
      const kp = {
        firstDayOfWeek: 0,
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
        monthNames: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      };
      var Yp = (function (e) {
        return (e.TWENTY_FOUR = "24"), (e.TWELVE = "12"), e;
      })({});
      let Np = (() => {
        class e {
          isSelectable(e, t, n, s, r, i, a) {
            let o = !0,
              c = !0,
              l = !0,
              d = !0;
            return (
              (r = new Date(r)),
              s &&
                (s.getFullYear() > n ||
                  (s.getFullYear() === n && (s.getMonth() > t || (s.getMonth() === t && s.getDate() > e)))) &&
                (o = !1),
              r &&
                (r.getFullYear() < n ||
                  (r.getFullYear() === n && (r.getMonth() < t || (r.getMonth() === t && r.getDate() < e)))) &&
                (c = !1),
              a && (l = !this.isDateDisabled(e, t, n, a)),
              i && (d = !this.isDayDisabled(e, t, n, i)),
              o && c && l && d
            );
          }
          isDateDisabled(e, t, n, s) {
            if (s) for (const r of s) if (r.getFullYear() === n && r.getMonth() === t && r.getDate() === e) return !0;
            return !1;
          }
          isDayDisabled(e, t, n, s) {
            if (s) {
              const r = new Date(n, t, e).getDay();
              return -1 !== s.indexOf(r);
            }
            return !1;
          }
          getDaysCountInMonth(e, t) {
            return 32 - this.daylightSavingAdjust(new Date(t, e, 32)).getDate();
          }
          getDaysCountInPrevMonth(e, t) {
            const n = this.getPreviousMonthAndYear(e, t);
            return this.getDaysCountInMonth(n.month, n.year);
          }
          getPreviousMonthAndYear(e, t) {
            let n, s;
            return 0 === e ? ((n = 11), (s = t - 1)) : ((n = e - 1), (s = t)), { month: n, year: s };
          }
          createMonth(e, t, n, s, r, i) {
            const a = [],
              o = this.getFirstDayOfMonthIndex(e, t),
              c = this.getDaysCountInMonth(e, t),
              l = this.getDaysCountInPrevMonth(e, t);
            this.getSundayIndex();
            let d = 1;
            const u = new Date();
            for (let h = 0; h < 6; h++) {
              const M = [];
              if (0 === h) {
                for (let c = l - o + 1; c <= l; c++) {
                  const a = this.getPreviousMonthAndYear(e, t);
                  M.push({
                    day: c,
                    month: a.month,
                    year: a.year,
                    otherMonth: !0,
                    today: this.isToday(u, c, a.month, a.year),
                    selectable: this.isSelectable(c, a.month, a.year, n, s, r, i),
                  });
                }
                const a = 7 - M.length;
                for (let o = 0; o < a; o++)
                  M.push({
                    day: d,
                    month: e,
                    year: t,
                    today: this.isToday(u, d, e, t),
                    selectable: this.isSelectable(d, e, t, n, s, r, i),
                  }),
                    d++;
              } else
                for (let a = 0; a < 7; a++) {
                  if (d > c) {
                    const a = this.getNextMonthAndYear(e, t);
                    M.push({
                      day: d - c,
                      month: a.month,
                      year: a.year,
                      otherMonth: !0,
                      today: this.isToday(u, d - c, a.month, a.year),
                      selectable: this.isSelectable(d - c, a.month, a.year, n, s, r, i),
                    });
                  } else
                    M.push({
                      day: d,
                      month: e,
                      year: t,
                      today: this.isToday(u, d, e, t),
                      selectable: this.isSelectable(d, e, t, n, s, r, i),
                    });
                  d++;
                }
              a.push(M);
            }
            return a;
          }
          getSundayIndex() {
            return kp.firstDayOfWeek > 0 ? 7 - kp.firstDayOfWeek : 0;
          }
          getFirstDayOfMonthIndex(e, t) {
            const n = new Date();
            n.setDate(1), n.setMonth(e), n.setFullYear(t);
            const s = n.getDay() + this.getSundayIndex();
            return s >= 7 ? s - 7 : s;
          }
          isToday(e, t, n, s) {
            return e.getDate() === t && e.getMonth() === n && e.getFullYear() === s;
          }
          getNextMonthAndYear(e, t) {
            let n, s;
            return 11 === e ? ((n = 0), (s = t + 1)) : ((n = e + 1), (s = t)), { month: n, year: s };
          }
          formatTime(e, t, n) {
            if (!e) return "";
            let s = "",
              r = e.getHours();
            const i = e.getMinutes(),
              a = e.getSeconds();
            return (
              "12" === t && r > 11 && 12 !== r && (r -= 12),
              (s += r < 10 ? "0" + r : r),
              (s += ":"),
              (s += i < 10 ? "0" + i : i),
              n && ((s += ":"), (s += a < 10 ? "0" + a : a)),
              "12" === t && (s += r > 11 ? " PM" : " AM"),
              s
            );
          }
          parseTime(e, t, n, s) {
            const r = e.split(":");
            let i = parseInt(r[0]);
            const a = parseInt(r[1]),
              o = n ? parseInt(r[2]) : null;
            if (!(isNaN(i) || isNaN(a) || i > 23 || a > 59 || ("12" === t && i > 12) || (n && (isNaN(o) || o > 59))))
              return "12" === t && 12 !== i && s && (i += 12), { hour: i, minute: a, second: o };
          }
          daylightSavingAdjust(e) {
            return e ? (e.setHours(e.getHours() > 12 ? e.getHours() + 2 : 0), e) : null;
          }
          parseDate(e, t, n, s) {
            switch (t) {
              case Sp.ISO_DATE_FORMAT:
                const t = e.split("-");
                e = t[1] + "/" + t[2] + "/" + t[0];
            }
            return new Date(e);
          }
          getStandardDateFormat(e) {
            let t;
            if (e) {
              const n = e.toString().split(" ");
              t = Op.getMonthNumber(n[1]) + "/" + n[2] + "/" + n[3];
            }
            return t;
          }
          getMediumDateFormat(e) {
            let t, n, s;
            return (
              e &&
                ((t = e.toString().split(" ")),
                t.length >= 4
                  ? (s = t[1] + " " + t[2] + ", " + t[3])
                  : ((t = e.toString().split(",")),
                    2 === t.length && ((n = t[0].split(" ")), (s = n[0] + " " + n[1] + ", " + t[1])))),
              s
            );
          }
          getLongDateFormat(e) {
            let t, n, s;
            return (
              e &&
                ((t = e.toString().split(" ")),
                t.length >= 4
                  ? (s = Op.getFullMonthName(t[1]) + " " + Op.getDateWithoutLeadingZero(t[2]) + ", " + t[3])
                  : ((t = e.toString().split(",")),
                    2 === t.length &&
                      ((n = t[0].split(" ")), (s = n[0] + " " + Op.getDateWithoutLeadingZero(n[1]) + ", " + t[1])))),
              s
            );
          }
          getFullDateFormat(e) {
            let t, n, s;
            return (
              e &&
                ((t = e.toString().split(" ")),
                t.length > 4
                  ? (s =
                      Op.getFullDayName(t[0]) +
                      ", " +
                      Op.getFullMonthName(t[1]) +
                      " " +
                      Op.getDateWithoutLeadingZero(t[2]) +
                      ", " +
                      t[3])
                  : ((t = e.toString().split(",")),
                    3 === t.length &&
                      ((n = t[1].trim().split(" ")),
                      (s = t[0] + ", " + n[0] + " " + Op.getDateWithoutLeadingZero(n[1]) + ", " + t[2])))),
              s
            );
          }
          getISODateFormat(e) {
            let t, n, s;
            return (
              e &&
                ((t = e.toString().split(" ")),
                t.length >= 4
                  ? (s = t[3] + "-" + Op.getMonthNumber(t[1]) + "-" + t[2])
                  : ((t = e.toString().split(",")),
                    2 === t.length &&
                      ((n = t[0].split(" ")), (s = n[0] + " " + Op.getDateWithoutLeadingZero(n[1]) + ", " + t[1])))),
              s
            );
          }
          getCustomDateFormat(e) {
            let t, n, s;
            return (
              e &&
                ((s = e.toString().split(" ")),
                s.length > 4
                  ? (n =
                      Op.getFullDayName(s[0]).substring(0, 3) +
                      ", " +
                      Op.getFullMonthName(s[1]) +
                      " " +
                      s[2] +
                      ", " +
                      s[3])
                  : ((s = e.toString().split(",")),
                    3 === s.length &&
                      ((t = s[1].trim().split(" ")),
                      (n = s[0] + ", " + t[0] + " " + Op.getDateWithoutLeadingZero(t[1]) + ", " + s[2])))),
              n
            );
          }
          formatDate(e, t, n) {
            let s, r;
            switch (t) {
              case Sp.DEFAULT_DATE_FORMAT:
                e &&
                  ((s = e.toString().split(" ")),
                  (r = new Date(s[1] + ", " + s[2] + "," + s[3]).toString().substring(0, 15)));
                break;
              case Sp.SHORT_DATE_FORMAT:
                e &&
                  ((s = e.toString().split(" ")),
                  (r = Op.getMonthNumber(s[1]) + "/" + s[2] + "/" + Op.getTwoDigitYear(s[3])));
                break;
              case Sp.MEDIUM_DATE_FORMAT:
                r = this.getMediumDateFormat(e);
                break;
              case Sp.LONG_DATE_FORMAT:
                r = this.getLongDateFormat(e);
                break;
              case Sp.FULL_DATE_FORMAT:
                r = this.getFullDateFormat(e);
                break;
              case Sp.STANDARD_DATE_FORMAT:
                r = this.getStandardDateFormat(e);
                break;
              case Sp.ISO_DATE_FORMAT:
                r = this.getISODateFormat(e);
                break;
              case Sp.CUSTOM_DATE_FORMAT:
                r = this.getCustomDateFormat(e);
            }
            return r;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac, providedIn: "root" })),
          e
        );
      })();
      class Ep {}
      function Cp(e, t = null) {
        return { type: 4, styles: t, timings: e };
      }
      function Wp(e, t = null) {
        return { type: 2, steps: e, options: t };
      }
      function qp(e) {
        return { type: 6, styles: e, offset: null };
      }
      function xp(e, t, n) {
        return { type: 0, name: e, styles: t, options: n };
      }
      function Bp(e, t, n = null) {
        return { type: 1, expr: e, animation: t, options: n };
      }
      function Hp(e) {
        Promise.resolve(null).then(e);
      }
      class jp {
        constructor(e = 0, t = 0) {
          (this._onDoneFns = []),
            (this._onStartFns = []),
            (this._onDestroyFns = []),
            (this._started = !1),
            (this._destroyed = !1),
            (this._finished = !1),
            (this.parentPlayer = null),
            (this.totalTime = e + t);
        }
        _onFinish() {
          this._finished || ((this._finished = !0), this._onDoneFns.forEach((e) => e()), (this._onDoneFns = []));
        }
        onStart(e) {
          this._onStartFns.push(e);
        }
        onDone(e) {
          this._onDoneFns.push(e);
        }
        onDestroy(e) {
          this._onDestroyFns.push(e);
        }
        hasStarted() {
          return this._started;
        }
        init() {}
        play() {
          this.hasStarted() || (this._onStart(), this.triggerMicrotask()), (this._started = !0);
        }
        triggerMicrotask() {
          Hp(() => this._onFinish());
        }
        _onStart() {
          this._onStartFns.forEach((e) => e()), (this._onStartFns = []);
        }
        pause() {}
        restart() {}
        finish() {
          this._onFinish();
        }
        destroy() {
          this._destroyed ||
            ((this._destroyed = !0),
            this.hasStarted() || this._onStart(),
            this.finish(),
            this._onDestroyFns.forEach((e) => e()),
            (this._onDestroyFns = []));
        }
        reset() {}
        setPosition(e) {}
        getPosition() {
          return 0;
        }
        triggerCallback(e) {
          const t = "start" == e ? this._onStartFns : this._onDoneFns;
          t.forEach((e) => e()), (t.length = 0);
        }
      }
      class Pp {
        constructor(e) {
          (this._onDoneFns = []),
            (this._onStartFns = []),
            (this._finished = !1),
            (this._started = !1),
            (this._destroyed = !1),
            (this._onDestroyFns = []),
            (this.parentPlayer = null),
            (this.totalTime = 0),
            (this.players = e);
          let t = 0,
            n = 0,
            s = 0;
          const r = this.players.length;
          0 == r
            ? Hp(() => this._onFinish())
            : this.players.forEach((e) => {
                e.onDone(() => {
                  ++t == r && this._onFinish();
                }),
                  e.onDestroy(() => {
                    ++n == r && this._onDestroy();
                  }),
                  e.onStart(() => {
                    ++s == r && this._onStart();
                  });
              }),
            (this.totalTime = this.players.reduce((e, t) => Math.max(e, t.totalTime), 0));
        }
        _onFinish() {
          this._finished || ((this._finished = !0), this._onDoneFns.forEach((e) => e()), (this._onDoneFns = []));
        }
        init() {
          this.players.forEach((e) => e.init());
        }
        onStart(e) {
          this._onStartFns.push(e);
        }
        _onStart() {
          this.hasStarted() || ((this._started = !0), this._onStartFns.forEach((e) => e()), (this._onStartFns = []));
        }
        onDone(e) {
          this._onDoneFns.push(e);
        }
        onDestroy(e) {
          this._onDestroyFns.push(e);
        }
        hasStarted() {
          return this._started;
        }
        play() {
          this.parentPlayer || this.init(), this._onStart(), this.players.forEach((e) => e.play());
        }
        pause() {
          this.players.forEach((e) => e.pause());
        }
        restart() {
          this.players.forEach((e) => e.restart());
        }
        finish() {
          this._onFinish(), this.players.forEach((e) => e.finish());
        }
        destroy() {
          this._onDestroy();
        }
        _onDestroy() {
          this._destroyed ||
            ((this._destroyed = !0),
            this._onFinish(),
            this.players.forEach((e) => e.destroy()),
            this._onDestroyFns.forEach((e) => e()),
            (this._onDestroyFns = []));
        }
        reset() {
          this.players.forEach((e) => e.reset()), (this._destroyed = !1), (this._finished = !1), (this._started = !1);
        }
        setPosition(e) {
          const t = e * this.totalTime;
          this.players.forEach((e) => {
            const n = e.totalTime ? Math.min(1, t / e.totalTime) : 1;
            e.setPosition(n);
          });
        }
        getPosition() {
          let e = 0;
          return (
            this.players.forEach((t) => {
              const n = t.getPosition();
              e = Math.min(n, e);
            }),
            e
          );
        }
        beforeDestroy() {
          this.players.forEach((e) => {
            e.beforeDestroy && e.beforeDestroy();
          });
        }
        triggerCallback(e) {
          const t = "start" == e ? this._onStartFns : this._onDoneFns;
          t.forEach((e) => e()), (t.length = 0);
        }
      }
      function Xp() {
        return "undefined" != typeof process && "[object process]" === {}.toString.call(process);
      }
      function Rp(e) {
        switch (e.length) {
          case 0:
            return new jp();
          case 1:
            return e[0];
          default:
            return new Pp(e);
        }
      }
      function Ip(e, t, n, s, r = {}, i = {}) {
        const a = [],
          o = [];
        let c = -1,
          l = null;
        if (
          (s.forEach((e) => {
            const n = e.offset,
              s = n == c,
              d = (s && l) || {};
            Object.keys(e).forEach((n) => {
              let s = n,
                o = e[n];
              if ("offset" !== n)
                switch (((s = t.normalizePropertyName(s, a)), o)) {
                  case "!":
                    o = r[n];
                    break;
                  case "*":
                    o = i[n];
                    break;
                  default:
                    o = t.normalizeStyleValue(n, s, o, a);
                }
              d[s] = o;
            }),
              s || o.push(d),
              (l = d),
              (c = n);
          }),
          a.length)
        ) {
          const e = "\n - ";
          throw new Error(`Unable to animate due to the following errors:${e}${a.join(e)}`);
        }
        return o;
      }
      function Fp(e, t, n, s) {
        switch (t) {
          case "start":
            e.onStart(() => s(n && Vp(n, "start", e)));
            break;
          case "done":
            e.onDone(() => s(n && Vp(n, "done", e)));
            break;
          case "destroy":
            e.onDestroy(() => s(n && Vp(n, "destroy", e)));
        }
      }
      function Vp(e, t, n) {
        const s = n.totalTime,
          r = Up(
            e.element,
            e.triggerName,
            e.fromState,
            e.toState,
            t || e.phaseName,
            null == s ? e.totalTime : s,
            !!n.disabled
          ),
          i = e._data;
        return null != i && (r._data = i), r;
      }
      function Up(e, t, n, s, r = "", i = 0, a) {
        return { element: e, triggerName: t, fromState: n, toState: s, phaseName: r, totalTime: i, disabled: !!a };
      }
      function Jp(e, t, n) {
        let s;
        return e instanceof Map ? ((s = e.get(t)), s || e.set(t, (s = n))) : ((s = e[t]), s || (s = e[t] = n)), s;
      }
      function Gp(e) {
        const t = e.indexOf(":");
        return [e.substring(1, t), e.substr(t + 1)];
      }
      let Qp = (e, t) => !1,
        Kp = (e, t) => !1,
        $p = (e, t, n) => [];
      const Zp = Xp();
      (Zp || "undefined" != typeof Element) &&
        ((Qp = (e, t) => e.contains(t)),
        (Kp = (() => {
          if (Zp || Element.prototype.matches) return (e, t) => e.matches(t);
          {
            const e = Element.prototype,
              t =
                e.matchesSelector ||
                e.mozMatchesSelector ||
                e.msMatchesSelector ||
                e.oMatchesSelector ||
                e.webkitMatchesSelector;
            return t ? (e, n) => t.apply(e, [n]) : Kp;
          }
        })()),
        ($p = (e, t, n) => {
          let s = [];
          if (n) s.push(...e.querySelectorAll(t));
          else {
            const n = e.querySelector(t);
            n && s.push(n);
          }
          return s;
        }));
      let em = null,
        tm = !1;
      function nm(e) {
        em ||
          ((em = ("undefined" != typeof document ? document.body : null) || {}),
          (tm = !!em.style && "WebkitAppearance" in em.style));
        let t = !0;
        return (
          em.style &&
            !(function (e) {
              return "ebkit" == e.substring(1, 6);
            })(e) &&
            ((t = e in em.style), !t && tm) &&
            (t = "Webkit" + e.charAt(0).toUpperCase() + e.substr(1) in em.style),
          t
        );
      }
      const sm = Kp,
        rm = Qp,
        im = $p;
      function am(e) {
        const t = {};
        return (
          Object.keys(e).forEach((n) => {
            const s = n.replace(/([a-z])([A-Z])/g, "$1-$2");
            t[s] = e[n];
          }),
          t
        );
      }
      let om = (() => {
          class e {
            validateStyleProperty(e) {
              return nm(e);
            }
            matchesElement(e, t) {
              return sm(e, t);
            }
            containsElement(e, t) {
              return rm(e, t);
            }
            query(e, t, n) {
              return im(e, t, n);
            }
            computeStyle(e, t, n) {
              return n || "";
            }
            animate(e, t, n, s, r, i = [], a) {
              return new jp(n, s);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        cm = (() => {
          class e {}
          return (e.NOOP = new om()), e;
        })();
      function lm(e) {
        if ("number" == typeof e) return e;
        const t = e.match(/^(-?[\.\d]+)(m?s)/);
        return !t || t.length < 2 ? 0 : dm(parseFloat(t[1]), t[2]);
      }
      function dm(e, t) {
        switch (t) {
          case "s":
            return 1e3 * e;
          default:
            return e;
        }
      }
      function um(e, t, n) {
        return e.hasOwnProperty("duration")
          ? e
          : (function (e, t, n) {
              let s,
                r = 0,
                i = "";
              if ("string" == typeof e) {
                const n = e.match(/^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i);
                if (null === n)
                  return t.push(`The provided timing value "${e}" is invalid.`), { duration: 0, delay: 0, easing: "" };
                s = dm(parseFloat(n[1]), n[2]);
                const a = n[3];
                null != a && (r = dm(parseFloat(a), n[4]));
                const o = n[5];
                o && (i = o);
              } else s = e;
              if (!n) {
                let n = !1,
                  i = t.length;
                s < 0 && (t.push("Duration values below 0 are not allowed for this animation step."), (n = !0)),
                  r < 0 && (t.push("Delay values below 0 are not allowed for this animation step."), (n = !0)),
                  n && t.splice(i, 0, `The provided timing value "${e}" is invalid.`);
              }
              return { duration: s, delay: r, easing: i };
            })(e, t, n);
      }
      function hm(e, t = {}) {
        return (
          Object.keys(e).forEach((n) => {
            t[n] = e[n];
          }),
          t
        );
      }
      function Mm(e, t, n = {}) {
        if (t) for (let s in e) n[s] = e[s];
        else hm(e, n);
        return n;
      }
      function pm(e, t, n) {
        return n ? t + ":" + n + ";" : "";
      }
      function mm(e) {
        let t = "";
        for (let n = 0; n < e.style.length; n++) {
          const s = e.style.item(n);
          t += pm(0, s, e.style.getPropertyValue(s));
        }
        for (const n in e.style)
          e.style.hasOwnProperty(n) &&
            !n.startsWith("_") &&
            (t += pm(0, n.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), e.style[n]));
        e.setAttribute("style", t);
      }
      function _m(e, t, n) {
        e.style &&
          (Object.keys(t).forEach((s) => {
            const r = zm(s);
            n && !n.hasOwnProperty(s) && (n[s] = e.style[r]), (e.style[r] = t[s]);
          }),
          Xp() && mm(e));
      }
      function fm(e, t) {
        e.style &&
          (Object.keys(t).forEach((t) => {
            const n = zm(t);
            e.style[n] = "";
          }),
          Xp() && mm(e));
      }
      function bm(e) {
        return Array.isArray(e) ? (1 == e.length ? e[0] : Wp(e)) : e;
      }
      const gm = new RegExp("{{\\s*(.+?)\\s*}}", "g");
      function ym(e) {
        let t = [];
        if ("string" == typeof e) {
          let n;
          for (; (n = gm.exec(e)); ) t.push(n[1]);
          gm.lastIndex = 0;
        }
        return t;
      }
      function Lm(e, t, n) {
        const s = e.toString(),
          r = s.replace(gm, (e, s) => {
            let r = t[s];
            return (
              t.hasOwnProperty(s) || (n.push("Please provide a value for the animation param " + s), (r = "")),
              r.toString()
            );
          });
        return r == s ? e : r;
      }
      function Am(e) {
        const t = [];
        let n = e.next();
        for (; !n.done; ) t.push(n.value), (n = e.next());
        return t;
      }
      const wm = /-+([a-z0-9])/g;
      function zm(e) {
        return e.replace(wm, (...e) => e[1].toUpperCase());
      }
      function Tm(e, t) {
        return 0 === e || 0 === t;
      }
      function vm(e, t, n) {
        const s = Object.keys(n);
        if (s.length && t.length) {
          let i = t[0],
            a = [];
          if (
            (s.forEach((e) => {
              i.hasOwnProperty(e) || a.push(e), (i[e] = n[e]);
            }),
            a.length)
          )
            for (var r = 1; r < t.length; r++) {
              let n = t[r];
              a.forEach(function (t) {
                n[t] = Om(e, t);
              });
            }
        }
        return t;
      }
      function Dm(e, t, n) {
        switch (t.type) {
          case 7:
            return e.visitTrigger(t, n);
          case 0:
            return e.visitState(t, n);
          case 1:
            return e.visitTransition(t, n);
          case 2:
            return e.visitSequence(t, n);
          case 3:
            return e.visitGroup(t, n);
          case 4:
            return e.visitAnimate(t, n);
          case 5:
            return e.visitKeyframes(t, n);
          case 6:
            return e.visitStyle(t, n);
          case 8:
            return e.visitReference(t, n);
          case 9:
            return e.visitAnimateChild(t, n);
          case 10:
            return e.visitAnimateRef(t, n);
          case 11:
            return e.visitQuery(t, n);
          case 12:
            return e.visitStagger(t, n);
          default:
            throw new Error("Unable to resolve animation metadata node #" + t.type);
        }
      }
      function Om(e, t) {
        return window.getComputedStyle(e)[t];
      }
      function Sm(e, t) {
        const n = [];
        return (
          "string" == typeof e
            ? e.split(/\s*,\s*/).forEach((e) =>
                (function (e, t, n) {
                  if (":" == e[0]) {
                    const s = (function (e, t) {
                      switch (e) {
                        case ":enter":
                          return "void => *";
                        case ":leave":
                          return "* => void";
                        case ":increment":
                          return (e, t) => parseFloat(t) > parseFloat(e);
                        case ":decrement":
                          return (e, t) => parseFloat(t) < parseFloat(e);
                        default:
                          return t.push(`The transition alias value "${e}" is not supported`), "* => *";
                      }
                    })(e, n);
                    if ("function" == typeof s) return void t.push(s);
                    e = s;
                  }
                  const s = e.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
                  if (null == s || s.length < 4)
                    return n.push(`The provided transition expression "${e}" is not supported`), t;
                  const r = s[1],
                    i = s[2],
                    a = s[3];
                  t.push(Nm(r, a)), "<" != i[0] || ("*" == r && "*" == a) || t.push(Nm(a, r));
                })(e, n, t)
              )
            : n.push(e),
          n
        );
      }
      const km = new Set(["true", "1"]),
        Ym = new Set(["false", "0"]);
      function Nm(e, t) {
        const n = km.has(e) || Ym.has(e),
          s = km.has(t) || Ym.has(t);
        return (r, i) => {
          let a = "*" == e || e == r,
            o = "*" == t || t == i;
          return (
            !a && n && "boolean" == typeof r && (a = r ? km.has(e) : Ym.has(e)),
            !o && s && "boolean" == typeof i && (o = i ? km.has(t) : Ym.has(t)),
            a && o
          );
        };
      }
      const Em = new RegExp("s*:selfs*,?", "g");
      function Cm(e, t, n) {
        return new Wm(e).build(t, n);
      }
      class Wm {
        constructor(e) {
          this._driver = e;
        }
        build(e, t) {
          const n = new qm(t);
          return this._resetContextStyleTimingState(n), Dm(this, bm(e), n);
        }
        _resetContextStyleTimingState(e) {
          (e.currentQuerySelector = ""), (e.collectedStyles = {}), (e.collectedStyles[""] = {}), (e.currentTime = 0);
        }
        visitTrigger(e, t) {
          let n = (t.queryCount = 0),
            s = (t.depCount = 0);
          const r = [],
            i = [];
          return (
            "@" == e.name.charAt(0) &&
              t.errors.push("animation triggers cannot be prefixed with an `@` sign (e.g. trigger('@foo', [...]))"),
            e.definitions.forEach((e) => {
              if ((this._resetContextStyleTimingState(t), 0 == e.type)) {
                const n = e,
                  s = n.name;
                s
                  .toString()
                  .split(/\s*,\s*/)
                  .forEach((e) => {
                    (n.name = e), r.push(this.visitState(n, t));
                  }),
                  (n.name = s);
              } else if (1 == e.type) {
                const r = this.visitTransition(e, t);
                (n += r.queryCount), (s += r.depCount), i.push(r);
              } else t.errors.push("only state() and transition() definitions can sit inside of a trigger()");
            }),
            { type: 7, name: e.name, states: r, transitions: i, queryCount: n, depCount: s, options: null }
          );
        }
        visitState(e, t) {
          const n = this.visitStyle(e.styles, t),
            s = (e.options && e.options.params) || null;
          if (n.containsDynamicStyles) {
            const r = new Set(),
              i = s || {};
            if (
              (n.styles.forEach((e) => {
                if (xm(e)) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    ym(t[e]).forEach((e) => {
                      i.hasOwnProperty(e) || r.add(e);
                    });
                  });
                }
              }),
              r.size)
            ) {
              const n = Am(r.values());
              t.errors.push(
                `state("${e.name}", ...) must define default values for all the following style substitutions: ${n.join(
                  ", "
                )}`
              );
            }
          }
          return { type: 0, name: e.name, style: n, options: s ? { params: s } : null };
        }
        visitTransition(e, t) {
          (t.queryCount = 0), (t.depCount = 0);
          const n = Dm(this, bm(e.animation), t);
          return {
            type: 1,
            matchers: Sm(e.expr, t.errors),
            animation: n,
            queryCount: t.queryCount,
            depCount: t.depCount,
            options: Bm(e.options),
          };
        }
        visitSequence(e, t) {
          return { type: 2, steps: e.steps.map((e) => Dm(this, e, t)), options: Bm(e.options) };
        }
        visitGroup(e, t) {
          const n = t.currentTime;
          let s = 0;
          const r = e.steps.map((e) => {
            t.currentTime = n;
            const r = Dm(this, e, t);
            return (s = Math.max(s, t.currentTime)), r;
          });
          return (t.currentTime = s), { type: 3, steps: r, options: Bm(e.options) };
        }
        visitAnimate(e, t) {
          const n = (function (e, t) {
            let n = null;
            if (e.hasOwnProperty("duration")) n = e;
            else if ("number" == typeof e) return Hm(um(e, t).duration, 0, "");
            const s = e;
            if (s.split(/\s+/).some((e) => "{" == e.charAt(0) && "{" == e.charAt(1))) {
              const e = Hm(0, 0, "");
              return (e.dynamic = !0), (e.strValue = s), e;
            }
            return (n = n || um(s, t)), Hm(n.duration, n.delay, n.easing);
          })(e.timings, t.errors);
          let s;
          t.currentAnimateTimings = n;
          let r = e.styles ? e.styles : qp({});
          if (5 == r.type) s = this.visitKeyframes(r, t);
          else {
            let r = e.styles,
              i = !1;
            if (!r) {
              i = !0;
              const e = {};
              n.easing && (e.easing = n.easing), (r = qp(e));
            }
            t.currentTime += n.duration + n.delay;
            const a = this.visitStyle(r, t);
            (a.isEmptyStep = i), (s = a);
          }
          return (t.currentAnimateTimings = null), { type: 4, timings: n, style: s, options: null };
        }
        visitStyle(e, t) {
          const n = this._makeStyleAst(e, t);
          return this._validateStyleAst(n, t), n;
        }
        _makeStyleAst(e, t) {
          const n = [];
          Array.isArray(e.styles)
            ? e.styles.forEach((e) => {
                "string" == typeof e
                  ? "*" == e
                    ? n.push(e)
                    : t.errors.push(`The provided style string value ${e} is not allowed.`)
                  : n.push(e);
              })
            : n.push(e.styles);
          let s = !1,
            r = null;
          return (
            n.forEach((e) => {
              if (xm(e)) {
                const t = e,
                  n = t.easing;
                if ((n && ((r = n), delete t.easing), !s))
                  for (let e in t)
                    if (t[e].toString().indexOf("{{") >= 0) {
                      s = !0;
                      break;
                    }
              }
            }),
            { type: 6, styles: n, easing: r, offset: e.offset, containsDynamicStyles: s, options: null }
          );
        }
        _validateStyleAst(e, t) {
          const n = t.currentAnimateTimings;
          let s = t.currentTime,
            r = t.currentTime;
          n && r > 0 && (r -= n.duration + n.delay),
            e.styles.forEach((e) => {
              "string" != typeof e &&
                Object.keys(e).forEach((n) => {
                  if (!this._driver.validateStyleProperty(n))
                    return void t.errors.push(
                      `The provided animation property "${n}" is not a supported CSS property for animations`
                    );
                  const i = t.collectedStyles[t.currentQuerySelector],
                    a = i[n];
                  let o = !0;
                  a &&
                    (r != s &&
                      r >= a.startTime &&
                      s <= a.endTime &&
                      (t.errors.push(
                        `The CSS property "${n}" that exists between the times of "${a.startTime}ms" and "${a.endTime}ms" is also being animated in a parallel animation between the times of "${r}ms" and "${s}ms"`
                      ),
                      (o = !1)),
                    (r = a.startTime)),
                    o && (i[n] = { startTime: r, endTime: s }),
                    t.options &&
                      (function (e, t, n) {
                        const s = t.params || {},
                          r = ym(e);
                        r.length &&
                          r.forEach((e) => {
                            s.hasOwnProperty(e) ||
                              n.push(`Unable to resolve the local animation param ${e} in the given list of values`);
                          });
                      })(e[n], t.options, t.errors);
                });
            });
        }
        visitKeyframes(e, t) {
          const n = { type: 5, styles: [], options: null };
          if (!t.currentAnimateTimings)
            return t.errors.push("keyframes() must be placed inside of a call to animate()"), n;
          let s = 0;
          const r = [];
          let i = !1,
            a = !1,
            o = 0;
          const c = e.steps.map((e) => {
            const n = this._makeStyleAst(e, t);
            let c =
                null != n.offset
                  ? n.offset
                  : (function (e) {
                      if ("string" == typeof e) return null;
                      let t = null;
                      if (Array.isArray(e))
                        e.forEach((e) => {
                          if (xm(e) && e.hasOwnProperty("offset")) {
                            const n = e;
                            (t = parseFloat(n.offset)), delete n.offset;
                          }
                        });
                      else if (xm(e) && e.hasOwnProperty("offset")) {
                        const n = e;
                        (t = parseFloat(n.offset)), delete n.offset;
                      }
                      return t;
                    })(n.styles),
              l = 0;
            return (
              null != c && (s++, (l = n.offset = c)), (a = a || l < 0 || l > 1), (i = i || l < o), (o = l), r.push(l), n
            );
          });
          a && t.errors.push("Please ensure that all keyframe offsets are between 0 and 1"),
            i && t.errors.push("Please ensure that all keyframe offsets are in order");
          const l = e.steps.length;
          let d = 0;
          s > 0 && s < l
            ? t.errors.push("Not all style() steps within the declared keyframes() contain offsets")
            : 0 == s && (d = 1 / (l - 1));
          const u = l - 1,
            h = t.currentTime,
            M = t.currentAnimateTimings,
            p = M.duration;
          return (
            c.forEach((e, s) => {
              const i = d > 0 ? (s == u ? 1 : d * s) : r[s],
                a = i * p;
              (t.currentTime = h + M.delay + a),
                (M.duration = a),
                this._validateStyleAst(e, t),
                (e.offset = i),
                n.styles.push(e);
            }),
            n
          );
        }
        visitReference(e, t) {
          return { type: 8, animation: Dm(this, bm(e.animation), t), options: Bm(e.options) };
        }
        visitAnimateChild(e, t) {
          return t.depCount++, { type: 9, options: Bm(e.options) };
        }
        visitAnimateRef(e, t) {
          return { type: 10, animation: this.visitReference(e.animation, t), options: Bm(e.options) };
        }
        visitQuery(e, t) {
          const n = t.currentQuerySelector,
            s = e.options || {};
          t.queryCount++, (t.currentQuery = e);
          const [r, i] = (function (e) {
            const t = !!e.split(/\s*,\s*/).find((e) => ":self" == e);
            return (
              t && (e = e.replace(Em, "")),
              [
                (e = e
                  .replace(/@\*/g, ".ng-trigger")
                  .replace(/@\w+/g, (e) => ".ng-trigger-" + e.substr(1))
                  .replace(/:animating/g, ".ng-animating")),
                t,
              ]
            );
          })(e.selector);
          (t.currentQuerySelector = n.length ? n + " " + r : r), Jp(t.collectedStyles, t.currentQuerySelector, {});
          const a = Dm(this, bm(e.animation), t);
          return (
            (t.currentQuery = null),
            (t.currentQuerySelector = n),
            {
              type: 11,
              selector: r,
              limit: s.limit || 0,
              optional: !!s.optional,
              includeSelf: i,
              animation: a,
              originalSelector: e.selector,
              options: Bm(e.options),
            }
          );
        }
        visitStagger(e, t) {
          t.currentQuery || t.errors.push("stagger() can only be used inside of query()");
          const n = "full" === e.timings ? { duration: 0, delay: 0, easing: "full" } : um(e.timings, t.errors, !0);
          return { type: 12, animation: Dm(this, bm(e.animation), t), timings: n, options: null };
        }
      }
      class qm {
        constructor(e) {
          (this.errors = e),
            (this.queryCount = 0),
            (this.depCount = 0),
            (this.currentTransition = null),
            (this.currentQuery = null),
            (this.currentQuerySelector = null),
            (this.currentAnimateTimings = null),
            (this.currentTime = 0),
            (this.collectedStyles = {}),
            (this.options = null);
        }
      }
      function xm(e) {
        return !Array.isArray(e) && "object" == typeof e;
      }
      function Bm(e) {
        var t;
        return e ? (e = hm(e)).params && (e.params = (t = e.params) ? hm(t) : null) : (e = {}), e;
      }
      function Hm(e, t, n) {
        return { duration: e, delay: t, easing: n };
      }
      function jm(e, t, n, s, r, i, a = null, o = !1) {
        return {
          type: 1,
          element: e,
          keyframes: t,
          preStyleProps: n,
          postStyleProps: s,
          duration: r,
          delay: i,
          totalTime: r + i,
          easing: a,
          subTimeline: o,
        };
      }
      class Pm {
        constructor() {
          this._map = new Map();
        }
        consume(e) {
          let t = this._map.get(e);
          return t ? this._map.delete(e) : (t = []), t;
        }
        append(e, t) {
          let n = this._map.get(e);
          n || this._map.set(e, (n = [])), n.push(...t);
        }
        has(e) {
          return this._map.has(e);
        }
        clear() {
          this._map.clear();
        }
      }
      const Xm = new RegExp(":enter", "g"),
        Rm = new RegExp(":leave", "g");
      function Im(e, t, n, s, r, i = {}, a = {}, o, c, l = []) {
        return new Fm().buildKeyframes(e, t, n, s, r, i, a, o, c, l);
      }
      class Fm {
        buildKeyframes(e, t, n, s, r, i, a, o, c, l = []) {
          c = c || new Pm();
          const d = new Um(e, t, c, s, r, l, []);
          (d.options = o), d.currentTimeline.setStyles([i], null, d.errors, o), Dm(this, n, d);
          const u = d.timelines.filter((e) => e.containsAnimation());
          if (u.length && Object.keys(a).length) {
            const e = u[u.length - 1];
            e.allowOnlyTimelineStyles() || e.setStyles([a], null, d.errors, o);
          }
          return u.length ? u.map((e) => e.buildKeyframes()) : [jm(t, [], [], [], 0, 0, "", !1)];
        }
        visitTrigger(e, t) {}
        visitState(e, t) {}
        visitTransition(e, t) {}
        visitAnimateChild(e, t) {
          const n = t.subInstructions.consume(t.element);
          if (n) {
            const s = t.createSubContext(e.options),
              r = t.currentTimeline.currentTime,
              i = this._visitSubInstructions(n, s, s.options);
            r != i && t.transformIntoNewTimeline(i);
          }
          t.previousNode = e;
        }
        visitAnimateRef(e, t) {
          const n = t.createSubContext(e.options);
          n.transformIntoNewTimeline(),
            this.visitReference(e.animation, n),
            t.transformIntoNewTimeline(n.currentTimeline.currentTime),
            (t.previousNode = e);
        }
        _visitSubInstructions(e, t, n) {
          let s = t.currentTimeline.currentTime;
          const r = null != n.duration ? lm(n.duration) : null,
            i = null != n.delay ? lm(n.delay) : null;
          return (
            0 !== r &&
              e.forEach((e) => {
                const n = t.appendInstructionToTimeline(e, r, i);
                s = Math.max(s, n.duration + n.delay);
              }),
            s
          );
        }
        visitReference(e, t) {
          t.updateOptions(e.options, !0), Dm(this, e.animation, t), (t.previousNode = e);
        }
        visitSequence(e, t) {
          const n = t.subContextCount;
          let s = t;
          const r = e.options;
          if (
            r &&
            (r.params || r.delay) &&
            ((s = t.createSubContext(r)), s.transformIntoNewTimeline(), null != r.delay)
          ) {
            6 == s.previousNode.type && (s.currentTimeline.snapshotCurrentStyles(), (s.previousNode = Vm));
            const e = lm(r.delay);
            s.delayNextStep(e);
          }
          e.steps.length &&
            (e.steps.forEach((e) => Dm(this, e, s)),
            s.currentTimeline.applyStylesToKeyframe(),
            s.subContextCount > n && s.transformIntoNewTimeline()),
            (t.previousNode = e);
        }
        visitGroup(e, t) {
          const n = [];
          let s = t.currentTimeline.currentTime;
          const r = e.options && e.options.delay ? lm(e.options.delay) : 0;
          e.steps.forEach((i) => {
            const a = t.createSubContext(e.options);
            r && a.delayNextStep(r),
              Dm(this, i, a),
              (s = Math.max(s, a.currentTimeline.currentTime)),
              n.push(a.currentTimeline);
          }),
            n.forEach((e) => t.currentTimeline.mergeTimelineCollectedStyles(e)),
            t.transformIntoNewTimeline(s),
            (t.previousNode = e);
        }
        _visitTiming(e, t) {
          if (e.dynamic) {
            const n = e.strValue;
            return um(t.params ? Lm(n, t.params, t.errors) : n, t.errors);
          }
          return { duration: e.duration, delay: e.delay, easing: e.easing };
        }
        visitAnimate(e, t) {
          const n = (t.currentAnimateTimings = this._visitTiming(e.timings, t)),
            s = t.currentTimeline;
          n.delay && (t.incrementTime(n.delay), s.snapshotCurrentStyles());
          const r = e.style;
          5 == r.type
            ? this.visitKeyframes(r, t)
            : (t.incrementTime(n.duration), this.visitStyle(r, t), s.applyStylesToKeyframe()),
            (t.currentAnimateTimings = null),
            (t.previousNode = e);
        }
        visitStyle(e, t) {
          const n = t.currentTimeline,
            s = t.currentAnimateTimings;
          !s && n.getCurrentStyleProperties().length && n.forwardFrame();
          const r = (s && s.easing) || e.easing;
          e.isEmptyStep ? n.applyEmptyStep(r) : n.setStyles(e.styles, r, t.errors, t.options), (t.previousNode = e);
        }
        visitKeyframes(e, t) {
          const n = t.currentAnimateTimings,
            s = t.currentTimeline.duration,
            r = n.duration,
            i = t.createSubContext().currentTimeline;
          (i.easing = n.easing),
            e.styles.forEach((e) => {
              i.forwardTime((e.offset || 0) * r),
                i.setStyles(e.styles, e.easing, t.errors, t.options),
                i.applyStylesToKeyframe();
            }),
            t.currentTimeline.mergeTimelineCollectedStyles(i),
            t.transformIntoNewTimeline(s + r),
            (t.previousNode = e);
        }
        visitQuery(e, t) {
          const n = t.currentTimeline.currentTime,
            s = e.options || {},
            r = s.delay ? lm(s.delay) : 0;
          r &&
            (6 === t.previousNode.type || (0 == n && t.currentTimeline.getCurrentStyleProperties().length)) &&
            (t.currentTimeline.snapshotCurrentStyles(), (t.previousNode = Vm));
          let i = n;
          const a = t.invokeQuery(e.selector, e.originalSelector, e.limit, e.includeSelf, !!s.optional, t.errors);
          t.currentQueryTotal = a.length;
          let o = null;
          a.forEach((n, s) => {
            t.currentQueryIndex = s;
            const a = t.createSubContext(e.options, n);
            r && a.delayNextStep(r),
              n === t.element && (o = a.currentTimeline),
              Dm(this, e.animation, a),
              a.currentTimeline.applyStylesToKeyframe(),
              (i = Math.max(i, a.currentTimeline.currentTime));
          }),
            (t.currentQueryIndex = 0),
            (t.currentQueryTotal = 0),
            t.transformIntoNewTimeline(i),
            o && (t.currentTimeline.mergeTimelineCollectedStyles(o), t.currentTimeline.snapshotCurrentStyles()),
            (t.previousNode = e);
        }
        visitStagger(e, t) {
          const n = t.parentContext,
            s = t.currentTimeline,
            r = e.timings,
            i = Math.abs(r.duration),
            a = i * (t.currentQueryTotal - 1);
          let o = i * t.currentQueryIndex;
          switch (r.duration < 0 ? "reverse" : r.easing) {
            case "reverse":
              o = a - o;
              break;
            case "full":
              o = n.currentStaggerTime;
          }
          const c = t.currentTimeline;
          o && c.delayNextStep(o);
          const l = c.currentTime;
          Dm(this, e.animation, t),
            (t.previousNode = e),
            (n.currentStaggerTime = s.currentTime - l + (s.startTime - n.currentTimeline.startTime));
        }
      }
      const Vm = {};
      class Um {
        constructor(e, t, n, s, r, i, a, o) {
          (this._driver = e),
            (this.element = t),
            (this.subInstructions = n),
            (this._enterClassName = s),
            (this._leaveClassName = r),
            (this.errors = i),
            (this.timelines = a),
            (this.parentContext = null),
            (this.currentAnimateTimings = null),
            (this.previousNode = Vm),
            (this.subContextCount = 0),
            (this.options = {}),
            (this.currentQueryIndex = 0),
            (this.currentQueryTotal = 0),
            (this.currentStaggerTime = 0),
            (this.currentTimeline = o || new Jm(this._driver, t, 0)),
            a.push(this.currentTimeline);
        }
        get params() {
          return this.options.params;
        }
        updateOptions(e, t) {
          if (!e) return;
          const n = e;
          let s = this.options;
          null != n.duration && (s.duration = lm(n.duration)), null != n.delay && (s.delay = lm(n.delay));
          const r = n.params;
          if (r) {
            let e = s.params;
            e || (e = this.options.params = {}),
              Object.keys(r).forEach((n) => {
                (t && e.hasOwnProperty(n)) || (e[n] = Lm(r[n], e, this.errors));
              });
          }
        }
        _copyOptions() {
          const e = {};
          if (this.options) {
            const t = this.options.params;
            if (t) {
              const n = (e.params = {});
              Object.keys(t).forEach((e) => {
                n[e] = t[e];
              });
            }
          }
          return e;
        }
        createSubContext(e = null, t, n) {
          const s = t || this.element,
            r = new Um(
              this._driver,
              s,
              this.subInstructions,
              this._enterClassName,
              this._leaveClassName,
              this.errors,
              this.timelines,
              this.currentTimeline.fork(s, n || 0)
            );
          return (
            (r.previousNode = this.previousNode),
            (r.currentAnimateTimings = this.currentAnimateTimings),
            (r.options = this._copyOptions()),
            r.updateOptions(e),
            (r.currentQueryIndex = this.currentQueryIndex),
            (r.currentQueryTotal = this.currentQueryTotal),
            (r.parentContext = this),
            this.subContextCount++,
            r
          );
        }
        transformIntoNewTimeline(e) {
          return (
            (this.previousNode = Vm),
            (this.currentTimeline = this.currentTimeline.fork(this.element, e)),
            this.timelines.push(this.currentTimeline),
            this.currentTimeline
          );
        }
        appendInstructionToTimeline(e, t, n) {
          const s = {
              duration: null != t ? t : e.duration,
              delay: this.currentTimeline.currentTime + (null != n ? n : 0) + e.delay,
              easing: "",
            },
            r = new Gm(
              this._driver,
              e.element,
              e.keyframes,
              e.preStyleProps,
              e.postStyleProps,
              s,
              e.stretchStartingKeyframe
            );
          return this.timelines.push(r), s;
        }
        incrementTime(e) {
          this.currentTimeline.forwardTime(this.currentTimeline.duration + e);
        }
        delayNextStep(e) {
          e > 0 && this.currentTimeline.delayNextStep(e);
        }
        invokeQuery(e, t, n, s, r, i) {
          let a = [];
          if ((s && a.push(this.element), e.length > 0)) {
            e = (e = e.replace(Xm, "." + this._enterClassName)).replace(Rm, "." + this._leaveClassName);
            let t = this._driver.query(this.element, e, 1 != n);
            0 !== n && (t = n < 0 ? t.slice(t.length + n, t.length) : t.slice(0, n)), a.push(...t);
          }
          return (
            r ||
              0 != a.length ||
              i.push(
                `\`query("${t}")\` returned zero elements. (Use \`query("${t}", { optional: true })\` if you wish to allow this.)`
              ),
            a
          );
        }
      }
      class Jm {
        constructor(e, t, n, s) {
          (this._driver = e),
            (this.element = t),
            (this.startTime = n),
            (this._elementTimelineStylesLookup = s),
            (this.duration = 0),
            (this._previousKeyframe = {}),
            (this._currentKeyframe = {}),
            (this._keyframes = new Map()),
            (this._styleSummary = {}),
            (this._pendingStyles = {}),
            (this._backFill = {}),
            (this._currentEmptyStepKeyframe = null),
            this._elementTimelineStylesLookup || (this._elementTimelineStylesLookup = new Map()),
            (this._localTimelineStyles = Object.create(this._backFill, {})),
            (this._globalTimelineStyles = this._elementTimelineStylesLookup.get(t)),
            this._globalTimelineStyles ||
              ((this._globalTimelineStyles = this._localTimelineStyles),
              this._elementTimelineStylesLookup.set(t, this._localTimelineStyles)),
            this._loadKeyframe();
        }
        containsAnimation() {
          switch (this._keyframes.size) {
            case 0:
              return !1;
            case 1:
              return this.getCurrentStyleProperties().length > 0;
            default:
              return !0;
          }
        }
        getCurrentStyleProperties() {
          return Object.keys(this._currentKeyframe);
        }
        get currentTime() {
          return this.startTime + this.duration;
        }
        delayNextStep(e) {
          const t = 1 == this._keyframes.size && Object.keys(this._pendingStyles).length;
          this.duration || t
            ? (this.forwardTime(this.currentTime + e), t && this.snapshotCurrentStyles())
            : (this.startTime += e);
        }
        fork(e, t) {
          return (
            this.applyStylesToKeyframe(),
            new Jm(this._driver, e, t || this.currentTime, this._elementTimelineStylesLookup)
          );
        }
        _loadKeyframe() {
          this._currentKeyframe && (this._previousKeyframe = this._currentKeyframe),
            (this._currentKeyframe = this._keyframes.get(this.duration)),
            this._currentKeyframe ||
              ((this._currentKeyframe = Object.create(this._backFill, {})),
              this._keyframes.set(this.duration, this._currentKeyframe));
        }
        forwardFrame() {
          (this.duration += 1), this._loadKeyframe();
        }
        forwardTime(e) {
          this.applyStylesToKeyframe(), (this.duration = e), this._loadKeyframe();
        }
        _updateStyle(e, t) {
          (this._localTimelineStyles[e] = t),
            (this._globalTimelineStyles[e] = t),
            (this._styleSummary[e] = { time: this.currentTime, value: t });
        }
        allowOnlyTimelineStyles() {
          return this._currentEmptyStepKeyframe !== this._currentKeyframe;
        }
        applyEmptyStep(e) {
          e && (this._previousKeyframe.easing = e),
            Object.keys(this._globalTimelineStyles).forEach((e) => {
              (this._backFill[e] = this._globalTimelineStyles[e] || "*"), (this._currentKeyframe[e] = "*");
            }),
            (this._currentEmptyStepKeyframe = this._currentKeyframe);
        }
        setStyles(e, t, n, s) {
          t && (this._previousKeyframe.easing = t);
          const r = (s && s.params) || {},
            i = (function (e, t) {
              const n = {};
              let s;
              return (
                e.forEach((e) => {
                  "*" === e
                    ? ((s = s || Object.keys(t)),
                      s.forEach((e) => {
                        n[e] = "*";
                      }))
                    : Mm(e, !1, n);
                }),
                n
              );
            })(e, this._globalTimelineStyles);
          Object.keys(i).forEach((e) => {
            const t = Lm(i[e], r, n);
            (this._pendingStyles[e] = t),
              this._localTimelineStyles.hasOwnProperty(e) ||
                (this._backFill[e] = this._globalTimelineStyles.hasOwnProperty(e)
                  ? this._globalTimelineStyles[e]
                  : "*"),
              this._updateStyle(e, t);
          });
        }
        applyStylesToKeyframe() {
          const e = this._pendingStyles,
            t = Object.keys(e);
          0 != t.length &&
            ((this._pendingStyles = {}),
            t.forEach((t) => {
              this._currentKeyframe[t] = e[t];
            }),
            Object.keys(this._localTimelineStyles).forEach((e) => {
              this._currentKeyframe.hasOwnProperty(e) || (this._currentKeyframe[e] = this._localTimelineStyles[e]);
            }));
        }
        snapshotCurrentStyles() {
          Object.keys(this._localTimelineStyles).forEach((e) => {
            const t = this._localTimelineStyles[e];
            (this._pendingStyles[e] = t), this._updateStyle(e, t);
          });
        }
        getFinalKeyframe() {
          return this._keyframes.get(this.duration);
        }
        get properties() {
          const e = [];
          for (let t in this._currentKeyframe) e.push(t);
          return e;
        }
        mergeTimelineCollectedStyles(e) {
          Object.keys(e._styleSummary).forEach((t) => {
            const n = this._styleSummary[t],
              s = e._styleSummary[t];
            (!n || s.time > n.time) && this._updateStyle(t, s.value);
          });
        }
        buildKeyframes() {
          this.applyStylesToKeyframe();
          const e = new Set(),
            t = new Set(),
            n = 1 === this._keyframes.size && 0 === this.duration;
          let s = [];
          this._keyframes.forEach((r, i) => {
            const a = Mm(r, !0);
            Object.keys(a).forEach((n) => {
              const s = a[n];
              "!" == s ? e.add(n) : "*" == s && t.add(n);
            }),
              n || (a.offset = i / this.duration),
              s.push(a);
          });
          const r = e.size ? Am(e.values()) : [],
            i = t.size ? Am(t.values()) : [];
          if (n) {
            const e = s[0],
              t = hm(e);
            (e.offset = 0), (t.offset = 1), (s = [e, t]);
          }
          return jm(this.element, s, r, i, this.duration, this.startTime, this.easing, !1);
        }
      }
      class Gm extends Jm {
        constructor(e, t, n, s, r, i, a = !1) {
          super(e, t, i.delay),
            (this.element = t),
            (this.keyframes = n),
            (this.preStyleProps = s),
            (this.postStyleProps = r),
            (this._stretchStartingKeyframe = a),
            (this.timings = { duration: i.duration, delay: i.delay, easing: i.easing });
        }
        containsAnimation() {
          return this.keyframes.length > 1;
        }
        buildKeyframes() {
          let e = this.keyframes,
            { delay: t, duration: n, easing: s } = this.timings;
          if (this._stretchStartingKeyframe && t) {
            const r = [],
              i = n + t,
              a = t / i,
              o = Mm(e[0], !1);
            (o.offset = 0), r.push(o);
            const c = Mm(e[0], !1);
            (c.offset = Qm(a)), r.push(c);
            const l = e.length - 1;
            for (let s = 1; s <= l; s++) {
              let a = Mm(e[s], !1);
              (a.offset = Qm((t + a.offset * n) / i)), r.push(a);
            }
            (n = i), (t = 0), (s = ""), (e = r);
          }
          return jm(this.element, e, this.preStyleProps, this.postStyleProps, n, t, s, !0);
        }
      }
      function Qm(e, t = 3) {
        const n = Math.pow(10, t - 1);
        return Math.round(e * n) / n;
      }
      class Km {}
      class $m extends Km {
        normalizePropertyName(e, t) {
          return zm(e);
        }
        normalizeStyleValue(e, t, n, s) {
          let r = "";
          const i = n.toString().trim();
          if (Zm[t] && 0 !== n && "0" !== n)
            if ("number" == typeof n) r = "px";
            else {
              const t = n.match(/^[+-]?[\d\.]+([a-z]*)$/);
              t && 0 == t[1].length && s.push(`Please provide a CSS unit value for ${e}:${n}`);
            }
          return i + r;
        }
      }
      const Zm = (() =>
        (function (e) {
          const t = {};
          return e.forEach((e) => (t[e] = !0)), t;
        })(
          "width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective".split(
            ","
          )
        ))();
      function e_(e, t, n, s, r, i, a, o, c, l, d, u, h) {
        return {
          type: 0,
          element: e,
          triggerName: t,
          isRemovalTransition: r,
          fromState: n,
          fromStyles: i,
          toState: s,
          toStyles: a,
          timelines: o,
          queriedElements: c,
          preStyleProps: l,
          postStyleProps: d,
          totalTime: u,
          errors: h,
        };
      }
      const t_ = {};
      class n_ {
        constructor(e, t, n) {
          (this._triggerName = e), (this.ast = t), (this._stateStyles = n);
        }
        match(e, t, n, s) {
          return (function (e, t, n, s, r) {
            return e.some((e) => e(t, n, s, r));
          })(this.ast.matchers, e, t, n, s);
        }
        buildStyles(e, t, n) {
          const s = this._stateStyles["*"],
            r = this._stateStyles[e],
            i = s ? s.buildStyles(t, n) : {};
          return r ? r.buildStyles(t, n) : i;
        }
        build(e, t, n, s, r, i, a, o, c, l) {
          const d = [],
            u = (this.ast.options && this.ast.options.params) || t_,
            h = this.buildStyles(n, (a && a.params) || t_, d),
            M = (o && o.params) || t_,
            p = this.buildStyles(s, M, d),
            m = new Set(),
            _ = new Map(),
            f = new Map(),
            b = "void" === s,
            g = { params: Object.assign(Object.assign({}, u), M) },
            y = l ? [] : Im(e, t, this.ast.animation, r, i, h, p, g, c, d);
          let L = 0;
          if (
            (y.forEach((e) => {
              L = Math.max(e.duration + e.delay, L);
            }),
            d.length)
          )
            return e_(t, this._triggerName, n, s, b, h, p, [], [], _, f, L, d);
          y.forEach((e) => {
            const n = e.element,
              s = Jp(_, n, {});
            e.preStyleProps.forEach((e) => (s[e] = !0));
            const r = Jp(f, n, {});
            e.postStyleProps.forEach((e) => (r[e] = !0)), n !== t && m.add(n);
          });
          const A = Am(m.values());
          return e_(t, this._triggerName, n, s, b, h, p, y, A, _, f, L);
        }
      }
      class s_ {
        constructor(e, t) {
          (this.styles = e), (this.defaultParams = t);
        }
        buildStyles(e, t) {
          const n = {},
            s = hm(this.defaultParams);
          return (
            Object.keys(e).forEach((t) => {
              const n = e[t];
              null != n && (s[t] = n);
            }),
            this.styles.styles.forEach((e) => {
              if ("string" != typeof e) {
                const r = e;
                Object.keys(r).forEach((e) => {
                  let i = r[e];
                  i.length > 1 && (i = Lm(i, s, t)), (n[e] = i);
                });
              }
            }),
            n
          );
        }
      }
      class r_ {
        constructor(e, t) {
          (this.name = e),
            (this.ast = t),
            (this.transitionFactories = []),
            (this.states = {}),
            t.states.forEach((e) => {
              this.states[e.name] = new s_(e.style, (e.options && e.options.params) || {});
            }),
            i_(this.states, "true", "1"),
            i_(this.states, "false", "0"),
            t.transitions.forEach((t) => {
              this.transitionFactories.push(new n_(e, t, this.states));
            }),
            (this.fallbackTransition = new n_(
              e,
              {
                type: 1,
                animation: { type: 2, steps: [], options: null },
                matchers: [(e, t) => !0],
                options: null,
                queryCount: 0,
                depCount: 0,
              },
              this.states
            ));
        }
        get containsQueries() {
          return this.ast.queryCount > 0;
        }
        matchTransition(e, t, n, s) {
          return this.transitionFactories.find((r) => r.match(e, t, n, s)) || null;
        }
        matchStyles(e, t, n) {
          return this.fallbackTransition.buildStyles(e, t, n);
        }
      }
      function i_(e, t, n) {
        e.hasOwnProperty(t) ? e.hasOwnProperty(n) || (e[n] = e[t]) : e.hasOwnProperty(n) && (e[t] = e[n]);
      }
      const a_ = new Pm();
      class o_ {
        constructor(e, t, n) {
          (this.bodyNode = e),
            (this._driver = t),
            (this._normalizer = n),
            (this._animations = {}),
            (this._playersById = {}),
            (this.players = []);
        }
        register(e, t) {
          const n = [],
            s = Cm(this._driver, t, n);
          if (n.length) throw new Error("Unable to build the animation due to the following errors: " + n.join("\n"));
          this._animations[e] = s;
        }
        _buildPlayer(e, t, n) {
          const s = e.element,
            r = Ip(0, this._normalizer, 0, e.keyframes, t, n);
          return this._driver.animate(s, r, e.duration, e.delay, e.easing, [], !0);
        }
        create(e, t, n = {}) {
          const s = [],
            r = this._animations[e];
          let i;
          const a = new Map();
          if (
            (r
              ? ((i = Im(this._driver, t, r, "ng-enter", "ng-leave", {}, {}, n, a_, s)),
                i.forEach((e) => {
                  const t = Jp(a, e.element, {});
                  e.postStyleProps.forEach((e) => (t[e] = null));
                }))
              : (s.push("The requested animation doesn't exist or has already been destroyed"), (i = [])),
            s.length)
          )
            throw new Error("Unable to create the animation due to the following errors: " + s.join("\n"));
          a.forEach((e, t) => {
            Object.keys(e).forEach((n) => {
              e[n] = this._driver.computeStyle(t, n, "*");
            });
          });
          const o = Rp(
            i.map((e) => {
              const t = a.get(e.element);
              return this._buildPlayer(e, {}, t);
            })
          );
          return (this._playersById[e] = o), o.onDestroy(() => this.destroy(e)), this.players.push(o), o;
        }
        destroy(e) {
          const t = this._getPlayer(e);
          t.destroy(), delete this._playersById[e];
          const n = this.players.indexOf(t);
          n >= 0 && this.players.splice(n, 1);
        }
        _getPlayer(e) {
          const t = this._playersById[e];
          if (!t) throw new Error("Unable to find the timeline player referenced by " + e);
          return t;
        }
        listen(e, t, n, s) {
          const r = Up(t, "", "", "");
          return Fp(this._getPlayer(e), n, r, s), () => {};
        }
        command(e, t, n, s) {
          if ("register" == n) return void this.register(e, s[0]);
          if ("create" == n) return void this.create(e, t, s[0] || {});
          const r = this._getPlayer(e);
          switch (n) {
            case "play":
              r.play();
              break;
            case "pause":
              r.pause();
              break;
            case "reset":
              r.reset();
              break;
            case "restart":
              r.restart();
              break;
            case "finish":
              r.finish();
              break;
            case "init":
              r.init();
              break;
            case "setPosition":
              r.setPosition(parseFloat(s[0]));
              break;
            case "destroy":
              this.destroy(e);
          }
        }
      }
      const c_ = [],
        l_ = { namespaceId: "", setForRemoval: !1, setForMove: !1, hasAnimation: !1, removedBeforeQueried: !1 },
        d_ = { namespaceId: "", setForMove: !1, setForRemoval: !1, hasAnimation: !1, removedBeforeQueried: !0 };
      class u_ {
        constructor(e, t = "") {
          this.namespaceId = t;
          const n = e && e.hasOwnProperty("value");
          if (((this.value = null != (s = n ? e.value : e) ? s : null), n)) {
            const t = hm(e);
            delete t.value, (this.options = t);
          } else this.options = {};
          var s;
          this.options.params || (this.options.params = {});
        }
        get params() {
          return this.options.params;
        }
        absorbOptions(e) {
          const t = e.params;
          if (t) {
            const e = this.options.params;
            Object.keys(t).forEach((n) => {
              null == e[n] && (e[n] = t[n]);
            });
          }
        }
      }
      const h_ = new u_("void");
      class M_ {
        constructor(e, t, n) {
          (this.id = e),
            (this.hostElement = t),
            (this._engine = n),
            (this.players = []),
            (this._triggers = {}),
            (this._queue = []),
            (this._elementListeners = new Map()),
            (this._hostClassName = "ng-tns-" + e),
            y_(t, this._hostClassName);
        }
        listen(e, t, n, s) {
          if (!this._triggers.hasOwnProperty(t))
            throw new Error(
              `Unable to listen on the animation trigger event "${n}" because the animation trigger "${t}" doesn't exist!`
            );
          if (null == n || 0 == n.length)
            throw new Error(
              `Unable to listen on the animation trigger "${t}" because the provided event is undefined!`
            );
          if ("start" != (r = n) && "done" != r)
            throw new Error(
              `The provided animation trigger event "${n}" for the animation trigger "${t}" is not supported!`
            );
          var r;
          const i = Jp(this._elementListeners, e, []),
            a = { name: t, phase: n, callback: s };
          i.push(a);
          const o = Jp(this._engine.statesByElement, e, {});
          return (
            o.hasOwnProperty(t) || (y_(e, "ng-trigger"), y_(e, "ng-trigger-" + t), (o[t] = h_)),
            () => {
              this._engine.afterFlush(() => {
                const e = i.indexOf(a);
                e >= 0 && i.splice(e, 1), this._triggers[t] || delete o[t];
              });
            }
          );
        }
        register(e, t) {
          return !this._triggers[e] && ((this._triggers[e] = t), !0);
        }
        _getTrigger(e) {
          const t = this._triggers[e];
          if (!t) throw new Error(`The provided animation trigger "${e}" has not been registered!`);
          return t;
        }
        trigger(e, t, n, s = !0) {
          const r = this._getTrigger(t),
            i = new m_(this.id, t, e);
          let a = this._engine.statesByElement.get(e);
          a || (y_(e, "ng-trigger"), y_(e, "ng-trigger-" + t), this._engine.statesByElement.set(e, (a = {})));
          let o = a[t];
          const c = new u_(n, this.id);
          if (
            (!(n && n.hasOwnProperty("value")) && o && c.absorbOptions(o.options),
            (a[t] = c),
            o || (o = h_),
            "void" !== c.value && o.value === c.value)
          ) {
            if (
              !(function (e, t) {
                const n = Object.keys(e),
                  s = Object.keys(t);
                if (n.length != s.length) return !1;
                for (let r = 0; r < n.length; r++) {
                  const s = n[r];
                  if (!t.hasOwnProperty(s) || e[s] !== t[s]) return !1;
                }
                return !0;
              })(o.params, c.params)
            ) {
              const t = [],
                n = r.matchStyles(o.value, o.params, t),
                s = r.matchStyles(c.value, c.params, t);
              t.length
                ? this._engine.reportError(t)
                : this._engine.afterFlush(() => {
                    fm(e, n), _m(e, s);
                  });
            }
            return;
          }
          const l = Jp(this._engine.playersByElement, e, []);
          l.forEach((e) => {
            e.namespaceId == this.id && e.triggerName == t && e.queued && e.destroy();
          });
          let d = r.matchTransition(o.value, c.value, e, c.params),
            u = !1;
          if (!d) {
            if (!s) return;
            (d = r.fallbackTransition), (u = !0);
          }
          return (
            this._engine.totalQueuedPlayers++,
            this._queue.push({
              element: e,
              triggerName: t,
              transition: d,
              fromState: o,
              toState: c,
              player: i,
              isFallbackTransition: u,
            }),
            u ||
              (y_(e, "ng-animate-queued"),
              i.onStart(() => {
                L_(e, "ng-animate-queued");
              })),
            i.onDone(() => {
              let t = this.players.indexOf(i);
              t >= 0 && this.players.splice(t, 1);
              const n = this._engine.playersByElement.get(e);
              if (n) {
                let e = n.indexOf(i);
                e >= 0 && n.splice(e, 1);
              }
            }),
            this.players.push(i),
            l.push(i),
            i
          );
        }
        deregister(e) {
          delete this._triggers[e],
            this._engine.statesByElement.forEach((t, n) => {
              delete t[e];
            }),
            this._elementListeners.forEach((t, n) => {
              this._elementListeners.set(
                n,
                t.filter((t) => t.name != e)
              );
            });
        }
        clearElementCache(e) {
          this._engine.statesByElement.delete(e), this._elementListeners.delete(e);
          const t = this._engine.playersByElement.get(e);
          t && (t.forEach((e) => e.destroy()), this._engine.playersByElement.delete(e));
        }
        _signalRemovalForInnerTriggers(e, t) {
          const n = this._engine.driver.query(e, ".ng-trigger", !0);
          n.forEach((e) => {
            if (e.__ng_removed) return;
            const n = this._engine.fetchNamespacesByElement(e);
            n.size ? n.forEach((n) => n.triggerLeaveAnimation(e, t, !1, !0)) : this.clearElementCache(e);
          }),
            this._engine.afterFlushAnimationsDone(() => n.forEach((e) => this.clearElementCache(e)));
        }
        triggerLeaveAnimation(e, t, n, s) {
          const r = this._engine.statesByElement.get(e);
          if (r) {
            const i = [];
            if (
              (Object.keys(r).forEach((t) => {
                if (this._triggers[t]) {
                  const n = this.trigger(e, t, "void", s);
                  n && i.push(n);
                }
              }),
              i.length)
            )
              return (
                this._engine.markElementAsRemoved(this.id, e, !0, t),
                n && Rp(i).onDone(() => this._engine.processLeaveNode(e)),
                !0
              );
          }
          return !1;
        }
        prepareLeaveAnimationListeners(e) {
          const t = this._elementListeners.get(e);
          if (t) {
            const n = new Set();
            t.forEach((t) => {
              const s = t.name;
              if (n.has(s)) return;
              n.add(s);
              const r = this._triggers[s].fallbackTransition,
                i = this._engine.statesByElement.get(e)[s] || h_,
                a = new u_("void"),
                o = new m_(this.id, s, e);
              this._engine.totalQueuedPlayers++,
                this._queue.push({
                  element: e,
                  triggerName: s,
                  transition: r,
                  fromState: i,
                  toState: a,
                  player: o,
                  isFallbackTransition: !0,
                });
            });
          }
        }
        removeNode(e, t) {
          const n = this._engine;
          if ((e.childElementCount && this._signalRemovalForInnerTriggers(e, t), this.triggerLeaveAnimation(e, t, !0)))
            return;
          let s = !1;
          if (n.totalAnimations) {
            const t = n.players.length ? n.playersByQueriedElement.get(e) : [];
            if (t && t.length) s = !0;
            else {
              let t = e;
              for (; (t = t.parentNode); )
                if (n.statesByElement.get(t)) {
                  s = !0;
                  break;
                }
            }
          }
          if ((this.prepareLeaveAnimationListeners(e), s)) n.markElementAsRemoved(this.id, e, !1, t);
          else {
            const s = e.__ng_removed;
            (s && s !== l_) ||
              (n.afterFlush(() => this.clearElementCache(e)), n.destroyInnerAnimations(e), n._onRemovalComplete(e, t));
          }
        }
        insertNode(e, t) {
          y_(e, this._hostClassName);
        }
        drainQueuedTransitions(e) {
          const t = [];
          return (
            this._queue.forEach((n) => {
              const s = n.player;
              if (s.destroyed) return;
              const r = n.element,
                i = this._elementListeners.get(r);
              i &&
                i.forEach((t) => {
                  if (t.name == n.triggerName) {
                    const s = Up(r, n.triggerName, n.fromState.value, n.toState.value);
                    (s._data = e), Fp(n.player, t.phase, s, t.callback);
                  }
                }),
                s.markedForDestroy
                  ? this._engine.afterFlush(() => {
                      s.destroy();
                    })
                  : t.push(n);
            }),
            (this._queue = []),
            t.sort((e, t) => {
              const n = e.transition.ast.depCount,
                s = t.transition.ast.depCount;
              return 0 == n || 0 == s ? n - s : this._engine.driver.containsElement(e.element, t.element) ? 1 : -1;
            })
          );
        }
        destroy(e) {
          this.players.forEach((e) => e.destroy()), this._signalRemovalForInnerTriggers(this.hostElement, e);
        }
        elementContainsData(e) {
          let t = !1;
          return this._elementListeners.has(e) && (t = !0), (t = !!this._queue.find((t) => t.element === e) || t), t;
        }
      }
      class p_ {
        constructor(e, t, n) {
          (this.bodyNode = e),
            (this.driver = t),
            (this._normalizer = n),
            (this.players = []),
            (this.newHostElements = new Map()),
            (this.playersByElement = new Map()),
            (this.playersByQueriedElement = new Map()),
            (this.statesByElement = new Map()),
            (this.disabledNodes = new Set()),
            (this.totalAnimations = 0),
            (this.totalQueuedPlayers = 0),
            (this._namespaceLookup = {}),
            (this._namespaceList = []),
            (this._flushFns = []),
            (this._whenQuietFns = []),
            (this.namespacesByHostElement = new Map()),
            (this.collectedEnterElements = []),
            (this.collectedLeaveElements = []),
            (this.onRemovalComplete = (e, t) => {});
        }
        _onRemovalComplete(e, t) {
          this.onRemovalComplete(e, t);
        }
        get queuedPlayers() {
          const e = [];
          return (
            this._namespaceList.forEach((t) => {
              t.players.forEach((t) => {
                t.queued && e.push(t);
              });
            }),
            e
          );
        }
        createNamespace(e, t) {
          const n = new M_(e, t, this);
          return (
            t.parentNode
              ? this._balanceNamespaceList(n, t)
              : (this.newHostElements.set(t, n), this.collectEnterElement(t)),
            (this._namespaceLookup[e] = n)
          );
        }
        _balanceNamespaceList(e, t) {
          const n = this._namespaceList.length - 1;
          if (n >= 0) {
            let s = !1;
            for (let r = n; r >= 0; r--)
              if (this.driver.containsElement(this._namespaceList[r].hostElement, t)) {
                this._namespaceList.splice(r + 1, 0, e), (s = !0);
                break;
              }
            s || this._namespaceList.splice(0, 0, e);
          } else this._namespaceList.push(e);
          return this.namespacesByHostElement.set(t, e), e;
        }
        register(e, t) {
          let n = this._namespaceLookup[e];
          return n || (n = this.createNamespace(e, t)), n;
        }
        registerTrigger(e, t, n) {
          let s = this._namespaceLookup[e];
          s && s.register(t, n) && this.totalAnimations++;
        }
        destroy(e, t) {
          if (!e) return;
          const n = this._fetchNamespace(e);
          this.afterFlush(() => {
            this.namespacesByHostElement.delete(n.hostElement), delete this._namespaceLookup[e];
            const t = this._namespaceList.indexOf(n);
            t >= 0 && this._namespaceList.splice(t, 1);
          }),
            this.afterFlushAnimationsDone(() => n.destroy(t));
        }
        _fetchNamespace(e) {
          return this._namespaceLookup[e];
        }
        fetchNamespacesByElement(e) {
          const t = new Set(),
            n = this.statesByElement.get(e);
          if (n) {
            const e = Object.keys(n);
            for (let s = 0; s < e.length; s++) {
              const r = n[e[s]].namespaceId;
              if (r) {
                const e = this._fetchNamespace(r);
                e && t.add(e);
              }
            }
          }
          return t;
        }
        trigger(e, t, n, s) {
          if (__(t)) {
            const r = this._fetchNamespace(e);
            if (r) return r.trigger(t, n, s), !0;
          }
          return !1;
        }
        insertNode(e, t, n, s) {
          if (!__(t)) return;
          const r = t.__ng_removed;
          if (r && r.setForRemoval) {
            (r.setForRemoval = !1), (r.setForMove = !0);
            const e = this.collectedLeaveElements.indexOf(t);
            e >= 0 && this.collectedLeaveElements.splice(e, 1);
          }
          if (e) {
            const s = this._fetchNamespace(e);
            s && s.insertNode(t, n);
          }
          s && this.collectEnterElement(t);
        }
        collectEnterElement(e) {
          this.collectedEnterElements.push(e);
        }
        markElementAsDisabled(e, t) {
          t
            ? this.disabledNodes.has(e) || (this.disabledNodes.add(e), y_(e, "ng-animate-disabled"))
            : this.disabledNodes.has(e) && (this.disabledNodes.delete(e), L_(e, "ng-animate-disabled"));
        }
        removeNode(e, t, n, s) {
          if (__(t)) {
            const r = e ? this._fetchNamespace(e) : null;
            if ((r ? r.removeNode(t, s) : this.markElementAsRemoved(e, t, !1, s), n)) {
              const n = this.namespacesByHostElement.get(t);
              n && n.id !== e && n.removeNode(t, s);
            }
          } else this._onRemovalComplete(t, s);
        }
        markElementAsRemoved(e, t, n, s) {
          this.collectedLeaveElements.push(t),
            (t.__ng_removed = { namespaceId: e, setForRemoval: s, hasAnimation: n, removedBeforeQueried: !1 });
        }
        listen(e, t, n, s, r) {
          return __(t) ? this._fetchNamespace(e).listen(t, n, s, r) : () => {};
        }
        _buildInstruction(e, t, n, s, r) {
          return e.transition.build(
            this.driver,
            e.element,
            e.fromState.value,
            e.toState.value,
            n,
            s,
            e.fromState.options,
            e.toState.options,
            t,
            r
          );
        }
        destroyInnerAnimations(e) {
          let t = this.driver.query(e, ".ng-trigger", !0);
          t.forEach((e) => this.destroyActiveAnimationsForElement(e)),
            0 != this.playersByQueriedElement.size &&
              ((t = this.driver.query(e, ".ng-animating", !0)),
              t.forEach((e) => this.finishActiveQueriedAnimationOnElement(e)));
        }
        destroyActiveAnimationsForElement(e) {
          const t = this.playersByElement.get(e);
          t &&
            t.forEach((e) => {
              e.queued ? (e.markedForDestroy = !0) : e.destroy();
            });
        }
        finishActiveQueriedAnimationOnElement(e) {
          const t = this.playersByQueriedElement.get(e);
          t && t.forEach((e) => e.finish());
        }
        whenRenderingDone() {
          return new Promise((e) => {
            if (this.players.length) return Rp(this.players).onDone(() => e());
            e();
          });
        }
        processLeaveNode(e) {
          const t = e.__ng_removed;
          if (t && t.setForRemoval) {
            if (((e.__ng_removed = l_), t.namespaceId)) {
              this.destroyInnerAnimations(e);
              const n = this._fetchNamespace(t.namespaceId);
              n && n.clearElementCache(e);
            }
            this._onRemovalComplete(e, t.setForRemoval);
          }
          this.driver.matchesElement(e, ".ng-animate-disabled") && this.markElementAsDisabled(e, !1),
            this.driver.query(e, ".ng-animate-disabled", !0).forEach((e) => {
              this.markElementAsDisabled(e, !1);
            });
        }
        flush(e = -1) {
          let t = [];
          if (
            (this.newHostElements.size &&
              (this.newHostElements.forEach((e, t) => this._balanceNamespaceList(e, t)), this.newHostElements.clear()),
            this.totalAnimations && this.collectedEnterElements.length)
          )
            for (let n = 0; n < this.collectedEnterElements.length; n++)
              y_(this.collectedEnterElements[n], "ng-star-inserted");
          if (this._namespaceList.length && (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
            const n = [];
            try {
              t = this._flushAnimations(n, e);
            } finally {
              for (let e = 0; e < n.length; e++) n[e]();
            }
          } else
            for (let n = 0; n < this.collectedLeaveElements.length; n++)
              this.processLeaveNode(this.collectedLeaveElements[n]);
          if (
            ((this.totalQueuedPlayers = 0),
            (this.collectedEnterElements.length = 0),
            (this.collectedLeaveElements.length = 0),
            this._flushFns.forEach((e) => e()),
            (this._flushFns = []),
            this._whenQuietFns.length)
          ) {
            const e = this._whenQuietFns;
            (this._whenQuietFns = []),
              t.length
                ? Rp(t).onDone(() => {
                    e.forEach((e) => e());
                  })
                : e.forEach((e) => e());
          }
        }
        reportError(e) {
          throw new Error(
            "Unable to process animations due to the following failed trigger transitions\n " + e.join("\n")
          );
        }
        _flushAnimations(e, t) {
          const n = new Pm(),
            s = [],
            r = new Map(),
            i = [],
            a = new Map(),
            o = new Map(),
            c = new Map(),
            l = new Set();
          this.disabledNodes.forEach((e) => {
            l.add(e);
            const t = this.driver.query(e, ".ng-animate-queued", !0);
            for (let n = 0; n < t.length; n++) l.add(t[n]);
          });
          const d = this.bodyNode,
            u = Array.from(this.statesByElement.keys()),
            h = g_(u, this.collectedEnterElements),
            M = new Map();
          let p = 0;
          h.forEach((e, t) => {
            const n = "ng-enter" + p++;
            M.set(t, n), e.forEach((e) => y_(e, n));
          });
          const m = [],
            _ = new Set(),
            f = new Set();
          for (let k = 0; k < this.collectedLeaveElements.length; k++) {
            const e = this.collectedLeaveElements[k],
              t = e.__ng_removed;
            t &&
              t.setForRemoval &&
              (m.push(e),
              _.add(e),
              t.hasAnimation ? this.driver.query(e, ".ng-star-inserted", !0).forEach((e) => _.add(e)) : f.add(e));
          }
          const b = new Map(),
            g = g_(u, Array.from(_));
          g.forEach((e, t) => {
            const n = "ng-leave" + p++;
            b.set(t, n), e.forEach((e) => y_(e, n));
          }),
            e.push(() => {
              h.forEach((e, t) => {
                const n = M.get(t);
                e.forEach((e) => L_(e, n));
              }),
                g.forEach((e, t) => {
                  const n = b.get(t);
                  e.forEach((e) => L_(e, n));
                }),
                m.forEach((e) => {
                  this.processLeaveNode(e);
                });
            });
          const y = [],
            L = [];
          for (let k = this._namespaceList.length - 1; k >= 0; k--)
            this._namespaceList[k].drainQueuedTransitions(t).forEach((e) => {
              const t = e.player,
                r = e.element;
              if ((y.push(t), this.collectedEnterElements.length)) {
                const e = r.__ng_removed;
                if (e && e.setForMove) return void t.destroy();
              }
              const l = !d || !this.driver.containsElement(d, r),
                u = b.get(r),
                h = M.get(r),
                p = this._buildInstruction(e, n, h, u, l);
              if (p.errors && p.errors.length) L.push(p);
              else {
                if (l)
                  return t.onStart(() => fm(r, p.fromStyles)), t.onDestroy(() => _m(r, p.toStyles)), void s.push(t);
                if (e.isFallbackTransition)
                  return t.onStart(() => fm(r, p.fromStyles)), t.onDestroy(() => _m(r, p.toStyles)), void s.push(t);
                p.timelines.forEach((e) => (e.stretchStartingKeyframe = !0)),
                  n.append(r, p.timelines),
                  i.push({ instruction: p, player: t, element: r }),
                  p.queriedElements.forEach((e) => Jp(a, e, []).push(t)),
                  p.preStyleProps.forEach((e, t) => {
                    const n = Object.keys(e);
                    if (n.length) {
                      let e = o.get(t);
                      e || o.set(t, (e = new Set())), n.forEach((t) => e.add(t));
                    }
                  }),
                  p.postStyleProps.forEach((e, t) => {
                    const n = Object.keys(e);
                    let s = c.get(t);
                    s || c.set(t, (s = new Set())), n.forEach((e) => s.add(e));
                  });
              }
            });
          if (L.length) {
            const e = [];
            L.forEach((t) => {
              e.push(`@${t.triggerName} has failed due to:\n`), t.errors.forEach((t) => e.push(`- ${t}\n`));
            }),
              y.forEach((e) => e.destroy()),
              this.reportError(e);
          }
          const A = new Map(),
            w = new Map();
          i.forEach((e) => {
            const t = e.element;
            n.has(t) && (w.set(t, t), this._beforeAnimationBuild(e.player.namespaceId, e.instruction, A));
          }),
            s.forEach((e) => {
              const t = e.element;
              this._getPreviousPlayers(t, !1, e.namespaceId, e.triggerName, null).forEach((e) => {
                Jp(A, t, []).push(e), e.destroy();
              });
            });
          const z = m.filter((e) => w_(e, o, c)),
            T = new Map();
          b_(T, this.driver, f, c, "*").forEach((e) => {
            w_(e, o, c) && z.push(e);
          });
          const v = new Map();
          h.forEach((e, t) => {
            b_(v, this.driver, new Set(e), o, "!");
          }),
            z.forEach((e) => {
              const t = T.get(e),
                n = v.get(e);
              T.set(e, Object.assign(Object.assign({}, t), n));
            });
          const D = [],
            O = [],
            S = {};
          i.forEach((e) => {
            const { element: t, player: i, instruction: a } = e;
            if (n.has(t)) {
              if (l.has(t))
                return (
                  i.onDestroy(() => _m(t, a.toStyles)),
                  (i.disabled = !0),
                  i.overrideTotalTime(a.totalTime),
                  void s.push(i)
                );
              let e = S;
              if (w.size > 1) {
                let n = t;
                const s = [];
                for (; (n = n.parentNode); ) {
                  const t = w.get(n);
                  if (t) {
                    e = t;
                    break;
                  }
                  s.push(n);
                }
                s.forEach((t) => w.set(t, e));
              }
              const n = this._buildAnimation(i.namespaceId, a, A, r, v, T);
              if ((i.setRealPlayer(n), e === S)) D.push(i);
              else {
                const t = this.playersByElement.get(e);
                t && t.length && (i.parentPlayer = Rp(t)), s.push(i);
              }
            } else fm(t, a.fromStyles), i.onDestroy(() => _m(t, a.toStyles)), O.push(i), l.has(t) && s.push(i);
          }),
            O.forEach((e) => {
              const t = r.get(e.element);
              if (t && t.length) {
                const n = Rp(t);
                e.setRealPlayer(n);
              }
            }),
            s.forEach((e) => {
              e.parentPlayer ? e.syncPlayerEvents(e.parentPlayer) : e.destroy();
            });
          for (let k = 0; k < m.length; k++) {
            const e = m[k],
              t = e.__ng_removed;
            if ((L_(e, "ng-leave"), t && t.hasAnimation)) continue;
            let n = [];
            if (a.size) {
              let t = a.get(e);
              t && t.length && n.push(...t);
              let s = this.driver.query(e, ".ng-animating", !0);
              for (let e = 0; e < s.length; e++) {
                let t = a.get(s[e]);
                t && t.length && n.push(...t);
              }
            }
            const s = n.filter((e) => !e.destroyed);
            s.length ? A_(this, e, s) : this.processLeaveNode(e);
          }
          return (
            (m.length = 0),
            D.forEach((e) => {
              this.players.push(e),
                e.onDone(() => {
                  e.destroy();
                  const t = this.players.indexOf(e);
                  this.players.splice(t, 1);
                }),
                e.play();
            }),
            D
          );
        }
        elementContainsData(e, t) {
          let n = !1;
          const s = t.__ng_removed;
          return (
            s && s.setForRemoval && (n = !0),
            this.playersByElement.has(t) && (n = !0),
            this.playersByQueriedElement.has(t) && (n = !0),
            this.statesByElement.has(t) && (n = !0),
            this._fetchNamespace(e).elementContainsData(t) || n
          );
        }
        afterFlush(e) {
          this._flushFns.push(e);
        }
        afterFlushAnimationsDone(e) {
          this._whenQuietFns.push(e);
        }
        _getPreviousPlayers(e, t, n, s, r) {
          let i = [];
          if (t) {
            const t = this.playersByQueriedElement.get(e);
            t && (i = t);
          } else {
            const t = this.playersByElement.get(e);
            if (t) {
              const e = !r || "void" == r;
              t.forEach((t) => {
                t.queued || ((e || t.triggerName == s) && i.push(t));
              });
            }
          }
          return (n || s) && (i = i.filter((e) => !((n && n != e.namespaceId) || (s && s != e.triggerName)))), i;
        }
        _beforeAnimationBuild(e, t, n) {
          const s = t.element,
            r = t.isRemovalTransition ? void 0 : e,
            i = t.isRemovalTransition ? void 0 : t.triggerName;
          for (const a of t.timelines) {
            const e = a.element,
              o = e !== s,
              c = Jp(n, e, []);
            this._getPreviousPlayers(e, o, r, i, t.toState).forEach((e) => {
              const t = e.getRealPlayer();
              t.beforeDestroy && t.beforeDestroy(), e.destroy(), c.push(e);
            });
          }
          fm(s, t.fromStyles);
        }
        _buildAnimation(e, t, n, s, r, i) {
          const a = t.triggerName,
            o = t.element,
            c = [],
            l = new Set(),
            d = new Set(),
            u = t.timelines.map((t) => {
              const u = t.element;
              l.add(u);
              const h = u.__ng_removed;
              if (h && h.removedBeforeQueried) return new jp(t.duration, t.delay);
              const M = u !== o,
                p = (function (e) {
                  const t = [];
                  return (
                    (function e(t, n) {
                      for (let s = 0; s < t.length; s++) {
                        const r = t[s];
                        r instanceof Pp ? e(r.players, n) : n.push(r);
                      }
                    })(e, t),
                    t
                  );
                })((n.get(u) || c_).map((e) => e.getRealPlayer())).filter((e) => !!e.element && e.element === u),
                m = r.get(u),
                _ = i.get(u),
                f = Ip(0, this._normalizer, 0, t.keyframes, m, _),
                b = this._buildPlayer(t, f, p);
              if ((t.subTimeline && s && d.add(u), M)) {
                const t = new m_(e, a, u);
                t.setRealPlayer(b), c.push(t);
              }
              return b;
            });
          c.forEach((e) => {
            Jp(this.playersByQueriedElement, e.element, []).push(e),
              e.onDone(() =>
                (function (e, t, n) {
                  let s;
                  if (e instanceof Map) {
                    if (((s = e.get(t)), s)) {
                      if (s.length) {
                        const e = s.indexOf(n);
                        s.splice(e, 1);
                      }
                      0 == s.length && e.delete(t);
                    }
                  } else if (((s = e[t]), s)) {
                    if (s.length) {
                      const e = s.indexOf(n);
                      s.splice(e, 1);
                    }
                    0 == s.length && delete e[t];
                  }
                  return s;
                })(this.playersByQueriedElement, e.element, e)
              );
          }),
            l.forEach((e) => y_(e, "ng-animating"));
          const h = Rp(u);
          return (
            h.onDestroy(() => {
              l.forEach((e) => L_(e, "ng-animating")), _m(o, t.toStyles);
            }),
            d.forEach((e) => {
              Jp(s, e, []).push(h);
            }),
            h
          );
        }
        _buildPlayer(e, t, n) {
          return t.length > 0
            ? this.driver.animate(e.element, t, e.duration, e.delay, e.easing, n)
            : new jp(e.duration, e.delay);
        }
      }
      class m_ {
        constructor(e, t, n) {
          (this.namespaceId = e),
            (this.triggerName = t),
            (this.element = n),
            (this._player = new jp()),
            (this._containsRealPlayer = !1),
            (this._queuedCallbacks = {}),
            (this.destroyed = !1),
            (this.markedForDestroy = !1),
            (this.disabled = !1),
            (this.queued = !0),
            (this.totalTime = 0);
        }
        setRealPlayer(e) {
          this._containsRealPlayer ||
            ((this._player = e),
            Object.keys(this._queuedCallbacks).forEach((t) => {
              this._queuedCallbacks[t].forEach((n) => Fp(e, t, void 0, n));
            }),
            (this._queuedCallbacks = {}),
            (this._containsRealPlayer = !0),
            this.overrideTotalTime(e.totalTime),
            (this.queued = !1));
        }
        getRealPlayer() {
          return this._player;
        }
        overrideTotalTime(e) {
          this.totalTime = e;
        }
        syncPlayerEvents(e) {
          const t = this._player;
          t.triggerCallback && e.onStart(() => t.triggerCallback("start")),
            e.onDone(() => this.finish()),
            e.onDestroy(() => this.destroy());
        }
        _queueEvent(e, t) {
          Jp(this._queuedCallbacks, e, []).push(t);
        }
        onDone(e) {
          this.queued && this._queueEvent("done", e), this._player.onDone(e);
        }
        onStart(e) {
          this.queued && this._queueEvent("start", e), this._player.onStart(e);
        }
        onDestroy(e) {
          this.queued && this._queueEvent("destroy", e), this._player.onDestroy(e);
        }
        init() {
          this._player.init();
        }
        hasStarted() {
          return !this.queued && this._player.hasStarted();
        }
        play() {
          !this.queued && this._player.play();
        }
        pause() {
          !this.queued && this._player.pause();
        }
        restart() {
          !this.queued && this._player.restart();
        }
        finish() {
          this._player.finish();
        }
        destroy() {
          (this.destroyed = !0), this._player.destroy();
        }
        reset() {
          !this.queued && this._player.reset();
        }
        setPosition(e) {
          this.queued || this._player.setPosition(e);
        }
        getPosition() {
          return this.queued ? 0 : this._player.getPosition();
        }
        triggerCallback(e) {
          const t = this._player;
          t.triggerCallback && t.triggerCallback(e);
        }
      }
      function __(e) {
        return e && 1 === e.nodeType;
      }
      function f_(e, t) {
        const n = e.style.display;
        return (e.style.display = null != t ? t : "none"), n;
      }
      function b_(e, t, n, s, r) {
        const i = [];
        n.forEach((e) => i.push(f_(e)));
        const a = [];
        s.forEach((n, s) => {
          const i = {};
          n.forEach((e) => {
            const n = (i[e] = t.computeStyle(s, e, r));
            (n && 0 != n.length) || ((s.__ng_removed = d_), a.push(s));
          }),
            e.set(s, i);
        });
        let o = 0;
        return n.forEach((e) => f_(e, i[o++])), a;
      }
      function g_(e, t) {
        const n = new Map();
        if ((e.forEach((e) => n.set(e, [])), 0 == t.length)) return n;
        const s = new Set(t),
          r = new Map();
        return (
          t.forEach((e) => {
            const t = (function e(t) {
              if (!t) return 1;
              let i = r.get(t);
              if (i) return i;
              const a = t.parentNode;
              return (i = n.has(a) ? a : s.has(a) ? 1 : e(a)), r.set(t, i), i;
            })(e);
            1 !== t && n.get(t).push(e);
          }),
          n
        );
      }
      function y_(e, t) {
        if (e.classList) e.classList.add(t);
        else {
          let n = e.$$classes;
          n || (n = e.$$classes = {}), (n[t] = !0);
        }
      }
      function L_(e, t) {
        if (e.classList) e.classList.remove(t);
        else {
          let n = e.$$classes;
          n && delete n[t];
        }
      }
      function A_(e, t, n) {
        Rp(n).onDone(() => e.processLeaveNode(t));
      }
      function w_(e, t, n) {
        const s = n.get(e);
        if (!s) return !1;
        let r = t.get(e);
        return r ? s.forEach((e) => r.add(e)) : t.set(e, s), n.delete(e), !0;
      }
      class z_ {
        constructor(e, t, n) {
          (this.bodyNode = e),
            (this._driver = t),
            (this._triggerCache = {}),
            (this.onRemovalComplete = (e, t) => {}),
            (this._transitionEngine = new p_(e, t, n)),
            (this._timelineEngine = new o_(e, t, n)),
            (this._transitionEngine.onRemovalComplete = (e, t) => this.onRemovalComplete(e, t));
        }
        registerTrigger(e, t, n, s, r) {
          const i = e + "-" + s;
          let a = this._triggerCache[i];
          if (!a) {
            const e = [],
              t = Cm(this._driver, r, e);
            if (e.length)
              throw new Error(
                `The animation trigger "${s}" has failed to build due to the following errors:\n - ${e.join("\n - ")}`
              );
            (a = (function (e, t) {
              return new r_(e, t);
            })(s, t)),
              (this._triggerCache[i] = a);
          }
          this._transitionEngine.registerTrigger(t, s, a);
        }
        register(e, t) {
          this._transitionEngine.register(e, t);
        }
        destroy(e, t) {
          this._transitionEngine.destroy(e, t);
        }
        onInsert(e, t, n, s) {
          this._transitionEngine.insertNode(e, t, n, s);
        }
        onRemove(e, t, n, s) {
          this._transitionEngine.removeNode(e, t, s || !1, n);
        }
        disableAnimations(e, t) {
          this._transitionEngine.markElementAsDisabled(e, t);
        }
        process(e, t, n, s) {
          if ("@" == n.charAt(0)) {
            const [e, r] = Gp(n);
            this._timelineEngine.command(e, t, r, s);
          } else this._transitionEngine.trigger(e, t, n, s);
        }
        listen(e, t, n, s, r) {
          if ("@" == n.charAt(0)) {
            const [e, s] = Gp(n);
            return this._timelineEngine.listen(e, t, s, r);
          }
          return this._transitionEngine.listen(e, t, n, s, r);
        }
        flush(e = -1) {
          this._transitionEngine.flush(e);
        }
        get players() {
          return this._transitionEngine.players.concat(this._timelineEngine.players);
        }
        whenRenderingDone() {
          return this._transitionEngine.whenRenderingDone();
        }
      }
      function T_(e, t) {
        let n = null,
          s = null;
        return (
          Array.isArray(t) && t.length ? ((n = D_(t[0])), t.length > 1 && (s = D_(t[t.length - 1]))) : t && (n = D_(t)),
          n || s ? new v_(e, n, s) : null
        );
      }
      let v_ = (() => {
        class e {
          constructor(t, n, s) {
            (this._element = t), (this._startStyles = n), (this._endStyles = s), (this._state = 0);
            let r = e.initialStylesByElement.get(t);
            r || e.initialStylesByElement.set(t, (r = {})), (this._initialStyles = r);
          }
          start() {
            this._state < 1 &&
              (this._startStyles && _m(this._element, this._startStyles, this._initialStyles), (this._state = 1));
          }
          finish() {
            this.start(),
              this._state < 2 &&
                (_m(this._element, this._initialStyles),
                this._endStyles && (_m(this._element, this._endStyles), (this._endStyles = null)),
                (this._state = 1));
          }
          destroy() {
            this.finish(),
              this._state < 3 &&
                (e.initialStylesByElement.delete(this._element),
                this._startStyles && (fm(this._element, this._startStyles), (this._endStyles = null)),
                this._endStyles && (fm(this._element, this._endStyles), (this._endStyles = null)),
                _m(this._element, this._initialStyles),
                (this._state = 3));
          }
        }
        return (e.initialStylesByElement = new WeakMap()), e;
      })();
      function D_(e) {
        let t = null;
        const n = Object.keys(e);
        for (let s = 0; s < n.length; s++) {
          const r = n[s];
          O_(r) && ((t = t || {}), (t[r] = e[r]));
        }
        return t;
      }
      function O_(e) {
        return "display" === e || "position" === e;
      }
      class S_ {
        constructor(e, t, n, s, r, i, a) {
          (this._element = e),
            (this._name = t),
            (this._duration = n),
            (this._delay = s),
            (this._easing = r),
            (this._fillMode = i),
            (this._onDoneFn = a),
            (this._finished = !1),
            (this._destroyed = !1),
            (this._startTime = 0),
            (this._position = 0),
            (this._eventFn = (e) => this._handleCallback(e));
        }
        apply() {
          !(function (e, t) {
            const n = W_(e, "").trim();
            n.length &&
              ((function (e, t) {
                let n = 0;
                for (let s = 0; s < e.length; s++) "," === e.charAt(s) && n++;
              })(n),
              (t = `${n}, ${t}`)),
              C_(e, "", t);
          })(
            this._element,
            `${this._duration}ms ${this._easing} ${this._delay}ms 1 normal ${this._fillMode} ${this._name}`
          ),
            E_(this._element, this._eventFn, !1),
            (this._startTime = Date.now());
        }
        pause() {
          k_(this._element, this._name, "paused");
        }
        resume() {
          k_(this._element, this._name, "running");
        }
        setPosition(e) {
          const t = Y_(this._element, this._name);
          (this._position = e * this._duration), C_(this._element, "Delay", `-${this._position}ms`, t);
        }
        getPosition() {
          return this._position;
        }
        _handleCallback(e) {
          const t = e._ngTestManualTimestamp || Date.now(),
            n = 1e3 * parseFloat(e.elapsedTime.toFixed(3));
          e.animationName == this._name &&
            Math.max(t - this._startTime, 0) >= this._delay &&
            n >= this._duration &&
            this.finish();
        }
        finish() {
          this._finished || ((this._finished = !0), this._onDoneFn(), E_(this._element, this._eventFn, !0));
        }
        destroy() {
          this._destroyed ||
            ((this._destroyed = !0),
            this.finish(),
            (function (e, t) {
              const n = W_(e, "").split(","),
                s = N_(n, t);
              s >= 0 && (n.splice(s, 1), C_(e, "", n.join(",")));
            })(this._element, this._name));
        }
      }
      function k_(e, t, n) {
        C_(e, "PlayState", n, Y_(e, t));
      }
      function Y_(e, t) {
        const n = W_(e, "");
        return n.indexOf(",") > 0 ? N_(n.split(","), t) : N_([n], t);
      }
      function N_(e, t) {
        for (let n = 0; n < e.length; n++) if (e[n].indexOf(t) >= 0) return n;
        return -1;
      }
      function E_(e, t, n) {
        n ? e.removeEventListener("animationend", t) : e.addEventListener("animationend", t);
      }
      function C_(e, t, n, s) {
        const r = "animation" + t;
        if (null != s) {
          const t = e.style[r];
          if (t.length) {
            const e = t.split(",");
            (e[s] = n), (n = e.join(","));
          }
        }
        e.style[r] = n;
      }
      function W_(e, t) {
        return e.style["animation" + t];
      }
      class q_ {
        constructor(e, t, n, s, r, i, a, o) {
          (this.element = e),
            (this.keyframes = t),
            (this.animationName = n),
            (this._duration = s),
            (this._delay = r),
            (this._finalStyles = a),
            (this._specialStyles = o),
            (this._onDoneFns = []),
            (this._onStartFns = []),
            (this._onDestroyFns = []),
            (this._started = !1),
            (this.currentSnapshot = {}),
            (this._state = 0),
            (this.easing = i || "linear"),
            (this.totalTime = s + r),
            this._buildStyler();
        }
        onStart(e) {
          this._onStartFns.push(e);
        }
        onDone(e) {
          this._onDoneFns.push(e);
        }
        onDestroy(e) {
          this._onDestroyFns.push(e);
        }
        destroy() {
          this.init(),
            this._state >= 4 ||
              ((this._state = 4),
              this._styler.destroy(),
              this._flushStartFns(),
              this._flushDoneFns(),
              this._specialStyles && this._specialStyles.destroy(),
              this._onDestroyFns.forEach((e) => e()),
              (this._onDestroyFns = []));
        }
        _flushDoneFns() {
          this._onDoneFns.forEach((e) => e()), (this._onDoneFns = []);
        }
        _flushStartFns() {
          this._onStartFns.forEach((e) => e()), (this._onStartFns = []);
        }
        finish() {
          this.init(),
            this._state >= 3 ||
              ((this._state = 3),
              this._styler.finish(),
              this._flushStartFns(),
              this._specialStyles && this._specialStyles.finish(),
              this._flushDoneFns());
        }
        setPosition(e) {
          this._styler.setPosition(e);
        }
        getPosition() {
          return this._styler.getPosition();
        }
        hasStarted() {
          return this._state >= 2;
        }
        init() {
          this._state >= 1 || ((this._state = 1), this._styler.apply(), this._delay && this._styler.pause());
        }
        play() {
          this.init(),
            this.hasStarted() ||
              (this._flushStartFns(), (this._state = 2), this._specialStyles && this._specialStyles.start()),
            this._styler.resume();
        }
        pause() {
          this.init(), this._styler.pause();
        }
        restart() {
          this.reset(), this.play();
        }
        reset() {
          this._styler.destroy(), this._buildStyler(), this._styler.apply();
        }
        _buildStyler() {
          this._styler = new S_(
            this.element,
            this.animationName,
            this._duration,
            this._delay,
            this.easing,
            "forwards",
            () => this.finish()
          );
        }
        triggerCallback(e) {
          const t = "start" == e ? this._onStartFns : this._onDoneFns;
          t.forEach((e) => e()), (t.length = 0);
        }
        beforeDestroy() {
          this.init();
          const e = {};
          if (this.hasStarted()) {
            const t = this._state >= 3;
            Object.keys(this._finalStyles).forEach((n) => {
              "offset" != n && (e[n] = t ? this._finalStyles[n] : Om(this.element, n));
            });
          }
          this.currentSnapshot = e;
        }
      }
      class x_ extends jp {
        constructor(e, t) {
          super(), (this.element = e), (this._startingStyles = {}), (this.__initialized = !1), (this._styles = am(t));
        }
        init() {
          !this.__initialized &&
            this._startingStyles &&
            ((this.__initialized = !0),
            Object.keys(this._styles).forEach((e) => {
              this._startingStyles[e] = this.element.style[e];
            }),
            super.init());
        }
        play() {
          this._startingStyles &&
            (this.init(),
            Object.keys(this._styles).forEach((e) => this.element.style.setProperty(e, this._styles[e])),
            super.play());
        }
        destroy() {
          this._startingStyles &&
            (Object.keys(this._startingStyles).forEach((e) => {
              const t = this._startingStyles[e];
              t ? this.element.style.setProperty(e, t) : this.element.style.removeProperty(e);
            }),
            (this._startingStyles = null),
            super.destroy());
        }
      }
      class B_ {
        constructor() {
          (this._count = 0), (this._head = document.querySelector("head")), (this._warningIssued = !1);
        }
        validateStyleProperty(e) {
          return nm(e);
        }
        matchesElement(e, t) {
          return sm(e, t);
        }
        containsElement(e, t) {
          return rm(e, t);
        }
        query(e, t, n) {
          return im(e, t, n);
        }
        computeStyle(e, t, n) {
          return window.getComputedStyle(e)[t];
        }
        buildKeyframeElement(e, t, n) {
          n = n.map((e) => am(e));
          let s = `@keyframes ${t} {\n`,
            r = "";
          n.forEach((e) => {
            r = " ";
            const t = parseFloat(e.offset);
            (s += `${r}${100 * t}% {\n`),
              (r += " "),
              Object.keys(e).forEach((t) => {
                const n = e[t];
                switch (t) {
                  case "offset":
                    return;
                  case "easing":
                    return void (n && (s += `${r}animation-timing-function: ${n};\n`));
                  default:
                    return void (s += `${r}${t}: ${n};\n`);
                }
              }),
              (s += r + "}\n");
          }),
            (s += "}\n");
          const i = document.createElement("style");
          return (i.textContent = s), i;
        }
        animate(e, t, n, s, r, i = [], a) {
          a && this._notifyFaultyScrubber();
          const o = i.filter((e) => e instanceof q_),
            c = {};
          Tm(n, s) &&
            o.forEach((e) => {
              let t = e.currentSnapshot;
              Object.keys(t).forEach((e) => (c[e] = t[e]));
            });
          const l = (function (e) {
            let t = {};
            return (
              e &&
                (Array.isArray(e) ? e : [e]).forEach((e) => {
                  Object.keys(e).forEach((n) => {
                    "offset" != n && "easing" != n && (t[n] = e[n]);
                  });
                }),
              t
            );
          })((t = vm(e, t, c)));
          if (0 == n) return new x_(e, l);
          const d = "gen_css_kf_" + this._count++,
            u = this.buildKeyframeElement(e, d, t);
          document.querySelector("head").appendChild(u);
          const h = T_(e, t),
            M = new q_(e, t, d, n, s, r, l, h);
          return (
            M.onDestroy(() => {
              var e;
              (e = u).parentNode.removeChild(e);
            }),
            M
          );
        }
        _notifyFaultyScrubber() {
          this._warningIssued ||
            (console.warn(
              "@angular/animations: please load the web-animations.js polyfill to allow programmatic access...\n",
              "  visit http://bit.ly/IWukam to learn more about using the web-animation-js polyfill."
            ),
            (this._warningIssued = !0));
        }
      }
      class H_ {
        constructor(e, t, n, s) {
          (this.element = e),
            (this.keyframes = t),
            (this.options = n),
            (this._specialStyles = s),
            (this._onDoneFns = []),
            (this._onStartFns = []),
            (this._onDestroyFns = []),
            (this._initialized = !1),
            (this._finished = !1),
            (this._started = !1),
            (this._destroyed = !1),
            (this.time = 0),
            (this.parentPlayer = null),
            (this.currentSnapshot = {}),
            (this._duration = n.duration),
            (this._delay = n.delay || 0),
            (this.time = this._duration + this._delay);
        }
        _onFinish() {
          this._finished || ((this._finished = !0), this._onDoneFns.forEach((e) => e()), (this._onDoneFns = []));
        }
        init() {
          this._buildPlayer(), this._preparePlayerBeforeStart();
        }
        _buildPlayer() {
          if (this._initialized) return;
          this._initialized = !0;
          const e = this.keyframes;
          (this.domPlayer = this._triggerWebAnimation(this.element, e, this.options)),
            (this._finalKeyframe = e.length ? e[e.length - 1] : {}),
            this.domPlayer.addEventListener("finish", () => this._onFinish());
        }
        _preparePlayerBeforeStart() {
          this._delay ? this._resetDomPlayerState() : this.domPlayer.pause();
        }
        _triggerWebAnimation(e, t, n) {
          return e.animate(t, n);
        }
        onStart(e) {
          this._onStartFns.push(e);
        }
        onDone(e) {
          this._onDoneFns.push(e);
        }
        onDestroy(e) {
          this._onDestroyFns.push(e);
        }
        play() {
          this._buildPlayer(),
            this.hasStarted() ||
              (this._onStartFns.forEach((e) => e()),
              (this._onStartFns = []),
              (this._started = !0),
              this._specialStyles && this._specialStyles.start()),
            this.domPlayer.play();
        }
        pause() {
          this.init(), this.domPlayer.pause();
        }
        finish() {
          this.init(), this._specialStyles && this._specialStyles.finish(), this._onFinish(), this.domPlayer.finish();
        }
        reset() {
          this._resetDomPlayerState(), (this._destroyed = !1), (this._finished = !1), (this._started = !1);
        }
        _resetDomPlayerState() {
          this.domPlayer && this.domPlayer.cancel();
        }
        restart() {
          this.reset(), this.play();
        }
        hasStarted() {
          return this._started;
        }
        destroy() {
          this._destroyed ||
            ((this._destroyed = !0),
            this._resetDomPlayerState(),
            this._onFinish(),
            this._specialStyles && this._specialStyles.destroy(),
            this._onDestroyFns.forEach((e) => e()),
            (this._onDestroyFns = []));
        }
        setPosition(e) {
          this.domPlayer.currentTime = e * this.time;
        }
        getPosition() {
          return this.domPlayer.currentTime / this.time;
        }
        get totalTime() {
          return this._delay + this._duration;
        }
        beforeDestroy() {
          const e = {};
          this.hasStarted() &&
            Object.keys(this._finalKeyframe).forEach((t) => {
              "offset" != t && (e[t] = this._finished ? this._finalKeyframe[t] : Om(this.element, t));
            }),
            (this.currentSnapshot = e);
        }
        triggerCallback(e) {
          const t = "start" == e ? this._onStartFns : this._onDoneFns;
          t.forEach((e) => e()), (t.length = 0);
        }
      }
      class j_ {
        constructor() {
          (this._isNativeImpl = /\{\s*\[native\s+code\]\s*\}/.test(P_().toString())),
            (this._cssKeyframesDriver = new B_());
        }
        validateStyleProperty(e) {
          return nm(e);
        }
        matchesElement(e, t) {
          return sm(e, t);
        }
        containsElement(e, t) {
          return rm(e, t);
        }
        query(e, t, n) {
          return im(e, t, n);
        }
        computeStyle(e, t, n) {
          return window.getComputedStyle(e)[t];
        }
        overrideWebAnimationsSupport(e) {
          this._isNativeImpl = e;
        }
        animate(e, t, n, s, r, i = [], a) {
          if (!a && !this._isNativeImpl) return this._cssKeyframesDriver.animate(e, t, n, s, r, i);
          const o = { duration: n, delay: s, fill: 0 == s ? "both" : "forwards" };
          r && (o.easing = r);
          const c = {},
            l = i.filter((e) => e instanceof H_);
          Tm(n, s) &&
            l.forEach((e) => {
              let t = e.currentSnapshot;
              Object.keys(t).forEach((e) => (c[e] = t[e]));
            });
          const d = T_(e, (t = vm(e, (t = t.map((e) => Mm(e, !1))), c)));
          return new H_(e, t, o, d);
        }
      }
      function P_() {
        return ("undefined" != typeof window && void 0 !== window.document && Element.prototype.animate) || {};
      }
      let X_ = (() => {
        class e extends Ep {
          constructor(e, t) {
            super(),
              (this._nextAnimationId = 0),
              (this._renderer = e.createRenderer(t.body, {
                id: "0",
                encapsulation: at.None,
                styles: [],
                data: { animation: [] },
              }));
          }
          build(e) {
            const t = this._nextAnimationId.toString();
            this._nextAnimationId++;
            const n = Array.isArray(e) ? Wp(e) : e;
            return F_(this._renderer, null, t, "register", [n]), new R_(t, this._renderer);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Ia), Ve(Gc));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      class R_ extends class {} {
        constructor(e, t) {
          super(), (this._id = e), (this._renderer = t);
        }
        create(e, t) {
          return new I_(this._id, e, t || {}, this._renderer);
        }
      }
      class I_ {
        constructor(e, t, n, s) {
          (this.id = e),
            (this.element = t),
            (this._renderer = s),
            (this.parentPlayer = null),
            (this._started = !1),
            (this.totalTime = 0),
            this._command("create", n);
        }
        _listen(e, t) {
          return this._renderer.listen(this.element, `@@${this.id}:${e}`, t);
        }
        _command(e, ...t) {
          return F_(this._renderer, this.element, this.id, e, t);
        }
        onDone(e) {
          this._listen("done", e);
        }
        onStart(e) {
          this._listen("start", e);
        }
        onDestroy(e) {
          this._listen("destroy", e);
        }
        init() {
          this._command("init");
        }
        hasStarted() {
          return this._started;
        }
        play() {
          this._command("play"), (this._started = !0);
        }
        pause() {
          this._command("pause");
        }
        restart() {
          this._command("restart");
        }
        finish() {
          this._command("finish");
        }
        destroy() {
          this._command("destroy");
        }
        reset() {
          this._command("reset");
        }
        setPosition(e) {
          this._command("setPosition", e);
        }
        getPosition() {
          return 0;
        }
      }
      function F_(e, t, n, s, r) {
        return e.setProperty(t, `@@${n}:${s}`, r);
      }
      let V_ = (() => {
        class e {
          constructor(e, t, n) {
            (this.delegate = e),
              (this.engine = t),
              (this._zone = n),
              (this._currentId = 0),
              (this._microtaskId = 1),
              (this._animationCallbacksBuffer = []),
              (this._rendererCache = new Map()),
              (this._cdRecurDepth = 0),
              (this.promise = Promise.resolve(0)),
              (t.onRemovalComplete = (e, t) => {
                t && t.parentNode(e) && t.removeChild(e.parentNode, e);
              });
          }
          createRenderer(e, t) {
            const n = this.delegate.createRenderer(e, t);
            if (!(e && t && t.data && t.data.animation)) {
              let e = this._rendererCache.get(n);
              return e || ((e = new U_("", n, this.engine)), this._rendererCache.set(n, e)), e;
            }
            const s = t.id,
              r = t.id + "-" + this._currentId;
            this._currentId++, this.engine.register(r, e);
            const i = (t) => {
              Array.isArray(t) ? t.forEach(i) : this.engine.registerTrigger(s, r, e, t.name, t);
            };
            return t.data.animation.forEach(i), new J_(this, r, n, this.engine);
          }
          begin() {
            this._cdRecurDepth++, this.delegate.begin && this.delegate.begin();
          }
          _scheduleCountTask() {
            this.promise.then(() => {
              this._microtaskId++;
            });
          }
          scheduleListenerCallback(e, t, n) {
            e >= 0 && e < this._microtaskId
              ? this._zone.run(() => t(n))
              : (0 == this._animationCallbacksBuffer.length &&
                  Promise.resolve(null).then(() => {
                    this._zone.run(() => {
                      this._animationCallbacksBuffer.forEach((e) => {
                        const [t, n] = e;
                        t(n);
                      }),
                        (this._animationCallbacksBuffer = []);
                    });
                  }),
                this._animationCallbacksBuffer.push([t, n]));
          }
          end() {
            this._cdRecurDepth--,
              0 == this._cdRecurDepth &&
                this._zone.runOutsideAngular(() => {
                  this._scheduleCountTask(), this.engine.flush(this._microtaskId);
                }),
              this.delegate.end && this.delegate.end();
          }
          whenRenderingDone() {
            return this.engine.whenRenderingDone();
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Ia), Ve(z_), Ve(bc));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      class U_ {
        constructor(e, t, n) {
          (this.namespaceId = e),
            (this.delegate = t),
            (this.engine = n),
            (this.destroyNode = this.delegate.destroyNode ? (e) => t.destroyNode(e) : null);
        }
        get data() {
          return this.delegate.data;
        }
        destroy() {
          this.engine.destroy(this.namespaceId, this.delegate), this.delegate.destroy();
        }
        createElement(e, t) {
          return this.delegate.createElement(e, t);
        }
        createComment(e) {
          return this.delegate.createComment(e);
        }
        createText(e) {
          return this.delegate.createText(e);
        }
        appendChild(e, t) {
          this.delegate.appendChild(e, t), this.engine.onInsert(this.namespaceId, t, e, !1);
        }
        insertBefore(e, t, n) {
          this.delegate.insertBefore(e, t, n), this.engine.onInsert(this.namespaceId, t, e, !0);
        }
        removeChild(e, t, n) {
          this.engine.onRemove(this.namespaceId, t, this.delegate, n);
        }
        selectRootElement(e, t) {
          return this.delegate.selectRootElement(e, t);
        }
        parentNode(e) {
          return this.delegate.parentNode(e);
        }
        nextSibling(e) {
          return this.delegate.nextSibling(e);
        }
        setAttribute(e, t, n, s) {
          this.delegate.setAttribute(e, t, n, s);
        }
        removeAttribute(e, t, n) {
          this.delegate.removeAttribute(e, t, n);
        }
        addClass(e, t) {
          this.delegate.addClass(e, t);
        }
        removeClass(e, t) {
          this.delegate.removeClass(e, t);
        }
        setStyle(e, t, n, s) {
          this.delegate.setStyle(e, t, n, s);
        }
        removeStyle(e, t, n) {
          this.delegate.removeStyle(e, t, n);
        }
        setProperty(e, t, n) {
          "@" == t.charAt(0) && "@.disabled" == t ? this.disableAnimations(e, !!n) : this.delegate.setProperty(e, t, n);
        }
        setValue(e, t) {
          this.delegate.setValue(e, t);
        }
        listen(e, t, n) {
          return this.delegate.listen(e, t, n);
        }
        disableAnimations(e, t) {
          this.engine.disableAnimations(e, t);
        }
      }
      class J_ extends U_ {
        constructor(e, t, n, s) {
          super(t, n, s), (this.factory = e), (this.namespaceId = t);
        }
        setProperty(e, t, n) {
          "@" == t.charAt(0)
            ? "." == t.charAt(1) && "@.disabled" == t
              ? this.disableAnimations(e, (n = void 0 === n || !!n))
              : this.engine.process(this.namespaceId, e, t.substr(1), n)
            : this.delegate.setProperty(e, t, n);
        }
        listen(e, t, n) {
          if ("@" == t.charAt(0)) {
            const s = (function (e) {
              switch (e) {
                case "body":
                  return document.body;
                case "document":
                  return document;
                case "window":
                  return window;
                default:
                  return e;
              }
            })(e);
            let r = t.substr(1),
              i = "";
            return (
              "@" != r.charAt(0) &&
                ([r, i] = (function (e) {
                  const t = e.indexOf(".");
                  return [e.substring(0, t), e.substr(t + 1)];
                })(r)),
              this.engine.listen(this.namespaceId, s, r, i, (e) => {
                this.factory.scheduleListenerCallback(e._data || -1, n, e);
              })
            );
          }
          return this.delegate.listen(e, t, n);
        }
      }
      let G_ = (() => {
        class e extends z_ {
          constructor(e, t, n) {
            super(e.body, t, n);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Ve(Gc), Ve(cm), Ve(Km));
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
          e
        );
      })();
      const Q_ = [
        {
          provide: cm,
          useFactory: function () {
            return "function" == typeof P_() ? new j_() : new B_();
          },
        },
        { provide: new qe("AnimationModuleType"), useValue: "BrowserAnimations" },
        { provide: Ep, useClass: X_ },
        {
          provide: Km,
          useFactory: function () {
            return new $m();
          },
        },
        { provide: z_, useClass: G_ },
        {
          provide: Ia,
          useFactory: function (e, t, n) {
            return new V_(e, t, n);
          },
          deps: [bd, z_, bc],
        },
      ];
      let K_ = (() => {
        class e {}
        return (
          (e.ɵmod = pt({ type: e })),
          (e.ɵinj = le({
            factory: function (t) {
              return new (t || e)();
            },
            providers: Q_,
            imports: [kd],
          })),
          e
        );
      })();
      function $_(e, t) {
        return new b((n) => {
          const s = e.length;
          if (0 === s) return void n.complete();
          const r = new Array(s);
          let i = 0,
            a = 0;
          for (let o = 0; o < s; o++) {
            const c = q(e[o]);
            let l = !1;
            n.add(
              c.subscribe({
                next: (e) => {
                  l || ((l = !0), a++), (r[o] = e);
                },
                error: (e) => n.error(e),
                complete: () => {
                  i++,
                    (i !== s && l) ||
                      (a === s && n.next(t ? t.reduce((e, t, n) => ((e[t] = r[n]), e), {}) : r), n.complete());
                },
              })
            );
          }
        });
      }
      const Z_ = new qe("NgValueAccessor"),
        ef = { provide: Z_, useExisting: Le(() => tf), multi: !0 };
      let tf = (() => {
        class e {
          constructor(e, t) {
            (this._renderer = e), (this._elementRef = t), (this.onChange = (e) => {}), (this.onTouched = () => {});
          }
          writeValue(e) {
            this._renderer.setProperty(this._elementRef.nativeElement, "checked", e);
          }
          registerOnChange(e) {
            this.onChange = e;
          }
          registerOnTouched(e) {
            this.onTouched = e;
          }
          setDisabledState(e) {
            this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(Va), Hi(Xa));
          }),
          (e.ɵdir = _t({
            type: e,
            selectors: [
              ["input", "type", "checkbox", "formControlName", ""],
              ["input", "type", "checkbox", "formControl", ""],
              ["input", "type", "checkbox", "ngModel", ""],
            ],
            hostBindings: function (e, t) {
              1 & e &&
                Ji("change", function (e) {
                  return t.onChange(e.target.checked);
                })("blur", function () {
                  return t.onTouched();
                });
            },
            features: [Ba([ef])],
          })),
          e
        );
      })();
      const nf = { provide: Z_, useExisting: Le(() => rf), multi: !0 },
        sf = new qe("CompositionEventMode");
      let rf = (() => {
          class e {
            constructor(e, t, n) {
              (this._renderer = e),
                (this._elementRef = t),
                (this._compositionMode = n),
                (this.onChange = (e) => {}),
                (this.onTouched = () => {}),
                (this._composing = !1),
                null == this._compositionMode &&
                  (this._compositionMode = !(function () {
                    const e = Jc() ? Jc().getUserAgent() : "";
                    return /android (\d+)/.test(e.toLowerCase());
                  })());
            }
            writeValue(e) {
              this._renderer.setProperty(this._elementRef.nativeElement, "value", null == e ? "" : e);
            }
            registerOnChange(e) {
              this.onChange = e;
            }
            registerOnTouched(e) {
              this.onTouched = e;
            }
            setDisabledState(e) {
              this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
            }
            _handleInput(e) {
              (!this._compositionMode || (this._compositionMode && !this._composing)) && this.onChange(e);
            }
            _compositionStart() {
              this._composing = !0;
            }
            _compositionEnd(e) {
              (this._composing = !1), this._compositionMode && this.onChange(e);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Va), Hi(Xa), Hi(sf, 8));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [
                ["input", "formControlName", "", 3, "type", "checkbox"],
                ["textarea", "formControlName", ""],
                ["input", "formControl", "", 3, "type", "checkbox"],
                ["textarea", "formControl", ""],
                ["input", "ngModel", "", 3, "type", "checkbox"],
                ["textarea", "ngModel", ""],
                ["", "ngDefaultControl", ""],
              ],
              hostBindings: function (e, t) {
                1 & e &&
                  Ji("input", function (e) {
                    return t._handleInput(e.target.value);
                  })("blur", function () {
                    return t.onTouched();
                  })("compositionstart", function () {
                    return t._compositionStart();
                  })("compositionend", function (e) {
                    return t._compositionEnd(e.target.value);
                  });
              },
              features: [Ba([nf])],
            })),
            e
          );
        })(),
        af = (() => {
          class e {
            get value() {
              return this.control ? this.control.value : null;
            }
            get valid() {
              return this.control ? this.control.valid : null;
            }
            get invalid() {
              return this.control ? this.control.invalid : null;
            }
            get pending() {
              return this.control ? this.control.pending : null;
            }
            get disabled() {
              return this.control ? this.control.disabled : null;
            }
            get enabled() {
              return this.control ? this.control.enabled : null;
            }
            get errors() {
              return this.control ? this.control.errors : null;
            }
            get pristine() {
              return this.control ? this.control.pristine : null;
            }
            get dirty() {
              return this.control ? this.control.dirty : null;
            }
            get touched() {
              return this.control ? this.control.touched : null;
            }
            get status() {
              return this.control ? this.control.status : null;
            }
            get untouched() {
              return this.control ? this.control.untouched : null;
            }
            get statusChanges() {
              return this.control ? this.control.statusChanges : null;
            }
            get valueChanges() {
              return this.control ? this.control.valueChanges : null;
            }
            get path() {
              return null;
            }
            reset(e) {
              this.control && this.control.reset(e);
            }
            hasError(e, t) {
              return !!this.control && this.control.hasError(e, t);
            }
            getError(e, t) {
              return this.control ? this.control.getError(e, t) : null;
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵdir = _t({ type: e })),
            e
          );
        })(),
        of = (() => {
          class e extends af {
            get formDirective() {
              return null;
            }
            get path() {
              return null;
            }
          }
          return (
            (e.ɵfac = function (t) {
              return cf(t || e);
            }),
            (e.ɵdir = _t({ type: e, features: [Li] })),
            e
          );
        })();
      const cf = ls(of);
      class lf extends af {
        constructor() {
          super(...arguments),
            (this._parent = null),
            (this.name = null),
            (this.valueAccessor = null),
            (this._rawValidators = []),
            (this._rawAsyncValidators = []);
        }
        get validator() {}
        get asyncValidator() {}
      }
      let df = (() => {
        class e extends class {
          constructor(e) {
            this._cd = e;
          }
          get ngClassUntouched() {
            return !!this._cd.control && this._cd.control.untouched;
          }
          get ngClassTouched() {
            return !!this._cd.control && this._cd.control.touched;
          }
          get ngClassPristine() {
            return !!this._cd.control && this._cd.control.pristine;
          }
          get ngClassDirty() {
            return !!this._cd.control && this._cd.control.dirty;
          }
          get ngClassValid() {
            return !!this._cd.control && this._cd.control.valid;
          }
          get ngClassInvalid() {
            return !!this._cd.control && this._cd.control.invalid;
          }
          get ngClassPending() {
            return !!this._cd.control && this._cd.control.pending;
          }
        } {
          constructor(e) {
            super(e);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(lf, 2));
          }),
          (e.ɵdir = _t({
            type: e,
            selectors: [
              ["", "formControlName", ""],
              ["", "ngModel", ""],
              ["", "formControl", ""],
            ],
            hostVars: 14,
            hostBindings: function (e, t) {
              2 & e &&
                la("ng-untouched", t.ngClassUntouched)("ng-touched", t.ngClassTouched)(
                  "ng-pristine",
                  t.ngClassPristine
                )("ng-dirty", t.ngClassDirty)("ng-valid", t.ngClassValid)("ng-invalid", t.ngClassInvalid)(
                  "ng-pending",
                  t.ngClassPending
                );
            },
            features: [Li],
          })),
          e
        );
      })();
      function uf(e) {
        return null == e || 0 === e.length;
      }
      function hf(e) {
        return null != e && "number" == typeof e.length;
      }
      const Mf = new qe("NgValidators"),
        pf = new qe("NgAsyncValidators"),
        mf =
          /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      class _f {
        static min(e) {
          return (t) => {
            if (uf(t.value) || uf(e)) return null;
            const n = parseFloat(t.value);
            return !isNaN(n) && n < e ? { min: { min: e, actual: t.value } } : null;
          };
        }
        static max(e) {
          return (t) => {
            if (uf(t.value) || uf(e)) return null;
            const n = parseFloat(t.value);
            return !isNaN(n) && n > e ? { max: { max: e, actual: t.value } } : null;
          };
        }
        static required(e) {
          return uf(e.value) ? { required: !0 } : null;
        }
        static requiredTrue(e) {
          return !0 === e.value ? null : { required: !0 };
        }
        static email(e) {
          return uf(e.value) || mf.test(e.value) ? null : { email: !0 };
        }
        static minLength(e) {
          return (t) =>
            uf(t.value) || !hf(t.value)
              ? null
              : t.value.length < e
              ? { minlength: { requiredLength: e, actualLength: t.value.length } }
              : null;
        }
        static maxLength(e) {
          return (t) =>
            hf(t.value) && t.value.length > e
              ? { maxlength: { requiredLength: e, actualLength: t.value.length } }
              : null;
        }
        static pattern(e) {
          if (!e) return _f.nullValidator;
          let t, n;
          return (
            "string" == typeof e
              ? ((n = ""),
                "^" !== e.charAt(0) && (n += "^"),
                (n += e),
                "$" !== e.charAt(e.length - 1) && (n += "$"),
                (t = new RegExp(n)))
              : ((n = e.toString()), (t = e)),
            (e) => {
              if (uf(e.value)) return null;
              const s = e.value;
              return t.test(s) ? null : { pattern: { requiredPattern: n, actualValue: s } };
            }
          );
        }
        static nullValidator(e) {
          return null;
        }
        static compose(e) {
          if (!e) return null;
          const t = e.filter(ff);
          return 0 == t.length
            ? null
            : function (e) {
                return gf(yf(e, t));
              };
        }
        static composeAsync(e) {
          if (!e) return null;
          const t = e.filter(ff);
          return 0 == t.length
            ? null
            : function (e) {
                return (function (...e) {
                  if (1 === e.length) {
                    const t = e[0];
                    if (c(t)) return $_(t, null);
                    if (l(t) && Object.getPrototypeOf(t) === Object.prototype) {
                      const e = Object.keys(t);
                      return $_(
                        e.map((e) => t[e]),
                        e
                      );
                    }
                  }
                  if ("function" == typeof e[e.length - 1]) {
                    const t = e.pop();
                    return $_((e = 1 === e.length && c(e[0]) ? e[0] : e), null).pipe(v((e) => t(...e)));
                  }
                  return $_(e, null);
                })(yf(e, t).map(bf)).pipe(v(gf));
              };
        }
      }
      function ff(e) {
        return null != e;
      }
      function bf(e) {
        const t = Vi(e) ? q(e) : e;
        return Ui(t), t;
      }
      function gf(e) {
        let t = {};
        return (
          e.forEach((e) => {
            t = null != e ? Object.assign(Object.assign({}, t), e) : t;
          }),
          0 === Object.keys(t).length ? null : t
        );
      }
      function yf(e, t) {
        return t.map((t) => t(e));
      }
      function Lf(e) {
        return e.map((e) =>
          (function (e) {
            return !e.validate;
          })(e)
            ? e
            : (t) => e.validate(t)
        );
      }
      const Af = { provide: Z_, useExisting: Le(() => wf), multi: !0 };
      let wf = (() => {
        class e {
          constructor(e, t) {
            (this._renderer = e), (this._elementRef = t), (this.onChange = (e) => {}), (this.onTouched = () => {});
          }
          writeValue(e) {
            this._renderer.setProperty(this._elementRef.nativeElement, "value", null == e ? "" : e);
          }
          registerOnChange(e) {
            this.onChange = (t) => {
              e("" == t ? null : parseFloat(t));
            };
          }
          registerOnTouched(e) {
            this.onTouched = e;
          }
          setDisabledState(e) {
            this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(Va), Hi(Xa));
          }),
          (e.ɵdir = _t({
            type: e,
            selectors: [
              ["input", "type", "number", "formControlName", ""],
              ["input", "type", "number", "formControl", ""],
              ["input", "type", "number", "ngModel", ""],
            ],
            hostBindings: function (e, t) {
              1 & e &&
                Ji("input", function (e) {
                  return t.onChange(e.target.value);
                })("blur", function () {
                  return t.onTouched();
                });
            },
            features: [Ba([Af])],
          })),
          e
        );
      })();
      const zf = { provide: Z_, useExisting: Le(() => vf), multi: !0 };
      let Tf = (() => {
          class e {
            constructor() {
              this._accessors = [];
            }
            add(e, t) {
              this._accessors.push([e, t]);
            }
            remove(e) {
              for (let t = this._accessors.length - 1; t >= 0; --t)
                if (this._accessors[t][1] === e) return void this._accessors.splice(t, 1);
            }
            select(e) {
              this._accessors.forEach((t) => {
                this._isSameGroup(t, e) && t[1] !== e && t[1].fireUncheck(e.value);
              });
            }
            _isSameGroup(e, t) {
              return !!e[0].control && e[0]._parent === t._control._parent && e[1].name === t.name;
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵprov = ce({ token: e, factory: e.ɵfac })),
            e
          );
        })(),
        vf = (() => {
          class e {
            constructor(e, t, n, s) {
              (this._renderer = e),
                (this._elementRef = t),
                (this._registry = n),
                (this._injector = s),
                (this.onChange = () => {}),
                (this.onTouched = () => {});
            }
            ngOnInit() {
              (this._control = this._injector.get(lf)), this._checkName(), this._registry.add(this._control, this);
            }
            ngOnDestroy() {
              this._registry.remove(this);
            }
            writeValue(e) {
              (this._state = e === this.value),
                this._renderer.setProperty(this._elementRef.nativeElement, "checked", this._state);
            }
            registerOnChange(e) {
              (this._fn = e),
                (this.onChange = () => {
                  e(this.value), this._registry.select(this);
                });
            }
            fireUncheck(e) {
              this.writeValue(e);
            }
            registerOnTouched(e) {
              this.onTouched = e;
            }
            setDisabledState(e) {
              this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
            }
            _checkName() {
              !this.name && this.formControlName && (this.name = this.formControlName);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Va), Hi(Xa), Hi(Tf), Hi(fi));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [
                ["input", "type", "radio", "formControlName", ""],
                ["input", "type", "radio", "formControl", ""],
                ["input", "type", "radio", "ngModel", ""],
              ],
              hostBindings: function (e, t) {
                1 & e &&
                  Ji("change", function () {
                    return t.onChange();
                  })("blur", function () {
                    return t.onTouched();
                  });
              },
              inputs: { name: "name", formControlName: "formControlName", value: "value" },
              features: [Ba([zf])],
            })),
            e
          );
        })();
      const Df = { provide: Z_, useExisting: Le(() => Of), multi: !0 };
      let Of = (() => {
        class e {
          constructor(e, t) {
            (this._renderer = e), (this._elementRef = t), (this.onChange = (e) => {}), (this.onTouched = () => {});
          }
          writeValue(e) {
            this._renderer.setProperty(this._elementRef.nativeElement, "value", parseFloat(e));
          }
          registerOnChange(e) {
            this.onChange = (t) => {
              e("" == t ? null : parseFloat(t));
            };
          }
          registerOnTouched(e) {
            this.onTouched = e;
          }
          setDisabledState(e) {
            this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(Va), Hi(Xa));
          }),
          (e.ɵdir = _t({
            type: e,
            selectors: [
              ["input", "type", "range", "formControlName", ""],
              ["input", "type", "range", "formControl", ""],
              ["input", "type", "range", "ngModel", ""],
            ],
            hostBindings: function (e, t) {
              1 & e &&
                Ji("change", function (e) {
                  return t.onChange(e.target.value);
                })("input", function (e) {
                  return t.onChange(e.target.value);
                })("blur", function () {
                  return t.onTouched();
                });
            },
            features: [Ba([Df])],
          })),
          e
        );
      })();
      const Sf = { provide: Z_, useExisting: Le(() => Yf), multi: !0 };
      function kf(e, t) {
        return null == e ? "" + t : (t && "object" == typeof t && (t = "Object"), `${e}: ${t}`.slice(0, 50));
      }
      let Yf = (() => {
          class e {
            constructor(e, t) {
              (this._renderer = e),
                (this._elementRef = t),
                (this._optionMap = new Map()),
                (this._idCounter = 0),
                (this.onChange = (e) => {}),
                (this.onTouched = () => {}),
                (this._compareWith = Object.is);
            }
            set compareWith(e) {
              this._compareWith = e;
            }
            writeValue(e) {
              this.value = e;
              const t = this._getOptionId(e);
              null == t && this._renderer.setProperty(this._elementRef.nativeElement, "selectedIndex", -1);
              const n = kf(t, e);
              this._renderer.setProperty(this._elementRef.nativeElement, "value", n);
            }
            registerOnChange(e) {
              this.onChange = (t) => {
                (this.value = this._getOptionValue(t)), e(this.value);
              };
            }
            registerOnTouched(e) {
              this.onTouched = e;
            }
            setDisabledState(e) {
              this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
            }
            _registerOption() {
              return (this._idCounter++).toString();
            }
            _getOptionId(e) {
              for (const t of Array.from(this._optionMap.keys()))
                if (this._compareWith(this._optionMap.get(t), e)) return t;
              return null;
            }
            _getOptionValue(e) {
              const t = (function (e) {
                return e.split(":")[0];
              })(e);
              return this._optionMap.has(t) ? this._optionMap.get(t) : e;
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Va), Hi(Xa));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [
                ["select", "formControlName", "", 3, "multiple", ""],
                ["select", "formControl", "", 3, "multiple", ""],
                ["select", "ngModel", "", 3, "multiple", ""],
              ],
              hostBindings: function (e, t) {
                1 & e &&
                  Ji("change", function (e) {
                    return t.onChange(e.target.value);
                  })("blur", function () {
                    return t.onTouched();
                  });
              },
              inputs: { compareWith: "compareWith" },
              features: [Ba([Sf])],
            })),
            e
          );
        })(),
        Nf = (() => {
          class e {
            constructor(e, t, n) {
              (this._element = e),
                (this._renderer = t),
                (this._select = n),
                this._select && (this.id = this._select._registerOption());
            }
            set ngValue(e) {
              null != this._select &&
                (this._select._optionMap.set(this.id, e),
                this._setElementValue(kf(this.id, e)),
                this._select.writeValue(this._select.value));
            }
            set value(e) {
              this._setElementValue(e), this._select && this._select.writeValue(this._select.value);
            }
            _setElementValue(e) {
              this._renderer.setProperty(this._element.nativeElement, "value", e);
            }
            ngOnDestroy() {
              this._select && (this._select._optionMap.delete(this.id), this._select.writeValue(this._select.value));
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Xa), Hi(Va), Hi(Yf, 9));
            }),
            (e.ɵdir = _t({ type: e, selectors: [["option"]], inputs: { ngValue: "ngValue", value: "value" } })),
            e
          );
        })();
      const Ef = { provide: Z_, useExisting: Le(() => Wf), multi: !0 };
      function Cf(e, t) {
        return null == e
          ? "" + t
          : ("string" == typeof t && (t = `'${t}'`),
            t && "object" == typeof t && (t = "Object"),
            `${e}: ${t}`.slice(0, 50));
      }
      let Wf = (() => {
          class e {
            constructor(e, t) {
              (this._renderer = e),
                (this._elementRef = t),
                (this._optionMap = new Map()),
                (this._idCounter = 0),
                (this.onChange = (e) => {}),
                (this.onTouched = () => {}),
                (this._compareWith = Object.is);
            }
            set compareWith(e) {
              this._compareWith = e;
            }
            writeValue(e) {
              let t;
              if (((this.value = e), Array.isArray(e))) {
                const n = e.map((e) => this._getOptionId(e));
                t = (e, t) => {
                  e._setSelected(n.indexOf(t.toString()) > -1);
                };
              } else
                t = (e, t) => {
                  e._setSelected(!1);
                };
              this._optionMap.forEach(t);
            }
            registerOnChange(e) {
              this.onChange = (t) => {
                const n = [];
                if (void 0 !== t.selectedOptions) {
                  const e = t.selectedOptions;
                  for (let t = 0; t < e.length; t++) {
                    const s = e.item(t),
                      r = this._getOptionValue(s.value);
                    n.push(r);
                  }
                } else {
                  const e = t.options;
                  for (let t = 0; t < e.length; t++) {
                    const s = e.item(t);
                    if (s.selected) {
                      const e = this._getOptionValue(s.value);
                      n.push(e);
                    }
                  }
                }
                (this.value = n), e(n);
              };
            }
            registerOnTouched(e) {
              this.onTouched = e;
            }
            setDisabledState(e) {
              this._renderer.setProperty(this._elementRef.nativeElement, "disabled", e);
            }
            _registerOption(e) {
              const t = (this._idCounter++).toString();
              return this._optionMap.set(t, e), t;
            }
            _getOptionId(e) {
              for (const t of Array.from(this._optionMap.keys()))
                if (this._compareWith(this._optionMap.get(t)._value, e)) return t;
              return null;
            }
            _getOptionValue(e) {
              const t = (function (e) {
                return e.split(":")[0];
              })(e);
              return this._optionMap.has(t) ? this._optionMap.get(t)._value : e;
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Va), Hi(Xa));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [
                ["select", "multiple", "", "formControlName", ""],
                ["select", "multiple", "", "formControl", ""],
                ["select", "multiple", "", "ngModel", ""],
              ],
              hostBindings: function (e, t) {
                1 & e &&
                  Ji("change", function (e) {
                    return t.onChange(e.target);
                  })("blur", function () {
                    return t.onTouched();
                  });
              },
              inputs: { compareWith: "compareWith" },
              features: [Ba([Ef])],
            })),
            e
          );
        })(),
        qf = (() => {
          class e {
            constructor(e, t, n) {
              (this._element = e),
                (this._renderer = t),
                (this._select = n),
                this._select && (this.id = this._select._registerOption(this));
            }
            set ngValue(e) {
              null != this._select &&
                ((this._value = e), this._setElementValue(Cf(this.id, e)), this._select.writeValue(this._select.value));
            }
            set value(e) {
              this._select
                ? ((this._value = e),
                  this._setElementValue(Cf(this.id, e)),
                  this._select.writeValue(this._select.value))
                : this._setElementValue(e);
            }
            _setElementValue(e) {
              this._renderer.setProperty(this._element.nativeElement, "value", e);
            }
            _setSelected(e) {
              this._renderer.setProperty(this._element.nativeElement, "selected", e);
            }
            ngOnDestroy() {
              this._select && (this._select._optionMap.delete(this.id), this._select.writeValue(this._select.value));
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Xa), Hi(Va), Hi(Wf, 9));
            }),
            (e.ɵdir = _t({ type: e, selectors: [["option"]], inputs: { ngValue: "ngValue", value: "value" } })),
            e
          );
        })();
      function xf(e, t) {
        e._pendingDirty && e.markAsDirty(),
          e.setValue(e._pendingValue, { emitModelToViewChange: !1 }),
          t.viewToModelUpdate(e._pendingValue),
          (e._pendingChange = !1);
      }
      function Bf(e) {
        return null != e ? _f.compose(Lf(e)) : null;
      }
      function Hf(e) {
        return null != e ? _f.composeAsync(Lf(e)) : null;
      }
      const jf = [tf, Of, wf, Yf, Wf, vf];
      function Pf(e) {
        return (Ff(e) ? e.validators : e) || null;
      }
      function Xf(e) {
        return Array.isArray(e) ? Bf(e) : e || null;
      }
      function Rf(e, t) {
        return (Ff(t) ? t.asyncValidators : e) || null;
      }
      function If(e) {
        return Array.isArray(e) ? Hf(e) : e || null;
      }
      function Ff(e) {
        return null != e && !Array.isArray(e) && "object" == typeof e;
      }
      class Vf {
        constructor(e, t) {
          (this._hasOwnPendingAsyncValidator = !1),
            (this._onCollectionChange = () => {}),
            (this.pristine = !0),
            (this.touched = !1),
            (this._onDisabledChange = []),
            (this._rawValidators = e),
            (this._rawAsyncValidators = t),
            (this._composedValidatorFn = Xf(this._rawValidators)),
            (this._composedAsyncValidatorFn = If(this._rawAsyncValidators));
        }
        get validator() {
          return this._composedValidatorFn;
        }
        set validator(e) {
          this._rawValidators = this._composedValidatorFn = e;
        }
        get asyncValidator() {
          return this._composedAsyncValidatorFn;
        }
        set asyncValidator(e) {
          this._rawAsyncValidators = this._composedAsyncValidatorFn = e;
        }
        get parent() {
          return this._parent;
        }
        get valid() {
          return "VALID" === this.status;
        }
        get invalid() {
          return "INVALID" === this.status;
        }
        get pending() {
          return "PENDING" == this.status;
        }
        get disabled() {
          return "DISABLED" === this.status;
        }
        get enabled() {
          return "DISABLED" !== this.status;
        }
        get dirty() {
          return !this.pristine;
        }
        get untouched() {
          return !this.touched;
        }
        get updateOn() {
          return this._updateOn ? this._updateOn : this.parent ? this.parent.updateOn : "change";
        }
        setValidators(e) {
          (this._rawValidators = e), (this._composedValidatorFn = Xf(e));
        }
        setAsyncValidators(e) {
          (this._rawAsyncValidators = e), (this._composedAsyncValidatorFn = If(e));
        }
        clearValidators() {
          this.validator = null;
        }
        clearAsyncValidators() {
          this.asyncValidator = null;
        }
        markAsTouched(e = {}) {
          (this.touched = !0), this._parent && !e.onlySelf && this._parent.markAsTouched(e);
        }
        markAllAsTouched() {
          this.markAsTouched({ onlySelf: !0 }), this._forEachChild((e) => e.markAllAsTouched());
        }
        markAsUntouched(e = {}) {
          (this.touched = !1),
            (this._pendingTouched = !1),
            this._forEachChild((e) => {
              e.markAsUntouched({ onlySelf: !0 });
            }),
            this._parent && !e.onlySelf && this._parent._updateTouched(e);
        }
        markAsDirty(e = {}) {
          (this.pristine = !1), this._parent && !e.onlySelf && this._parent.markAsDirty(e);
        }
        markAsPristine(e = {}) {
          (this.pristine = !0),
            (this._pendingDirty = !1),
            this._forEachChild((e) => {
              e.markAsPristine({ onlySelf: !0 });
            }),
            this._parent && !e.onlySelf && this._parent._updatePristine(e);
        }
        markAsPending(e = {}) {
          (this.status = "PENDING"),
            !1 !== e.emitEvent && this.statusChanges.emit(this.status),
            this._parent && !e.onlySelf && this._parent.markAsPending(e);
        }
        disable(e = {}) {
          const t = this._parentMarkedDirty(e.onlySelf);
          (this.status = "DISABLED"),
            (this.errors = null),
            this._forEachChild((t) => {
              t.disable(Object.assign(Object.assign({}, e), { onlySelf: !0 }));
            }),
            this._updateValue(),
            !1 !== e.emitEvent && (this.valueChanges.emit(this.value), this.statusChanges.emit(this.status)),
            this._updateAncestors(Object.assign(Object.assign({}, e), { skipPristineCheck: t })),
            this._onDisabledChange.forEach((e) => e(!0));
        }
        enable(e = {}) {
          const t = this._parentMarkedDirty(e.onlySelf);
          (this.status = "VALID"),
            this._forEachChild((t) => {
              t.enable(Object.assign(Object.assign({}, e), { onlySelf: !0 }));
            }),
            this.updateValueAndValidity({ onlySelf: !0, emitEvent: e.emitEvent }),
            this._updateAncestors(Object.assign(Object.assign({}, e), { skipPristineCheck: t })),
            this._onDisabledChange.forEach((e) => e(!1));
        }
        _updateAncestors(e) {
          this._parent &&
            !e.onlySelf &&
            (this._parent.updateValueAndValidity(e),
            e.skipPristineCheck || this._parent._updatePristine(),
            this._parent._updateTouched());
        }
        setParent(e) {
          this._parent = e;
        }
        updateValueAndValidity(e = {}) {
          this._setInitialStatus(),
            this._updateValue(),
            this.enabled &&
              (this._cancelExistingSubscription(),
              (this.errors = this._runValidator()),
              (this.status = this._calculateStatus()),
              ("VALID" !== this.status && "PENDING" !== this.status) || this._runAsyncValidator(e.emitEvent)),
            !1 !== e.emitEvent && (this.valueChanges.emit(this.value), this.statusChanges.emit(this.status)),
            this._parent && !e.onlySelf && this._parent.updateValueAndValidity(e);
        }
        _updateTreeValidity(e = { emitEvent: !0 }) {
          this._forEachChild((t) => t._updateTreeValidity(e)),
            this.updateValueAndValidity({ onlySelf: !0, emitEvent: e.emitEvent });
        }
        _setInitialStatus() {
          this.status = this._allControlsDisabled() ? "DISABLED" : "VALID";
        }
        _runValidator() {
          return this.validator ? this.validator(this) : null;
        }
        _runAsyncValidator(e) {
          if (this.asyncValidator) {
            (this.status = "PENDING"), (this._hasOwnPendingAsyncValidator = !0);
            const t = bf(this.asyncValidator(this));
            this._asyncValidationSubscription = t.subscribe((t) => {
              (this._hasOwnPendingAsyncValidator = !1), this.setErrors(t, { emitEvent: e });
            });
          }
        }
        _cancelExistingSubscription() {
          this._asyncValidationSubscription &&
            (this._asyncValidationSubscription.unsubscribe(), (this._hasOwnPendingAsyncValidator = !1));
        }
        setErrors(e, t = {}) {
          (this.errors = e), this._updateControlsErrors(!1 !== t.emitEvent);
        }
        get(e) {
          return (function (e, t, n) {
            if (null == t) return null;
            if ((Array.isArray(t) || (t = t.split(".")), Array.isArray(t) && 0 === t.length)) return null;
            let s = e;
            return (
              t.forEach((e) => {
                s =
                  s instanceof Jf
                    ? s.controls.hasOwnProperty(e)
                      ? s.controls[e]
                      : null
                    : (s instanceof Gf && s.at(e)) || null;
              }),
              s
            );
          })(this, e);
        }
        getError(e, t) {
          const n = t ? this.get(t) : this;
          return n && n.errors ? n.errors[e] : null;
        }
        hasError(e, t) {
          return !!this.getError(e, t);
        }
        get root() {
          let e = this;
          for (; e._parent; ) e = e._parent;
          return e;
        }
        _updateControlsErrors(e) {
          (this.status = this._calculateStatus()),
            e && this.statusChanges.emit(this.status),
            this._parent && this._parent._updateControlsErrors(e);
        }
        _initObservables() {
          (this.valueChanges = new Co()), (this.statusChanges = new Co());
        }
        _calculateStatus() {
          return this._allControlsDisabled()
            ? "DISABLED"
            : this.errors
            ? "INVALID"
            : this._hasOwnPendingAsyncValidator || this._anyControlsHaveStatus("PENDING")
            ? "PENDING"
            : this._anyControlsHaveStatus("INVALID")
            ? "INVALID"
            : "VALID";
        }
        _anyControlsHaveStatus(e) {
          return this._anyControls((t) => t.status === e);
        }
        _anyControlsDirty() {
          return this._anyControls((e) => e.dirty);
        }
        _anyControlsTouched() {
          return this._anyControls((e) => e.touched);
        }
        _updatePristine(e = {}) {
          (this.pristine = !this._anyControlsDirty()), this._parent && !e.onlySelf && this._parent._updatePristine(e);
        }
        _updateTouched(e = {}) {
          (this.touched = this._anyControlsTouched()), this._parent && !e.onlySelf && this._parent._updateTouched(e);
        }
        _isBoxedValue(e) {
          return "object" == typeof e && null !== e && 2 === Object.keys(e).length && "value" in e && "disabled" in e;
        }
        _registerOnCollectionChange(e) {
          this._onCollectionChange = e;
        }
        _setUpdateStrategy(e) {
          Ff(e) && null != e.updateOn && (this._updateOn = e.updateOn);
        }
        _parentMarkedDirty(e) {
          return !e && this._parent && this._parent.dirty && !this._parent._anyControlsDirty();
        }
      }
      class Uf extends Vf {
        constructor(e = null, t, n) {
          super(Pf(t), Rf(n, t)),
            (this._onChange = []),
            this._applyFormState(e),
            this._setUpdateStrategy(t),
            this.updateValueAndValidity({ onlySelf: !0, emitEvent: !1 }),
            this._initObservables();
        }
        setValue(e, t = {}) {
          (this.value = this._pendingValue = e),
            this._onChange.length &&
              !1 !== t.emitModelToViewChange &&
              this._onChange.forEach((e) => e(this.value, !1 !== t.emitViewToModelChange)),
            this.updateValueAndValidity(t);
        }
        patchValue(e, t = {}) {
          this.setValue(e, t);
        }
        reset(e = null, t = {}) {
          this._applyFormState(e),
            this.markAsPristine(t),
            this.markAsUntouched(t),
            this.setValue(this.value, t),
            (this._pendingChange = !1);
        }
        _updateValue() {}
        _anyControls(e) {
          return !1;
        }
        _allControlsDisabled() {
          return this.disabled;
        }
        registerOnChange(e) {
          this._onChange.push(e);
        }
        _clearChangeFns() {
          (this._onChange = []), (this._onDisabledChange = []), (this._onCollectionChange = () => {});
        }
        registerOnDisabledChange(e) {
          this._onDisabledChange.push(e);
        }
        _forEachChild(e) {}
        _syncPendingControls() {
          return !(
            "submit" !== this.updateOn ||
            (this._pendingDirty && this.markAsDirty(),
            this._pendingTouched && this.markAsTouched(),
            !this._pendingChange) ||
            (this.setValue(this._pendingValue, { onlySelf: !0, emitModelToViewChange: !1 }), 0)
          );
        }
        _applyFormState(e) {
          this._isBoxedValue(e)
            ? ((this.value = this._pendingValue = e.value),
              e.disabled ? this.disable({ onlySelf: !0, emitEvent: !1 }) : this.enable({ onlySelf: !0, emitEvent: !1 }))
            : (this.value = this._pendingValue = e);
        }
      }
      class Jf extends Vf {
        constructor(e, t, n) {
          super(Pf(t), Rf(n, t)),
            (this.controls = e),
            this._initObservables(),
            this._setUpdateStrategy(t),
            this._setUpControls(),
            this.updateValueAndValidity({ onlySelf: !0, emitEvent: !1 });
        }
        registerControl(e, t) {
          return this.controls[e]
            ? this.controls[e]
            : ((this.controls[e] = t), t.setParent(this), t._registerOnCollectionChange(this._onCollectionChange), t);
        }
        addControl(e, t) {
          this.registerControl(e, t), this.updateValueAndValidity(), this._onCollectionChange();
        }
        removeControl(e) {
          this.controls[e] && this.controls[e]._registerOnCollectionChange(() => {}),
            delete this.controls[e],
            this.updateValueAndValidity(),
            this._onCollectionChange();
        }
        setControl(e, t) {
          this.controls[e] && this.controls[e]._registerOnCollectionChange(() => {}),
            delete this.controls[e],
            t && this.registerControl(e, t),
            this.updateValueAndValidity(),
            this._onCollectionChange();
        }
        contains(e) {
          return this.controls.hasOwnProperty(e) && this.controls[e].enabled;
        }
        setValue(e, t = {}) {
          this._checkAllValuesPresent(e),
            Object.keys(e).forEach((n) => {
              this._throwIfControlMissing(n), this.controls[n].setValue(e[n], { onlySelf: !0, emitEvent: t.emitEvent });
            }),
            this.updateValueAndValidity(t);
        }
        patchValue(e, t = {}) {
          Object.keys(e).forEach((n) => {
            this.controls[n] && this.controls[n].patchValue(e[n], { onlySelf: !0, emitEvent: t.emitEvent });
          }),
            this.updateValueAndValidity(t);
        }
        reset(e = {}, t = {}) {
          this._forEachChild((n, s) => {
            n.reset(e[s], { onlySelf: !0, emitEvent: t.emitEvent });
          }),
            this._updatePristine(t),
            this._updateTouched(t),
            this.updateValueAndValidity(t);
        }
        getRawValue() {
          return this._reduceChildren({}, (e, t, n) => ((e[n] = t instanceof Uf ? t.value : t.getRawValue()), e));
        }
        _syncPendingControls() {
          let e = this._reduceChildren(!1, (e, t) => !!t._syncPendingControls() || e);
          return e && this.updateValueAndValidity({ onlySelf: !0 }), e;
        }
        _throwIfControlMissing(e) {
          if (!Object.keys(this.controls).length)
            throw new Error(
              "\n        There are no form controls registered with this group yet. If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      "
            );
          if (!this.controls[e]) throw new Error(`Cannot find form control with name: ${e}.`);
        }
        _forEachChild(e) {
          Object.keys(this.controls).forEach((t) => e(this.controls[t], t));
        }
        _setUpControls() {
          this._forEachChild((e) => {
            e.setParent(this), e._registerOnCollectionChange(this._onCollectionChange);
          });
        }
        _updateValue() {
          this.value = this._reduceValue();
        }
        _anyControls(e) {
          for (const t of Object.keys(this.controls)) {
            const n = this.controls[t];
            if (this.contains(t) && e(n)) return !0;
          }
          return !1;
        }
        _reduceValue() {
          return this._reduceChildren({}, (e, t, n) => ((t.enabled || this.disabled) && (e[n] = t.value), e));
        }
        _reduceChildren(e, t) {
          let n = e;
          return (
            this._forEachChild((e, s) => {
              n = t(n, e, s);
            }),
            n
          );
        }
        _allControlsDisabled() {
          for (const e of Object.keys(this.controls)) if (this.controls[e].enabled) return !1;
          return Object.keys(this.controls).length > 0 || this.disabled;
        }
        _checkAllValuesPresent(e) {
          this._forEachChild((t, n) => {
            if (void 0 === e[n]) throw new Error(`Must supply a value for form control with name: '${n}'.`);
          });
        }
      }
      class Gf extends Vf {
        constructor(e, t, n) {
          super(Pf(t), Rf(n, t)),
            (this.controls = e),
            this._initObservables(),
            this._setUpdateStrategy(t),
            this._setUpControls(),
            this.updateValueAndValidity({ onlySelf: !0, emitEvent: !1 });
        }
        at(e) {
          return this.controls[e];
        }
        push(e) {
          this.controls.push(e), this._registerControl(e), this.updateValueAndValidity(), this._onCollectionChange();
        }
        insert(e, t) {
          this.controls.splice(e, 0, t), this._registerControl(t), this.updateValueAndValidity();
        }
        removeAt(e) {
          this.controls[e] && this.controls[e]._registerOnCollectionChange(() => {}),
            this.controls.splice(e, 1),
            this.updateValueAndValidity();
        }
        setControl(e, t) {
          this.controls[e] && this.controls[e]._registerOnCollectionChange(() => {}),
            this.controls.splice(e, 1),
            t && (this.controls.splice(e, 0, t), this._registerControl(t)),
            this.updateValueAndValidity(),
            this._onCollectionChange();
        }
        get length() {
          return this.controls.length;
        }
        setValue(e, t = {}) {
          this._checkAllValuesPresent(e),
            e.forEach((e, n) => {
              this._throwIfControlMissing(n), this.at(n).setValue(e, { onlySelf: !0, emitEvent: t.emitEvent });
            }),
            this.updateValueAndValidity(t);
        }
        patchValue(e, t = {}) {
          e.forEach((e, n) => {
            this.at(n) && this.at(n).patchValue(e, { onlySelf: !0, emitEvent: t.emitEvent });
          }),
            this.updateValueAndValidity(t);
        }
        reset(e = [], t = {}) {
          this._forEachChild((n, s) => {
            n.reset(e[s], { onlySelf: !0, emitEvent: t.emitEvent });
          }),
            this._updatePristine(t),
            this._updateTouched(t),
            this.updateValueAndValidity(t);
        }
        getRawValue() {
          return this.controls.map((e) => (e instanceof Uf ? e.value : e.getRawValue()));
        }
        clear() {
          this.controls.length < 1 ||
            (this._forEachChild((e) => e._registerOnCollectionChange(() => {})),
            this.controls.splice(0),
            this.updateValueAndValidity());
        }
        _syncPendingControls() {
          let e = this.controls.reduce((e, t) => !!t._syncPendingControls() || e, !1);
          return e && this.updateValueAndValidity({ onlySelf: !0 }), e;
        }
        _throwIfControlMissing(e) {
          if (!this.controls.length)
            throw new Error(
              "\n        There are no form controls registered with this array yet. If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      "
            );
          if (!this.at(e)) throw new Error("Cannot find form control at index " + e);
        }
        _forEachChild(e) {
          this.controls.forEach((t, n) => {
            e(t, n);
          });
        }
        _updateValue() {
          this.value = this.controls.filter((e) => e.enabled || this.disabled).map((e) => e.value);
        }
        _anyControls(e) {
          return this.controls.some((t) => t.enabled && e(t));
        }
        _setUpControls() {
          this._forEachChild((e) => this._registerControl(e));
        }
        _checkAllValuesPresent(e) {
          this._forEachChild((t, n) => {
            if (void 0 === e[n]) throw new Error(`Must supply a value for form control at index: ${n}.`);
          });
        }
        _allControlsDisabled() {
          for (const e of this.controls) if (e.enabled) return !1;
          return this.controls.length > 0 || this.disabled;
        }
        _registerControl(e) {
          e.setParent(this), e._registerOnCollectionChange(this._onCollectionChange);
        }
      }
      const Qf = { provide: lf, useExisting: Le(() => $f) },
        Kf = (() => Promise.resolve(null))();
      let $f = (() => {
          class e extends lf {
            constructor(e, t, n, s) {
              super(),
                (this.control = new Uf()),
                (this._registered = !1),
                (this.update = new Co()),
                (this._parent = e),
                (this._rawValidators = t || []),
                (this._rawAsyncValidators = n || []),
                (this.valueAccessor = (function (e, t) {
                  if (!t) return null;
                  Array.isArray(t);
                  let n = void 0,
                    s = void 0,
                    r = void 0;
                  return (
                    t.forEach((e) => {
                      var t;
                      e.constructor === rf
                        ? (n = e)
                        : ((t = e), jf.some((e) => t.constructor === e) ? (s = e) : (r = e));
                    }),
                    r || s || n || null
                  );
                })(0, s));
            }
            ngOnChanges(e) {
              this._checkForErrors(),
                this._registered || this._setUpControl(),
                "isDisabled" in e && this._updateDisabled(e),
                (function (e, t) {
                  if (!e.hasOwnProperty("model")) return !1;
                  const n = e.model;
                  return !!n.isFirstChange() || !Object.is(t, n.currentValue);
                })(e, this.viewModel) && (this._updateValue(this.model), (this.viewModel = this.model));
            }
            ngOnDestroy() {
              this.formDirective && this.formDirective.removeControl(this);
            }
            get path() {
              return this._parent ? [...this._parent.path, this.name] : [this.name];
            }
            get formDirective() {
              return this._parent ? this._parent.formDirective : null;
            }
            get validator() {
              return Bf(this._rawValidators);
            }
            get asyncValidator() {
              return Hf(this._rawAsyncValidators);
            }
            viewToModelUpdate(e) {
              (this.viewModel = e), this.update.emit(e);
            }
            _setUpControl() {
              this._setUpdateStrategy(),
                this._isStandalone() ? this._setUpStandalone() : this.formDirective.addControl(this),
                (this._registered = !0);
            }
            _setUpdateStrategy() {
              this.options && null != this.options.updateOn && (this.control._updateOn = this.options.updateOn);
            }
            _isStandalone() {
              return !this._parent || !(!this.options || !this.options.standalone);
            }
            _setUpStandalone() {
              var e, t;
              ((e = this.control).validator = _f.compose([e.validator, (t = this).validator])),
                (e.asyncValidator = _f.composeAsync([e.asyncValidator, t.asyncValidator])),
                t.valueAccessor.writeValue(e.value),
                (function (e, t) {
                  t.valueAccessor.registerOnChange((n) => {
                    (e._pendingValue = n),
                      (e._pendingChange = !0),
                      (e._pendingDirty = !0),
                      "change" === e.updateOn && xf(e, t);
                  });
                })(e, t),
                (function (e, t) {
                  e.registerOnChange((e, n) => {
                    t.valueAccessor.writeValue(e), n && t.viewToModelUpdate(e);
                  });
                })(e, t),
                (function (e, t) {
                  t.valueAccessor.registerOnTouched(() => {
                    (e._pendingTouched = !0),
                      "blur" === e.updateOn && e._pendingChange && xf(e, t),
                      "submit" !== e.updateOn && e.markAsTouched();
                  });
                })(e, t),
                t.valueAccessor.setDisabledState &&
                  e.registerOnDisabledChange((e) => {
                    t.valueAccessor.setDisabledState(e);
                  }),
                t._rawValidators.forEach((t) => {
                  t.registerOnValidatorChange && t.registerOnValidatorChange(() => e.updateValueAndValidity());
                }),
                t._rawAsyncValidators.forEach((t) => {
                  t.registerOnValidatorChange && t.registerOnValidatorChange(() => e.updateValueAndValidity());
                }),
                this.control.updateValueAndValidity({ emitEvent: !1 });
            }
            _checkForErrors() {
              this._isStandalone() || this._checkParentType(), this._checkName();
            }
            _checkParentType() {}
            _checkName() {
              this.options && this.options.name && (this.name = this.options.name), this._isStandalone();
            }
            _updateValue(e) {
              Kf.then(() => {
                this.control.setValue(e, { emitViewToModelChange: !1 });
              });
            }
            _updateDisabled(e) {
              const t = e.isDisabled.currentValue,
                n = "" === t || (t && "false" !== t);
              Kf.then(() => {
                n && !this.control.disabled
                  ? this.control.disable()
                  : !n && this.control.disabled && this.control.enable();
              });
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(of, 9), Hi(Mf, 10), Hi(pf, 10), Hi(Z_, 10));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [["", "ngModel", "", 3, "formControlName", "", 3, "formControl", ""]],
              inputs: {
                name: "name",
                isDisabled: ["disabled", "isDisabled"],
                model: ["ngModel", "model"],
                options: ["ngModelOptions", "options"],
              },
              outputs: { update: "ngModelChange" },
              exportAs: ["ngModel"],
              features: [Ba([Qf]), Li, Wt],
            })),
            e
          );
        })(),
        Zf = (() => {
          class e {}
          return (
            (e.ɵmod = pt({ type: e })),
            (e.ɵinj = le({
              factory: function (t) {
                return new (t || e)();
              },
            })),
            e
          );
        })(),
        eb = (() => {
          class e {}
          return (
            (e.ɵmod = pt({ type: e })),
            (e.ɵinj = le({
              factory: function (t) {
                return new (t || e)();
              },
              providers: [Tf],
              imports: [Zf],
            })),
            e
          );
        })(),
        tb = (() => {
          class e {
            constructor(e) {
              (this.controlCallback = new Co()),
                (this.parentComponentName = ""),
                (this.parentModuleName = ""),
                this.populateParentComponentName(e),
                this.populateParentModuleName(e),
                (this._viewContainerRef = e),
                setTimeout(() => {
                  this._viewContainerRef &&
                    this.applyExternalStyles(this._viewContainerRef.element.nativeElement.localName);
                }, 0);
            }
            invokeControlCallBack(e) {
              this.isControlCallback &&
                Boolean(JSON.parse(this.isControlCallback)) &&
                this.controlCallback.emit({ controlCallbackData: e });
            }
            populateParentComponentName(e) {
              e &&
                e._data &&
                e._data.componentView &&
                e._data.componentView.parent &&
                e._data.componentView.parent.component &&
                e._data.componentView.parent.component.constructor &&
                e._data.componentView.parent.component.constructor.name &&
                "" !== e._data.componentView.parent.component.constructor.name &&
                (this.parentComponentName = e._data.componentView.parent.component.constructor.name);
            }
            populateParentModuleName(e) {
              e &&
                e._data &&
                e._data.componentView &&
                e._data.componentView.parent &&
                e._data.componentView.parent.root &&
                e._data.componentView.parent.root.ngModule &&
                e._data.componentView.parent.root.ngModule._moduleType &&
                e._data.componentView.parent.root.ngModule._moduleType.name &&
                "" !== e._data.componentView.parent.root.ngModule._moduleType.name &&
                (this.parentModuleName = e._data.componentView.parent.root.ngModule._moduleType.name);
            }
            applyExternalStyles(e) {
              if (this.overwriteStyle && e) {
                const t = this.overwriteStyle.split("/"),
                  n = document.createElement("style");
                let s = "";
                t && t.length > 0 && (s = t[t.length - 1]), (n.id = s);
                const r = document.getElementById(s);
                r && r.remove();
                const i = document.querySelector(e);
                i && ((n.innerHTML = " @import url( '" + this.overwriteStyle + "' )"), i.appendChild(n));
              }
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(mo));
            }),
            (e.ɵdir = _t({
              type: e,
              inputs: { isControlCallback: "isControlCallback", overwriteStyle: "overwriteStyle" },
              outputs: { controlCallback: "controlCallback" },
            })),
            e
          );
        })();
      var nb = n("nVrk");
      let sb = (() => {
        class e {
          get appWindow() {
            return window;
          }
          get appDocument() {
            return document;
          }
        }
        return (
          (e.ɵfac = function (t) {
            return new (t || e)();
          }),
          (e.ɵprov = ce({ token: e, factory: e.ɵfac, providedIn: "root" })),
          e
        );
      })();
      const rb = ["datepicker"],
        ib = ["inputfield"],
        ab = function (e) {
          return { "retail-av-datepicker-trigger": !0, "retail-av-state-disabled": e };
        };
      function ob(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "button", 15),
            Ji("click", function (t) {
              an(e), Ki();
              const n = Bi(1);
              return Ki().onButtonClick(t, n);
            }),
            Ri();
        }
        if (2 & e) {
          const e = Ki(2);
          ji("ngClass", vo(2, ab, e.disabled))("disabled", e.disabled);
        }
      }
      const cb = function (e) {
        return {
          "retail-av-inputtext retail-av-widget retail-av-state-default retail-av-corner-all": !0,
          "retail-av-disabled-class": e,
        };
      };
      function lb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "input", 12, 13),
            Ji("keydown", function (t) {
              return an(e), Ki().onInputKeydown(t);
            })("click", function () {
              return an(e), Ki().onCalendarClick();
            })("blur", function (t) {
              return an(e), Ki().onInputBlur(t);
            })("input", function (t) {
              return an(e), Ki().onUserInput(t);
            }),
            Ri(),
            xi(2, ob, 1, 4, "button", 14);
        }
        if (2 & e) {
          const e = Ki();
          da(e.inputStyleClass),
            ji("value", e.inputFieldValue)("readonly", e.readonlyInput)("ngStyle", e.inputStyle)(
              "placeholder",
              e.placeholder || ""
            )("disabled", e.disabled)("ngClass", vo(13, cb, e.isCalendarClicked)),
            Ci("id", e.inputId)("name", e.inputName)("required", e.required)("tabindex", e.tabindex),
            Ws(2),
            ji("ngIf", e.showIcon);
        }
      }
      function db(e, t) {
        if ((1 & e && (Xi(0, "div"), ya(1), Ri()), 2 & e)) {
          const e = Ki();
          Ws(1), La(e.displayHeading);
        }
      }
      function ub(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "a", 28),
            Ji("click", function (t) {
              return an(e), Ki(3).prevMonth(t);
            }),
            Ii(1, "span", 29),
            Ri();
        }
        2 & e && ea("tabindex", Ki(3).tabindex);
      }
      function hb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "a", 30),
            Ji("click", function (t) {
              return an(e), Ki(3).nextMonth(t);
            }),
            Ii(1, "span", 31),
            Ri();
        }
        2 & e && ea("tabindex", Ki(3).tabindex);
      }
      function Mb(e, t) {
        if ((1 & e && (Xi(0, "span", 32), ya(1), Ri()), 2 & e)) {
          const e = Ki(2).$implicit,
            t = Ki();
          Ws(1), La(t.locale.monthNames[t.currentMonth[e]]);
        }
      }
      function pb(e, t) {
        if ((1 & e && (Xi(0, "option", 35), ya(1), Ri()), 2 & e)) {
          const e = t.$implicit,
            n = t.index,
            s = Ki(4);
          ji("value", n)("selected", n === s.currentMonth), Ci("aria-label", e), Ws(1), Aa(" ", e, " ");
        }
      }
      function mb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "select", 33),
            Ji("change", function (t) {
              return an(e), Ki(3).onMonthDropdownChange(t);
            }),
            xi(1, pb, 2, 4, "option", 34),
            Ri();
        }
        if (2 & e) {
          const e = Ki(3);
          Ws(1), ji("ngForOf", e.locale.monthNames);
        }
      }
      function _b(e, t) {
        if ((1 & e && (Xi(0, "option", 35), ya(1), Ri()), 2 & e)) {
          const e = t.$implicit,
            n = Ki(3).$implicit,
            s = Ki();
          ji("value", e)("selected", e === s.currentYear[n]),
            Ci("aria-label", s.currentYear[n]),
            Ws(1),
            Aa(" ", s.currentYear[n], " ");
        }
      }
      function fb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "select", 36),
            Ji("change", function (t) {
              return an(e), Ki(3).onYearDropdownChange(t);
            }),
            xi(1, _b, 2, 4, "option", 34),
            Ri();
        }
        if (2 & e) {
          const e = Ki(3);
          Ws(1), ji("ngForOf", e.yearOptions);
        }
      }
      function bb(e, t) {
        if ((1 & e && (Xi(0, "span", 37), ya(1), Ri()), 2 & e)) {
          const e = Ki(2).$implicit,
            t = Ki();
          Ws(1), La(t.currentYear[e]);
        }
      }
      function gb(e, t) {
        if (
          (1 & e &&
            (Xi(0, "div", 20),
            Zi(1, 1),
            xi(2, ub, 2, 1, "a", 21),
            xi(3, hb, 2, 1, "a", 22),
            Xi(4, "div", 23),
            xi(5, Mb, 2, 1, "span", 24),
            xi(6, mb, 2, 1, "select", 25),
            xi(7, fb, 2, 1, "select", 26),
            xi(8, bb, 2, 1, "span", 27),
            Ri(),
            Ri()),
          2 & e)
        ) {
          const e = Ki().index,
            t = Ki();
          Ws(2),
            ji("ngIf", 0 === e),
            Ws(1),
            ji("ngIf", e === t.displayMonths - 1),
            Ws(2),
            ji("ngIf", !t.monthNavigator),
            Ws(1),
            ji("ngIf", t.monthNavigator),
            Ws(1),
            ji("ngIf", t.yearNavigator),
            Ws(1),
            ji("ngIf", !t.yearNavigator);
        }
      }
      function yb(e, t) {
        if ((1 & e && (Xi(0, "th", 43), Xi(1, "span"), ya(2), Ri(), Ri()), 2 & e)) {
          const e = t.$implicit;
          Ci("aria-label", e), Ws(2), La(e);
        }
      }
      const Lb = function (e, t, n) {
        return { "retail-av-state-active": e, "retail-av-state-highlight": t, "retail-av-state-disabled": n };
      };
      function Ab(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "a", 47),
            Ji("click", function (t) {
              an(e);
              const n = Ki().$implicit;
              return Ki(4).onDateSelect(t, n);
            }),
            ya(1),
            Ri();
        }
        if (2 & e) {
          const e = Ki().$implicit,
            t = Ki(3).$implicit,
            n = Ki();
          ea("tabindex", n.tabindex),
            qi("aria-label", "", n.locale.monthNames[n.currentMonth[t]], " ", e.day, ""),
            ji(
              "ngClass",
              Do(
                5,
                Lb,
                n.isSelected(e) || n.isInRange(e) || (e.today && n.isDefault(e)),
                e.today && !n.isDefault(e),
                !e.selectable
              )
            ),
            Ws(1),
            La(e.day);
        }
      }
      const wb = function (e, t, n) {
        return {
          "retail-av-datepicker-other-month retail-av-state-disabled": e,
          "retail-av-datepicker-current-day": t,
          "retail-av-datepicker-today": n,
        };
      };
      function zb(e, t) {
        if ((1 & e && (Xi(0, "td", 45), xi(1, Ab, 2, 9, "a", 46), Ri()), 2 & e)) {
          const e = t.$implicit,
            n = Ki(4);
          ji("ngClass", Do(2, wb, e.otherMonth, n.isSelected(e), e.today)),
            Ws(1),
            ji("ngIf", !e.otherMonth || n.showOtherMonths);
        }
      }
      function Tb(e, t) {
        if ((1 & e && (Xi(0, "tr", 40), xi(1, zb, 2, 6, "td", 44), Ri()), 2 & e)) {
          const e = t.$implicit;
          Ws(1), ji("ngForOf", e);
        }
      }
      function vb(e, t) {
        if (
          (1 & e &&
            (Xi(0, "table", 38),
            Xi(1, "thead", 39),
            Xi(2, "tr", 40),
            xi(3, yb, 3, 2, "th", 41),
            Ri(),
            Ri(),
            Xi(4, "tbody", 39),
            xi(5, Tb, 2, 1, "tr", 42),
            Ri(),
            Ri()),
          2 & e)
        ) {
          const e = Ki().$implicit,
            t = Ki();
          Ws(3), ji("ngForOf", t.weekDays), Ws(2), ji("ngForOf", t.dates[e]);
        }
      }
      const Db = function (e) {
        return { "retail-av-calendar-date-pannel-margin-right": e };
      };
      function Ob(e, t) {
        if (
          (1 & e &&
            (Xi(0, "div", 16), Xi(1, "div", 17), xi(2, gb, 9, 6, "div", 18), xi(3, vb, 6, 2, "table", 19), Ri(), Ri()),
          2 & e)
        ) {
          const e = t.index,
            n = Ki();
          Ws(1),
            ji("ngClass", vo(3, Db, e < n.displayMonths - 1)),
            Ws(1),
            ji("ngIf", !n.timeOnly && (n.overlayVisible || n.inline)),
            Ws(1),
            ji("ngIf", !n.timeOnly && (n.overlayVisible || n.inline));
        }
      }
      function Sb(e, t) {
        1 & e &&
          (Xi(0, "div", 54),
          Xi(1, "a", 55),
          Ii(2, "span", 51),
          Ri(),
          Xi(3, "span"),
          ya(4, ":"),
          Ri(),
          Xi(5, "a", 55),
          Ii(6, "span", 53),
          Ri(),
          Ri());
      }
      const kb = function (e) {
        return { display: e };
      };
      function Yb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div", 60),
            Xi(1, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki(2).incrementSecond(t);
            }),
            Ii(2, "span", 51),
            Ri(),
            Xi(3, "span", 52),
            ya(4, "0"),
            Ri(),
            Xi(5, "span"),
            ya(6),
            Ri(),
            Xi(7, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki(2).decrementSecond(t);
            }),
            Ii(8, "span", 53),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = Ki(2);
          Ws(1),
            ea("tabindex", e.tabindex),
            Ws(2),
            ji("ngStyle", vo(4, kb, e.currentSecond < 10 ? "inline" : "none")),
            Ws(3),
            La(e.currentSecond),
            Ws(1),
            ea("tabindex", e.tabindex);
        }
      }
      function Nb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div", 61),
            Xi(1, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki(2).toggleAMPM(t);
            }),
            Ii(2, "span", 51),
            Ri(),
            Xi(3, "span"),
            ya(4),
            Ri(),
            Xi(5, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki(2).toggleAMPM(t);
            }),
            Ii(6, "span", 53),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = Ki(2);
          Ws(1), ea("tabindex", e.tabindex), Ws(3), La(e.pm ? "PM" : "AM"), Ws(1), ea("tabindex", e.tabindex);
        }
      }
      function Eb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div", 48),
            Xi(1, "div", 49),
            Xi(2, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki().incrementHour(t);
            }),
            Ii(3, "span", 51),
            Ri(),
            Xi(4, "span", 52),
            ya(5, "0"),
            Ri(),
            Xi(6, "span"),
            ya(7),
            Ri(),
            Xi(8, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki().decrementHour(t);
            }),
            Ii(9, "span", 53),
            Ri(),
            Ri(),
            Xi(10, "div", 54),
            Xi(11, "a", 55),
            Ii(12, "span", 51),
            Ri(),
            Xi(13, "span"),
            ya(14, ":"),
            Ri(),
            Xi(15, "a", 55),
            Ii(16, "span", 53),
            Ri(),
            Ri(),
            Xi(17, "div", 56),
            Xi(18, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki().incrementMinute(t);
            }),
            Ii(19, "span", 51),
            Ri(),
            Xi(20, "span", 52),
            ya(21, "0"),
            Ri(),
            Xi(22, "span"),
            ya(23),
            Ri(),
            Xi(24, "a", 50),
            Ji("click", function (t) {
              return an(e), Ki().decrementMinute(t);
            }),
            Ii(25, "span", 53),
            Ri(),
            Ri(),
            xi(26, Sb, 7, 0, "div", 57),
            xi(27, Yb, 9, 6, "div", 58),
            xi(28, Nb, 7, 3, "div", 59),
            Ri();
        }
        if (2 & e) {
          const e = Ki();
          Ws(2),
            ea("tabindex", e.tabindex),
            Ws(2),
            ji("ngStyle", vo(11, kb, e.currentHour < 10 ? "inline" : "none")),
            Ws(3),
            La(e.currentHour),
            Ws(1),
            ea("tabindex", e.tabindex),
            Ws(10),
            ea("tabindex", e.tabindex),
            Ws(2),
            ji("ngStyle", vo(13, kb, e.currentMinute < 10 ? "inline" : "none")),
            Ws(3),
            La(e.currentMinute),
            Ws(1),
            ea("tabindex", e.tabindex),
            Ws(2),
            ji("ngIf", e.showSeconds),
            Ws(1),
            ji("ngIf", e.showSeconds),
            Ws(1),
            ji("ngIf", "12" === e.hourFormat);
        }
      }
      const Cb = function (e) {
        return { "retail-av-slot-selected": e };
      };
      function Wb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div", 69),
            Ji("click", function (n) {
              an(e);
              const s = t.$implicit;
              return Ki(3).onTimeSlotChange(n, null == s ? null : s.timeSlotId);
            }),
            Xi(1, "span", 70),
            ya(2),
            Yo(3, "lowercase"),
            Yo(4, "date"),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = t.$implicit,
            n = Ki(3);
          ea("id", null == e ? null : e.timeSlot),
            ji("ngClass", vo(10, Cb, n.selectedTimeSlotId === (null == e ? null : e.timeSlotId))),
            Ci("data-endtime", null == e ? null : e.endTime),
            Ws(1),
            ea("id", null == e ? null : e.timeSlot),
            Ws(1),
            La(
              (function (e, t, n) {
                const s = sn(),
                  r = Ut(s, 3);
                return Eo(s, No(s, 3) ? ko(s, Mn(), 5, r.transform, n, r) : r.transform(n));
              })(
                0,
                0,
                (function (e, t, n, s) {
                  const r = sn(),
                    i = Ut(r, e);
                  return Eo(
                    r,
                    No(r, e)
                      ? (function (e, t, n, s, r, i, a) {
                          const o = t + n;
                          return Ei(e, o, r, i) ? Yi(e, o + 2, a ? s.call(a, r, i) : s(r, i)) : So(e, o + 2);
                        })(r, Mn(), t, i.transform, n, s, i)
                      : i.transform(n, s)
                  );
                })(4, 7, null == e ? null : e.timeSlot, "hh:mm a")
              )
            );
        }
      }
      function qb(e, t) {
        if ((1 & e && (Xi(0, "div", 67), xi(1, Wb, 5, 12, "div", 68), Ri()), 2 & e)) {
          const e = Ki(2);
          Ws(1), ji("ngForOf", e.filteredTimeSlots);
        }
      }
      function xb(e, t) {
        1 & e &&
          (Xi(0, "span", 71), Ii(1, "input", 72), Ri(), Xi(2, "div", 73), ya(3, " Please select another day "), Ri());
      }
      function Bb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div"),
            Xi(1, "span", 74),
            Ji("click", function () {
              return an(e), Ki(2).seeMoreOptions();
            }),
            Ri(),
            Xi(2, "a", 75),
            Ji("click", function () {
              return an(e), Ki(2).seeMoreOptions();
            }),
            ya(3, "See more available times"),
            Ri(),
            Ri();
        }
      }
      function Hb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div"),
            Xi(1, "span", 76),
            Ji("click", function () {
              return an(e), Ki(2).seeLessOptions();
            }),
            Ri(),
            Xi(2, "a", 75),
            Ji("click", function () {
              return an(e), Ki(2).seeLessOptions();
            }),
            ya(3, "See less available times"),
            Ri(),
            Ri();
        }
      }
      function jb(e, t) {
        if (
          (1 & e &&
            (Xi(0, "div", 1),
            Xi(1, "div", 62),
            Xi(2, "p", 63),
            ya(3, " Select Time "),
            Ri(),
            xi(4, qb, 2, 1, "div", 64),
            xi(5, xb, 4, 0, "ng-template", null, 65, Qo),
            Xi(7, "div", 66),
            xi(8, Bb, 4, 0, "div", 8),
            xi(9, Hb, 4, 0, "div", 8),
            Ri(),
            Ri(),
            Ri()),
          2 & e)
        ) {
          const e = Bi(6),
            t = Ki();
          Ws(4),
            ji("ngIf", t.filteredTimeSlots && t.filteredTimeSlots.length > 0)("ngIfElse", e),
            Ws(4),
            ji("ngIf", t.isTimeSlotExceed && !t.isSeeMoreClicked),
            Ws(1),
            ji("ngIf", t.isSeeMoreClicked);
        }
      }
      const Pb = [[["p-footer"]], [["p-header"]]],
        Xb = function (e) {
          return { "retail-av-calendar": !0, "retail-av-calendar-w-btn": e };
        },
        Rb = function (e, t, n, s, r) {
          return {
            "retail-av-datepicker-inline": e,
            "retail-av-shadow": t,
            "retail-av-state-disabled": n,
            "retail-av-datepicker-timeonly": s,
            "retail-av-datepicker-with-multiple-month": r,
          };
        },
        Ib = function (e, t, n, s, r) {
          return { display: e, "margin-left": t, left: n, top: s, position: r };
        },
        Fb = function (e) {
          return { width: e };
        },
        Vb = ["p-footer", "p-header"];
      let Ub = (() => {
        class e extends tb {
          constructor(e, t, n, s, r, i) {
            super(i),
              (this.el = e),
              (this.renderer = t),
              (this.cd = n),
              (this.calendarService = s),
              (this.globalRefService = r),
              (this.viewContainerRef = i),
              (this.name = ""),
              (this.controlType = ""),
              (this.dateFormat = Sp.CUSTOM_DATE_FORMAT),
              (this.inline = !1),
              (this.showOtherMonths = !1),
              (this.icon = "fa-calendar"),
              (this.readonlyInput = !0),
              (this.shortYearCutoff = "+10"),
              (this.hourFormat = Yp.TWENTY_FOUR),
              (this.stepHour = 1),
              (this.stepMinute = 1),
              (this.stepSecond = 1),
              (this.showSeconds = !1),
              (this.showOnFocus = !0),
              (this.dataType = "date"),
              (this.disabledDates = []),
              (this.displayMonths = 1),
              (this.calendarWeekDayFormat = 1),
              (this.componentToLoad = null),
              (this.tabindex = 0),
              (this.onFocus = new Co()),
              (this.onBlur = new Co()),
              (this.onSelect = new Co()),
              (this.onInput = new Co()),
              (this.setCalenderRangeDays = new Co()),
              (this._locale = kp),
              (this.closeOverlay = !0),
              (this.inputFieldValue = null),
              (this._isValid = !0),
              (this.topCoordinate = 0),
              (this.leftCoordinate = 0),
              (this.dateMask = Sp.DEFAULT_DATE_MASK),
              (this.onNewEventReceived = new Co()),
              (this.dateTimeStrIntoObj = []),
              (this.availableDates = []),
              (this.availableTimeSlots = []),
              (this.selectedDate = new Date().toDateString()),
              (this.selectedTime = new Date()),
              (this.selectedTimeSlotId = ""),
              (this.moment = nb),
              (this.selectedFormattedDate = ""),
              (this.selectedDateField = new Co()),
              (this.selectedTimeField = new Co()),
              (this.selectedDateVal = ""),
              (this.selectedTimeVal = ""),
              (this.timeSlotId = new Co()),
              (this.filteredTimeSlots = []),
              (this.isTimeSlotsAvailable = !1),
              (this.isTimeSlotExceed = !1),
              (this.isPristine = !0),
              (this.isLocalRun = !1),
              (this.isCalendarClicked = !1),
              (this.isSeeMoreClicked = !1),
              (this.onModelChange = () => {}),
              (this.onModelTouched = () => {}),
              (this.enableTesting = !1);
          }
          get locale() {
            return this._locale;
          }
          set locale(e) {
            this.currentMonth &&
              ((this._locale = e), this.createWeekDays(), this.createMonth(this.currentMonth[0], this.currentYear[0]));
          }
          setCalenderRange(e) {
            this.setCalenderRangeDays.emit(e);
            const t = new Date(new Date().setDate(new Date().getDate() - e.payload.range)),
              n = {
                day: t.getDate(),
                month: t.getMonth(),
                year: t.getFullYear(),
                today: this.calendarService.isToday(new Date(), t.getDay(), t.getMonth(), t.getFullYear()),
                selectable: !0,
              };
            this.onDateSelect(null, n);
          }
          ngOnInit() {
            (this.inputStyleClass = "retail-av-input-text"),
              (this.defaultDate = new Date()),
              (this.placeholder = Sp.CUSTOM_DATE_FORMAT),
              (this.isLocalRun = !1),
              this.enableTesting && this.createTestingMockData(),
              this.isLocalRun
                ? (this.dateTimeStrIntoObj = this.dateTimeList)
                : ((this.dateTimeList = this.dateTimeList ? this.dateTimeList.replace(/'/g, '"') : this.dateTimeList),
                  (this.dateTimeStrIntoObj = this.dateTimeList ? JSON.parse(this.dateTimeList) : [])),
              (this.availableTimeSlots = this.dateTimeStrIntoObj.map((e) => {
                let t = e.date.split("-"),
                  n = e.startTime.split(":"),
                  s = e.endTime.split(":");
                return {
                  timeSlot: new Date(
                    parseInt(t[0]),
                    parseInt(t[1]) - 1,
                    parseInt(t[2]),
                    parseInt(n[0]),
                    parseInt(n[1])
                  ),
                  timeSlotId: e.timeSlotId,
                  endTime: new Date(parseInt(t[0]), parseInt(t[1]) - 1, parseInt(t[2]), parseInt(s[0]), parseInt(s[1])),
                };
              })),
              this.getAvailableAppointmentDateSlots(),
              (this.dateFormat = Sp.CUSTOM_DATE_FORMAT);
            const e = this.defaultDate || new Date();
            if (
              (this.createWeekDays(),
              (this.currentMonth = []),
              (this.dates = []),
              (this.currentMonthText = []),
              (this.currentYear = []),
              (this.currentMonth[0] = e.getMonth()),
              (this.currentYear[0] = e.getFullYear()),
              (this.numberOfMonth = Array(this.displayMonths)
                .fill(0)
                .map((e, t) => t)),
              (this.pm = e.getHours() > 11),
              this.showTime
                ? ((this.currentMinute = e.getMinutes()),
                  (this.currentSecond = e.getSeconds()),
                  (this.currentHour =
                    this.hourFormat === Yp.TWELVE ? (0 === e.getHours() ? 12 : e.getHours() % 12) : e.getHours()))
                : this.timeOnly && ((this.currentMinute = 0), (this.currentHour = 0), (this.currentSecond = 0)),
              this.createMonth(this.currentMonth[0], this.currentYear[0]),
              this.yearNavigator && this.yearRange)
            ) {
              this.yearOptions = [];
              const e = this.yearRange.split(":"),
                t = parseInt(e[0]),
                n = parseInt(e[1]);
              for (let s = t; s <= n; s++) this.yearOptions.push(s);
            }
            if ((this.setDateMask(), this.value)) {
              let e = !1;
              this.dateTimeStrIntoObj.filter((t) => {
                if (t.timeSlotId === this.value) {
                  const n = t.date.split("-");
                  (this.selectedDate = new Date(
                    parseInt(n[0]),
                    parseInt(n[1]) - 1,
                    parseInt(n[2]),
                    parseInt("00"),
                    parseInt("00"),
                    parseInt("00"),
                    parseInt("00")
                  ).toDateString()),
                    (this.selectedFormattedDate = nb(new Date(this.selectedDate)).format("MMMM DD, YYYY"));
                  const s = this.tConvert(t.startTime);
                  let r = new Date(this.selectedFormattedDate);
                  (this.isPristine = !1),
                    this.onCalendarSelection(r),
                    (this.initialDateVal = this.inputFieldValue),
                    (this.inputFieldValue = this.inputFieldValue + " : " + s),
                    (e = !0);
                }
              }),
                !1 === e && ((this.value = ""), this.timeSlotId.emit(this.value));
            }
          }
          setDateMask() {
            switch (this.dateFormat) {
              case Sp.DEFAULT_DATE_FORMAT:
                (this.dateMask = Sp.DEFAULT_DATE_MASK),
                  (this.textMask = { mask: this.dateMask, guide: !0, keepCharPositions: !0 });
                break;
              case Sp.SHORT_DATE_FORMAT:
                (this.dateMask = Sp.SHORT_DATE_MASK),
                  (this.textMask = { mask: this.dateMask, guide: !0, keepCharPositions: !0 });
                break;
              case Sp.MEDIUM_DATE_FORMAT:
                (this.dateMask = Sp.MEDIUM_DATE_MASK),
                  (this.textMask = { mask: this.dateMask, guide: !0, keepCharPositions: !0 });
                break;
              case Sp.LONG_DATE_FORMAT:
              case Sp.FULL_DATE_FORMAT:
                this.textMask = { mask: !1 };
                break;
              case Sp.STANDARD_DATE_FORMAT:
                (this.dateMask = Sp.STANDARD_DATE_MASK),
                  (this.textMask = { mask: this.dateMask, guide: !0, keepCharPositions: !0 });
                break;
              case Sp.ISO_DATE_FORMAT:
                (this.dateMask = Sp.ISO_DATE_MASK),
                  (this.textMask = { mask: this.dateMask, guide: !0, keepCharPositions: !0 });
            }
          }
          setCalendarDate(e) {
            this.calendarValue = e;
            try {
              (this.calendarValue = this.parseValueFromString(e)),
                (this.inputFieldValue = this.calendarService.formatDate(
                  this.calendarValue,
                  this.dateFormat,
                  this._locale
                )),
                this.updateUI(),
                (this._isValid = !0);
            } catch (t) {
              (this.calendarValue = null), (this.inputFieldValue = null), (this._isValid = !1);
            }
            this.updateModel(), (this.filled = null !== e && e.length);
          }
          ngAfterViewInit() {
            this.overlay = this.overlayViewChild.nativeElement;
          }
          ngAfterViewChecked() {
            this.overlayShown && (this.overlayShown = !1);
          }
          writeValue(e) {
            e && this.isCustomValidDate(this.getPlainText(e)) && Op.isValidDate(e)
              ? ((this.calendarValue = e),
                ("string" == typeof e || "object" == typeof e) &&
                  ((this.calendarValue = this.parseValueFromString(e.toString())),
                  this.updateInputfield(),
                  this.updateUI()))
              : ((this._isValid = !1),
                (this.prevValue = e),
                e
                  ? (this.calendarValue = this.getPlainText(e))
                  : ((this.calendarValue = null), (this.inputFieldValue = null)));
          }
          getPlainText(e) {
            return e.toString().replace(/_/g, "");
          }
          isValidDate(e) {
            let t;
            return e.length >= 10 && (t = "invalid date" !== new Date(e).toString().toLowerCase()), t;
          }
          registerOnChange(e) {
            this.onModelChange = e;
          }
          registerOnTouched(e) {
            this.onModelTouched = e;
          }
          setDisabledState(e) {
            this.disabled = e;
          }
          createWeekDays() {
            this.weekDays = [];
            let e = this.locale.firstDayOfWeek;
            for (let t = 0; t < 7; t++)
              this.weekDays.push(this.locale.dayNames[e].substring(0, this.calendarWeekDayFormat)),
                (e = 6 === e ? 0 : ++e);
          }
          createMonth(e, t) {
            for (let n = 0; n < this.displayMonths; n++) {
              let s = e + n,
                r = t;
              s > 11 && ((s = 0), r++), (this.dataMinDate = new Date());
              let i = new Date();
              (this.dataMaxDate = new Date(i.setDate(i.getDate() + 14))),
                (this.dates[n] = this.calendarService.createMonth(
                  s,
                  r,
                  this.dataMinDate,
                  this.dataMaxDate,
                  this.disabledDays,
                  this.disabledDates
                )),
                (this.currentMonth[n] = s),
                (this.currentYear[n] = r),
                (this.currentMonthText[n] = this.locale.monthNames[s]);
            }
          }
          prevMonth(e) {
            this.disabled ||
              (0 === this.currentMonth[0]
                ? ((this.currentMonth[0] = 11), this.currentYear[0]--)
                : this.currentMonth[0]--,
              this.createMonth(this.currentMonth[0], this.currentYear[0])),
              e.preventDefault();
          }
          nextMonth(e) {
            this.disabled ||
              (11 === this.currentMonth[0]
                ? ((this.currentMonth[0] = 0), this.currentYear[0]++)
                : this.currentMonth[0]++,
              this.createMonth(this.currentMonth[0], this.currentYear[0])),
              e.preventDefault();
          }
          onDateSelect(e, t) {
            if (this.disabled || !t.selectable) return void e.preventDefault();
            t.otherMonth ? this.selectOtherMonths && this.selectDate(t) : this.selectDate(t),
              (this.dateClick = !0),
              this.updateInputfield(),
              e && e.preventDefault(),
              this.invokeControlCallBack(this),
              (this.value = ""),
              this.timeSlotId.emit(this.value),
              (this.selectedDate = this.inputFieldValue),
              this.selectedDate && (this.selectedDate = this.selectedDate.replace(/,/g, "")),
              this.selectedDateField.emit(this.selectedDate),
              (this.selectedFormattedDate = this.inputFieldValue),
              (this.fullTimeSlotsAvailable = this.filterTimeSlots()),
              (this.isTimeSlotExceed = this.fullTimeSlotsAvailable.length > 6);
            let n = [...this.fullTimeSlotsAvailable];
            n &&
              ((this.numberOfSlots = parseInt(this.slotsToDisplay)),
              (this.filteredTimeSlots = n.splice(0, this.numberOfSlots))),
              !0 === this.isPristine && (this.selectedTimeSlotId = ""),
              (this.isPristine = !0),
              (this.isSeeMoreClicked = !1);
          }
          updateInputfield() {
            if (this.calendarValue) {
              let e;
              this.timeOnly
                ? (e = this.calendarService.formatTime(this.calendarValue, this.hourFormat, this.showSeconds))
                : ((e = this.calendarService.formatDate(this.calendarValue, this.dateFormat, this._locale)),
                  this.showTime &&
                    (e +=
                      " " + this.calendarService.formatTime(this.calendarValue, this.hourFormat, this.showSeconds))),
                (this.inputFieldValue = e);
            } else (this.inputFieldValue = ""), (this.calendarValue = null);
            this.updateFilledState();
          }
          selectDate(e) {
            (this.calendarValue = this.utc
              ? new Date(Date.UTC(e.year, e.month, e.day))
              : new Date(e.year, e.month, e.day)),
              this.showTime &&
                (this.calendarValue.setHours(
                  this.hourFormat === Yp.TWELVE && this.pm && 12 !== this.currentHour
                    ? this.currentHour + 12
                    : this.currentHour
                ),
                this.calendarValue.setMinutes(this.currentMinute),
                this.calendarValue.setSeconds(this.currentSecond)),
              (this._isValid = !0),
              this.updateModel(),
              this.onSelect.emit(this.calendarService.formatDate(this.calendarValue, this.dateFormat, this._locale));
          }
          updateModel() {
            "date" === this.dataType
              ? this.onModelChange(this.calendarService.formatDate(this.calendarValue, this.dateFormat, this._locale))
              : "string" === this.dataType &&
                (this.timeOnly
                  ? this.onModelChange(
                      this.calendarService.formatTime(this.calendarValue, this.hourFormat, this.showSeconds)
                    )
                  : (this.onModelChange(
                      this.calendarService.formatDate(this.calendarValue, this.dateFormat, this._locale)
                    ),
                    this.onSelect.emit(this.calendarService.getStandardDateFormat(this.calendarValue))));
          }
          isSelected(e) {
            return (
              !(!this.calendarValue || !this._isValid) &&
              this.calendarValue.getDate() === e.day &&
              this.calendarValue.getMonth() === e.month &&
              this.calendarValue.getFullYear() === e.year
            );
          }
          isInRange(e) {
            const t = new Date(e.year + "/" + (e.month + 1) + "/" + e.day);
            return !!(t && t >= this.selectedStartDateRange && t <= this.selectedEndDateRange);
          }
          findCoordinates() {
            let e = 352;
            if (1 === this.dates.length) {
              const t = this.dates[0];
              t[0][6].month === t[5][0].month && (e = 390);
            }
            const t = this.el.nativeElement,
              n = t.getBoundingClientRect(),
              s = this.globalRefService.appWindow;
            this.positionTypeFixed
              ? (n.top > s.innerHeight - t.offsetHeight - e
                  ? (this.topCoordinate = s.innerHeight - t.offsetHeight - (s.innerHeight - n.top) - e + 50)
                  : n.top <= s.innerHeight - t.offsetHeight - e && (this.topCoordinate = t.offsetHeight + n.top + 20),
                (this.leftCoordinate =
                  n.left + 20 + 312 > s.innerWidth ? n.left - (n.left + 20 + 312 - s.innerWidth) : n.left),
                this.leftCoordinate < 0 && (this.leftCoordinate = 0),
                (this.positionType = "fixed"),
                s.innerWidth <= 500 &&
                  ((this.positionType = "fixed"), (this.leftCoordinate = 10), (this.topCoordinate = 10)))
              : s.innerWidth <= 500 && !this.selectionRangePanel
              ? ((this.positionType = "fixed"), (this.leftCoordinate = 10), (this.topCoordinate = 10))
              : ((this.positionType = "absolute"), (this.leftCoordinate = null), (this.topCoordinate = null));
          }
          onInputFocus(e, t) {
            let n = new Date();
            null != this.inputFieldValue && this._isValid && (n = new Date(this.inputFieldValue)),
              null != this.selectedStartDateRange && (n = new Date(this.selectedStartDateRange)),
              (this.currentMonth[0] = n.getMonth()),
              (this.currentYear[0] = n.getFullYear()),
              this.createMonth(this.currentMonth[0], this.currentYear[0]),
              t.preventDefault(),
              (this.focus = !0),
              this.showOnFocus && this.showOverlay(e),
              this.findCoordinates(),
              this.onFocus.emit(t);
          }
          onInputBlur(e) {
            !this._isValid && this.calendarValue && (this.inputFieldValue = this.prevValue),
              this.calendarValue &&
                this.isCustomValidDate(this.getPlainText(this.calendarValue)) &&
                Op.isValidDate(this.calendarValue.toString()) &&
                ((this.focus = !1), this.onBlur.emit(e), this.updateInputfield(), this.onModelTouched());
          }
          isCustomValidDate(e) {
            let t, n, s;
            switch (this.dateFormat) {
              case Sp.DEFAULT_DATE_FORMAT:
                e &&
                  ((t = e.toString().split(" ")),
                  (s = t.length >= 4 && 3 === t[1].length && 2 === t[2].length && 4 === t[3].length));
                break;
              case Sp.SHORT_DATE_FORMAT:
                e &&
                  ((t = e.toString().split("/")),
                  (s = 3 === t.length && t[0].length >= 1 && t[1].length >= 1 && 2 === t[2].length));
                break;
              case Sp.MEDIUM_DATE_FORMAT:
                e &&
                  ((t = e.toString().split(",")),
                  2 === t.length &&
                    ((n = t[0].split(" ")),
                    2 === n.length && (s = 3 === n[0].length && n[1].length >= 1 && 4 === t[1].length)));
                break;
              case Sp.LONG_DATE_FORMAT:
                e &&
                  ((t = e.toString().split(",")),
                  2 === t.length &&
                    ((n = t[0].split(" ")),
                    2 === n.length && (s = n[0].length >= 3 && n[1].length >= 1 && 4 === t[1].length)));
                break;
              case Sp.FULL_DATE_FORMAT:
                e &&
                  ((t = e.toString().split(",")),
                  3 === t.length &&
                    ((n = t[1].split(" ")),
                    2 === n.length && (s = n[0].length >= 3 && n[1].length >= 1 && 4 === t[2].length)));
                break;
              case Sp.STANDARD_DATE_FORMAT:
                e &&
                  ((t = e.toString().split("/")),
                  (s = 3 === t.length && 2 === t[0].length && 2 === t[1].length && 4 === t[2].length));
                break;
              case Sp.ISO_DATE_FORMAT:
                e &&
                  ((t = e.toString().split("-")),
                  (s = 3 === t.length && 4 === t[0].length && 2 === t[1].length && 2 === t[2].length));
            }
            return s;
          }
          onButtonClick(e, t) {
            console.log("one"),
              console.log(this.closeOverlay),
              (this.closeOverlay = !1),
              (this.overlayVisible = !0),
              this.overlay.offsetParent || (t.focus(), this.showOverlay(t));
          }
          onInputKeydown(e) {
            9 === e.keyCode && (this.overlayVisible = !1);
          }
          onMonthDropdownChange(e) {
            (this.currentMonth[0] = parseInt(e.target.value)),
              this.createMonth(this.currentMonth[0], this.currentYear[0]);
          }
          onYearDropdownChange(e) {
            (this.currentYear[0] = parseInt(e.target.value)),
              this.createMonth(this.currentMonth[0], this.currentYear[0]);
          }
          incrementHour(e) {
            const t = this.currentHour + this.stepHour;
            this.hourFormat === Yp.TWENTY_FOUR
              ? (this.currentHour = t >= 24 ? t - 24 : t)
              : this.hourFormat === Yp.TWELVE && (this.currentHour = t >= 13 ? t - 12 : t),
              this.updateTime(),
              e.preventDefault();
          }
          decrementHour(e) {
            const t = this.currentHour - this.stepHour;
            this.hourFormat === Yp.TWENTY_FOUR
              ? (this.currentHour = t < 0 ? 24 + t : t)
              : this.hourFormat === Yp.TWELVE && (this.currentHour = t <= 0 ? 12 + t : t),
              this.updateTime(),
              e.preventDefault();
          }
          incrementMinute(e) {
            const t = this.currentMinute + this.stepMinute;
            (this.currentMinute = t > 59 ? t - 60 : t), this.updateTime(), e.preventDefault();
          }
          decrementMinute(e) {
            const t = this.currentMinute - this.stepMinute;
            (this.currentMinute = t < 0 ? 60 + t : t), this.updateTime(), e.preventDefault();
          }
          incrementSecond(e) {
            const t = this.currentSecond + this.stepSecond;
            (this.currentSecond = t > 59 ? t - 60 : t), this.updateTime(), e.preventDefault();
          }
          decrementSecond(e) {
            const t = this.currentSecond - this.stepSecond;
            (this.currentSecond = t < 0 ? 60 + t : t), this.updateTime(), e.preventDefault();
          }
          updateTime() {
            (this.calendarValue = this.calendarValue || new Date()),
              this.calendarValue.setHours(
                this.hourFormat === Yp.TWELVE && this.pm && 12 !== this.currentHour
                  ? this.currentHour + 12
                  : this.currentHour
              ),
              this.calendarValue.setMinutes(this.currentMinute),
              this.calendarValue.setSeconds(this.currentSecond),
              this.updateModel(),
              this.onSelect.emit(this.calendarValue),
              this.updateInputfield();
          }
          toggleAMPM(e) {
            (this.pm = !this.pm), this.updateTime(), e.preventDefault();
          }
          onUserInput(e) {
            let t, n;
            switch (this.dateFormat) {
              case Sp.DEFAULT_DATE_FORMAT:
              case Sp.SHORT_DATE_FORMAT:
                t = Op.isValidDate(e.target.value.substring(3));
                break;
              case Sp.MEDIUM_DATE_FORMAT:
              case Sp.LONG_DATE_FORMAT:
                (n = e.target.value.toString().split(",")),
                  n.length > 1 && 4 === n[1].trim().length && (t = Op.isValidDate(e.target.value));
                break;
              case Sp.FULL_DATE_FORMAT:
                (n = e.target.value.toString().split(",")),
                  n.length > 2 && 4 === n[2].trim().length && (t = Op.isValidDate(e.target.value));
                break;
              case Sp.STANDARD_DATE_FORMAT:
                (n = e.target.value.toString().split("/")),
                  n.length > 2 && 4 === n[2].trim().length && (t = Op.isValidDate(e.target.value));
                break;
              case Sp.ISO_DATE_FORMAT:
                (n = e.target.value.toString().split("-")),
                  n.length > 2 && 2 === n[2].trim().length && (t = Op.isValidDate(e.target.value));
            }
            t ? this.onCalendarSelection(e.target.value) : this.onInput.emit(e.target.value);
          }
          onCalendarSelection(e) {
            try {
              (this.calendarValue = this.parseValueFromString(e)),
                (this.inputFieldValue = this.calendarService.formatDate(
                  this.calendarValue,
                  this.dateFormat,
                  this._locale
                )),
                this.updateUI(),
                (this._isValid = !0),
                this.onSelect.emit(this.calendarService.formatDate(this.calendarValue, this.dateFormat, this._locale));
            } catch (t) {
              (this.calendarValue = null), (this.inputFieldValue = null), (this._isValid = !1);
            }
            this.updateModel(),
              (this.filled = null !== e && e.length),
              this.onInput.emit(this.calendarService.formatDate(this.calendarValue, this.dateFormat, this._locale));
          }
          parseValueFromString(e) {
            let t;
            const n = e.toString().split(" ");
            return (
              this.timeOnly
                ? ((t = new Date()), this.populateTime(t, n[0], n[1]))
                : this.showTime
                ? ((t = this.calendarService.parseDate(n[0], this.dateFormat, this._locale, this.shortYearCutoff)),
                  this.populateTime(t, n[1], n[2]))
                : (t = this.calendarService.parseDate(e, this.dateFormat, this._locale, this.shortYearCutoff)),
              t
            );
          }
          populateTime(e, t, n) {
            if (this.hourFormat === Yp.TWELVE && !n) throw new Error("Invalid Time");
            this.pm = "PM" === n || "pm" === n;
            const s = this.calendarService.parseTime(t, this.hourFormat, this.showSeconds, this.pm);
            e.setHours(s.hour), e.setMinutes(s.minute), e.setSeconds(s.second);
          }
          updateUI() {
            const e = this.calendarValue || this.defaultDate || new Date();
            if ((this.createMonth(e.getMonth(), e.getFullYear()), this.showTime || this.timeOnly)) {
              const t = e.getHours();
              (this.currentHour =
                this.hourFormat === Yp.TWELVE ? (t >= 12 ? (12 === t ? 12 : t - 12) : 0 === t ? 12 : t) : e.getHours()),
                (this.currentMinute = e.getMinutes()),
                (this.currentSecond = e.getSeconds());
            }
          }
          showOverlay(e) {
            (this.overlayVisible = e), (this.overlayShown = e), this.bindDocumentClickListener();
          }
          displayOverlay(e) {
            (this.closeOverlay = !e), this.showOverlay(e);
          }
          unbindDocumentClickListener() {
            this.documentClickListener && this.documentClickListener();
          }
          updateFilledState() {
            this.filled = this.inputFieldValue && "" !== this.inputFieldValue;
          }
          bindDocumentClickListener() {
            this.documentClickListener ||
              (this.documentClickListener = this.renderer.listen("document", "click", () => {
                this.closeOverlay && (this.overlayVisible = !1),
                  (this.overlayVisible = !0),
                  (this.dateClick = !1),
                  this.cd.detectChanges();
              }));
          }
          isDefault(e) {
            if (this.inputFieldValue && "" !== this.inputFieldValue) {
              const t = new Date(this.inputFieldValue);
              return t.getDate() === e.day && t.getMonth() === e.month && t.getFullYear() === e.year;
            }
            return !1;
          }
          getDates(e, t) {
            for (var n = new Array(), s = e; s <= t; ) n.push(new Date(s)), (s = this.addDays(s, 1));
            return n;
          }
          addDays(e, t) {
            var n = new Date(e);
            return n.setDate(n.getDate() + t), n;
          }
          getAvailableAppointmentDateSlots() {
            let e = new Date(),
              t = this.getDates(new Date(e.setDate(e.getDate())), new Date(e.setDate(e.getDate() + 14)));
            if (
              (t.map((e) => this.moment(e).startOf("day").toDate()),
              t.forEach((e) => {
                let t = {},
                  n = this.dateTimeStrIntoObj.filter((t) => t.date === nb(e).format("YYYY-MM-DD"));
                (t.dateObj = e),
                  n.length > 0 ? (t.isEnabled = !0) : ((t.isEnabled = !1), this.disabledDates.push(new Date(e))),
                  this.availableDates.push(t);
              }),
              console.log("this.availableDates", this.availableDates),
              this.availableTimeSlots.sort((e, t) => e.timeSlot.getTime() - t.timeSlot.getTime()),
              this.availableTimeSlots.length > 0)
            ) {
              const e =
                this.availableTimeSlots.find((e) => this.moment(e.timeSlot).isSame(this.selectedDate, "day")) ||
                this.availableTimeSlots[0].timeSlot;
              e.timeSlot && (this.selectedDate = e.timeSlot.toDateString());
            }
          }
          filterTimeSlots() {
            return this.availableTimeSlots.filter(
              (e) => new Date(e.timeSlot).toDateString() === new Date(this.selectedDate).toDateString()
            );
          }
          onTimeSlotChange(e, t) {
            (this.selectedTime = new Date(e.srcElement.id)), this.selectedTimeField.emit(this.selectedTime);
            const n = nb(this.selectedTime).format("hh:mm A");
            (this.selectedTimeSlotId = t),
              (this.value = this.selectedTimeSlotId),
              (this.selectedDateVal = this.selectedFormattedDate),
              (this.selectedTimeVal = n),
              this.inputFieldValue.includes(":")
                ? ((this.inputFieldValue = this.inputFieldValue.split(" :")[0]),
                  (this.inputFieldValue = this.inputFieldValue + " : " + this.selectedTimeVal.toLowerCase()))
                : (this.inputFieldValue = this.inputFieldValue + " : " + this.selectedTimeVal.toLowerCase()),
              document.getElementById("calid") &&
                (document.getElementById("calid").setAttribute("selectedDateVal", this.selectedFormattedDate),
                document.getElementById("calid").setAttribute("selectedTimeVal", n)),
              this.timeSlotId.emit(this.value);
          }
          seeMoreOptions() {
            (this.numberOfSlots += parseInt(this.slotsToDisplay)),
              (this.filteredTimeSlots = [...this.fullTimeSlotsAvailable]),
              this.filteredTimeSlots.length === this.fullTimeSlotsAvailable.length && (this.isTimeSlotExceed = !1),
              (this.isSeeMoreClicked = !0);
          }
          seeLessOptions() {
            (this.isSeeMoreClicked = !1),
              (this.numberOfSlots = parseInt(this.slotsToDisplay)),
              (this.filteredTimeSlots = [...this.fullTimeSlotsAvailable].splice(0, this.numberOfSlots)),
              (this.isTimeSlotExceed = this.fullTimeSlotsAvailable.length > 6);
          }
          onDatePickerClick(e) {}
          onLoadSelectDate(e) {
            new Date().toDateString(),
              (this.selectedDate = !1 === this.isPristine ? this.initialDateVal : this.inputFieldValue),
              this.selectedDate && (this.selectedDate = this.selectedDate.replace(/,/g, "")),
              (this.fullTimeSlotsAvailable = this.filterTimeSlots()),
              (this.isTimeSlotExceed = this.fullTimeSlotsAvailable.length > 6);
            let t = [...this.fullTimeSlotsAvailable];
            t &&
              ((this.numberOfSlots = parseInt(this.slotsToDisplay)),
              (this.filteredTimeSlots = t.splice(0, this.numberOfSlots))),
              !0 === this.isPristine && (this.selectedTimeSlotId = ""),
              (this.isPristine = !0);
          }
          onCalendarClick() {
            (this.isCalendarClicked = !0),
              (this.closeOverlay = !1),
              (this.overlayVisible = !0),
              this.inputFieldValue ||
                (this.defaultDate && (this.onCalendarSelection(this.defaultDate), this.onLoadSelectDate(""))),
              !1 === this.isPristine && ((this.selectedTimeSlotId = this.value), this.onLoadSelectDate(""));
          }
          createTestingMockData() {
            (this.slotsToDisplay = "6"),
              null == this.dateTimeList &&
                ((this.isLocalRun = !0),
                (this.dateTimeList = [
                  {
                    timeSlotId:
                      "TW9uIEp1biAxNCAwMDowMDowMCBFRFQgMjAyMXw0fDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs1",
                    date: "2022-06-29",
                    timeSlot: "1400-1430",
                    startTime: "14:00",
                    endTime: "14:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs2",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "14:30",
                    endTime: "15:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-29",
                    timeSlot: "1500-1530",
                    startTime: "15:00",
                    endTime: "15:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "11:30",
                    endTime: "12:00",
                  },
                  {
                    timeSlotId:
                      "TW9uIEp1biAxNCAwMDowMDowMCBFRFQgMjAyMXw0fDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs1",
                    date: "2022-06-29",
                    timeSlot: "1400-1430",
                    startTime: "14:00",
                    endTime: "14:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs2",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "14:30",
                    endTime: "15:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-29",
                    timeSlot: "1500-1530",
                    startTime: "15:00",
                    endTime: "15:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "11:30",
                    endTime: "12:00",
                  },
                  {
                    timeSlotId:
                      "TW9uIEp1biAxNCAwMDowMDowMCBFRFQgMjAyMXw0fDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs1",
                    date: "2022-06-29",
                    timeSlot: "1400-1430",
                    startTime: "14:00",
                    endTime: "14:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs2",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "14:30",
                    endTime: "15:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-29",
                    timeSlot: "1500-1530",
                    startTime: "15:00",
                    endTime: "15:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "11:30",
                    endTime: "12:00",
                  },
                  {
                    timeSlotId:
                      "TW9uIEp1biAxNCAwMDowMDowMCBFRFQgMjAyMXw0fDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs1",
                    date: "2022-06-29",
                    timeSlot: "1400-1430",
                    startTime: "14:00",
                    endTime: "14:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs2",
                    date: "2022-06-29",
                    timeSlot: "1430-1500",
                    startTime: "14:30",
                    endTime: "15:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-29",
                    timeSlot: "1500-1530",
                    startTime: "15:00",
                    endTime: "15:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-01",
                    timeSlot: "1430-1500",
                    startTime: "11:30",
                    endTime: "12:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSbAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-29",
                    timeSlot: "1800-1830",
                    startTime: "18:00",
                    endTime: "18:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-30",
                    timeSlot: "1830-1900",
                    startTime: "18:30",
                    endTime: "19:00",
                  },
                  {
                    timeSlotId:
                      "TW9uIEp1biAxNCAwMDowMDowMCBFRFQgMjAyMXw0fDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs1",
                    date: "2022-06-30",
                    timeSlot: "1900-1930",
                    startTime: "19:00",
                    endTime: "19:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs2",
                    date: "2022-06-30",
                    timeSlot: "1430-1500",
                    startTime: "14:30",
                    endTime: "20:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-30",
                    timeSlot: "1500-1530",
                    startTime: "15:00",
                    endTime: "20:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-30",
                    timeSlot: "1430-1500",
                    startTime: "11:30",
                    endTime: "21:00",
                  },
                  {
                    timeSlotId:
                      "TW9uIEp1biAxNCAwMDowMDowMCBFRFQgMjAyMXw0fDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs1",
                    date: "2022-06-30",
                    timeSlot: "1400-1430",
                    startTime: "14:00",
                    endTime: "22:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs2",
                    date: "2022-06-30",
                    timeSlot: "1430-1500",
                    startTime: "14:30",
                    endTime: "22:00",
                  },
                  {
                    timeSlotId:
                      "U2F0IEp1biAxOSAwMDowMDowMCBFRFQgMjAyMXxZfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs3",
                    date: "2022-06-30",
                    timeSlot: "1500-1530",
                    startTime: "15:00",
                    endTime: "23:30",
                  },
                  {
                    timeSlotId:
                      "VHVlIEp1biAxNSAwMDowMDowMCBFRFQgMjAyMXwwfDlXfDAwMDAwMDAwMDAwMDI4MDF8UEMyMDAwNUJCOENFQzdBQzgwMDAwMHxudWxs4",
                    date: "2022-06-30",
                    timeSlot: "1430-1500",
                    startTime: "11:30",
                    endTime: "18:00",
                  },
                ]));
          }
          tConvert(e) {
            return (
              (e = e.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [e]).length > 1 &&
                (((e = e.slice(1))[5] = +e[0] < 12 ? " am" : " pm"), (e[0] = +e[0] % 12 || 12)),
              e.join("")
            );
          }
          ngOnDestroy() {
            this.unbindDocumentClickListener();
          }
          validate(e) {
            return this._isValid ? null : { invalidDate: !0 };
          }
        }
        var t;
        return (
          (e.ɵfac = function (t) {
            return new (t || e)(Hi(Xa), Hi(Va), Hi(ei), Hi(Np), Hi(sb), Hi(mo));
          }),
          (e.ɵcmp = dt({
            type: e,
            selectors: [["calendar-component"]],
            viewQuery: function (e, t) {
              var n;
              1 & e && (Vo(rb, !0), Vo(ib, !0)),
                2 & e &&
                  (Fo((n = Jo())) && (t.overlayViewChild = n.first),
                  Fo((n = Jo())) && (t.inputfieldViewChild = n.first));
            },
            hostVars: 4,
            hostBindings: function (e, t) {
              2 & e && la("ui-inputwrapper-filled", t.filled)("ui-inputwrapper-focus", t.focus);
            },
            inputs: {
              name: "name",
              controlType: "controlType",
              defaultDate: "defaultDate",
              style: "style",
              styleClass: "styleClass",
              inputStyle: "inputStyle",
              inputId: "inputId",
              inputName: "inputName",
              inputStyleClass: "inputStyleClass",
              placeholder: "placeholder",
              disabled: "disabled",
              dateFormat: "dateFormat",
              inline: "inline",
              showOtherMonths: "showOtherMonths",
              selectOtherMonths: "selectOtherMonths",
              showIcon: "showIcon",
              icon: "icon",
              readonlyInput: "readonlyInput",
              shortYearCutoff: "shortYearCutoff",
              monthNavigator: "monthNavigator",
              yearNavigator: "yearNavigator",
              yearRange: "yearRange",
              showTime: "showTime",
              hourFormat: "hourFormat",
              timeOnly: "timeOnly",
              stepHour: "stepHour",
              stepMinute: "stepMinute",
              stepSecond: "stepSecond",
              showSeconds: "showSeconds",
              required: "required",
              showOnFocus: "showOnFocus",
              dataType: "dataType",
              disabledDates: "disabledDates",
              disabledDays: "disabledDays",
              utc: "utc",
              displayMonths: "displayMonths",
              minDate: "minDate",
              maxDate: "maxDate",
              selectedStartDateRange: "selectedStartDateRange",
              selectedEndDateRange: "selectedEndDateRange",
              displayHeading: "displayHeading",
              selectionRangePanel: "selectionRangePanel",
              calendarLeftMargin: "calendarLeftMargin",
              calendarWeekDayFormat: "calendarWeekDayFormat",
              positionTypeFixed: "positionTypeFixed",
              componentToLoad: "componentToLoad",
              tabindex: "tabindex",
              dateTimeList: ["dataTimeApi", "dateTimeList"],
              value: "value",
              selectedDateVal: "selectedDateVal",
              selectedTimeVal: "selectedTimeVal",
              slotsToDisplay: "slotsToDisplay",
              locale: "locale",
              enableTesting: "enableTesting",
            },
            outputs: {
              onFocus: "onFocus",
              onBlur: "onBlur",
              onSelect: "onSelect",
              onInput: "onInput",
              setCalenderRangeDays: "setCalenderRangeDays",
              onNewEventReceived: "onNewEventReceived",
              selectedDateField: "selectedDateField",
              selectedTimeField: "selectedTimeField",
              timeSlotId: "timeSlotId",
            },
            features: [
              Ba([
                { provide: Z_, useExisting: Le(() => e), multi: !0 },
                { provide: Mf, useExisting: Le(() => e), multi: !0 },
              ]),
              Li,
            ],
            ngContentSelectors: Vb,
            decls: 14,
            vars: 30,
            consts: [
              [1, "retail-av-datetime-container"],
              [1, "retail-av-time-section"],
              [1, "retail-av-datepicker-text"],
              [3, "ngClass", "ngStyle"],
              [3, "ngIf"],
              [
                "role",
                "dialog",
                1,
                "retail-av-datepicker",
                "retail-av-widget",
                "retail-av-widget-content",
                "retail-av-helper-clearfix",
                "retail-av-corner-all",
                3,
                "tabindex",
                "ngClass",
                "ngStyle",
                "click",
              ],
              ["datepicker", ""],
              [1, "retail-av-datepicker-container", 3, "ngStyle"],
              [4, "ngIf"],
              ["class", "retail-av-calendar-date-pannel", 4, "ngFor", "ngForOf"],
              ["class", "retail-av-timepicker retail-av-widget-header retail-av-corner-all", 4, "ngIf"],
              ["class", "retail-av-time-section", 4, "ngIf"],
              [
                "aria-haspopup",
                "true",
                "role",
                "textbox",
                "type",
                "text",
                3,
                "value",
                "readonly",
                "ngStyle",
                "placeholder",
                "disabled",
                "ngClass",
                "keydown",
                "click",
                "blur",
                "input",
              ],
              ["inputfield", ""],
              ["role", "button", "type", "button", 3, "ngClass", "disabled", "click", 4, "ngIf"],
              ["role", "button", "type", "button", 3, "ngClass", "disabled", "click"],
              [1, "retail-av-calendar-date-pannel"],
              [1, "retail-av-calendar-date-panel-width", "retail-av-datepicker-calendar-margin", 3, "ngClass"],
              [
                "class",
                "retail-av-datepicker-header retail-av-widget-header retail-av-helper-clearfix retail-av-corner-all",
                4,
                "ngIf",
              ],
              ["role", "grid", "aria-label", "calendarheader", "class", "retail-av-datepicker-calendar", 4, "ngIf"],
              [
                1,
                "retail-av-datepicker-header",
                "retail-av-widget-header",
                "retail-av-helper-clearfix",
                "retail-av-corner-all",
              ],
              [
                "class",
                "retail-av-datepicker-prev retail-av-corner-all",
                "title",
                "Prev",
                "href",
                "#",
                "role",
                "button",
                "aria-label",
                "previous month",
                3,
                "tabindex",
                "click",
                4,
                "ngIf",
              ],
              [
                "class",
                "retail-av-datepicker-next retail-av-corner-all",
                "title",
                "Next",
                "href",
                "#",
                "role",
                "button",
                "aria-label",
                "next month",
                3,
                "tabindex",
                "click",
                4,
                "ngIf",
              ],
              [1, "retail-av-datepicker-title"],
              ["class", "retail-av-datepicker-month", 4, "ngIf"],
              ["class", "retail-av-datepicker-month", 3, "change", 4, "ngIf"],
              ["class", "retail-av-datepicker-year", 3, "change", 4, "ngIf"],
              ["class", "retail-av-datepicker-year", 4, "ngIf"],
              [
                "title",
                "Prev",
                "href",
                "#",
                "role",
                "button",
                "aria-label",
                "previous month",
                1,
                "retail-av-datepicker-prev",
                "retail-av-corner-all",
                3,
                "tabindex",
                "click",
              ],
              [1, "fa", "fa-angle-left"],
              [
                "title",
                "Next",
                "href",
                "#",
                "role",
                "button",
                "aria-label",
                "next month",
                1,
                "retail-av-datepicker-next",
                "retail-av-corner-all",
                3,
                "tabindex",
                "click",
              ],
              [1, "fa", "fa-angle-right"],
              [1, "retail-av-datepicker-month"],
              [1, "retail-av-datepicker-month", 3, "change"],
              [3, "value", "selected", 4, "ngFor", "ngForOf"],
              [3, "value", "selected"],
              [1, "retail-av-datepicker-year", 3, "change"],
              [1, "retail-av-datepicker-year"],
              ["role", "grid", "aria-label", "calendarheader", 1, "retail-av-datepicker-calendar"],
              ["role", "rowgroup"],
              ["role", "row"],
              ["role", "columnheader", "scope", "col", 4, "ngFor", "ngForOf"],
              ["role", "row", 4, "ngFor", "ngForOf"],
              ["role", "columnheader", "scope", "col"],
              ["role", "gridcell", 3, "ngClass", 4, "ngFor", "ngForOf"],
              ["role", "gridcell", 3, "ngClass"],
              ["class", "retail-av-state-default", "href", "#", 3, "ngClass", "tabindex", "click", 4, "ngIf"],
              ["href", "#", 1, "retail-av-state-default", 3, "ngClass", "tabindex", "click"],
              [1, "retail-av-timepicker", "retail-av-widget-header", "retail-av-corner-all"],
              [1, "retail-av-hour-picker"],
              ["href", "#", 3, "tabindex", "click"],
              [1, "fa", "fa-angle-up"],
              [3, "ngStyle"],
              [1, "fa", "fa-angle-down"],
              [1, "retail-av-separator"],
              ["href", "#"],
              [1, "retail-av-minute-picker"],
              ["class", "retail-av-separator", 4, "ngIf"],
              ["class", "retail-av-second-picker", 4, "ngIf"],
              ["class", "retail-av-ampm-picker", 4, "ngIf"],
              [1, "retail-av-second-picker"],
              [1, "retail-av-ampm-picker"],
              [1, "retail-av-time-slot-container"],
              [1, "retail-av-datepicker-text", "retail-av-timeslot-text"],
              ["class", "retail-av-slot-time-area", "id", "timeDetails", 4, "ngIf", "ngIfElse"],
              ["noSlotSection", ""],
              [1, "retail-av-timeslot-container"],
              ["id", "timeDetails", 1, "retail-av-slot-time-area"],
              ["class", "retail-av-slot-time", 3, "id", "ngClass", "click", 4, "ngFor", "ngForOf"],
              [1, "retail-av-slot-time", 3, "id", "ngClass", "click"],
              [1, "retail-av-time-span", 3, "id"],
              [1, "retail-av-calendar", "retail-av-no-timeslot-icon"],
              [
                "value",
                "No time slots available",
                "readonly",
                "true",
                1,
                "retail-av-input-text",
                "retail-av-inputtext",
                "retail-av-notimeslot-available",
              ],
              [1, "retail-av-time-error-message"],
              [1, "retail-av-purple-arrow", 3, "click"],
              [1, "retail-show-more-timeslots", 3, "click"],
              [1, "retail-av-purple-arrow-down", 3, "click"],
            ],
            template: function (e, t) {
              1 & e &&
                ((function (e) {
                  const t = sn()[16][6];
                  if (!t.projection) {
                    const n = (t.projection = tt(e ? e.length : 1, null)),
                      s = n.slice();
                    let r = t.child;
                    for (; null !== r; ) {
                      const t = e ? $i(r, e) : 0;
                      null !== t && (s[t] ? (s[t].projectionNext = r) : (n[t] = r), (s[t] = r)), (r = r.next);
                    }
                  }
                })(Pb),
                Xi(0, "section", 0),
                Xi(1, "div", 1),
                Xi(2, "div", 2),
                ya(3, " Select a date for your appointment "),
                Ri(),
                Ri(),
                Xi(4, "span", 3),
                xi(5, lb, 3, 15, "ng-template", 4),
                Xi(6, "div", 5, 6),
                Ji("click", function (e) {
                  return t.onDatePickerClick(e);
                }),
                Xi(8, "div", 7),
                xi(9, db, 2, 1, "div", 8),
                xi(10, Ob, 4, 5, "div", 9),
                Ri(),
                xi(11, Eb, 29, 15, "div", 10),
                Zi(12),
                Ri(),
                Ri(),
                xi(13, jb, 10, 4, "div", 11),
                Ri()),
                2 & e &&
                  (Ws(4),
                  da(t.styleClass),
                  ji("ngClass", vo(14, Xb, t.showIcon))("ngStyle", t.style),
                  Ws(1),
                  ji("ngIf", !t.inline),
                  Ws(1),
                  ea("tabindex", t.tabindex),
                  ji("ngClass", Oo(16, Rb, t.inline, !t.inline, t.disabled, t.timeOnly, t.selectionRangePanel))(
                    "ngStyle",
                    Oo(
                      22,
                      Ib,
                      t.inline ? "inline-block" : t.overlayVisible && t.showOnFocus ? "block" : "none",
                      t.calendarLeftMargin + "px",
                      0 !== t.leftCoordinate ? t.leftCoordinate + "px" : "inherit",
                      0 !== t.topCoordinate ? t.topCoordinate + "px" : "inherit",
                      t.positionTypeFixed ? "fixed" : t.positionType
                    )
                  )("@overlayState", t.inline || (t.overlayVisible && t.showOnFocus) ? "visible" : "hidden"),
                  Ws(2),
                  ji(
                    "ngStyle",
                    vo(
                      28,
                      Fb,
                      290 * t.displayMonths + 30 * (t.displayMonths - 1) + (t.selectionRangePanel ? 257 : 0) + "px"
                    )
                  ),
                  Ws(1),
                  ji("ngIf", t.displayHeading),
                  Ws(1),
                  ji("ngForOf", t.numberOfMonth),
                  Ws(1),
                  ji("ngIf", t.showTime || t.timeOnly),
                  Ws(2),
                  ji("ngIf", t.inputFieldValue && t.isPristine));
            },
            directives: [Xl, Gl, Vl, Il, Nf, qf],
            pipes: [Kl, $l],
            styles: [
              '.retail-av-button-secondary{font-family:xfinitystandard;position:relative;display:block;padding:12px 24px;left:0;border-radius:40px;font-size:16px;cursor:pointer;transition:background-color .3s ease 0s,border .3s ease 0s,color .3s ease 0s,padding 1s ease 0s,line-height 1s ease 0s,border-radius 1s ease 0s,font-size 1s ease 0s,left 1s ease 0s;outline:none;line-height:1}.retail-av-input-text{display:block;width:100%;height:auto!important;padding:10px;border-radius:3px;font-size:16px;font-family:XfinityStandard}.retail-av-datepicker{border-radius:4px}.retail-av-calendar:after{content:"";display:block;position:absolute;width:20px;height:20px;right:10px;top:10px;background-repeat:no-repeat;background-size:contain;pointer-events:none}.retail-av-calendar{position:relative;display:inline-block;margin-bottom:20px}.retail-av-calendar *{box-sizing:border-box}.retail-av-calendar-date-pannel button{height:100%;border-top-left-radius:0;border-bottom-left-radius:0;position:absolute;width:2em;border-left:0}.retail-av-fluid .retail-av-calendar{width:100%}.retail-av-fluid .retail-av-calendar button{width:2em}.retail-av-fluid .retail-av-calendar.retail-av-calendar-w-btn .retail-av-inputtext{width:calc(100% - 2em)}.retail-av-datepicker{position:absolute;top:40px;border-radius:8px;z-index:9999}.retail-av-datepicker.retail-av-datepicker-inline{display:block;position:static}.retail-av-datepicker .retail-av-datepicker-header{position:relative;padding:.2em 0}.retail-av-datepicker .retail-av-datepicker-next,.retail-av-datepicker .retail-av-datepicker-prev{position:absolute;top:.125em;width:1.8em;height:1.8em;background-position:50%;background-repeat:no-repeat}.retail-av-datepicker .retail-av-datepicker-prev{left:.125em}.retail-av-datepicker .retail-av-datepicker-next{right:.125em}.retail-av-datepicker .retail-av-datepicker-next span,.retail-av-datepicker .retail-av-datepicker-prev span{display:block;position:absolute;left:50%;top:50%;margin-top:-.5em}.retail-av-datepicker .retail-av-datepicker-prev span{margin-left:-.25em}.retail-av-datepicker .retail-av-datepicker-next span{margin-left:-.125em}.retail-av-datepicker .retail-av-datepicker-title{margin:0 2.3em;line-height:1.8em;text-align:center}.retail-av-datepicker .retail-av-datepicker-title select{font-size:1em;margin:.125em 0}.retail-av-datepicker select.retail-av-datepicker-month{width:55%}.retail-av-datepicker select.retail-av-datepicker-year{width:35%}.retail-av-datepicker select.retail-av-datepicker-month{margin-right:.25em}.retail-av-datepicker table{width:100%;font-size:.9em;border-collapse:collapse;margin:0 0 .4em}.retail-av-datepicker th{padding:.7em .3em;text-align:center;font-weight:700;border:0}.retail-av-datepicker td{border:0}.retail-av-datepicker .retail-av-state-default.retail-av-state-disabled{pointer-events:none;mix-blend-mode:normal;opacity:.3}.retail-av-datepicker td a,.retail-av-datepicker td span{display:inline-block;width:40px;height:40px;line-height:40px;vertical-align:middle;text-align:center;text-decoration:none}.retail-av-datepicker .retail-av-datepicker-buttonpane{background-image:none;margin:.7em 0 0;padding:0 .2em;border-left:0;border-right:0;border-bottom:0}.retail-av-datepicker .retail-av-datepicker-buttonpane button{float:right;margin:.5em .2em .4em;cursor:pointer;padding:.2em .6em .3em;width:auto;overflow:visible}.retail-av-datepicker .retail-av-datepicker-buttonpane button.retail-av-datepicker-current{float:left}.retail-av-datepicker.retail-av-datepicker-multi{width:auto}.retail-av-datepicker-multi .retail-av-datepicker-group{float:left}.retail-av-datepicker-multi .retail-av-datepicker-group table{width:95%;margin:0 auto .4em}.retail-av-datepicker-multi-2 .retail-av-datepicker-group{width:50%}.retail-av-datepicker-multi-3 .retail-av-datepicker-group{width:33.3%}.retail-av-datepicker-multi-4 .retail-av-datepicker-group{width:25%}.retail-av-datepicker-multi .retail-av-datepicker-group-last .retail-av-datepicker-header,.retail-av-datepicker-multi .retail-av-datepicker-group-middle .retail-av-datepicker-header{border-left-width:0}.retail-av-datepicker-multi .retail-av-datepicker-buttonpane{clear:left}.retail-av-datepicker-row-break{clear:both;width:100%;font-size:0}.retail-av-calendar.retail-av-calendar-w-btn input{border-top-right-radius:0;border-bottom-right-radius:0}.retail-av-timepicker{text-align:center;padding:.5em 0}.retail-av-timepicker>div{display:inline-block;margin-left:.5em;min-width:1.5em}.retail-av-timepicker>.retail-av-minute-picker,.retail-av-timepicker>.retail-av-second-picker{margin-left:0}.retail-av-timepicker>.retail-av-separator{margin-left:0;min-width:.75em}.retail-av-timepicker>.retail-av-separator a{visibility:hidden}.retail-av-timepicker>div a{display:block;opacity:.7;filter:Alpha(Opacity=70)}.retail-av-timepicker>div a:hover{display:block;opacity:1;filter:Alpha(Opacity=100)}.retail-av-calendar-date-panel-width{width:290px;float:left}.retail-av-calendar-date-pannel-margin-right{margin-right:30px}thead tr th span{font-weight:500}button.retail-av-datepicker-trigger{display:none}input.retail-av-input-text.retail-av-inputtext{background:#f6f6f9;border-radius:4px;border:none;width:327px}#retail-av-library--content--calendar{width:100%!important}.retail-av-datepicker{position:relative!important;top:inherit!important;left:0!important}table.retail-av-datepicker-calendar{font-weight:400;font-size:14px;line-height:21px;text-align:center;color:#141417;font-family:Helvetica}.retail-av-datepicker-calendar thead[role=rowgroup]{opacity:.6;mix-blend-mode:normal}.retail-av-slot-time-area{display:flex;flex-wrap:wrap;width:312px;height:auto}.retail-av-slot-time{width:50%;height:auto;flex:0 1 50%;margin:0 0 18px}.retail-av-time-span{background:#805ff6;border:1px solid #805ff6;border-radius:20px;padding:10px 14px;font-family:XFINITYStandard;font-weight:400;font-size:16px;line-height:19px;color:#fff;cursor:pointer;width:105px;height:40px;display:inline-block;box-sizing:border-box}.retail-av-slot-selected .retail-av-time-span{background:#000;border:1px solid #000}.retail-show-more-timeslots{font-family:Xfinity Brown;font-style:normal;font-weight:400;font-size:16px;line-height:19px;color:#805ff6;cursor:pointer}.retail-av-timeslot-container{padding-top:37px}.retail-av-calendar-date-panel-width.retail-av-datepicker-calendar-margin{border:1px solid #c7cdd2;background:#fff;box-shadow:0 7px 5px 0 rgba(20,20,23,.15);width:327px;padding:10px;border-radius:8px;z-index:9999}.retail-av-time-section{display:flex;justify-content:center}.retail-av-time-slot-container{width:312px}.retail-av-datepicker-text{margin-bottom:8px;font-family:XFINITYStandard;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#141417;text-align:left;width:312px}.retail-av-timeslot-text{font-size:16px;line-height:16px;margin:0 0 16px}.retail-av-notimeslot-available{box-sizing:border-box;border:1.5px solid #d92324!important}.retail-av-time-error-message{font-family:Xfinity Brown;font-style:normal;font-weight:400;font-size:14px;line-height:17px;color:#d92324;float:right;padding-top:4px}.retail-av-datetime-container{width:auto;text-align:center}@media screen and (max-width:560px){.retail-av-datepicker-with-multiple-month{position:absolute;top:40px;left:inherit;transform:inherit;margin-left:0!important}input.retail-av-input-text.retail-av-inputtext{border-radius:3px;border:1px solid #b1b9bf}.retail-av-timeslot-container{padding-top:13px}}.retail-av-datepicker-title .retail-av-datepicker-month,.retail-av-datepicker-title .retail-av-datepicker-year{font-family:Xfinity Brown;font-style:normal;font-weight:700;font-size:16px;line-height:24px;text-align:center;color:#141417;padding-right:4px}.retail-av-datepicker th{color:#141417}.retail-av-datepicker td a.retail-av-state-highlight,.retail-av-datepicker td span.retail-av-state-highlight{background:#fff;border:1px solid #ceceda;border-radius:50%}.retail-av-datepicker td a,.retail-av-datepicker td span{color:#141417}.retail-av-datepicker td a.retail-av-state-active,.retail-av-datepicker td a:hover,.retail-av-datepicker td span.retail-av-state-active,.retail-av-datepicker td span:hover{background:#7155d3;border:1px solid #ceceda;box-sizing:border-box;color:#fff;border-radius:50%;box-shadow:0 4px 3px #ceceda}.retail-av-purple-arrow{padding-right:32px}.retail-av-input-text{cursor:pointer;color:#000;outline:none}.retail-av-calendar.retail-av-no-timeslot-icon{margin-bottom:0}.retail-av-datepicker-pannel{list-style-type:none;float:left;margin:0;padding:0}.retail-av-calendar-side-pannel{width:224px;margin-right:20px;border-right-width:1px;border-right-style:solid;float:left;height:290px}.retail-av-calendar-side-pannel button{margin:10px auto}.retail-av-calendar-side-pannel-container{padding-top:30px}.retail-av-disabled-class{pointer-events:none}.retail-av-purple-arrow-down{width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:8px solid #805ff6;display:inline-block;margin:0 10px}@media screen and (max-width:800px){.retail-av-calendar-side-pannel{width:100%;margin-right:0;border-bottom:1px solid;border-right:0;height:100px;margin-bottom:20px}.retail-av-calendar-side-pannel button{margin:2px;float:left;padding:0 14px}.retail-av-calendar-side-pannel-container{padding-top:4px}.retail-av-datepicker-container{width:auto!important}.retail-av-datepicker-calendar-margin{margin-right:0!important}}',
            ],
            encapsulation: 2,
            data: {
              animation: [
                ((t = [
                  xp("hidden", qp({ opacity: 0 })),
                  xp("visible", qp({ opacity: 1 })),
                  Bp("visible => hidden", Cp("400ms ease-in")),
                  Bp("hidden => visible", Cp("400ms ease-out")),
                ]),
                { type: 7, name: "overlayState", definitions: t, options: {} }),
              ],
            },
          })),
          e
        );
      })();
      function Jb(e, t) {
        if ((1 & e && (Xi(0, "div", 5), ya(1), Ri()), 2 & e)) {
          const e = t.index;
          Ws(1), Aa(" ", e + 1, " ");
        }
      }
      function Gb(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "span"),
            Xi(1, "button", 6),
            Ji("click", function () {
              return an(e), Ki().submitPreviousAction();
            }),
            ya(2, "Previous"),
            Ri(),
            Xi(3, "button", 6),
            Ji("click", function () {
              return an(e), Ki().submitNextAction();
            }),
            ya(4, "Next"),
            Ri(),
            Ri();
        }
      }
      let Qb = (() => {
          class e {
            constructor() {
              this.circleInnerText = 2;
            }
            ngOnInit() {
              this.createNumberOfCircles(parseInt(this.stepNumber));
            }
            submitNextAction() {
              (this.stepNumber = parseInt(this.stepNumber)),
                (this.updateStepNumber = parseInt(this.updateStepNumber)),
                this.updateStepNumber >= 1 && this.updateStepNumber < this.stepNumber
                  ? ((this.updateStepNumber += 1), this.update(this.updateStepNumber))
                  : console.warn("Maximum Steps Reached");
            }
            submitPreviousAction() {
              (this.stepNumber = parseInt(this.stepNumber)),
                (this.updateStepNumber = parseInt(this.updateStepNumber)),
                this.updateStepNumber > 1
                  ? ((this.updateStepNumber -= 1), this.update(this.updateStepNumber))
                  : console.warn("You are at first step already");
            }
            createNumberOfCircles(e) {
              (this.stepArray = new Array(e)),
                setTimeout(() => {
                  this.update(parseInt(this.updateStepNumber));
                });
            }
            update(e) {
              (this.progress = document.getElementById("progress")),
                (this.stepCircles = document.querySelectorAll(".circle")),
                this.stepCircles.forEach((t, n) => {
                  n < e ? t.classList.add("active") : t.classList.remove("active");
                });
              const t = document.querySelectorAll(".active");
              this.progress &&
                (this.progress.style.width = ((t.length - 1) / (this.stepCircles.length - 1)) * 100 + "%");
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵcmp = dt({
              type: e,
              selectors: [["step-progress-indicator-component"]],
              inputs: { stepNumber: "stepNumber", updateStepNumber: "updateStepNumber", isLocal: "isLocal" },
              decls: 5,
              vars: 2,
              consts: [
                [1, "container"],
                ["id", "progress-container", 1, "progress-container"],
                ["id", "progress", 1, "progress"],
                ["class", "circle", 4, "ngFor", "ngForOf"],
                [4, "ngIf"],
                [1, "circle"],
                [1, "btn", 3, "click"],
              ],
              template: function (e, t) {
                1 & e &&
                  (Xi(0, "div", 0),
                  Xi(1, "div", 1),
                  Ii(2, "div", 2),
                  xi(3, Jb, 2, 1, "div", 3),
                  Ri(),
                  Ri(),
                  xi(4, Gb, 5, 0, "span", 4)),
                  2 & e && (Ws(3), ji("ngForOf", t.stepArray), Ws(1), ji("ngIf", "true" === t.isLocal));
              },
              directives: [Il, Vl],
              styles: [
                '*[_ngcontent-%COMP%]{padding:0;margin:0;border:0;box-sizing:inherit}html[_ngcontent-%COMP%]{box-sizing:border-box}body[_ngcontent-%COMP%]{margin:0}.container[_ngcontent-%COMP%], body[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;overflow:hidden}.container[_ngcontent-%COMP%]{text-align:center;margin:5% auto}.progress-container[_ngcontent-%COMP%]:before{content:"";background-color:#b1b1bd;position:absolute;top:50%;left:0;transform:translateY(-50%);height:1px;width:100%;z-index:1}.progress-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between;position:relative;max-width:100%;width:241px}.progress[_ngcontent-%COMP%]{background:#805ff6;position:absolute;top:50%;left:0;transform:translateY(-50%);height:1px;width:0;z-index:1}.circle[_ngcontent-%COMP%], .progress[_ngcontent-%COMP%]{transition:.4s ease}.circle[_ngcontent-%COMP%]{background:#b1b1bd;color:#000;border-radius:50%;height:35px;width:35px;display:flex;align-items:center;justify-content:center;z-index:9999;border:1px solid #b1b1bd;font-size:20px;font-weight:400;line-height:24px}.circle.active[_ngcontent-%COMP%]{border-color:#805ff6;background-color:#805ff6;color:#fff}.btn[_ngcontent-%COMP%]{background-color:#000;color:#fff;cursor:pointer;font-family:inherit;border:0;border-radius:6px;padding:8px 30px;margin:5px;font-size:14px;width:100px}',
              ],
            })),
            e
          );
        })(),
        Kb = (() => {
          class e {
            constructor(e) {
              (this._elementRef = e), (this.clickOutsideEvent = new Co());
            }
            onClick(e, t) {
              t && (this._elementRef.nativeElement.contains(t) || this.clickOutsideEvent.emit(e));
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Xa));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [["", "singleSelectClickOutside", ""]],
              hostBindings: function (e, t) {
                1 & e &&
                  Ji(
                    "click",
                    function (e) {
                      return t.onClick(e, e.target);
                    },
                    !1,
                    Yt
                  );
              },
              outputs: { clickOutsideEvent: "clickOutsideEvent" },
            })),
            e
          );
        })();
      const $b = ["optionList"];
      function Zb(e, t) {
        if ((1 & e && (Xi(0, "div", 9), ya(1), Ri()), 2 & e)) {
          const e = Ki(2);
          Ws(1), La(e.defaultSelection);
        }
      }
      function eg(e, t) {
        if ((1 & e && (Xi(0, "div", 10), ya(1), Ri()), 2 & e)) {
          const e = Ki(2);
          Ws(1), La(e.reasonName);
        }
      }
      const tg = function (e) {
        return { selected: e };
      };
      function ng(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "label", 11),
            Xi(1, "input", 12),
            Ji("ngModelChange", function (n) {
              return an(e), (t.$implicit.checked = n);
            })("change", function () {
              an(e);
              const n = t.$implicit;
              return Ki(2).getSelectedValue(
                null == n ? null : n.checked,
                null == n ? null : n.name,
                null == n ? null : n.id
              );
            }),
            Ri(),
            Xi(2, "span"),
            ya(3),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = t.$implicit,
            n = Ki(2);
          ji(
            "ngClass",
            vo(5, tg, n.useSelectedClass(e.id, null == n.currentSelected ? null : n.currentSelected.eleId))
          ),
            Ws(1),
            ea("id", e.id),
            ji("ngModel", e.checked),
            Ci("name", e.name),
            Ws(2),
            La(e.name);
        }
      }
      function sg(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div"),
            Xi(1, "button", 2),
            Ji("click", function () {
              return an(e), Ki().toggleDropdown();
            }),
            xi(2, Zb, 2, 1, "div", 3),
            xi(3, eg, 2, 1, "div", 4),
            Xi(4, "div", 5),
            ya(5, " arrow icon "),
            Ri(),
            Ri(),
            Xi(6, "div", 6, 7),
            xi(8, ng, 4, 7, "label", 8),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = Ki();
          Ws(2), ji("ngIf", !e.reasonName), Ws(1), ji("ngIf", e.reasonName), Ws(5), ji("ngForOf", e.list);
        }
      }
      let rg = (() => {
          class e {
            constructor() {
              (this.list = []),
                (this.answerKey = []),
                (this.answerValue = []),
                (this.showDropDown = !1),
                (this.checkedList = []),
                (this.checkedIdList = []),
                (this.strToVal = []),
                (this.selectedServicesVal = ""),
                (this.subAnswerSelectedValue = new Co());
            }
            ngOnInit() {
              ("undefined" !== this.dataAnswerInput && this.dataAnswerInput) || (this.dataAnswerInput = null),
                ("undefined" !== this.value && this.value) || (this.value = null),
                (this.dataAnswerInput = this.dataAnswerInput
                  ? this.dataAnswerInput.replace(/'/g, '"')
                  : this.dataAnswerInput),
                (this.answerInputStrIntoObj = this.dataAnswerInput ? JSON.parse(this.dataAnswerInput) : []),
                (this.answerKey = Object.keys(this.answerInputStrIntoObj)),
                (this.answerValue = Object.values(this.answerInputStrIntoObj)),
                this.answerKey.filter((e, t) => {
                  this.value === e
                    ? this.currentSelected
                      ? this.list.push({ id: e, name: this.answerValue[t], checked: !1 })
                      : ((this.reasonName = this.answerValue[t]),
                        (this.currentSelected = { checked: !0, name: this.answerValue[t], eleId: e }),
                        this.list.push({ id: e, name: this.answerValue[t], checked: !0 }))
                    : this.list.push({ id: e, name: this.answerValue[t], checked: !1 });
                });
            }
            toggleDropdown() {
              (this.optionList.nativeElement.style.display = this.showDropDown ? "none" : "block"),
                (this.showDropDown = !this.showDropDown);
            }
            closeDropdown(e) {
              this.showDropDown && this.toggleDropdown();
            }
            getSelectedValue(e, t, n) {
              (this.currentSelected && t == this.currentSelected.name) ||
                ((this.reasonName = t),
                (this.value = n),
                this.subAnswerSelectedValue.emit(this.value),
                (this.currentSelected = { checked: e, name: t, eleId: n })),
                this.closeDropdown(null);
            }
            useSelectedClass(e, t) {
              return e == t;
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵcmp = dt({
              type: e,
              selectors: [["single-select-dropdown-component"]],
              viewQuery: function (e, t) {
                var n, s;
                1 & e && ((s = $b), !0, Uo(rn(), sn(), s, true, undefined, !1)),
                  2 & e && Fo((n = Jo())) && (t.optionList = n.first);
              },
              inputs: {
                value: "value",
                selectedServicesVal: "selectedServicesVal",
                dataAnswerInput: "dataAnswerInput",
                defaultSelection: ["defaultText", "defaultSelection"],
              },
              outputs: { subAnswerSelectedValue: "subAnswerSelectedValue" },
              decls: 2,
              vars: 1,
              consts: [
                ["singleSelectClickOutside", "", 1, "singleselect-custom-container", 3, "clickOutsideEvent"],
                [4, "ngIf"],
                ["id", "selected-text", 1, "drop-toggle", "btn", "flat", 3, "click"],
                ["class", "selected-text selected-text-default", 4, "ngIf"],
                ["class", "selected-text", "id", "selectedReason", 4, "ngIf"],
                [1, "dropdown-arrow-down"],
                ["id", "optionList", 1, "drop-show"],
                ["optionList", ""],
                [3, "ngClass", 4, "ngFor", "ngForOf"],
                [1, "selected-text", "selected-text-default"],
                ["id", "selectedReason", 1, "selected-text"],
                [3, "ngClass"],
                ["type", "checkbox", 1, "drop-down-item", 3, "id", "ngModel", "ngModelChange", "change"],
              ],
              template: function (e, t) {
                1 & e &&
                  (Xi(0, "div", 0),
                  Ji("clickOutsideEvent", function (e) {
                    return t.closeDropdown(e);
                  }),
                  xi(1, sg, 9, 3, "div", 1),
                  Ri()),
                  2 & e && (Ws(1), ji("ngIf", (null == t.list ? null : t.list.length) > 0));
              },
              directives: [Kb, Vl, Il, Xl, tf, df, $f],
              styles: [
                ".drop-toggle[_ngcontent-%COMP%]{background-color:#fff;padding:10px 15px;border-radius:4px;cursor:pointer;cursor:hand;border:1px solid #ccc;width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:flex}.selected-text[_ngcontent-%COMP%], .singleselect-custom-container[_ngcontent-%COMP%]{font-family:XFINITYBrown}.selected-text[_ngcontent-%COMP%]{font-size:16px;width:95%!important;text-overflow:ellipsis!important;overflow:hidden;color:#000!important}.drop-toggle[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right}.drop-show[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #bababa;position:absolute;z-index:99999;box-shadow:0 6px 10px rgba(0,0,0,.15);width:90.5%;display:none}.drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:block;font-size:16px;cursor:pointer;margin:0;padding-left:10px;text-align:left}.drop-show[_ngcontent-%COMP%]   label.selected[_ngcontent-%COMP%], .drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:hover{color:#fff;background-color:#805ff6}.drop-show[_ngcontent-%COMP%]:hover   label.selected[_ngcontent-%COMP%]{color:#000;background-color:#fff}.drop-show[_ngcontent-%COMP%]:hover   label.selected[_ngcontent-%COMP%]:hover{color:#fff;background-color:#805ff6}.drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:top;margin-right:10px;width:22px;height:22px;display:none}.drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;line-height:22px;vertical-align:sub}.dropdown-arrow-down[_ngcontent-%COMP%]{right:10%;background:url(Triangle.png) no-repeat 50%;background-size:13px 8px;color:transparent;width:13px}.text-wrapper[_ngcontent-%COMP%]{width:90%}.selected-text-default[_ngcontent-%COMP%]{font-size:16pt;font-style:italic;color:#8b978e!important}.drop-down-item[_ngcontent-%COMP%], .selected-text-default[_ngcontent-%COMP%]{font-family:XFINITYBrown}",
              ],
            })),
            e
          );
        })(),
        ig = (() => {
          class e {
            constructor(e) {
              (this._elementRef = e), (this.clickOutsideEvent = new Co());
            }
            onClick(e, t) {
              if ((console.warn("$event.target", t.className), !t)) return;
              const n = this._elementRef.nativeElement.contains(t),
                s = t.closest(".multiselect-custom-container");
              console.warn("$event.target.parentDiv", s), n || s || this.clickOutsideEvent.emit(e);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)(Hi(Xa));
            }),
            (e.ɵdir = _t({
              type: e,
              selectors: [["", "clickOutside", ""]],
              hostBindings: function (e, t) {
                1 & e &&
                  Ji(
                    "click",
                    function (e) {
                      return t.onClick(e, e.target);
                    },
                    !1,
                    Yt
                  );
              },
              outputs: { clickOutsideEvent: "clickOutsideEvent" },
            })),
            e
          );
        })();
      function ag(e, t) {
        if ((1 & e && (Xi(0, "div", 8), ya(1), Ri()), 2 & e)) {
          const e = Ki(2);
          Ws(1), La(e.defaultSelection);
        }
      }
      function og(e, t) {
        if ((1 & e && (Xi(0, "div", 9), ya(1), Ri()), 2 & e)) {
          const e = Ki(2);
          Ws(1), La(e.checkedList.join(", "));
        }
      }
      function cg(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "label"),
            Xi(1, "input", 10),
            Ji("ngModelChange", function (n) {
              return an(e), (t.$implicit.checked = n);
            })("change", function () {
              an(e);
              const n = t.$implicit;
              return Ki(2).getSelectedValue(
                null == n ? null : n.checked,
                null == n ? null : n.name,
                null == n ? null : n.id
              );
            }),
            Ri(),
            Ii(2, "span", 11),
            Xi(3, "span"),
            ya(4),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = t.$implicit;
          Ws(1), ea("id", e.id), ji("ngModel", e.checked), Ci("name", e.name), Ws(3), La(e.name);
        }
      }
      function lg(e, t) {
        if (1 & e) {
          const e = Fi();
          Xi(0, "div"),
            Xi(1, "button", 2),
            Ji("click", function () {
              return an(e), Ki().toggleDropdown();
            }),
            xi(2, ag, 2, 1, "div", 3),
            xi(3, og, 2, 1, "div", 4),
            Xi(4, "div", 5),
            ya(5, " arrow icon "),
            Ri(),
            Ri(),
            Xi(6, "div", 6),
            xi(7, cg, 5, 4, "label", 7),
            Ri(),
            Ri();
        }
        if (2 & e) {
          const e = Ki();
          Ws(2),
            ji("ngIf", 0 === (null == e.checkedList ? null : e.checkedList.length)),
            Ws(1),
            ji("ngIf", (null == e.checkedList ? null : e.checkedList.length) > 0),
            Ws(4),
            ji("ngForOf", e.list);
        }
      }
      let dg = (() => {
          class e {
            constructor() {
              (this.list = []),
                (this.answerKey = []),
                (this.answerValue = []),
                (this.showDropDown = !1),
                (this.checkedList = []),
                (this.checkedIdList = []),
                (this.strToVal = []),
                (this.selectedServicesVal = ""),
                (this.subAnswerSelectedValue = new Co());
            }
            ngOnInit() {
              (this.checkedList = []),
                ("undefined" !== this.dataAnswerInput && this.dataAnswerInput) || (this.dataAnswerInput = null),
                "undefined" !== this.value && this.value
                  ? (this.strToVal = this.value.split(","))
                  : (this.value = null),
                (this.dataAnswerInput = this.dataAnswerInput
                  ? this.dataAnswerInput.replace(/'/g, '"')
                  : this.dataAnswerInput),
                (this.answerInputStrIntoObj = this.dataAnswerInput ? JSON.parse(this.dataAnswerInput) : []),
                (this.answerKey = Object.keys(this.answerInputStrIntoObj)),
                (this.answerValue = Object.values(this.answerInputStrIntoObj)),
                this.answerKey.filter((e, t) => {
                  this.strToVal && -1 !== this.strToVal.indexOf(e)
                    ? (this.list.push({ id: e, name: this.answerValue[t], checked: !0 }),
                      this.checkedList.push(this.answerValue[t]))
                    : this.list.push({ id: e, name: this.answerValue[t], checked: !1 });
                }),
                this.checkedList && this.checkedList.length > 0 && this.getRightPanelData();
            }
            toggleDropdown() {
              (document.getElementById("showServiceList").style.display = this.showDropDown ? "none" : "block"),
                (this.showDropDown = !this.showDropDown);
            }
            closeDropdown(e) {
              this.showDropDown && document.getElementById("choose-your-services-multiselect-btn").click();
            }
            getRightPanelData() {
              const e = localStorage.getItem("userSelected");
              e && "customer" === e && this.doNexusCheck(), e && "guest" === e && this.doNexusCheckGuest();
            }
            getSelectedValue(e, t, n) {
              if (
                ((this.checkedList = []),
                (this.checkedIdList = []),
                this.list.filter((e) => {
                  e.checked && (this.checkedList.push(e.name), this.checkedIdList.push(e.id));
                }),
                this.checkedIdList.length > 0)
              ) {
                const e = this.checkedIdList.join(",");
                (this.value = e), this.subAnswerSelectedValue.emit(this.value);
              } else (this.value = null), this.subAnswerSelectedValue.emit(null);
              this.currentSelected = { checked: e, name: t };
            }
            doNexusCheck() {
              let e;
              if (this.checkedList && this.checkedList.length > 0) {
                let t, n;
                const s = document.querySelector("#finalReason"),
                  r = Array.from(document.querySelectorAll(".retail-av-option-item")),
                  i = Array.from(document.querySelectorAll(".retail-av-other-option-item"));
                r &&
                  r.length > 0 &&
                  r.filter((e) => {
                    e.getAttribute("selectedreasonvalue") && (t = e.getAttribute("selectedreasonvalue"));
                  }),
                  i &&
                    i.length > 0 &&
                    i.filter((e) => {
                      e.getAttribute("selectedotherreasonvalue") && (n = e.getAttribute("selectedotherreasonvalue"));
                    }),
                  (e = n
                    ? `Existing Customer - ${n} - ${this.checkedList.join(", ")}`
                    : t
                    ? `Existing Customer - ${t} - ${this.checkedList.join(", ")}`
                    : "");
                const a = document.querySelectorAll("[data-binding='customerbinding']");
                a && a.length > 0 && a[0] && a[1] && ((a[0].textContent = e), (a[1].textContent = e)),
                  s.setAttribute("value", e);
              } else e = "";
            }
            doNexusCheckGuest() {
              const e = document.querySelector("#finalReason");
              let t;
              t =
                this.checkedList && this.checkedList.length > 0 ? "New Customer - " + this.checkedList.join(", ") : "";
              const n = document.querySelectorAll("[data-binding='guestBinding']");
              n && n.length > 0 && n[0] && n[1] && ((n[0].textContent = t), (n[1].textContent = t)),
                e.setAttribute("value", t);
            }
          }
          return (
            (e.ɵfac = function (t) {
              return new (t || e)();
            }),
            (e.ɵcmp = dt({
              type: e,
              selectors: [["multi-select-dropdown-component"]],
              inputs: {
                value: "value",
                selectedServicesVal: "selectedServicesVal",
                dataAnswerInput: "dataAnswerInput",
                defaultSelection: ["defaultText", "defaultSelection"],
              },
              outputs: { subAnswerSelectedValue: "subAnswerSelectedValue" },
              decls: 2,
              vars: 1,
              consts: [
                ["clickOutside", "", 1, "multiselect-custom-container", 3, "clickOutsideEvent"],
                [4, "ngIf"],
                ["id", "choose-your-services-multiselect-btn", 1, "drop-toggle", "btn", "flat", 3, "click"],
                ["class", "selected-text selected-text-default", 4, "ngIf"],
                ["class", "selected-text", "id", "selectedServicesList", 4, "ngIf"],
                [1, "dropdown-arrow-down"],
                ["id", "showServiceList", 1, "drop-show"],
                [4, "ngFor", "ngForOf"],
                [1, "selected-text", "selected-text-default"],
                ["id", "selectedServicesList", 1, "selected-text"],
                ["type", "checkbox", 1, "drop-down-item", 3, "id", "ngModel", "ngModelChange", "change"],
                [1, "retail-av-mulitiselect-checkbox-span"],
              ],
              template: function (e, t) {
                1 & e &&
                  (Xi(0, "div", 0),
                  Ji("clickOutsideEvent", function (e) {
                    return t.closeDropdown(e);
                  }),
                  xi(1, lg, 8, 3, "div", 1),
                  Ri()),
                  2 & e && (Ws(1), ji("ngIf", (null == t.list ? null : t.list.length) > 0));
              },
              directives: [ig, Vl, Il, tf, df, $f],
              styles: [
                ".drop-toggle[_ngcontent-%COMP%]{background-color:#fff;padding:10px 15px;border-radius:4px;cursor:pointer;cursor:hand;border:1px solid #ccc;width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:flex}.multiselect-custom-container[_ngcontent-%COMP%], .selected-text[_ngcontent-%COMP%]{font-family:XFINITYBrown}.selected-text[_ngcontent-%COMP%]{font-size:16px;width:95%!important;text-overflow:ellipsis!important;overflow:hidden;color:#000!important}.drop-toggle[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right}.drop-show[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #bababa;position:absolute;z-index:99999;box-shadow:0 6px 10px rgba(0,0,0,.15);width:90.5%;display:none}.drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:block;font-size:16px;cursor:pointer;margin:10px;text-align:left;position:relative}.drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:middle;margin-right:10px;width:22px;height:22px}.drop-show[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;line-height:22px}.dropdown-arrow-down[_ngcontent-%COMP%]{right:10%;background:url(Triangle.png) no-repeat 50%;background-size:13px 8px;color:transparent;width:13px}.text-wrapper[_ngcontent-%COMP%]{width:90%}.selected-text-default[_ngcontent-%COMP%]{font-size:16pt;font-style:italic;color:#8b978e!important}.drop-down-item[_ngcontent-%COMP%], .selected-text-default[_ngcontent-%COMP%]{font-family:XFINITYBrown}",
              ],
            })),
            e
          );
        })(),
        ug = (() => {
          class e {
            constructor(e) {
              this.injector = e;
              const t = vp(Ub, { injector: this.injector });
              customElements.get("calendar-web-component") || customElements.define("calendar-web-component", t);
              const n = vp(Qb, { injector: this.injector });
              customElements.get("step-progress-indicator-web-component") ||
                customElements.define("step-progress-indicator-web-component", n);
              const s = vp(rg, { injector: this.injector });
              customElements.get("single-select-dropdown-web-component") ||
                customElements.define("single-select-dropdown-web-component", s);
              const r = vp(dg, { injector: this.injector });
              customElements.get("multi-select-dropdown-web-component") ||
                customElements.define("multi-select-dropdown-web-component", r);
            }
            ngDoBootstrap() {}
          }
          return (
            (e.ɵmod = pt({ type: e })),
            (e.ɵinj = le({
              factory: function (t) {
                return new (t || e)(Ve(fi));
              },
              providers: [Np],
              imports: [[kd, op, K_, eb]],
            })),
            e
          );
        })();
      (function () {
        if (_s) throw new Error("Cannot enable prod mode after platform setup.");
        ms = !1;
      })(),
        Od()
          .bootstrapModule(ug)
          .catch((e) => console.error(e));
    },
    "zX+o": function (e, t, n) {
      !(function (e) {
        "use strict";
        e.defineLocale("oc-lnc", {
          months: {
            standalone:
              "geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split(
                "_"
              ),
            format:
              "de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split(
                "_"
              ),
            isFormat: /D[oD]?(\s)+MMMM/,
          },
          monthsShort: "gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),
          monthsParseExact: !0,
          weekdays: "dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split("_"),
          weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
          weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
          weekdaysParseExact: !0,
          longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [de] YYYY",
            ll: "D MMM YYYY",
            LLL: "D MMMM [de] YYYY [a] H:mm",
            lll: "D MMM YYYY, H:mm",
            LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
            llll: "ddd D MMM YYYY, H:mm",
          },
          calendar: {
            sameDay: "[u\xe8i a] LT",
            nextDay: "[deman a] LT",
            nextWeek: "dddd [a] LT",
            lastDay: "[i\xe8r a] LT",
            lastWeek: "dddd [passat a] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "d'aqu\xed %s",
            past: "fa %s",
            s: "unas segondas",
            ss: "%d segondas",
            m: "una minuta",
            mm: "%d minutas",
            h: "una ora",
            hh: "%d oras",
            d: "un jorn",
            dd: "%d jorns",
            M: "un mes",
            MM: "%d meses",
            y: "un an",
            yy: "%d ans",
          },
          dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|\xe8|a)/,
          ordinal: function (e, t) {
            var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "\xe8";
            return ("w" !== t && "W" !== t) || (n = "a"), e + n;
          },
          week: { dow: 1, doy: 4 },
        });
      })(n("wgY5"));
    },
    zn8P: function (e, t) {
      function n(e) {
        return Promise.resolve().then(function () {
          var t = new Error("Cannot find module '" + e + "'");
          throw ((t.code = "MODULE_NOT_FOUND"), t);
        });
      }
      (n.keys = function () {
        return [];
      }),
        (n.resolve = n),
        (e.exports = n),
        (n.id = "zn8P");
    },
  },
  [[0, 0]],
]);
(window.webpackJsonp = window.webpackJsonp || []).push([
  [2],
  {
    2: function (e, t, n) {
      e.exports = n("hN/g");
    },
    "hN/g": function (e, t, n) {
      "use strict";
      n.r(t), n("nf2o");
    },
    nf2o: function (e, t, n) {
      var o, r;
      void 0 ===
        (r =
          "function" ==
          typeof (o = function () {
            "use strict";
            !(function (e) {
              const t = e.performance;
              function n(e) {
                t && t.mark && t.mark(e);
              }
              function o(e, n) {
                t && t.measure && t.measure(e, n);
              }
              n("Zone");
              const r = e.__Zone_symbol_prefix || "__zone_symbol__";
              function s(e) {
                return r + e;
              }
              const a = !0 === e[s("forceDuplicateZoneCheck")];
              if (e.Zone) {
                if (a || "function" != typeof e.Zone.__symbol__) throw new Error("Zone already loaded.");
                return e.Zone;
              }
              class i {
                constructor(e, t) {
                  (this._parent = e),
                    (this._name = t ? t.name || "unnamed" : "<root>"),
                    (this._properties = (t && t.properties) || {}),
                    (this._zoneDelegate = new l(this, this._parent && this._parent._zoneDelegate, t));
                }
                static assertZonePatched() {
                  if (e.Promise !== C.ZoneAwarePromise)
                    throw new Error(
                      "Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)"
                    );
                }
                static get root() {
                  let e = i.current;
                  for (; e.parent; ) e = e.parent;
                  return e;
                }
                static get current() {
                  return z.zone;
                }
                static get currentTask() {
                  return j;
                }
                static __load_patch(t, r) {
                  if (C.hasOwnProperty(t)) {
                    if (a) throw Error("Already loaded patch: " + t);
                  } else if (!e["__Zone_disable_" + t]) {
                    const s = "Zone:" + t;
                    n(s), (C[t] = r(e, i, O)), o(s, s);
                  }
                }
                get parent() {
                  return this._parent;
                }
                get name() {
                  return this._name;
                }
                get(e) {
                  const t = this.getZoneWith(e);
                  if (t) return t._properties[e];
                }
                getZoneWith(e) {
                  let t = this;
                  for (; t; ) {
                    if (t._properties.hasOwnProperty(e)) return t;
                    t = t._parent;
                  }
                  return null;
                }
                fork(e) {
                  if (!e) throw new Error("ZoneSpec required!");
                  return this._zoneDelegate.fork(this, e);
                }
                wrap(e, t) {
                  if ("function" != typeof e) throw new Error("Expecting function got: " + e);
                  const n = this._zoneDelegate.intercept(this, e, t),
                    o = this;
                  return function () {
                    return o.runGuarded(n, this, arguments, t);
                  };
                }
                run(e, t, n, o) {
                  z = { parent: z, zone: this };
                  try {
                    return this._zoneDelegate.invoke(this, e, t, n, o);
                  } finally {
                    z = z.parent;
                  }
                }
                runGuarded(e, t = null, n, o) {
                  z = { parent: z, zone: this };
                  try {
                    try {
                      return this._zoneDelegate.invoke(this, e, t, n, o);
                    } catch (r) {
                      if (this._zoneDelegate.handleError(this, r)) throw r;
                    }
                  } finally {
                    z = z.parent;
                  }
                }
                runTask(e, t, n) {
                  if (e.zone != this)
                    throw new Error(
                      "A task can only be run in the zone of creation! (Creation: " +
                        (e.zone || y).name +
                        "; Execution: " +
                        this.name +
                        ")"
                    );
                  if (e.state === v && (e.type === P || e.type === D)) return;
                  const o = e.state != E;
                  o && e._transitionTo(E, T), e.runCount++;
                  const r = j;
                  (j = e), (z = { parent: z, zone: this });
                  try {
                    e.type == D && e.data && !e.data.isPeriodic && (e.cancelFn = void 0);
                    try {
                      return this._zoneDelegate.invokeTask(this, e, t, n);
                    } catch (s) {
                      if (this._zoneDelegate.handleError(this, s)) throw s;
                    }
                  } finally {
                    e.state !== v &&
                      e.state !== Z &&
                      (e.type == P || (e.data && e.data.isPeriodic)
                        ? o && e._transitionTo(T, E)
                        : ((e.runCount = 0), this._updateTaskCount(e, -1), o && e._transitionTo(v, E, v))),
                      (z = z.parent),
                      (j = r);
                  }
                }
                scheduleTask(e) {
                  if (e.zone && e.zone !== this) {
                    let t = this;
                    for (; t; ) {
                      if (t === e.zone)
                        throw Error(
                          `can not reschedule task to ${this.name} which is descendants of the original zone ${e.zone.name}`
                        );
                      t = t.parent;
                    }
                  }
                  e._transitionTo(b, v);
                  const t = [];
                  (e._zoneDelegates = t), (e._zone = this);
                  try {
                    e = this._zoneDelegate.scheduleTask(this, e);
                  } catch (n) {
                    throw (e._transitionTo(Z, b, v), this._zoneDelegate.handleError(this, n), n);
                  }
                  return (
                    e._zoneDelegates === t && this._updateTaskCount(e, 1), e.state == b && e._transitionTo(T, b), e
                  );
                }
                scheduleMicroTask(e, t, n, o) {
                  return this.scheduleTask(new u(S, e, t, n, o, void 0));
                }
                scheduleMacroTask(e, t, n, o, r) {
                  return this.scheduleTask(new u(D, e, t, n, o, r));
                }
                scheduleEventTask(e, t, n, o, r) {
                  return this.scheduleTask(new u(P, e, t, n, o, r));
                }
                cancelTask(e) {
                  if (e.zone != this)
                    throw new Error(
                      "A task can only be cancelled in the zone of creation! (Creation: " +
                        (e.zone || y).name +
                        "; Execution: " +
                        this.name +
                        ")"
                    );
                  e._transitionTo(w, T, E);
                  try {
                    this._zoneDelegate.cancelTask(this, e);
                  } catch (t) {
                    throw (e._transitionTo(Z, w), this._zoneDelegate.handleError(this, t), t);
                  }
                  return this._updateTaskCount(e, -1), e._transitionTo(v, w), (e.runCount = 0), e;
                }
                _updateTaskCount(e, t) {
                  const n = e._zoneDelegates;
                  -1 == t && (e._zoneDelegates = null);
                  for (let o = 0; o < n.length; o++) n[o]._updateTaskCount(e.type, t);
                }
              }
              i.__symbol__ = s;
              const c = {
                name: "",
                onHasTask: (e, t, n, o) => e.hasTask(n, o),
                onScheduleTask: (e, t, n, o) => e.scheduleTask(n, o),
                onInvokeTask: (e, t, n, o, r, s) => e.invokeTask(n, o, r, s),
                onCancelTask: (e, t, n, o) => e.cancelTask(n, o),
              };
              class l {
                constructor(e, t, n) {
                  (this._taskCounts = { microTask: 0, macroTask: 0, eventTask: 0 }),
                    (this.zone = e),
                    (this._parentDelegate = t),
                    (this._forkZS = n && (n && n.onFork ? n : t._forkZS)),
                    (this._forkDlgt = n && (n.onFork ? t : t._forkDlgt)),
                    (this._forkCurrZone = n && (n.onFork ? this.zone : t._forkCurrZone)),
                    (this._interceptZS = n && (n.onIntercept ? n : t._interceptZS)),
                    (this._interceptDlgt = n && (n.onIntercept ? t : t._interceptDlgt)),
                    (this._interceptCurrZone = n && (n.onIntercept ? this.zone : t._interceptCurrZone)),
                    (this._invokeZS = n && (n.onInvoke ? n : t._invokeZS)),
                    (this._invokeDlgt = n && (n.onInvoke ? t : t._invokeDlgt)),
                    (this._invokeCurrZone = n && (n.onInvoke ? this.zone : t._invokeCurrZone)),
                    (this._handleErrorZS = n && (n.onHandleError ? n : t._handleErrorZS)),
                    (this._handleErrorDlgt = n && (n.onHandleError ? t : t._handleErrorDlgt)),
                    (this._handleErrorCurrZone = n && (n.onHandleError ? this.zone : t._handleErrorCurrZone)),
                    (this._scheduleTaskZS = n && (n.onScheduleTask ? n : t._scheduleTaskZS)),
                    (this._scheduleTaskDlgt = n && (n.onScheduleTask ? t : t._scheduleTaskDlgt)),
                    (this._scheduleTaskCurrZone = n && (n.onScheduleTask ? this.zone : t._scheduleTaskCurrZone)),
                    (this._invokeTaskZS = n && (n.onInvokeTask ? n : t._invokeTaskZS)),
                    (this._invokeTaskDlgt = n && (n.onInvokeTask ? t : t._invokeTaskDlgt)),
                    (this._invokeTaskCurrZone = n && (n.onInvokeTask ? this.zone : t._invokeTaskCurrZone)),
                    (this._cancelTaskZS = n && (n.onCancelTask ? n : t._cancelTaskZS)),
                    (this._cancelTaskDlgt = n && (n.onCancelTask ? t : t._cancelTaskDlgt)),
                    (this._cancelTaskCurrZone = n && (n.onCancelTask ? this.zone : t._cancelTaskCurrZone)),
                    (this._hasTaskZS = null),
                    (this._hasTaskDlgt = null),
                    (this._hasTaskDlgtOwner = null),
                    (this._hasTaskCurrZone = null);
                  const o = n && n.onHasTask;
                  (o || (t && t._hasTaskZS)) &&
                    ((this._hasTaskZS = o ? n : c),
                    (this._hasTaskDlgt = t),
                    (this._hasTaskDlgtOwner = this),
                    (this._hasTaskCurrZone = e),
                    n.onScheduleTask ||
                      ((this._scheduleTaskZS = c),
                      (this._scheduleTaskDlgt = t),
                      (this._scheduleTaskCurrZone = this.zone)),
                    n.onInvokeTask ||
                      ((this._invokeTaskZS = c), (this._invokeTaskDlgt = t), (this._invokeTaskCurrZone = this.zone)),
                    n.onCancelTask ||
                      ((this._cancelTaskZS = c), (this._cancelTaskDlgt = t), (this._cancelTaskCurrZone = this.zone)));
                }
                fork(e, t) {
                  return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, e, t) : new i(e, t);
                }
                intercept(e, t, n) {
                  return this._interceptZS
                    ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, e, t, n)
                    : t;
                }
                invoke(e, t, n, o, r) {
                  return this._invokeZS
                    ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, e, t, n, o, r)
                    : t.apply(n, o);
                }
                handleError(e, t) {
                  return (
                    !this._handleErrorZS ||
                    this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, e, t)
                  );
                }
                scheduleTask(e, t) {
                  let n = t;
                  if (this._scheduleTaskZS)
                    this._hasTaskZS && n._zoneDelegates.push(this._hasTaskDlgtOwner),
                      (n = this._scheduleTaskZS.onScheduleTask(
                        this._scheduleTaskDlgt,
                        this._scheduleTaskCurrZone,
                        e,
                        t
                      )),
                      n || (n = t);
                  else if (t.scheduleFn) t.scheduleFn(t);
                  else {
                    if (t.type != S) throw new Error("Task is missing scheduleFn.");
                    k(t);
                  }
                  return n;
                }
                invokeTask(e, t, n, o) {
                  return this._invokeTaskZS
                    ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, e, t, n, o)
                    : t.callback.apply(n, o);
                }
                cancelTask(e, t) {
                  let n;
                  if (this._cancelTaskZS)
                    n = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, e, t);
                  else {
                    if (!t.cancelFn) throw Error("Task is not cancelable");
                    n = t.cancelFn(t);
                  }
                  return n;
                }
                hasTask(e, t) {
                  try {
                    this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, e, t);
                  } catch (n) {
                    this.handleError(e, n);
                  }
                }
                _updateTaskCount(e, t) {
                  const n = this._taskCounts,
                    o = n[e],
                    r = (n[e] = o + t);
                  if (r < 0) throw new Error("More tasks executed then were scheduled.");
                  (0 != o && 0 != r) ||
                    this.hasTask(this.zone, {
                      microTask: n.microTask > 0,
                      macroTask: n.macroTask > 0,
                      eventTask: n.eventTask > 0,
                      change: e,
                    });
                }
              }
              class u {
                constructor(t, n, o, r, s, a) {
                  if (
                    ((this._zone = null),
                    (this.runCount = 0),
                    (this._zoneDelegates = null),
                    (this._state = "notScheduled"),
                    (this.type = t),
                    (this.source = n),
                    (this.data = r),
                    (this.scheduleFn = s),
                    (this.cancelFn = a),
                    !o)
                  )
                    throw new Error("callback is not defined");
                  this.callback = o;
                  const i = this;
                  this.invoke =
                    t === P && r && r.useG
                      ? u.invokeTask
                      : function () {
                          return u.invokeTask.call(e, i, this, arguments);
                        };
                }
                static invokeTask(e, t, n) {
                  e || (e = this), I++;
                  try {
                    return e.runCount++, e.zone.runTask(e, t, n);
                  } finally {
                    1 == I && m(), I--;
                  }
                }
                get zone() {
                  return this._zone;
                }
                get state() {
                  return this._state;
                }
                cancelScheduleRequest() {
                  this._transitionTo(v, b);
                }
                _transitionTo(e, t, n) {
                  if (this._state !== t && this._state !== n)
                    throw new Error(
                      `${this.type} '${this.source}': can not transition to '${e}', expecting state '${t}'${
                        n ? " or '" + n + "'" : ""
                      }, was '${this._state}'.`
                    );
                  (this._state = e), e == v && (this._zoneDelegates = null);
                }
                toString() {
                  return this.data && void 0 !== this.data.handleId
                    ? this.data.handleId.toString()
                    : Object.prototype.toString.call(this);
                }
                toJSON() {
                  return {
                    type: this.type,
                    state: this.state,
                    source: this.source,
                    zone: this.zone.name,
                    runCount: this.runCount,
                  };
                }
              }
              const h = s("setTimeout"),
                p = s("Promise"),
                f = s("then");
              let d,
                g = [],
                _ = !1;
              function k(t) {
                if (0 === I && 0 === g.length)
                  if ((d || (e[p] && (d = e[p].resolve(0))), d)) {
                    let e = d[f];
                    e || (e = d.then), e.call(d, m);
                  } else e[h](m, 0);
                t && g.push(t);
              }
              function m() {
                if (!_) {
                  for (_ = !0; g.length; ) {
                    const t = g;
                    g = [];
                    for (let n = 0; n < t.length; n++) {
                      const o = t[n];
                      try {
                        o.zone.runTask(o, null, null);
                      } catch (e) {
                        O.onUnhandledError(e);
                      }
                    }
                  }
                  O.microtaskDrainDone(), (_ = !1);
                }
              }
              const y = { name: "NO ZONE" },
                v = "notScheduled",
                b = "scheduling",
                T = "scheduled",
                E = "running",
                w = "canceling",
                Z = "unknown",
                S = "microTask",
                D = "macroTask",
                P = "eventTask",
                C = {},
                O = {
                  symbol: s,
                  currentZoneFrame: () => z,
                  onUnhandledError: R,
                  microtaskDrainDone: R,
                  scheduleMicroTask: k,
                  showUncaughtError: () => !i[s("ignoreConsoleErrorUncaughtError")],
                  patchEventTarget: () => [],
                  patchOnProperties: R,
                  patchMethod: () => R,
                  bindArguments: () => [],
                  patchThen: () => R,
                  patchMacroTask: () => R,
                  setNativePromise: (e) => {
                    e && "function" == typeof e.resolve && (d = e.resolve(0));
                  },
                  patchEventPrototype: () => R,
                  isIEOrEdge: () => !1,
                  getGlobalObjects: () => {},
                  ObjectDefineProperty: () => R,
                  ObjectGetOwnPropertyDescriptor: () => {},
                  ObjectCreate: () => {},
                  ArraySlice: () => [],
                  patchClass: () => R,
                  wrapWithCurrentZone: () => R,
                  filterProperties: () => [],
                  attachOriginToPatched: () => R,
                  _redefineProperty: () => R,
                  patchCallbacks: () => R,
                };
              let z = { parent: null, zone: new i(null, null) },
                j = null,
                I = 0;
              function R() {}
              o("Zone", "Zone"), (e.Zone = i);
            })(("undefined" != typeof window && window) || ("undefined" != typeof self && self) || global),
              Zone.__load_patch("ZoneAwarePromise", (e, t, n) => {
                const o = Object.getOwnPropertyDescriptor,
                  r = Object.defineProperty,
                  s = n.symbol,
                  a = [],
                  i = !0 === e[s("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")],
                  c = s("Promise"),
                  l = s("then");
                (n.onUnhandledError = (e) => {
                  if (n.showUncaughtError()) {
                    const t = e && e.rejection;
                    t
                      ? console.error(
                          "Unhandled Promise rejection:",
                          t instanceof Error ? t.message : t,
                          "; Zone:",
                          e.zone.name,
                          "; Task:",
                          e.task && e.task.source,
                          "; Value:",
                          t,
                          t instanceof Error ? t.stack : void 0
                        )
                      : console.error(e);
                  }
                }),
                  (n.microtaskDrainDone = () => {
                    for (; a.length; ) {
                      const t = a.shift();
                      try {
                        t.zone.runGuarded(() => {
                          throw t;
                        });
                      } catch (e) {
                        h(e);
                      }
                    }
                  });
                const u = s("unhandledPromiseRejectionHandler");
                function h(e) {
                  n.onUnhandledError(e);
                  try {
                    const n = t[u];
                    "function" == typeof n && n.call(this, e);
                  } catch (o) {}
                }
                function p(e) {
                  return e && e.then;
                }
                function f(e) {
                  return e;
                }
                function d(e) {
                  return D.reject(e);
                }
                const g = s("state"),
                  _ = s("value"),
                  k = s("finally"),
                  m = s("parentPromiseValue"),
                  y = s("parentPromiseState");
                function v(e, t) {
                  return (n) => {
                    try {
                      T(e, t, n);
                    } catch (o) {
                      T(e, !1, o);
                    }
                  };
                }
                const b = s("currentTaskTrace");
                function T(e, o, s) {
                  const c = (function () {
                    let e = !1;
                    return function (t) {
                      return function () {
                        e || ((e = !0), t.apply(null, arguments));
                      };
                    };
                  })();
                  if (e === s) throw new TypeError("Promise resolved with itself");
                  if (null === e[g]) {
                    let h = null;
                    try {
                      ("object" != typeof s && "function" != typeof s) || (h = s && s.then);
                    } catch (u) {
                      return (
                        c(() => {
                          T(e, !1, u);
                        })(),
                        e
                      );
                    }
                    if (!1 !== o && s instanceof D && s.hasOwnProperty(g) && s.hasOwnProperty(_) && null !== s[g])
                      w(s), T(e, s[g], s[_]);
                    else if (!1 !== o && "function" == typeof h)
                      try {
                        h.call(s, c(v(e, o)), c(v(e, !1)));
                      } catch (u) {
                        c(() => {
                          T(e, !1, u);
                        })();
                      }
                    else {
                      e[g] = o;
                      const c = e[_];
                      if (
                        ((e[_] = s),
                        e[k] === k && !0 === o && ((e[g] = e[y]), (e[_] = e[m])),
                        !1 === o && s instanceof Error)
                      ) {
                        const e = t.currentTask && t.currentTask.data && t.currentTask.data.__creationTrace__;
                        e && r(s, b, { configurable: !0, enumerable: !1, writable: !0, value: e });
                      }
                      for (let t = 0; t < c.length; ) Z(e, c[t++], c[t++], c[t++], c[t++]);
                      if (0 == c.length && 0 == o) {
                        e[g] = 0;
                        let o = s;
                        if (!i)
                          try {
                            throw new Error(
                              "Uncaught (in promise): " +
                                ((l = s) && l.toString === Object.prototype.toString
                                  ? ((l.constructor && l.constructor.name) || "") + ": " + JSON.stringify(l)
                                  : l
                                  ? l.toString()
                                  : Object.prototype.toString.call(l)) +
                                (s && s.stack ? "\n" + s.stack : "")
                            );
                          } catch (u) {
                            o = u;
                          }
                        (o.rejection = s),
                          (o.promise = e),
                          (o.zone = t.current),
                          (o.task = t.currentTask),
                          a.push(o),
                          n.scheduleMicroTask();
                      }
                    }
                  }
                  var l;
                  return e;
                }
                const E = s("rejectionHandledHandler");
                function w(e) {
                  if (0 === e[g]) {
                    try {
                      const n = t[E];
                      n && "function" == typeof n && n.call(this, { rejection: e[_], promise: e });
                    } catch (n) {}
                    e[g] = !1;
                    for (let t = 0; t < a.length; t++) e === a[t].promise && a.splice(t, 1);
                  }
                }
                function Z(e, t, n, o, r) {
                  w(e);
                  const s = e[g],
                    a = s ? ("function" == typeof o ? o : f) : "function" == typeof r ? r : d;
                  t.scheduleMicroTask(
                    "Promise.then",
                    () => {
                      try {
                        const o = e[_],
                          r = !!n && k === n[k];
                        r && ((n[m] = o), (n[y] = s));
                        const i = t.run(a, void 0, r && a !== d && a !== f ? [] : [o]);
                        T(n, !0, i);
                      } catch (o) {
                        T(n, !1, o);
                      }
                    },
                    n
                  );
                }
                const S = function () {};
                class D {
                  static toString() {
                    return "function ZoneAwarePromise() { [native code] }";
                  }
                  static resolve(e) {
                    return T(new this(null), !0, e);
                  }
                  static reject(e) {
                    return T(new this(null), !1, e);
                  }
                  static race(e) {
                    let t,
                      n,
                      o = new this((e, o) => {
                        (t = e), (n = o);
                      });
                    function r(e) {
                      t(e);
                    }
                    function s(e) {
                      n(e);
                    }
                    for (let a of e) p(a) || (a = this.resolve(a)), a.then(r, s);
                    return o;
                  }
                  static all(e) {
                    return D.allWithCallback(e);
                  }
                  static allSettled(e) {
                    return (this && this.prototype instanceof D ? this : D).allWithCallback(e, {
                      thenCallback: (e) => ({ status: "fulfilled", value: e }),
                      errorCallback: (e) => ({ status: "rejected", reason: e }),
                    });
                  }
                  static allWithCallback(e, t) {
                    let n,
                      o,
                      r = new this((e, t) => {
                        (n = e), (o = t);
                      }),
                      s = 2,
                      a = 0;
                    const i = [];
                    for (let l of e) {
                      p(l) || (l = this.resolve(l));
                      const e = a;
                      try {
                        l.then(
                          (o) => {
                            (i[e] = t ? t.thenCallback(o) : o), s--, 0 === s && n(i);
                          },
                          (r) => {
                            t ? ((i[e] = t.errorCallback(r)), s--, 0 === s && n(i)) : o(r);
                          }
                        );
                      } catch (c) {
                        o(c);
                      }
                      s++, a++;
                    }
                    return (s -= 2), 0 === s && n(i), r;
                  }
                  constructor(e) {
                    const t = this;
                    if (!(t instanceof D)) throw new Error("Must be an instanceof Promise.");
                    (t[g] = null), (t[_] = []);
                    try {
                      e && e(v(t, !0), v(t, !1));
                    } catch (n) {
                      T(t, !1, n);
                    }
                  }
                  get [Symbol.toStringTag]() {
                    return "Promise";
                  }
                  get [Symbol.species]() {
                    return D;
                  }
                  then(e, n) {
                    let o = this.constructor[Symbol.species];
                    (o && "function" == typeof o) || (o = this.constructor || D);
                    const r = new o(S),
                      s = t.current;
                    return null == this[g] ? this[_].push(s, r, e, n) : Z(this, s, r, e, n), r;
                  }
                  catch(e) {
                    return this.then(null, e);
                  }
                  finally(e) {
                    let n = this.constructor[Symbol.species];
                    (n && "function" == typeof n) || (n = D);
                    const o = new n(S);
                    o[k] = k;
                    const r = t.current;
                    return null == this[g] ? this[_].push(r, o, e, e) : Z(this, r, o, e, e), o;
                  }
                }
                (D.resolve = D.resolve), (D.reject = D.reject), (D.race = D.race), (D.all = D.all);
                const P = (e[c] = e.Promise),
                  C = t.__symbol__("ZoneAwarePromise");
                let O = o(e, "Promise");
                (O && !O.configurable) ||
                  (O && delete O.writable,
                  O && delete O.value,
                  O || (O = { configurable: !0, enumerable: !0 }),
                  (O.get = function () {
                    return e[C] ? e[C] : e[c];
                  }),
                  (O.set = function (t) {
                    t === D ? (e[C] = t) : ((e[c] = t), t.prototype[l] || j(t), n.setNativePromise(t));
                  }),
                  r(e, "Promise", O)),
                  (e.Promise = D);
                const z = s("thenPatched");
                function j(e) {
                  const t = e.prototype,
                    n = o(t, "then");
                  if (n && (!1 === n.writable || !n.configurable)) return;
                  const r = t.then;
                  (t[l] = r),
                    (e.prototype.then = function (e, t) {
                      return new D((e, t) => {
                        r.call(this, e, t);
                      }).then(e, t);
                    }),
                    (e[z] = !0);
                }
                if (((n.patchThen = j), P)) {
                  j(P);
                  const t = e.fetch;
                  "function" == typeof t &&
                    ((e[n.symbol("fetch")] = t),
                    (e.fetch =
                      ((I = t),
                      function () {
                        let e = I.apply(this, arguments);
                        if (e instanceof D) return e;
                        let t = e.constructor;
                        return t[z] || j(t), e;
                      })));
                }
                var I;
                return (Promise[t.__symbol__("uncaughtPromiseErrors")] = a), D;
              });
            const e = Object.getOwnPropertyDescriptor,
              t = Object.defineProperty,
              n = Object.getPrototypeOf,
              o = Object.create,
              r = Array.prototype.slice,
              s = Zone.__symbol__("addEventListener"),
              a = Zone.__symbol__("removeEventListener"),
              i = Zone.__symbol__("");
            function c(e, t) {
              return Zone.current.wrap(e, t);
            }
            function l(e, t, n, o, r) {
              return Zone.current.scheduleMacroTask(e, t, n, o, r);
            }
            const u = Zone.__symbol__,
              h = "undefined" != typeof window,
              p = h ? window : void 0,
              f = (h && p) || ("object" == typeof self && self) || global,
              d = [null];
            function g(e, t) {
              for (let n = e.length - 1; n >= 0; n--) "function" == typeof e[n] && (e[n] = c(e[n], t + "_" + n));
              return e;
            }
            function _(e) {
              return !e || (!1 !== e.writable && !("function" == typeof e.get && void 0 === e.set));
            }
            const k = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope,
              m = !("nw" in f) && void 0 !== f.process && "[object process]" === {}.toString.call(f.process),
              y = !m && !k && !(!h || !p.HTMLElement),
              v =
                void 0 !== f.process &&
                "[object process]" === {}.toString.call(f.process) &&
                !k &&
                !(!h || !p.HTMLElement),
              b = {},
              T = function (e) {
                if (!(e = e || f.event)) return;
                let t = b[e.type];
                t || (t = b[e.type] = u("ON_PROPERTY" + e.type));
                const n = this || e.target || f,
                  o = n[t];
                let r;
                if (y && n === p && "error" === e.type) {
                  const t = e;
                  (r = o && o.call(this, t.message, t.filename, t.lineno, t.colno, t.error)),
                    !0 === r && e.preventDefault();
                } else (r = o && o.apply(this, arguments)), null == r || r || e.preventDefault();
                return r;
              };
            function E(n, o, r) {
              let s = e(n, o);
              if ((!s && r && e(r, o) && (s = { enumerable: !0, configurable: !0 }), !s || !s.configurable)) return;
              const a = u("on" + o + "patched");
              if (n.hasOwnProperty(a) && n[a]) return;
              delete s.writable, delete s.value;
              const i = s.get,
                c = s.set,
                l = o.substr(2);
              let h = b[l];
              h || (h = b[l] = u("ON_PROPERTY" + l)),
                (s.set = function (e) {
                  let t = this;
                  t || n !== f || (t = f),
                    t &&
                      (t[h] && t.removeEventListener(l, T),
                      c && c.apply(t, d),
                      "function" == typeof e ? ((t[h] = e), t.addEventListener(l, T, !1)) : (t[h] = null));
                }),
                (s.get = function () {
                  let e = this;
                  if ((e || n !== f || (e = f), !e)) return null;
                  const t = e[h];
                  if (t) return t;
                  if (i) {
                    let t = i && i.call(this);
                    if (t)
                      return s.set.call(this, t), "function" == typeof e.removeAttribute && e.removeAttribute(o), t;
                  }
                  return null;
                }),
                t(n, o, s),
                (n[a] = !0);
            }
            function w(e, t, n) {
              if (t) for (let o = 0; o < t.length; o++) E(e, "on" + t[o], n);
              else {
                const t = [];
                for (const n in e) "on" == n.substr(0, 2) && t.push(n);
                for (let o = 0; o < t.length; o++) E(e, t[o], n);
              }
            }
            const Z = u("originalInstance");
            function S(e) {
              const n = f[e];
              if (!n) return;
              (f[u(e)] = n),
                (f[e] = function () {
                  const t = g(arguments, e);
                  switch (t.length) {
                    case 0:
                      this[Z] = new n();
                      break;
                    case 1:
                      this[Z] = new n(t[0]);
                      break;
                    case 2:
                      this[Z] = new n(t[0], t[1]);
                      break;
                    case 3:
                      this[Z] = new n(t[0], t[1], t[2]);
                      break;
                    case 4:
                      this[Z] = new n(t[0], t[1], t[2], t[3]);
                      break;
                    default:
                      throw new Error("Arg list too long.");
                  }
                }),
                C(f[e], n);
              const o = new n(function () {});
              let r;
              for (r in o)
                ("XMLHttpRequest" === e && "responseBlob" === r) ||
                  (function (n) {
                    "function" == typeof o[n]
                      ? (f[e].prototype[n] = function () {
                          return this[Z][n].apply(this[Z], arguments);
                        })
                      : t(f[e].prototype, n, {
                          set: function (t) {
                            "function" == typeof t
                              ? ((this[Z][n] = c(t, e + "." + n)), C(this[Z][n], t))
                              : (this[Z][n] = t);
                          },
                          get: function () {
                            return this[Z][n];
                          },
                        });
                  })(r);
              for (r in n) "prototype" !== r && n.hasOwnProperty(r) && (f[e][r] = n[r]);
            }
            function D(t, o, r) {
              let s = t;
              for (; s && !s.hasOwnProperty(o); ) s = n(s);
              !s && t[o] && (s = t);
              const a = u(o);
              let i = null;
              if (s && !(i = s[a]) && ((i = s[a] = s[o]), _(s && e(s, o)))) {
                const e = r(i, a, o);
                (s[o] = function () {
                  return e(this, arguments);
                }),
                  C(s[o], i);
              }
              return i;
            }
            function P(e, t, n) {
              let o = null;
              function r(e) {
                const t = e.data;
                return (
                  (t.args[t.cbIdx] = function () {
                    e.invoke.apply(this, arguments);
                  }),
                  o.apply(t.target, t.args),
                  e
                );
              }
              o = D(
                e,
                t,
                (e) =>
                  function (t, o) {
                    const s = n(t, o);
                    return s.cbIdx >= 0 && "function" == typeof o[s.cbIdx]
                      ? l(s.name, o[s.cbIdx], s, r)
                      : e.apply(t, o);
                  }
              );
            }
            function C(e, t) {
              e[u("OriginalDelegate")] = t;
            }
            let O = !1,
              z = !1;
            function j() {
              try {
                const e = p.navigator.userAgent;
                if (-1 !== e.indexOf("MSIE ") || -1 !== e.indexOf("Trident/")) return !0;
              } catch (e) {}
              return !1;
            }
            function I() {
              if (O) return z;
              O = !0;
              try {
                const e = p.navigator.userAgent;
                (-1 === e.indexOf("MSIE ") && -1 === e.indexOf("Trident/") && -1 === e.indexOf("Edge/")) || (z = !0);
              } catch (e) {}
              return z;
            }
            Zone.__load_patch("toString", (e) => {
              const t = Function.prototype.toString,
                n = u("OriginalDelegate"),
                o = u("Promise"),
                r = u("Error"),
                s = function () {
                  if ("function" == typeof this) {
                    const s = this[n];
                    if (s) return "function" == typeof s ? t.call(s) : Object.prototype.toString.call(s);
                    if (this === Promise) {
                      const n = e[o];
                      if (n) return t.call(n);
                    }
                    if (this === Error) {
                      const n = e[r];
                      if (n) return t.call(n);
                    }
                  }
                  return t.call(this);
                };
              (s[n] = t), (Function.prototype.toString = s);
              const a = Object.prototype.toString;
              Object.prototype.toString = function () {
                return this instanceof Promise ? "[object Promise]" : a.call(this);
              };
            });
            let R = !1;
            if ("undefined" != typeof window)
              try {
                const e = Object.defineProperty({}, "passive", {
                  get: function () {
                    R = !0;
                  },
                });
                window.addEventListener("test", e, e), window.removeEventListener("test", e, e);
              } catch (ie) {
                R = !1;
              }
            const N = { useG: !0 },
              x = {},
              L = {},
              M = new RegExp("^" + i + "(\\w+)(true|false)$"),
              A = u("propagationStopped");
            function H(e, t) {
              const n = (t ? t(e) : e) + "false",
                o = (t ? t(e) : e) + "true",
                r = i + n,
                s = i + o;
              (x[e] = {}), (x[e].false = r), (x[e].true = s);
            }
            function F(e, t, o) {
              const r = (o && o.add) || "addEventListener",
                s = (o && o.rm) || "removeEventListener",
                a = (o && o.listeners) || "eventListeners",
                c = (o && o.rmAll) || "removeAllListeners",
                l = u(r),
                h = "." + r + ":",
                p = function (e, t, n) {
                  if (e.isRemoved) return;
                  const o = e.callback;
                  "object" == typeof o &&
                    o.handleEvent &&
                    ((e.callback = (e) => o.handleEvent(e)), (e.originalDelegate = o)),
                    e.invoke(e, t, [n]);
                  const r = e.options;
                  r &&
                    "object" == typeof r &&
                    r.once &&
                    t[s].call(t, n.type, e.originalDelegate ? e.originalDelegate : e.callback, r);
                },
                f = function (t) {
                  if (!(t = t || e.event)) return;
                  const n = this || t.target || e,
                    o = n[x[t.type].false];
                  if (o)
                    if (1 === o.length) p(o[0], n, t);
                    else {
                      const e = o.slice();
                      for (let o = 0; o < e.length && (!t || !0 !== t[A]); o++) p(e[o], n, t);
                    }
                },
                d = function (t) {
                  if (!(t = t || e.event)) return;
                  const n = this || t.target || e,
                    o = n[x[t.type].true];
                  if (o)
                    if (1 === o.length) p(o[0], n, t);
                    else {
                      const e = o.slice();
                      for (let o = 0; o < e.length && (!t || !0 !== t[A]); o++) p(e[o], n, t);
                    }
                };
              function g(t, o) {
                if (!t) return !1;
                let p = !0;
                o && void 0 !== o.useG && (p = o.useG);
                const g = o && o.vh;
                let _ = !0;
                o && void 0 !== o.chkDup && (_ = o.chkDup);
                let k = !1;
                o && void 0 !== o.rt && (k = o.rt);
                let y = t;
                for (; y && !y.hasOwnProperty(r); ) y = n(y);
                if ((!y && t[r] && (y = t), !y)) return !1;
                if (y[l]) return !1;
                const v = o && o.eventNameToString,
                  b = {},
                  T = (y[l] = y[r]),
                  E = (y[u(s)] = y[s]),
                  w = (y[u(a)] = y[a]),
                  Z = (y[u(c)] = y[c]);
                let S;
                function D(e, t) {
                  return !R && "object" == typeof e && e
                    ? !!e.capture
                    : R && t
                    ? "boolean" == typeof e
                      ? { capture: e, passive: !0 }
                      : e
                      ? "object" == typeof e && !1 !== e.passive
                        ? Object.assign(Object.assign({}, e), { passive: !0 })
                        : e
                      : { passive: !0 }
                    : e;
                }
                o && o.prepend && (S = y[u(o.prepend)] = y[o.prepend]);
                const P = p
                    ? function (e) {
                        if (!b.isExisting) return T.call(b.target, b.eventName, b.capture ? d : f, b.options);
                      }
                    : function (e) {
                        return T.call(b.target, b.eventName, e.invoke, b.options);
                      },
                  O = p
                    ? function (e) {
                        if (!e.isRemoved) {
                          const t = x[e.eventName];
                          let n;
                          t && (n = t[e.capture ? "true" : "false"]);
                          const o = n && e.target[n];
                          if (o)
                            for (let r = 0; r < o.length; r++)
                              if (o[r] === e) {
                                o.splice(r, 1),
                                  (e.isRemoved = !0),
                                  0 === o.length && ((e.allRemoved = !0), (e.target[n] = null));
                                break;
                              }
                        }
                        if (e.allRemoved) return E.call(e.target, e.eventName, e.capture ? d : f, e.options);
                      }
                    : function (e) {
                        return E.call(e.target, e.eventName, e.invoke, e.options);
                      },
                  z =
                    o && o.diff
                      ? o.diff
                      : function (e, t) {
                          const n = typeof t;
                          return ("function" === n && e.callback === t) || ("object" === n && e.originalDelegate === t);
                        },
                  j = Zone[u("BLACK_LISTED_EVENTS")],
                  I = e[u("PASSIVE_EVENTS")],
                  A = function (t, n, r, s, a = !1, i = !1) {
                    return function () {
                      const c = this || e;
                      let l = arguments[0];
                      o && o.transferEventName && (l = o.transferEventName(l));
                      let u = arguments[1];
                      if (!u) return t.apply(this, arguments);
                      if (m && "uncaughtException" === l) return t.apply(this, arguments);
                      let h = !1;
                      if ("function" != typeof u) {
                        if (!u.handleEvent) return t.apply(this, arguments);
                        h = !0;
                      }
                      if (g && !g(t, u, c, arguments)) return;
                      const f = R && !!I && -1 !== I.indexOf(l),
                        d = D(arguments[2], f);
                      if (j)
                        for (let e = 0; e < j.length; e++)
                          if (l === j[e]) return f ? t.call(c, l, u, d) : t.apply(this, arguments);
                      const k = !!d && ("boolean" == typeof d || d.capture),
                        y = !(!d || "object" != typeof d) && d.once,
                        T = Zone.current;
                      let E = x[l];
                      E || (H(l, v), (E = x[l]));
                      const w = E[k ? "true" : "false"];
                      let Z,
                        S = c[w],
                        P = !1;
                      if (S) {
                        if (((P = !0), _)) for (let e = 0; e < S.length; e++) if (z(S[e], u)) return;
                      } else S = c[w] = [];
                      const C = c.constructor.name,
                        O = L[C];
                      O && (Z = O[l]),
                        Z || (Z = C + n + (v ? v(l) : l)),
                        (b.options = d),
                        y && (b.options.once = !1),
                        (b.target = c),
                        (b.capture = k),
                        (b.eventName = l),
                        (b.isExisting = P);
                      const M = p ? N : void 0;
                      M && (M.taskData = b);
                      const A = T.scheduleEventTask(Z, u, M, r, s);
                      return (
                        (b.target = null),
                        M && (M.taskData = null),
                        y && (d.once = !0),
                        (R || "boolean" != typeof A.options) && (A.options = d),
                        (A.target = c),
                        (A.capture = k),
                        (A.eventName = l),
                        h && (A.originalDelegate = u),
                        i ? S.unshift(A) : S.push(A),
                        a ? c : void 0
                      );
                    };
                  };
                return (
                  (y[r] = A(T, h, P, O, k)),
                  S &&
                    (y.prependListener = A(
                      S,
                      ".prependListener:",
                      function (e) {
                        return S.call(b.target, b.eventName, e.invoke, b.options);
                      },
                      O,
                      k,
                      !0
                    )),
                  (y[s] = function () {
                    const t = this || e;
                    let n = arguments[0];
                    o && o.transferEventName && (n = o.transferEventName(n));
                    const r = arguments[2],
                      s = !!r && ("boolean" == typeof r || r.capture),
                      a = arguments[1];
                    if (!a) return E.apply(this, arguments);
                    if (g && !g(E, a, t, arguments)) return;
                    const c = x[n];
                    let l;
                    c && (l = c[s ? "true" : "false"]);
                    const u = l && t[l];
                    if (u)
                      for (let e = 0; e < u.length; e++) {
                        const o = u[e];
                        if (z(o, a))
                          return (
                            u.splice(e, 1),
                            (o.isRemoved = !0),
                            0 === u.length &&
                              ((o.allRemoved = !0), (t[l] = null), "string" == typeof n) &&
                              (t[i + "ON_PROPERTY" + n] = null),
                            o.zone.cancelTask(o),
                            k ? t : void 0
                          );
                      }
                    return E.apply(this, arguments);
                  }),
                  (y[a] = function () {
                    const t = this || e;
                    let n = arguments[0];
                    o && o.transferEventName && (n = o.transferEventName(n));
                    const r = [],
                      s = G(t, v ? v(n) : n);
                    for (let e = 0; e < s.length; e++) {
                      const t = s[e];
                      r.push(t.originalDelegate ? t.originalDelegate : t.callback);
                    }
                    return r;
                  }),
                  (y[c] = function () {
                    const t = this || e;
                    let n = arguments[0];
                    if (n) {
                      o && o.transferEventName && (n = o.transferEventName(n));
                      const e = x[n];
                      if (e) {
                        const o = t[e.false],
                          r = t[e.true];
                        if (o) {
                          const e = o.slice();
                          for (let t = 0; t < e.length; t++) {
                            const o = e[t];
                            this[s].call(this, n, o.originalDelegate ? o.originalDelegate : o.callback, o.options);
                          }
                        }
                        if (r) {
                          const e = r.slice();
                          for (let t = 0; t < e.length; t++) {
                            const o = e[t];
                            this[s].call(this, n, o.originalDelegate ? o.originalDelegate : o.callback, o.options);
                          }
                        }
                      }
                    } else {
                      const e = Object.keys(t);
                      for (let t = 0; t < e.length; t++) {
                        const n = M.exec(e[t]);
                        let o = n && n[1];
                        o && "removeListener" !== o && this[c].call(this, o);
                      }
                      this[c].call(this, "removeListener");
                    }
                    if (k) return this;
                  }),
                  C(y[r], T),
                  C(y[s], E),
                  Z && C(y[c], Z),
                  w && C(y[a], w),
                  !0
                );
              }
              let _ = [];
              for (let n = 0; n < t.length; n++) _[n] = g(t[n], o);
              return _;
            }
            function G(e, t) {
              if (!t) {
                const n = [];
                for (let o in e) {
                  const r = M.exec(o);
                  let s = r && r[1];
                  if (s && (!t || s === t)) {
                    const t = e[o];
                    if (t) for (let e = 0; e < t.length; e++) n.push(t[e]);
                  }
                }
                return n;
              }
              let n = x[t];
              n || (H(t), (n = x[t]));
              const o = e[n.false],
                r = e[n.true];
              return o ? (r ? o.concat(r) : o.slice()) : r ? r.slice() : [];
            }
            function B(e, t) {
              const n = e.Event;
              n &&
                n.prototype &&
                t.patchMethod(
                  n.prototype,
                  "stopImmediatePropagation",
                  (e) =>
                    function (t, n) {
                      (t[A] = !0), e && e.apply(t, n);
                    }
                );
            }
            function q(e, t, n, o, r) {
              const s = Zone.__symbol__(o);
              if (t[s]) return;
              const a = (t[s] = t[o]);
              (t[o] = function (s, i, c) {
                return (
                  i &&
                    i.prototype &&
                    r.forEach(function (t) {
                      const r = `${n}.${o}::` + t,
                        s = i.prototype;
                      if (s.hasOwnProperty(t)) {
                        const n = e.ObjectGetOwnPropertyDescriptor(s, t);
                        n && n.value
                          ? ((n.value = e.wrapWithCurrentZone(n.value, r)), e._redefineProperty(i.prototype, t, n))
                          : s[t] && (s[t] = e.wrapWithCurrentZone(s[t], r));
                      } else s[t] && (s[t] = e.wrapWithCurrentZone(s[t], r));
                    }),
                  a.call(t, s, i, c)
                );
              }),
                e.attachOriginToPatched(t[o], a);
            }
            const W = [
                "absolutedeviceorientation",
                "afterinput",
                "afterprint",
                "appinstalled",
                "beforeinstallprompt",
                "beforeprint",
                "beforeunload",
                "devicelight",
                "devicemotion",
                "deviceorientation",
                "deviceorientationabsolute",
                "deviceproximity",
                "hashchange",
                "languagechange",
                "message",
                "mozbeforepaint",
                "offline",
                "online",
                "paint",
                "pageshow",
                "pagehide",
                "popstate",
                "rejectionhandled",
                "storage",
                "unhandledrejection",
                "unload",
                "userproximity",
                "vrdisplayconnected",
                "vrdisplaydisconnected",
                "vrdisplaypresentchange",
              ],
              U = ["encrypted", "waitingforkey", "msneedkey", "mozinterruptbegin", "mozinterruptend"],
              V = ["load"],
              $ = ["blur", "error", "focus", "load", "resize", "scroll", "messageerror"],
              X = ["bounce", "finish", "start"],
              J = [
                "loadstart",
                "progress",
                "abort",
                "error",
                "load",
                "progress",
                "timeout",
                "loadend",
                "readystatechange",
              ],
              Y = ["upgradeneeded", "complete", "abort", "success", "error", "blocked", "versionchange", "close"],
              K = ["close", "error", "open", "message"],
              Q = ["error", "message"],
              ee = [
                "abort",
                "animationcancel",
                "animationend",
                "animationiteration",
                "auxclick",
                "beforeinput",
                "blur",
                "cancel",
                "canplay",
                "canplaythrough",
                "change",
                "compositionstart",
                "compositionupdate",
                "compositionend",
                "cuechange",
                "click",
                "close",
                "contextmenu",
                "curechange",
                "dblclick",
                "drag",
                "dragend",
                "dragenter",
                "dragexit",
                "dragleave",
                "dragover",
                "drop",
                "durationchange",
                "emptied",
                "ended",
                "error",
                "focus",
                "focusin",
                "focusout",
                "gotpointercapture",
                "input",
                "invalid",
                "keydown",
                "keypress",
                "keyup",
                "load",
                "loadstart",
                "loadeddata",
                "loadedmetadata",
                "lostpointercapture",
                "mousedown",
                "mouseenter",
                "mouseleave",
                "mousemove",
                "mouseout",
                "mouseover",
                "mouseup",
                "mousewheel",
                "orientationchange",
                "pause",
                "play",
                "playing",
                "pointercancel",
                "pointerdown",
                "pointerenter",
                "pointerleave",
                "pointerlockchange",
                "mozpointerlockchange",
                "webkitpointerlockerchange",
                "pointerlockerror",
                "mozpointerlockerror",
                "webkitpointerlockerror",
                "pointermove",
                "pointout",
                "pointerover",
                "pointerup",
                "progress",
                "ratechange",
                "reset",
                "resize",
                "scroll",
                "seeked",
                "seeking",
                "select",
                "selectionchange",
                "selectstart",
                "show",
                "sort",
                "stalled",
                "submit",
                "suspend",
                "timeupdate",
                "volumechange",
                "touchcancel",
                "touchmove",
                "touchstart",
                "touchend",
                "transitioncancel",
                "transitionend",
                "waiting",
                "wheel",
              ].concat(
                ["webglcontextrestored", "webglcontextlost", "webglcontextcreationerror"],
                ["autocomplete", "autocompleteerror"],
                ["toggle"],
                [
                  "afterscriptexecute",
                  "beforescriptexecute",
                  "DOMContentLoaded",
                  "freeze",
                  "fullscreenchange",
                  "mozfullscreenchange",
                  "webkitfullscreenchange",
                  "msfullscreenchange",
                  "fullscreenerror",
                  "mozfullscreenerror",
                  "webkitfullscreenerror",
                  "msfullscreenerror",
                  "readystatechange",
                  "visibilitychange",
                  "resume",
                ],
                W,
                [
                  "beforecopy",
                  "beforecut",
                  "beforepaste",
                  "copy",
                  "cut",
                  "paste",
                  "dragstart",
                  "loadend",
                  "animationstart",
                  "search",
                  "transitionrun",
                  "transitionstart",
                  "webkitanimationend",
                  "webkitanimationiteration",
                  "webkitanimationstart",
                  "webkittransitionend",
                ],
                [
                  "activate",
                  "afterupdate",
                  "ariarequest",
                  "beforeactivate",
                  "beforedeactivate",
                  "beforeeditfocus",
                  "beforeupdate",
                  "cellchange",
                  "controlselect",
                  "dataavailable",
                  "datasetchanged",
                  "datasetcomplete",
                  "errorupdate",
                  "filterchange",
                  "layoutcomplete",
                  "losecapture",
                  "move",
                  "moveend",
                  "movestart",
                  "propertychange",
                  "resizeend",
                  "resizestart",
                  "rowenter",
                  "rowexit",
                  "rowsdelete",
                  "rowsinserted",
                  "command",
                  "compassneedscalibration",
                  "deactivate",
                  "help",
                  "mscontentzoom",
                  "msmanipulationstatechanged",
                  "msgesturechange",
                  "msgesturedoubletap",
                  "msgestureend",
                  "msgesturehold",
                  "msgesturestart",
                  "msgesturetap",
                  "msgotpointercapture",
                  "msinertiastart",
                  "mslostpointercapture",
                  "mspointercancel",
                  "mspointerdown",
                  "mspointerenter",
                  "mspointerhover",
                  "mspointerleave",
                  "mspointermove",
                  "mspointerout",
                  "mspointerover",
                  "mspointerup",
                  "pointerout",
                  "mssitemodejumplistitemremoved",
                  "msthumbnailclick",
                  "stop",
                  "storagecommit",
                ]
              );
            function te(e, t, n) {
              if (!n || 0 === n.length) return t;
              const o = n.filter((t) => t.target === e);
              if (!o || 0 === o.length) return t;
              const r = o[0].ignoreProperties;
              return t.filter((e) => -1 === r.indexOf(e));
            }
            function ne(e, t, n, o) {
              e && w(e, te(e, t, n), o);
            }
            function oe(e, t) {
              if (m && !v) return;
              if (Zone[e.symbol("patchEvents")]) return;
              const o = "undefined" != typeof WebSocket,
                r = t.__Zone_ignore_on_properties;
              if (y) {
                const e = window,
                  t = j ? [{ target: e, ignoreProperties: ["error"] }] : [];
                ne(e, ee.concat(["messageerror"]), r ? r.concat(t) : r, n(e)),
                  ne(Document.prototype, ee, r),
                  void 0 !== e.SVGElement && ne(e.SVGElement.prototype, ee, r),
                  ne(Element.prototype, ee, r),
                  ne(HTMLElement.prototype, ee, r),
                  ne(HTMLMediaElement.prototype, U, r),
                  ne(HTMLFrameSetElement.prototype, W.concat($), r),
                  ne(HTMLBodyElement.prototype, W.concat($), r),
                  ne(HTMLFrameElement.prototype, V, r),
                  ne(HTMLIFrameElement.prototype, V, r);
                const o = e.HTMLMarqueeElement;
                o && ne(o.prototype, X, r);
                const s = e.Worker;
                s && ne(s.prototype, Q, r);
              }
              const s = t.XMLHttpRequest;
              s && ne(s.prototype, J, r);
              const a = t.XMLHttpRequestEventTarget;
              a && ne(a && a.prototype, J, r),
                "undefined" != typeof IDBIndex &&
                  (ne(IDBIndex.prototype, Y, r),
                  ne(IDBRequest.prototype, Y, r),
                  ne(IDBOpenDBRequest.prototype, Y, r),
                  ne(IDBDatabase.prototype, Y, r),
                  ne(IDBTransaction.prototype, Y, r),
                  ne(IDBCursor.prototype, Y, r)),
                o && ne(WebSocket.prototype, K, r);
            }
            Zone.__load_patch("util", (n, s, a) => {
              (a.patchOnProperties = w), (a.patchMethod = D), (a.bindArguments = g), (a.patchMacroTask = P);
              const l = s.__symbol__("BLACK_LISTED_EVENTS"),
                u = s.__symbol__("UNPATCHED_EVENTS");
              n[u] && (n[l] = n[u]),
                n[l] && (s[l] = s[u] = n[l]),
                (a.patchEventPrototype = B),
                (a.patchEventTarget = F),
                (a.isIEOrEdge = I),
                (a.ObjectDefineProperty = t),
                (a.ObjectGetOwnPropertyDescriptor = e),
                (a.ObjectCreate = o),
                (a.ArraySlice = r),
                (a.patchClass = S),
                (a.wrapWithCurrentZone = c),
                (a.filterProperties = te),
                (a.attachOriginToPatched = C),
                (a._redefineProperty = Object.defineProperty),
                (a.patchCallbacks = q),
                (a.getGlobalObjects = () => ({
                  globalSources: L,
                  zoneSymbolEventNames: x,
                  eventNames: ee,
                  isBrowser: y,
                  isMix: v,
                  isNode: m,
                  TRUE_STR: "true",
                  FALSE_STR: "false",
                  ZONE_SYMBOL_PREFIX: i,
                  ADD_EVENT_LISTENER_STR: "addEventListener",
                  REMOVE_EVENT_LISTENER_STR: "removeEventListener",
                }));
            });
            const re = u("zoneTask");
            function se(e, t, n, o) {
              let r = null,
                s = null;
              n += o;
              const a = {};
              function i(t) {
                const n = t.data;
                return (
                  (n.args[0] = function () {
                    try {
                      t.invoke.apply(this, arguments);
                    } finally {
                      (t.data && t.data.isPeriodic) ||
                        ("number" == typeof n.handleId ? delete a[n.handleId] : n.handleId && (n.handleId[re] = null));
                    }
                  }),
                  (n.handleId = r.apply(e, n.args)),
                  t
                );
              }
              function c(e) {
                return s(e.data.handleId);
              }
              (r = D(
                e,
                (t += o),
                (n) =>
                  function (r, s) {
                    if ("function" == typeof s[0]) {
                      const e = l(
                        t,
                        s[0],
                        {
                          isPeriodic: "Interval" === o,
                          delay: "Timeout" === o || "Interval" === o ? s[1] || 0 : void 0,
                          args: s,
                        },
                        i,
                        c
                      );
                      if (!e) return e;
                      const n = e.data.handleId;
                      return (
                        "number" == typeof n ? (a[n] = e) : n && (n[re] = e),
                        n &&
                          n.ref &&
                          n.unref &&
                          "function" == typeof n.ref &&
                          "function" == typeof n.unref &&
                          ((e.ref = n.ref.bind(n)), (e.unref = n.unref.bind(n))),
                        "number" == typeof n || n ? n : e
                      );
                    }
                    return n.apply(e, s);
                  }
              )),
                (s = D(
                  e,
                  n,
                  (t) =>
                    function (n, o) {
                      const r = o[0];
                      let s;
                      "number" == typeof r ? (s = a[r]) : ((s = r && r[re]), s || (s = r)),
                        s && "string" == typeof s.type
                          ? "notScheduled" !== s.state &&
                            ((s.cancelFn && s.data.isPeriodic) || 0 === s.runCount) &&
                            ("number" == typeof r ? delete a[r] : r && (r[re] = null), s.zone.cancelTask(s))
                          : t.apply(e, o);
                    }
                ));
            }
            function ae(e, t) {
              if (Zone[t.symbol("patchEventTarget")]) return;
              const {
                eventNames: n,
                zoneSymbolEventNames: o,
                TRUE_STR: r,
                FALSE_STR: s,
                ZONE_SYMBOL_PREFIX: a,
              } = t.getGlobalObjects();
              for (let c = 0; c < n.length; c++) {
                const e = n[c],
                  t = a + (e + s),
                  i = a + (e + r);
                (o[e] = {}), (o[e][s] = t), (o[e][r] = i);
              }
              const i = e.EventTarget;
              return i && i.prototype ? (t.patchEventTarget(e, [i && i.prototype]), !0) : void 0;
            }
            Zone.__load_patch("legacy", (e) => {
              const t = e[Zone.__symbol__("legacyPatch")];
              t && t();
            }),
              Zone.__load_patch("timers", (e) => {
                se(e, "set", "clear", "Timeout"), se(e, "set", "clear", "Interval"), se(e, "set", "clear", "Immediate");
              }),
              Zone.__load_patch("requestAnimationFrame", (e) => {
                se(e, "request", "cancel", "AnimationFrame"),
                  se(e, "mozRequest", "mozCancel", "AnimationFrame"),
                  se(e, "webkitRequest", "webkitCancel", "AnimationFrame");
              }),
              Zone.__load_patch("blocking", (e, t) => {
                const n = ["alert", "prompt", "confirm"];
                for (let o = 0; o < n.length; o++)
                  D(
                    e,
                    n[o],
                    (n, o, r) =>
                      function (o, s) {
                        return t.current.run(n, e, s, r);
                      }
                  );
              }),
              Zone.__load_patch("EventTarget", (e, t, n) => {
                (function (e, t) {
                  t.patchEventPrototype(e, t);
                })(e, n),
                  ae(e, n);
                const o = e.XMLHttpRequestEventTarget;
                o && o.prototype && n.patchEventTarget(e, [o.prototype]),
                  S("MutationObserver"),
                  S("WebKitMutationObserver"),
                  S("IntersectionObserver"),
                  S("FileReader");
              }),
              Zone.__load_patch("on_property", (e, t, n) => {
                oe(n, e);
              }),
              Zone.__load_patch("customElements", (e, t, n) => {
                !(function (e, t) {
                  const { isBrowser: n, isMix: o } = t.getGlobalObjects();
                  (n || o) &&
                    e.customElements &&
                    "customElements" in e &&
                    t.patchCallbacks(t, e.customElements, "customElements", "define", [
                      "connectedCallback",
                      "disconnectedCallback",
                      "adoptedCallback",
                      "attributeChangedCallback",
                    ]);
                })(e, n);
              }),
              Zone.__load_patch("XHR", (e, t) => {
                !(function (e) {
                  const p = e.XMLHttpRequest;
                  if (!p) return;
                  const f = p.prototype;
                  let d = f[s],
                    g = f[a];
                  if (!d) {
                    const t = e.XMLHttpRequestEventTarget;
                    if (t) {
                      const e = t.prototype;
                      (d = e[s]), (g = e[a]);
                    }
                  }
                  function _(e) {
                    const o = e.data,
                      c = o.target;
                    (c[i] = !1), (c[h] = !1);
                    const l = c[r];
                    d || ((d = c[s]), (g = c[a])), l && g.call(c, "readystatechange", l);
                    const u = (c[r] = () => {
                      if (c.readyState === c.DONE)
                        if (!o.aborted && c[i] && "scheduled" === e.state) {
                          const n = c[t.__symbol__("loadfalse")];
                          if (n && n.length > 0) {
                            const r = e.invoke;
                            (e.invoke = function () {
                              const n = c[t.__symbol__("loadfalse")];
                              for (let t = 0; t < n.length; t++) n[t] === e && n.splice(t, 1);
                              o.aborted || "scheduled" !== e.state || r.call(e);
                            }),
                              n.push(e);
                          } else e.invoke();
                        } else o.aborted || !1 !== c[i] || (c[h] = !0);
                    });
                    return d.call(c, "readystatechange", u), c[n] || (c[n] = e), T.apply(c, o.args), (c[i] = !0), e;
                  }
                  function k() {}
                  function m(e) {
                    const t = e.data;
                    return (t.aborted = !0), E.apply(t.target, t.args);
                  }
                  const y = D(
                      f,
                      "open",
                      () =>
                        function (e, t) {
                          return (e[o] = 0 == t[2]), (e[c] = t[1]), y.apply(e, t);
                        }
                    ),
                    v = u("fetchTaskAborting"),
                    b = u("fetchTaskScheduling"),
                    T = D(
                      f,
                      "send",
                      () =>
                        function (e, n) {
                          if (!0 === t.current[b]) return T.apply(e, n);
                          if (e[o]) return T.apply(e, n);
                          {
                            const t = { target: e, url: e[c], isPeriodic: !1, args: n, aborted: !1 },
                              o = l("XMLHttpRequest.send", k, t, _, m);
                            e && !0 === e[h] && !t.aborted && "scheduled" === o.state && o.invoke();
                          }
                        }
                    ),
                    E = D(
                      f,
                      "abort",
                      () =>
                        function (e, o) {
                          const r = e[n];
                          if (r && "string" == typeof r.type) {
                            if (null == r.cancelFn || (r.data && r.data.aborted)) return;
                            r.zone.cancelTask(r);
                          } else if (!0 === t.current[v]) return E.apply(e, o);
                        }
                    );
                })(e);
                const n = u("xhrTask"),
                  o = u("xhrSync"),
                  r = u("xhrListener"),
                  i = u("xhrScheduled"),
                  c = u("xhrURL"),
                  h = u("xhrErrorBeforeScheduled");
              }),
              Zone.__load_patch("geolocation", (t) => {
                t.navigator &&
                  t.navigator.geolocation &&
                  (function (t, n) {
                    const o = t.constructor.name;
                    for (let r = 0; r < n.length; r++) {
                      const s = n[r],
                        a = t[s];
                      if (a) {
                        if (!_(e(t, s))) continue;
                        t[s] = ((e) => {
                          const t = function () {
                            return e.apply(this, g(arguments, o + "." + s));
                          };
                          return C(t, e), t;
                        })(a);
                      }
                    }
                  })(t.navigator.geolocation, ["getCurrentPosition", "watchPosition"]);
              }),
              Zone.__load_patch("PromiseRejectionEvent", (e, t) => {
                function n(t) {
                  return function (n) {
                    G(e, t).forEach((o) => {
                      const r = e.PromiseRejectionEvent;
                      if (r) {
                        const e = new r(t, { promise: n.promise, reason: n.rejection });
                        o.invoke(e);
                      }
                    });
                  };
                }
                e.PromiseRejectionEvent &&
                  ((t[u("unhandledPromiseRejectionHandler")] = n("unhandledrejection")),
                  (t[u("rejectionHandledHandler")] = n("rejectionhandled")));
              });
          })
            ? o.call(t, n, t, e)
            : o) || (e.exports = r);
    },
  },
  [[2, 0]],
]);
!(function (e) {
  function r(r) {
    for (var n, l, f = r[0], i = r[1], p = r[2], c = 0, s = []; c < f.length; c++)
      (l = f[c]), Object.prototype.hasOwnProperty.call(o, l) && o[l] && s.push(o[l][0]), (o[l] = 0);
    for (n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    for (a && a(r); s.length; ) s.shift()();
    return u.push.apply(u, p || []), t();
  }
  function t() {
    for (var e, r = 0; r < u.length; r++) {
      for (var t = u[r], n = !0, f = 1; f < t.length; f++) 0 !== o[t[f]] && (n = !1);
      n && (u.splice(r--, 1), (e = l((l.s = t[0]))));
    }
    return e;
  }
  var n = {},
    o = { 0: 0 },
    u = [];
  function l(r) {
    if (n[r]) return n[r].exports;
    var t = (n[r] = { i: r, l: !1, exports: {} });
    return e[r].call(t.exports, t, t.exports, l), (t.l = !0), t.exports;
  }
  (l.m = e),
    (l.c = n),
    (l.d = function (e, r, t) {
      l.o(e, r) || Object.defineProperty(e, r, { enumerable: !0, get: t });
    }),
    (l.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (l.t = function (e, r) {
      if ((1 & r && (e = l(e)), 8 & r)) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if ((l.r(t), Object.defineProperty(t, "default", { enumerable: !0, value: e }), 2 & r && "string" != typeof e))
        for (var n in e)
          l.d(
            t,
            n,
            function (r) {
              return e[r];
            }.bind(null, n)
          );
      return t;
    }),
    (l.n = function (e) {
      var r =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return l.d(r, "a", r), r;
    }),
    (l.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }),
    (l.p = "");
  var f = (window.webpackJsonp = window.webpackJsonp || []),
    i = f.push.bind(f);
  (f.push = r), (f = f.slice());
  for (var p = 0; p < f.length; p++) r(f[p]);
  var a = i;
  t();
})([]);
